// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28231.5, 199, 149.5%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2337D80A%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23FD5812%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23FD5812%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27rgb%2883.2, 57.2, 17.6%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%28226.8, 187.8, 128.4%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@charset "UTF-8";

/* fallback */
@font-face {
  font-family: "Material Symbols Outlined";
  font-style: normal;
  font-weight: 400;
  src: url(https://fonts.gstatic.com/s/materialsymbolsoutlined/v192/kJF1BvYX7BgnkSrUwT8OhrdQw4oELdPIeeII9v6oDMzByHX9rA6RzaxHMPdY43zj-jCxv3fzvRNU22ZXGJpEpjC_1v-p_4MrImHCIJIZrDCvHOej.woff2) format("woff2");
}

.material-symbols-outlined {
  font-family: "Material Symbols Outlined";
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
}

:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f5f7f8;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #d08f2c;
  --bs-secondary: #3A4252;
  --bs-success: #37D80A;
  --bs-info: #2DB6F5;
  --bs-warning: #FFBC2B;
  --bs-danger: #FD5812;
  --bs-light: #D5D9E2;
  --bs-dark: #000000;
  --bs-primary-div: #d08f2c;
  --bs-primary-div-50: #b27c26;
  --bs-primary-div-60: #946920;
  --bs-primary-50: #b27c26;
  --bs-primary-60: #946920;
  --bs-primary-70: #76561a;
  --bs-success-50: #1E8308;
  --bs-success-60: #25B003;
  --bs-success-70: #82FC5A;
  --bs-success-80: #D8FFC8;
  --bs-success-90: #eeffe5;
  --bs-success-100: #d8ffc8;
  --bs-body-bg: #F6F7F9;
  --bs-danger-div: #ffed9d;
  --bs-danger-40: #D71C00;
  --bs-danger-50: #EE3E08;
  --bs-danger-60: #EC1F00;
  --bs-danger-70: #FFE1DD;
  --bs-danger-80: #ff4023;
  --bs-danger-90: #C52B09;
  --bs-danger-100: #ffe1dd;
  --bs-rating-color: #FE7A36;
  --bs-card-bg-c: #3584FC;
  --bs-card-text-c: #FFE8D4;
  --bs-gary-light: #F4F6FC;
  --bs-border-color: #ECEEF2;
  --bs-border-color-50: #ECF0FF;
  --bs-gray-100: #f5f7f8;
  --bs-body-color-50: #526077;
  --bs-body-color-60: #8695AA;
  --bs-purple-100: #f3e8ff;
  --bs-info-100: #daebff;
  --bs-primary-rgb: 208, 143, 44;
  --bs-secondary-rgb: 58, 66, 82;
  --bs-success-rgb: 55, 216, 10;
  --bs-info-rgb: 45, 182, 245;
  --bs-warning-rgb: 255, 188, 43;
  --bs-danger-rgb: 253, 88, 18;
  --bs-light-rgb: 213, 217, 226;
  --bs-dark-rgb: 0, 0, 0;
  --bs-primary-div-rgb: 208, 143, 44;
  --bs-primary-div-50-rgb: 178, 124, 38;
  --bs-primary-div-60-rgb: 148, 105, 32;
  --bs-primary-50-rgb: 178, 124, 38;
  --bs-primary-60-rgb: 148, 105, 32;
  --bs-primary-70-rgb: 118, 86, 26;
  --bs-success-50-rgb: 30, 131, 8;
  --bs-success-60-rgb: 37, 176, 3;
  --bs-success-70-rgb: 130, 252, 90;
  --bs-success-80-rgb: 216, 255, 200;
  --bs-success-90-rgb: 238, 255, 229;
  --bs-success-100-rgb: 216, 255, 200;
  --bs-body-bg-rgb: 246, 247, 249;
  --bs-danger-div-rgb: 255, 237, 157;
  --bs-danger-40-rgb: 215, 28, 0;
  --bs-danger-50-rgb: 238, 62, 8;
  --bs-danger-60-rgb: 236, 31, 0;
  --bs-danger-70-rgb: 255, 225, 221;
  --bs-danger-80-rgb: 255, 64, 35;
  --bs-danger-90-rgb: 197, 43, 9;
  --bs-danger-100-rgb: 255, 225, 221;
  --bs-rating-color-rgb: 254, 122, 54;
  --bs-card-bg-c-rgb: 53, 132, 252;
  --bs-card-text-c-rgb: 255, 232, 212;
  --bs-gary-light-rgb: 244, 246, 252;
  --bs-border-color-rgb: 236, 238, 242;
  --bs-border-color-50-rgb: 236, 240, 255;
  --bs-gray-100-rgb: 245, 247, 248;
  --bs-body-color-50-rgb: 82, 96, 119;
  --bs-body-color-60-rgb: 134, 149, 170;
  --bs-purple-100-rgb: 243, 232, 255;
  --bs-info-100-rgb: 218, 235, 255;
  --bs-primary-text-emphasis: rgb(83.2, 57.2, 17.6);
  --bs-secondary-text-emphasis: rgb(23.2, 26.4, 32.8);
  --bs-success-text-emphasis: rgb(22, 86.4, 4);
  --bs-info-text-emphasis: rgb(18, 72.8, 98);
  --bs-warning-text-emphasis: rgb(102, 75.2, 17.2);
  --bs-danger-text-emphasis: rgb(101.2, 35.2, 7.2);
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgb(245.6, 232.6, 212.8);
  --bs-secondary-bg-subtle: rgb(215.6, 217.2, 220.4);
  --bs-success-bg-subtle: rgb(215, 247.2, 206);
  --bs-info-bg-subtle: rgb(213, 240.4, 253);
  --bs-warning-bg-subtle: rgb(255, 241.6, 212.6);
  --bs-danger-bg-subtle: rgb(254.6, 221.6, 207.6);
  --bs-light-bg-subtle: rgb(250, 251, 251.5);
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: rgb(236.2, 210.2, 170.6);
  --bs-secondary-border-subtle: rgb(176.2, 179.4, 185.8);
  --bs-success-border-subtle: rgb(175, 239.4, 157);
  --bs-info-border-subtle: rgb(171, 225.8, 251);
  --bs-warning-border-subtle: rgb(255, 228.2, 170.2);
  --bs-danger-border-subtle: rgb(254.2, 188.2, 160.2);
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 0.88rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #fff;
  --bs-body-color-rgb: 255, 255, 255;
  --bs-body-bg: #F6F7F9;
  --bs-body-bg-rgb: 246, 247, 249;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(255, 255, 255, 0.75);
  --bs-secondary-color-rgb: 255, 255, 255;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(255, 255, 255, 0.5);
  --bs-tertiary-color-rgb: 255, 255, 255;
  --bs-tertiary-bg: #f5f7f8;
  --bs-tertiary-bg-rgb: 245, 247, 248;
  --bs-heading-color: inherit;
  --bs-link-color: #d08f2c;
  --bs-link-color-rgb: 208, 143, 44;
  --bs-link-decoration: underline;
  --bs-link-hover-color: rgb(166.4, 114.4, 35.2);
  --bs-link-hover-color-rgb: 166, 114, 35;
  --bs-code-color: #d63384;
  --bs-highlight-color: #fff;
  --bs-highlight-bg: rgb(255, 242.6, 205.4);
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #ECEEF2;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(208, 143, 44, 0.25);
  --bs-form-valid-color: #37D80A;
  --bs-form-valid-border-color: #37D80A;
  --bs-form-invalid-color: #FD5812;
  --bs-form-invalid-border-color: #FD5812;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: rgb(42.5, 47.5, 52.5);
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: rgb(226.8, 187.8, 128.4);
  --bs-secondary-text-emphasis: rgb(136.8, 141.6, 151.2);
  --bs-success-text-emphasis: rgb(135, 231.6, 108);
  --bs-info-text-emphasis: rgb(129, 211.2, 249);
  --bs-warning-text-emphasis: rgb(255, 214.8, 127.8);
  --bs-danger-text-emphasis: rgb(253.8, 154.8, 112.8);
  --bs-light-text-emphasis: #f5f7f8;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: rgb(41.6, 28.6, 8.8);
  --bs-secondary-bg-subtle: rgb(11.6, 13.2, 16.4);
  --bs-success-bg-subtle: rgb(11, 43.2, 2);
  --bs-info-bg-subtle: rgb(9, 36.4, 49);
  --bs-warning-bg-subtle: rgb(51, 37.6, 8.6);
  --bs-danger-bg-subtle: rgb(50.6, 17.6, 3.6);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: rgb(124.8, 85.8, 26.4);
  --bs-secondary-border-subtle: rgb(34.8, 39.6, 49.2);
  --bs-success-border-subtle: rgb(33, 129.6, 6);
  --bs-info-border-subtle: rgb(27, 109.2, 147);
  --bs-warning-border-subtle: rgb(153, 112.8, 25.8);
  --bs-danger-border-subtle: rgb(151.8, 52.8, 10.8);
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(226.8, 187.8, 128.4);
  --bs-link-hover-color: rgb(232.44, 201.24, 153.72);
  --bs-link-color-rgb: 227, 188, 128;
  --bs-link-hover-color-rgb: 232, 201, 154;
  --bs-code-color: rgb(230.4, 132.6, 181.2);
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: rgb(102, 77.2, 2.8);
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(117, 183, 152.4);
  --bs-form-valid-border-color: rgb(117, 183, 152.4);
  --bs-form-invalid-color: rgb(234, 133.8, 143.4);
  --bs-form-invalid-border-color: rgb(234, 133.8, 143.4);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6,
.h6,
h5,
.h5,
h4,
.h4,
h3,
.h3,
h2,
.h2,
h1,
.h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1,
.h1 {
  font-size: calc(1.345rem + 1.14vw);
}

@media (min-width: 1200px) {

  h1,
  .h1 {
    font-size: 2.2rem;
  }
}

h2,
.h2 {
  font-size: calc(1.3274rem + 0.9288vw);
}

@media (min-width: 1200px) {

  h2,
  .h2 {
    font-size: 2.024rem;
  }
}

h3,
.h3 {
  font-size: calc(1.2834rem + 0.4008vw);
}

@media (min-width: 1200px) {

  h3,
  .h3 {
    font-size: 1.584rem;
  }
}

h4,
.h4 {
  font-size: 1.232rem;
}

h5,
.h5 {
  font-size: 0.88rem;
}

h6,
.h6 {
  font-size: 0.88rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small,
.small {
  font-size: 0.875em;
}

mark,
.mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}

a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]),
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}

pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}

a>code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}

kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
  font-size: calc(1.275rem + 0.3vw);
}

@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}

legend+* {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.1rem;
  font-weight: 300;
}

.display-1 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.625rem + 4.5vw);
}

@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.575rem + 3.9vw);
}

@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.525rem + 3.3vw);
}

@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.475rem + 2.7vw);
}

@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.425rem + 2.1vw);
}

@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.375rem + 1.5vw);
}

@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.1rem;
}

.blockquote> :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}

.blockquote-footer::before {
  content: "— ";
}

/*!
 * Bootstrap  v5.3.7 (https://getbootstrap.com/)
 * Copyright 2011-2025 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f5f7f8;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #d08f2c;
  --bs-secondary: #3A4252;
  --bs-success: #37D80A;
  --bs-info: #2DB6F5;
  --bs-warning: #FFBC2B;
  --bs-danger: #FD5812;
  --bs-light: #D5D9E2;
  --bs-dark: #000000;
  --bs-primary-div: #d08f2c;
  --bs-primary-div-50: #b27c26;
  --bs-primary-div-60: #946920;
  --bs-primary-50: #b27c26;
  --bs-primary-60: #946920;
  --bs-primary-70: #76561a;
  --bs-success-50: #1E8308;
  --bs-success-60: #25B003;
  --bs-success-70: #82FC5A;
  --bs-success-80: #D8FFC8;
  --bs-success-90: #eeffe5;
  --bs-success-100: #d8ffc8;
  --bs-body-bg: #F6F7F9;
  --bs-danger-div: #ffed9d;
  --bs-danger-40: #D71C00;
  --bs-danger-50: #EE3E08;
  --bs-danger-60: #EC1F00;
  --bs-danger-70: #FFE1DD;
  --bs-danger-80: #ff4023;
  --bs-danger-90: #C52B09;
  --bs-danger-100: #ffe1dd;
  --bs-rating-color: #FE7A36;
  --bs-card-bg-c: #3584FC;
  --bs-card-text-c: #FFE8D4;
  --bs-gary-light: #F4F6FC;
  --bs-border-color: #ECEEF2;
  --bs-border-color-50: #ECF0FF;
  --bs-gray-100: #f5f7f8;
  --bs-body-color-50: #526077;
  --bs-body-color-60: #8695AA;
  --bs-purple-100: #f3e8ff;
  --bs-info-100: #daebff;
  --bs-primary-rgb: 208, 143, 44;
  --bs-secondary-rgb: 58, 66, 82;
  --bs-success-rgb: 55, 216, 10;
  --bs-info-rgb: 45, 182, 245;
  --bs-warning-rgb: 255, 188, 43;
  --bs-danger-rgb: 253, 88, 18;
  --bs-light-rgb: 213, 217, 226;
  --bs-dark-rgb: 0, 0, 0;
  --bs-primary-div-rgb: 208, 143, 44;
  --bs-primary-div-50-rgb: 178, 124, 38;
  --bs-primary-div-60-rgb: 148, 105, 32;
  --bs-primary-50-rgb: 178, 124, 38;
  --bs-primary-60-rgb: 148, 105, 32;
  --bs-primary-70-rgb: 118, 86, 26;
  --bs-success-50-rgb: 30, 131, 8;
  --bs-success-60-rgb: 37, 176, 3;
  --bs-success-70-rgb: 130, 252, 90;
  --bs-success-80-rgb: 216, 255, 200;
  --bs-success-90-rgb: 238, 255, 229;
  --bs-success-100-rgb: 216, 255, 200;
  --bs-body-bg-rgb: 246, 247, 249;
  --bs-danger-div-rgb: 255, 237, 157;
  --bs-danger-40-rgb: 215, 28, 0;
  --bs-danger-50-rgb: 238, 62, 8;
  --bs-danger-60-rgb: 236, 31, 0;
  --bs-danger-70-rgb: 255, 225, 221;
  --bs-danger-80-rgb: 255, 64, 35;
  --bs-danger-90-rgb: 197, 43, 9;
  --bs-danger-100-rgb: 255, 225, 221;
  --bs-rating-color-rgb: 254, 122, 54;
  --bs-card-bg-c-rgb: 53, 132, 252;
  --bs-card-text-c-rgb: 255, 232, 212;
  --bs-gary-light-rgb: 244, 246, 252;
  --bs-border-color-rgb: 236, 238, 242;
  --bs-border-color-50-rgb: 236, 240, 255;
  --bs-gray-100-rgb: 245, 247, 248;
  --bs-body-color-50-rgb: 82, 96, 119;
  --bs-body-color-60-rgb: 134, 149, 170;
  --bs-purple-100-rgb: 243, 232, 255;
  --bs-info-100-rgb: 218, 235, 255;
  --bs-primary-text-emphasis: rgb(83.2, 57.2, 17.6);
  --bs-secondary-text-emphasis: rgb(23.2, 26.4, 32.8);
  --bs-success-text-emphasis: rgb(22, 86.4, 4);
  --bs-info-text-emphasis: rgb(18, 72.8, 98);
  --bs-warning-text-emphasis: rgb(102, 75.2, 17.2);
  --bs-danger-text-emphasis: rgb(101.2, 35.2, 7.2);
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgb(245.6, 232.6, 212.8);
  --bs-secondary-bg-subtle: rgb(215.6, 217.2, 220.4);
  --bs-success-bg-subtle: rgb(215, 247.2, 206);
  --bs-info-bg-subtle: rgb(213, 240.4, 253);
  --bs-warning-bg-subtle: rgb(255, 241.6, 212.6);
  --bs-danger-bg-subtle: rgb(254.6, 221.6, 207.6);
  --bs-light-bg-subtle: rgb(250, 251, 251.5);
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: rgb(236.2, 210.2, 170.6);
  --bs-secondary-border-subtle: rgb(176.2, 179.4, 185.8);
  --bs-success-border-subtle: rgb(175, 239.4, 157);
  --bs-info-border-subtle: rgb(171, 225.8, 251);
  --bs-warning-border-subtle: rgb(255, 228.2, 170.2);
  --bs-danger-border-subtle: rgb(254.2, 188.2, 160.2);
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 0.88rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #fff;
  --bs-body-color-rgb: 255, 255, 255;
  --bs-body-bg: #F6F7F9;
  --bs-body-bg-rgb: 246, 247, 249;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(255, 255, 255, 0.75);
  --bs-secondary-color-rgb: 255, 255, 255;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(255, 255, 255, 0.5);
  --bs-tertiary-color-rgb: 255, 255, 255;
  --bs-tertiary-bg: #f5f7f8;
  --bs-tertiary-bg-rgb: 245, 247, 248;
  --bs-heading-color: inherit;
  --bs-link-color: #d08f2c;
  --bs-link-color-rgb: 208, 143, 44;
  --bs-link-decoration: underline;
  --bs-link-hover-color: rgb(166.4, 114.4, 35.2);
  --bs-link-hover-color-rgb: 166, 114, 35;
  --bs-code-color: #d63384;
  --bs-highlight-color: #fff;
  --bs-highlight-bg: rgb(255, 242.6, 205.4);
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #ECEEF2;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(208, 143, 44, 0.25);
  --bs-form-valid-color: #37D80A;
  --bs-form-valid-border-color: #37D80A;
  --bs-form-invalid-color: #FD5812;
  --bs-form-invalid-border-color: #FD5812;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: rgb(42.5, 47.5, 52.5);
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: rgb(226.8, 187.8, 128.4);
  --bs-secondary-text-emphasis: rgb(136.8, 141.6, 151.2);
  --bs-success-text-emphasis: rgb(135, 231.6, 108);
  --bs-info-text-emphasis: rgb(129, 211.2, 249);
  --bs-warning-text-emphasis: rgb(255, 214.8, 127.8);
  --bs-danger-text-emphasis: rgb(253.8, 154.8, 112.8);
  --bs-light-text-emphasis: #f5f7f8;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: rgb(41.6, 28.6, 8.8);
  --bs-secondary-bg-subtle: rgb(11.6, 13.2, 16.4);
  --bs-success-bg-subtle: rgb(11, 43.2, 2);
  --bs-info-bg-subtle: rgb(9, 36.4, 49);
  --bs-warning-bg-subtle: rgb(51, 37.6, 8.6);
  --bs-danger-bg-subtle: rgb(50.6, 17.6, 3.6);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: rgb(124.8, 85.8, 26.4);
  --bs-secondary-border-subtle: rgb(34.8, 39.6, 49.2);
  --bs-success-border-subtle: rgb(33, 129.6, 6);
  --bs-info-border-subtle: rgb(27, 109.2, 147);
  --bs-warning-border-subtle: rgb(153, 112.8, 25.8);
  --bs-danger-border-subtle: rgb(151.8, 52.8, 10.8);
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(226.8, 187.8, 128.4);
  --bs-link-hover-color: rgb(232.44, 201.24, 153.72);
  --bs-link-color-rgb: 227, 188, 128;
  --bs-link-hover-color-rgb: 232, 201, 154;
  --bs-code-color: rgb(230.4, 132.6, 181.2);
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: rgb(102, 77.2, 2.8);
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(117, 183, 152.4);
  --bs-form-valid-border-color: rgb(117, 183, 152.4);
  --bs-form-invalid-color: rgb(234, 133.8, 143.4);
  --bs-form-invalid-border-color: rgb(234, 133.8, 143.4);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1,
.h1 {
  font-size: calc(1.345rem + 1.14vw);
}

@media (min-width: 1200px) {

  h1,
  .h1 {
    font-size: 2.2rem;
  }
}

h2,
.h2 {
  font-size: calc(1.3274rem + 0.9288vw);
}

@media (min-width: 1200px) {

  h2,
  .h2 {
    font-size: 2.024rem;
  }
}

h3,
.h3 {
  font-size: calc(1.2834rem + 0.4008vw);
}

@media (min-width: 1200px) {

  h3,
  .h3 {
    font-size: 1.584rem;
  }
}

h4,
.h4 {
  font-size: 1.232rem;
}

h5,
.h5 {
  font-size: 0.88rem;
}

h6,
.h6 {
  font-size: 0.88rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small,
.small {
  font-size: 0.875em;
}

mark,
.mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}

a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]),
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}

pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}

a>code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}

kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
  font-size: calc(1.275rem + 0.3vw);
}

@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}

legend+* {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.1rem;
  font-weight: 300;
}

.display-1 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.625rem + 4.5vw);
}

@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.575rem + 3.9vw);
}

@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.525rem + 3.3vw);
}

@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.475rem + 2.7vw);
}

@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.425rem + 2.1vw);
}

@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.375rem + 1.5vw);
}

@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.1rem;
}

.blockquote> :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}

.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {

  .container-sm,
  .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {

  .container-md,
  .container-sm,
  .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {

  .container-lg,
  .container-md,
  .container-sm,
  .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {

  .container-xl,
  .container-lg,
  .container-md,
  .container-sm,
  .container {
    max-width: 1140px;
  }
}

@media (min-width: 1400px) {

  .container-xxl,
  .container-xl,
  .container-lg,
  .container-md,
  .container-sm,
  .container {
    max-width: 1320px;
  }
}

:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}

.row>* {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto>* {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1>* {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2>* {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3>* {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4>* {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5>* {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6>* {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }

  .row-cols-sm-auto>* {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-sm-1>* {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-sm-2>* {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-sm-3>* {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-sm-4>* {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-sm-5>* {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-sm-6>* {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-sm-0 {
    margin-left: 0;
  }

  .offset-sm-1 {
    margin-left: 8.33333333%;
  }

  .offset-sm-2 {
    margin-left: 16.66666667%;
  }

  .offset-sm-3 {
    margin-left: 25%;
  }

  .offset-sm-4 {
    margin-left: 33.33333333%;
  }

  .offset-sm-5 {
    margin-left: 41.66666667%;
  }

  .offset-sm-6 {
    margin-left: 50%;
  }

  .offset-sm-7 {
    margin-left: 58.33333333%;
  }

  .offset-sm-8 {
    margin-left: 66.66666667%;
  }

  .offset-sm-9 {
    margin-left: 75%;
  }

  .offset-sm-10 {
    margin-left: 83.33333333%;
  }

  .offset-sm-11 {
    margin-left: 91.66666667%;
  }

  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }

  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }

  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }

  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }

  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }

  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }

  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }

  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }

  .row-cols-md-auto>* {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-md-1>* {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-md-2>* {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-md-3>* {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-md-4>* {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-md-5>* {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-md-6>* {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-md-0 {
    margin-left: 0;
  }

  .offset-md-1 {
    margin-left: 8.33333333%;
  }

  .offset-md-2 {
    margin-left: 16.66666667%;
  }

  .offset-md-3 {
    margin-left: 25%;
  }

  .offset-md-4 {
    margin-left: 33.33333333%;
  }

  .offset-md-5 {
    margin-left: 41.66666667%;
  }

  .offset-md-6 {
    margin-left: 50%;
  }

  .offset-md-7 {
    margin-left: 58.33333333%;
  }

  .offset-md-8 {
    margin-left: 66.66666667%;
  }

  .offset-md-9 {
    margin-left: 75%;
  }

  .offset-md-10 {
    margin-left: 83.33333333%;
  }

  .offset-md-11 {
    margin-left: 91.66666667%;
  }

  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }

  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }

  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }

  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }

  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }

  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }

  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }

  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }

  .row-cols-lg-auto>* {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-lg-1>* {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-lg-2>* {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-lg-3>* {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-lg-4>* {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-lg-5>* {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-lg-6>* {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-lg-0 {
    margin-left: 0;
  }

  .offset-lg-1 {
    margin-left: 8.33333333%;
  }

  .offset-lg-2 {
    margin-left: 16.66666667%;
  }

  .offset-lg-3 {
    margin-left: 25%;
  }

  .offset-lg-4 {
    margin-left: 33.33333333%;
  }

  .offset-lg-5 {
    margin-left: 41.66666667%;
  }

  .offset-lg-6 {
    margin-left: 50%;
  }

  .offset-lg-7 {
    margin-left: 58.33333333%;
  }

  .offset-lg-8 {
    margin-left: 66.66666667%;
  }

  .offset-lg-9 {
    margin-left: 75%;
  }

  .offset-lg-10 {
    margin-left: 83.33333333%;
  }

  .offset-lg-11 {
    margin-left: 91.66666667%;
  }

  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }

  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }

  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }

  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }

  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }

  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }

  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }

  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }

  .row-cols-xl-auto>* {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-xl-1>* {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-xl-2>* {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-xl-3>* {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-xl-4>* {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-xl-5>* {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-xl-6>* {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-xl-0 {
    margin-left: 0;
  }

  .offset-xl-1 {
    margin-left: 8.33333333%;
  }

  .offset-xl-2 {
    margin-left: 16.66666667%;
  }

  .offset-xl-3 {
    margin-left: 25%;
  }

  .offset-xl-4 {
    margin-left: 33.33333333%;
  }

  .offset-xl-5 {
    margin-left: 41.66666667%;
  }

  .offset-xl-6 {
    margin-left: 50%;
  }

  .offset-xl-7 {
    margin-left: 58.33333333%;
  }

  .offset-xl-8 {
    margin-left: 66.66666667%;
  }

  .offset-xl-9 {
    margin-left: 75%;
  }

  .offset-xl-10 {
    margin-left: 83.33333333%;
  }

  .offset-xl-11 {
    margin-left: 91.66666667%;
  }

  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }

  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }

  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }

  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }

  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }

  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }

  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }

  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}

@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }

  .row-cols-xxl-auto>* {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-xxl-1>* {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-xxl-2>* {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-xxl-3>* {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .row-cols-xxl-4>* {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-xxl-5>* {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-xxl-6>* {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-xxl-0 {
    margin-left: 0;
  }

  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }

  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }

  .offset-xxl-3 {
    margin-left: 25%;
  }

  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }

  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }

  .offset-xxl-6 {
    margin-left: 50%;
  }

  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }

  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }

  .offset-xxl-9 {
    margin-left: 75%;
  }

  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }

  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }

  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }

  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }

  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }

  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }

  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }

  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }

  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }

  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}

.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}

.table> :not(caption)>*>* {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}

.table>tbody {
  vertical-align: inherit;
}

.table>thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm> :not(caption)>*>* {
  padding: 0.25rem 0.25rem;
}

.table-bordered> :not(caption)>* {
  border-width: var(--bs-border-width) 0;
}

.table-bordered> :not(caption)>*>* {
  border-width: 0 var(--bs-border-width);
}

.table-borderless> :not(caption)>*>* {
  border-bottom-width: 0;
}

.table-borderless> :not(:first-child) {
  border-top-width: 0;
}

.table-striped>tbody>tr:nth-of-type(odd)>* {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns> :not(caption)>tr> :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover>tbody>tr:hover>* {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(245.6, 232.6, 212.8);
  --bs-table-border-color: rgb(196.48, 186.08, 170.24);
  --bs-table-striped-bg: rgb(233.32, 220.97, 202.16);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(221.04, 209.34, 191.52);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(227.18, 215.155, 196.84);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(215.6, 217.2, 220.4);
  --bs-table-border-color: rgb(172.48, 173.76, 176.32);
  --bs-table-striped-bg: rgb(204.82, 206.34, 209.38);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(194.04, 195.48, 198.36);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(199.43, 200.91, 203.87);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: rgb(215, 247.2, 206);
  --bs-table-border-color: rgb(172, 197.76, 164.8);
  --bs-table-striped-bg: rgb(204.25, 234.84, 195.7);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(193.5, 222.48, 185.4);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(198.875, 228.66, 190.55);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: rgb(213, 240.4, 253);
  --bs-table-border-color: rgb(170.4, 192.32, 202.4);
  --bs-table-striped-bg: rgb(202.35, 228.38, 240.35);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(191.7, 216.36, 227.7);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(197.025, 222.37, 234.025);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: rgb(255, 241.6, 212.6);
  --bs-table-border-color: rgb(204, 193.28, 170.08);
  --bs-table-striped-bg: rgb(242.25, 229.52, 201.97);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(229.5, 217.44, 191.34);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(235.875, 223.48, 196.655);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: rgb(254.6, 221.6, 207.6);
  --bs-table-border-color: rgb(203.68, 177.28, 166.08);
  --bs-table-striped-bg: rgb(241.87, 210.52, 197.22);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(229.14, 199.44, 186.84);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(235.505, 204.98, 192.03);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #D5D9E2;
  --bs-table-border-color: rgb(170.4, 173.6, 180.8);
  --bs-table-striped-bg: rgb(202.35, 206.15, 214.7);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(191.7, 195.3, 203.4);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(197.025, 200.725, 209.05);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #000000;
  --bs-table-border-color: #333333;
  --bs-table-striped-bg: rgb(12.75, 12.75, 12.75);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(25.5, 25.5, 25.5);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(19.125, 19.125, 19.125);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.1rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.77rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 0.88rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}

.form-control[type=file] {
  overflow: hidden;
}

.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: rgb(231.5, 199, 149.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(208, 143, 44, 0.25);
}

.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}

.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}

.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}

.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}

.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}

.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}

.form-control-plaintext:focus {
  outline: 0;
}

.form-control-plaintext.form-control-sm,
.form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.77rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.1rem;
  border-radius: var(--bs-border-radius-lg);
}

.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}

textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}

textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}

.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}

.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}

.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}

.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}

.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 0.88rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}

.form-select:focus {
  border-color: rgb(231.5, 199, 149.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(208, 143, 44, 0.25);
}

.form-select[multiple],
.form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}

.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}

.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.77rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.1rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.32rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}

.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}

.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  print-color-adjust: exact;
}

.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}

.form-check-input[type=radio] {
  border-radius: 50%;
}

.form-check-input:active {
  filter: brightness(90%);
}

.form-check-input:focus {
  border-color: rgb(231.5, 199, 149.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(208, 143, 44, 0.25);
}

.form-check-input:checked {
  background-color: #d08f2c;
  border-color: #d08f2c;
}

.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.form-check-input[type=checkbox]:indeterminate {
  background-color: #d08f2c;
  border-color: #d08f2c;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}

.form-check-input[disabled]~.form-check-label,
.form-check-input:disabled~.form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}

.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}

.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}

.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.btn-check[disabled]+.btn,
.btn-check:disabled+.btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}

.form-range:focus {
  outline: 0;
}

.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #F6F7F9, 0 0 0 0.25rem rgba(208, 143, 44, 0.25);
}

.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #F6F7F9, 0 0 0 0.25rem rgba(208, 143, 44, 0.25);
}

.form-range::-moz-focus-outer {
  border: 0;
}

.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #d08f2c;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}

.form-range::-webkit-slider-thumb:active {
  background-color: rgb(240.9, 221.4, 191.7);
}

.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}

.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #d08f2c;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}

.form-range::-moz-range-thumb:active {
  background-color: rgb(240.9, 221.4, 191.7);
}

.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}

.form-range:disabled {
  pointer-events: none;
}

.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}

.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}

.form-floating>.form-control,
.form-floating>.form-control-plaintext,
.form-floating>.form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}

.form-floating>label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  max-width: 100%;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  color: rgba(var(--bs-body-color-rgb), 0.65);
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-floating>label {
    transition: none;
  }
}

.form-floating>.form-control,
.form-floating>.form-control-plaintext {
  padding: 1rem 0.75rem;
}

.form-floating>.form-control::placeholder,
.form-floating>.form-control-plaintext::placeholder {
  color: transparent;
}

.form-floating>.form-control:focus,
.form-floating>.form-control:not(:placeholder-shown),
.form-floating>.form-control-plaintext:focus,
.form-floating>.form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating>.form-control:-webkit-autofill,
.form-floating>.form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.form-floating>.form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
  padding-left: 0.75rem;
}

.form-floating>.form-control:focus~label,
.form-floating>.form-control:not(:placeholder-shown)~label,
.form-floating>.form-control-plaintext~label,
.form-floating>.form-select~label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating>.form-control:-webkit-autofill~label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.form-floating>textarea:focus~label::after,
.form-floating>textarea:not(:placeholder-shown)~label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}

.form-floating>textarea:disabled~label::after {
  background-color: var(--bs-secondary-bg);
}

.form-floating>.form-control-plaintext~label {
  border-width: var(--bs-border-width) 0;
}

.form-floating> :disabled~label,
.form-floating>.form-control:disabled~label {
  color: #6c757d;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group>.form-control,
.input-group>.form-select,
.input-group>.form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}

.input-group>.form-control:focus,
.input-group>.form-select:focus,
.input-group>.form-floating:focus-within {
  z-index: 5;
}

.input-group .btn {
  position: relative;
  z-index: 2;
}

.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 0.88rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}

.input-group-lg>.form-control,
.input-group-lg>.form-select,
.input-group-lg>.input-group-text,
.input-group-lg>.btn {
  padding: 0.5rem 1rem;
  font-size: 1.1rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm>.form-control,
.input-group-sm>.form-select,
.input-group-sm>.input-group-text,
.input-group-sm>.btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.77rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg>.form-select,
.input-group-sm>.form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation)> :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation)>.dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-control,
.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group.has-validation> :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation>.dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-control,
.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group> :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(-1 * var(--bs-border-width));
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group>.form-floating:not(:first-child)>.form-control,
.input-group>.form-floating:not(:first-child)>.form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.77rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid~.valid-feedback,
.was-validated :valid~.valid-tooltip,
.is-valid~.valid-feedback,
.is-valid~.valid-tooltip {
  display: block;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-control:valid:focus,
.form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid,
textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid,
.form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}

.was-validated .form-select:valid:not([multiple]):not([size]),
.was-validated .form-select:valid:not([multiple])[size="1"],
.form-select.is-valid:not([multiple]):not([size]),
.form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-select:valid:focus,
.form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid,
.form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid,
.form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}

.was-validated .form-check-input:valid:checked,
.form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}

.was-validated .form-check-input:valid:focus,
.form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-check-input:valid~.form-check-label,
.form-check-input.is-valid~.form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input~.valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group>.form-control:not(:focus):valid,
.input-group>.form-control:not(:focus).is-valid,
.was-validated .input-group>.form-select:not(:focus):valid,
.input-group>.form-select:not(:focus).is-valid,
.was-validated .input-group>.form-floating:not(:focus-within):valid,
.input-group>.form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.77rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid~.invalid-feedback,
.was-validated :invalid~.invalid-tooltip,
.is-invalid~.invalid-feedback,
.is-invalid~.invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-control:invalid:focus,
.form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid,
textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid,
.form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}

.was-validated .form-select:invalid:not([multiple]):not([size]),
.was-validated .form-select:invalid:not([multiple])[size="1"],
.form-select.is-invalid:not([multiple]):not([size]),
.form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-select:invalid:focus,
.form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid,
.form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid,
.form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}

.was-validated .form-check-input:invalid:checked,
.form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}

.was-validated .form-check-input:invalid:focus,
.form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-check-input:invalid~.form-check-label,
.form-check-input.is-invalid~.form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input~.invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group>.form-control:not(:focus):invalid,
.input-group>.form-control:not(:focus).is-invalid,
.was-validated .input-group>.form-select:not(:focus):invalid,
.input-group>.form-select:not(:focus).is-invalid,
.was-validated .input-group>.form-floating:not(:focus-within):invalid,
.input-group>.form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 0.88rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}

.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}

.btn-check+.btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}

.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn-check:focus-visible+.btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn-check:checked+.btn,
:not(.btn-check)+.btn:active,
.btn:first-child:active,
.btn.active,
.btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}

.btn-check:checked+.btn:focus-visible,
:not(.btn-check)+.btn:active:focus-visible,
.btn:first-child:active:focus-visible,
.btn.active:focus-visible,
.btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn-check:checked:focus-visible+.btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}

.btn:disabled,
.btn.disabled,
fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #000;
  --bs-btn-bg: #d08f2c;
  --bs-btn-border-color: #d08f2c;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(215.05, 159.8, 75.65);
  --bs-btn-hover-border-color: rgb(212.7, 154.2, 65.1);
  --bs-btn-focus-shadow-rgb: 177, 122, 37;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(217.4, 165.4, 86.2);
  --bs-btn-active-border-color: rgb(212.7, 154.2, 65.1);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #d08f2c;
  --bs-btn-disabled-border-color: #d08f2c;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #3A4252;
  --bs-btn-border-color: #3A4252;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(49.3, 56.1, 69.7);
  --bs-btn-hover-border-color: rgb(46.4, 52.8, 65.6);
  --bs-btn-focus-shadow-rgb: 88, 94, 108;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(46.4, 52.8, 65.6);
  --bs-btn-active-border-color: rgb(43.5, 49.5, 61.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #3A4252;
  --bs-btn-disabled-border-color: #3A4252;
}

.btn-success {
  --bs-btn-color: #000;
  --bs-btn-bg: #37D80A;
  --bs-btn-border-color: #37D80A;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(85, 221.85, 46.75);
  --bs-btn-hover-border-color: rgb(75, 219.9, 34.5);
  --bs-btn-focus-shadow-rgb: 47, 184, 9;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(95, 223.8, 59);
  --bs-btn-active-border-color: rgb(75, 219.9, 34.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #37D80A;
  --bs-btn-disabled-border-color: #37D80A;
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #2DB6F5;
  --bs-btn-border-color: #2DB6F5;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(76.5, 192.95, 246.5);
  --bs-btn-hover-border-color: rgb(66, 189.3, 246);
  --bs-btn-focus-shadow-rgb: 38, 155, 208;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(87, 196.6, 247);
  --bs-btn-active-border-color: rgb(66, 189.3, 246);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #2DB6F5;
  --bs-btn-disabled-border-color: #2DB6F5;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #FFBC2B;
  --bs-btn-border-color: #FFBC2B;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(255, 198.05, 74.8);
  --bs-btn-hover-border-color: rgb(255, 194.7, 64.2);
  --bs-btn-focus-shadow-rgb: 217, 160, 37;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(255, 201.4, 85.4);
  --bs-btn-active-border-color: rgb(255, 194.7, 64.2);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #FFBC2B;
  --bs-btn-disabled-border-color: #FFBC2B;
}

.btn-danger {
  --bs-btn-color: #000;
  --bs-btn-bg: #FD5812;
  --bs-btn-border-color: #FD5812;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(253.3, 113.05, 53.55);
  --bs-btn-hover-border-color: rgb(253.2, 104.7, 41.7);
  --bs-btn-focus-shadow-rgb: 215, 75, 15;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(253.4, 121.4, 65.4);
  --bs-btn-active-border-color: rgb(253.2, 104.7, 41.7);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #FD5812;
  --bs-btn-disabled-border-color: #FD5812;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #D5D9E2;
  --bs-btn-border-color: #D5D9E2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(181.05, 184.45, 192.1);
  --bs-btn-hover-border-color: rgb(170.4, 173.6, 180.8);
  --bs-btn-focus-shadow-rgb: 181, 184, 192;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(170.4, 173.6, 180.8);
  --bs-btn-active-border-color: rgb(159.75, 162.75, 169.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #D5D9E2;
  --bs-btn-disabled-border-color: #D5D9E2;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #000000;
  --bs-btn-border-color: #000000;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(38.25, 38.25, 38.25);
  --bs-btn-hover-border-color: rgb(25.5, 25.5, 25.5);
  --bs-btn-focus-shadow-rgb: 38, 38, 38;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #333333;
  --bs-btn-active-border-color: rgb(25.5, 25.5, 25.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #000000;
  --bs-btn-disabled-border-color: #000000;
}

.btn-primary-div {
  --bs-btn-color: #000;
  --bs-btn-bg: #d08f2c;
  --bs-btn-border-color: #d08f2c;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(215.05, 159.8, 75.65);
  --bs-btn-hover-border-color: rgb(212.7, 154.2, 65.1);
  --bs-btn-focus-shadow-rgb: 177, 122, 37;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(217.4, 165.4, 86.2);
  --bs-btn-active-border-color: rgb(212.7, 154.2, 65.1);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #d08f2c;
  --bs-btn-disabled-border-color: #d08f2c;
}

.btn-primary-div-50 {
  --bs-btn-color: #000;
  --bs-btn-bg: #b27c26;
  --bs-btn-border-color: #b27c26;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(189.55, 143.65, 70.55);
  --bs-btn-hover-border-color: rgb(185.7, 137.1, 59.7);
  --bs-btn-focus-shadow-rgb: 151, 105, 32;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(193.4, 150.2, 81.4);
  --bs-btn-active-border-color: rgb(185.7, 137.1, 59.7);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #b27c26;
  --bs-btn-disabled-border-color: #b27c26;
}

.btn-primary-div-60 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #946920;
  --bs-btn-border-color: #946920;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(125.8, 89.25, 27.2);
  --bs-btn-hover-border-color: rgb(118.4, 84, 25.6);
  --bs-btn-focus-shadow-rgb: 164, 128, 65;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(118.4, 84, 25.6);
  --bs-btn-active-border-color: rgb(111, 78.75, 24);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #946920;
  --bs-btn-disabled-border-color: #946920;
}

.btn-primary-50 {
  --bs-btn-color: #000;
  --bs-btn-bg: #b27c26;
  --bs-btn-border-color: #b27c26;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(189.55, 143.65, 70.55);
  --bs-btn-hover-border-color: rgb(185.7, 137.1, 59.7);
  --bs-btn-focus-shadow-rgb: 151, 105, 32;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(193.4, 150.2, 81.4);
  --bs-btn-active-border-color: rgb(185.7, 137.1, 59.7);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #b27c26;
  --bs-btn-disabled-border-color: #b27c26;
}

.btn-primary-60 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #946920;
  --bs-btn-border-color: #946920;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(125.8, 89.25, 27.2);
  --bs-btn-hover-border-color: rgb(118.4, 84, 25.6);
  --bs-btn-focus-shadow-rgb: 164, 128, 65;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(118.4, 84, 25.6);
  --bs-btn-active-border-color: rgb(111, 78.75, 24);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #946920;
  --bs-btn-disabled-border-color: #946920;
}

.btn-primary-70 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #76561a;
  --bs-btn-border-color: #76561a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(100.3, 73.1, 22.1);
  --bs-btn-hover-border-color: rgb(94.4, 68.8, 20.8);
  --bs-btn-focus-shadow-rgb: 139, 111, 60;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(94.4, 68.8, 20.8);
  --bs-btn-active-border-color: rgb(88.5, 64.5, 19.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #76561a;
  --bs-btn-disabled-border-color: #76561a;
}

.btn-success-50 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #1E8308;
  --bs-btn-border-color: #1E8308;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(25.5, 111.35, 6.8);
  --bs-btn-hover-border-color: rgb(24, 104.8, 6.4);
  --bs-btn-focus-shadow-rgb: 64, 150, 45;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(24, 104.8, 6.4);
  --bs-btn-active-border-color: rgb(22.5, 98.25, 6);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #1E8308;
  --bs-btn-disabled-border-color: #1E8308;
}

.btn-success-60 {
  --bs-btn-color: #000;
  --bs-btn-bg: #25B003;
  --bs-btn-border-color: #25B003;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(69.7, 187.85, 40.8);
  --bs-btn-hover-border-color: rgb(58.8, 183.9, 28.2);
  --bs-btn-focus-shadow-rgb: 31, 150, 3;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(80.6, 191.8, 53.4);
  --bs-btn-active-border-color: rgb(58.8, 183.9, 28.2);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #25B003;
  --bs-btn-disabled-border-color: #25B003;
}

.btn-success-70 {
  --bs-btn-color: #000;
  --bs-btn-bg: #82FC5A;
  --bs-btn-border-color: #82FC5A;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(148.75, 252.45, 114.75);
  --bs-btn-hover-border-color: rgb(142.5, 252.3, 106.5);
  --bs-btn-focus-shadow-rgb: 111, 214, 77;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(155, 252.6, 123);
  --bs-btn-active-border-color: rgb(142.5, 252.3, 106.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #82FC5A;
  --bs-btn-disabled-border-color: #82FC5A;
}

.btn-success-80 {
  --bs-btn-color: #000;
  --bs-btn-bg: #D8FFC8;
  --bs-btn-border-color: #D8FFC8;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(221.85, 255, 208.25);
  --bs-btn-hover-border-color: rgb(219.9, 255, 205.5);
  --bs-btn-focus-shadow-rgb: 184, 217, 170;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(223.8, 255, 211);
  --bs-btn-active-border-color: rgb(219.9, 255, 205.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #D8FFC8;
  --bs-btn-disabled-border-color: #D8FFC8;
}

.btn-success-90 {
  --bs-btn-color: #000;
  --bs-btn-bg: #eeffe5;
  --bs-btn-border-color: #eeffe5;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(240.55, 255, 232.9);
  --bs-btn-hover-border-color: rgb(239.7, 255, 231.6);
  --bs-btn-focus-shadow-rgb: 202, 217, 195;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(241.4, 255, 234.2);
  --bs-btn-active-border-color: rgb(239.7, 255, 231.6);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #eeffe5;
  --bs-btn-disabled-border-color: #eeffe5;
}

.btn-success-100 {
  --bs-btn-color: #000;
  --bs-btn-bg: #d8ffc8;
  --bs-btn-border-color: #d8ffc8;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(221.85, 255, 208.25);
  --bs-btn-hover-border-color: rgb(219.9, 255, 205.5);
  --bs-btn-focus-shadow-rgb: 184, 217, 170;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(223.8, 255, 211);
  --bs-btn-active-border-color: rgb(219.9, 255, 205.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #d8ffc8;
  --bs-btn-disabled-border-color: #d8ffc8;
}

.btn-body-bg {
  --bs-btn-color: #000;
  --bs-btn-bg: #F6F7F9;
  --bs-btn-border-color: #F6F7F9;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(247.35, 248.2, 249.9);
  --bs-btn-hover-border-color: rgb(246.9, 247.8, 249.6);
  --bs-btn-focus-shadow-rgb: 209, 210, 212;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(247.8, 248.6, 250.2);
  --bs-btn-active-border-color: rgb(246.9, 247.8, 249.6);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #F6F7F9;
  --bs-btn-disabled-border-color: #F6F7F9;
}

.btn-danger-div {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffed9d;
  --bs-btn-border-color: #ffed9d;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(255, 239.7, 171.7);
  --bs-btn-hover-border-color: rgb(255, 238.8, 166.8);
  --bs-btn-focus-shadow-rgb: 217, 201, 133;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(255, 240.6, 176.6);
  --bs-btn-active-border-color: rgb(255, 238.8, 166.8);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffed9d;
  --bs-btn-disabled-border-color: #ffed9d;
}

.btn-danger-40 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #D71C00;
  --bs-btn-border-color: #D71C00;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(182.75, 23.8, 0);
  --bs-btn-hover-border-color: rgb(172, 22.4, 0);
  --bs-btn-focus-shadow-rgb: 221, 62, 38;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(172, 22.4, 0);
  --bs-btn-active-border-color: rgb(161.25, 21, 0);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #D71C00;
  --bs-btn-disabled-border-color: #D71C00;
}

.btn-danger-50 {
  --bs-btn-color: #000;
  --bs-btn-bg: #EE3E08;
  --bs-btn-border-color: #EE3E08;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(240.55, 90.95, 45.05);
  --bs-btn-hover-border-color: rgb(239.7, 81.3, 32.7);
  --bs-btn-focus-shadow-rgb: 202, 53, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(241.4, 100.6, 57.4);
  --bs-btn-active-border-color: rgb(239.7, 81.3, 32.7);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #EE3E08;
  --bs-btn-disabled-border-color: #EE3E08;
}

.btn-danger-60 {
  --bs-btn-color: #000;
  --bs-btn-bg: #EC1F00;
  --bs-btn-border-color: #EC1F00;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(238.85, 64.6, 38.25);
  --bs-btn-hover-border-color: rgb(237.9, 53.4, 25.5);
  --bs-btn-focus-shadow-rgb: 201, 26, 0;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(239.8, 75.8, 51);
  --bs-btn-active-border-color: rgb(237.9, 53.4, 25.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #EC1F00;
  --bs-btn-disabled-border-color: #EC1F00;
}

.btn-danger-70 {
  --bs-btn-color: #000;
  --bs-btn-bg: #FFE1DD;
  --bs-btn-border-color: #FFE1DD;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(255, 229.5, 226.1);
  --bs-btn-hover-border-color: rgb(255, 228, 224.4);
  --bs-btn-focus-shadow-rgb: 217, 191, 188;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(255, 231, 227.8);
  --bs-btn-active-border-color: rgb(255, 228, 224.4);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #FFE1DD;
  --bs-btn-disabled-border-color: #FFE1DD;
}

.btn-danger-80 {
  --bs-btn-color: #000;
  --bs-btn-bg: #ff4023;
  --bs-btn-border-color: #ff4023;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(255, 92.65, 68);
  --bs-btn-hover-border-color: rgb(255, 83.1, 57);
  --bs-btn-focus-shadow-rgb: 217, 54, 30;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(255, 102.2, 79);
  --bs-btn-active-border-color: rgb(255, 83.1, 57);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ff4023;
  --bs-btn-disabled-border-color: #ff4023;
}

.btn-danger-90 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #C52B09;
  --bs-btn-border-color: #C52B09;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(167.45, 36.55, 7.65);
  --bs-btn-hover-border-color: rgb(157.6, 34.4, 7.2);
  --bs-btn-focus-shadow-rgb: 206, 75, 46;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(157.6, 34.4, 7.2);
  --bs-btn-active-border-color: rgb(147.75, 32.25, 6.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #C52B09;
  --bs-btn-disabled-border-color: #C52B09;
}

.btn-danger-100 {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffe1dd;
  --bs-btn-border-color: #ffe1dd;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(255, 229.5, 226.1);
  --bs-btn-hover-border-color: rgb(255, 228, 224.4);
  --bs-btn-focus-shadow-rgb: 217, 191, 188;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(255, 231, 227.8);
  --bs-btn-active-border-color: rgb(255, 228, 224.4);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffe1dd;
  --bs-btn-disabled-border-color: #ffe1dd;
}

.btn-rating-color {
  --bs-btn-color: #000;
  --bs-btn-bg: #FE7A36;
  --bs-btn-border-color: #FE7A36;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(254.15, 141.95, 84.15);
  --bs-btn-hover-border-color: rgb(254.1, 135.3, 74.1);
  --bs-btn-focus-shadow-rgb: 216, 104, 46;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(254.2, 148.6, 94.2);
  --bs-btn-active-border-color: rgb(254.1, 135.3, 74.1);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #FE7A36;
  --bs-btn-disabled-border-color: #FE7A36;
}

.btn-card-bg-c {
  --bs-btn-color: #000;
  --bs-btn-bg: #3584FC;
  --bs-btn-border-color: #3584FC;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(83.3, 150.45, 252.45);
  --bs-btn-hover-border-color: rgb(73.2, 144.3, 252.3);
  --bs-btn-focus-shadow-rgb: 45, 112, 214;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(93.4, 156.6, 252.6);
  --bs-btn-active-border-color: rgb(73.2, 144.3, 252.3);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #3584FC;
  --bs-btn-disabled-border-color: #3584FC;
}

.btn-card-text-c {
  --bs-btn-color: #000;
  --bs-btn-bg: #FFE8D4;
  --bs-btn-border-color: #FFE8D4;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(255, 235.45, 218.45);
  --bs-btn-hover-border-color: rgb(255, 234.3, 216.3);
  --bs-btn-focus-shadow-rgb: 217, 197, 180;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(255, 236.6, 220.6);
  --bs-btn-active-border-color: rgb(255, 234.3, 216.3);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #FFE8D4;
  --bs-btn-disabled-border-color: #FFE8D4;
}

.btn-gary-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #F4F6FC;
  --bs-btn-border-color: #F4F6FC;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(245.65, 247.35, 252.45);
  --bs-btn-hover-border-color: rgb(245.1, 246.9, 252.3);
  --bs-btn-focus-shadow-rgb: 207, 209, 214;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(246.2, 247.8, 252.6);
  --bs-btn-active-border-color: rgb(245.1, 246.9, 252.3);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #F4F6FC;
  --bs-btn-disabled-border-color: #F4F6FC;
}

.btn-border-color {
  --bs-btn-color: #000;
  --bs-btn-bg: #ECEEF2;
  --bs-btn-border-color: #ECEEF2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(238.85, 240.55, 243.95);
  --bs-btn-hover-border-color: rgb(237.9, 239.7, 243.3);
  --bs-btn-focus-shadow-rgb: 201, 202, 206;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(239.8, 241.4, 244.6);
  --bs-btn-active-border-color: rgb(237.9, 239.7, 243.3);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ECEEF2;
  --bs-btn-disabled-border-color: #ECEEF2;
}

.btn-border-color-50 {
  --bs-btn-color: #000;
  --bs-btn-bg: #ECF0FF;
  --bs-btn-border-color: #ECF0FF;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(238.85, 242.25, 255);
  --bs-btn-hover-border-color: rgb(237.9, 241.5, 255);
  --bs-btn-focus-shadow-rgb: 201, 204, 217;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(239.8, 243, 255);
  --bs-btn-active-border-color: rgb(237.9, 241.5, 255);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ECF0FF;
  --bs-btn-disabled-border-color: #ECF0FF;
}

.btn-gray-100 {
  --bs-btn-color: #000;
  --bs-btn-bg: #f5f7f8;
  --bs-btn-border-color: #f5f7f8;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(246.5, 248.2, 249.05);
  --bs-btn-hover-border-color: rgb(246, 247.8, 248.7);
  --bs-btn-focus-shadow-rgb: 208, 210, 211;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(247, 248.6, 249.4);
  --bs-btn-active-border-color: rgb(246, 247.8, 248.7);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f5f7f8;
  --bs-btn-disabled-border-color: #f5f7f8;
}

.btn-body-color-50 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #526077;
  --bs-btn-border-color: #526077;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(69.7, 81.6, 101.15);
  --bs-btn-hover-border-color: rgb(65.6, 76.8, 95.2);
  --bs-btn-focus-shadow-rgb: 108, 120, 139;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(65.6, 76.8, 95.2);
  --bs-btn-active-border-color: rgb(61.5, 72, 89.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #526077;
  --bs-btn-disabled-border-color: #526077;
}

.btn-body-color-60 {
  --bs-btn-color: #000;
  --bs-btn-bg: #8695AA;
  --bs-btn-border-color: #8695AA;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(152.15, 164.9, 182.75);
  --bs-btn-hover-border-color: rgb(146.1, 159.6, 178.5);
  --bs-btn-focus-shadow-rgb: 114, 127, 145;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(158.2, 170.2, 187);
  --bs-btn-active-border-color: rgb(146.1, 159.6, 178.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #8695AA;
  --bs-btn-disabled-border-color: #8695AA;
}

.btn-purple-100 {
  --bs-btn-color: #000;
  --bs-btn-bg: #f3e8ff;
  --bs-btn-border-color: #f3e8ff;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(244.8, 235.45, 255);
  --bs-btn-hover-border-color: rgb(244.2, 234.3, 255);
  --bs-btn-focus-shadow-rgb: 207, 197, 217;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(245.4, 236.6, 255);
  --bs-btn-active-border-color: rgb(244.2, 234.3, 255);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f3e8ff;
  --bs-btn-disabled-border-color: #f3e8ff;
}

.btn-info-100 {
  --bs-btn-color: #000;
  --bs-btn-bg: #daebff;
  --bs-btn-border-color: #daebff;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(223.55, 238, 255);
  --bs-btn-hover-border-color: rgb(221.7, 237, 255);
  --bs-btn-focus-shadow-rgb: 185, 200, 217;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(225.4, 239, 255);
  --bs-btn-active-border-color: rgb(221.7, 237, 255);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #daebff;
  --bs-btn-disabled-border-color: #daebff;
}

.btn-outline-primary {
  --bs-btn-color: #d08f2c;
  --bs-btn-border-color: #d08f2c;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d08f2c;
  --bs-btn-hover-border-color: #d08f2c;
  --bs-btn-focus-shadow-rgb: 208, 143, 44;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #d08f2c;
  --bs-btn-active-border-color: #d08f2c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #d08f2c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #d08f2c;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #3A4252;
  --bs-btn-border-color: #3A4252;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #3A4252;
  --bs-btn-hover-border-color: #3A4252;
  --bs-btn-focus-shadow-rgb: 58, 66, 82;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #3A4252;
  --bs-btn-active-border-color: #3A4252;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #3A4252;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #3A4252;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #37D80A;
  --bs-btn-border-color: #37D80A;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #37D80A;
  --bs-btn-hover-border-color: #37D80A;
  --bs-btn-focus-shadow-rgb: 55, 216, 10;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #37D80A;
  --bs-btn-active-border-color: #37D80A;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #37D80A;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #37D80A;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #2DB6F5;
  --bs-btn-border-color: #2DB6F5;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #2DB6F5;
  --bs-btn-hover-border-color: #2DB6F5;
  --bs-btn-focus-shadow-rgb: 45, 182, 245;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #2DB6F5;
  --bs-btn-active-border-color: #2DB6F5;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #2DB6F5;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #2DB6F5;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #FFBC2B;
  --bs-btn-border-color: #FFBC2B;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #FFBC2B;
  --bs-btn-hover-border-color: #FFBC2B;
  --bs-btn-focus-shadow-rgb: 255, 188, 43;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #FFBC2B;
  --bs-btn-active-border-color: #FFBC2B;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFBC2B;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #FFBC2B;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #FD5812;
  --bs-btn-border-color: #FD5812;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #FD5812;
  --bs-btn-hover-border-color: #FD5812;
  --bs-btn-focus-shadow-rgb: 253, 88, 18;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #FD5812;
  --bs-btn-active-border-color: #FD5812;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FD5812;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #FD5812;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #D5D9E2;
  --bs-btn-border-color: #D5D9E2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #D5D9E2;
  --bs-btn-hover-border-color: #D5D9E2;
  --bs-btn-focus-shadow-rgb: 213, 217, 226;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #D5D9E2;
  --bs-btn-active-border-color: #D5D9E2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #D5D9E2;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #D5D9E2;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #000000;
  --bs-btn-border-color: #000000;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #000000;
  --bs-btn-hover-border-color: #000000;
  --bs-btn-focus-shadow-rgb: 0, 0, 0;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #000000;
  --bs-btn-active-border-color: #000000;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #000000;
  --bs-gradient: none;
}

.btn-outline-primary-div {
  --bs-btn-color: #d08f2c;
  --bs-btn-border-color: #d08f2c;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d08f2c;
  --bs-btn-hover-border-color: #d08f2c;
  --bs-btn-focus-shadow-rgb: 208, 143, 44;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #d08f2c;
  --bs-btn-active-border-color: #d08f2c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #d08f2c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #d08f2c;
  --bs-gradient: none;
}

.btn-outline-primary-div-50 {
  --bs-btn-color: #b27c26;
  --bs-btn-border-color: #b27c26;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #b27c26;
  --bs-btn-hover-border-color: #b27c26;
  --bs-btn-focus-shadow-rgb: 178, 124, 38;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #b27c26;
  --bs-btn-active-border-color: #b27c26;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #b27c26;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #b27c26;
  --bs-gradient: none;
}

.btn-outline-primary-div-60 {
  --bs-btn-color: #946920;
  --bs-btn-border-color: #946920;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #946920;
  --bs-btn-hover-border-color: #946920;
  --bs-btn-focus-shadow-rgb: 148, 105, 32;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #946920;
  --bs-btn-active-border-color: #946920;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #946920;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #946920;
  --bs-gradient: none;
}

.btn-outline-primary-50 {
  --bs-btn-color: #b27c26;
  --bs-btn-border-color: #b27c26;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #b27c26;
  --bs-btn-hover-border-color: #b27c26;
  --bs-btn-focus-shadow-rgb: 178, 124, 38;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #b27c26;
  --bs-btn-active-border-color: #b27c26;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #b27c26;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #b27c26;
  --bs-gradient: none;
}

.btn-outline-primary-60 {
  --bs-btn-color: #946920;
  --bs-btn-border-color: #946920;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #946920;
  --bs-btn-hover-border-color: #946920;
  --bs-btn-focus-shadow-rgb: 148, 105, 32;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #946920;
  --bs-btn-active-border-color: #946920;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #946920;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #946920;
  --bs-gradient: none;
}

.btn-outline-primary-70 {
  --bs-btn-color: #76561a;
  --bs-btn-border-color: #76561a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #76561a;
  --bs-btn-hover-border-color: #76561a;
  --bs-btn-focus-shadow-rgb: 118, 86, 26;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #76561a;
  --bs-btn-active-border-color: #76561a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #76561a;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #76561a;
  --bs-gradient: none;
}

.btn-outline-success-50 {
  --bs-btn-color: #1E8308;
  --bs-btn-border-color: #1E8308;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #1E8308;
  --bs-btn-hover-border-color: #1E8308;
  --bs-btn-focus-shadow-rgb: 30, 131, 8;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #1E8308;
  --bs-btn-active-border-color: #1E8308;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #1E8308;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #1E8308;
  --bs-gradient: none;
}

.btn-outline-success-60 {
  --bs-btn-color: #25B003;
  --bs-btn-border-color: #25B003;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #25B003;
  --bs-btn-hover-border-color: #25B003;
  --bs-btn-focus-shadow-rgb: 37, 176, 3;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #25B003;
  --bs-btn-active-border-color: #25B003;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #25B003;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #25B003;
  --bs-gradient: none;
}

.btn-outline-success-70 {
  --bs-btn-color: #82FC5A;
  --bs-btn-border-color: #82FC5A;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #82FC5A;
  --bs-btn-hover-border-color: #82FC5A;
  --bs-btn-focus-shadow-rgb: 130, 252, 90;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #82FC5A;
  --bs-btn-active-border-color: #82FC5A;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #82FC5A;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #82FC5A;
  --bs-gradient: none;
}

.btn-outline-success-80 {
  --bs-btn-color: #D8FFC8;
  --bs-btn-border-color: #D8FFC8;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #D8FFC8;
  --bs-btn-hover-border-color: #D8FFC8;
  --bs-btn-focus-shadow-rgb: 216, 255, 200;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #D8FFC8;
  --bs-btn-active-border-color: #D8FFC8;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #D8FFC8;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #D8FFC8;
  --bs-gradient: none;
}

.btn-outline-success-90 {
  --bs-btn-color: #eeffe5;
  --bs-btn-border-color: #eeffe5;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #eeffe5;
  --bs-btn-hover-border-color: #eeffe5;
  --bs-btn-focus-shadow-rgb: 238, 255, 229;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #eeffe5;
  --bs-btn-active-border-color: #eeffe5;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #eeffe5;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #eeffe5;
  --bs-gradient: none;
}

.btn-outline-success-100 {
  --bs-btn-color: #d8ffc8;
  --bs-btn-border-color: #d8ffc8;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d8ffc8;
  --bs-btn-hover-border-color: #d8ffc8;
  --bs-btn-focus-shadow-rgb: 216, 255, 200;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #d8ffc8;
  --bs-btn-active-border-color: #d8ffc8;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #d8ffc8;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #d8ffc8;
  --bs-gradient: none;
}

.btn-outline-body-bg {
  --bs-btn-color: #F6F7F9;
  --bs-btn-border-color: #F6F7F9;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #F6F7F9;
  --bs-btn-hover-border-color: #F6F7F9;
  --bs-btn-focus-shadow-rgb: 246, 247, 249;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #F6F7F9;
  --bs-btn-active-border-color: #F6F7F9;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #F6F7F9;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #F6F7F9;
  --bs-gradient: none;
}

.btn-outline-danger-div {
  --bs-btn-color: #ffed9d;
  --bs-btn-border-color: #ffed9d;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffed9d;
  --bs-btn-hover-border-color: #ffed9d;
  --bs-btn-focus-shadow-rgb: 255, 237, 157;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffed9d;
  --bs-btn-active-border-color: #ffed9d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffed9d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffed9d;
  --bs-gradient: none;
}

.btn-outline-danger-40 {
  --bs-btn-color: #D71C00;
  --bs-btn-border-color: #D71C00;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #D71C00;
  --bs-btn-hover-border-color: #D71C00;
  --bs-btn-focus-shadow-rgb: 215, 28, 0;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #D71C00;
  --bs-btn-active-border-color: #D71C00;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #D71C00;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #D71C00;
  --bs-gradient: none;
}

.btn-outline-danger-50 {
  --bs-btn-color: #EE3E08;
  --bs-btn-border-color: #EE3E08;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #EE3E08;
  --bs-btn-hover-border-color: #EE3E08;
  --bs-btn-focus-shadow-rgb: 238, 62, 8;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #EE3E08;
  --bs-btn-active-border-color: #EE3E08;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #EE3E08;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #EE3E08;
  --bs-gradient: none;
}

.btn-outline-danger-60 {
  --bs-btn-color: #EC1F00;
  --bs-btn-border-color: #EC1F00;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #EC1F00;
  --bs-btn-hover-border-color: #EC1F00;
  --bs-btn-focus-shadow-rgb: 236, 31, 0;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #EC1F00;
  --bs-btn-active-border-color: #EC1F00;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #EC1F00;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #EC1F00;
  --bs-gradient: none;
}

.btn-outline-danger-70 {
  --bs-btn-color: #FFE1DD;
  --bs-btn-border-color: #FFE1DD;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #FFE1DD;
  --bs-btn-hover-border-color: #FFE1DD;
  --bs-btn-focus-shadow-rgb: 255, 225, 221;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #FFE1DD;
  --bs-btn-active-border-color: #FFE1DD;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFE1DD;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #FFE1DD;
  --bs-gradient: none;
}

.btn-outline-danger-80 {
  --bs-btn-color: #ff4023;
  --bs-btn-border-color: #ff4023;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ff4023;
  --bs-btn-hover-border-color: #ff4023;
  --bs-btn-focus-shadow-rgb: 255, 64, 35;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ff4023;
  --bs-btn-active-border-color: #ff4023;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ff4023;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ff4023;
  --bs-gradient: none;
}

.btn-outline-danger-90 {
  --bs-btn-color: #C52B09;
  --bs-btn-border-color: #C52B09;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #C52B09;
  --bs-btn-hover-border-color: #C52B09;
  --bs-btn-focus-shadow-rgb: 197, 43, 9;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #C52B09;
  --bs-btn-active-border-color: #C52B09;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #C52B09;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #C52B09;
  --bs-gradient: none;
}

.btn-outline-danger-100 {
  --bs-btn-color: #ffe1dd;
  --bs-btn-border-color: #ffe1dd;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffe1dd;
  --bs-btn-hover-border-color: #ffe1dd;
  --bs-btn-focus-shadow-rgb: 255, 225, 221;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffe1dd;
  --bs-btn-active-border-color: #ffe1dd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffe1dd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffe1dd;
  --bs-gradient: none;
}

.btn-outline-rating-color {
  --bs-btn-color: #FE7A36;
  --bs-btn-border-color: #FE7A36;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #FE7A36;
  --bs-btn-hover-border-color: #FE7A36;
  --bs-btn-focus-shadow-rgb: 254, 122, 54;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #FE7A36;
  --bs-btn-active-border-color: #FE7A36;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FE7A36;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #FE7A36;
  --bs-gradient: none;
}

.btn-outline-card-bg-c {
  --bs-btn-color: #3584FC;
  --bs-btn-border-color: #3584FC;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #3584FC;
  --bs-btn-hover-border-color: #3584FC;
  --bs-btn-focus-shadow-rgb: 53, 132, 252;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #3584FC;
  --bs-btn-active-border-color: #3584FC;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #3584FC;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #3584FC;
  --bs-gradient: none;
}

.btn-outline-card-text-c {
  --bs-btn-color: #FFE8D4;
  --bs-btn-border-color: #FFE8D4;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #FFE8D4;
  --bs-btn-hover-border-color: #FFE8D4;
  --bs-btn-focus-shadow-rgb: 255, 232, 212;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #FFE8D4;
  --bs-btn-active-border-color: #FFE8D4;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFE8D4;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #FFE8D4;
  --bs-gradient: none;
}

.btn-outline-gary-light {
  --bs-btn-color: #F4F6FC;
  --bs-btn-border-color: #F4F6FC;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #F4F6FC;
  --bs-btn-hover-border-color: #F4F6FC;
  --bs-btn-focus-shadow-rgb: 244, 246, 252;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #F4F6FC;
  --bs-btn-active-border-color: #F4F6FC;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #F4F6FC;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #F4F6FC;
  --bs-gradient: none;
}

.btn-outline-border-color {
  --bs-btn-color: #ECEEF2;
  --bs-btn-border-color: #ECEEF2;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ECEEF2;
  --bs-btn-hover-border-color: #ECEEF2;
  --bs-btn-focus-shadow-rgb: 236, 238, 242;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ECEEF2;
  --bs-btn-active-border-color: #ECEEF2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ECEEF2;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ECEEF2;
  --bs-gradient: none;
}

.btn-outline-border-color-50 {
  --bs-btn-color: #ECF0FF;
  --bs-btn-border-color: #ECF0FF;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ECF0FF;
  --bs-btn-hover-border-color: #ECF0FF;
  --bs-btn-focus-shadow-rgb: 236, 240, 255;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ECF0FF;
  --bs-btn-active-border-color: #ECF0FF;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ECF0FF;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ECF0FF;
  --bs-gradient: none;
}

.btn-outline-gray-100 {
  --bs-btn-color: #f5f7f8;
  --bs-btn-border-color: #f5f7f8;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f5f7f8;
  --bs-btn-hover-border-color: #f5f7f8;
  --bs-btn-focus-shadow-rgb: 245, 247, 248;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f5f7f8;
  --bs-btn-active-border-color: #f5f7f8;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f5f7f8;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f5f7f8;
  --bs-gradient: none;
}

.btn-outline-body-color-50 {
  --bs-btn-color: #526077;
  --bs-btn-border-color: #526077;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #526077;
  --bs-btn-hover-border-color: #526077;
  --bs-btn-focus-shadow-rgb: 82, 96, 119;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #526077;
  --bs-btn-active-border-color: #526077;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #526077;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #526077;
  --bs-gradient: none;
}

.btn-outline-body-color-60 {
  --bs-btn-color: #8695AA;
  --bs-btn-border-color: #8695AA;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #8695AA;
  --bs-btn-hover-border-color: #8695AA;
  --bs-btn-focus-shadow-rgb: 134, 149, 170;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #8695AA;
  --bs-btn-active-border-color: #8695AA;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #8695AA;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #8695AA;
  --bs-gradient: none;
}

.btn-outline-purple-100 {
  --bs-btn-color: #f3e8ff;
  --bs-btn-border-color: #f3e8ff;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f3e8ff;
  --bs-btn-hover-border-color: #f3e8ff;
  --bs-btn-focus-shadow-rgb: 243, 232, 255;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f3e8ff;
  --bs-btn-active-border-color: #f3e8ff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f3e8ff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f3e8ff;
  --bs-gradient: none;
}

.btn-outline-info-100 {
  --bs-btn-color: #daebff;
  --bs-btn-border-color: #daebff;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #daebff;
  --bs-btn-hover-border-color: #daebff;
  --bs-btn-focus-shadow-rgb: 218, 235, 255;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #daebff;
  --bs-btn-active-border-color: #daebff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #daebff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #daebff;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 177, 122, 37;
  text-decoration: underline;
}

.btn-link:focus-visible {
  color: var(--bs-btn-color);
}

.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg,
.btn-group-lg>.btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.1rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm,
.btn-group-sm>.btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.77rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}

.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}

.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 0.88rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #d08f2c;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}

.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}

.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}

.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }

  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-sm-end {
    --bs-position: end;
  }

  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }

  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-md-end {
    --bs-position: end;
  }

  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }

  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-lg-end {
    --bs-position: end;
  }

  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }

  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xl-end {
    --bs-position: end;
  }

  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }

  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xxl-end {
    --bs-position: end;
  }

  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}

.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}

.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}

.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}

.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}

.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}

.dropstart .dropdown-toggle::after {
  display: none;
}

.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}

.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}

.dropdown-item:hover,
.dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}

.dropdown-item.active,
.dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}

.dropdown-item.disabled,
.dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.77rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #d08f2c;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.btn-group>.btn,
.btn-group-vertical>.btn {
  position: relative;
  flex: 1 1 auto;
}

.btn-group>.btn-check:checked+.btn,
.btn-group>.btn-check:focus+.btn,
.btn-group>.btn:hover,
.btn-group>.btn:focus,
.btn-group>.btn:active,
.btn-group>.btn.active,
.btn-group-vertical>.btn-check:checked+.btn,
.btn-group-vertical>.btn-check:focus+.btn,
.btn-group-vertical>.btn:hover,
.btn-group-vertical>.btn:focus,
.btn-group-vertical>.btn:active,
.btn-group-vertical>.btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--bs-border-radius);
}

.btn-group> :not(.btn-check:first-child)+.btn,
.btn-group>.btn-group:not(:first-child) {
  margin-left: calc(-1 * var(--bs-border-width));
}

.btn-group>.btn:not(:last-child):not(.dropdown-toggle),
.btn-group>.btn.dropdown-toggle-split:first-child,
.btn-group>.btn-group:not(:last-child)>.btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group>.btn:nth-child(n+3),
.btn-group> :not(.btn-check)+.btn,
.btn-group>.btn-group:not(:first-child)>.btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}

.dropdown-toggle-split::after,
.dropup .dropdown-toggle-split::after,
.dropend .dropdown-toggle-split::after {
  margin-left: 0;
}

.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm+.dropdown-toggle-split,
.btn-group-sm>.btn+.dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg+.dropdown-toggle-split,
.btn-group-lg>.btn+.dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.btn-group-vertical>.btn,
.btn-group-vertical>.btn-group {
  width: 100%;
}

.btn-group-vertical>.btn:not(:first-child),
.btn-group-vertical>.btn-group:not(:first-child) {
  margin-top: calc(-1 * var(--bs-border-width));
}

.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical>.btn-group:not(:last-child)>.btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical>.btn:nth-child(n+3),
.btn-group-vertical> :not(.btn-check)+.btn,
.btn-group-vertical>.btn-group:not(:first-child)>.btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}

.nav-link:hover,
.nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}

.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(208, 143, 44, 0.25);
}

.nav-link.disabled,
.nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}

.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}

.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}

.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #d08f2c;
}

.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}

.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}

.nav-underline .nav-link:hover,
.nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}

.nav-underline .nav-link.active,
.nav-underline .show>.nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill>.nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified>.nav-link,
.nav-justified .nav-item {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content>.tab-pane {
  display: none;
}

.tab-content>.active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.335rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.1rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.1rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}

.navbar>.container,
.navbar>.container-fluid,
.navbar>.container-sm,
.navbar>.container-md,
.navbar>.container-lg,
.navbar>.container-xl,
.navbar>.container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}

.navbar-brand:hover,
.navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.navbar-nav .nav-link.active,
.navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}

.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}

.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-grow: 1;
  flex-basis: 100%;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}

@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}

.navbar-toggler:hover {
  text-decoration: none;
}

.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }

  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-sm .navbar-toggler {
    display: none;
  }

  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }

  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }

  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }

  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-md .navbar-toggler {
    display: none;
  }

  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }

  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }

  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }

  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-lg .navbar-toggler {
    display: none;
  }

  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }

  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }

  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }

  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-xl .navbar-toggler {
    display: none;
  }

  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }

  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }

  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }

  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }

  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }

  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }

  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }

  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}

.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}

.navbar-expand .navbar-nav {
  flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}

.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}

.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}

.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}

.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}

.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}

.card>hr {
  margin-right: 0;
  margin-left: 0;
}

.card>.list-group {
  border-top: inherit;
  border-bottom: inherit;
}

.card>.list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card>.list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card>.card-header+.list-group,
.card>.list-group+.card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link+.card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}

.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}

.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}

.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group>.card {
  margin-bottom: var(--bs-card-group-margin);
}

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }

  .card-group>.card {
    flex: 1 0;
    margin-bottom: 0;
  }

  .card-group>.card+.card {
    margin-left: 0;
    border-left: 0;
  }

  .card-group>.card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .card-group>.card:not(:last-child)>.card-img-top,
  .card-group>.card:not(:last-child)>.card-header {
    border-top-right-radius: 0;
  }

  .card-group>.card:not(:last-child)>.card-img-bottom,
  .card-group>.card:not(:last-child)>.card-footer {
    border-bottom-right-radius: 0;
  }

  .card-group>.card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .card-group>.card:not(:first-child)>.card-img-top,
  .card-group>.card:not(:first-child)>.card-header {
    border-top-left-radius: 0;
  }

  .card-group>.card:not(:first-child)>.card-img-bottom,
  .card-group>.card:not(:first-child)>.card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(208, 143, 44, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 0.88rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}

.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}

.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}

.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}

@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}

.accordion-button:hover {
  z-index: 2;
}

.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}

.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}

.accordion-item:first-of-type>.accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}

.accordion-item:not(:first-of-type) {
  border-top: 0;
}

.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-item:last-of-type>.accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}

.accordion-item:last-of-type>.accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush>.accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}

.accordion-flush>.accordion-item:first-child {
  border-top: 0;
}

.accordion-flush>.accordion-item:last-child {
  border-bottom: 0;
}

.accordion-flush>.accordion-item>.accordion-collapse,
.accordion-flush>.accordion-item>.accordion-header .accordion-button,
.accordion-flush>.accordion-item>.accordion-header .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item+.breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}

.breadcrumb-item+.breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/")
    /* rtl: var(--bs-breadcrumb-divider, "/") */
  ;
}

.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 0.88rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(208, 143, 44, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #d08f2c;
  --bs-pagination-active-border-color: #d08f2c;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}

.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}

.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}

.page-link.active,
.active>.page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}

.page-link.disabled,
.disabled>.page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(-1 * var(--bs-border-width));
}

.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}

.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.1rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.77rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}

.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

.alert-primary-div {
  --bs-alert-color: var(--bs-primary-div-text-emphasis);
  --bs-alert-bg: var(--bs-primary-div-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-div-border-subtle);
  --bs-alert-link-color: var(--bs-primary-div-text-emphasis);
}

.alert-primary-div-50 {
  --bs-alert-color: var(--bs-primary-div-50-text-emphasis);
  --bs-alert-bg: var(--bs-primary-div-50-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-div-50-border-subtle);
  --bs-alert-link-color: var(--bs-primary-div-50-text-emphasis);
}

.alert-primary-div-60 {
  --bs-alert-color: var(--bs-primary-div-60-text-emphasis);
  --bs-alert-bg: var(--bs-primary-div-60-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-div-60-border-subtle);
  --bs-alert-link-color: var(--bs-primary-div-60-text-emphasis);
}

.alert-primary-50 {
  --bs-alert-color: var(--bs-primary-50-text-emphasis);
  --bs-alert-bg: var(--bs-primary-50-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-50-border-subtle);
  --bs-alert-link-color: var(--bs-primary-50-text-emphasis);
}

.alert-primary-60 {
  --bs-alert-color: var(--bs-primary-60-text-emphasis);
  --bs-alert-bg: var(--bs-primary-60-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-60-border-subtle);
  --bs-alert-link-color: var(--bs-primary-60-text-emphasis);
}

.alert-primary-70 {
  --bs-alert-color: var(--bs-primary-70-text-emphasis);
  --bs-alert-bg: var(--bs-primary-70-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-70-border-subtle);
  --bs-alert-link-color: var(--bs-primary-70-text-emphasis);
}

.alert-success-50 {
  --bs-alert-color: var(--bs-success-50-text-emphasis);
  --bs-alert-bg: var(--bs-success-50-bg-subtle);
  --bs-alert-border-color: var(--bs-success-50-border-subtle);
  --bs-alert-link-color: var(--bs-success-50-text-emphasis);
}

.alert-success-60 {
  --bs-alert-color: var(--bs-success-60-text-emphasis);
  --bs-alert-bg: var(--bs-success-60-bg-subtle);
  --bs-alert-border-color: var(--bs-success-60-border-subtle);
  --bs-alert-link-color: var(--bs-success-60-text-emphasis);
}

.alert-success-70 {
  --bs-alert-color: var(--bs-success-70-text-emphasis);
  --bs-alert-bg: var(--bs-success-70-bg-subtle);
  --bs-alert-border-color: var(--bs-success-70-border-subtle);
  --bs-alert-link-color: var(--bs-success-70-text-emphasis);
}

.alert-success-80 {
  --bs-alert-color: var(--bs-success-80-text-emphasis);
  --bs-alert-bg: var(--bs-success-80-bg-subtle);
  --bs-alert-border-color: var(--bs-success-80-border-subtle);
  --bs-alert-link-color: var(--bs-success-80-text-emphasis);
}

.alert-success-90 {
  --bs-alert-color: var(--bs-success-90-text-emphasis);
  --bs-alert-bg: var(--bs-success-90-bg-subtle);
  --bs-alert-border-color: var(--bs-success-90-border-subtle);
  --bs-alert-link-color: var(--bs-success-90-text-emphasis);
}

.alert-success-100 {
  --bs-alert-color: var(--bs-success-100-text-emphasis);
  --bs-alert-bg: var(--bs-success-100-bg-subtle);
  --bs-alert-border-color: var(--bs-success-100-border-subtle);
  --bs-alert-link-color: var(--bs-success-100-text-emphasis);
}

.alert-body-bg {
  --bs-alert-color: var(--bs-body-bg-text-emphasis);
  --bs-alert-bg: var(--bs-body-bg-bg-subtle);
  --bs-alert-border-color: var(--bs-body-bg-border-subtle);
  --bs-alert-link-color: var(--bs-body-bg-text-emphasis);
}

.alert-danger-div {
  --bs-alert-color: var(--bs-danger-div-text-emphasis);
  --bs-alert-bg: var(--bs-danger-div-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-div-border-subtle);
  --bs-alert-link-color: var(--bs-danger-div-text-emphasis);
}

.alert-danger-40 {
  --bs-alert-color: var(--bs-danger-40-text-emphasis);
  --bs-alert-bg: var(--bs-danger-40-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-40-border-subtle);
  --bs-alert-link-color: var(--bs-danger-40-text-emphasis);
}

.alert-danger-50 {
  --bs-alert-color: var(--bs-danger-50-text-emphasis);
  --bs-alert-bg: var(--bs-danger-50-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-50-border-subtle);
  --bs-alert-link-color: var(--bs-danger-50-text-emphasis);
}

.alert-danger-60 {
  --bs-alert-color: var(--bs-danger-60-text-emphasis);
  --bs-alert-bg: var(--bs-danger-60-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-60-border-subtle);
  --bs-alert-link-color: var(--bs-danger-60-text-emphasis);
}

.alert-danger-70 {
  --bs-alert-color: var(--bs-danger-70-text-emphasis);
  --bs-alert-bg: var(--bs-danger-70-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-70-border-subtle);
  --bs-alert-link-color: var(--bs-danger-70-text-emphasis);
}

.alert-danger-80 {
  --bs-alert-color: var(--bs-danger-80-text-emphasis);
  --bs-alert-bg: var(--bs-danger-80-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-80-border-subtle);
  --bs-alert-link-color: var(--bs-danger-80-text-emphasis);
}

.alert-danger-90 {
  --bs-alert-color: var(--bs-danger-90-text-emphasis);
  --bs-alert-bg: var(--bs-danger-90-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-90-border-subtle);
  --bs-alert-link-color: var(--bs-danger-90-text-emphasis);
}

.alert-danger-100 {
  --bs-alert-color: var(--bs-danger-100-text-emphasis);
  --bs-alert-bg: var(--bs-danger-100-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-100-border-subtle);
  --bs-alert-link-color: var(--bs-danger-100-text-emphasis);
}

.alert-rating-color {
  --bs-alert-color: var(--bs-rating-color-text-emphasis);
  --bs-alert-bg: var(--bs-rating-color-bg-subtle);
  --bs-alert-border-color: var(--bs-rating-color-border-subtle);
  --bs-alert-link-color: var(--bs-rating-color-text-emphasis);
}

.alert-card-bg-c {
  --bs-alert-color: var(--bs-card-bg-c-text-emphasis);
  --bs-alert-bg: var(--bs-card-bg-c-bg-subtle);
  --bs-alert-border-color: var(--bs-card-bg-c-border-subtle);
  --bs-alert-link-color: var(--bs-card-bg-c-text-emphasis);
}

.alert-card-text-c {
  --bs-alert-color: var(--bs-card-text-c-text-emphasis);
  --bs-alert-bg: var(--bs-card-text-c-bg-subtle);
  --bs-alert-border-color: var(--bs-card-text-c-border-subtle);
  --bs-alert-link-color: var(--bs-card-text-c-text-emphasis);
}

.alert-gary-light {
  --bs-alert-color: var(--bs-gary-light-text-emphasis);
  --bs-alert-bg: var(--bs-gary-light-bg-subtle);
  --bs-alert-border-color: var(--bs-gary-light-border-subtle);
  --bs-alert-link-color: var(--bs-gary-light-text-emphasis);
}

.alert-border-color {
  --bs-alert-color: var(--bs-border-color-text-emphasis);
  --bs-alert-bg: var(--bs-border-color-bg-subtle);
  --bs-alert-border-color: var(--bs-border-color-border-subtle);
  --bs-alert-link-color: var(--bs-border-color-text-emphasis);
}

.alert-border-color-50 {
  --bs-alert-color: var(--bs-border-color-50-text-emphasis);
  --bs-alert-bg: var(--bs-border-color-50-bg-subtle);
  --bs-alert-border-color: var(--bs-border-color-50-border-subtle);
  --bs-alert-link-color: var(--bs-border-color-50-text-emphasis);
}

.alert-gray-100 {
  --bs-alert-color: var(--bs-gray-100-text-emphasis);
  --bs-alert-bg: var(--bs-gray-100-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-100-border-subtle);
  --bs-alert-link-color: var(--bs-gray-100-text-emphasis);
}

.alert-body-color-50 {
  --bs-alert-color: var(--bs-body-color-50-text-emphasis);
  --bs-alert-bg: var(--bs-body-color-50-bg-subtle);
  --bs-alert-border-color: var(--bs-body-color-50-border-subtle);
  --bs-alert-link-color: var(--bs-body-color-50-text-emphasis);
}

.alert-body-color-60 {
  --bs-alert-color: var(--bs-body-color-60-text-emphasis);
  --bs-alert-bg: var(--bs-body-color-60-bg-subtle);
  --bs-alert-border-color: var(--bs-body-color-60-border-subtle);
  --bs-alert-link-color: var(--bs-body-color-60-text-emphasis);
}

.alert-purple-100 {
  --bs-alert-color: var(--bs-purple-100-text-emphasis);
  --bs-alert-bg: var(--bs-purple-100-bg-subtle);
  --bs-alert-border-color: var(--bs-purple-100-border-subtle);
  --bs-alert-link-color: var(--bs-purple-100-text-emphasis);
}

.alert-info-100 {
  --bs-alert-color: var(--bs-info-100-text-emphasis);
  --bs-alert-bg: var(--bs-info-100-bg-subtle);
  --bs-alert-border-color: var(--bs-info-100-border-subtle);
  --bs-alert-link-color: var(--bs-info-100-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: var(--bs-progress-height);
  }
}

.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.66rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #d08f2c;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked>.progress {
  overflow: visible;
}

.progress-stacked>.progress>.progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #d08f2c;
  --bs-list-group-active-border-color: #d08f2c;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}

.list-group-numbered>.list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}

.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}

.list-group-item.disabled,
.list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}

.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}

.list-group-item+.list-group-item {
  border-top-width: 0;
}

.list-group-item+.list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}

.list-group-item-action:not(.active):hover,
.list-group-item-action:not(.active):focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}

.list-group-item-action:not(.active):active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-horizontal {
  flex-direction: row;
}

.list-group-horizontal>.list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}

.list-group-horizontal>.list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}

.list-group-horizontal>.list-group-item.active {
  margin-top: 0;
}

.list-group-horizontal>.list-group-item+.list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}

.list-group-horizontal>.list-group-item+.list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }

  .list-group-horizontal-sm>.list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }

  .list-group-horizontal-sm>.list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-sm>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-sm>.list-group-item+.list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }

  .list-group-horizontal-sm>.list-group-item+.list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }

  .list-group-horizontal-md>.list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }

  .list-group-horizontal-md>.list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-md>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-md>.list-group-item+.list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }

  .list-group-horizontal-md>.list-group-item+.list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }

  .list-group-horizontal-lg>.list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }

  .list-group-horizontal-lg>.list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-lg>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-lg>.list-group-item+.list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }

  .list-group-horizontal-lg>.list-group-item+.list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }

  .list-group-horizontal-xl>.list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }

  .list-group-horizontal-xl>.list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-xl>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-xl>.list-group-item+.list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }

  .list-group-horizontal-xl>.list-group-item+.list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}

@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }

  .list-group-horizontal-xxl>.list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }

  .list-group-horizontal-xxl>.list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }

  .list-group-horizontal-xxl>.list-group-item.active {
    margin-top: 0;
  }

  .list-group-horizontal-xxl>.list-group-item+.list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }

  .list-group-horizontal-xxl>.list-group-item+.list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}

.list-group-flush {
  border-radius: 0;
}

.list-group-flush>.list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}

.list-group-flush>.list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.list-group-item-primary-div {
  --bs-list-group-color: var(--bs-primary-div-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-div-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-div-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-div-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-div-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-div-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-div-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-div-text-emphasis);
}

.list-group-item-primary-div-50 {
  --bs-list-group-color: var(--bs-primary-div-50-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-div-50-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-div-50-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-div-50-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-div-50-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-div-50-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-div-50-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-div-50-text-emphasis);
}

.list-group-item-primary-div-60 {
  --bs-list-group-color: var(--bs-primary-div-60-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-div-60-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-div-60-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-div-60-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-div-60-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-div-60-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-div-60-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-div-60-text-emphasis);
}

.list-group-item-primary-50 {
  --bs-list-group-color: var(--bs-primary-50-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-50-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-50-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-50-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-50-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-50-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-50-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-50-text-emphasis);
}

.list-group-item-primary-60 {
  --bs-list-group-color: var(--bs-primary-60-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-60-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-60-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-60-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-60-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-60-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-60-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-60-text-emphasis);
}

.list-group-item-primary-70 {
  --bs-list-group-color: var(--bs-primary-70-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-70-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-70-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-70-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-70-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-70-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-70-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-70-text-emphasis);
}

.list-group-item-success-50 {
  --bs-list-group-color: var(--bs-success-50-text-emphasis);
  --bs-list-group-bg: var(--bs-success-50-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-50-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-50-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-50-border-subtle);
  --bs-list-group-active-color: var(--bs-success-50-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-50-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-50-text-emphasis);
}

.list-group-item-success-60 {
  --bs-list-group-color: var(--bs-success-60-text-emphasis);
  --bs-list-group-bg: var(--bs-success-60-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-60-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-60-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-60-border-subtle);
  --bs-list-group-active-color: var(--bs-success-60-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-60-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-60-text-emphasis);
}

.list-group-item-success-70 {
  --bs-list-group-color: var(--bs-success-70-text-emphasis);
  --bs-list-group-bg: var(--bs-success-70-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-70-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-70-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-70-border-subtle);
  --bs-list-group-active-color: var(--bs-success-70-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-70-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-70-text-emphasis);
}

.list-group-item-success-80 {
  --bs-list-group-color: var(--bs-success-80-text-emphasis);
  --bs-list-group-bg: var(--bs-success-80-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-80-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-80-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-80-border-subtle);
  --bs-list-group-active-color: var(--bs-success-80-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-80-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-80-text-emphasis);
}

.list-group-item-success-90 {
  --bs-list-group-color: var(--bs-success-90-text-emphasis);
  --bs-list-group-bg: var(--bs-success-90-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-90-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-90-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-90-border-subtle);
  --bs-list-group-active-color: var(--bs-success-90-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-90-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-90-text-emphasis);
}

.list-group-item-success-100 {
  --bs-list-group-color: var(--bs-success-100-text-emphasis);
  --bs-list-group-bg: var(--bs-success-100-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-100-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-100-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-100-border-subtle);
  --bs-list-group-active-color: var(--bs-success-100-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-100-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-100-text-emphasis);
}

.list-group-item-body-bg {
  --bs-list-group-color: var(--bs-body-bg-text-emphasis);
  --bs-list-group-bg: var(--bs-body-bg-bg-subtle);
  --bs-list-group-border-color: var(--bs-body-bg-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-body-bg-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-body-bg-border-subtle);
  --bs-list-group-active-color: var(--bs-body-bg-bg-subtle);
  --bs-list-group-active-bg: var(--bs-body-bg-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-body-bg-text-emphasis);
}

.list-group-item-danger-div {
  --bs-list-group-color: var(--bs-danger-div-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-div-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-div-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-div-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-div-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-div-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-div-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-div-text-emphasis);
}

.list-group-item-danger-40 {
  --bs-list-group-color: var(--bs-danger-40-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-40-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-40-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-40-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-40-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-40-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-40-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-40-text-emphasis);
}

.list-group-item-danger-50 {
  --bs-list-group-color: var(--bs-danger-50-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-50-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-50-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-50-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-50-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-50-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-50-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-50-text-emphasis);
}

.list-group-item-danger-60 {
  --bs-list-group-color: var(--bs-danger-60-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-60-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-60-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-60-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-60-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-60-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-60-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-60-text-emphasis);
}

.list-group-item-danger-70 {
  --bs-list-group-color: var(--bs-danger-70-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-70-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-70-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-70-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-70-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-70-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-70-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-70-text-emphasis);
}

.list-group-item-danger-80 {
  --bs-list-group-color: var(--bs-danger-80-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-80-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-80-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-80-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-80-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-80-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-80-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-80-text-emphasis);
}

.list-group-item-danger-90 {
  --bs-list-group-color: var(--bs-danger-90-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-90-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-90-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-90-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-90-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-90-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-90-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-90-text-emphasis);
}

.list-group-item-danger-100 {
  --bs-list-group-color: var(--bs-danger-100-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-100-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-100-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-100-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-100-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-100-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-100-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-100-text-emphasis);
}

.list-group-item-rating-color {
  --bs-list-group-color: var(--bs-rating-color-text-emphasis);
  --bs-list-group-bg: var(--bs-rating-color-bg-subtle);
  --bs-list-group-border-color: var(--bs-rating-color-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-rating-color-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-rating-color-border-subtle);
  --bs-list-group-active-color: var(--bs-rating-color-bg-subtle);
  --bs-list-group-active-bg: var(--bs-rating-color-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-rating-color-text-emphasis);
}

.list-group-item-card-bg-c {
  --bs-list-group-color: var(--bs-card-bg-c-text-emphasis);
  --bs-list-group-bg: var(--bs-card-bg-c-bg-subtle);
  --bs-list-group-border-color: var(--bs-card-bg-c-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-card-bg-c-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-card-bg-c-border-subtle);
  --bs-list-group-active-color: var(--bs-card-bg-c-bg-subtle);
  --bs-list-group-active-bg: var(--bs-card-bg-c-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-card-bg-c-text-emphasis);
}

.list-group-item-card-text-c {
  --bs-list-group-color: var(--bs-card-text-c-text-emphasis);
  --bs-list-group-bg: var(--bs-card-text-c-bg-subtle);
  --bs-list-group-border-color: var(--bs-card-text-c-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-card-text-c-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-card-text-c-border-subtle);
  --bs-list-group-active-color: var(--bs-card-text-c-bg-subtle);
  --bs-list-group-active-bg: var(--bs-card-text-c-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-card-text-c-text-emphasis);
}

.list-group-item-gary-light {
  --bs-list-group-color: var(--bs-gary-light-text-emphasis);
  --bs-list-group-bg: var(--bs-gary-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-gary-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gary-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gary-light-border-subtle);
  --bs-list-group-active-color: var(--bs-gary-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gary-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gary-light-text-emphasis);
}

.list-group-item-border-color {
  --bs-list-group-color: var(--bs-border-color-text-emphasis);
  --bs-list-group-bg: var(--bs-border-color-bg-subtle);
  --bs-list-group-border-color: var(--bs-border-color-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-border-color-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-border-color-border-subtle);
  --bs-list-group-active-color: var(--bs-border-color-bg-subtle);
  --bs-list-group-active-bg: var(--bs-border-color-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-border-color-text-emphasis);
}

.list-group-item-border-color-50 {
  --bs-list-group-color: var(--bs-border-color-50-text-emphasis);
  --bs-list-group-bg: var(--bs-border-color-50-bg-subtle);
  --bs-list-group-border-color: var(--bs-border-color-50-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-border-color-50-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-border-color-50-border-subtle);
  --bs-list-group-active-color: var(--bs-border-color-50-bg-subtle);
  --bs-list-group-active-bg: var(--bs-border-color-50-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-border-color-50-text-emphasis);
}

.list-group-item-gray-100 {
  --bs-list-group-color: var(--bs-gray-100-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-100-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-100-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-100-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-100-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-100-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-100-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-100-text-emphasis);
}

.list-group-item-body-color-50 {
  --bs-list-group-color: var(--bs-body-color-50-text-emphasis);
  --bs-list-group-bg: var(--bs-body-color-50-bg-subtle);
  --bs-list-group-border-color: var(--bs-body-color-50-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-body-color-50-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-body-color-50-border-subtle);
  --bs-list-group-active-color: var(--bs-body-color-50-bg-subtle);
  --bs-list-group-active-bg: var(--bs-body-color-50-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-body-color-50-text-emphasis);
}

.list-group-item-body-color-60 {
  --bs-list-group-color: var(--bs-body-color-60-text-emphasis);
  --bs-list-group-bg: var(--bs-body-color-60-bg-subtle);
  --bs-list-group-border-color: var(--bs-body-color-60-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-body-color-60-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-body-color-60-border-subtle);
  --bs-list-group-active-color: var(--bs-body-color-60-bg-subtle);
  --bs-list-group-active-bg: var(--bs-body-color-60-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-body-color-60-text-emphasis);
}

.list-group-item-purple-100 {
  --bs-list-group-color: var(--bs-purple-100-text-emphasis);
  --bs-list-group-bg: var(--bs-purple-100-bg-subtle);
  --bs-list-group-border-color: var(--bs-purple-100-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-purple-100-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-purple-100-border-subtle);
  --bs-list-group-active-color: var(--bs-purple-100-bg-subtle);
  --bs-list-group-active-bg: var(--bs-purple-100-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-purple-100-text-emphasis);
}

.list-group-item-info-100 {
  --bs-list-group-color: var(--bs-info-100-text-emphasis);
  --bs-list-group-bg: var(--bs-info-100-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-100-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-100-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-100-border-subtle);
  --bs-list-group-active-color: var(--bs-info-100-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-100-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-100-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(208, 143, 44, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  filter: var(--bs-btn-close-filter);
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}

.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}

.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}

.btn-close:disabled,
.btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

:root,
[data-bs-theme=light] {
  --bs-btn-close-filter: ;
}

[data-bs-theme=dark] {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}

.toast.showing {
  opacity: 0;
}

.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}

.toast-container> :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}

.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: var(--bs-body-color);
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}

.modal.fade .modal-dialog {
  transform: translate(0, -50px);
  transition: transform 0.3s ease-out;
}

@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}

.modal.show .modal-dialog {
  transform: none;
}

.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}

.modal-backdrop.fade {
  opacity: 0;
}

.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}

.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-right: calc(-0.5 * var(--bs-modal-header-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-left: auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}

.modal-footer>* {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }

  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }

  .modal-sm {
    --bs-modal-width: 300px;
  }
}

@media (min-width: 992px) {

  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}

@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}

.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}

.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}

.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}

.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }

  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }

  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }

  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }

  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }

  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }

  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }

  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}

.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.77rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}

.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}

.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}

.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}

.bs-tooltip-top .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}

.bs-tooltip-end .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}

.bs-tooltip-bottom .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}

.bs-tooltip-start .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.77rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 0.88rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}

.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}

.popover .popover-arrow::before,
.popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top>.popover-arrow,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}

.bs-popover-top>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before,
.bs-popover-top>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}

.bs-popover-top>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}

.bs-popover-top>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end>.popover-arrow,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}

.bs-popover-end>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before,
.bs-popover-end>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}

.bs-popover-end>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}

.bs-popover-end>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom>.popover-arrow,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}

.bs-popover-bottom>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before,
.bs-popover-bottom>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}

.bs-popover-bottom>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}

.bs-popover-bottom>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}

.bs-popover-bottom .popover-header::before,
.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start>.popover-arrow,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}

.bs-popover-start>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before,
.bs-popover-start>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}

.bs-popover-start>.popover-arrow::before,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}

.bs-popover-start>.popover-arrow::after,
.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}

.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}

.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}

@media (prefers-reduced-motion: reduce) {

  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  filter: var(--bs-carousel-control-icon-filter);
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {

  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}

.carousel-control-prev:hover,
.carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___})
    /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e")*/
  ;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___})
    /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e")*/
  ;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}

.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: var(--bs-carousel-indicator-active-bg);
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}

.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--bs-carousel-caption-color);
  text-align: center;
}

.carousel-dark {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

:root,
[data-bs-theme=light] {
  --bs-carousel-indicator-active-bg: #fff;
  --bs-carousel-caption-color: #fff;
  --bs-carousel-control-icon-filter: ;
}

[data-bs-theme=dark] {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg)
      /* rtl:ignore */
    ;
  }
}

.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }

  50% {
    opacity: 1;
    transform: none;
  }
}

.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {

  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}

.offcanvas,
.offcanvas-xxl,
.offcanvas-xl,
.offcanvas-lg,
.offcanvas-md,
.offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}

@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}

@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }

  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }

  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }

  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }

  .offcanvas-sm.showing,
  .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }

  .offcanvas-sm.showing,
  .offcanvas-sm.hiding,
  .offcanvas-sm.show {
    visibility: visible;
  }
}

@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }

  .offcanvas-sm .offcanvas-header {
    display: none;
  }

  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}

@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }

  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }

  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }

  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }

  .offcanvas-md.showing,
  .offcanvas-md.show:not(.hiding) {
    transform: none;
  }

  .offcanvas-md.showing,
  .offcanvas-md.hiding,
  .offcanvas-md.show {
    visibility: visible;
  }
}

@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }

  .offcanvas-md .offcanvas-header {
    display: none;
  }

  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}

@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }

  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }

  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }

  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }

  .offcanvas-lg.showing,
  .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }

  .offcanvas-lg.showing,
  .offcanvas-lg.hiding,
  .offcanvas-lg.show {
    visibility: visible;
  }
}

@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }

  .offcanvas-lg .offcanvas-header {
    display: none;
  }

  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}

@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }

  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }

  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }

  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }

  .offcanvas-xl.showing,
  .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }

  .offcanvas-xl.showing,
  .offcanvas-xl.hiding,
  .offcanvas-xl.show {
    visibility: visible;
  }
}

@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }

  .offcanvas-xl .offcanvas-header {
    display: none;
  }

  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}

@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }

  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }

  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }

  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }

  .offcanvas-xxl.showing,
  .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }

  .offcanvas-xxl.showing,
  .offcanvas-xxl.hiding,
  .offcanvas-xxl.show {
    visibility: visible;
  }
}

@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }

  .offcanvas-xxl .offcanvas-header {
    display: none;
  }

  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}

@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}

.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}

.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}

.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}

.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}

.offcanvas.showing,
.offcanvas.show:not(.hiding) {
  transform: none;
}

.offcanvas.showing,
.offcanvas.hiding,
.offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}

.offcanvas-backdrop.fade {
  opacity: 0;
}

.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}

.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-left: auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}

.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}

.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #000 !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #000 !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #000 !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary-div {
  color: #000 !important;
  background-color: RGBA(var(--bs-primary-div-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary-div-50 {
  color: #000 !important;
  background-color: RGBA(var(--bs-primary-div-50-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary-div-60 {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-div-60-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary-50 {
  color: #000 !important;
  background-color: RGBA(var(--bs-primary-50-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary-60 {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-60-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary-70 {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-70-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success-50 {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-50-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success-60 {
  color: #000 !important;
  background-color: RGBA(var(--bs-success-60-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success-70 {
  color: #000 !important;
  background-color: RGBA(var(--bs-success-70-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success-80 {
  color: #000 !important;
  background-color: RGBA(var(--bs-success-80-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success-90 {
  color: #000 !important;
  background-color: RGBA(var(--bs-success-90-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success-100 {
  color: #000 !important;
  background-color: RGBA(var(--bs-success-100-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-body-bg {
  color: #000 !important;
  background-color: RGBA(var(--bs-body-bg-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger-div {
  color: #000 !important;
  background-color: RGBA(var(--bs-danger-div-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger-40 {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-40-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger-50 {
  color: #000 !important;
  background-color: RGBA(var(--bs-danger-50-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger-60 {
  color: #000 !important;
  background-color: RGBA(var(--bs-danger-60-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger-70 {
  color: #000 !important;
  background-color: RGBA(var(--bs-danger-70-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger-80 {
  color: #000 !important;
  background-color: RGBA(var(--bs-danger-80-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger-90 {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-90-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger-100 {
  color: #000 !important;
  background-color: RGBA(var(--bs-danger-100-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-rating-color {
  color: #000 !important;
  background-color: RGBA(var(--bs-rating-color-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-card-bg-c {
  color: #000 !important;
  background-color: RGBA(var(--bs-card-bg-c-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-card-text-c {
  color: #000 !important;
  background-color: RGBA(var(--bs-card-text-c-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gary-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-gary-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-border-color {
  color: #000 !important;
  background-color: RGBA(var(--bs-border-color-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-border-color-50 {
  color: #000 !important;
  background-color: RGBA(var(--bs-border-color-50-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-100 {
  color: #000 !important;
  background-color: RGBA(var(--bs-gray-100-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-body-color-50 {
  color: #fff !important;
  background-color: RGBA(var(--bs-body-color-50-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-body-color-60 {
  color: #000 !important;
  background-color: RGBA(var(--bs-body-color-60-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-purple-100 {
  color: #000 !important;
  background-color: RGBA(var(--bs-purple-100-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info-100 {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-100-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary:hover,
.link-primary:focus {
  color: RGBA(217, 165, 86, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(217, 165, 86, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary:hover,
.link-secondary:focus {
  color: RGBA(46, 53, 66, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(46, 53, 66, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-success:hover,
.link-success:focus {
  color: RGBA(95, 224, 59, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(95, 224, 59, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-info:hover,
.link-info:focus {
  color: RGBA(87, 197, 247, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(87, 197, 247, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning:hover,
.link-warning:focus {
  color: RGBA(255, 201, 85, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 201, 85, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger:hover,
.link-danger:focus {
  color: RGBA(253, 121, 65, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(253, 121, 65, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-light:hover,
.link-light:focus {
  color: RGBA(221, 225, 232, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(221, 225, 232, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark:hover,
.link-dark:focus {
  color: RGBA(0, 0, 0, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(0, 0, 0, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-div {
  color: RGBA(var(--bs-primary-div-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-div-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-div:hover,
.link-primary-div:focus {
  color: RGBA(217, 165, 86, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(217, 165, 86, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-div-50 {
  color: RGBA(var(--bs-primary-div-50-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-div-50-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-div-50:hover,
.link-primary-div-50:focus {
  color: RGBA(193, 150, 81, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(193, 150, 81, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-div-60 {
  color: RGBA(var(--bs-primary-div-60-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-div-60-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-div-60:hover,
.link-primary-div-60:focus {
  color: RGBA(118, 84, 26, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(118, 84, 26, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-50 {
  color: RGBA(var(--bs-primary-50-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-50-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-50:hover,
.link-primary-50:focus {
  color: RGBA(193, 150, 81, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(193, 150, 81, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-60 {
  color: RGBA(var(--bs-primary-60-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-60-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-60:hover,
.link-primary-60:focus {
  color: RGBA(118, 84, 26, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(118, 84, 26, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-70 {
  color: RGBA(var(--bs-primary-70-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-70-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-70:hover,
.link-primary-70:focus {
  color: RGBA(94, 69, 21, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(94, 69, 21, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success-50 {
  color: RGBA(var(--bs-success-50-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-50-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-success-50:hover,
.link-success-50:focus {
  color: RGBA(24, 105, 6, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(24, 105, 6, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success-60 {
  color: RGBA(var(--bs-success-60-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-60-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-success-60:hover,
.link-success-60:focus {
  color: RGBA(81, 192, 53, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(81, 192, 53, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success-70 {
  color: RGBA(var(--bs-success-70-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-70-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-success-70:hover,
.link-success-70:focus {
  color: RGBA(155, 253, 123, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(155, 253, 123, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success-80 {
  color: RGBA(var(--bs-success-80-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-80-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-success-80:hover,
.link-success-80:focus {
  color: RGBA(224, 255, 211, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(224, 255, 211, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success-90 {
  color: RGBA(var(--bs-success-90-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-90-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-success-90:hover,
.link-success-90:focus {
  color: RGBA(241, 255, 234, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(241, 255, 234, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success-100 {
  color: RGBA(var(--bs-success-100-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-100-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-success-100:hover,
.link-success-100:focus {
  color: RGBA(224, 255, 211, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(224, 255, 211, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-bg {
  color: RGBA(var(--bs-body-bg-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-body-bg-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-bg:hover,
.link-body-bg:focus {
  color: RGBA(248, 249, 250, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(248, 249, 250, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger-div {
  color: RGBA(var(--bs-danger-div-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-div-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger-div:hover,
.link-danger-div:focus {
  color: RGBA(255, 241, 177, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 241, 177, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger-40 {
  color: RGBA(var(--bs-danger-40-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-40-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger-40:hover,
.link-danger-40:focus {
  color: RGBA(172, 22, 0, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(172, 22, 0, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger-50 {
  color: RGBA(var(--bs-danger-50-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-50-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger-50:hover,
.link-danger-50:focus {
  color: RGBA(241, 101, 57, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(241, 101, 57, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger-60 {
  color: RGBA(var(--bs-danger-60-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-60-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger-60:hover,
.link-danger-60:focus {
  color: RGBA(240, 76, 51, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(240, 76, 51, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger-70 {
  color: RGBA(var(--bs-danger-70-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-70-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger-70:hover,
.link-danger-70:focus {
  color: RGBA(255, 231, 228, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 231, 228, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger-80 {
  color: RGBA(var(--bs-danger-80-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-80-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger-80:hover,
.link-danger-80:focus {
  color: RGBA(255, 102, 79, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 102, 79, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger-90 {
  color: RGBA(var(--bs-danger-90-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-90-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger-90:hover,
.link-danger-90:focus {
  color: RGBA(158, 34, 7, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(158, 34, 7, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger-100 {
  color: RGBA(var(--bs-danger-100-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-100-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger-100:hover,
.link-danger-100:focus {
  color: RGBA(255, 231, 228, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 231, 228, var(--bs-link-underline-opacity, 1)) !important;
}

.link-rating-color {
  color: RGBA(var(--bs-rating-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-rating-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-rating-color:hover,
.link-rating-color:focus {
  color: RGBA(254, 149, 94, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(254, 149, 94, var(--bs-link-underline-opacity, 1)) !important;
}

.link-card-bg-c {
  color: RGBA(var(--bs-card-bg-c-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-card-bg-c-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-card-bg-c:hover,
.link-card-bg-c:focus {
  color: RGBA(93, 157, 253, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(93, 157, 253, var(--bs-link-underline-opacity, 1)) !important;
}

.link-card-text-c {
  color: RGBA(var(--bs-card-text-c-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-card-text-c-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-card-text-c:hover,
.link-card-text-c:focus {
  color: RGBA(255, 237, 221, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 237, 221, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gary-light {
  color: RGBA(var(--bs-gary-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gary-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-gary-light:hover,
.link-gary-light:focus {
  color: RGBA(246, 248, 253, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(246, 248, 253, var(--bs-link-underline-opacity, 1)) !important;
}

.link-border-color {
  color: RGBA(var(--bs-border-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-border-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-border-color:hover,
.link-border-color:focus {
  color: RGBA(240, 241, 245, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(240, 241, 245, var(--bs-link-underline-opacity, 1)) !important;
}

.link-border-color-50 {
  color: RGBA(var(--bs-border-color-50-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-border-color-50-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-border-color-50:hover,
.link-border-color-50:focus {
  color: RGBA(240, 243, 255, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(240, 243, 255, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-100 {
  color: RGBA(var(--bs-gray-100-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-100-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-100:hover,
.link-gray-100:focus {
  color: RGBA(247, 249, 249, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(247, 249, 249, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-color-50 {
  color: RGBA(var(--bs-body-color-50-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-body-color-50-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-color-50:hover,
.link-body-color-50:focus {
  color: RGBA(66, 77, 95, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(66, 77, 95, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-color-60 {
  color: RGBA(var(--bs-body-color-60-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-body-color-60-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-color-60:hover,
.link-body-color-60:focus {
  color: RGBA(158, 170, 187, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(158, 170, 187, var(--bs-link-underline-opacity, 1)) !important;
}

.link-purple-100 {
  color: RGBA(var(--bs-purple-100-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-purple-100-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-purple-100:hover,
.link-purple-100:focus {
  color: RGBA(245, 237, 255, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(245, 237, 255, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info-100 {
  color: RGBA(var(--bs-info-100-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-100-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-info-100:hover,
.link-info-100:focus {
  color: RGBA(225, 239, 255, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(225, 239, 255, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis:hover,
.link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}

.icon-link>.bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}

@media (prefers-reduced-motion: reduce) {
  .icon-link>.bi {
    transition: none;
  }
}

.icon-link-hover:hover>.bi,
.icon-link-hover:focus-visible>.bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}

.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}

.ratio>* {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}

@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}

@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}

@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}

@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}

.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.visually-hidden *,
.visually-hidden-focusable:not(:focus):not(:focus-within) * {
  overflow: hidden !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary-div {
  --bs-focus-ring-color: rgba(var(--bs-primary-div-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary-div-50 {
  --bs-focus-ring-color: rgba(var(--bs-primary-div-50-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary-div-60 {
  --bs-focus-ring-color: rgba(var(--bs-primary-div-60-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary-50 {
  --bs-focus-ring-color: rgba(var(--bs-primary-50-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary-60 {
  --bs-focus-ring-color: rgba(var(--bs-primary-60-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary-70 {
  --bs-focus-ring-color: rgba(var(--bs-primary-70-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success-50 {
  --bs-focus-ring-color: rgba(var(--bs-success-50-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success-60 {
  --bs-focus-ring-color: rgba(var(--bs-success-60-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success-70 {
  --bs-focus-ring-color: rgba(var(--bs-success-70-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success-80 {
  --bs-focus-ring-color: rgba(var(--bs-success-80-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success-90 {
  --bs-focus-ring-color: rgba(var(--bs-success-90-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success-100 {
  --bs-focus-ring-color: rgba(var(--bs-success-100-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-body-bg {
  --bs-focus-ring-color: rgba(var(--bs-body-bg-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger-div {
  --bs-focus-ring-color: rgba(var(--bs-danger-div-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger-40 {
  --bs-focus-ring-color: rgba(var(--bs-danger-40-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger-50 {
  --bs-focus-ring-color: rgba(var(--bs-danger-50-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger-60 {
  --bs-focus-ring-color: rgba(var(--bs-danger-60-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger-70 {
  --bs-focus-ring-color: rgba(var(--bs-danger-70-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger-80 {
  --bs-focus-ring-color: rgba(var(--bs-danger-80-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger-90 {
  --bs-focus-ring-color: rgba(var(--bs-danger-90-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger-100 {
  --bs-focus-ring-color: rgba(var(--bs-danger-100-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-rating-color {
  --bs-focus-ring-color: rgba(var(--bs-rating-color-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-card-bg-c {
  --bs-focus-ring-color: rgba(var(--bs-card-bg-c-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-card-text-c {
  --bs-focus-ring-color: rgba(var(--bs-card-text-c-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gary-light {
  --bs-focus-ring-color: rgba(var(--bs-gary-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-border-color {
  --bs-focus-ring-color: rgba(var(--bs-border-color-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-border-color-50 {
  --bs-focus-ring-color: rgba(var(--bs-border-color-50-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-100 {
  --bs-focus-ring-color: rgba(var(--bs-gray-100-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-body-color-50 {
  --bs-focus-ring-color: rgba(var(--bs-body-color-50-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-body-color-60 {
  --bs-focus-ring-color: rgba(var(--bs-body-color-60-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-purple-100 {
  --bs-focus-ring-color: rgba(var(--bs-purple-100-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info-100 {
  --bs-focus-ring-color: rgba(var(--bs-info-100-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-div {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-div-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-div-50 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-div-50-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-div-60 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-div-60-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-50 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-50-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-60 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-60-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-70 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-70-rgb), var(--bs-border-opacity)) !important;
}

.border-success-50 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-50-rgb), var(--bs-border-opacity)) !important;
}

.border-success-60 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-60-rgb), var(--bs-border-opacity)) !important;
}

.border-success-70 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-70-rgb), var(--bs-border-opacity)) !important;
}

.border-success-80 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-80-rgb), var(--bs-border-opacity)) !important;
}

.border-success-90 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-90-rgb), var(--bs-border-opacity)) !important;
}

.border-success-100 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-100-rgb), var(--bs-border-opacity)) !important;
}

.border-body-bg {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-body-bg-rgb), var(--bs-border-opacity)) !important;
}

.border-danger-div {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-div-rgb), var(--bs-border-opacity)) !important;
}

.border-danger-40 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-40-rgb), var(--bs-border-opacity)) !important;
}

.border-danger-50 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-50-rgb), var(--bs-border-opacity)) !important;
}

.border-danger-60 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-60-rgb), var(--bs-border-opacity)) !important;
}

.border-danger-70 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-70-rgb), var(--bs-border-opacity)) !important;
}

.border-danger-80 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-80-rgb), var(--bs-border-opacity)) !important;
}

.border-danger-90 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-90-rgb), var(--bs-border-opacity)) !important;
}

.border-danger-100 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-100-rgb), var(--bs-border-opacity)) !important;
}

.border-rating-color {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-rating-color-rgb), var(--bs-border-opacity)) !important;
}

.border-card-bg-c {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-card-bg-c-rgb), var(--bs-border-opacity)) !important;
}

.border-card-text-c {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-card-text-c-rgb), var(--bs-border-opacity)) !important;
}

.border-gary-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gary-light-rgb), var(--bs-border-opacity)) !important;
}

.border-border-color {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-border-color-rgb), var(--bs-border-opacity)) !important;
}

.border-border-color-50 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-border-color-50-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-100 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-100-rgb), var(--bs-border-opacity)) !important;
}

.border-body-color-50 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-body-color-50-rgb), var(--bs-border-opacity)) !important;
}

.border-body-color-60 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-body-color-60-rgb), var(--bs-border-opacity)) !important;
}

.border-purple-100 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-purple-100-rgb), var(--bs-border-opacity)) !important;
}

.border-info-100 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-100-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.345rem + 1.14vw) !important;
}

.fs-2 {
  font-size: calc(1.3274rem + 0.9288vw) !important;
}

.fs-3 {
  font-size: calc(1.2834rem + 0.4008vw) !important;
}

.fs-4 {
  font-size: 1.232rem !important;
}

.fs-5 {
  font-size: 0.88rem !important;
}

.fs-6 {
  font-size: 0.88rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-primary-div {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-div-rgb), var(--bs-text-opacity)) !important;
}

.text-primary-div-50 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-div-50-rgb), var(--bs-text-opacity)) !important;
}

.text-primary-div-60 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-div-60-rgb), var(--bs-text-opacity)) !important;
}

.text-primary-50 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-50-rgb), var(--bs-text-opacity)) !important;
}

.text-primary-60 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-60-rgb), var(--bs-text-opacity)) !important;
}

.text-primary-70 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-70-rgb), var(--bs-text-opacity)) !important;
}

.text-success-50 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-50-rgb), var(--bs-text-opacity)) !important;
}

.text-success-60 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-60-rgb), var(--bs-text-opacity)) !important;
}

.text-success-70 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-70-rgb), var(--bs-text-opacity)) !important;
}

.text-success-80 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-80-rgb), var(--bs-text-opacity)) !important;
}

.text-success-90 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-90-rgb), var(--bs-text-opacity)) !important;
}

.text-success-100 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-100-rgb), var(--bs-text-opacity)) !important;
}

.text-body-bg {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-bg-rgb), var(--bs-text-opacity)) !important;
}

.text-danger-div {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-div-rgb), var(--bs-text-opacity)) !important;
}

.text-danger-40 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-40-rgb), var(--bs-text-opacity)) !important;
}

.text-danger-50 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-50-rgb), var(--bs-text-opacity)) !important;
}

.text-danger-60 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-60-rgb), var(--bs-text-opacity)) !important;
}

.text-danger-70 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-70-rgb), var(--bs-text-opacity)) !important;
}

.text-danger-80 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-80-rgb), var(--bs-text-opacity)) !important;
}

.text-danger-90 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-90-rgb), var(--bs-text-opacity)) !important;
}

.text-danger-100 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-100-rgb), var(--bs-text-opacity)) !important;
}

.text-rating-color {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-rating-color-rgb), var(--bs-text-opacity)) !important;
}

.text-card-bg-c {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-card-bg-c-rgb), var(--bs-text-opacity)) !important;
}

.text-card-text-c {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-card-text-c-rgb), var(--bs-text-opacity)) !important;
}

.text-gary-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gary-light-rgb), var(--bs-text-opacity)) !important;
}

.text-border-color {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-border-color-rgb), var(--bs-text-opacity)) !important;
}

.text-border-color-50 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-border-color-50-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-100 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-100-rgb), var(--bs-text-opacity)) !important;
}

.text-body-color-50 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-50-rgb), var(--bs-text-opacity)) !important;
}

.text-body-color-60 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-60-rgb), var(--bs-text-opacity)) !important;
}

.text-purple-100 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-purple-100-rgb), var(--bs-text-opacity)) !important;
}

.text-info-100 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-100-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary-div {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-div-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary-div-50 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-div-50-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary-div-60 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-div-60-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary-50 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-50-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary-60 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-60-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary-70 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-70-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success-50 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-50-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success-60 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-60-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success-70 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-70-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success-80 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-80-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success-90 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-90-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success-100 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-100-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-body-bg {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-body-bg-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger-div {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-div-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger-40 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-40-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger-50 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-50-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger-60 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-60-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger-70 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-70-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger-80 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-80-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger-90 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-90-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger-100 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-100-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-rating-color {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-rating-color-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-card-bg-c {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-card-bg-c-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-card-text-c {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-card-text-c-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gary-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gary-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-border-color {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-border-color-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-border-color-50 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-border-color-50-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-100 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-100-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-body-color-50 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-body-color-50-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-body-color-60 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-body-color-60-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-purple-100 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-purple-100-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info-100 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-100-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary-div {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-div-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary-div-50 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-div-50-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary-div-60 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-div-60-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary-50 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-50-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary-60 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-60-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary-70 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-70-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success-50 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-50-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success-60 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-60-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success-70 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-70-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success-80 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-80-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success-90 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-90-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-100-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-bg {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger-div {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-div-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger-40 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-40-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger-50 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-50-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger-60 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-60-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger-70 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-70-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger-80 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-80-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger-90 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-90-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-100-rgb), var(--bs-bg-opacity)) !important;
}

.bg-rating-color {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-rating-color-rgb), var(--bs-bg-opacity)) !important;
}

.bg-card-bg-c {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-card-bg-c-rgb), var(--bs-bg-opacity)) !important;
}

.bg-card-text-c {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-card-text-c-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gary-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gary-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-border-color {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-border-color-rgb), var(--bs-bg-opacity)) !important;
}

.bg-border-color-50 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-border-color-50-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-100-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-color-50 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-color-50-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-color-60 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-color-60-rgb), var(--bs-bg-opacity)) !important;
}

.bg-purple-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-purple-100-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-100-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }

  .float-sm-end {
    float: right !important;
  }

  .float-sm-none {
    float: none !important;
  }

  .object-fit-sm-contain {
    object-fit: contain !important;
  }

  .object-fit-sm-cover {
    object-fit: cover !important;
  }

  .object-fit-sm-fill {
    object-fit: fill !important;
  }

  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }

  .object-fit-sm-none {
    object-fit: none !important;
  }

  .d-sm-inline {
    display: inline !important;
  }

  .d-sm-inline-block {
    display: inline-block !important;
  }

  .d-sm-block {
    display: block !important;
  }

  .d-sm-grid {
    display: grid !important;
  }

  .d-sm-inline-grid {
    display: inline-grid !important;
  }

  .d-sm-table {
    display: table !important;
  }

  .d-sm-table-row {
    display: table-row !important;
  }

  .d-sm-table-cell {
    display: table-cell !important;
  }

  .d-sm-flex {
    display: flex !important;
  }

  .d-sm-inline-flex {
    display: inline-flex !important;
  }

  .d-sm-none {
    display: none !important;
  }

  .flex-sm-fill {
    flex: 1 1 auto !important;
  }

  .flex-sm-row {
    flex-direction: row !important;
  }

  .flex-sm-column {
    flex-direction: column !important;
  }

  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }

  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-sm-start {
    justify-content: flex-start !important;
  }

  .justify-content-sm-end {
    justify-content: flex-end !important;
  }

  .justify-content-sm-center {
    justify-content: center !important;
  }

  .justify-content-sm-between {
    justify-content: space-between !important;
  }

  .justify-content-sm-around {
    justify-content: space-around !important;
  }

  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-sm-start {
    align-items: flex-start !important;
  }

  .align-items-sm-end {
    align-items: flex-end !important;
  }

  .align-items-sm-center {
    align-items: center !important;
  }

  .align-items-sm-baseline {
    align-items: baseline !important;
  }

  .align-items-sm-stretch {
    align-items: stretch !important;
  }

  .align-content-sm-start {
    align-content: flex-start !important;
  }

  .align-content-sm-end {
    align-content: flex-end !important;
  }

  .align-content-sm-center {
    align-content: center !important;
  }

  .align-content-sm-between {
    align-content: space-between !important;
  }

  .align-content-sm-around {
    align-content: space-around !important;
  }

  .align-content-sm-stretch {
    align-content: stretch !important;
  }

  .align-self-sm-auto {
    align-self: auto !important;
  }

  .align-self-sm-start {
    align-self: flex-start !important;
  }

  .align-self-sm-end {
    align-self: flex-end !important;
  }

  .align-self-sm-center {
    align-self: center !important;
  }

  .align-self-sm-baseline {
    align-self: baseline !important;
  }

  .align-self-sm-stretch {
    align-self: stretch !important;
  }

  .order-sm-first {
    order: -1 !important;
  }

  .order-sm-0 {
    order: 0 !important;
  }

  .order-sm-1 {
    order: 1 !important;
  }

  .order-sm-2 {
    order: 2 !important;
  }

  .order-sm-3 {
    order: 3 !important;
  }

  .order-sm-4 {
    order: 4 !important;
  }

  .order-sm-5 {
    order: 5 !important;
  }

  .order-sm-last {
    order: 6 !important;
  }

  .m-sm-0 {
    margin: 0 !important;
  }

  .m-sm-1 {
    margin: 0.25rem !important;
  }

  .m-sm-2 {
    margin: 0.5rem !important;
  }

  .m-sm-3 {
    margin: 1rem !important;
  }

  .m-sm-4 {
    margin: 1.5rem !important;
  }

  .m-sm-5 {
    margin: 3rem !important;
  }

  .m-sm-auto {
    margin: auto !important;
  }

  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-sm-0 {
    margin-top: 0 !important;
  }

  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }

  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }

  .mt-sm-3 {
    margin-top: 1rem !important;
  }

  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }

  .mt-sm-5 {
    margin-top: 3rem !important;
  }

  .mt-sm-auto {
    margin-top: auto !important;
  }

  .me-sm-0 {
    margin-right: 0 !important;
  }

  .me-sm-1 {
    margin-right: 0.25rem !important;
  }

  .me-sm-2 {
    margin-right: 0.5rem !important;
  }

  .me-sm-3 {
    margin-right: 1rem !important;
  }

  .me-sm-4 {
    margin-right: 1.5rem !important;
  }

  .me-sm-5 {
    margin-right: 3rem !important;
  }

  .me-sm-auto {
    margin-right: auto !important;
  }

  .mb-sm-0 {
    margin-bottom: 0 !important;
  }

  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }

  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }

  .mb-sm-auto {
    margin-bottom: auto !important;
  }

  .ms-sm-0 {
    margin-left: 0 !important;
  }

  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }

  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }

  .ms-sm-3 {
    margin-left: 1rem !important;
  }

  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }

  .ms-sm-5 {
    margin-left: 3rem !important;
  }

  .ms-sm-auto {
    margin-left: auto !important;
  }

  .p-sm-0 {
    padding: 0 !important;
  }

  .p-sm-1 {
    padding: 0.25rem !important;
  }

  .p-sm-2 {
    padding: 0.5rem !important;
  }

  .p-sm-3 {
    padding: 1rem !important;
  }

  .p-sm-4 {
    padding: 1.5rem !important;
  }

  .p-sm-5 {
    padding: 3rem !important;
  }

  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-sm-0 {
    padding-top: 0 !important;
  }

  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }

  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }

  .pt-sm-3 {
    padding-top: 1rem !important;
  }

  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }

  .pt-sm-5 {
    padding-top: 3rem !important;
  }

  .pe-sm-0 {
    padding-right: 0 !important;
  }

  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }

  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }

  .pe-sm-3 {
    padding-right: 1rem !important;
  }

  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }

  .pe-sm-5 {
    padding-right: 3rem !important;
  }

  .pb-sm-0 {
    padding-bottom: 0 !important;
  }

  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }

  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }

  .ps-sm-0 {
    padding-left: 0 !important;
  }

  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }

  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }

  .ps-sm-3 {
    padding-left: 1rem !important;
  }

  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }

  .ps-sm-5 {
    padding-left: 3rem !important;
  }

  .gap-sm-0 {
    gap: 0 !important;
  }

  .gap-sm-1 {
    gap: 0.25rem !important;
  }

  .gap-sm-2 {
    gap: 0.5rem !important;
  }

  .gap-sm-3 {
    gap: 1rem !important;
  }

  .gap-sm-4 {
    gap: 1.5rem !important;
  }

  .gap-sm-5 {
    gap: 3rem !important;
  }

  .row-gap-sm-0 {
    row-gap: 0 !important;
  }

  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }

  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }

  .column-gap-sm-0 {
    column-gap: 0 !important;
  }

  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }

  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }

  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }

  .text-sm-start {
    text-align: left !important;
  }

  .text-sm-end {
    text-align: right !important;
  }

  .text-sm-center {
    text-align: center !important;
  }
}

@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }

  .float-md-end {
    float: right !important;
  }

  .float-md-none {
    float: none !important;
  }

  .object-fit-md-contain {
    object-fit: contain !important;
  }

  .object-fit-md-cover {
    object-fit: cover !important;
  }

  .object-fit-md-fill {
    object-fit: fill !important;
  }

  .object-fit-md-scale {
    object-fit: scale-down !important;
  }

  .object-fit-md-none {
    object-fit: none !important;
  }

  .d-md-inline {
    display: inline !important;
  }

  .d-md-inline-block {
    display: inline-block !important;
  }

  .d-md-block {
    display: block !important;
  }

  .d-md-grid {
    display: grid !important;
  }

  .d-md-inline-grid {
    display: inline-grid !important;
  }

  .d-md-table {
    display: table !important;
  }

  .d-md-table-row {
    display: table-row !important;
  }

  .d-md-table-cell {
    display: table-cell !important;
  }

  .d-md-flex {
    display: flex !important;
  }

  .d-md-inline-flex {
    display: inline-flex !important;
  }

  .d-md-none {
    display: none !important;
  }

  .flex-md-fill {
    flex: 1 1 auto !important;
  }

  .flex-md-row {
    flex-direction: row !important;
  }

  .flex-md-column {
    flex-direction: column !important;
  }

  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-md-wrap {
    flex-wrap: wrap !important;
  }

  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-md-start {
    justify-content: flex-start !important;
  }

  .justify-content-md-end {
    justify-content: flex-end !important;
  }

  .justify-content-md-center {
    justify-content: center !important;
  }

  .justify-content-md-between {
    justify-content: space-between !important;
  }

  .justify-content-md-around {
    justify-content: space-around !important;
  }

  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-md-start {
    align-items: flex-start !important;
  }

  .align-items-md-end {
    align-items: flex-end !important;
  }

  .align-items-md-center {
    align-items: center !important;
  }

  .align-items-md-baseline {
    align-items: baseline !important;
  }

  .align-items-md-stretch {
    align-items: stretch !important;
  }

  .align-content-md-start {
    align-content: flex-start !important;
  }

  .align-content-md-end {
    align-content: flex-end !important;
  }

  .align-content-md-center {
    align-content: center !important;
  }

  .align-content-md-between {
    align-content: space-between !important;
  }

  .align-content-md-around {
    align-content: space-around !important;
  }

  .align-content-md-stretch {
    align-content: stretch !important;
  }

  .align-self-md-auto {
    align-self: auto !important;
  }

  .align-self-md-start {
    align-self: flex-start !important;
  }

  .align-self-md-end {
    align-self: flex-end !important;
  }

  .align-self-md-center {
    align-self: center !important;
  }

  .align-self-md-baseline {
    align-self: baseline !important;
  }

  .align-self-md-stretch {
    align-self: stretch !important;
  }

  .order-md-first {
    order: -1 !important;
  }

  .order-md-0 {
    order: 0 !important;
  }

  .order-md-1 {
    order: 1 !important;
  }

  .order-md-2 {
    order: 2 !important;
  }

  .order-md-3 {
    order: 3 !important;
  }

  .order-md-4 {
    order: 4 !important;
  }

  .order-md-5 {
    order: 5 !important;
  }

  .order-md-last {
    order: 6 !important;
  }

  .m-md-0 {
    margin: 0 !important;
  }

  .m-md-1 {
    margin: 0.25rem !important;
  }

  .m-md-2 {
    margin: 0.5rem !important;
  }

  .m-md-3 {
    margin: 1rem !important;
  }

  .m-md-4 {
    margin: 1.5rem !important;
  }

  .m-md-5 {
    margin: 3rem !important;
  }

  .m-md-auto {
    margin: auto !important;
  }

  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-md-0 {
    margin-top: 0 !important;
  }

  .mt-md-1 {
    margin-top: 0.25rem !important;
  }

  .mt-md-2 {
    margin-top: 0.5rem !important;
  }

  .mt-md-3 {
    margin-top: 1rem !important;
  }

  .mt-md-4 {
    margin-top: 1.5rem !important;
  }

  .mt-md-5 {
    margin-top: 3rem !important;
  }

  .mt-md-auto {
    margin-top: auto !important;
  }

  .me-md-0 {
    margin-right: 0 !important;
  }

  .me-md-1 {
    margin-right: 0.25rem !important;
  }

  .me-md-2 {
    margin-right: 0.5rem !important;
  }

  .me-md-3 {
    margin-right: 1rem !important;
  }

  .me-md-4 {
    margin-right: 1.5rem !important;
  }

  .me-md-5 {
    margin-right: 3rem !important;
  }

  .me-md-auto {
    margin-right: auto !important;
  }

  .mb-md-0 {
    margin-bottom: 0 !important;
  }

  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-md-3 {
    margin-bottom: 1rem !important;
  }

  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-md-5 {
    margin-bottom: 3rem !important;
  }

  .mb-md-auto {
    margin-bottom: auto !important;
  }

  .ms-md-0 {
    margin-left: 0 !important;
  }

  .ms-md-1 {
    margin-left: 0.25rem !important;
  }

  .ms-md-2 {
    margin-left: 0.5rem !important;
  }

  .ms-md-3 {
    margin-left: 1rem !important;
  }

  .ms-md-4 {
    margin-left: 1.5rem !important;
  }

  .ms-md-5 {
    margin-left: 3rem !important;
  }

  .ms-md-auto {
    margin-left: auto !important;
  }

  .p-md-0 {
    padding: 0 !important;
  }

  .p-md-1 {
    padding: 0.25rem !important;
  }

  .p-md-2 {
    padding: 0.5rem !important;
  }

  .p-md-3 {
    padding: 1rem !important;
  }

  .p-md-4 {
    padding: 1.5rem !important;
  }

  .p-md-5 {
    padding: 3rem !important;
  }

  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-md-0 {
    padding-top: 0 !important;
  }

  .pt-md-1 {
    padding-top: 0.25rem !important;
  }

  .pt-md-2 {
    padding-top: 0.5rem !important;
  }

  .pt-md-3 {
    padding-top: 1rem !important;
  }

  .pt-md-4 {
    padding-top: 1.5rem !important;
  }

  .pt-md-5 {
    padding-top: 3rem !important;
  }

  .pe-md-0 {
    padding-right: 0 !important;
  }

  .pe-md-1 {
    padding-right: 0.25rem !important;
  }

  .pe-md-2 {
    padding-right: 0.5rem !important;
  }

  .pe-md-3 {
    padding-right: 1rem !important;
  }

  .pe-md-4 {
    padding-right: 1.5rem !important;
  }

  .pe-md-5 {
    padding-right: 3rem !important;
  }

  .pb-md-0 {
    padding-bottom: 0 !important;
  }

  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-md-3 {
    padding-bottom: 1rem !important;
  }

  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-md-5 {
    padding-bottom: 3rem !important;
  }

  .ps-md-0 {
    padding-left: 0 !important;
  }

  .ps-md-1 {
    padding-left: 0.25rem !important;
  }

  .ps-md-2 {
    padding-left: 0.5rem !important;
  }

  .ps-md-3 {
    padding-left: 1rem !important;
  }

  .ps-md-4 {
    padding-left: 1.5rem !important;
  }

  .ps-md-5 {
    padding-left: 3rem !important;
  }

  .gap-md-0 {
    gap: 0 !important;
  }

  .gap-md-1 {
    gap: 0.25rem !important;
  }

  .gap-md-2 {
    gap: 0.5rem !important;
  }

  .gap-md-3 {
    gap: 1rem !important;
  }

  .gap-md-4 {
    gap: 1.5rem !important;
  }

  .gap-md-5 {
    gap: 3rem !important;
  }

  .row-gap-md-0 {
    row-gap: 0 !important;
  }

  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-md-3 {
    row-gap: 1rem !important;
  }

  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-md-5 {
    row-gap: 3rem !important;
  }

  .column-gap-md-0 {
    column-gap: 0 !important;
  }

  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-md-3 {
    column-gap: 1rem !important;
  }

  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }

  .column-gap-md-5 {
    column-gap: 3rem !important;
  }

  .text-md-start {
    text-align: left !important;
  }

  .text-md-end {
    text-align: right !important;
  }

  .text-md-center {
    text-align: center !important;
  }
}

@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }

  .float-lg-end {
    float: right !important;
  }

  .float-lg-none {
    float: none !important;
  }

  .object-fit-lg-contain {
    object-fit: contain !important;
  }

  .object-fit-lg-cover {
    object-fit: cover !important;
  }

  .object-fit-lg-fill {
    object-fit: fill !important;
  }

  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }

  .object-fit-lg-none {
    object-fit: none !important;
  }

  .d-lg-inline {
    display: inline !important;
  }

  .d-lg-inline-block {
    display: inline-block !important;
  }

  .d-lg-block {
    display: block !important;
  }

  .d-lg-grid {
    display: grid !important;
  }

  .d-lg-inline-grid {
    display: inline-grid !important;
  }

  .d-lg-table {
    display: table !important;
  }

  .d-lg-table-row {
    display: table-row !important;
  }

  .d-lg-table-cell {
    display: table-cell !important;
  }

  .d-lg-flex {
    display: flex !important;
  }

  .d-lg-inline-flex {
    display: inline-flex !important;
  }

  .d-lg-none {
    display: none !important;
  }

  .flex-lg-fill {
    flex: 1 1 auto !important;
  }

  .flex-lg-row {
    flex-direction: row !important;
  }

  .flex-lg-column {
    flex-direction: column !important;
  }

  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }

  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-lg-start {
    justify-content: flex-start !important;
  }

  .justify-content-lg-end {
    justify-content: flex-end !important;
  }

  .justify-content-lg-center {
    justify-content: center !important;
  }

  .justify-content-lg-between {
    justify-content: space-between !important;
  }

  .justify-content-lg-around {
    justify-content: space-around !important;
  }

  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-lg-start {
    align-items: flex-start !important;
  }

  .align-items-lg-end {
    align-items: flex-end !important;
  }

  .align-items-lg-center {
    align-items: center !important;
  }

  .align-items-lg-baseline {
    align-items: baseline !important;
  }

  .align-items-lg-stretch {
    align-items: stretch !important;
  }

  .align-content-lg-start {
    align-content: flex-start !important;
  }

  .align-content-lg-end {
    align-content: flex-end !important;
  }

  .align-content-lg-center {
    align-content: center !important;
  }

  .align-content-lg-between {
    align-content: space-between !important;
  }

  .align-content-lg-around {
    align-content: space-around !important;
  }

  .align-content-lg-stretch {
    align-content: stretch !important;
  }

  .align-self-lg-auto {
    align-self: auto !important;
  }

  .align-self-lg-start {
    align-self: flex-start !important;
  }

  .align-self-lg-end {
    align-self: flex-end !important;
  }

  .align-self-lg-center {
    align-self: center !important;
  }

  .align-self-lg-baseline {
    align-self: baseline !important;
  }

  .align-self-lg-stretch {
    align-self: stretch !important;
  }

  .order-lg-first {
    order: -1 !important;
  }

  .order-lg-0 {
    order: 0 !important;
  }

  .order-lg-1 {
    order: 1 !important;
  }

  .order-lg-2 {
    order: 2 !important;
  }

  .order-lg-3 {
    order: 3 !important;
  }

  .order-lg-4 {
    order: 4 !important;
  }

  .order-lg-5 {
    order: 5 !important;
  }

  .order-lg-last {
    order: 6 !important;
  }

  .m-lg-0 {
    margin: 0 !important;
  }

  .m-lg-1 {
    margin: 0.25rem !important;
  }

  .m-lg-2 {
    margin: 0.5rem !important;
  }

  .m-lg-3 {
    margin: 1rem !important;
  }

  .m-lg-4 {
    margin: 1.5rem !important;
  }

  .m-lg-5 {
    margin: 3rem !important;
  }

  .m-lg-auto {
    margin: auto !important;
  }

  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-lg-0 {
    margin-top: 0 !important;
  }

  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }

  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }

  .mt-lg-3 {
    margin-top: 1rem !important;
  }

  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }

  .mt-lg-5 {
    margin-top: 3rem !important;
  }

  .mt-lg-auto {
    margin-top: auto !important;
  }

  .me-lg-0 {
    margin-right: 0 !important;
  }

  .me-lg-1 {
    margin-right: 0.25rem !important;
  }

  .me-lg-2 {
    margin-right: 0.5rem !important;
  }

  .me-lg-3 {
    margin-right: 1rem !important;
  }

  .me-lg-4 {
    margin-right: 1.5rem !important;
  }

  .me-lg-5 {
    margin-right: 3rem !important;
  }

  .me-lg-auto {
    margin-right: auto !important;
  }

  .mb-lg-0 {
    margin-bottom: 0 !important;
  }

  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }

  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }

  .mb-lg-auto {
    margin-bottom: auto !important;
  }

  .ms-lg-0 {
    margin-left: 0 !important;
  }

  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }

  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }

  .ms-lg-3 {
    margin-left: 1rem !important;
  }

  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }

  .ms-lg-5 {
    margin-left: 3rem !important;
  }

  .ms-lg-auto {
    margin-left: auto !important;
  }

  .p-lg-0 {
    padding: 0 !important;
  }

  .p-lg-1 {
    padding: 0.25rem !important;
  }

  .p-lg-2 {
    padding: 0.5rem !important;
  }

  .p-lg-3 {
    padding: 1rem !important;
  }

  .p-lg-4 {
    padding: 1.5rem !important;
  }

  .p-lg-5 {
    padding: 3rem !important;
  }

  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-lg-0 {
    padding-top: 0 !important;
  }

  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }

  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }

  .pt-lg-3 {
    padding-top: 1rem !important;
  }

  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }

  .pt-lg-5 {
    padding-top: 3rem !important;
  }

  .pe-lg-0 {
    padding-right: 0 !important;
  }

  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }

  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }

  .pe-lg-3 {
    padding-right: 1rem !important;
  }

  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }

  .pe-lg-5 {
    padding-right: 3rem !important;
  }

  .pb-lg-0 {
    padding-bottom: 0 !important;
  }

  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }

  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }

  .ps-lg-0 {
    padding-left: 0 !important;
  }

  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }

  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }

  .ps-lg-3 {
    padding-left: 1rem !important;
  }

  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }

  .ps-lg-5 {
    padding-left: 3rem !important;
  }

  .gap-lg-0 {
    gap: 0 !important;
  }

  .gap-lg-1 {
    gap: 0.25rem !important;
  }

  .gap-lg-2 {
    gap: 0.5rem !important;
  }

  .gap-lg-3 {
    gap: 1rem !important;
  }

  .gap-lg-4 {
    gap: 1.5rem !important;
  }

  .gap-lg-5 {
    gap: 3rem !important;
  }

  .row-gap-lg-0 {
    row-gap: 0 !important;
  }

  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }

  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }

  .column-gap-lg-0 {
    column-gap: 0 !important;
  }

  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }

  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }

  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }

  .text-lg-start {
    text-align: left !important;
  }

  .text-lg-end {
    text-align: right !important;
  }

  .text-lg-center {
    text-align: center !important;
  }
}

@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }

  .float-xl-end {
    float: right !important;
  }

  .float-xl-none {
    float: none !important;
  }

  .object-fit-xl-contain {
    object-fit: contain !important;
  }

  .object-fit-xl-cover {
    object-fit: cover !important;
  }

  .object-fit-xl-fill {
    object-fit: fill !important;
  }

  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }

  .object-fit-xl-none {
    object-fit: none !important;
  }

  .d-xl-inline {
    display: inline !important;
  }

  .d-xl-inline-block {
    display: inline-block !important;
  }

  .d-xl-block {
    display: block !important;
  }

  .d-xl-grid {
    display: grid !important;
  }

  .d-xl-inline-grid {
    display: inline-grid !important;
  }

  .d-xl-table {
    display: table !important;
  }

  .d-xl-table-row {
    display: table-row !important;
  }

  .d-xl-table-cell {
    display: table-cell !important;
  }

  .d-xl-flex {
    display: flex !important;
  }

  .d-xl-inline-flex {
    display: inline-flex !important;
  }

  .d-xl-none {
    display: none !important;
  }

  .flex-xl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xl-row {
    flex-direction: row !important;
  }

  .flex-xl-column {
    flex-direction: column !important;
  }

  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-xl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xl-center {
    justify-content: center !important;
  }

  .justify-content-xl-between {
    justify-content: space-between !important;
  }

  .justify-content-xl-around {
    justify-content: space-around !important;
  }

  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-xl-start {
    align-items: flex-start !important;
  }

  .align-items-xl-end {
    align-items: flex-end !important;
  }

  .align-items-xl-center {
    align-items: center !important;
  }

  .align-items-xl-baseline {
    align-items: baseline !important;
  }

  .align-items-xl-stretch {
    align-items: stretch !important;
  }

  .align-content-xl-start {
    align-content: flex-start !important;
  }

  .align-content-xl-end {
    align-content: flex-end !important;
  }

  .align-content-xl-center {
    align-content: center !important;
  }

  .align-content-xl-between {
    align-content: space-between !important;
  }

  .align-content-xl-around {
    align-content: space-around !important;
  }

  .align-content-xl-stretch {
    align-content: stretch !important;
  }

  .align-self-xl-auto {
    align-self: auto !important;
  }

  .align-self-xl-start {
    align-self: flex-start !important;
  }

  .align-self-xl-end {
    align-self: flex-end !important;
  }

  .align-self-xl-center {
    align-self: center !important;
  }

  .align-self-xl-baseline {
    align-self: baseline !important;
  }

  .align-self-xl-stretch {
    align-self: stretch !important;
  }

  .order-xl-first {
    order: -1 !important;
  }

  .order-xl-0 {
    order: 0 !important;
  }

  .order-xl-1 {
    order: 1 !important;
  }

  .order-xl-2 {
    order: 2 !important;
  }

  .order-xl-3 {
    order: 3 !important;
  }

  .order-xl-4 {
    order: 4 !important;
  }

  .order-xl-5 {
    order: 5 !important;
  }

  .order-xl-last {
    order: 6 !important;
  }

  .m-xl-0 {
    margin: 0 !important;
  }

  .m-xl-1 {
    margin: 0.25rem !important;
  }

  .m-xl-2 {
    margin: 0.5rem !important;
  }

  .m-xl-3 {
    margin: 1rem !important;
  }

  .m-xl-4 {
    margin: 1.5rem !important;
  }

  .m-xl-5 {
    margin: 3rem !important;
  }

  .m-xl-auto {
    margin: auto !important;
  }

  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-xl-0 {
    margin-top: 0 !important;
  }

  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }

  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }

  .mt-xl-3 {
    margin-top: 1rem !important;
  }

  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }

  .mt-xl-5 {
    margin-top: 3rem !important;
  }

  .mt-xl-auto {
    margin-top: auto !important;
  }

  .me-xl-0 {
    margin-right: 0 !important;
  }

  .me-xl-1 {
    margin-right: 0.25rem !important;
  }

  .me-xl-2 {
    margin-right: 0.5rem !important;
  }

  .me-xl-3 {
    margin-right: 1rem !important;
  }

  .me-xl-4 {
    margin-right: 1.5rem !important;
  }

  .me-xl-5 {
    margin-right: 3rem !important;
  }

  .me-xl-auto {
    margin-right: auto !important;
  }

  .mb-xl-0 {
    margin-bottom: 0 !important;
  }

  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }

  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }

  .mb-xl-auto {
    margin-bottom: auto !important;
  }

  .ms-xl-0 {
    margin-left: 0 !important;
  }

  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }

  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }

  .ms-xl-3 {
    margin-left: 1rem !important;
  }

  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }

  .ms-xl-5 {
    margin-left: 3rem !important;
  }

  .ms-xl-auto {
    margin-left: auto !important;
  }

  .p-xl-0 {
    padding: 0 !important;
  }

  .p-xl-1 {
    padding: 0.25rem !important;
  }

  .p-xl-2 {
    padding: 0.5rem !important;
  }

  .p-xl-3 {
    padding: 1rem !important;
  }

  .p-xl-4 {
    padding: 1.5rem !important;
  }

  .p-xl-5 {
    padding: 3rem !important;
  }

  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-xl-0 {
    padding-top: 0 !important;
  }

  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }

  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }

  .pt-xl-3 {
    padding-top: 1rem !important;
  }

  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }

  .pt-xl-5 {
    padding-top: 3rem !important;
  }

  .pe-xl-0 {
    padding-right: 0 !important;
  }

  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }

  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }

  .pe-xl-3 {
    padding-right: 1rem !important;
  }

  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }

  .pe-xl-5 {
    padding-right: 3rem !important;
  }

  .pb-xl-0 {
    padding-bottom: 0 !important;
  }

  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }

  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }

  .ps-xl-0 {
    padding-left: 0 !important;
  }

  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }

  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }

  .ps-xl-3 {
    padding-left: 1rem !important;
  }

  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }

  .ps-xl-5 {
    padding-left: 3rem !important;
  }

  .gap-xl-0 {
    gap: 0 !important;
  }

  .gap-xl-1 {
    gap: 0.25rem !important;
  }

  .gap-xl-2 {
    gap: 0.5rem !important;
  }

  .gap-xl-3 {
    gap: 1rem !important;
  }

  .gap-xl-4 {
    gap: 1.5rem !important;
  }

  .gap-xl-5 {
    gap: 3rem !important;
  }

  .row-gap-xl-0 {
    row-gap: 0 !important;
  }

  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }

  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }

  .column-gap-xl-0 {
    column-gap: 0 !important;
  }

  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }

  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }

  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }

  .text-xl-start {
    text-align: left !important;
  }

  .text-xl-end {
    text-align: right !important;
  }

  .text-xl-center {
    text-align: center !important;
  }
}

@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }

  .float-xxl-end {
    float: right !important;
  }

  .float-xxl-none {
    float: none !important;
  }

  .object-fit-xxl-contain {
    object-fit: contain !important;
  }

  .object-fit-xxl-cover {
    object-fit: cover !important;
  }

  .object-fit-xxl-fill {
    object-fit: fill !important;
  }

  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }

  .object-fit-xxl-none {
    object-fit: none !important;
  }

  .d-xxl-inline {
    display: inline !important;
  }

  .d-xxl-inline-block {
    display: inline-block !important;
  }

  .d-xxl-block {
    display: block !important;
  }

  .d-xxl-grid {
    display: grid !important;
  }

  .d-xxl-inline-grid {
    display: inline-grid !important;
  }

  .d-xxl-table {
    display: table !important;
  }

  .d-xxl-table-row {
    display: table-row !important;
  }

  .d-xxl-table-cell {
    display: table-cell !important;
  }

  .d-xxl-flex {
    display: flex !important;
  }

  .d-xxl-inline-flex {
    display: inline-flex !important;
  }

  .d-xxl-none {
    display: none !important;
  }

  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xxl-row {
    flex-direction: row !important;
  }

  .flex-xxl-column {
    flex-direction: column !important;
  }

  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xxl-center {
    justify-content: center !important;
  }

  .justify-content-xxl-between {
    justify-content: space-between !important;
  }

  .justify-content-xxl-around {
    justify-content: space-around !important;
  }

  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-xxl-start {
    align-items: flex-start !important;
  }

  .align-items-xxl-end {
    align-items: flex-end !important;
  }

  .align-items-xxl-center {
    align-items: center !important;
  }

  .align-items-xxl-baseline {
    align-items: baseline !important;
  }

  .align-items-xxl-stretch {
    align-items: stretch !important;
  }

  .align-content-xxl-start {
    align-content: flex-start !important;
  }

  .align-content-xxl-end {
    align-content: flex-end !important;
  }

  .align-content-xxl-center {
    align-content: center !important;
  }

  .align-content-xxl-between {
    align-content: space-between !important;
  }

  .align-content-xxl-around {
    align-content: space-around !important;
  }

  .align-content-xxl-stretch {
    align-content: stretch !important;
  }

  .align-self-xxl-auto {
    align-self: auto !important;
  }

  .align-self-xxl-start {
    align-self: flex-start !important;
  }

  .align-self-xxl-end {
    align-self: flex-end !important;
  }

  .align-self-xxl-center {
    align-self: center !important;
  }

  .align-self-xxl-baseline {
    align-self: baseline !important;
  }

  .align-self-xxl-stretch {
    align-self: stretch !important;
  }

  .order-xxl-first {
    order: -1 !important;
  }

  .order-xxl-0 {
    order: 0 !important;
  }

  .order-xxl-1 {
    order: 1 !important;
  }

  .order-xxl-2 {
    order: 2 !important;
  }

  .order-xxl-3 {
    order: 3 !important;
  }

  .order-xxl-4 {
    order: 4 !important;
  }

  .order-xxl-5 {
    order: 5 !important;
  }

  .order-xxl-last {
    order: 6 !important;
  }

  .m-xxl-0 {
    margin: 0 !important;
  }

  .m-xxl-1 {
    margin: 0.25rem !important;
  }

  .m-xxl-2 {
    margin: 0.5rem !important;
  }

  .m-xxl-3 {
    margin: 1rem !important;
  }

  .m-xxl-4 {
    margin: 1.5rem !important;
  }

  .m-xxl-5 {
    margin: 3rem !important;
  }

  .m-xxl-auto {
    margin: auto !important;
  }

  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-xxl-0 {
    margin-top: 0 !important;
  }

  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }

  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }

  .mt-xxl-3 {
    margin-top: 1rem !important;
  }

  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }

  .mt-xxl-5 {
    margin-top: 3rem !important;
  }

  .mt-xxl-auto {
    margin-top: auto !important;
  }

  .me-xxl-0 {
    margin-right: 0 !important;
  }

  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }

  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }

  .me-xxl-3 {
    margin-right: 1rem !important;
  }

  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }

  .me-xxl-5 {
    margin-right: 3rem !important;
  }

  .me-xxl-auto {
    margin-right: auto !important;
  }

  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }

  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }

  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }

  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }

  .mb-xxl-auto {
    margin-bottom: auto !important;
  }

  .ms-xxl-0 {
    margin-left: 0 !important;
  }

  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }

  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }

  .ms-xxl-3 {
    margin-left: 1rem !important;
  }

  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }

  .ms-xxl-5 {
    margin-left: 3rem !important;
  }

  .ms-xxl-auto {
    margin-left: auto !important;
  }

  .p-xxl-0 {
    padding: 0 !important;
  }

  .p-xxl-1 {
    padding: 0.25rem !important;
  }

  .p-xxl-2 {
    padding: 0.5rem !important;
  }

  .p-xxl-3 {
    padding: 1rem !important;
  }

  .p-xxl-4 {
    padding: 1.5rem !important;
  }

  .p-xxl-5 {
    padding: 3rem !important;
  }

  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .pt-xxl-0 {
    padding-top: 0 !important;
  }

  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }

  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }

  .pt-xxl-3 {
    padding-top: 1rem !important;
  }

  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }

  .pt-xxl-5 {
    padding-top: 3rem !important;
  }

  .pe-xxl-0 {
    padding-right: 0 !important;
  }

  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }

  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }

  .pe-xxl-3 {
    padding-right: 1rem !important;
  }

  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }

  .pe-xxl-5 {
    padding-right: 3rem !important;
  }

  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }

  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }

  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }

  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }

  .ps-xxl-0 {
    padding-left: 0 !important;
  }

  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }

  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }

  .ps-xxl-3 {
    padding-left: 1rem !important;
  }

  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }

  .ps-xxl-5 {
    padding-left: 3rem !important;
  }

  .gap-xxl-0 {
    gap: 0 !important;
  }

  .gap-xxl-1 {
    gap: 0.25rem !important;
  }

  .gap-xxl-2 {
    gap: 0.5rem !important;
  }

  .gap-xxl-3 {
    gap: 1rem !important;
  }

  .gap-xxl-4 {
    gap: 1.5rem !important;
  }

  .gap-xxl-5 {
    gap: 3rem !important;
  }

  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }

  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }

  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }

  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }

  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }

  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }

  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }

  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }

  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }

  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }

  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }

  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }

  .text-xxl-start {
    text-align: left !important;
  }

  .text-xxl-end {
    text-align: right !important;
  }

  .text-xxl-center {
    text-align: center !important;
  }
}

@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.2rem !important;
  }

  .fs-2 {
    font-size: 2.024rem !important;
  }

  .fs-3 {
    font-size: 1.584rem !important;
  }
}

@media print {
  .d-print-inline {
    display: inline !important;
  }

  .d-print-inline-block {
    display: inline-block !important;
  }

  .d-print-block {
    display: block !important;
  }

  .d-print-grid {
    display: grid !important;
  }

  .d-print-inline-grid {
    display: inline-grid !important;
  }

  .d-print-table {
    display: table !important;
  }

  .d-print-table-row {
    display: table-row !important;
  }

  .d-print-table-cell {
    display: table-cell !important;
  }

  .d-print-flex {
    display: flex !important;
  }

  .d-print-inline-flex {
    display: inline-flex !important;
  }

  .d-print-none {
    display: none !important;
  }
}

/* Global Area Style
============================================*/
body {
  font-family: "Inter", sans-serif;
}

a {
  transition: all ease 0.5s;
  color: #fff;
}

a:hover {
  color: #d08f2c;
}

a:focus-visible {
  outline: 0;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  color: #3A4252;
  font-weight: 700;
}

h3,
.h3 {
  font-size: 18px;
}

p {
  margin-bottom: 15px;
  line-height: 26px;
}

p:last-child {
  margin-bottom: 0;
}

img {
  max-width: 100%;
  height: auto;
}

.label,
.form-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 10px;
}

.card {
  transition: all ease 0.5s;
}

.btn-primary:hover span {
  color: #fff !important;
}

.form-control {
  background-color: #fff;
  border: 1px solid #D5D9E2;
  height: 50px;
  color: #3A4252 !important;
  font-size: 15px;
  padding: 14px 16px;
  width: 100%;
  transition: all ease 0.5s;
  border-radius: 7px;
}

.form-control::placeholder {
  color: #fff;
  font-size: 14px;
}

.form-control:focus {
  background-color: #fff;
  box-shadow: unset;
  outline: 0;
  border: 1px solid #d08f2c;
  color: #8695AA;
}

.form-control.form-select {
  cursor: pointer;
  color: #8695AA;
}

.form-control.file {
  padding-top: 12px;
}

.form-control.h-55 {
  height: 55px;
}

.form-control.h-60 {
  height: 60px;
}

textarea.form-control {
  height: auto;
}

.form-check {
  margin-bottom: 0;
}

.form-check .form-check-input {
  border: 2px solid #fff;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.form-check .form-check-input:focus {
  box-shadow: none;
  border-color: #d08f2c;
}

.form-check .form-check-input:checked[type=checkbox] {
  border-color: #d08f2c;
}

.form-check .form-check-label {
  padding-left: 5px;
}

.month-select {
  width: 114px;
  height: 36px;
  padding-top: 6px;
  padding-bottom: 10px;
  background-size: 10px 10px;
  background-position: right 8px center;
  font-size: 14px;
}

.month-select.w-145 {
  width: 145px;
}

.month-select.w-135 {
  width: 135px;
}

.month-select.w-90 {
  width: 90px;
}

.month-select.w-99 {
  width: 105px;
}

.lcbmp-none:last-child {
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
  border-bottom: none !important;
}

.lcmb-none:last-child {
  border-bottom: 0 !important;
  margin-bottom: 0 !important;
}

.tr-lcbp-none:last-child td {
  border-bottom: none;
  padding-bottom: 0 !important;
}

.list-last-child li:last-child {
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
  border-bottom: none !important;
}

.l-lcbm li:last-child {
  margin-bottom: 0 !important;
  border-bottom: none !important;
}

.hover-text-white:hover {
  color: #fff !important;
}

.cursor-pointer {
  cursor: pointer;
}

.py-38 {
  padding-top: 38px !important;
  padding-bottom: 38px !important;
}

.default-src-form .form-control {
  height: 40px;
  background-color: #F6F7F9;
  border-color: #F6F7F9;
  padding-left: 35px;
}

.default-src-form .start-0 {
  left: 15px !important;
}

.breadcrumb-page-list .breadcrumb {
  margin: 0;
}

.breadcrumb-page-list .breadcrumb li a {
  text-decoration: none;
}

.bg-4936F5 {
  background-color: #4936F5;
}

/* BG Image Area Style
============================================*/
.bg-img {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

/* Preloader Area Style
============================================*/
#preloader {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  position: fixed;
  background-color: #fff;
}

#preloader .preloader {
  transform: translate(-50%, -50%);
  position: absolute;
  left: 50%;
  top: 50%;
}

#preloader .preloader .loader {
  position: relative;
  overflow: hidden;
  display: block;
  height: 150px;
  width: 150px;
  margin-left: auto;
  margin-right: auto;
}

#preloader .preloader .loader div {
  height: 100%;
}

#preloader .preloader .loader,
#preloader .preloader .loader div {
  padding: 8px;
  border-radius: 50%;
  border: 2px solid transparent;
  animation: rotate linear 3.5s infinite;
  border-top-color: #d08f2c;
  border-border-bottom: #d08f2c;
}

#preloader .preloader .waviy {
  position: relative;
  text-align: center;
  -webkit-box-reflect: below -47px linear-gradient(transparent, rgba(0, 0, 0, 0.2));
  font-size: 50px;
  font-weight: 700;
}

#preloader .preloader .waviy span {
  position: relative;
  color: #000000;
  animation-delay: 0.1s;
  display: inline-block;
  animation: waviy 1s infinite;
}

#preloader .preloader .waviy span:nth-child(2) {
  animation-delay: 0.2s;
}

#preloader .preloader .waviy span:nth-child(3) {
  animation-delay: 0.3s;
}

#preloader .preloader .waviy span:nth-child(4) {
  animation-delay: 0.4s;
}

#preloader .preloader .waviy span:nth-child(5) {
  animation-delay: 0.5s;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes waviy {

  0%,
  40%,
  100% {
    transform: translateY(0);
  }

  20% {
    transform: translateY(-20px);
  }
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  #preloader .preloader .waviy {
    font-size: 30px;
  }
}

.badge {
  background-color: #ECF0FF;
  color: #d08f2c;
}

.badge.pending,
.badge.Pending {
  background-color: rgba(255, 193, 7, 0.15);
  color: #FFBC2B;
}

.badge.rejected,
.badge.Rejected,
.badge.NotAvailable,
.badge.notAvailable,
.badge.Not.Available,
.badge.not.available,
.badge.Not,
.badge.not,
.badge.past,
.badge.Past {
  background-color: #FFE1DD;
  color: #FD5812;
}

.badge.pInProgress,
.badge.cancelled,
.badge.Cancelled,
.badge.draft,
.badge.Draft,
.badge.deactive,
.badge.Deactive,
.badge.Deactivate,
.badge.deactivate,
.badge.Unread,
.badge.unread,
.badge.inProgress,
.badge.in.Progress,
.badge.In.Progress {
  background-color: #FFE1DD;
  color: #FD5812;
}

.badge.finished,
.badge .Finished,
.badge.shipped,
.badge.Shipped,
.badge.pFinished {
  background-color: #D8FFC8;
  color: #37D80A;
}

.badge.pPending {
  background-color: #F3E8FF;
  color: #d08f2c;
}

/*
Action Opt Style
======================================================*/
.action-opt .btn {
  border: none;
  color: #8F9DBD;
  font-size: 22px;
}

.action-opt .btn:after {
  display: none;
}

.action-opt .btn:focus {
  border: none;
  box-shadow: none;
}

.action-opt .btn.bg {
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #F3F6F9;
  border-radius: 4px;
}

.action-opt .btn.bg svg {
  margin-right: 0 !important;
  stroke: #fff !important;
}

.action-opt .dropdown-menu .dropdown-item {
  font-size: 14px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
}

.action-opt .dropdown-menu .dropdown-item i,
.action-opt .dropdown-menu .dropdown-item span {
  font-size: 16px;
  margin-right: 5px;
  position: relative;
  top: 0;
}

.action-opt .dropdown-menu .dropdown-item:hover {
  background: rgba(92, 97, 242, 0.05);
  color: #d08f2c;
}

.action-opt.hover .dropdown-menu {
  display: block !important;
  opacity: 0;
  transition: all ease 0.5s;
}

.action-opt.hover:hover .dropdown-menu {
  opacity: 1;
}

/*
Custom Width Area Style
======================================================*/
.w-330 {
  width: 330px;
}

.wh-11 {
  width: 11px;
  height: 11px;
}

.wh-16 {
  width: 16px;
  height: 16px;
}

.wh-25 {
  width: 25px;
  height: 25px;
}

.wh-30 {
  width: 30px;
  height: 30px;
}

.wh-34 {
  width: 34px;
  height: 34px;
}

.wh-35 {
  width: 35px;
  height: 35px;
}

.wh-40 {
  width: 40px;
  height: 40px;
}

.wh-44 {
  width: 44px;
  height: 44px;
}

.wh-45 {
  width: 45px;
  height: 45px;
}

.wh-47 {
  width: 47px;
  height: 47px;
}

.wh-48 {
  width: 48px;
  height: 48px;
}

.wh-52 {
  width: 52px;
  height: 52px;
}

.wh-55 {
  width: 55px;
  height: 55px;
}

.wh-57 {
  width: 57px;
  height: 57px;
}

.wh-60 {
  width: 60px;
  height: 60px;
}

.wh-65 {
  width: 65px;
  height: 65px;
}

.wh-67 {
  width: 67px;
  height: 67px;
}

.wh-70 {
  width: 70px;
  height: 70px;
}

.wh-75 {
  width: 75px;
  height: 75px;
}

.wh-77 {
  width: 77px;
  height: 77px;
}

.wh-80 {
  width: 80px;
  height: 60px;
}

.wh-87 {
  width: 87px;
  height: 87px;
}

.wh-100 {
  width: 100px;
  height: 100px;
}

.wh-130 {
  width: 130px;
  height: 130px;
}

.wh-130-113 {
  width: 130px;
  height: 113px;
}

.wh-150 {
  width: 150px;
  height: 150px;
}

.wh-160 {
  width: 160px;
  height: 160px;
}

.mw-80 {
  max-width: 80px;
}

.mw-123 {
  max-width: 123px;
}

.mw-380 {
  max-width: 380px;
}

.mw-430 {
  max-width: 430px;
}

.mw-480 {
  max-width: 480px;
}

.mw-548 {
  max-width: 548px;
}

.mw-740 {
  max-width: 740px;
}

/** New **/
.max-h-198 {
  max-height: 198px;
  overflow-y: auto;
}

.max-h-217 {
  max-height: 217.5px;
  overflow-y: auto;
}

.max-h-275 {
  max-height: 275px;
  overflow-y: auto;
}

.max-h-312 {
  max-height: 312px;
  overflow-y: auto;
}

.max-h-497 {
  max-height: 497px;
  overflow-y: auto;
}

.max-h-419 {
  max-height: 419px;
  overflow-y: auto;
}

.scrollbar {
  /* width */
  /* Track */
  /* Handle */
  /* Handle on hover */
}

.scrollbar::-webkit-scrollbar {
  width: 5px;
}

.scrollbar::-webkit-scrollbar-track {
  background: #fff;
}

.scrollbar::-webkit-scrollbar-thumb {
  background: #c5c5c5;
}

.scrollbar::-webkit-scrollbar-thumb:hover {
  background: #888;
}

/*
Custom Rounded Area Style
======================================================*/
.rounded-bottom-15 {
  border-radius: 0 0 15px 15px;
}

.rounded-top-7 {
  border-radius: 7px 7px 0 0;
}

/*
Custom Transition Area Style
======================================================*/
.transition {
  transition: all ease 0.5s;
}

.transition-x {
  transition: all ease 0.5s;
}

.transition-x:hover {
  transform: translateX(-5px);
}

.transition-x-right {
  transition: all ease 0.5s;
}

.transition-x-right:hover {
  transform: translateX(5px);
}

.transition-y {
  transition: all ease 0.5s;
}

.transition-y:hover {
  transform: translateY(-5px);
}

.transition-y-bottom {
  transition: all ease 0.5s;
}

.transition-y-bottom:hover {
  transform: translateY(5px);
}

.transition-zoom-in {
  transition: all ease 0.5s;
}

.transition-zoom-in:hover {
  transform: scale(1.3);
}

/*
Custom Font Size Area Style
======================================================*/
.fs-10 {
  font-size: 10px;
}

.fs-11 {
  font-size: 11px;
}

.fs-12 {
  font-size: 12px !important;
}

.fs-13 {
  font-size: 13px;
}

.fs-14 {
  font-size: 14px;
}

.fs-15 {
  font-size: 15px;
}

.fs-16 {
  font-size: 16px;
}

.fs-17 {
  font-size: 17px;
}

.fs-18 {
  font-size: 18px;
}

.fs-19 {
  font-size: 19px;
}

.fs-20 {
  font-size: 20px;
}

.fs-21 {
  font-size: 21px;
}

.fs-22 {
  font-size: 22px;
}

.fs-23 {
  font-size: 23px;
}

.fs-24 {
  font-size: 24px;
}

.fs-25 {
  font-size: 25px;
}

.fs-26 {
  font-size: 26px;
}

.fs-27 {
  font-size: 27px;
}

.fs-28 {
  font-size: 28px;
}

.fs-29 {
  font-size: 29px;
}

.fs-30 {
  font-size: 30px;
}

.fs-32 {
  font-size: 32px;
}

.fs-35 {
  font-size: 35px;
}

.fs-40 {
  font-size: 40px;
}

.fs-45 {
  font-size: 45px;
}

/*
Custom Padding & Margin Area Style
======================================================*/
.mb-20 {
  margin-bottom: 20px;
}

.mb-29 {
  margin-bottom: 29px;
}

.mb-30 {
  margin-bottom: 30px;
}

.mb-35 {
  margin-bottom: 35px;
}

.mb-19 {
  margin-bottom: 19px;
}

.ms-m-15 {
  margin-left: -15px;
}

.ms-m-15:first-child {
  margin-left: 0;
}

.ms-m-20 {
  margin-left: -20px;
}

.ms-m-20:first-child {
  margin-left: 0;
}

.ms-m-10 {
  margin-left: -10px;
}

.ms-e-10 {
  margin-right: -10px;
}

.p-20 {
  padding: 20px;
}

.ps-20 {
  padding-left: 20px;
}

.mt-minus-110 {
  margin-top: -100px;
}

.minus-l-20 {
  margin-left: -20px;
}

.minus-l-20:first-child {
  margin-left: 0;
}

.box-shadow {
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

/*
Line Height Area Style
======================================================*/
.lh-16 {
  line-height: 16.5px !important;
}

.lh-25 {
  line-height: 25px !important;
}

.lh-30 {
  line-height: 30px !important;
}

.lh-34 {
  line-height: 34px !important;
}

.lh-35 {
  line-height: 35px !important;
}

.lh-40 {
  line-height: 40px !important;
}

.lh-44 {
  line-height: 44px !important;
}

.lh-45 {
  line-height: 45px !important;
}

.lh-48 {
  line-height: 48px !important;
}

.lh-56 {
  line-height: 56px !important;
}

.lh-55 {
  line-height: 59px !important;
}

.lh-60 {
  line-height: 60px !important;
}

.lh-70 {
  line-height: 70px !important;
}

.lh-97 {
  line-height: 97px !important;
}

/*
Custom Border Color Area Style
======================================================*/
.border-color-white {
  border-color: #fff !important;
}

.list-dot li {
  position: relative;
  padding-right: 14px;
  margin-right: 10px;
}

.list-dot li::before {
  content: "";
  position: absolute;
  top: 50%;
  right: 0;
  width: 5px;
  height: 5px;
  background-color: #fff;
  border-radius: 50px;
  transform: translateY(-50%);
}

.list-dot li:last-child {
  padding-right: 0;
  margin-right: 0;
}

.list-dot li:last-child::before {
  display: none;
}

/*
Custom Hover Area Style
======================================================*/
.hover {
  transition: all ease 0.5s;
}

.hover:hover {
  color: #d08f2c !important;
}

.hover:hover i,
.hover:hover span {
  color: #d08f2c !important;
}

.hover-white {
  transition: all ease 0.5s;
}

.hover-white:hover {
  color: #fff !important;
}

.hover-white:hover i,
.hover-white:hover span {
  color: #fff !important;
}

.hover-bg {
  transition: all ease 0.5s;
}

.hover-bg:hover {
  background-color: #d08f2c !important;
  color: #fff !important;
}

.hover-bg:hover i,
.hover-bg:hover span {
  color: #fff !important;
}

.cursor {
  cursor: pointer;
}

.cursor-move {
  cursor: move;
}

.product-upload input[type=file] {
  display: none;
}

.product-upload .file-upload {
  display: inline-block;
  cursor: pointer;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  width: 100%;
}

.inbox-tabs {
  flex-wrap: wrap !important;
  padding-bottom: 15px !important;
  gap: 3rem !important;
}

.inbox-tabs .nav-item .nav-link {
  position: relative;
  padding: 0;
  font-weight: 500;
  color: #fff;
  border: none;
  background-color: transparent;
}

.inbox-tabs .nav-item .nav-link::before {
  content: "";
  position: absolute;
  bottom: -15px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #d08f2c;
  opacity: 0;
  transition: all ease 0.5s;
}

.inbox-tabs .nav-item .nav-link.active {
  color: #d08f2c !important;
}

.inbox-tabs .nav-item .nav-link.active::before {
  opacity: 1;
}

.inbox-tabs .nav-item .nav-link.active i,
.inbox-tabs .nav-item .nav-link.active span {
  color: #d08f2c !important;
}

.seller-tabs .nav-item .nav-link.active {
  background-color: #d08f2c !important;
  color: #fff !important;
}

.profile-tabs .nav-item .nav-link.active {
  background-color: #d08f2c !important;
  color: #fff !important;
}

.profile-tabs .nav-item .nav-link:hover {
  background-color: #d08f2c !important;
  color: #fff !important;
}

.tracking-step {
  position: relative;
  z-index: 1;
}

.tracking-step::before {
  content: "";
  position: absolute;
  top: 25px;
  left: 0;
  right: 0;
  border-top: 1px dashed #fff;
  z-index: -1;
  border-spacing: 20px;
}

.tracking-step .count {
  width: 50px;
  height: 50px;
  line-height: 48px;
  border: 1px dashed #fff;
  display: inline-block;
  border-radius: 50px;
  background-color: #d08f2c;
}

.tracking-step .count.active {
  background-color: #0dcaf0;
}

.tracking-step.style-two::before {
  border-color: #d08f2c;
}

.tracking-step.style-two .count {
  border-color: #d08f2c;
}

.tracking-step.style-two .count.active {
  background-color: #d08f2c;
}

.top-1 {
  top: 1px;
}

.top-2 {
  top: 2px;
}

.top-3 {
  top: 3px;
}

.top-4 {
  top: 4px;
}

.top-5 {
  top: 5px;
}

button i,
button span {
  transition: all ease 0.5s;
}

button:hover i,
button:hover span {
  color: #d08f2c;
}

.btn-close:focus {
  box-shadow: none;
}

.copy-btn {
  margin-top: 144px;
  margin-right: 35px;
}

.copy-btn:hover {
  background-color: #d08f2c !important;
  color: #fff;
}

.carousel-control-prev {
  width: 38px;
  height: 38px;
  background-color: #d08f2c;
  padding: 10px;
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  border-radius: 5px;
  opacity: 1;
}

.carousel-control-next {
  width: 38px;
  height: 38px;
  background-color: #d08f2c;
  padding: 10px;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  border-radius: 5px;
  opacity: 1;
}

.rating i,
.rating span {
  transition: all ease 0.5s;
  font-size: 20px;
  cursor: pointer;
}

.rating.active i,
.rating.active span {
  color: #f7d700;
}

/*
Scroll Bar Style
======================================================*/
.scroll-bar {
  margin-top: 0 !important;
  overflow: auto;
  padding-right: 5px;
  /* width */
  /* Track */
  /* Handle */
  /* Handle on hover */
}

.scroll-bar::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  -webkit-transition: all ease 0.5s;
  transition: all ease 0.5s;
  border-radius: 50px;
}

.scroll-bar::-webkit-scrollbar-track {
  background: #F0F0F4;
  -webkit-transition: all ease 0.5s;
  transition: all ease 0.5s;
  border-radius: 50px;
}

.scroll-bar::-webkit-scrollbar-thumb {
  background: #e0e0e2;
  -webkit-transition: all ease 0.5s;
  transition: all ease 0.5s;
  border-radius: 50px;
}

.scroll-bar::-webkit-scrollbar-thumb:hover {
  background: #d08f2c;
  border-radius: 50px;
}

.scroll-bar.active {
  /* Handle */
  /* Handle on hover */
}

.scroll-bar.active::-webkit-scrollbar-track {
  background: #F0F0F4;
  -webkit-transition: all ease 0.5s;
  transition: all ease 0.5s;
  border-radius: 0;
}

.scroll-bar.active::-webkit-scrollbar-thumb {
  background: #d08f2c;
  -webkit-transition: all ease 0.5s;
  transition: all ease 0.5s;
  border-radius: 0;
}

.scroll-bar.active::-webkit-scrollbar-thumb:hover {
  background: #d08f2c;
  border-radius: 0;
}

.btn-primary.bg-opacity-10:hover {
  background-color: #d08f2c !important;
  color: #fff !important;
}

.btn-danger.bg-opacity-10:hover {
  background-color: #FD5812 !important;
  color: #fff !important;
}

.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px;
}

.tag-container .tag {
  background-color: #d08f2c;
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.tag-container .tag-close {
  margin-left: 4px;
  cursor: pointer;
}

#x__PREV__X {
  background: #EBEAF7;
  font-size: 30px;
  height: 34px;
  line-height: 13px;
}

a#x__NEXT__X {
  background: #EBEAF7;
  font-size: 30px;
  height: 34px;
  line-height: 13px;
}

.faq-wrapper.accordion .accordion-item {
  border-radius: 7px;
}

.faq-wrapper.accordion .accordion-item .accordion-header .accordion-button {
  border-radius: 7px;
  font-size: 16px;
  font-weight: 500;
  background-color: #fff;
  box-shadow: none;
  color: #000;
}

.faq-wrapper.accordion .accordion-item .accordion-header .accordion-button:focus {
  box-shadow: none;
}

.faq-wrapper.accordion .accordion-item .accordion-header .accordion-button:not(.collapsed) {
  box-shadow: none;
}

.faq-wrapper.accordion .accordion-item .accordion-body {
  padding-top: 1px;
}

.wizard-tabs {
  position: relative;
  z-index: 1;
}

.wizard-tabs::before {
  content: "";
  position: absolute;
  top: 25px;
  left: 0;
  right: 0;
  width: 100%;
  height: 1px;
  background-color: #A9A9C8;
  opacity: 0.1;
  z-index: -1;
}

.wizard-tabs .nav-item .nav-link {
  background-color: #f1f2fd !important;
}

.wizard-tabs .nav-item .nav-link.active {
  background-color: #d08f2c !important;
}

.wizard-tabs .nav-item .nav-link.active span {
  color: #fff !important;
}

.wizard-tabs2 {
  position: relative;
  z-index: 1;
}

.wizard-tabs2::before {
  content: "";
  position: absolute;
  top: 25px;
  left: 0;
  right: 0;
  width: 100%;
  height: 2px;
  background-color: #A9A9C8;
  opacity: 0.1;
  z-index: -1;
}

.wizard-tabs2 .nav-item .nav-link {
  background-color: #fff;
  padding: 0 30px !important;
  border: none;
}

.wizard-tabs2 .nav-item .nav-link span {
  background-color: #f1f2fd !important;
  line-height: 48px;
}

.wizard-tabs2 .nav-item .nav-link.active span {
  color: #fff !important;
  background-color: #d08f2c !important;
}

.wizard-tabs2 .nav-item:first-child .nav-link {
  padding-left: 0 !important;
}

.wizard-tabs2 .nav-item:last-child .nav-link {
  padding-right: 0 !important;
}

/*
Theme Settings Style
======================================================*/
.settings-btn {
  background-color: #3A4252;
  padding: 8px 20px;
  display: inline-block;
  color: #fff;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
  border: none;
  transition: all ease 0.5s;
}

.settings-btn input {
  width: 0;
  height: 0;
  opacity: 0;
  cursor: pointer;
}

.settings-btn .slider {
  position: relative;
}

.settings-btn .slider:before {
  content: "Click To RTL";
  cursor: pointer;
}

.settings-btn .slider:after {
  content: "Click To LTR";
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}

.offcanvas-backdrop {
  background-color: transparent;
}

.light {
  display: none;
}

.light1 {
  display: none;
}

.light2 {
  display: none;
}

.light3 {
  display: none;
}

.radius {
  display: none;
}

.white {
  display: none;
}

.fluid {
  display: none;
}

/*
Swiper Slider Style
======================================================*/
.swiper-pagination2 {
  position: absolute;
  bottom: 57px !important;
  left: 25px !important;
  z-index: 1;
  text-align: left !important;
  width: 100px !important;
}

.swiper-pagination2.swiper-pagination-clickable .swiper-pagination-bullet {
  background-color: #fff;
  opacity: 1;
}

.swiper-pagination2.swiper-pagination-clickable .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: #FD5812;
}

/* Courses Area Style
============================================*/
.course-accordion .accordion-button:focus {
  box-shadow: none;
}

.course-accordion .accordion-button:not(.collapsed) {
  box-shadow: none;
}

.courses-slide .swiper-pagination {
  bottom: 10px;
  left: 10px;
  text-align: left;
}

.courses-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: #fff;
}

/* File Manager Area Style
============================================*/
.file-subdown {
  padding-left: 28px;
  margin-top: 21px;
  margin-bottom: 25px;
}

.file-subdown li {
  position: relative;
  padding-left: 15px;
  margin-bottom: 18px;
}

.file-subdown li:last-child {
  margin-bottom: 0;
}

.file-subdown li::before {
  left: 0;
  top: 50%;
  width: 6px;
  content: "";
  height: 6px;
  border-radius: 50%;
  position: absolute;
  transform: translateY(-50%);
  transition: all ease 0.5s;
  border: 1px solid #d08f2c;
}

/* Quantity Area Style
============================================*/
.product-quantity {
  border: 1px solid #E2E8F0;
  border-radius: 4px;
  display: inline-block;
}

.product-quantity.bg-e2e8f0 {
  background-color: #e2e8f0;
}

.product-quantity.bg-e2e8f0 .add-to-cart-counter input {
  background-color: #e2e8f0;
}

.product-quantity.bg-e2e8f0 .add-to-cart-counter .minusBtn,
.product-quantity.bg-e2e8f0 .add-to-cart-counter .plusBtn {
  background-color: #fff;
}

.product-quantity .add-to-cart-counter {
  display: flex;
  padding: 5px;
}

.product-quantity .add-to-cart-counter input {
  background-color: #fff;
  border: 1px solid #E2E8F0;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #5B5B98;
  border-radius: 4px;
  height: 36px;
  padding: 0;
  border-radius: 0;
}

.product-quantity .add-to-cart-counter input:focus {
  border-color: #d08f2c;
  outline: none;
}

.product-quantity .add-to-cart-counter .minusBtn,
.product-quantity .add-to-cart-counter .plusBtn {
  background-color: #E2E8F0;
  width: 36px;
  height: 36px;
  line-height: 30px;
  border-radius: 4px;
  transition: all ease 0.5s;
  font-family: "remixicon" !important;
  padding: 0;
  border: 0;
  color: #5B5B98;
}

.product-quantity .add-to-cart-counter .minusBtn:hover,
.product-quantity .add-to-cart-counter .plusBtn:hover {
  background-color: #d08f2c;
  color: #fff;
  border-color: #d08f2c;
}

.for-light-logo {
  display: block;
}

.for-dark-logo {
  display: none;
}

.upcoming-events-slide {
  direction: ltr;
}

.upcoming-events-slide .swiper-pagination {
  position: initial;
  text-align: left;
}

.upcoming-events-slide .swiper-pagination .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
}

.upcoming-events-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: #d08f2c;
}

.card.bg-primary.border-0.rounded-3.position-relative.mb-4 .form-select {
  color: #fff !important;
}

.email-sidebar-nav li a:hover,
.email-sidebar-nav li a.active {
  color: #d08f2c;
}

.fm-sidebar-nav li a:hover,
.fm-sidebar-nav li a.active {
  color: #d08f2c;
}

.products-list-tabs li .nav-link {
  font-size: 16px;
  font-weight: 500;
  border: none !important;
  border-radius: 7px;
  background-color: #f6f7f9;
  padding: 10px 30px;
  color: #3A4252;
  text-transform: capitalize;
}

.products-list-tabs li .nav-link.active {
  background-color: #d08f2c;
  color: #fff;
}

.react-select__control {
  min-height: 60px !important;
}

.main-content:has(div.auth-main-content) {
  padding: 0;
}

.main-content:has(div.fp-wrapper) {
  padding: 0;
}

.main-content:has(div.not-found-content) {
  padding: 0;
}

.cryptocurrency-slider .swiper-pagination {
  bottom: 0;
}

.cryptocurrency-slider .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: #d08f2c;
}

.recent-property-slide .swiper-pagination {
  position: initial;
  line-height: 1;
  margin-top: 10px;
}

.recent-property-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: #d08f2c;
}

.date-time-picker-demo .react-datetime-picker__wrapper {
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 4px 10px;
  background: #f5f5f5;
}

.date-time-picker-demo .react-datetime-picker__wrapper .react-datetime-picker__inputGroup {
  font-size: 13px;
}

.date-time-picker-demo .react-datetime-picker__wrapper .react-datetime-picker__button {
  padding: 0;
  margin-left: 5px;
}

.date-time-picker-demo .react-datetime-picker__wrapper .react-datetime-picker__button svg {
  display: inherit;
  width: 15px;
}

.date-time-picker-demo .react-calendar {
  border: 1px solid #ECEEF2;
  padding: 10px;
}

.custom-modal {
  background-color: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  transition: all ease 0.5s;
}

.custom-modal .close-link {
  cursor: pointer;
  line-height: 1;
}

.custom-modal .custom-modal-content {
  width: 400px;
  height: 100%;
  background-color: #F6F7F9;
  overflow-y: auto;
}

.custom-modal .custom-modal-header {
  background-color: #F6F7F9;
}

.custom-modal.right {
  right: -100%;
  left: auto;
}

.custom-modal.right.show {
  right: 0;
  left: 0;
}

.custom-modal.right .custom-modal-content {
  margin-left: auto;
}

.custom-modal.left {
  left: -100%;
  right: auto;
}

.custom-modal.left.show {
  right: 0;
  left: 0;
}

.custom-modal.center {
  transform: scale(0);
  padding: 20px;
}

.custom-modal.center.show {
  transform: scale(1);
}

.custom-modal.center .custom-modal-content {
  width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.custom-modal .close-outside {
  position: absolute;
  left: 0;
  top: 0;
  cursor: ne-resize;
  width: 100%;
  height: 100%;
}

/* Marketing Dashboard CSS */
.avatar-upload {
  position: relative;
  max-width: 135px;
}

.avatar-upload .avatar-edit {
  position: absolute;
  right: -17px;
  bottom: -17px;
  z-index: 1;
}

.avatar-upload .avatar-edit input {
  display: none;
}

.avatar-upload .avatar-edit input+label {
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  margin-bottom: 0;
  border-radius: 100%;
  background: #FFFFFF;
  border: 1px solid transparent;
  box-shadow: 0px 4px 34px 0px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  font-weight: normal;
  transition: all ease 0.5s;
  font-size: 20px;
}

.avatar-upload .avatar-edit input+label:after {
  content: "\\ea13";
  font-family: remixicon !important;
  color: #757575;
  position: absolute;
  top: 0;
  left: 1px;
  right: 0;
  text-align: center;
  margin: auto;
}

.avatar-upload .avatar-preview {
  width: 135px;
  height: 135px;
  position: relative;
  border-radius: 4px;
  border: 6px solid #F8F8F8;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
}

.avatar-upload .avatar-preview>div {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.dark .avatar-upload .avatar-preview {
  border: 6px solid #2f2f2f;
}

/* File Upload Area Style
============================================*/
.only-file-upload .form__file {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  cursor: pointer;
  opacity: 0;
}

.only-file-upload .form__files-container {
  display: flex;
  width: 100%;
  padding: 5px 0;
  justify-content: space-between;
  align-items: center;
  background-color: #ECEEF2;
  padding: 10px;
  margin-top: 10px;
  border-radius: 6px;
}

.only-file-upload .form__text {
  font-size: 14px;
  color: #3A4252;
  max-width: 450px;
  whitespace: no-wrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.only-file-upload .form__icon {
  font-size: 22px;
  color: #d08f2c;
  text-decoration: none;
  background-color: rgba(31, 100, 241, 0.1);
  width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  border-radius: 4px;
  display: inline-block;
}

.only-file-upload .form__icon:hover {
  background-color: #d08f2c;
  color: #fff;
}

/* Card Body Custom Padding Area Style
============================================*/
.custom-padding-30 {
  padding: 30px;
}

.custom-shadow {
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.05);
}

.upcoming-events-slide-two .swiper-pagination {
  position: initial;
  line-height: 1;
  bottom: 0;
}

.upcoming-events-slide-two .swiper-pagination .swiper-pagination-bullet {
  background-color: #d08f2c;
  border-radius: 50px;
  transition: all ease 0.5s;
  height: 4px;
}

.upcoming-events-slide-two .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: 24px;
}

.fw-800 {
  font-weight: 800;
}

.fw-900 {
  font-weight: 900;
}

.last-child-none .child:last-child {
  border-bottom: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
}

.school-nb {
  padding-left: 30px;
  padding-right: 30px;
  margin-bottom: 17.5px;
  padding-bottom: 17.5px;
}

.school-nb:last-child {
  padding-bottom: 0;
  border-bottom: none !important;
}

.bg-ecf0ff {
  background-color: #ecf0ff;
}

.bg-faf5ff {
  background-color: #faf5ff;
}

.bg-fff5ed {
  background-color: #fff5ed;
}

.cco-tab-btn {
  cursor: pointer;
}

.cco-tab-btn img.hidden {
  display: none;
}

.cco-tab-btn.active img {
  display: none;
}

.cco-tab-btn.active img.hidden {
  display: block;
}

.cco-tab-btn.active .text-body,
.cco-tab-btn.active .text-secondary,
.cco-tab-btn.active .text-black,
.cco-tab-btn.active .text-success,
.cco-tab-btn.active .text-danger-50 {
  color: #fff !important;
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .p-4 {
    padding: 15px !important;
  }

  .fs-16 {
    font-size: 15px;
  }

  .fs-20 {
    font-size: 18px;
  }

  .fs-24 {
    font-size: 20px;
  }

  .fs-28 {
    font-size: 21px;
  }

  .file-upload {
    font-size: 13px !important;
  }

  .wh-160 {
    width: 110px;
    height: 110px;
  }

  .mw-123 {
    max-width: 43px;
  }

  .custom-padding-30 {
    padding: 20px;
  }

  .custom-modal .custom-modal-content {
    width: 320px;
  }

  .custom-modal.center .custom-modal-content {
    width: 320px;
  }
}

@media only screen and (min-width: 576px) and (max-width: 767px) {
  .mw-123 {
    max-width: 120px;
  }
}

/* Min width 768px to Max width 992px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .p-4 {
    padding: 20px !important;
  }

  .fs-28 {
    font-size: 24px;
  }
}

/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .mw-123 {
    max-width: 98px;
  }

  .custom-p1 {
    padding-right: 12px !important;
  }

  .custom-p2 {
    padding-left: 12px !important;
  }

  .custom-p2 .card {
    border-radius: 0 0 8px 8px !important;
  }

  .custom-p2 .rounded-start-0 {
    border: none !important;
    border-top: 1px solid #ECEEF2 !important;
  }
}

/* Min width 1200px to Max width 1399px */
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .p-4 {
    padding: 20px !important;
  }

  .pb-y-0 {
    padding-bottom: 0 !important;
  }

  .py-38 {
    padding-top: 34px !important;
    padding-bottom: 34px !important;
  }

  .mw-123 {
    max-width: 90px;
  }

  .custom-p1 {
    padding-right: 12px !important;
  }

  .custom-p2 {
    padding-left: 12px !important;
  }

  .custom-p2 .card {
    border-radius: 0 0 8px 8px !important;
  }

  .custom-p2 .rounded-start-0 {
    border: none !important;
    border-top: 1px solid #ECEEF2 !important;
  }
}

/* Min width 1400px to Max width 1799px */
@media only screen and (min-width: 1400px) and (max-width: 1799px) {
  .py-38 {
    padding-top: 30px !important;
    padding-bottom: 30px !important;
  }
}

@media only screen and (min-width: 992px) {
  .mb-lg-30 {
    margin-bottom: 30px !important;
  }

  .h-md-100 {
    height: 100%;
  }
}

@media only screen and (min-width: 768px) {
  .h-md-100 {
    height: 100%;
  }
}

@media only screen and (min-width: 1600px) {
  .employee-attendance-list li {
    position: relative;
  }

  .employee-attendance-list li::before {
    content: "";
    position: absolute;
    top: 0;
    left: -50%;
    transform: translateX(-50%);
    width: 0.5px;
    height: 100%;
    background-color: #ECEEF2;
  }

  .employee-attendance-list li:first-child::before {
    display: none;
  }
}

@media only screen and (min-width: 1920px) {
  .custom-xxxl-10 {
    flex: 0 0 auto;
    width: 77%;
  }

  .custom-xxxl-2 {
    flex: 0 0 auto;
    width: 23%;
  }
}

.c-dropdown::after {
  display: none;
}

.select-dropdown .dropdown-toggle {
  padding: 6.5px 14px;
  position: relative;
}

.select-dropdown .dropdown-toggle i {
  font-size: 18px;
  line-height: 1;
  position: relative;
  top: 2px;
}

.select-dropdown .dropdown-toggle::after {
  display: none;
}

.select-dropdown .dropdown-item:active {
  color: #fff !important;
}

.select-dropdown.without-border .dropdown-toggle {
  padding: 0;
  border: 0 !important;
}

.select-dropdown.without-border .dropdown-toggle::after {
  right: 0;
}

.categories-tabs .nav-item .nav-link {
  border-color: #ECEEF2;
}

.categories-tabs .nav-item .nav-link.active {
  border-color: #d08f2c;
}

.categories-tabs .nav-item .nav-link.active span .d-none {
  display: inline-block !important;
}

.payment-method .btn-check:checked+.btn,
.payment-method :not(.btn-check)+.btn:active,
.payment-method .btn:first-child:active,
.payment-method .btn.active,
.payment-method .btn.show {
  border-color: #d08f2c !important;
  background-color: #ECF0FF !important;
}

/* Follow Button Style
============================================*/
.follow-button .followed {
  transition: all ease 0.5s;
}

.follow-button.followed {
  background-color: #d08f2c !important;
  color: #fff !important;
}

/* Audio player Style
============================================*/
.most-popular-tabs {
  margin-bottom: 20px;
}

.most-popular-tabs .nav-item .nav-link {
  padding: 3.5px 12px;
}

.most-popular-tabs .nav-item .nav-link.active {
  background-color: #d08f2c !important;
  color: #fff !important;
}

.single-play .audio-play-btn {
  opacity: 0;
  transition: all ease 0.5s;
}

.single-play:hover .audio-play-btn {
  opacity: 1;
}

.single-play.active .audio-play-btn {
  opacity: 1;
}

.doctor-cover-bg {
  position: relative;
  z-index: 0;
}

.doctor-cover-bg::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 90px;
  background-color: #fff;
  z-index: -1;
}

.doctor-cover-bg .avatar-upload .avatar-edit input+label:after {
  display: none;
}

.wave-container .wave-bar {
  width: 2px;
  height: 25px;
  background-color: #C2CDFF;
  margin-left: 2px;
  animation: wave-animation 1s infinite ease-in-out;
  animation-play-state: paused;
}

.wave-container .wave-bar:nth-child(odd) {
  animation-delay: 0.2s;
}

.wave-container .wave-bar:nth-child(even) {
  animation-delay: 0.4s;
}

@keyframes wave-animation {

  0%,
  100% {
    transform: scaleY(1);
  }

  50% {
    transform: scaleY(2);
  }
}

.audio-player-for-wave .ri-pause-fill {
  left: 0 !important;
}

.mastering-digital-marketing-slide .swiper-pagination {
  text-align: right;
  position: absolute;
  top: 0 !important;
  right: 0 !important;
  display: block;
  padding: 20px 30px;
  z-index: 0;
  height: 30px;
  z-index: 9;
}

.mastering-digital-marketing-slide .swiper-pagination .swiper-pagination-bullet {
  background-color: #8695AA;
  width: 10px;
  height: 3px;
  border-radius: 4px;
  transition: all ease 0.5s;
  opacity: 1;
}

.mastering-digital-marketing-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: #ECEEF2;
  width: 30px;
}

.call-overview-tabs .calls-card.bg-primary.active {
  background-color: #d08f2c !important;
}

.call-overview-tabs .calls-card.bg-primary.active .text-body.d-block {
  color: #ECEEF2 !important;
}

.call-overview-tabs .calls-card.bg-primary.active h3.text-secondary,
.call-overview-tabs .calls-card.bg-primary.active .text-secondary.h3 {
  color: #fff !important;
}

.call-overview-tabs .calls-card.bg-primary.active span.d-flex.align-items-center.align-items-center.text-body {
  color: #fff !important;
}

.call-overview-tabs .calls-card.bg-primary.active span.d-flex.align-items-center.align-items-center.text-body span {
  color: #fff !important;
}

.call-overview-tabs .calls-card.bg-primary.active span.d-flex.align-items-center.align-items-center.text-body .material-symbols-outlined {
  color: #fff !important;
}

.call-overview-tabs .calls-card.bg-primary.active img {
  filter: brightness(100);
}

.call-overview-tabs .calls-card.bg-primary-divs.active {
  background-color: #b27c26 !important;
}

.call-overview-tabs .calls-card.bg-primary-divs.active .text-body.d-block {
  color: #ECEEF2 !important;
}

.call-overview-tabs .calls-card.bg-primary-divs.active h3.text-secondary,
.call-overview-tabs .calls-card.bg-primary-divs.active .text-secondary.h3 {
  color: #fff !important;
}

.call-overview-tabs .calls-card.bg-primary-divs.active span.d-flex.align-items-center.align-items-center.text-body {
  color: #fff !important;
}

.call-overview-tabs .calls-card.bg-primary-divs.active span.d-flex.align-items-center.align-items-center.text-body span {
  color: #fff !important;
}

.call-overview-tabs .calls-card.bg-primary-divs.active span.d-flex.align-items-center.align-items-center.text-body .material-symbols-outlined {
  color: #fff !important;
}

.call-overview-tabs .calls-card.bg-primary-divs.active img {
  filter: brightness(100);
}

.call-overview-tabs .calls-card.bg-dangers.active {
  background-color: #EE3E08 !important;
}

.call-overview-tabs .calls-card.bg-dangers.active .text-body.d-block {
  color: #ECEEF2 !important;
}

.call-overview-tabs .calls-card.bg-dangers.active h3.text-secondary,
.call-overview-tabs .calls-card.bg-dangers.active .text-secondary.h3 {
  color: #fff !important;
}

.call-overview-tabs .calls-card.bg-dangers.active span.d-flex.align-items-center.align-items-center.text-body {
  color: #fff !important;
}

.call-overview-tabs .calls-card.bg-dangers.active span.d-flex.align-items-center.align-items-center.text-body span {
  color: #fff !important;
}

.call-overview-tabs .calls-card.bg-dangers.active span.d-flex.align-items-center.align-items-center.text-body .material-symbols-outlined {
  color: #fff !important;
}

.call-overview-tabs .calls-card.bg-dangers.active img {
  filter: brightness(100);
}

.search-overlay {
  display: none;
}

.search-overlay .form-control {
  font-size: 12px;
  height: 40px;
}

.search-overlay .form-control::placeholder {
  font-size: 12px;
}

.close-btn {
  display: none !important;
}

.close-btn.active {
  display: block !important;
  background-color: #FD5812 !important;
  color: #fff !important;
}

.recently-played .table-responsive .table tbody tr td {
  border-color: #F6F7F9;
  padding: 12px 12px !important;
}

.recently-played .table-responsive .table tbody tr:last-child td {
  border: none;
}

.popular-hosts .table-responsive .table tbody tr td {
  border-color: #F6F7F9;
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.popular-hosts .table-responsive .table tbody tr:last-child td {
  border: none;
}

.top-podcasts .table-responsive .table thead tr th {
  padding-left: 18px;
  padding-right: 18px;
}

.top-podcasts .table-responsive .table tbody tr td {
  border-color: #F6F7F9;
  padding-left: 18px;
  padding-right: 18px;
}

.top-podcasts .table-responsive .table tbody tr:last-child td {
  border: none;
}

.light-mode-btn i {
  color: #FE7A36 !important;
}

.light-mode-btn .dark_mode {
  display: none;
}

.dark .light_mode {
  display: none;
}

.dark .dark_mode {
  display: block;
}

.apexcharts-tooltip-marker {
  line-height: 13px !important;
}

.apexcharts-tooltip-marker::before {
  font-size: 12px !important;
}

@media only screen and (max-width: 767px) {
  .recently-played .table-responsive .table {
    width: 770px;
  }

  .top-podcasts .table-responsive .table {
    width: 745px;
  }
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .recently-played .table-responsive .table {
    width: 860px;
  }
}

@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .recently-played .table-responsive .table {
    width: 860px;
  }
}

.-right-10 {
  right: -10px;
}

[dir=rtl] .-right-10 {
  right: auto;
  left: -10px;
}

.text-000 {
  color: #000 !important;
}

.-mr-10 {
  margin-right: -10px;
}

.bsts-products-slide .swiper-button-prev,
.bsts-products-slide .swiper-button-next {
  background-color: #d08f2c;
  color: #fff;
  width: 30px;
  height: 30px;
  border-radius: 100%;
}

.bsts-products-slide .swiper-button-prev::after,
.bsts-products-slide .swiper-button-next::after {
  font-size: 18px;
}

.bsts-products-slide .swiper-button-prev.swiper-button-disabled,
.bsts-products-slide .swiper-button-next.swiper-button-disabled {
  cursor: auto;
  pointer-events: auto;
}

.ra-calendar .react-calendar__month-view__days .react-calendar__tile {
  background-color: #E6EFF2;
  border-radius: 10px;
  border: 2px solid #fff;
  height: 50px;
}

.dark .ra-calendar .react-calendar__month-view__days .react-calendar__tile {
  background-color: #000;
  border: 2px solid #333;
}

.bs-rs-appointments {
  padding-left: 11px;
  padding-right: 5px;
}

.bs-rs-appointments .bs-rs-appointments-list {
  border-left: 1px dashed #D5D9E2;
  padding-left: 37px;
}

.bs-rs-appointments .bs-rs-appointments-list .verifyIcon {
  left: -37px !important;
}

[dir=rtl] .bs-rs-appointments {
  padding-left: 5px;
  padding-right: 11px;
}

[dir=rtl] .bs-rs-appointments .bs-rs-appointments-list {
  padding-left: 0;
  padding-right: 37px;
  border-left: none;
  border-right: 1px dashed #D5D9E2;
}

[dir=rtl] .bs-rs-appointments .bs-rs-appointments-list .verifyIcon {
  left: auto !important;
  right: -60px !important;
}

@media only screen and (max-width: 767px) {
  .default-table-area.campaigns-table.style-two.bs-top-customers .table-responsive .table {
    width: 940px !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .default-table-area.campaigns-table.style-two.bs-top-customers .table-responsive .table {
    width: 940px !important;
  }
}

.pr-5 {
  padding-right: 5px;
}

.doctor-welcome-card {
  padding-left: 105px;
  padding-right: 80px;
}

.doctor-main-wrapper {
  padding-left: 80px;
  padding-right: 80px;
}

.pd-text-content h1,
.pd-text-content .h1 {
  font-size: 20px;
}

.pd-text-content h2,
.pd-text-content .h2 {
  font-size: 19px;
}

.pd-text-content h3,
.pd-text-content .h3 {
  font-size: 18px;
}

.pd-text-content h4,
.pd-text-content .h4 {
  font-size: 17px;
}

.pd-text-content h5,
.pd-text-content .h5 {
  font-size: 16px;
}

.pd-text-content h6,
.pd-text-content .h6 {
  font-size: 15px;
}

.pd-text-content ul,
.pd-text-content ol {
  margin-bottom: 0;
  margin-top: 15px;
  padding-left: 17px;
}

.pd-text-content ul li,
.pd-text-content ol li {
  line-height: 1.8;
  margin-bottom: 5px;
}

.pd-text-content ul li::marker,
.pd-text-content ol li::marker {
  color: #d08f2c;
  font-size: 18px;
}

.pd-text-content ul li:last-child,
.pd-text-content ol li:last-child {
  margin-bottom: 0;
}

.-po-left-26 {
  left: -26px !important;
}

.recent-appointment-notify {
  border-left: 1px dashed #D5D9E2;
  padding-left: 26px;
}

.dark .doctor-cover-bg::before {
  background-color: #000;
}

[dir=rtl] .pr-5 {
  padding-right: 0;
  padding-left: 5px;
}

[dir=rtl] .pd-text-content ul,
[dir=rtl] .pd-text-content ol {
  padding-left: 0;
  padding-right: 17px;
}

[dir=rtl] .-po-left-26 {
  left: 0 !important;
  right: -50px !important;
}

[dir=rtl] .recent-appointment-notify {
  border-left: none;
  border-right: 1px dashed #D5D9E2;
  padding-left: 0;
  padding-right: 26px;
}

@media only screen and (min-width: 992px) {
  .default-table-area.campaigns-table.latest-transaction-table.doctor-patients-table .table-responsive .table {
    width: 100% !important;
  }
}

@media only screen and (max-width: 1199px) {
  .doctor-welcome-card {
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .doctor-main-wrapper {
    padding-left: 0;
    padding-right: 0;
    margin-top: 25px !important;
  }
}

@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .doctor-welcome-card {
    padding-left: 50px;
    padding-right: 50px;
  }

  .doctor-main-wrapper {
    padding-left: 0;
    padding-right: 0;
    margin-top: 25px !important;
  }
}

@media only screen and (min-width: 1400px) and (max-width: 1599px) {
  .doctor-welcome-card {
    padding-left: 50px;
    padding-right: 50px;
  }

  .doctor-main-wrapper {
    padding-left: 30px;
    padding-right: 30px;
  }
}

.p-25 {
  padding: 25px;
}

.mt-10 {
  margin-top: 10px;
}

.gad-bg {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
}

.default-table-area.upcoming-vip-reservations-table.style-two .table-responsive .table thead tr th {
  padding-bottom: 9px;
  padding-left: 21px;
  padding-right: 21px;
}

.default-table-area.upcoming-vip-reservations-table.style-two .table-responsive .table thead tr th:first-child {
  padding-left: 0 !important;
}

.default-table-area.upcoming-vip-reservations-table.style-two .table-responsive .table thead tr th:last-child {
  padding-right: 0 !important;
}

.default-table-area.upcoming-vip-reservations-table.style-two .table-responsive .table tbody tr td {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 21px;
  padding-right: 21px;
}

.default-table-area.upcoming-vip-reservations-table.style-two .table-responsive .table tbody tr td:first-child {
  padding-left: 0 !important;
}

.default-table-area.upcoming-vip-reservations-table.style-two .table-responsive .table tbody tr td:last-child {
  padding-right: 0 !important;
}

.popular-rooms-slide .swiper-pagination {
  position: initial;
  margin-top: 10px;
}

.popular-rooms-slide .swiper-pagination .swiper-pagination-bullet {
  border-radius: 30px;
  height: 5px;
}

.popular-rooms-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: 20px;
  background-color: #d08f2c;
}

@media only screen and (max-width: 767px) {
  .default-table-area.upcoming-vip-reservations-table.style-two .table-responsive .table {
    width: 693px !important;
  }
}

@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .default-table-area.upcoming-vip-reservations-table.style-two .table-responsive .table tbody tr td {
    padding-left: 13px;
    padding-right: 13px;
  }

  .default-table-area.upcoming-vip-reservations-table.style-two .table-responsive .table tbody tr td .fs-14 {
    font-size: 12px !important;
  }
}

.welcome-real-estate-agent {
  padding: 10px 25px 70px;
  padding-left: 75px;
  padding-right: 75px;
}

.welcome-card-wrap {
  margin-top: -90px;
}

.my-featured-listings-slide .swiper-pagination {
  position: initial;
  margin-top: 10px;
}

.my-featured-listings-slide .swiper-pagination .swiper-pagination-bullet {
  border-radius: 30px;
  height: 5px;
}

.my-featured-listings-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: 20px;
  background-color: #d08f2c;
}

.rea-app-btn {
  padding: 7px 17.5px;
  margin-bottom: 31px;
  display: inline-block;
  border-radius: 0.375rem;
  color: #fff !important;
  background-color: #1a5710;
  font-size: 16px;
  text-decoration: none;
}

.rea-app-btn:hover {
  background-color: #25b003;
  color: #fff;
}

.rea-client-ratings-slide .swiper-pagination {
  position: initial;
  margin-top: 10px;
}

.rea-client-ratings-slide .swiper-pagination .swiper-pagination-bullet {
  border-radius: 30px;
  height: 5px;
}

.rea-client-ratings-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: 20px;
  background-color: #d08f2c;
}

@media only screen and (max-width: 767px) {
  .welcome-real-estate-agent {
    padding: 0 0 70px;
    text-align: center;
  }

  .welcome-real-estate-agent .fs-32 {
    font-size: 25px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .welcome-real-estate-agent {
    text-align: center;
  }
}

@media only screen and (max-width: 767px) {
  .cc-recent-transactions .table {
    width: 767px;
  }
}

.default-table-area.ct-gainers-losers.style-two .table-responsive .table tbody tr td {
  padding-top: 11px;
  padding-bottom: 11px;
}

@media only screen and (max-width: 767px) {
  .default-table-area.ct-recent-transactions2.style-two .table-responsive .table {
    width: 767px;
  }
}

.default-table-area.cp-transactions-history.style-two .table-responsive .table tbody tr td {
  padding-top: 12.5px;
  padding-bottom: 12.5px;
}

@media only screen and (max-width: 767px) {
  .default-table-area.cp-individual-asset-performance.style-two .table-responsive .table {
    width: 800px;
  }

  .default-table-area.cp-individual-asset-performance.style-two .table-responsive .table thead tr th {
    font-size: 13px;
  }

  .default-table-area.cp-individual-asset-performance.style-two .table-responsive .table tbody tr td {
    font-size: 13px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .default-table-area.cp-individual-asset-performance.style-two .table-responsive .table thead tr th {
    font-size: 13px;
  }

  .default-table-area.cp-individual-asset-performance.style-two .table-responsive .table tbody tr td {
    font-size: 13px;
  }
}

/** Sidebar Menu Area
===================================**/
.sidebar-area {
  position: fixed;
  top: 0;
  left: 0;
  width: 270px;
  height: 100%;
  transition: all ease 0.5s;
  padding-bottom: 30px;
  background-color: #fff;
}

.sidebar-area .logo {
  padding: 21.5px 25px;
  border-bottom: 1px solid #ECF0FF;
}

.sidebar-area .logo .logo-text {
  font-size: 24px;
  position: absolute;
  top: -4px;
  left: 33px;
  transition: all ease 0.5s;
  font-weight: 700;
}

.sidebar-area.dark .logo {
  border-color: #262626 !important;
}

.sidebar-area .sidebar-burger-menu {
  transition: all ease 0.5s;
  right: 21px !important;
}

.sidebar-menu {
  padding-top: 20px;
  padding-left: 25px;
  padding-right: 25px;
  padding-bottom: 60px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  /* width */
  /* Track */
  /* Handle */
  /* Handle on hover */
}

.sidebar-menu::-webkit-scrollbar {
  width: 5px;
}

.sidebar-menu::-webkit-scrollbar-track {
  background: #fff;
}

.sidebar-menu::-webkit-scrollbar-thumb {
  background: #c5c5c5;
}

.sidebar-menu::-webkit-scrollbar-thumb:hover {
  background: #888;
}

.sidebar-menu .accordion {
  border: none;
  background-color: transparent;
}

.sidebar-menu .accordion .accordion-item {
  border: none;
  background-color: transparent;
  margin-bottom: 3px;
}

.sidebar-menu .accordion .accordion-item .accordion-header .accordion-button {
  background-color: transparent;
  border-radius: 5px;
  border: none;
  box-shadow: none;
  font-weight: 500;
  padding: 9.5px 13px;
  display: flex;
  white-space: nowrap;
  transition: all ease 0.5s;
}

.sidebar-menu .accordion .accordion-item .accordion-header .accordion-button::after {
  width: 15px;
  height: 15px;
  background-size: contain;
}

.sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .material-symbols-outlined {
  margin-right: 8px;
  font-size: 21px;
  color: #fff;
}

.sidebar-menu .accordion .accordion-item .accordion-header .accordion-button:hover {
  background-color: #F6F7F9;
}

.sidebar-menu .accordion .accordion-item .accordion-header .accordion-button:hover .material-symbols-outlined {
  color: #3A4252;
}

.sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .title {
  color: #3A4252;
}

.sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .count {
  background-color: #FFF5ED;
  color: #FD5812;
  border-radius: 50px;
  color: #FD5812;
  font-size: 11px;
  font-weight: 600;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  position: absolute;
  top: 50%;
  right: 42px;
  transform: translateY(-50%);
}

.sidebar-menu .accordion .accordion-item .accordion-header .accordion-button[aria-expanded=true] {
  background-color: #F6F7F9;
}

.sidebar-menu .accordion .accordion-item .accordion-collapse .accordion-body {
  padding: 0;
}

.sidebar-menu .menu-item {
  list-style-type: none;
  margin-bottom: 5px;
}

.sidebar-menu .menu-item .menu-link {
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  color: #3A4252;
  padding: 9.5px 12px;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

.sidebar-menu .menu-item .menu-link .title {
  transition: all ease 0.5s;
}

.sidebar-menu .menu-item .menu-link .tag {
  background-color: #FFE8D4;
  width: 28px;
  height: 16px;
  font-size: 10px;
  color: #FD5812;
  display: inline-block;
  text-align: center;
  border-radius: 2px;
  position: relative;
  margin-left: 8px;
}

.sidebar-menu .menu-item .menu-link .tag::before {
  content: "";
  position: absolute;
  top: 4px;
  left: -3px;
  width: 8px;
  height: 8px;
  background-color: #FFE8D4;
  border-radius: 1px;
  transform: rotate(45deg);
  z-index: -1;
}

.sidebar-menu .menu-item .menu-link .tag.new {
  background-color: #D8FFC8;
  color: #37D80A;
}

.sidebar-menu .menu-item .menu-link .tag.new::before {
  background-color: #D8FFC8;
}

.sidebar-menu .menu-item .menu-link .material-symbols-outlined {
  margin-right: 8px;
  font-size: 21px;
  color: #fff;
}

.sidebar-menu .menu-item .menu-link.logout {
  background-color: #f5f5f9;
}

.sidebar-menu .menu-item .menu-link.active,
.sidebar-menu .menu-item .menu-link:hover {
  background-color: #f5f5f9;
  color: #d08f2c;
}

.sidebar-menu .menu-item .menu-link.active .material-symbols-outlined,
.sidebar-menu .menu-item .menu-link:hover .material-symbols-outlined {
  color: #d08f2c;
}

.sidebar-menu .menu-item .menu-link.active::before,
.sidebar-menu .menu-item .menu-link:hover::before {
  opacity: 1;
  border-color: #d08f2c;
}

.sidebar-menu .menu-item .menu-link.active::after,
.sidebar-menu .menu-item .menu-link:hover::after {
  border-color: #fff;
}

.sidebar-menu .sub-menu {
  padding: 0;
  margin-top: 4px;
  margin-bottom: 0;
}

.sidebar-menu .sub-menu .menu-item {
  margin-bottom: 4px;
}

.sidebar-menu .sub-menu .menu-item .menu-link {
  padding: 9.5px 18px;
  padding-left: 38px;
  transition: all ease 0.5s;
  position: relative;
  font-size: 14px;
  color: #fff;
  display: flex;
  white-space: nowrap;
}

.sidebar-menu .sub-menu .menu-item .menu-link::before {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 10px;
  height: 10px;
  border: 1px solid #fff;
  left: 18px;
  border-radius: 50px;
  transition: all ease 0.5s;
}

.sidebar-menu .sub-menu .menu-item .menu-link.active,
.sidebar-menu .sub-menu .menu-item .menu-link:hover {
  background-color: #ECF0FF;
  color: #d08f2c;
}

.sidebar-menu .sub-menu .menu-item .menu-link.active::before,
.sidebar-menu .sub-menu .menu-item .menu-link:hover::before {
  opacity: 1;
  border-color: #d08f2c;
}

.sidebar-menu .sub-menu .menu-item .menu-link.active::after,
.sidebar-menu .sub-menu .menu-item .menu-link:hover::after {
  border-color: #fff;
}

.sidebar-menu .menu-title {
  position: relative;
  display: block;
  z-index: 1;
  margin-top: 12px;
}

.sidebar-menu .menu-title .menu-title-text {
  font-size: 12px;
  font-weight: 500;
  color: #fff;
  display: block;
  margin-bottom: 7px;
}

.sidebar-menu .menu-title:first-child {
  margin-top: 0;
}

@media only screen and (min-width: 1200px) {
  .main-wrapper-content.active .sidebar-area {
    width: 80px;
    z-index: 2;
    transition: all ease 0.5s;
  }

  .main-wrapper-content.active .sidebar-area .logo {
    padding-left: 25px;
    padding-right: 25px;
  }

  .main-wrapper-content.active .sidebar-area .logo .logo-text {
    left: 0;
    opacity: 0;
    visibility: hidden;
  }

  .main-wrapper-content.active .sidebar-area .sidebar-menu {
    padding: 17px;
    padding-bottom: 60px;
  }

  .main-wrapper-content.active .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button {
    padding: 10px;
  }

  .main-wrapper-content.active .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button::after {
    display: none;
  }

  .main-wrapper-content.active .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .material-symbols-outlined {
    margin-right: 0;
  }

  .main-wrapper-content.active .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .title {
    display: none;
  }

  .main-wrapper-content.active .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .count {
    display: none;
  }

  .main-wrapper-content.active .sidebar-area .sidebar-menu .menu-item .menu-link .title {
    display: none;
  }

  .main-wrapper-content.active .sidebar-area .sidebar-menu .menu-header {
    display: none;
  }

  .main-wrapper-content.active .sidebar-area .sidebar-menu .sub-menu {
    display: none;
  }

  .main-wrapper-content.active .sidebar-area .sidebar-menu .menu-title {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .main-wrapper-content.active .sidebar-area .sidebar-menu .menu-title .menu-title-text {
    margin-bottom: 0;
    font-size: 0;
    position: relative;
    transition: all ease 0.5s;
  }

  .main-wrapper-content.active .sidebar-area .sidebar-menu .menu-title .menu-title-text::before {
    top: 50%;
    width: 50px;
    content: "";
    height: 1px;
    position: absolute;
    transform: translateY(-50%);
    background: #ECEEF2;
  }

  .main-wrapper-content.active .sidebar-area:hover {
    width: 270px;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  }

  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .menu-header {
    display: block;
  }

  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button {
    padding: 10px;
  }

  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button::after {
    display: block;
  }

  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .material-symbols-outlined {
    margin-right: 8px;
  }

  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .title {
    display: block;
  }

  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .count {
    display: block;
  }

  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .sub-menu {
    display: block;
  }

  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .sub-menu .menu-item .menu-link {
    padding-left: 35px;
  }

  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .menu-item .menu-link .title {
    display: block;
  }

  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .menu-title {
    margin-top: 12px;
    margin-bottom: 0;
  }

  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .menu-title .menu-title-text {
    margin-bottom: 7px;
    font-size: 12px;
  }

  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .menu-title .menu-title-text::before {
    display: none;
  }

  .main-wrapper-content.active .sidebar-area:hover .logo .logo-text {
    left: 33px;
    opacity: 1;
    visibility: visible;
  }

  .main-wrapper-content.active .sidebar-area:hover .sidebar-burger-menu {
    opacity: 1 !important;
    z-index: 1 !important;
    right: 21px !important;
  }

  .main-wrapper-content.compact-sidebar .main-content {
    padding-left: 92px;
  }

  .main-wrapper-content.compact-sidebar .main-content .header-area .left-header-content ul li.hbm {
    display: none !important;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area {
    width: 80px;
    z-index: 2;
    transition: all ease 0.5s;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-burger-menu {
    display: none !important;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area .logo {
    padding-left: 25px;
    padding-right: 25px;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area .logo .logo-text {
    left: 0;
    opacity: 0;
    visibility: hidden;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu {
    padding: 17px;
    padding-bottom: 60px;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button {
    padding: 10px;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button::after {
    display: none;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .material-symbols-outlined {
    margin-right: 0;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .title {
    display: none;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .count {
    display: none;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .menu-item .menu-link .title {
    display: none;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .menu-header {
    display: none;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .sub-menu {
    display: none;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .menu-title {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .menu-title .menu-title-text {
    margin-bottom: 0;
    font-size: 0;
    position: relative;
    transition: all ease 0.5s;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .menu-title .menu-title-text::before {
    top: 50%;
    width: 50px;
    content: "";
    height: 1px;
    position: absolute;
    transform: translateY(-50%);
    background: #ECEEF2;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area:hover {
    width: 270px;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .menu-header {
    display: block;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button {
    padding: 10px;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button::after {
    display: block;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .material-symbols-outlined {
    margin-right: 8px;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .title {
    display: block;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .count {
    display: block;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .sub-menu {
    display: block;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .sub-menu .menu-item .menu-link {
    padding-left: 35px;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .menu-item .menu-link .title {
    display: block;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .menu-title {
    margin-top: 12px;
    margin-bottom: 0;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .menu-title .menu-title-text {
    margin-bottom: 7px;
    font-size: 12px;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .menu-title .menu-title-text::before {
    display: none;
  }

  .main-wrapper-content.compact-sidebar .sidebar-area:hover .logo .logo-text {
    left: 33px;
    opacity: 1;
    visibility: visible;
  }

  .dark .main-wrapper-content.active .sidebar-area .sidebar-menu .menu-title .menu-title-text::before {
    background: #555;
  }
}

[dir=rtl] {
  /* Min width 1200px */
}

@media only screen and (min-width: 1200px) {
  [dir=rtl] .main-wrapper-content.compact-sidebar .main-content {
    padding-left: 25px;
    padding-right: 106px;
  }
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .sidebar-area {
    top: 0;
    z-index: 2;
    width: 300px !important;
  }

  .main-content {
    padding-left: 0;
    padding-top: 0;
  }

  .main-content .inner-main-content {
    padding-right: 0;
  }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .main-content {
    padding-left: 0;
  }

  .main-content .inner-main-content {
    padding-right: 0;
  }
}

/* Max width 1199px */
@media only screen and (max-width: 1199px) {
  .sidebar-area {
    z-index: 2;
    left: -350px;
  }

  .sidebar-area .logo {
    border-bottom: 1px solid #ededed;
  }

  .sidebar-area .logo .logo-text {
    left: 33px;
  }

  .sidebar-area .sidebar-burger-menu {
    right: 20px !important;
  }

  .main-wrapper-content.active .sidebar-area {
    width: 270px;
    left: 0;
    box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
  }

  .main-wrapper-content.active .sidebar-area .logo .logo-text {
    left: 33px;
    opacity: 1;
    visibility: visible;
  }

  .main-wrapper-content.active .sidebar-area .sidebar-burger-menu {
    opacity: 1 !important;
    z-index: 1 !important;
    right: 20px !important;
  }

  .main-wrapper-content.active .sidebar-area .sidebar-menu {
    padding-bottom: 150px;
    padding: 25px;
    padding-top: 20px;
    padding-bottom: 60px;
  }

  .main-wrapper-content.active .sidebar-area .sidebar-menu .menu-header {
    display: block;
  }
}

/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .main-content {
    padding-left: 0;
  }

  .main-content .inner-main-content {
    padding-right: 0;
  }
}

/* Min width 1200px to Max width 1399px */
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .sidebar-area {
    width: 250px;
    z-index: 2;
  }

  .sidebar-menu {
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 15px;
  }

  .sidebar-menu .menu-title .menu-title-text {
    font-size: 12px;
  }

  .sidebar-menu .menu-item .menu-link.menu-toggle::after {
    top: 22px;
  }

  .sidebar-menu .sub-menu .menu-item .menu-link {
    padding-left: 35px;
  }

  .sidebar-menu .sub-menu .menu-item .menu-link::before {
    left: 18px;
  }
}

/* Min width 1400px to Max width 1799px */
@media only screen and (min-width: 1400px) and (max-width: 1799px) {
  .sidebar-area {
    width: 250px;
  }

  .sidebar-menu {
    padding-left: 25px;
    padding-right: 25px;
    padding-top: 15px;
  }

  .sidebar-menu .menu-title .menu-title-text {
    font-size: 12px;
  }

  .sidebar-menu .menu-item .menu-link.menu-toggle::after {
    top: 22px;
  }

  .sidebar-menu .sub-menu .menu-item .menu-link {
    padding-left: 35px;
  }

  .sidebar-menu .sub-menu .menu-item .menu-link::before {
    left: 18px;
  }
}

/* Main Content Area Style
============================================*/
.main-content {
  padding-left: 300px;
  transition: all ease 0.5s;
  padding-right: 25px;
  min-height: 100vh;
}

.main-content .inner-main-content {
  padding-right: 18px;
  transition: all ease 0.5s;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 89.5vh;
}

@media only screen and (min-width: 1200px) {
  .main-wrapper-content.active .main-content {
    padding-left: 92px;
  }
}

/* Min width 1200px to Max width 1399px */
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .main-content {
    padding-left: 262px;
    transition: all ease 0.5s;
    padding-right: 12px;
  }
}

/* Min width 1400px to Max width 1799px */
@media only screen and (min-width: 1400px) and (max-width: 1799px) {
  .main-content {
    padding-left: 275px;
    transition: all ease 0.5s;
    padding-right: 15px;
  }
}

/* Max width 1199px */
@media only screen and (max-width: 1199px) {
  .main-content {
    padding-left: 12px;
    padding-right: 12px;
  }
}

/* Header Area Style
============================================*/
.header-area {
  padding: 12px 25px;
  position: sticky;
  top: 0;
  z-index: 1;
}

.header-area.sticky {
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translateZ(0);
  }
}

.left-header-content ul li {
  margin-right: 25px;
}

.left-header-content ul li .header-burger-menu .material-symbols-outlined {
  transition: all ease 0.5s;
  font-size: 24px;
  position: relative;
  top: 3.5px;
  color: #fff;
}

.left-header-content ul li .header-burger-menu .material-symbols-outlined:hover {
  color: #d08f2c;
}

.left-header-content ul li .src-form .form-control {
  height: 44px;
  background-color: #F6F7F9;
  border-color: #F6F7F9;
  padding: 10px 16px;
  border-radius: 7px;
  width: 260px;
}

.left-header-content ul li .src-form .form-control:focus {
  border-color: #d08f2c;
}

.left-header-content ul li .src-form .src-btn {
  right: 16px !important;
}

.left-header-content ul li .src-form .src-btn .material-symbols-outlined {
  color: #d08f2c;
  font-size: 20px;
  position: relative;
  top: 3px;
}

.left-header-content ul li .notifications.dropdown .btn-secondary {
  background-color: transparent;
  line-height: 1;
}

.left-header-content ul li .notifications.dropdown .btn-secondary .material-symbols-outlined {
  font-size: 24px;
  color: #fff;
  position: relative;
  top: 2px;
  transition: all ease 0.5s;
}

.left-header-content ul li .notifications.dropdown .btn-secondary:hover .material-symbols-outlined {
  color: #d08f2c;
}

.left-header-content ul li .notifications.dropdown .dropdown-menu {
  width: 240px;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0px 4px 45px 0px rgba(0, 0, 0, 0.1);
  transform: translate(0px, 30px) !important;
  left: auto !important;
  right: 0 !important;
}

.left-header-content ul li .notifications.dropdown .dropdown-menu .dropdown-item {
  white-space: inherit;
  width: 53px;
}

.left-header-content ul li .notifications.dropdown .dropdown-menu .dropdown-item span {
  font-size: 12px;
  margin-top: 5px;
  display: block;
  color: #000000;
}

.left-header-content ul li .notifications.dropdown .dropdown-menu .dropdown-item:hover {
  background-color: transparent;
}

.left-header-content ul li:last-child {
  margin-right: 0;
}

.left-header-content ul li.logo-box {
  display: none;
}

.right-header-content .header-right-item {
  margin-right: 25px;
  position: relative;
  top: 3.5px;
}

.right-header-content .header-right-item .light-dark .material-symbols-outlined {
  font-size: 24px;
  color: #FE7A36;
  cursor: pointer;
}

.right-header-content .header-right-item .notifications.dropdown .btn-secondary {
  background: transparent;
}

.right-header-content .header-right-item .notifications.dropdown .btn-secondary .material-symbols-outlined {
  font-size: 24px;
  color: #fff;
}

.right-header-content .header-right-item .notifications.dropdown .btn-secondary.badge {
  position: relative;
}

.right-header-content .header-right-item .notifications.dropdown .btn-secondary.badge::before {
  content: "";
  position: absolute;
  top: 3px;
  right: 3px;
  width: 7px;
  height: 7px;
  background-color: #FD5812;
  border-radius: 50px;
}

.right-header-content .header-right-item .notifications.dropdown .btn-secondary.dropdown-toggle {
  padding-right: 16px !important;
}

.right-header-content .header-right-item .notifications.dropdown .btn-secondary.dropdown-toggle::after {
  font-family: "remixicon";
  content: "\\ea4e";
  position: absolute;
  top: 3px;
  right: -2px;
  margin: 0;
  border: 0;
  color: #fff;
}

.right-header-content .header-right-item .notifications.dropdown .dropdown-menu {
  width: 240px;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0px 4px 45px 0px rgba(0, 0, 0, 0.1);
  transform: translate(0px, 30px) !important;
  left: auto !important;
  right: 0 !important;
}

.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .title {
  padding: 12px 20px;
  display: inline-block;
}

.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .notification-menu {
  padding: 0;
  border-top: 1px dashed #eeeeee;
}

.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .notification-menu:last-child .dropdown-item {
  border-radius: 0 0 6px 6px;
}

.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .notification-menu.unseen {
  position: relative;
}

.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .notification-menu.unseen::before {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 5px;
  height: 5px;
  background-color: #d08f2c;
  border-radius: 50px;
  right: 20px;
}

.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item {
  white-space: inherit;
  padding: 12px 20px;
}

.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item .material-symbols-outlined {
  width: 44px;
  height: 44px;
  line-height: 44px;
  background-color: #f6f5fe;
  text-align: center;
  border-radius: 50px;
  font-size: 22px;
  transition: all ease 0.5s;
}

.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item p {
  margin-bottom: 0;
}

.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:hover,
.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:focus,
.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item.active,
.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:focus-visible {
  background-color: #ebf2fa;
  color: #fff;
}

.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:hover i,
.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:hover .material-symbols-outlined,
.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:focus i,
.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:focus .material-symbols-outlined,
.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item.active i,
.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item.active .material-symbols-outlined,
.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:focus-visible i,
.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:focus-visible .material-symbols-outlined {
  background-color: #d08f2c;
  color: #fff !important;
}

.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:focus {
  background-color: #ebf2fa;
}

.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .view-all {
  padding: 12px 20px;
  border-top: 1px dashed #eeeeee;
}

.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .view-all span {
  position: relative;
  display: inline-block;
  padding-bottom: 1px;
}

.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .view-all span::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #d08f2c;
  transform: scale(0);
  transition: all ease 0.5s;
}

.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .view-all:hover span::before {
  transform: scale(1);
}

.right-header-content .header-right-item .notifications.noti.dropdown .dropdown-menu {
  width: 350px;
}

.right-header-content .header-right-item .notifications.noti.dropdown .btn-secondary.dropdown-toggle {
  padding: 0 !important;
}

.right-header-content .header-right-item .notifications.noti.dropdown .btn-secondary.dropdown-toggle::after {
  display: none;
}

.right-header-content .header-right-item .fullscreen-btn {
  position: relative;
}

.right-header-content .header-right-item .fullscreen-btn.active i,
.right-header-content .header-right-item .fullscreen-btn.active .material-symbols-outlined {
  opacity: 0;
}

.right-header-content .header-right-item .fullscreen-btn.active::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 24px;
  height: 24px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
}

.right-header-content .header-right-item .admin-profile {
  top: -3px;
}

.right-header-content .header-right-item .admin-profile h3,
.right-header-content .header-right-item .admin-profile .h3 {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 0;
}

.right-header-content .header-right-item .admin-profile .administrator {
  border: 2px solid #C2CDFF;
  display: block;
}

.right-header-content .header-right-item .admin-profile .dropdown-toggle {
  padding-right: 16px !important;
}

.right-header-content .header-right-item .admin-profile .dropdown-toggle::after {
  font-family: "remixicon";
  content: "\\ea4e";
  position: absolute;
  top: 50%;
  right: -2px;
  margin: 0;
  border: 0;
  transform: translateY(-50%);
  color: #fff;
}

.right-header-content .header-right-item .admin-profile .dropdown-menu {
  width: 195px;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0px 4px 45px 0px rgba(0, 0, 0, 0.1);
  transform: translate(0px, 55px) !important;
  padding: 20px;
  left: auto !important;
  right: 0 !important;
}

.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link {
  border-top: 1px solid #F6F7F9;
  margin-top: 10px;
  padding-top: 10px;
}

.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item {
  padding: 0;
  padding: 7.5px 0;
  position: relative;
}

.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: -20px;
  width: 2px;
  height: 100%;
  background-color: #d08f2c;
  transform: scaleY(0);
  transition: all ease 0.5s;
}

.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item .material-symbols-outlined {
  font-size: 22px;
  color: #3A4252;
  transition: all ease 0.5s;
}

.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item span {
  transition: all ease 0.5s;
}

.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item:hover {
  background-color: transparent;
}

.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item:hover::before {
  transform: scaleY(1);
}

.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item:hover span {
  color: #d08f2c;
}

.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item:hover i,
.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item:hover .material-symbols-outlined {
  color: #d08f2c;
}

.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item.activeLink {
  color: #d08f2c !important;
  background-color: transparent !important;
}

.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item.activeLink span,
.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item.activeLink i {
  color: #d08f2c !important;
}

.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li:last-child {
  margin-bottom: 0;
}

.right-header-content .header-right-item .theme-settings-btn .material-symbols-outlined {
  animation: rotation 2s infinite linear;
  color: #3A4252;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(359deg);
  }
}

.right-header-content .header-right-item:last-child {
  margin-right: 0;
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .left-header-content ul li .src-form .form-control {
    width: 100%;
  }

  .right-header-content .header-right-item {
    margin-right: 16px;
  }
}

@media only screen and (max-width: 575px) {
  .right-header-content .header-right-item .notifications.noti.dropdown .dropdown-menu {
    width: 290px;
    transform: translate(150px, 30px) !important;
  }

  .right-header-content .header-right-item .notifications.language.dropdown .dropdown-menu {
    left: 0 !important;
    right: auto !important;
  }
}

@media only screen and (min-width: 576px) and (max-width: 767px) {
  .right-header-content .header-right-item {
    margin-right: 10px;
  }
}

@media only screen and (min-width: 479px) and (max-width: 575px) {
  .right-header-content .header-right-item .dropdown.noti .dropdown-menu {
    width: 293px;
    transform: translate(95px, 60px) !important;
  }
}

/* Min width 768px to Max width 992px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .left-header-content ul li .src-form .form-control {
    width: 100%;
  }
}

/* Max width 1199px */
@media only screen and (max-width: 1199px) {
  .header-area {
    padding: 12px;
  }

  .left-header-content ul li {
    margin-right: 15px;
  }
}

/* Footer Area Style
============================================*/
.footer-area {
  padding: 25px 30px;
}

/* Max width 991px */
@media only screen and (max-width: 991px) {
  .footer-area {
    padding: 10px 10px;
  }
}

/* Stats Box Area Style
============================================*/
.welcome-box .border-bottom {
  border-color: #262626 !important;
  padding-bottom: 40px;
  margin-bottom: 40px;
}

.welcome-box.style-two {
  background: linear-gradient(81deg, #605DFF 3.39%, #9747FF 93.3%);
}

.welcome-box.style-two .welcome-2 {
  position: absolute;
  top: 0;
  right: 0;
}

.welcome-box.style-two p {
  color: #F6F7F9 !important;
}

.welcome-status-item i,
.welcome-status-item span {
  width: 42px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  border-radius: 7px;
  background-color: #ECF0FF;
  color: #d08f2c;
  position: relative;
  top: -3px;
  font-size: 24px;
}

.welcome-status-item i.icon-bg,
.welcome-status-item span.icon-bg {
  background-color: #FFE8D4;
  color: #FD5812;
}

.welcome-status-item.style-two i,
.welcome-status-item.style-two span {
  background-color: #FFC8C0;
  color: #EE3E08;
}

.welcome-status-item.style-two i.icon-bg.two,
.welcome-status-item.style-two span.icon-bg.two {
  background-color: #D8FFC8;
  color: #25B003;
}

.stats-box .count {
  background-color: #FFE1DD;
  color: #FD5812;
  border: 1px solid #FFCEA9;
  display: inline-block;
  border-radius: 50px;
  font-size: 12px;
  font-weight: 500;
  width: 52px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  margin-left: 7px;
}

.stats-box .count.up {
  background-color: #D8FFC8;
  border-color: #82FC5A;
  color: #1E8308;
}

.stats-box .stats-list li {
  margin-bottom: 6px;
}

.stats-box .stats-list li .title {
  position: relative;
  padding-left: 30px;
}

.stats-box .stats-list li .title::before {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: 20px;
  height: 5px;
  background-color: #d08f2c;
  border-radius: 50px;
}

.stats-box .stats-list li:last-child {
  margin-bottom: 0;
}

.stats-box .stats-list li:last-child .title::before {
  background-color: #C2CDFF;
}

.chart-position {
  top: -5px;
  right: 15px;
  max-width: 120px;
  position: absolute;
}

.congratulations {
  bottom: 12px;
  right: 7px;
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .welcome-box .border-bottom {
    padding-bottom: 25px;
    margin-bottom: 25px;
  }
}

/* Min width 768px to Max width 992px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .stats-box.style-three .p-4 {
    padding: 10px !important;
  }
}

/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .stats-box.style-three .p-4 {
    padding: 10px !important;
  }
}

@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .stats-box.style-three .p-4 {
    padding: 10px !important;
  }

  .welcome-box.style-two .welcome-2 {
    width: 185px;
  }
}

/* Min width 1400px to Max width 1600px */
@media only screen and (min-width: 1400px) and (max-width: 1600px) {
  .welcome-box.style-two .welcome-2 {
    width: 230px;
  }
}

/* Sales By Locations Area Style
============================================*/
.sales_by_locations li {
  margin-bottom: 21.5px;
  position: relative;
  padding-right: 48px;
}

.sales_by_locations li:last-child {
  margin-bottom: 0;
}

.sales_by_locations li .progress {
  overflow: unset;
  border-radius: 50px;
  height: 5px;
  background-color: #ECF0FF;
}

.sales_by_locations li .progress-bar {
  border-radius: 50px;
}

.sales_by_locations li .count {
  position: absolute;
  top: 20px;
  right: 0;
  font-size: 15px;
}

.sales_by_locations.style-two li {
  margin-bottom: 22px;
}

.sales_by_locations.style-two li:last-child {
  margin-bottom: 0;
}

.gl-tr:first-child td {
  padding-top: 0 !important;
}

/* Default Table Area Style
============================================*/
.default-table-area {
  /* Analytics Dashboard CSS */
  /* Crypto Dashboard CSS */
  /* Sales Dashboard CSS */
  /* Hospital Dashboard CSS */
  /* Marketing Dashboard CSS */
  /* NFT Dashboard CSS */
  /* NFT Dashboard CSS */
  /* Finance Dashboard CSS */
}

.default-table-area .table-responsive {
  border-radius: 8px 8px 0 0 !important;
}

.default-table-area .table-responsive .table {
  margin-bottom: 0;
  border: 1px solid #F6F7F9;
}

.default-table-area .table-responsive .table thead tr th {
  background-color: #F6F7F9;
  color: #445164;
  font-weight: 500;
  padding: 15px 15px;
  border: none;
  border-bottom: 1px solid #ECEEF2;
}

.default-table-area .table-responsive .table thead tr th:first-child {
  border-radius: 8px 0 0 0;
  padding-left: 25px !important;
}

.default-table-area .table-responsive .table thead tr th:last-child {
  border-radius: 0 8px 0 0;
  padding-right: 25px !important;
}

.default-table-area .table-responsive .table tbody tr td {
  background-color: transparent;
  color: #3A4252;
  border-color: #ECEEF2;
  padding: 15px 15px;
}

.default-table-area .table-responsive .table tbody tr td:first-child {
  border-left: 1px solid #ECEEF2;
  padding-left: 25px !important;
}

.default-table-area .table-responsive .table tbody tr td:last-child {
  border-right: 1px solid #ECEEF2;
  padding-right: 25px !important;
}

.default-table-area .table-responsive .table tbody tr td a {
  text-decoration: none;
}

.default-table-area .table-responsive .table tbody tr td a h6,
.default-table-area .table-responsive .table tbody tr td a .h6 {
  margin-bottom: 0;
  transition: all ease 0.5s;
}

.default-table-area .table-responsive .table tbody tr td a:hover h6,
.default-table-area .table-responsive .table tbody tr td a:hover .h6 {
  color: #d08f2c;
}

.default-table-area .table-responsive .table tbody tr td .badge {
  font-size: 13px;
}

.default-table-area.top-selling-products .table-responsive .table tbody tr td {
  padding: 18.5px 15px;
}

.default-table-area.recent-orders .table-responsive .table tbody tr td {
  padding: 18.5px 15px;
}

.default-table-area.recent-orders.recent-style-two .table-responsive .table tbody tr td {
  padding: 15px 15px;
}

.default-table-area.recent-leads.style-two .table-responsive .table tbody tr td {
  padding: 10.8px 8px;
}

.default-table-area .showing-wrap {
  border: 1px solid #ECEEF2;
  border-top: none;
  padding: 13px 25px;
  border-radius: 0 0 8px 8px;
}

.default-table-area.style-two .table-responsive {
  border-radius: 0 !important;
}

.default-table-area.style-two .table-responsive .table thead tr th {
  background-color: #ECF0FF;
  font-size: 14px;
  padding: 15px 8px;
  border: none !important;
}

.default-table-area.style-two .table-responsive .table thead tr th:first-child {
  border-radius: 0;
}

.default-table-area.style-two .table-responsive .table thead tr th:last-child {
  border-radius: 0;
}

.default-table-area.style-two .table-responsive .table tbody tr td {
  padding: 15px 8px;
  border-left: none;
  border-right: none;
}

.default-table-area.style-two .showing-wrap {
  border: 0;
  padding: 0;
}

.default-table-area.to-do-list .table-responsive .table thead tr th {
  padding: 15px 7px;
}

.default-table-area.to-do-list .table-responsive .table tbody tr td {
  padding: 15px 7px;
}

.default-table-area.to-do-list.padding-style .table-responsive .table thead tr th {
  padding: 9.5px 7px;
}

.default-table-area.to-do-list.padding-style .table-responsive .table tbody tr td {
  padding: 11.5px 7px;
}

.default-table-area.email-list .table-responsive {
  border: none;
}

.default-table-area.email-list .table-responsive .table {
  border: none;
}

.default-table-area.email-list .table-responsive .table tbody tr td {
  border: none;
  border-bottom: 1px solid #ECEEF2;
}

.default-table-area.email-list .table-responsive .table tbody tr td:first-child {
  padding-left: 0 !important;
}

.default-table-area.email-list .table-responsive .table tbody tr td:last-child {
  padding-right: 0 !important;
}

.default-table-area.email-list .pagination-area {
  position: absolute;
  top: 20px;
  right: 20px;
}

.default-table-area.recent-files .table-responsive .table tbody tr td {
  padding: 15px 5px;
}

.default-table-area.recent-files .table-responsive .table thead tr th {
  padding: 15px 5px;
}

.default-table-area.deals-table .table-responsive .table tbody tr td {
  padding-top: 20px;
  padding-bottom: 20px;
}

.default-table-area.connected-table .table-responsive .table tbody tr td {
  border: 0 !important;
}

.default-table-area.connected-table .table-responsive .table tbody tr td.ps-0 {
  padding-left: 0 !important;
}

.default-table-area.connected-table .table-responsive .table tbody tr td.pe-0 {
  padding-right: 0 !important;
}

.default-table-area.browser-leads.style-two .table-responsive .table thead tr th:first-child {
  padding-left: 0 !important;
}

.default-table-area.browser-leads.style-two .table-responsive .table thead tr th:last-child {
  padding-right: 0 !important;
}

.default-table-area.browser-leads.style-two .table-responsive .table tbody tr td {
  padding-top: 8px;
  padding-bottom: 8px;
}

.default-table-area.browser-leads.style-two .table-responsive .table tbody tr td:first-child {
  padding-left: 0 !important;
}

.default-table-area.browser-leads.style-two .table-responsive .table tbody tr td:last-child {
  padding-right: 0 !important;
}

.default-table-area.transaction-table.style-two .table-responsive .table thead tr th:first-child {
  padding-left: 0 !important;
}

.default-table-area.transaction-table.style-two .table-responsive .table thead tr th:last-child {
  padding-right: 0 !important;
}

.default-table-area.transaction-table.style-two .table-responsive .table tbody tr td {
  padding-top: 8px;
  padding-bottom: 8px;
}

.default-table-area.transaction-table.style-two .table-responsive .table tbody tr td:first-child {
  padding-left: 0 !important;
}

.default-table-area.transaction-table.style-two .table-responsive .table tbody tr td:last-child {
  padding-right: 0 !important;
}

.default-table-area.portfolio-table.style-two .table-responsive .table thead tr {
  border-color: #262626 !important;
}

.default-table-area.portfolio-table.style-two .table-responsive .table thead tr th:first-child {
  padding-left: 0 !important;
}

.default-table-area.portfolio-table.style-two .table-responsive .table thead tr th:last-child {
  padding-right: 0 !important;
}

.default-table-area.portfolio-table.style-two .table-responsive .table tbody tr td {
  border-color: #262626;
  padding-top: 11px;
  padding-bottom: 11px;
}

.default-table-area.portfolio-table.style-two .table-responsive .table tbody tr td:first-child {
  padding-left: 0 !important;
}

.default-table-area.portfolio-table.style-two .table-responsive .table tbody tr td:last-child {
  padding-right: 0 !important;
}

.default-table-area.rankings-table.style-two .table-responsive .table thead tr th:first-child {
  padding-left: 0 !important;
}

.default-table-area.rankings-table.style-two .table-responsive .table thead tr th:last-child {
  padding-right: 0 !important;
}

.default-table-area.rankings-table.style-two .table-responsive .table tbody tr td {
  padding-top: 11px;
  padding-bottom: 11px;
}

.default-table-area.rankings-table.style-two .table-responsive .table tbody tr td:first-child {
  padding-left: 0 !important;
}

.default-table-area.rankings-table.style-two .table-responsive .table tbody tr td:last-child {
  padding-right: 0 !important;
}

.default-table-area.sales-locations-table.style-two .table-responsive .table thead tr th:first-child {
  padding-left: 0 !important;
}

.default-table-area.sales-locations-table.style-two .table-responsive .table thead tr th:last-child {
  padding-right: 0 !important;
}

.default-table-area.sales-locations-table.style-two .table-responsive .table tbody tr td {
  padding-top: 11px;
  padding-bottom: 11px;
}

.default-table-area.sales-locations-table.style-two .table-responsive .table tbody tr td:first-child {
  padding-left: 0 !important;
}

.default-table-area.sales-locations-table.style-two .table-responsive .table tbody tr td:last-child {
  padding-right: 0 !important;
}

.default-table-area.patient-table.style-two .table-responsive .table thead tr th:first-child {
  padding-left: 0 !important;
}

.default-table-area.patient-table.style-two .table-responsive .table thead tr th:last-child {
  padding-right: 0 !important;
}

.default-table-area.patient-table.style-two .table-responsive .table tbody tr td {
  padding-top: 8px;
  padding-bottom: 8px;
}

.default-table-area.patient-table.style-two .table-responsive .table tbody tr td:first-child {
  padding-left: 0 !important;
}

.default-table-area.patient-table.style-two .table-responsive .table tbody tr td:last-child {
  padding-right: 0 !important;
}

.default-table-area.campaigns-table.style-two .table-responsive .table thead tr th:first-child {
  padding-left: 0 !important;
}

.default-table-area.campaigns-table.style-two .table-responsive .table thead tr th:last-child {
  padding-right: 0 !important;
}

.default-table-area.campaigns-table.style-two .table-responsive .table tbody tr td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.default-table-area.campaigns-table.style-two .table-responsive .table tbody tr td:first-child {
  padding-left: 0 !important;
}

.default-table-area.campaigns-table.style-two .table-responsive .table tbody tr td:last-child {
  padding-right: 0 !important;
}

.default-table-area.top-nfts-table.style-two .table-responsive .table thead tr th:first-child {
  padding-left: 0 !important;
}

.default-table-area.top-nfts-table.style-two .table-responsive .table thead tr th:last-child {
  padding-right: 0 !important;
}

.default-table-area.top-nfts-table.style-two .table-responsive .table tbody tr td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.default-table-area.top-nfts-table.style-two .table-responsive .table tbody tr td:first-child {
  padding-left: 0 !important;
}

.default-table-area.top-nfts-table.style-two .table-responsive .table tbody tr td:last-child {
  padding-right: 0 !important;
}

.default-table-area.history-of-bids.style-two .table-responsive {
  height: 438px;
}

.default-table-area.history-of-bids.style-two .table-responsive .table tbody tr td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.default-table-area.history-of-bids.style-two .table-responsive .table tbody tr td:first-child {
  padding-left: 0 !important;
}

.default-table-area.history-of-bids.style-two .table-responsive .table tbody tr td:last-child {
  padding-right: 0 !important;
}

.default-table-area.transaction-history.style-two .table-responsive .table tbody tr td {
  padding-top: 23.5px;
  padding-bottom: 23.5px;
}

.default-table-area.transaction-history-large.style-two .table-responsive .table tbody tr td {
  padding-top: 23.5px;
  padding-bottom: 23.5px;
}

.default-table-area.shipment-list.style-two .table-responsive .table tbody tr td {
  padding-top: 19px;
  padding-bottom: 19px;
}

.default-table-area.style-three .table-responsive .table thead tr th {
  font-size: 14px;
  color: #fff;
}

.default-table-area.style-three .table-responsive .table thead tr th:first-child {
  padding-left: 30px !important;
}

.default-table-area.style-three .table-responsive .table thead tr th:last-child {
  padding-right: 30px;
}

.default-table-area.style-three .table-responsive .table tbody tr td {
  padding-top: 10px;
  padding-bottom: 10px;
  border-left: none;
  border-right: none;
}

.default-table-area.style-three .table-responsive .table tbody tr td:first-child {
  padding-left: 30px !important;
}

.default-table-area.style-three .table-responsive .table tbody tr td:last-child {
  padding-right: 30px;
}

.default-table-area.agents-performance-overview.style-three .table-responsive {
  border-radius: 0 !important;
}

.default-table-area.agents-performance-overview.style-three .table-responsive .table {
  border-spacing: 10px;
}

.default-table-area.agents-performance-overview.style-three .table-responsive .table tbody tr td {
  padding: 10px !important;
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-top: 10px solid #fff;
  background-color: #F6F7F9;
  border-radius: 0 !important;
}

.default-table-area.agents-performance-overview.style-three .table-responsive .table tbody tr td:first-child {
  border-radius: 10px 0 0 10px !important;
}

.default-table-area.agents-performance-overview.style-three .table-responsive .table tbody tr td:last-child {
  border-radius: 0 10px 10px 0 !important;
}

.default-table-area.for-data-table .tablesorter-header {
  background-color: transparent !important;
  position: relative;
}

.default-table-area.for-data-table .tablesorter-header::after {
  content: "\\f326";
  font-family: remixicon !important;
  margin-left: 4px;
}

.default-table-area.for-data-table .Selc {
  display: none;
}

.table-src-form {
  margin-right: 20px;
}

.table-src-form i,
.table-src-form .material-symbols-outlined {
  left: 15px !important;
  font-size: 20px;
}

.table-src-form .form-control {
  padding-left: 40px;
  background-color: #F6F7F9;
  height: 36px;
  width: 240px;
  padding-top: 5px;
  padding-bottom: 5px;
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .default-table-area {
    /* Analytics Dashboard CSS */
  }

  .default-table-area.to-do-list .table {
    width: 738.66px;
  }

  .default-table-area.recent-files .table {
    width: 819px;
  }

  .default-table-area.manage-reviews-table .table {
    width: 1100px;
  }

  .default-table-area.latest-transaction .table {
    width: 967px;
  }

  .default-table-area.transaction-history.tracking-order.style-two .table-responsive .table {
    width: 742px;
  }

  .default-table-area.style-three .table-responsive .table thead tr th:first-child {
    padding-left: 15px !important;
  }

  .default-table-area.style-three .table-responsive .table thead tr th:last-child {
    padding-right: 15px !important;
  }

  .default-table-area.style-three .table-responsive .table tbody tr td:first-child {
    padding-left: 15px !important;
  }

  .default-table-area.style-three .table-responsive .table tbody tr td:last-child {
    padding-right: 15px !important;
  }

  .default-table-area.browser-leads.style-two .table-responsive .table.for-mobile-width {
    width: 715px !important;
  }

  .ec-recent-orders .table {
    width: 960px;
  }

  .analytics-bu-by-users {
    width: 715px;
  }

  .analytics-tbpt-table {
    width: 715px;
  }

  .crypto-th-table {
    width: 715px;
  }

  .crypto-cr-table {
    width: 900px;
  }

  .patient-table .table {
    width: 730px;
  }

  .default-table-area.email-list .pagination-area {
    position: initial;
    margin-top: 15px;
  }
}

/* Max width 490px */
@media only screen and (max-width: 490px) {

  /* Analytics Dashboard CSS */
  .default-table-area.top-nfts-table.style-two .table-responsive .table {
    width: 436px !important;
  }

  .default-table-area.agents-performance-overview.style-three .table-responsive .table {
    width: 480px;
  }
}

@media only screen and (max-width: 380px) {
  .default-table-area {
    /* Crypto Dashboard CSS */
  }

  .default-table-area.team-members .table {
    width: 357.33px;
  }

  .default-table-area.portfolio-table.style-two .table-responsive .table {
    width: 357.33px;
  }
}

@media only screen and (max-width: 576px) {
  .default-table-area.top-selling-products .table {
    width: 595.33px;
  }

  .default-table-area.recent-orders .table {
    width: 690px;
  }

  .default-table-area.my-tasks .table {
    width: 547px;
  }

  .default-table-area.to-do-list .table {
    width: 738.66px;
  }

  .default-table-area.top-instructors .table {
    width: 551.5px;
  }

  .default-table-area.recent-customer-ratings .table {
    width: 551.5px;
  }

  .default-table-area.speaker-table .table {
    width: 525px;
  }

  .default-table-area.connected-table .table {
    width: 522px;
  }

  .table-src-form {
    margin-right: 10px;
  }

  .table-src-form .form-control {
    width: 140px;
  }
}

/* Max width 650px */
@media only screen and (max-width: 650px) {

  /* Analytics Dashboard CSS */
  .default-table-area {
    /* Marketing Dashboard CSS */
  }

  .default-table-area.campaigns-table.style-two .table-responsive .table {
    width: 670px !important;
  }

  .default-table-area.employee-leave-request.style-three .table-responsive .table {
    width: 626px !important;
  }
}

@media only screen and (max-width: 685px) {
  .default-table-area.recent-orders .table {
    width: 690px;
  }

  .default-table-area.recent-leads .table {
    width: 690px;
  }

  .default-table-area.email-list .table {
    width: 680px;
  }
}

/* Max width 1340px */
@media only screen and (max-width: 1340px) {

  /* Crypto Dashboard CSS */
  .default-table-area.patient-table.style-two .table-responsive .table {
    width: 927px !important;
  }

  .default-table-area.shipment-list.style-two .table-responsive .table {
    width: 1003px;
  }

  .default-table-area.employee-list.style-three .table-responsive .table {
    width: 1042px;
  }
}

/* Min width 768px to Max width 992px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .default-table-area.email-list .table {
    width: 680px;
  }

  .default-table-area.recent-files .table {
    width: 819px;
  }

  .default-table-area.manage-reviews-table .table {
    width: 1100px;
  }

  .default-table-area.latest-transaction .table {
    width: 967px;
  }

  .default-table-area.style-three .table-responsive .table thead tr th:first-child {
    padding-left: 15px !important;
  }

  .default-table-area.style-three .table-responsive .table thead tr th:last-child {
    padding-right: 15px !important;
  }

  .default-table-area.style-three .table-responsive .table tbody tr td:first-child {
    padding-left: 15px !important;
  }

  .default-table-area.style-three .table-responsive .table tbody tr td:last-child {
    padding-right: 15px !important;
  }

  .ec-recent-orders .table {
    width: 1050px;
  }

  .crypto-cr-table {
    width: 930px;
  }
}

@media only screen and (max-width: 685px) {
  .default-table-area {
    /* Finance Dashboard CSS */
  }

  .default-table-area.recent-orders .table {
    width: 690px;
  }

  .default-table-area.recent-leads .table {
    width: 690px;
  }

  .default-table-area.email-list .table {
    width: 680px;
  }

  .default-table-area.transaction-history.style-two .table-responsive .table {
    width: 685px;
  }

  .default-table-area.recent-calls.style-three .table-responsive .table {
    width: 710px;
  }
}

/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .default-table-area.recent-leads .table {
    width: 690px;
  }

  .default-table-area.recent-customer-ratings .table {
    width: 551.5px;
  }

  .default-table-area.recent-files .table {
    width: 819px;
  }

  .default-table-area.manage-reviews-table .table {
    width: 1100px;
  }

  .default-table-area.speaker-table .table {
    width: 525px;
  }

  .patient-table .table {
    width: 730px;
  }
}

/* Min width 1200px to Max width 1399px */
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .default-table-area.top-selling-products .table {
    width: 620px;
  }

  .default-table-area.recent-orders .table {
    width: 719px;
  }

  .default-table-area.recent-leads .table {
    width: 690px;
  }

  .default-table-area.recent-customer-ratings .table {
    width: 551.5px;
  }

  .default-table-area.email-list .table {
    width: 680px;
  }

  .default-table-area.recent-files .table {
    width: 819px;
  }

  .default-table-area.manage-reviews-table .table {
    width: 1100px;
  }

  .default-table-area.speaker-table .table {
    width: 525px;
  }

  .patient-table .table {
    width: 730px;
  }
}

/* Min width 1400px to Max width 1500px */
@media only screen and (min-width: 1400px) and (max-width: 1550px) {
  .crypto-th-table {
    width: 715px;
  }
}

@media only screen and (max-width: 1399px) {
  .default-table-area.all-projects .table {
    width: 1120px;
  }

  .default-table-area.default-table-width .table {
    width: 1120px;
  }

  .default-table-area.all-products .table {
    width: 1300px;
  }

  .default-table-area.all-products #myTable {
    width: 1300px !important;
  }
}

@media only screen and (max-width: 1550px) {
  .default-table-area.campaigns-table.latest-transaction-table .table-responsive .table {
    width: 927px !important;
  }

  .default-table-area.real-estate-customers.style-two .table-responsive .table {
    width: 1252px;
  }

  .default-table-area.all-products .table {
    width: 1300px;
  }

  .default-table-area.all-products #myTable {
    width: 1300px !important;
  }

  .default-table-area.all-carts .table {
    width: 926px;
  }
}

/* Pagination Area Style
============================================*/
.pagination .page-item {
  margin-right: 7px;
}

.pagination .page-item .page-link {
  padding: 6px 12px;
  border-radius: 4px;
  border: 1px solid #ECEEF2;
  background: #fff;
  transition: all ease 0.5s;
  font-weight: 500;
  color: #fff;
}

.pagination .page-item .page-link:focus {
  box-shadow: none;
}

.pagination .page-item .page-link.icon {
  padding: 0;
}

.pagination .page-item .page-link.icon i,
.pagination .page-item .page-link.icon span {
  width: 31px;
  height: 31px;
  line-height: 33px;
  text-align: center;
  font-size: 22px;
}

.pagination .page-item .page-link.active {
  background-color: #d08f2c;
  color: #fff;
  z-index: 0 !important;
}

.pagination .page-item .page-link:hover {
  background-color: #d08f2c;
  color: #fff;
}

.pagination .page-item .page-link:hover i,
.pagination .page-item .page-link:hover span {
  color: #fff;
}

.pagination .page-item:last-child {
  margin-right: 0;
}

/* Calendar Style
============================================*/
.fc-theme-standard .fc-scrollgrid {
  border: 1px solid #ECF0FF;
}

.fc-theme-standard th {
  background-color: #ECF0FF;
  font-size: 14px;
  font-weight: 500;
}

.fc-theme-standard tr th,
.fc-theme-standard tr td {
  border: 1px solid #ECF0FF;
}

.fc-theme-standard a {
  text-decoration: none;
}

.fc .fc-toolbar-title {
  font-size: 18px;
  font-weight: 700;
}

.fc .fc-button-primary {
  text-transform: capitalize;
}

.fc .fc-col-header-cell-cushion {
  padding: 8px 4px;
  color: black;
}

.fc .fc-daygrid-day-number {
  padding: 20px;
}

/* Calendar Area Style
============================================*/
.react-calendar {
  width: 100%;
  border: none;
  font-family: "Inter", sans-serif;
}

.react-calendar .react-calendar__navigation {
  align-items: center;
  height: auto;
}

.react-calendar .react-calendar__navigation button .react-calendar__navigation__label__labelText {
  font-weight: 600;
  font-size: 13px;
}

.react-calendar .react-calendar__navigation .react-calendar__navigation__prev2-button,
.react-calendar .react-calendar__navigation .react-calendar__navigation__next2-button {
  display: none;
}

.react-calendar .react-calendar__navigation .react-calendar__navigation__prev-button,
.react-calendar .react-calendar__navigation .react-calendar__navigation__next-button {
  background-color: #f5f5f5;
  width: 20px;
  height: 20px;
  min-width: auto;
  border-radius: 100%;
}

.react-calendar .react-calendar__month-view__weekdays .react-calendar__month-view__weekdays__weekday {
  text-transform: capitalize;
  color: #3A4252;
  font-size: 12px;
}

.react-calendar .react-calendar__month-view__days__day--weekend {
  color: #FD5812 !important;
}

.react-calendar .react-calendar__month-view__days .react-calendar__month-view__days__day--neighboringMonth {
  opacity: 0.5;
}

.react-calendar .react-calendar__month-view__days .react-calendar__tile {
  color: #3A4252;
  font-size: 14px;
}

.react-calendar .react-calendar__month-view__days .react-calendar__tile.react-calendar__tile--active {
  background-color: transparent;
}

.react-calendar .react-calendar__month-view__days .react-calendar__tile.react-calendar__tile--active abbr {
  background-color: #d08f2c;
  color: #fff !important;
  border-radius: 100%;
  padding: 0;
  width: 30px;
  height: 30px;
  display: inline-block;
  line-height: 30px;
}

.dark .react-calendar .react-calendar__navigation .react-calendar__navigation__prev-button,
.dark .react-calendar .react-calendar__navigation .react-calendar__navigation__next-button {
  background-color: #000000;
}

.dark .react-calendar .react-calendar__month-view__weekdays .react-calendar__month-view__weekdays__weekday {
  color: #fff;
}

.dark .react-calendar .react-calendar__month-view__days .react-calendar__tile {
  color: #3A4252;
}

.dark .fc-theme-standard th {
  background-color: #212121;
  color: #fff;
}

.dark .fc-theme-standard .fc-scrollgrid {
  border: 1px solid #172036;
}

.dark .fc-theme-standard tr th,
.dark .fc-theme-standard tr td {
  border: 1px solid #172036;
}

.dark .fc .fc-col-header-cell-cushion {
  color: #fff;
}

.dark .fc .fc-daygrid-day-number {
  color: #fff;
}

.dark .mantine-1qycoz3 {
  border: 1px solid #212121;
  background-color: #212121;
  color: #fff;
}

/* Chat Area Style
============================================*/
.status-position {
  top: 2px;
  right: -5px;
}

.status-position2 {
  bottom: 4px;
  right: -2px;
}

.chat-tabs {
  justify-content: space-between;
  margin-bottom: 1.5rem !important;
}

.chat-tabs .nav-item .nav-link {
  position: relative;
  border: none;
  padding: 0 0 10px;
  font-weight: 500;
  color: #fff;
}

.chat-tabs .nav-item .nav-link::before {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0;
  height: 2px;
  background-color: #d08f2c;
  transition: all ease 0.5s;
}

.chat-tabs .nav-item .nav-link.active,
.chat-tabs .nav-item .nav-link:hover {
  color: #d08f2c !important;
  background-color: transparent;
}

.chat-tabs .nav-item .nav-link.active::before,
.chat-tabs .nav-item .nav-link:hover::before {
  width: 100%;
  right: auto;
  left: 0;
}

.chat-details li {
  max-width: 800px;
}

.chat-details li p {
  border-radius: 0px 15px 15px 15px;
  background-color: #F5F6FA;
  margin-bottom: 0;
  padding: 15px 20px;
  margin-bottom: 5px;
  display: inline-block;
}

.chat-details li .dropdown.action-opt {
  opacity: 0;
  transition: all ease 0.5s;
}

.chat-details li.own-chat p {
  border-radius: 15px 0 15px 15px;
  background-color: #d08f2c;
  color: #fff;
}

.chat-details li:hover .dropdown.action-opt {
  opacity: 1;
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .chat-details li p {
    padding: 10px;
  }
}

/* Min width 768px to Max width 992px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .chat-details li p {
    padding: 10px;
  }
}

/* Min width 1400px to Max width 1799px */
/* Terminals Area Style
============================================*/
.timeline-wrap {
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 15px;
}

.timeline-wrap::before {
  content: "";
  display: block;
  position: absolute;
  left: 50%;
  transform: translatex(-50%);
  border: 1px dashed #d08f2c;
  height: 80%;
}

.timeline-wrap .timeline-item-2 {
  display: flex;
}

.timeline-wrap .timeline-item-2 .text {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 50px);
  position: relative;
  background-color: #ECF0FF;
}

.timeline-wrap .timeline-item-2 .icon {
  flex: 1 1 100px;
}

.timeline-wrap .timeline-item-2 .icon div {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin: auto;
  background: #d08f2c;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  position: relative;
  z-index: 1;
}

.timeline-wrap .timeline-item-2 .icon.two div {
  background: #37D80A;
}

.timeline-wrap .timeline-item-2 .icon.three div {
  background: #d08f2c;
}

.timeline-wrap .timeline-item-2 .icon.four div {
  background: #FD5812;
}

.timeline-wrap .timeline-item-2 .time {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 50px);
}

.timeline-wrap .timeline-item-2 .time time {
  font-size: 12px;
  background-color: #d08f2c;
  color: #fff;
  display: inline-block;
  padding: 9px 15px;
  border-radius: 7px;
  position: relative;
}

.timeline-wrap .timeline-item-2 .time time::before {
  content: "";
  position: absolute;
  top: 10px;
  left: -6px;
  width: 15px;
  height: 15px;
  background-color: #d08f2c;
  transform: rotate(45deg);
  border-radius: 2px;
}

.timeline-wrap .timeline-item-2:nth-child(even) {
  flex-direction: row-reverse;
}

.timeline-wrap .timeline-item-2:nth-child(even) .time time::before {
  left: auto;
  right: -6px;
}

.timeline-wrap .timeline-item-2:nth-child(even)>div:last-child {
  text-align: end;
}

.timeline-item {
  position: relative;
  padding-left: 90px;
}

.timeline-item .time-line-date {
  position: absolute;
  top: -5px;
  left: 0;
}

.timeline-item .border-style-for-timeline {
  border-left: 1px dashed #D5D9E2;
  padding-left: 30px;
  position: relative;
  padding-bottom: 30px;
}

.timeline-item .border-style-for-timeline::before {
  content: "";
  position: absolute;
  top: 0;
  left: -6px;
  width: 12px;
  height: 12px;
  background-color: #37D80A;
  border-radius: 50px;
}

.timeline-item .border-style-for-timeline.dot-2::before {
  background-color: #FD5812;
}

.timeline-item .border-style-for-timeline.dot-3::before {
  background-color: #AD63F6;
}

.timeline-item .border-style-for-timeline.dot-4::before {
  background-color: #3584FC;
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .timeline-wrap {
    margin: 0;
  }

  .timeline-wrap::before {
    display: none;
  }

  .timeline-wrap .timeline-item-2 {
    flex-flow: column wrap;
    height: auto;
  }

  .timeline-wrap .timeline-item-2:nth-child(even) {
    flex-direction: column;
  }

  .timeline-wrap .timeline-item-2:nth-child(even)>.time:last-child {
    text-align: start;
  }

  .timeline-wrap .timeline-item-2:nth-child(odd) h3::after,
  .timeline-wrap .timeline-item-2:nth-child(odd) .h3::after {
    border: none;
  }

  .timeline-wrap .timeline-item-2 .icon {
    order: 1;
    flex: 1 1 100%;
    width: 100px;
  }

  .timeline-wrap .timeline-item-2 .icon div {
    display: none !important;
  }

  .timeline-wrap .timeline-item-2 .time {
    order: 2;
    flex: 1 1 50px;
    width: calc(100% - 90px);
  }

  .timeline-wrap .timeline-item-2 .text {
    order: 3;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(100% - 50px);
    width: calc(100% + 1px);
  }
}

/* Priceing Area Style
============================================*/
.priceing-border {
  position: relative;
}

.priceing-border::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: -130px;
  width: 1px;
  height: 100%;
  border-left: 1px dashed #ECEEF2;
}

.priceing-border.style-two::before {
  left: 0 !important;
}

.popular-tag {
  top: 25px;
  left: 227px;
  transform: rotate(-15deg);
}

.populartsgs {
  top: 20px;
  right: 20px;
}

/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .priceing-border::before {
    left: -51px;
  }

  .popular-tag {
    left: 144px;
  }
}

/* Min width 1200px to Max width 1399px */
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .priceing-border::before {
    left: -51px;
  }

  .popular-tag {
    left: 130px;
  }
}

/* Min width 1400px to Max width 1799px */
@media only screen and (min-width: 1400px) and (max-width: 1799px) {
  .priceing-border::before {
    left: -68px;
  }

  .popular-tag {
    left: 160px;
  }
}

@media only screen and (max-width: 991px) {
  .priceing-border::before {
    display: none;
  }

  .popular-tag {
    left: auto;
    right: 25px;
    top: 25px;
  }
}

/* Products Area Style
============================================*/
.product-image .react-tabs__tab-panel {
  background-color: #f6f7f9;
  padding: 3rem !important;
  border-radius: 7px;
  text-align: center;
}

.product-image .react-tabs__tab-list {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  border: none;
  gap: 15px;
}

.product-image .react-tabs__tab-list .react-tabs__tab {
  margin: 10px 0 0;
  background-color: #f6f7f9;
  border-radius: 7px;
  text-align: center;
  padding: 15px;
  border: 1px solid #f6f7f9 !important;
}

.product-image .react-tabs__tab-list .react-tabs__tab.react-tabs__tab--selected {
  border: 1px solid #FFBC2B !important;
}

.select-style .btn-check:checked+.btn,
.select-style .btn.active,
.select-style .btn.show,
.select-style .btn:first-child:active,
.select-style :not(.btn-check)+.btn:active {
  border-color: #FFBC2B !important;
}

.select-color li {
  width: 30px;
  height: 30px;
  border: 1px solid #fff;
  cursor: pointer;
}

.select-color li.color1 {
  background-color: #ECEEF2;
  border-radius: 50px;
}

.select-color li.color1.active {
  border-color: #FFBC2B;
}

.select-color li.color2 {
  background-color: #D5D9E2;
  border-radius: 50px;
}

.select-color li:hover {
  border-color: #FFBC2B;
}

.add-to-cart-counter {
  display: flex;
}

.add-to-cart-counter input {
  background-color: #ECF0FF;
  color: #fff;
  border: 1px solid #ECF0FF;
  max-width: 50px;
  text-align: center;
  font-size: 16px;
  border: 0;
}

.add-to-cart-counter input:focus {
  box-shadow: none;
  border: none;
  outline: none;
}

.add-to-cart-counter .minusBtn,
.add-to-cart-counter .plusBtn {
  border-right: 1px solid #ECF0FF;
  width: 35px;
  height: 42px;
  line-height: 31.9px;
  background-color: #ECF0FF;
  border-radius: 0 7px 7px 0 !important;
}

.add-to-cart-counter .minusBtn {
  border-radius: 7px 0 0 7px !important;
}

.review-tabs {
  margin-bottom: 1px;
}

.review-tabs .nav-item .nav-link {
  color: #fff;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px solid #F6F7F9 !important;
  padding: 11px 30px;
}

.review-tabs .nav-item .nav-link.active {
  background-color: #fff;
  border-color: #d08f2c !important;
}

/* Max width 767px */
/* Min width 768px to Max width 992px */
/* Min width 992px to Max width 1199px */
/* Min width 1200px to Max width 1399px */
/* Min width 1400px to Max width 1799px */
/* RTL Area Style
============================================*/
[dir=rtl] {
  text-align: right;
}

[dir=rtl] .ms-1 {
  margin-left: 0 !important;
  margin-right: 0.25rem !important;
}

[dir=rtl] .ms-2 {
  margin-left: 0 !important;
  margin-right: 0.5rem !important;
}

[dir=rtl] .ms-3 {
  margin-left: 0 !important;
  margin-right: 1rem !important;
}

[dir=rtl] .ms-4 {
  margin-left: 0 !important;
  margin-right: 1.5rem !important;
}

[dir=rtl] .ms-5 {
  margin-left: 0 !important;
  margin-right: 3rem !important;
}

[dir=rtl] .me-1 {
  margin-right: 0 !important;
  margin-left: 0.25rem !important;
}

[dir=rtl] .me-2 {
  margin-right: 0 !important;
  margin-left: 0.5rem !important;
}

[dir=rtl] .me-3 {
  margin-right: 0 !important;
  margin-left: 1rem !important;
}

[dir=rtl] .me-4 {
  margin-right: 0 !important;
  margin-left: 1.5rem !important;
}

[dir=rtl] .me-5 {
  margin-right: 0 !important;
  margin-left: 3rem !important;
}

[dir=rtl] .ms-m-20 {
  margin-left: 0;
  margin-right: -20px;
}

[dir=rtl] .ms-m-15 {
  margin-left: 0;
  margin-right: -15px;
}

[dir=rtl] .ms-xxl-3 {
  margin-left: 0 !important;
  margin-right: 1rem !important;
}

[dir=rtl] .ps-1 {
  padding-left: 0 !important;
  padding-right: 0.25rem !important;
}

[dir=rtl] .ps-2 {
  padding-left: 0 !important;
  padding-right: 0.5rem !important;
}

[dir=rtl] .ps-3 {
  padding-left: 0 !important;
  padding-right: 1rem !important;
}

[dir=rtl] .ps-4 {
  padding-left: 0 !important;
  padding-right: 1.5rem !important;
}

[dir=rtl] .ps-5 {
  padding-left: 0 !important;
  padding-right: 3rem !important;
}

[dir=rtl] .pe-1 {
  padding-right: 0 !important;
  padding-left: 0.25rem !important;
}

[dir=rtl] .pe-2 {
  padding-right: 0 !important;
  padding-left: 0.5rem !important;
}

[dir=rtl] .pe-3 {
  padding-right: 0 !important;
  padding-left: 1rem !important;
}

[dir=rtl] .pe-4 {
  padding-right: 0 !important;
  padding-left: 1.5rem !important;
}

[dir=rtl] .pe-5 {
  padding-right: 0 !important;
  padding-left: 3rem !important;
}

[dir=rtl] .ps-0 {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

[dir=rtl] .ps-xxl-4 {
  padding-left: 0 !important;
  padding-right: 1.5rem !important;
}

[dir=rtl] .text-start {
  text-align: right !important;
}

[dir=rtl] .text-end {
  text-align: left !important;
}

[dir=rtl] .text-sm-end {
  text-align: left !important;
}

[dir=rtl] .main-content {
  padding-left: 25px;
  padding-right: 295px;
}

@media only screen and (min-width: 1200px) {
  [dir=rtl] .main-wrapper-content.active .main-content {
    padding-left: 25px;
    padding-right: 105px;
  }
}

[dir=rtl] .sidebar-area {
  left: auto;
  right: 0;
}

[dir=rtl] .sidebar-area .logo .logo-text {
  left: auto;
  right: 33px;
}

[dir=rtl] .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button i,
[dir=rtl] .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button span {
  margin-right: 0;
  margin-left: 7px;
}

[dir=rtl] .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .count {
  right: auto;
  left: 42px;
}

[dir=rtl] .sidebar-menu .menu-item .menu-link i,
[dir=rtl] .sidebar-menu .menu-item .menu-link span {
  margin-right: 0;
  margin-left: 8px;
}

[dir=rtl] .sidebar-menu .menu-item .menu-link .tag {
  margin-left: 0;
  margin-right: 12px;
}

[dir=rtl] .sidebar-menu .sub-menu .menu-item .menu-link {
  padding-left: 0;
  padding-right: 35px;
}

[dir=rtl] .sidebar-menu .sub-menu .menu-item .menu-link:before {
  left: auto;
  right: 18px;
}

[dir=rtl] .menu-vertical .menu-item .menu-link .count {
  right: auto;
  left: 42px;
}

[dir=rtl] .menu-vertical .menu-item .menu-link .menu-icon {
  margin-right: 0;
  margin-left: 4px;
}

[dir=rtl] .menu-vertical .menu-item .menu-link.menu-toggle::after {
  right: auto;
  left: 25px;
  transform: translateY(-50%) rotate(225deg);
}

[dir=rtl] .menu-vertical .menu-item.open:not(.menu-item-closing)>.menu-toggle::after {
  transform: translateY(-50%) rotate(135deg);
}

[dir=rtl] .menu-vertical .menu-sub .menu-item .menu-link {
  padding-left: 0;
  padding-right: 35px;
}

[dir=rtl] .menu-vertical .menu-sub .menu-item .menu-link::before {
  left: auto;
  right: 18px;
}

[dir=rtl] .menu-vertical .menu-sub .menu-item .menu-link .tag {
  margin-left: 0;
  margin-right: 12px;
}

[dir=rtl] .menu-vertical .menu-sub .menu-item .menu-link .tag::before {
  left: auto;
  right: -3px;
}

[dir=rtl] .right-header-content .header-right-item {
  margin-right: 0;
  margin-left: 25px;
}

[dir=rtl] .right-header-content .header-right-item .notifications.dropdown .dropdown-menu {
  left: 0 !important;
  right: auto !important;
}

[dir=rtl] .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .notification-menu {
  text-align: right;
}

[dir=rtl] .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .notification-menu.unseen::before {
  right: auto;
  left: 20px;
}

[dir=rtl] .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .title {
  display: block;
  text-align: right;
}

[dir=rtl] .right-header-content .header-right-item:last-child {
  margin-left: 0;
}

[dir=rtl] .right-header-content .header-right-item .admin-profile .dropdown-menu {
  left: 0 !important;
  right: auto !important;
}

[dir=rtl] .right-header-content .header-right-item .admin-profile .dropdown-toggle {
  padding-right: 0 !important;
  padding-left: 16px !important;
}

[dir=rtl] .right-header-content .header-right-item .admin-profile .dropdown-toggle::after {
  right: auto;
  left: -4px !important;
}

[dir=rtl] .right-header-content .header-right-item .admin-profile .info {
  text-align: right;
}

[dir=rtl] .offcanvas-header .btn-close {
  margin-right: auto;
  margin-left: 0;
}

[dir=rtl] .left-header-content ul li {
  margin-right: 0;
  margin-left: 25px;
}

[dir=rtl] .left-header-content ul li:last-child {
  margin-left: 0;
}

[dir=rtl] .left-header-content ul li .src-form .src-btn {
  right: auto !important;
  left: 20px !important;
}

@media only screen and (min-width: 1200px) {
  [dir=rtl] .main-wrapper-content.active .sidebar-area:hover .sidebar-burger-menu {
    right: auto !important;
    left: 21px !important;
  }
}

[dir=rtl] .stats-box .count {
  margin-left: 0;
  margin-right: 7px;
}

[dir=rtl] .apexcharts-legend.apexcharts-align-left.apx-legend-position-top {
  right: auto !important;
  left: 0 !important;
}

[dir=rtl] .sales_by_locations li {
  padding-right: 0;
  padding-left: 48px;
}

[dir=rtl] .table-src-form {
  margin-right: 0;
  margin-left: 20px;
}

[dir=rtl] .table-src-form i,
[dir=rtl] .table-src-form span {
  left: auto !important;
  right: 15px !important;
}

[dir=rtl] .table-src-form .form-control {
  padding-left: 0;
  padding-right: 40px;
}

[dir=rtl] .chart-position {
  right: auto;
  left: 15px;
}

[dir=rtl] .default-table-area .table-responsive .table thead tr th:last-child {
  padding-right: 8px !important;
  padding-left: 25px !important;
}

[dir=rtl] .default-table-area .table-responsive .table thead tr th:first-child {
  padding-left: 8px !important;
  padding-right: 25px !important;
}

[dir=rtl] .default-table-area .table-responsive .table tbody tr td:last-child {
  padding-right: 8px !important;
  padding-left: 25px !important;
}

[dir=rtl] .default-table-area .table-responsive .table tbody tr td:first-child {
  padding-left: 8px !important;
  padding-right: 25px !important;
}

[dir=rtl] .default-table-area.email-list .table-responsive .table tbody tr td:last-child {
  padding-right: 8px !important;
  padding-left: 0 !important;
}

[dir=rtl] .default-table-area.email-list .table-responsive .table tbody tr td:first-child {
  padding-left: 8px !important;
  padding-right: 0 !important;
}

[dir=rtl] .default-table-area.email-list .pagination-area {
  right: auto;
  left: 20px;
}

[dir=rtl] .welcome-box.style-two .welcome-2 {
  right: auto;
  left: 0;
}

[dir=rtl] #projects_roadmap {
  direction: ltr;
}

[dir=rtl] #student_interested_topics {
  direction: ltr;
}

[dir=rtl] .courses-slide {
  direction: ltr;
}

[dir=rtl] .courses-slide .flex-grow-1.ms-3 {
  margin-right: 0;
  margin-left: 15px !important;
}

[dir=rtl] .courses-slide .swiper-pagination2 {
  left: auto !important;
  right: 25px !important;
  text-align: right;
}

[dir=rtl] .row.mb-4 .col-lg-8.col-sm-8.pe-sm-0 {
  padding-right: 12px !important;
}

[dir=rtl] .row.mb-4 .col-lg-4.col-sm-4.ps-sm-0 {
  padding-left: 12px !important;
}

[dir=rtl] .row.mb-4 .rounded-3 {
  border-radius: 8px !important;
}

[dir=rtl] .month-select {
  background-position: left 16px center !important;
}

[dir=rtl] .month-select.p-0 {
  background-position: left 0 center !important;
}

[dir=rtl] .congratulations {
  right: auto;
  left: 0;
}

[dir=rtl] .upcoming-events-slide .ms-1 {
  margin-right: 0 !important;
  margin-left: 0.25rem !important;
}

[dir=rtl] .popular-tag {
  left: auto;
  right: 227px;
}

[dir=rtl] .populartsgs {
  right: auto;
  left: 20px;
}

[dir=rtl] .priceing-border::before {
  left: auto;
  right: -130px;
}

[dir=rtl] .priceing-border.style-two::before {
  right: auto;
  left: -130px;
}

[dir=rtl] .timeline-item {
  padding-left: 0;
  padding-right: 90px;
}

[dir=rtl] .timeline-item .border-style-for-timeline {
  padding-left: 0;
  padding-right: 30px;
  border-left: none;
  border-right: 1px dashed #D5D9E2;
}

[dir=rtl] .timeline-item .border-style-for-timeline::before {
  left: auto;
  right: -6px;
}

[dir=rtl] .timeline-item .time-line-date {
  left: auto;
  right: 0;
}

[dir=rtl] .breadcrumb-item+.breadcrumb-item {
  padding-left: 0;
  padding-right: 12px !important;
}

[dir=rtl] .file-subdown {
  padding-left: 0;
  padding-right: 28px;
}

[dir=rtl] .file-subdown li {
  padding-left: 0;
  padding-right: 15px;
}

[dir=rtl] .file-subdown li::before {
  left: auto;
  right: 0;
}

[dir=rtl] .mb-4.transition-y .ps-2 {
  padding-right: 0 !important;
  padding-left: 0.5rem !important;
}

[dir=rtl] .product-quantity .add-to-cart-counter .minusBtn {
  border-radius: 0 4px 4px 0 !important;
}

[dir=rtl] .product-quantity .add-to-cart-counter .plusBtn {
  border-radius: 4px 0 0 4px !important;
}

[dir=rtl] .form-control.form-select {
  background-position: left 0.75rem center;
}

[dir=rtl] #projects_roadmap2 {
  direction: ltr;
}

[dir=rtl] button.btn.border-primary.text-primary.position-absolute.hover-bg {
  right: auto !important;
  left: 24px !important;
}

[dir=rtl] .for-rtl-position {
  right: auto !important;
  left: 25px !important;
}

[dir=rtl] .start-0 {
  left: auto;
  right: 0;
}

[dir=rtl] .ps-20 {
  padding-left: 0;
  padding-right: 20px;
}

[dir=rtl] .end-0 {
  right: auto !important;
  left: 0 !important;
}

[dir=rtl] .ms-lg-auto {
  margin-left: 0 !important;
  margin-right: auto !important;
}

[dir=rtl] i.ri-eye-off-line.password-toggle-icon.translate-middle-y.top-50.end-0.position-absolute {
  right: auto !important;
  left: 15px !important;
}

[dir=rtl] #sales_report {
  direction: ltr;
}

[dir=rtl] #balance_overview {
  direction: ltr;
}

[dir=rtl] #top_sales {
  direction: ltr;
}

[dir=rtl] #returning_customer_rate {
  direction: ltr;
}

[dir=rtl] #projects_progress {
  direction: ltr;
}

[dir=rtl] #project_analysis {
  direction: ltr;
}

[dir=rtl] #time_spent {
  direction: ltr;
}

[dir=rtl] #tickets_status {
  direction: ltr;
}

[dir=rtl] #new_tickets_vs_solved_sickets {
  direction: ltr;
}

[dir=rtl] .apexcharts-legend-text {
  padding-left: 0;
  padding-right: 5px;
  margin-left: 0;
  margin-right: 0;
}

[dir=rtl] .sales_by_locations li .progress-bar .count {
  right: auto;
  left: 0;
}

[dir=rtl] .pagination {
  padding-right: 0;
}

[dir=rtl] .pagination .page-item {
  margin-right: 0;
  margin-left: 7px;
}

[dir=rtl] .pagination .page-item:last-child {
  margin-left: 0;
}

[dir=rtl] .offcanvas {
  right: auto;
  left: 0;
  transform: translateX(-150%);
}

[dir=rtl] .offcanvas.show {
  transform: translateX(0);
}

@media (min-width: 768px) {
  [dir=rtl] .ms-md-3 {
    margin-left: 0 !important;
    margin-right: 1rem !important;
  }
}

@media (min-width: 576px) {
  [dir=rtl] .ms-sm-3 {
    margin-left: 0 !important;
    margin-right: 1rem !important;
  }

  [dir=rtl] .ms-sm-4 {
    margin-left: 0 !important;
    margin-right: 1.5rem !important;
  }
}

[dir=rtl] .action-opt .dropdown-menu li .dropdown-item svg {
  margin-right: 0;
  margin-left: 2px;
}

[dir=rtl] .form-check {
  padding-left: 0;
  padding-right: 1.5em;
}

[dir=rtl] .form-check .form-check-input {
  float: right;
  margin-left: 0;
  margin-right: -1.5em;
}

[dir=rtl] .form-check .form-check-label {
  padding-left: 0;
  padding-right: 5px;
}

[dir=rtl] .dot {
  padding-left: 0;
  padding-right: 15px;
}

[dir=rtl] .dot::before {
  left: auto;
  right: 0;
}

[dir=rtl] .chat-details .own-chat {
  margin-left: 0 !important;
  margin-right: auto;
}

[dir=rtl] .nav-tabs {
  padding-right: 0;
}

[dir=rtl] .accordion-button::after {
  margin-left: 0;
  margin-right: auto;
}

@media (min-width: 992px) {
  [dir=rtl] .ms-lg-5 {
    margin-left: 0 !important;
    margin-right: 3rem !important;
  }
}

@media (min-width: 576px) {
  [dir=rtl] .ps-sm-5 {
    padding-left: 0 !important;
    padding-right: 3rem !important;
  }
}

@media (min-width: 576px) {
  [dir=rtl] .ms-sm-5 {
    margin-left: 0 !important;
    margin-right: 3rem !important;
  }
}

[dir=rtl] .ms-4 {
  margin-left: 0 !important;
  margin-right: 1.5rem !important;
}

[dir=rtl] .faq-wrapper.accordion .accordion-item .accordion-header .accordion-button.control {
  padding-left: 0;
  padding-right: 50px !important;
}

[dir=rtl] .faq-wrapper.accordion .accordion-item .accordion-header .accordion-button.control::after {
  left: auto;
  right: 0;
}

[dir=rtl] .copy-btn {
  left: 40px !important;
}

@media (min-width: 1400px) {
  [dir=rtl] .pe-xxl-5 {
    padding-right: 0 !important;
    padding-left: 3rem !important;
  }
}

@media (min-width: 768px) {
  [dir=rtl] .me-md-5 {
    margin-right: 0 !important;
    margin-left: 3rem !important;
  }
}

[dir=rtl] .password-wrapper .password-toggle-icon {
  right: auto !important;
  left: 15px !important;
}

@media only screen and (max-width: 1199px) {
  [dir=rtl] .sidebar-area {
    left: auto;
    right: -100%;
    z-index: 2;
  }

  [dir=rtl] .sidebar-area .sidebar-burger-menu {
    right: auto !important;
    left: 17px !important;
    z-index: 1 !important;
    opacity: 1 !important;
  }

  [dir=rtl] .main-wrapper-content.active .sidebar-area {
    right: 0;
  }

  [dir=rtl] .main-wrapper-content.active .sidebar-area .sidebar-burger-menu {
    right: auto !important;
    left: 20px !important;
  }

  [dir=rtl] .main-content {
    padding-right: 12px;
    padding-left: 12px;
  }

  [dir=rtl] .right-header-content .header-right-item {
    margin-left: 13px;
  }
}

@media only screen and (max-width: 575px) {
  [dir=rtl] .right-header-content .header-right-item .dropdown.noti .dropdown-menu {
    width: 275px;
    transform: translate(-135px, 41px) !important;
  }

  [dir=rtl] .right-header-content .header-right-item .notifications.language .dropdown-menu {
    left: auto !important;
    right: 0 !important;
  }

  [dir=rtl] .left-header-content ul li .notifications.dropdown .dropdown-menu {
    transform: translate(204px, 30px) !important;
  }
}

@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  [dir=rtl] .main-content {
    padding-left: 12px;
    padding-right: 262px;
  }
}

@media only screen and (min-width: 1400px) and (max-width: 1799px) {
  [dir=rtl] .main-content {
    padding-left: 12px;
    padding-right: 262px;
  }
}

[dir=rtl] .rtl-btn {
  background-color: #d08f2c;
}

[dir=rtl] .settings-btn .slider {
  position: relative;
}

[dir=rtl] .settings-btn .slider:before {
  opacity: 0;
}

[dir=rtl] .settings-btn .slider:after {
  opacity: 1;
}

[dir=rtl] .sales_by_locations li .count {
  right: auto;
  left: 0;
}

[dir=rtl] .apexcharts-canvas {
  direction: ltr;
}

[dir=rtl] .minus-l-20 {
  margin-left: 0;
  margin-right: -20px;
}

[dir=rtl] .minus-l-20:first-child {
  margin-right: 0;
}

[dir=rtl] .ot-course-card ul {
  justify-content: end;
}

[dir=rtl] .courses-slide .swiper-pagination {
  bottom: 15px;
  left: auto;
  right: 10px;
  text-align: right;
}

[dir=rtl] .upcoming-events-slide .d-flex {
  justify-content: end;
}

[dir=rtl] .default-src-form .form-control {
  padding-left: 0;
  padding-right: 35px;
}

[dir=rtl] .default-src-form .start-0 {
  right: 10px;
}

[dir=rtl] .default-table-area .table-responsive .table tbody tr td:first-child {
  border-left: none;
}

[dir=rtl] .default-table-area .table-responsive .table tbody tr td:last-child {
  border-right: none;
}

[dir=rtl] .toast-header .btn-close {
  margin-right: 10px;
  margin-left: 0;
}

[dir=rtl] .custom-modal.right {
  right: auto;
  left: -100%;
}

[dir=rtl] .custom-modal.right.show {
  left: 0;
  right: 0;
}

[dir=rtl] .custom-modal.right .custom-modal-content {
  margin-left: 0;
  margin-right: auto;
}

[dir=rtl] .custom-modal.left {
  left: auto;
  right: -100%;
}

[dir=rtl] .custom-modal.left.show {
  left: 0;
  right: 0;
}

[dir=rtl] .nft-slide .swiper-button-next,
[dir=rtl] .nft-slide-two .swiper-button-next {
  right: auto;
  left: 0;
}

[dir=rtl] .for-rtl-chat .ms-auto {
  margin-left: 0 !important;
  margin-right: auto !important;
  text-align: right;
}

[dir=rtl] .for-rtl-form .start-0 {
  left: auto !important;
  right: 0;
}

[dir=rtl] .for-rtl-form .form-control {
  padding-right: 40px;
}

[dir=rtl] .date-time-picker-demo .react-datetime-picker__wrapper .react-datetime-picker__button {
  margin-left: 0;
  margin-right: 5px;
}

[dir=rtl] .ms-e-10 {
  margin-right: 0;
  margin-left: -10px;
}

[dir=rtl] .action-opt .dropdown-menu .dropdown-item i,
[dir=rtl] .action-opt .dropdown-menu .dropdown-item span {
  margin-right: 0;
  margin-left: 5px;
}

[dir=rtl] .shape.shape-8 {
  right: auto;
  left: 200px;
}

[dir=rtl] .breadcrumb-page-list .breadcrumb .breadcrumb-item::before {
  float: right;
  padding-right: 0;
  padding-left: 0.5rem;
}

[dir=rtl] .select-dropdown {
  right: 0 !important;
  left: -10px;
}

[dir=rtl] .select-dropdown .dropdown-item {
  text-align: right;
}

[dir=rtl] .right-for-rtl {
  right: auto !important;
  left: -10px;
}

[dir=rtl] .position-for-mobile {
  left: auto !important;
  right: 0 !important;
}

[dir=rtl] .position-for-mobile ul.ps-0.mb-0.list-unstyled.last-child-none {
  margin-left: 0 !important;
  margin-right: -110px !important;
}

@media only screen and (max-width: 767px) {
  [dir=rtl] .position-for-mobile {
    position: initial !important;
  }

  [dir=rtl] .position-for-mobile ul.ps-0.mb-0.list-unstyled.last-child-none {
    margin-right: -120px !important;
  }
}

/* Dark Mode Area Style
============================================*/
.dark {
  background-color: #000000 !important;
}

.dark body {
  background-color: #000000 !important;
  color: #fff !important;
}

.dark p,
.dark span,
.dark i,
.dark .apexcharts-text,
.dark td,
.dark th,
.dark a,
.dark label {
  color: #fff;
}

.dark .apexcharts-text {
  fill: #fff;
}

.dark .apexcharts-legend-text {
  color: #fff !important;
}

.dark .text-body {
  color: #fff !important;
}

.dark ul li {
  color: #fff !important;
}

.dark ol li {
  color: #fff !important;
}

.dark .h1,
.dark .h2,
.dark .h3,
.dark .h4,
.dark .h5,
.dark .h6,
.dark h1,
.dark h2,
.dark h3,
.dark h4,
.dark h5,
.dark h6 {
  color: #fff;
}

.dark .text-secondary {
  color: #fff !important;
}

.dark .text-dark {
  color: #fff !important;
}

.dark .bg-white {
  background-color: #101010 !important;
}

.dark .card {
  background-color: #101010 !important;
}

.dark .card.bg-primary {
  background-color: #d08f2c !important;
}

.dark .card.bg-card-bg-c .list-dot li {
  color: #fff !important;
}

.dark .card .bg-body-bg {
  background-color: #000000 !important;
}

.dark .bg-primary p {
  color: #fff !important;
}

.dark .form-control {
  background-color: #212121 !important;
  border-color: #212121 !important;
  color: #fff !important;
}

.dark .form-control:focus {
  border-color: #d08f2c !important;
}

.dark .border {
  border-color: #262626 !important;
}

.dark .border-top {
  border-color: #262626 !important;
}

.dark .border-bottom {
  border-color: #262626 !important;
}

.dark .border-start {
  border-color: #262626 !important;
}

.dark .border-border-color {
  border-color: #262626 !important;
}

.dark .settings-btn {
  color: #fff;
}

.dark .settings-btn span {
  color: #fff;
}

.dark .header-area {
  background-color: #101010 !important;
}

.dark .left-header-content ul li .notifications.dropdown .btn-secondary i,
.dark .left-header-content ul li .notifications.dropdown .btn-secondary span {
  color: #fff;
}

.dark .left-header-content ul li .notifications.dropdown .dropdown-menu {
  background-color: #101010;
}

.dark .left-header-content ul li .notifications.dropdown .dropdown-menu .dropdown-item span {
  color: #fff;
}

.dark .left-header-content ul li .notifications.apps .dropdown-toggle::after {
  display: none;
}

.dark .left-header-content ul li .header-burger-menu i,
.dark .left-header-content ul li .header-burger-menu span {
  color: #fff;
}

.dark .right-header-content .header-right-item .notifications.dropdown .btn-secondary i,
.dark .right-header-content .header-right-item .notifications.dropdown .btn-secondary span {
  color: #fff;
}

.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu {
  background-color: #000000 !important;
  border: 1px solid #333 !important;
}

.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .notification-menu {
  border-color: #1b212a !important;
}

.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .title {
  color: #fff !important;
}

.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .title span {
  color: #fff !important;
}

.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .title button {
  color: #fff !important;
}

.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item i {
  background-color: #373a40;
}

.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item span {
  transition: all ease 0.5s;
  color: #fff !important;
}

.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item p span {
  color: #fff !important;
}

.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:hover,
.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:focus,
.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item.active,
.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:focus-visible {
  background-color: #101010 !important;
}

.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .view-all {
  border-color: #262626;
}

.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .view-all span {
  color: #fff !important;
}

.dark .right-header-content .header-right-item .admin-profile .dropdown-menu {
  background-color: #000000 !important;
  border: 1px solid #333 !important;
}

.dark .right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link {
  border-color: #262626;
}

.dark .right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item i,
.dark .right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item span {
  color: #fff;
}

.dark .right-header-content .header-right-item .theme-settings-btn i,
.dark .right-header-content .header-right-item .theme-settings-btn span {
  color: #fff;
}

.dark .sidebar-burger-menu svg {
  stroke: #fff;
}

.dark .sidebar-area {
  background-color: #101010;
}

.dark .sidebar-area .logo {
  border-color: #262626 !important;
}

.dark .sidebar-area .logo .logo-text {
  color: #fff !important;
}

.dark .sidebar-area .admin .admin-info .name {
  color: #fff;
}

.dark .sidebar-menu {
  /* Track */
  /* Handle */
  /* Handle on hover */
}

.dark .sidebar-menu::-webkit-scrollbar-track {
  background: #333;
}

.dark .sidebar-menu::-webkit-scrollbar-thumb {
  background: #444;
}

.dark .sidebar-menu::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.dark .sidebar-menu .menu-title .menu-title-text {
  color: #fff;
}

.dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button:hover {
  background-color: #222222;
}

.dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button:hover i,
.dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button:hover span {
  color: #fff;
}

.dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .count {
  background-color: rgba(255, 255, 255, 0.0784313725) !important;
  color: #FD5812;
}

.dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button i,
.dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button span {
  color: #fff;
}

.dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .title {
  color: #fff;
}

.dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button[aria-expanded=true] {
  background-color: #222222;
}

.dark .sidebar-menu .menu-item .menu-link {
  color: #3A4252;
}

.dark .sidebar-menu .menu-item .menu-link i,
.dark .sidebar-menu .menu-item .menu-link span {
  color: #fff;
}

.dark .sidebar-menu .menu-item .menu-link .title {
  color: #fff;
}

.dark .sidebar-menu .menu-item .menu-link.logout {
  background-color: #222222;
}

.dark .sidebar-menu .menu-item .menu-link.active,
.dark .sidebar-menu .menu-item .menu-link:hover {
  background-color: #222222;
}

.dark .sidebar-menu .sub-menu .menu-item .menu-link {
  color: #fff;
}

.dark .sidebar-menu .sub-menu .menu-item .menu-link::before {
  border: 1px solid #fff;
}

.dark .sidebar-menu .sub-menu .menu-item .menu-link.active,
.dark .sidebar-menu .sub-menu .menu-item .menu-link:hover {
  background-color: #222222;
  color: #d08f2c;
}

.dark .sidebar-menu .sub-menu .menu-item .menu-link.active::before,
.dark .sidebar-menu .sub-menu .menu-item .menu-link:hover::before {
  opacity: 1;
  border-color: #d08f2c;
}

.dark .sidebar-menu .sub-menu .menu-item .menu-link.active::after,
.dark .sidebar-menu .sub-menu .menu-item .menu-link:hover::after {
  border-color: #fff;
}

.dark .menu-vertical .menu-item .menu-link .title {
  color: #fff;
}

.dark .menu-vertical .menu-item .menu-link i,
.dark .menu-vertical .menu-item .menu-link span {
  color: #fff;
}

.dark .menu-vertical .menu-item .menu-link:hover {
  background-color: #212121;
}

.dark .menu-vertical .menu-item .menu-link.logout {
  background-color: #212121 !important;
}

.dark .menu-vertical .menu-item.open .menu-link.active {
  background-color: #212121;
  color: #d08f2c;
}

.dark .menu-vertical .menu-item.open .menu-link.active .title {
  color: #fff;
}

.dark .menu-vertical .menu-item.open .menu-link.active::before {
  border-color: #d08f2c;
}

.dark .menu-vertical .menu-title .menu-title-text {
  color: #fff;
}

.dark .menu-vertical .menu-sub .menu-item .menu-link {
  color: #c5c5c5;
}

.dark .menu-vertical .menu-sub .menu-item .menu-link::before {
  border-color: #fff;
}

.dark .menu-vertical .menu-sub .menu-item .menu-link.active {
  color: #fff;
}

.dark .menu-vertical .menu-sub .menu-item .menu-link:hover::before {
  border-color: #d08f2c;
  background-color: transparent;
}

.dark .action-opt .dropdown-menu {
  background-color: #000000 !important;
}

.dark .action-opt .dropdown-menu li .dropdown-item {
  color: #fff;
}

.dark .default-table-area .table-responsive .table {
  border-color: #262626;
}

.dark .default-table-area .table-responsive .table thead tr th {
  background-color: #212121;
  color: #fff;
  border-color: #262626;
}

.dark .default-table-area .table-responsive .table tbody tr td {
  color: #fff;
  border-color: #262626;
}

.dark .default-table-area .table-responsive .table tbody tr td a h6,
.dark .default-table-area .table-responsive .table tbody tr td a .h6 {
  color: #fff;
}

.dark .default-table-area .showing-wrap {
  border-color: #262626;
}

.dark .default-table-area.agents-performance-overview.style-three .table-responsive .table tbody tr td {
  border-top: 10px solid #101010;
  background-color: #212121;
}

.dark .pagination .page-item .page-link {
  background: #212121;
  border-color: #212121;
  color: #fff;
}

.dark .pagination .page-item .page-link.active {
  background-color: #d08f2c;
}

.dark .pagination .page-item .page-link:hover {
  background-color: #d08f2c;
}

.dark .footer-area {
  background-color: #101010 !important;
}

.dark .apexcharts-text.apexcharts-datalabel-value {
  fill: #fff !important;
}

.dark .apexcharts-radialbar-hollow {
  fill: #14171c !important;
}

.dark .apexcharts-gridline {
  stroke: #262626;
}

.dark #top_sales .apexcharts-gridline {
  stroke: #101010;
}

.dark #total_orders1 .apexcharts-gridline {
  stroke: #101010;
}

.dark #total_evenue .apexcharts-gridline {
  stroke: #101010;
}

.dark #total_customers .apexcharts-gridline {
  stroke: #101010;
}

.dark .offcanvas {
  background-color: #000000 !important;
}

.dark .offcanvas-header .btn-close {
  opacity: 1;
  filter: invert(1);
}

.dark .offcanvas-header.bg-body-bg {
  background-color: #212121 !important;
}

.dark .form-check-input {
  background-color: transparent;
}

.dark .stats-box.style-three {
  background-color: #212121 !important;
}

.dark .stats-box.style-three span {
  color: #fff;
}

.dark .priceing-border::before {
  border-color: #262626;
}

.dark .faq-wrapper.accordion .accordion-item {
  background-color: transparent;
}

.dark .faq-wrapper.accordion .accordion-item .accordion-body {
  background-color: #212121;
  color: #828690;
}

.dark .faq-wrapper.accordion .accordion-item .accordion-header .accordion-button {
  background-color: #212121 !important;
}

.dark .faq-wrapper.accordion .accordion-item .accordion-header .accordion-button:not(.collapsed) {
  background-color: #212121;
}

.dark .timeline-wrap .timeline-item-2 .text {
  background-color: #212121;
}

.dark .calendar-wrap {
  background-color: transparent;
}

.dark .calendar-wrap .fc tbody tr th {
  border-color: #262626;
  background-color: #212121;
}

.dark .calendar-wrap .fc .fc-col-header-cell-cushion {
  color: #fff;
}

.dark .calendar-wrap .fc .fc-today-button {
  color: #fff;
}

.dark .calendar-wrap .fc-icon-chevron-left:before {
  color: #fff;
}

.dark .calendar-wrap .fc-icon-chevron-right:before {
  color: #fff;
}

.dark .calendar-wrap .fc-theme-standard td,
.dark .calendar-wrap .fc-theme-standard .calendar-wrap .fc-theme-standard th {
  border-color: #262626;
}

.dark .calendar-wrap .fc-theme-standard .fc-scrollgrid {
  border-color: #262626;
}

.dark .calendar-wrap .fc-daygrid-day-number {
  color: #fff;
}

.dark .chat-details li p {
  background-color: #000000;
}

.dark .chat-details li.own-chat p {
  background-color: #d08f2c;
  color: #fff !important;
}

.dark .chat-call-option li button {
  background-color: #212121;
}

.dark .chat-call-option li button:hover {
  background-color: #d08f2c;
}

.dark .bg-gary-light.for-dark {
  background-color: #000000 !important;
}

.dark #editor-container {
  border-color: #262626 !important;
}

.dark .ql-toolbar.ql-snow {
  background-color: #212121;
  border-color: #262626;
}

.dark .ql-snow .ql-picker.ql-expanded .ql-picker-label {
  color: #fff !important;
}

.dark .ql-snow .ql-picker.ql-expanded .ql-picker-label::before {
  color: #fff !important;
}

.dark .ql-snow .ql-stroke {
  stroke: #fff;
}

.dark .kanban-for-dark .rounded-3 {
  background-color: #212121 !important;
}

.dark .file-for-dark.card {
  background-color: #212121 !important;
}

.dark ::-webkit-calendar-picker-indicator {
  filter: invert(1);
}

.dark .seller-tabs .nav-item .nav-link {
  background-color: #212121 !important;
}

.dark .seller-tabs .nav-item .nav-link.active {
  background-color: #d08f2c !important;
}

.dark .bg-body-bg.product-for-dark {
  background-color: #212121 !important;
}

.dark .product-quantity {
  border-color: #1d2127;
}

.dark .product-quantity .add-to-cart-counter .minusBtn,
.dark .product-quantity .product-quantity .add-to-cart-counter .plusBtn {
  background-color: #212121 !important;
}

.dark .product-quantity .add-to-cart-counter .minusBtn:hover,
.dark .product-quantity .product-quantity .add-to-cart-counter .plusBtn:hover {
  background-color: #d08f2c !important;
}

.dark .product-quantity .add-to-cart-counter input {
  background-color: #212121;
  border-color: #212121;
  color: #fff;
}

.dark .product-quantity.bg-e2e8f0 {
  background-color: transparent;
}

.dark .product-quantity.bg-e2e8f0 .add-to-cart-counter .minusBtn,
.dark .product-quantity.bg-e2e8f0 .add-to-cart-counter .plusBtn {
  background-color: #212121;
}

.dark .product-quantity.bg-e2e8f0 .add-to-cart-counter .minusBtn:hover,
.dark .product-quantity.bg-e2e8f0 .add-to-cart-counter .plusBtn:hover {
  background-color: #d08f2c;
}

.dark .product-quantity .add-to-cart-counter .minusBtn,
.dark .product-quantity .add-to-cart-counter .plusBtn {
  background-color: #212121;
}

.dark .product-quantity .add-to-cart-counter .minusBtn:hover,
.dark .product-quantity .add-to-cart-counter .plusBtn:hover {
  background-color: #d08f2c;
}

.dark .product-details-content .border-0.bg-transparent span {
  color: #fff !important;
}

.dark .product-details-content .border-0.bg-transparent .bg-border-color {
  background-color: #212121 !important;
}

.dark .product-details-content .ps-0.mb-0.list-unstyled.d-flex.gap-2.flex-wrap .hover-bg {
  background-color: #212121 !important;
}

.dark .product-details-content .ps-0.mb-0.list-unstyled.d-flex.gap-2.flex-wrap .hover-bg:hover {
  background-color: #d08f2c !important;
}

.dark .review-tabs .nav-item .nav-link {
  border-color: #212121 !important;
}

.dark .review-tabs .nav-item .nav-link.active {
  border-color: #d08f2c !important;
}

.dark .tracking-step.style-two .count {
  background-color: #212121 !important;
}

.dark .bg-for-dark-mode {
  background-color: #000000 !important;
}

.dark .course-accordion.accordion .accordion-item {
  background-color: transparent;
}

.dark .course-accordion.accordion .accordion-item .accordion-body {
  color: #828690;
}

.dark .course-accordion.accordion .accordion-item .accordion-header .accordion-button {
  background-color: #212121 !important;
}

.dark .course-accordion.accordion .accordion-item .accordion-header .accordion-button:not(.collapsed)::after {
  background-color: #b3b3b3;
  border-radius: 100%;
}

.dark .course-accordion.accordion .accordion-item .accordion-header .accordion-button:not(.collapsed) {
  background-color: #212121;
}

.dark .nav-tabs {
  border-color: #262626;
  background-color: transparent !important;
}

.dark .nav-tabs .nav-link {
  border: none;
}

.dark .nav-tabs .nav-link:hover {
  border: none;
}

.dark .nav-tabs .nav-link.active,
.dark .nav-tabs .nav-tabs .nav-item.show .nav-link {
  background-color: #212121;
  border-color: #262626;
  color: #fff;
}

.dark :not(pre)>code[class*=language-],
.dark pre[class*=language-] {
  background: #212121;
}

.dark code[class*=language-],
.dark pre[class*=language-] {
  text-shadow: none;
  color: #fff;
}

.dark .list-group-item {
  border-color: #262626;
  background-color: #000000 !important;
}

.dark .modal-content {
  background-color: #212121;
}

.dark .modal-header {
  border-color: #262626;
  background-color: #101010;
}

.dark .modal-footer {
  border-color: #262626;
  background-color: #101010;
}

.dark #x__PREV__X {
  background-color: #212121;
}

.dark #x__NEXT__X {
  background-color: #212121;
}

.dark .input-group-text {
  background-color: #000000;
  border-color: #000000;
}

.dark .input-group-text img {
  border-radius: 50px;
}

.dark .calendar-content th,
.dark .calendar-content td {
  background-color: #212121;
  color: #fff;
}

.dark .calendar-content .active-date {
  background-color: #d08f2c;
  color: #fff;
}

.dark .calendar-content table {
  background-color: #212121;
}

.dark .form-check .form-check-label {
  color: #fff;
}

.dark .wizard-tabs .nav-item .nav-link {
  background-color: #000000 !important;
}

.dark .wizard-tabs .nav-item .nav-link.active {
  background-color: #d08f2c !important;
}

.dark .wizard-tabs2 .nav-item .nav-link {
  background-color: #101010;
}

.dark .wizard-tabs2 .nav-item .nav-link span {
  background-color: #212121 !important;
}

.dark .wizard-tabs2 .nav-item .nav-link.active span {
  background-color: #d08f2c !important;
}

.dark .for-light-logo {
  display: none;
}

.dark .for-dark-logo {
  display: block;
}

.dark .toast-header {
  background-color: #212121 !important;
  border-color: #262626;
}

.dark .toast-body {
  background-color: #000000 !important;
}

.dark #preloader {
  background-color: #14171c;
}

.dark #preloader .preloader .waviy span {
  color: #fff;
}

.dark div:where(.swal2-container) div:where(.swal2-popup) {
  background-color: #212121;
}

.dark div#swal2-html-container {
  color: #fff;
}

.dark .form-select {
  background-color: #212121;
  border-color: #212121;
}

.dark .welcome-box .border-bottom {
  border-color: #262626 !important;
}

.dark .control-panel-modal .modal-header.bg-body-bg {
  background-color: #000000 !important;
  border-left: 1px solid #333;
  border-bottom: 1px solid #333;
}

.dark .control-panel-modal .modal-header .btn-close {
  background-color: #fff;
  opacity: 1;
  width: 30px;
  height: 30px;
  border-radius: 100px;
}

.dark .control-panel-modal .cpm-content {
  background-color: #000;
  border-left: 1px solid #333;
}

.dark .react-calendar {
  background-color: #101010;
}

.dark .react-calendar .react-calendar__month-view__weekdays .react-calendar__month-view__weekdays__weekday {
  color: #fff;
}

.dark .react-calendar .react-calendar__month-view__days .react-calendar__tile {
  color: #fff;
}

.dark .btn {
  color: #fff;
}

.dark .btn span,
.dark .btn i {
  color: #fff;
}

.dark .kb-card {
  background-color: #212121 !important;
}

.dark code,
.dark pre {
  background-color: #212121 !important;
  color: #fff !important;
}

.dark .navbar.bg-body-tertiary {
  background-color: #000 !important;
}

.dark .trezo-accordion {
  background-color: #212121;
  border: 1px solid #212121;
}

.dark .trezo-accordion .accordion-item {
  background-color: #212121;
  border-color: #444;
}

.dark .trezo-accordion .accordion-item .accordion-button {
  background-color: #212121;
  color: #fff;
}

.dark .react-select__control {
  background-color: #212121;
  border-color: #212121;
}

.dark .react-select__control .react-select__indicator-separator {
  background-color: #474747;
}

.dark .testimonials-card {
  background-color: #212121 !important;
}

.dark .bg-body {
  background-color: #212121 !important;
}

.dark .date-time-picker-demo .react-datetime-picker__wrapper {
  border: 1px solid #000000;
  background: #000000;
}

.dark .date-time-picker-demo .react-datetime-picker__wrapper .react-datetime-picker__button svg {
  stroke: #fff;
}

.dark .date-time-picker-demo .react-calendar {
  border: 1px solid #333;
}

.dark .custom-modal {
  background-color: rgba(0, 0, 0, 0.2);
}

.dark .custom-modal .close-link {
  color: #fff;
}

.dark .custom-modal .custom-modal-header {
  background-color: #000000;
}

.dark .custom-modal .custom-modal-content {
  background-color: #000000;
}

.dark .custom-radio input[type=radio]:checked+.radio-content {
  background: #000000;
}

.dark .bg-border-color {
  background-color: #000 !important;
}

.dark .for-dark-card {
  background-color: #0C1427 !important;
}

.dark .recent-property-slide .bg-white {
  background-color: #000000 !important;
}

.dark .bg-ecf0ff,
.dark .bg-faf5ff,
.dark .bg-fff5ed {
  background-color: #000000;
}

.dark .t-chart .apexcharts-text {
  fill: #fff !important;
}

.dark .t-chart .apexcharts-tooltip-y-group span {
  color: #fff !important;
}

.dark .products-list-tabs li .nav-link {
  background-color: #1c1b1b;
  color: #fff;
}

.dark .badge.completed,
.dark .badge.confirmed,
.dark .badge.active,
.dark .badge.published,
.dark .badge.successful,
.dark .badge.available,
.dark .badge.happening,
.dark .badge.upcoming,
.dark .badge.read {
  color: #d08f2c !important;
}

.dark .accordion-button:not(.collapsed)::after {
  filter: contrast(0.4);
}

.dark .payment-method .text-black {
  color: #717171 !important;
}

.dark .border-gray-100 {
  border-color: #212121 !important;
}

.dark .welcome-for-hotel {
  background-color: #000000 !important;
}

.dark .popular-rooms-slide .swiper-pagination .swiper-pagination-bullet {
  background-color: #555;
  opacity: 1;
}

.dark .popular-rooms-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: #d08f2c;
}

.dark .bg-gray-100 {
  background-color: #212121 !important;
}

.dark .bg-gray-100.border {
  border-color: #212121 !important;
}

.dark .my-featured-listings-bg {
  background-color: #222222 !important;
}

.dark .rea-manage-app {
  background-color: #222222 !important;
}

.dark .rea-client-ratings-card .bg-border-color-50,
.dark .rea-client-ratings-card .bg-danger-100,
.dark .rea-client-ratings-card .bg-success-90 {
  background-color: #222222 !important;
}

.dark .rea-client-ratings-slide .swiper-pagination .swiper-pagination-bullet,
.dark .my-featured-listings-slide .swiper-pagination .swiper-pagination-bullet {
  background-color: #555;
  opacity: 1;
}

.dark .rea-client-ratings-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active,
.dark .my-featured-listings-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: #d08f2c;
}

.dark .cc-card {
  background-image: inherit !important;
}

.dark .gradient-card-dark {
  background: #222222 !important;
}

.dark .bg-black-for-dark {
  background-color: #000 !important;
}

.dark-top-navbar .header-area {
  background-color: #101010 !important;
}

.dark-top-navbar .left-header-content p,
.dark-top-navbar .left-header-content span {
  color: #fff;
}

.dark-top-navbar .left-header-content ul li .src-form .form-control {
  background-color: #212121;
  border-color: #212121;
  color: #fff !important;
}

.dark-top-navbar .left-header-content ul li .notifications.dropdown .btn-secondary i,
.dark-top-navbar .left-header-content ul li .notifications.dropdown .btn-secondary span {
  color: #fff;
}

.dark-top-navbar .left-header-content ul li .notifications.dropdown .dropdown-menu {
  background-color: #101010;
}

.dark-top-navbar .left-header-content ul li .notifications.dropdown .dropdown-menu .dropdown-item span {
  color: #fff;
}

.dark-top-navbar .left-header-content ul li .notifications.apps .dropdown-toggle::after {
  display: none;
}

.dark-top-navbar .left-header-content ul li .header-burger-menu i,
.dark-top-navbar .left-header-content ul li .header-burger-menu span {
  color: #fff;
}

.dark-top-navbar .right-header-content p,
.dark-top-navbar .right-header-content span {
  color: #fff;
}

.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .btn-secondary i,
.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .btn-secondary span {
  color: #fff;
}

.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu {
  background-color: #000000 !important;
  border: 1px solid #333 !important;
}

.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .notification-menu {
  border-color: #1b212a !important;
}

.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .title {
  color: #fff !important;
}

.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .title span {
  color: #fff !important;
}

.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .title button {
  color: #fff !important;
}

.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item i,
.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item span {
  background-color: #373a40;
}

.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item span {
  transition: all ease 0.5s;
  color: #fff !important;
}

.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item p {
  color: #fff;
}

.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item p span {
  color: #fff !important;
}

.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:hover {
  background-color: #101010 !important;
}

.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .view-all {
  border-color: #262626;
}

.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .view-all span {
  color: #fff !important;
}

.dark-top-navbar .right-header-content .header-right-item .admin-profile h3,
.dark-top-navbar .right-header-content .header-right-item .admin-profile .h3 {
  color: #fff;
}

.dark-top-navbar .right-header-content .header-right-item .admin-profile .dropdown-menu {
  background-color: #000000 !important;
  border: 1px solid #333 !important;
}

.dark-top-navbar .right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link {
  border-color: #262626;
}

.dark-top-navbar .right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item i,
.dark-top-navbar .right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item span {
  color: #fff;
}

.dark-top-navbar .right-header-content .header-right-item .theme-settings-btn i,
.dark-top-navbar .right-header-content .header-right-item .theme-settings-btn span {
  color: #fff;
}

.left-sidebar-dark .sidebar-area {
  background-color: #101010;
}

.left-sidebar-dark .sidebar-area .logo {
  border-color: #262626 !important;
}

.left-sidebar-dark .sidebar-area .logo .logo-text {
  color: #fff !important;
}

.left-sidebar-dark .sidebar-area .sidebar-burger-menu {
  color: #fff;
}

.left-sidebar-dark .sidebar-area .admin .admin-info .name {
  color: #fff;
}

.left-sidebar-dark .sidebar-menu {
  /* Track */
  /* Handle */
  /* Handle on hover */
}

.left-sidebar-dark .sidebar-menu::-webkit-scrollbar-track {
  background: #333;
}

.left-sidebar-dark .sidebar-menu::-webkit-scrollbar-thumb {
  background: #444;
}

.left-sidebar-dark .sidebar-menu::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.left-sidebar-dark .sidebar-menu .menu-title .menu-title-text {
  color: #fff;
}

.left-sidebar-dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button:hover {
  background-color: #222222;
}

.left-sidebar-dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button:hover i,
.left-sidebar-dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button:hover span {
  color: #fff;
}

.left-sidebar-dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button i,
.left-sidebar-dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button span {
  color: #fff;
}

.left-sidebar-dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .title {
  color: #fff;
}

.left-sidebar-dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button[aria-expanded=true] {
  background-color: #222222;
}

.left-sidebar-dark .sidebar-menu .menu-item .menu-link {
  color: #3A4252;
}

.left-sidebar-dark .sidebar-menu .menu-item .menu-link i,
.left-sidebar-dark .sidebar-menu .menu-item .menu-link span {
  color: #fff;
}

.left-sidebar-dark .sidebar-menu .menu-item .menu-link .title {
  color: #fff;
}

.left-sidebar-dark .sidebar-menu .menu-item .menu-link.logout {
  background-color: #222222;
}

.left-sidebar-dark .sidebar-menu .menu-item .menu-link.active,
.left-sidebar-dark .sidebar-menu .menu-item .menu-link:hover {
  background-color: #222222;
}

.left-sidebar-dark .sidebar-menu .sub-menu .menu-item .menu-link {
  color: #fff;
}

.left-sidebar-dark .sidebar-menu .sub-menu .menu-item .menu-link::before {
  border: 1px solid #fff;
}

.left-sidebar-dark .sidebar-menu .sub-menu .menu-item .menu-link.active,
.left-sidebar-dark .sidebar-menu .sub-menu .menu-item .menu-link:hover {
  background-color: #222222;
  color: #d08f2c;
}

.left-sidebar-dark .sidebar-menu .sub-menu .menu-item .menu-link.active::before,
.left-sidebar-dark .sidebar-menu .sub-menu .menu-item .menu-link:hover::before {
  opacity: 1;
  border-color: #d08f2c;
}

.left-sidebar-dark .sidebar-menu .sub-menu .menu-item .menu-link.active::after,
.left-sidebar-dark .sidebar-menu .sub-menu .menu-item .menu-link:hover::after {
  border-color: #fff;
}

/* Only Radius Square Area Style
============================================*/
[card-radius-square-data-theme=card-radius] .card-style-btn {
  background-color: #d08f2c;
}

[card-radius-square-data-theme=card-radius] .card {
  border-radius: 0 !important;
}

[card-radius-square-data-theme=card-radius] .btn {
  border-radius: 0;
}

[card-radius-square-data-theme=card-radius] .rounded {
  border-radius: 0 !important;
}

[card-radius-square-data-theme=card-radius] .header-area {
  border-radius: 0 !important;
}

[card-radius-square-data-theme=card-radius] .rounded-top-7 {
  border-radius: 0 !important;
}

[card-radius-square-data-theme=card-radius] .pagination .page-item .page-link {
  border-radius: 0;
}

[card-radius-square-data-theme=card-radius] .form-control {
  border-radius: 0 !important;
}

[card-radius-square-data-theme=card-radius] .right-header-content .header-right-item .notifications.dropdown .btn-secondary {
  border-radius: 0;
}

[card-radius-square-data-theme=card-radius] .menu-vertical .menu-item .menu-link {
  border-radius: 0;
}

[card-radius-square-data-theme=card-radius] .settings-btn {
  border-radius: 0;
}

[card-radius-square-data-theme=card-radius] .radius {
  display: inline-block;
}

[card-radius-square-data-theme=card-radius] .square {
  display: none;
}

/* Only Card Background Area Style
============================================*/
[card-bg-data-theme=card-bg-gray] {
  background-color: #fff !important;
}

[card-bg-data-theme=card-bg-gray] .card-bg-style-btn {
  background-color: #d08f2c;
}

[card-bg-data-theme=card-bg-gray] .card {
  background-color: #F6F7F9 !important;
}

[card-bg-data-theme=card-bg-gray] .card.bg-primary-div {
  background-color: #d08f2c !important;
}

[card-bg-data-theme=card-bg-gray] .card.bg-primary {
  background-color: #d08f2c !important;
}

[card-bg-data-theme=card-bg-gray] .header-area {
  background-color: #F6F7F9 !important;
}

[card-bg-data-theme=card-bg-gray] .sidebar-area {
  background-color: #F6F7F9 !important;
}

[card-bg-data-theme=card-bg-gray] .footer-area {
  background-color: #F6F7F9 !important;
}

[card-bg-data-theme=card-bg-gray] .sidebar-area .admin .admin-info {
  background-color: #F6F7F9 !important;
}

[card-bg-data-theme=card-bg-gray] .offcanvas {
  background-color: #F6F7F9 !important;
}

[card-bg-data-theme=card-bg-gray] .white {
  display: inline-block;
}

[card-bg-data-theme=card-bg-gray] .gray {
  display: none;
}

/* Fluid & Boxed Area Style
============================================*/
[boxed-style-data-theme=boxed-style-boxed].boxed-size {
  width: 1440px;
  margin: auto;
}

[boxed-style-data-theme=boxed-style-boxed] .fluid-boxed-btn {
  background-color: #d08f2c;
}

[boxed-style-data-theme=boxed-style-boxed] .fluid {
  display: inline-block;
}

[boxed-style-data-theme=boxed-style-boxed] .boxed {
  display: none;
}

[boxed-style-data-theme=boxed-style-boxed] .sidebar-area {
  inset-inline-start: auto !important;
}

[boxed-style-data-theme=boxed-style-boxed] .priceing-border::before {
  left: -67px;
}

[boxed-style-data-theme=boxed-style-boxed] .popular-tag {
  left: 160px;
}

@media only screen and (min-width: 1920px) {
  [boxed-style-data-theme=boxed-style-boxed] .custom-xxxl-10 {
    flex: 0 0 auto;
    width: 66.6666666667%;
  }

  [boxed-style-data-theme=boxed-style-boxed] .custom-xxxl-2 {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
}

/* Landing Page Area Style
============================================*/
.ptb-150 {
  padding-top: 150px;
  padding-bottom: 150px;
}

.pt-150 {
  padding-top: 150px;
}

.pb-150 {
  padding-bottom: 150px;
}

.pb-125 {
  padding-bottom: 125px;
}

.pt-125 {
  padding-top: 125px;
}

.fs-60 {
  font-size: 60px;
}

.shape {
  position: absolute;
  z-index: -1;
}

.shape.shape-1 {
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}

.shape.shape-2 {
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

.shape.shape-3 {
  top: 0;
  left: 0;
}

.shape.shape-4 {
  top: 200px;
  right: 0;
}

.shape.shape-5 {
  bottom: -100px;
  left: 0;
}

.shape.shape-6 {
  bottom: -250px;
  right: 0;
}

.shape.shape-7 {
  top: -180px;
  left: 0;
  filter: blur(125px);
}

.shape.shape-8 {
  top: -160px;
  right: 200px;
  filter: blur(75px);
}

.shape.shape-9 {
  bottom: 0;
  left: 0;
  filter: blur(75px);
}

.shape.shape-10 {
  bottom: 0;
  right: 0;
  filter: blur(75px);
}

.navbar {
  padding: 20px 0;
}

.navbar.sticky {
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 10;
  animation: 500ms ease-in-out 0s normal none 1 running fadeInDown;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  background-color: #fff !important;
}

.navbar .white-logo {
  display: none;
}

.navbar .btn:hover {
  color: #fff !important;
}

.navbar-nav .nav-link.active {
  color: #d08f2c !important;
}

.page-banner-area {
  padding-top: 195px;
}

.page-banner-area .shape-5 {
  top: -220px;
  left: -50px;
  z-index: -1;
  position: absolute;
  filter: blur(150px);
}

.page-banner-area .shape-6 {
  bottom: 0;
  z-index: -1;
  right: -30px;
  position: absolute;
  filter: blur(250px);
}

.banner-content {
  margin-bottom: 75px;
}

.banner-area {
  padding-top: 185px;
  padding-bottom: 150px;
  background-position: center -350px !important;
}

.banner-content {
  margin-bottom: 75px;
}

.top-title {
  color: #d08f2c;
  border: 1px solid #d08f2c;
  padding: 5.5px 17px;
  display: inline-block;
  position: relative;
  transform: rotate(-6.536deg);
  margin-bottom: 10px;
}

.top-title::before,
.top-title::after {
  content: "";
  position: absolute;
  top: -4px;
  right: -4px;
  width: 7px;
  height: 7px;
  background-color: #d08f2c;
}

.top-title::after {
  right: auto;
  left: -4px;
}

.top-title span::before,
.top-title span::after {
  content: "";
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 7px;
  height: 7px;
  background-color: #d08f2c;
}

.top-title span::after {
  right: auto;
  left: -4px;
}

.section-title {
  max-width: 848px;
  margin: auto;
  margin-bottom: 60px;
  text-align: center;
}

.section-title.mw-630 {
  max-width: 630px;
}

.section-title h2,
.section-title .h2 {
  font-size: 36px;
  line-height: 1.4;
  letter-spacing: -1px;
}

.section-title h2:last-child,
.section-title .h2:last-child {
  margin-bottom: 0;
}

.key-features-single-item {
  margin-bottom: 25px;
}

.key-features-single-item i,
.key-features-single-item span {
  width: 85px;
  height: 85px;
  line-height: 85px;
  font-size: 55px;
  text-align: center;
  border-radius: 17px;
  margin-bottom: 20px;
}

.key-features-single-item h3,
.key-features-single-item .h3 {
  font-size: 24px;
  margin-bottom: 15px;
  font-weight: 600;
}

.tailor-content h2,
.tailor-content .h2 {
  font-size: 36px;
  line-height: 1.4;
  letter-spacing: -1px;
  margin-bottom: 60px;
}

.tailor-content ul li {
  margin-bottom: 30px;
}

.tailor-content ul li:last-child {
  margin-bottom: 0;
}

.masonrow {
  -moz-column-width: 25em;
  -webkit-column-width: 25em;
  -moz-column-gap: 1.6em;
  -webkit-column-gap: 1.6em;
}

.masonrow .item {
  width: 100%;
  margin-bottom: 25px;
  display: inline-block;
}

.masonrow.style-two {
  -moz-column-width: 22em;
  -webkit-column-width: 22em;
  -moz-column-gap: 1.6em;
  -webkit-column-gap: 1.6em;
}

.masonrow.style-two .item {
  width: 100%;
  margin-bottom: 30px;
  display: inline-block;
}

.single-testimonials {
  background-color: #fff;
  border-radius: 10px;
  padding: 40px;
  position: relative;
  display: block;
}

.single-testimonials .reating {
  margin-bottom: 22px;
}

.single-testimonials .reating li {
  display: inline-block;
}

.single-testimonials .reating li i,
.single-testimonials .reating li span {
  color: #FFBC2B;
  font-size: 20px;
}

.single-testimonials p {
  margin-bottom: 22px;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.9;
}

.single-testimonials .review-info h4,
.single-testimonials .review-info .h4 {
  font-size: 16px;
  margin-bottom: 5px;
}

.single-testimonials .review-info span {
  font-size: 14px;
}

.team-slide .swiper-pagination {
  position: initial;
  margin-top: 30px;
}

.team-slide .swiper-pagination .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
}

.team-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background-color: #d08f2c;
}

.our-team-single-item .team-img {
  border-radius: 7px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: rgba(255, 255, 255, 0.26);
  backdrop-filter: blur(3.5999999046px);
  padding: 16px;
}

.our-team-single-item .team-img img {
  border-radius: 7px;
}

.our-team-single-item .team-content {
  border-radius: 7px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: rgba(255, 255, 255, 0.26);
  backdrop-filter: blur(3.5999999046px);
  padding: 30px;
  margin-top: -1px;
}

.team-controller .controller-icon {
  width: 64px;
  height: 64px;
  line-height: 64px;
  text-align: center;
  background-color: #ECF0FF;
  display: inline-block;
  font-size: 20px;
  border-radius: 100px;
  transition: all ease 0.5s;
}

.team-controller .controller-icon:hover {
  background-color: #d08f2c;
  color: #fff;
}

.contact-us-img {
  border-radius: 7px;
  border: 1px solid rgba(255, 255, 255, 0.13);
  background: rgba(255, 255, 255, 0.31);
  backdrop-filter: blur(5.0999999046px);
  padding: 16px;
}

.contact-us-img img {
  border-radius: 7px;
}

.contact-us-form h2,
.contact-us-form .h2 {
  font-size: 36px;
  line-height: 1.4;
  letter-spacing: -1px;
  margin-bottom: 60px;
}

.unlock-content {
  max-width: 825px;
  margin: auto;
  text-align: center;
}

.unlock-content h2,
.unlock-content .h2 {
  font-size: 48px;
  letter-spacing: -1.5px;
  line-height: 1.4;
  margin-bottom: 20px;
}

.unlock-content p {
  margin-bottom: 45px;
}

#backtotop {
  position: fixed;
  top: 100%;
  right: 30px;
  bottom: 30px;
  margin: auto;
  width: 40px;
  height: 40px;
  border: none;
  background-color: #d08f2c;
  transform: translateY(-100%);
  z-index: 2;
  transition: all ease 0.5s;
  font-size: 20px;
  border-radius: 4px;
}

#backtotop i,
#backtotop span {
  color: #fff;
}

#backtotop:hover {
  background-color: #d08f2c;
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .ptb-150 {
    padding-top: 60px;
    padding-bottom: 60px;
  }

  .pt-150 {
    padding-top: 60px;
  }

  .pb-150 {
    padding-bottom: 60px;
  }

  .pb-125 {
    padding-bottom: 35px;
  }

  .pt-125 {
    padding-top: 35px;
  }

  .fs-60 {
    font-size: 30px;
  }

  .banner-area {
    padding-top: 145px;
    padding-bottom: 60px;
  }

  .banner-content {
    margin-bottom: 30px;
  }

  .banner-content p {
    font-size: 16px !important;
  }

  .section-title {
    margin-bottom: 35px;
  }

  .section-title h2,
  .section-title .h2 {
    font-size: 25px;
  }

  .key-features-single-item i,
  .key-features-single-item span {
    width: 70px;
    height: 70px;
    line-height: 70px;
    font-size: 40px;
  }

  .key-features-single-item h3,
  .key-features-single-item .h3 {
    font-size: 20px;
  }

  .tailor-content {
    margin-top: 30px;
  }

  .tailor-content h2,
  .tailor-content .h2 {
    font-size: 25px;
    margin-bottom: 35px;
  }

  .single-testimonials {
    padding: 25px;
  }

  .single-testimonials .reating {
    margin-bottom: 15px;
  }

  .single-testimonials p {
    margin-bottom: 15px;
    font-size: 15px;
  }

  .team-controller .controller-icon {
    width: 45px;
    height: 45px;
    line-height: 45px;
  }

  .our-team-single-item .team-content {
    padding: 20px;
  }

  .shape.shape-3 {
    top: auto;
    bottom: 0;
  }

  .contact-us-form h2,
  .contact-us-form .h2 {
    font-size: 25px;
    margin-bottom: 30px;
  }

  .unlock-content h2,
  .unlock-content .h2 {
    font-size: 25px;
    margin-bottom: 15px;
  }

  .unlock-content p {
    margin-bottom: 20px;
  }
}

/* Min width 768px to Max width 992px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .ptb-150 {
    padding-top: 60px;
    padding-bottom: 60px;
  }

  .pt-150 {
    padding-top: 60px;
  }

  .pb-150 {
    padding-bottom: 60px;
  }

  .pb-125 {
    padding-bottom: 35px;
  }

  .pt-125 {
    padding-top: 35px;
  }

  .fs-60 {
    font-size: 50px;
  }

  .banner-area {
    padding-top: 145px;
    padding-bottom: 60px;
  }

  .banner-content {
    margin-bottom: 30px;
  }

  .banner-content p {
    font-size: 16px !important;
  }

  .section-title {
    margin-bottom: 35px;
  }

  .section-title h2,
  .section-title .h2 {
    font-size: 30px;
  }

  .key-features-single-item i,
  .key-features-single-item span {
    width: 70px;
    height: 70px;
    line-height: 70px;
    font-size: 40px;
  }

  .key-features-single-item h3,
  .key-features-single-item .h3 {
    font-size: 20px;
  }

  .tailor-content {
    margin-top: 30px;
  }

  .tailor-content h2,
  .tailor-content .h2 {
    font-size: 30px;
    margin-bottom: 35px;
  }

  .single-testimonials {
    padding: 25px;
  }

  .single-testimonials .reating {
    margin-bottom: 15px;
  }

  .single-testimonials p {
    margin-bottom: 15px;
    font-size: 15px;
  }

  .team-controller .controller-icon {
    width: 45px;
    height: 45px;
    line-height: 45px;
  }

  .our-team-single-item .team-content {
    padding: 20px;
  }

  .contact-us-form h2,
  .contact-us-form .h2 {
    font-size: 30px;
    margin-bottom: 30px;
  }

  .unlock-content h2,
  .unlock-content .h2 {
    font-size: 35px;
    margin-bottom: 15px;
  }

  .unlock-content p {
    margin-bottom: 20px;
  }
}

/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {

  .contact-us-form h2,
  .contact-us-form .h2 {
    font-size: 35px;
  }
}

@media only screen and (max-width: 991px) {
  .navbar {
    background-color: #fff;
  }

  .navbar.bg-opacity-25 {
    --bs-bg-opacity: 1 !important;
  }

  .navbar-toggler:focus {
    box-shadow: none;
  }
}

.footer-logo .white-logo {
  display: none;
}

[dir=rtl] .our-team-area .section-title.mw-630 {
  margin-left: auto !important;
  margin-right: 0 !important;
}

.dark .navbar.sticky {
  background-color: #000 !important;
}

.dark .navbar .black-logo {
  display: none;
}

.dark .navbar .white-logo {
  display: block !important;
}

.dark .single-testimonials {
  background-color: #101010;
}

.dark .our-team-single-item .team-img {
  border: 1px solid #101010;
  background: #101010;
}

.dark .our-team-single-item .team-content {
  border: 1px solid #101010;
  background: #101010;
}

.dark .faq-wrapper.accordion .accordion-item .accordion-header .accordion-button {
  color: #fff;
}

.dark .footer-logo .white-logo {
  display: block;
}

.dark .footer-logo .black-logo {
  display: none;
}

.dark .copyright-area.bg-white {
  background-color: #101010 !important;
}

@media only screen and (max-width: 991px) {
  .dark .navbar {
    background-color: #000;
  }
}

/* Analytics Dashboard Area Style
============================================*/
.analytics-tabs {
  border: 1px solid #ECEEF2;
  border-radius: 7px;
}

.analytics-tabs li button {
  padding: 3px 15px;
  border: 0;
  background-color: transparent;
  color: #fff;
}

.analytics-tabs li button.active {
  background-color: #ECF0FF;
}

.analytics-tabs li button:hover {
  background-color: #ECF0FF;
}

.analytics-tabs li:nth-child(2) button {
  border-left: 1px solid #ECEEF2;
  border-right: 1px solid #ECEEF2;
}

.cryptocurrency-controller .controller-icon {
  width: 30px;
  height: 30px;
  line-height: 29px;
  text-align: center;
  border: 1px solid #ECEEF2;
  display: inline-block;
  font-size: 17px;
  border-radius: 4px;
  transition: all ease 0.5s;
}

.cryptocurrency-controller .controller-icon:hover {
  background-color: #d08f2c;
  color: #fff;
}

@media only screen and (max-width: 575px) {
  .analytics-tabs {
    margin-bottom: 10px !important;
  }

  .analytics-tabs li button {
    padding: 3px 12px;
  }
}

/* Min width 1400px to Max width 1799px */
@media only screen and (min-width: 1400px) and (max-width: 1799px) {
  .ms-minus-27 {
    margin-left: -27px;
  }

  .me-plus-27 {
    margin-right: 27px;
  }

  .ms-plus-21 {
    margin-left: 21px;
  }
}

/* Marketing Area Style
============================================*/
/* Marketing Dashboard CSS */
.create-campaigns-tabs {
  max-width: 960px;
  margin: auto;
  margin-bottom: 60px;
}

.create-campaigns-tabs .tab button {
  position: relative;
  padding: 0;
  padding-bottom: 5px;
  letter-spacing: 2px;
}

.create-campaigns-tabs .tab button::before {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0;
  height: 2px;
  background-color: #d08f2c;
  transition: all ease 0.5s;
}

.create-campaigns-tabs .tab.active button {
  color: #d08f2c !important;
}

.create-campaigns-tabs .tab.active button::before {
  width: 100%;
  right: auto;
  left: 0;
}

.custom-radio {
  width: 100%;
  position: relative;
  cursor: pointer;
}

.custom-radio input[type=radio] {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: #e2e4e7;
  width: 20px;
  height: 20px;
  margin-top: 2px;
}

.custom-radio input[type=radio]:checked+.radio-content:after {
  content: "";
  position: absolute;
  height: 20px;
  width: 20px;
  background: #d08f2c;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 100%;
  border: 3px solid #fff;
  box-shadow: 0px 0px 0px 2px #d08f2c;
}

.custom-radio input[type=radio]:checked+.radio-content {
  border: 2px dashed #d08f2c;
  background: #ECEEF2;
  transition: ease-in 0.3s;
}

.custom-radio input[type=radio]:focus {
  box-shadow: none;
}

.custom-radio .radio-content {
  border: 2px dashed #e2e4e7;
  border-radius: 10px;
  position: relative;
  padding: 18px;
  padding-left: 55px;
}

.custom-radio.style-two input[type=radio] {
  left: 0;
  width: 30px;
  height: 30px;
  margin-top: -9px;
}

.custom-radio.style-two input[type=radio]:checked+.radio-content:after {
  left: 0;
  width: 30px;
  height: 30px;
}

.custom-radio.style-two input[type=radio]:checked+.radio-content {
  border: none;
  background-color: transparent;
}

.custom-radio.style-two .radio-content {
  padding: 0;
  border: none;
  padding-left: 45px;
}

.form-check {
  position: relative;
}

.form-check.style .form-check-label {
  padding: 0 0 0 40px;
  color: #000;
}

.form-check.style .form-check-input {
  width: 30px;
  height: 30px;
  border: 0;
  background-color: #ECEEF2;
  margin: 0;
  position: absolute;
  left: 0;
  top: 5px;
}

.form-check.style .label-description {
  padding-left: 40px;
}

.form-check.style .form-check-input:checked {
  background-color: #d08f2c;
}

.form-check.style.after-check .form-check-input {
  width: 20px;
  height: 20px;
  border: 0;
}

.form-check.style.after-check .form-check-input::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px dashed #ECEEF2;
  z-index: 1;
  border-radius: 6px;
}

.form-check.style.after-check .form-check-input::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: -1;
  border-radius: 6px;
}

.form-check.style.after-check .form-check-input:checked {
  background-color: #d08f2c;
}

.form-check.style.after-check .form-check-input:checked::before {
  border-color: #5DA8FF;
}

.form-check.style.after-check .form-check-input:checked::after {
  background-color: #ECEEF2;
}

.tab-content-wrap .tab-contents {
  display: none;
}

.tab-content-wrap .tab-contents.active {
  display: block;
}

.tab-content-wrap .tab-contents.back-none {
  position: relative;
}

.tab-content-wrap .tab-contents.back-none::before {
  content: "";
  position: absolute;
  bottom: -88px;
  left: -560px;
  right: 0;
  margin: auto;
  width: 625px;
  height: 50px;
  background-color: #f6f7f9;
}

@media only screen and (max-width: 767px) {
  .create-campaigns-tabs {
    margin-bottom: 30px;
  }
}

[dir=rtl] .form-check {
  position: relative;
}

[dir=rtl] .form-check.style .form-check-label {
  padding: 0 40px 0 0;
}

[dir=rtl] .form-check.style .form-check-input {
  left: auto;
  right: 0;
}

[dir=rtl] .form-check.style .label-description {
  padding-left: 0;
  padding-right: 40px;
}

.dark .form-check.style .form-check-label {
  color: #fff;
}

.dark .form-check.style .form-check-input {
  background-color: #2f2f2f;
}

/* FNT Area Style
============================================*/
/* NFT Dashboard CSS */
.place-bid .opacity-0 {
  transition: all ease 0.5s;
}

.place-bid:hover .opacity-0 {
  opacity: 1 !important;
}

.nft-slide {
  margin-top: -95px;
}

.nft-slide .swiper-button-prev,
.nft-slide .swiper-button-next {
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #3A4252;
  color: #C2CDFF;
  border-radius: 100px;
  transition: all ease 0.5s;
}

.nft-slide .swiper-button-prev::after,
.nft-slide .swiper-button-next::after {
  font-size: 18px;
}

.nft-slide .swiper-button-prev:hover,
.nft-slide .swiper-button-next:hover {
  background-color: #d08f2c;
}

.nft-slide .swiper-button-prev.swiper-button-disabled,
.nft-slide .swiper-button-prev.swiper-button-disabled,
.nft-slide .swiper-button-next.swiper-button-disabled,
.nft-slide .swiper-button-next.swiper-button-disabled {
  pointer-events: auto;
}

.nft-slide .swiper-button-prev {
  left: 0;
}

.nft-slide .swiper-button-next {
  right: 0;
}

.nft-slide-two .swiper-button-prev,
.nft-slide-two .swiper-button-next {
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #3A4252;
  color: #C2CDFF;
  border-radius: 100px;
  transition: all ease 0.5s;
}

.nft-slide-two .swiper-button-prev::after,
.nft-slide-two .swiper-button-next::after {
  font-size: 18px;
}

.nft-slide-two .swiper-button-prev:hover,
.nft-slide-two .swiper-button-next:hover {
  background-color: #d08f2c;
}

.nft-slide-two .swiper-button-prev.swiper-button-disabled,
.nft-slide-two .swiper-button-prev.swiper-button-disabled,
.nft-slide-two .swiper-button-next.swiper-button-disabled,
.nft-slide-two .swiper-button-next.swiper-button-disabled {
  pointer-events: auto;
}

.nft-slide-two .swiper-button-prev {
  left: 0;
}

.nft-slide-two .swiper-button-next {
  right: 0;
}

.top-collections-slide .swiper-pagination {
  position: initial;
  margin-top: 15px;
  line-height: 1;
}

.ethereum-rate-tabs {
  margin-bottom: 30px;
  border: 0;
}

.ethereum-rate-tabs .nav-item .nav-link {
  width: 47px;
  height: 32px;
  padding: 0;
  border: 0;
  font-weight: 600;
  font-size: 12px;
  border-radius: 4px;
  color: #64748B;
}

.ethereum-rate-tabs .nav-item .nav-link.active {
  background-color: #d08f2c !important;
  color: #fff !important;
}

.swiper-pagination-top-collections.swiper-pagination-clickable .swiper-pagination-bullet {
  background-color: #526077;
}

.live-auction .nav-item .nav-link {
  padding: 0;
}

.live-auction .nav-item .nav-link.active {
  color: #d08f2c !important;
}

.clockdiv {
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(12px);
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  margin: 6px;
}

.clockdiv .time {
  color: #3A4252;
  font-size: 14px;
  font-weight: 700;
  position: relative;
}

.clockdiv .time::before {
  content: ":";
  position: absolute;
  right: -10px;
}

.clockdiv .time:last-child::before {
  display: none;
}

.clockdiv .days {
  position: relative;
  padding-right: 10px;
}

.clockdiv .days::before {
  content: "d";
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

.clockdiv .hours {
  position: relative;
  padding-right: 10px;
}

.clockdiv .hours::before {
  content: "h";
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

.clockdiv .minutes {
  position: relative;
  padding-right: 15px;
}

.clockdiv .minutes::before {
  content: "m";
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

.clockdiv .seconds {
  position: relative;
  padding-right: 10px;
}

.clockdiv .seconds::before {
  content: "s";
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .manage-nft {
    padding: 20px !important;
    padding-bottom: 120px !important;
  }

  .nft-detail-tabs .nav-item .nav-link {
    width: 50px !important;
  }
}

/* Min width 768px to Max width 992px */
/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .nft-detail-tabs .nav-item .nav-link {
    width: 50px !important;
  }
}

/* Min width 1200px to Max width 1399px */
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .nft-detail-tabs .nav-item .nav-link {
    width: 60px !important;
  }
}

/* Min width 1400px to Max width 1799px */
/* Restaurant Area Style
============================================*/
.welcome-restaurant {
  padding: 60px 30px;
  padding-bottom: 57px;
}

.welcome-restaurant h2,
.welcome-restaurant .h2 {
  color: #fff;
  font-size: 32px;
  font-weight: 700;
  line-height: 125%;
  letter-spacing: -0.5px;
  max-width: 326px;
  margin-bottom: 30px;
}

.welcome-restaurant .dish-wrap {
  position: absolute;
  top: 50%;
  right: 38px;
  transform: translateY(-50%);
}

.welcome-restaurant .dish-wrap .dish-img {
  animation: rotateAndReverse 4s linear infinite;
}

.welcome-restaurant .dish-wrap .dish-shape {
  position: absolute;
  top: 0;
  right: 30px;
}

.welcome-restaurant .dish-wrap .dish-shape1 {
  position: absolute;
  top: -10px;
  left: -15px;
}

.welcome-restaurant .dish-wrap .dish-shape2 {
  position: absolute;
  bottom: -10px;
  right: -15px;
}

@keyframes rotateAndReverse {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

.revenue-card {
  padding: 22px 24px;
}

.revenue-card h2,
.revenue-card .h2 {
  font-size: 32px;
  font-weight: 700;
  line-height: 125%;
  letter-spacing: -0.5px;
  margin-bottom: 0;
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .welcome-restaurant {
    padding: 20px;
  }

  .welcome-restaurant h2,
  .welcome-restaurant .h2 {
    font-size: 20px;
    max-width: 200px;
    margin-bottom: 15px;
  }
}

@media only screen and (max-width: 520px) {
  .dish-wrap {
    display: none;
  }
}

/* Min width 768px to Max width 992px */
/* Min width 992px to Max width 1199px */
/* Min width 1200px to Max width 1399px */
/* Min width 1400px to Max width 1799px */
.dark .welcome-restaurant {
  background-color: #FE7A36 !important;
}

[dir=rtl] .welcome-restaurant .dish-wrap {
  right: auto;
  left: 38px;
}

.dish-details-images-card {
  padding: 13px;
  margin-bottom: 15px;
  border-radius: 7px;
}

.dish-details-card {
  padding: 25px;
  border-radius: 7px;
}

.dish-details-card .trezo-card-content .text-xs {
  font-size: 12px;
}

.dish-details-card .trezo-card-content h3,
.dish-details-card .trezo-card-content .h3 {
  font-size: 24px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.dish-details-card .trezo-card-content .price {
  font-size: 16px;
  color: #EC1F00;
}

.dish-details-card .trezo-card-content .ratings {
  font-size: 15px;
  color: #FE7A36;
}

.dish-details-card .trezo-card-content .ratings i {
  margin-right: 2px;
}

.dish-details-card .trezo-card-content .ratings i:last-child {
  margin-right: 0;
}

.dish-details-card .trezo-card-content .ratings span.text-xs {
  font-size: 12px;
  margin-left: 2px;
}

.dish-details-card .trezo-card-content .border-top {
  border-color: #ECEEF2 !important;
  margin-top: 25px;
  margin-bottom: 25px;
}

.dish-details-card .trezo-card-content h4,
.dish-details-card .trezo-card-content .h4 {
  font-size: 18px;
  margin-bottom: 12px;
}

.dish-details-card .trezo-card-content .nutrition-values {
  margin-bottom: 25px;
  margin-top: 15px;
}

.dish-details-card .trezo-card-content .nutrition-values .item {
  padding: 10px 20px;
  border: 1px solid #ECEEF2;
}

.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(1) .item,
.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(2) .item,
.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(3) .item,
.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(4) .item,
.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(5) .item,
.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(6) .item {
  border-bottom-width: 0;
}

.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(1) .item,
.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(3) .item,
.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(5) .item,
.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(7) .item,
.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(9) .item,
.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(11) .item {
  border-right-width: 0;
}

.dark .dish-details-card .trezo-card-content .ratings i {
  color: #FE7A36;
}

.dark .dish-details-card .trezo-card-content .border-top {
  border-color: #333 !important;
}

.dark .dish-details-card .trezo-card-content .nutrition-values .item {
  border: 1px solid #333;
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .dish-details-card {
    height: auto;
  }

  .dish-details-card .trezo-card-content h3,
  .dish-details-card .trezo-card-content .h3 {
    font-size: 20px;
    margin-top: 8px;
    margin-bottom: 8px;
  }

  .dish-details-card .trezo-card-content .price {
    font-size: 14px;
  }

  .dish-details-card .trezo-card-content .ratings {
    margin-top: 12px;
  }

  .dish-details-card .trezo-card-content .border-top {
    margin-top: 17px;
    margin-bottom: 17px;
  }

  .dish-details-card .trezo-card-content h4,
  .dish-details-card .trezo-card-content .h4 {
    font-size: 16px;
  }

  .dish-details-card .trezo-card-content .mb-25 {
    margin-bottom: 17px !important;
  }

  .dish-details-card .trezo-card-content .nutrition-values {
    margin-bottom: 17px;
    margin-top: 15px;
  }

  .dish-details-card .trezo-card-content .nutrition-values .item {
    padding: 10px 15px;
  }

  .dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(7) .item {
    border-bottom-width: 0;
  }

  .dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(1) .item,
  .dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(3) .item,
  .dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(5) .item,
  .dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(7) .item,
  .dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(9) .item,
  .dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(11) .item {
    border-right-width: 1px;
  }
}

/* Min width 576px to Max width 767px */
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .dish-details-card .trezo-card-content .border-top {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .dish-details-card .trezo-card-content .mb-25 {
    margin-bottom: 20px !important;
  }

  .dish-details-card .trezo-card-content .nutrition-values {
    margin-bottom: 20px;
  }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .dish-details-card {
    height: auto;
  }

  .dish-details-card .trezo-card-content h3,
  .dish-details-card .trezo-card-content .h3 {
    font-size: 22px;
  }

  .dish-details-card .trezo-card-content .price {
    font-size: 15px;
  }

  .dish-details-card .trezo-card-content h4,
  .dish-details-card .trezo-card-content .h4 {
    font-size: 17px;
  }
}

/* Min width 992px to Max width 1199px */
/* Min width 1200px to Max width 1399px */
/* Min width 1600px */
.with-horizontal-navbar .header-area {
  position: fixed;
  left: 0;
  right: 0;
  border-radius: 0 0 7px 7px !important;
}

.with-horizontal-navbar .header-area::before {
  left: 0;
  right: 0;
  top: 75px;
  content: "";
  height: 1px;
  position: absolute;
  background: #ECEEF2;
}

.with-horizontal-navbar .header-area .container-fluid,
.with-horizontal-navbar .header-area .container-sm,
.with-horizontal-navbar .header-area .container-md,
.with-horizontal-navbar .header-area .container-lg,
.with-horizontal-navbar .header-area .container-xl,
.with-horizontal-navbar .header-area .container-xxl {
  max-width: 1295px;
}

.with-horizontal-navbar .header-area .logo-box {
  display: block !important;
}

.horizontal-navbar-area {
  max-width: 1295px;
  margin-top: 13px;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 0;
  padding-top: 13px;
  display: none;
}

.horizontal-navbar-area .accordion {
  gap: 6px;
}

.horizontal-navbar-area .accordion .accordion-item {
  background-color: transparent;
  color: #3A4252;
  white-space: nowrap;
  position: relative;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-button {
  display: flex;
  align-items: center;
  color: #3A4252;
  font-size: 14px;
  background-color: transparent;
  padding-bottom: 9px;
  padding-right: 33px;
  padding-left: 14px;
  padding-top: 9px;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-button i {
  transition: all ease 0.5s;
  color: #fff;
  margin-right: 7px;
  font-size: 22px;
  line-height: 1;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-button .trezo-badge {
  padding: 0;
  width: 20px;
  height: 20px;
  font-size: 11px;
  line-height: 20px;
  color: #FD5812;
  background-color: #fff5ed;
  margin-left: 11px;
  margin-right: 0;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-button .trezo-badge.style-two {
  color: #00b69b;
  background: rgba(0, 182, 155, 0.07);
}

.horizontal-navbar-area .accordion .accordion-item .accordion-button .trezo-badge.style-three {
  color: #ee368c;
  background: rgba(238, 54, 140, 0.1);
}

.horizontal-navbar-area .accordion .accordion-item .accordion-button::after {
  display: none;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-button::before {
  top: 50%;
  right: 8px;
  margin-top: 1px;
  content: "\\ea4e";
  position: absolute;
  color: #fff;
  transform: translateY(-50%);
  transition: all ease 0.5s;
  font-size: 19px;
  font-family: remixicon;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-button:hover {
  color: #3A4252;
  background-color: #f6f7f9;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-button:hover i {
  color: #3A4252;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-button:hover::before {
  color: #3A4252;
}

.horizontal-navbar-area .accordion .accordion-item:has(.active) .accordion-button {
  color: #3A4252;
  background-color: #f6f7f9;
}

.horizontal-navbar-area .accordion .accordion-item:has(.active) .accordion-button i {
  color: #3A4252;
}

.horizontal-navbar-area .accordion .accordion-item:has(.active) .accordion-button::before {
  color: #3A4252;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body {
  left: 0;
  top: 100%;
  opacity: 0;
  z-index: 1;
  width: 270px;
  padding: 12px 0;
  margin-top: 13px;
  position: absolute;
  visibility: hidden;
  transition: all ease 0.5s;
  background-color: #fff;
  box-shadow: 0 0.25rem 1.125rem 0 rgba(47, 43, 61, 0.1);
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button {
  color: #fff;
  font-size: 14px;
  background-color: transparent;
  padding-bottom: 10px;
  padding-right: 10px;
  padding-left: 31px;
  padding-top: 10px;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button::after {
  top: 50%;
  left: 13px;
  width: 10px;
  content: "";
  height: 10px;
  transition: 0.3s;
  border-radius: 50%;
  position: absolute;
  display: inline-block;
  transform: translateY(-50%);
  background: unset !important;
  border: 1px solid #fff;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button i {
  margin-right: 0;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button:hover,
.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button.active {
  background-color: #ecf0ff;
  color: #d08f2c;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button:hover i,
.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button.active i {
  color: #d08f2c;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button:hover::after,
.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button.active::after {
  border-color: #d08f2c;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button:hover::before,
.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button.active::before {
  color: #d08f2c;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button .trezo-badge {
  top: 50%;
  padding: 0;
  right: 34px;
  width: 20px;
  height: 20px;
  font-size: 11px;
  line-height: 20px;
  position: absolute;
  color: #FD5812;
  transform: translateY(-50%);
  background-color: #fff5ed;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button .trezo-badge.style-two {
  color: #00b69b;
  background: rgba(0, 182, 155, 0.07);
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button .trezo-badge.style-three {
  color: #ee368c;
  background: rgba(238, 54, 140, 0.1);
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button.with-icon {
  display: flex !important;
  align-items: center;
  padding-left: 12px;
  gap: 7px;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button.with-icon i {
  font-size: 21px;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button.with-icon::after {
  display: none;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item {
  position: relative;
  padding-left: 12px;
  padding-right: 12px;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link {
  color: #fff;
  font-size: 14px;
  text-decoration: none;
  border-radius: 5px;
  padding-bottom: 10px;
  padding-right: 12px;
  padding-left: 31px;
  padding-top: 10px;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link::after {
  top: 50%;
  left: 13px;
  width: 10px;
  content: "";
  height: 10px;
  transition: 0.3s;
  border-radius: 50%;
  position: absolute;
  transform: translateY(-50%);
  border: 1px solid #fff;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link:hover,
.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link.active {
  background-color: #ecf0ff;
  color: #d08f2c;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link:hover::after,
.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link.active::after {
  border-color: #d08f2c;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge {
  top: -1px;
  padding: 2px 6px;
  margin-left: 10px;
  border-radius: 3px;
  line-height: initial;
  color: #FD5812;
  background-color: #ffe8d4;
  font-size: 10px;
  font-weight: normal;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge::before {
  top: 50%;
  left: -3px;
  width: 6px;
  height: 6px;
  content: "";
  position: absolute;
  background: #ffe8d4;
  transform: translateY(-50%) rotate(45deg);
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge.style-two {
  color: #37D80A;
  background-color: #d8ffc8;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge.style-two::before {
  background: #d8ffc8;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge.style-three {
  color: #d08f2c;
  background-color: #eae0f3;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge.style-three::before {
  background: #eae0f3;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link.with-icon {
  display: flex !important;
  align-items: center;
  padding-left: 12px;
  gap: 7px;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link.with-icon i {
  font-size: 21px;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link.with-icon::after {
  display: none;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
  top: 0;
  left: 100%;
  opacity: 0;
  margin-top: 0;
  visibility: hidden;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
  opacity: 0;
  visibility: hidden;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
  opacity: 0;
  visibility: hidden;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item:hover .accordion-body {
  opacity: 1;
  visibility: visible;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item:hover .accordion-body {
  opacity: 1;
  visibility: visible;
}

.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item:hover .accordion-body {
  opacity: 1;
  visibility: visible;
}

.horizontal-navbar-area .accordion .accordion-item.megamenu {
  position: inherit;
}

.horizontal-navbar-area .accordion .accordion-item.megamenu .accordion-body {
  width: auto;
  right: 0;
  padding-left: 12px;
  padding-right: 12px;
}

.horizontal-navbar-area .accordion .accordion-item.megamenu .accordion-body .sidebar-sub-menu {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-left: -5px;
  margin-right: -5px;
}

.horizontal-navbar-area .accordion .accordion-item.megamenu .accordion-body .sidebar-sub-menu .sidemenu-item {
  flex: 0 0 auto;
  width: 25%;
  padding-left: 5px;
  padding-right: 5px;
}

.horizontal-navbar-area .accordion .accordion-item:hover .accordion-body {
  opacity: 1;
  visibility: visible;
}

.horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body {
  left: auto;
  right: 0;
}

.horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
  left: -100%;
}

.horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
  left: 100%;
}

.horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
  left: 100%;
}

.dark .with-horizontal-navbar .header-area::before {
  background: #172036;
}

.dark .with-horizontal-navbar .header-area .logo {
  display: none;
}

.dark .with-horizontal-navbar .header-area .logo.white-logo {
  display: block;
}

.dark .horizontal-navbar-area .accordion .accordion-item {
  color: #fff;
}

.dark .horizontal-navbar-area .accordion .accordion-item>.accordion-button {
  color: #fff;
}

.dark .horizontal-navbar-area .accordion .accordion-item>.accordion-button .title {
  color: #fff;
}

.dark .horizontal-navbar-area .accordion .accordion-item>.accordion-button .trezo-badge {
  background-color: rgba(255, 255, 255, 0.08);
}

.dark .horizontal-navbar-area .accordion .accordion-item>.accordion-button .trezo-badge.style-two {
  background-color: rgba(255, 255, 255, 0.08);
}

.dark .horizontal-navbar-area .accordion .accordion-item>.accordion-button .trezo-badge.style-three {
  background-color: rgba(255, 255, 255, 0.08);
}

.dark .horizontal-navbar-area .accordion .accordion-item>.accordion-button:hover {
  color: #fff;
  background-color: #212121;
}

.dark .horizontal-navbar-area .accordion .accordion-item>.accordion-button:hover i {
  color: #fff;
}

.dark .horizontal-navbar-area .accordion .accordion-item>.accordion-button:hover::before {
  color: #fff;
}

.dark .horizontal-navbar-area .accordion .accordion-item:has(.active) .accordion-button {
  color: #fff;
  background-color: #212121;
}

.dark .horizontal-navbar-area .accordion .accordion-item:has(.active) .accordion-button i {
  color: #fff;
}

.dark .horizontal-navbar-area .accordion .accordion-item:has(.active) .accordion-button::before {
  color: #fff;
}

.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body {
  background-color: #0c1427;
}

.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button:hover,
.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button.active {
  background-color: #212121;
}

.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button .trezo-badge {
  background-color: rgba(255, 255, 255, 0.08);
}

.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button .trezo-badge.style-two {
  background-color: rgba(255, 255, 255, 0.08);
}

.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button .trezo-badge.style-three {
  background-color: rgba(255, 255, 255, 0.08);
}

.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link {
  color: #8695aa;
}

.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link::after {
  border-color: #8695aa;
}

.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link:hover,
.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link.active {
  background-color: #212121;
  color: #d08f2c;
}

.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link:hover::after,
.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link.active::after {
  border-color: #d08f2c;
}

.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge {
  background: rgba(255, 255, 255, 0.08);
}

.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge::before {
  background: rgba(255, 255, 255, 0.08);
}

.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge.style-two {
  background: rgba(255, 255, 255, 0.08);
}

.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge.style-two::before {
  background: rgba(255, 255, 255, 0.08);
}

.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge.style-three {
  background: rgba(255, 255, 255, 0.08);
}

.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge.style-three::before {
  background: rgba(255, 255, 255, 0.08);
}

.with-horizontal-navbar .dark.header-area::before {
  background: #172036;
}

.with-horizontal-navbar .dark.header-area .logo {
  display: none;
}

.with-horizontal-navbar .dark.header-area .logo.white-logo {
  display: block;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-button {
  padding-right: 14px;
  padding-left: 33px;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-button i {
  margin-right: 0;
  margin-left: 7px;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-button .trezo-badge {
  margin-left: 0;
  margin-right: 11px;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-button::before {
  right: auto;
  left: 8px;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body {
  left: auto;
  right: 0;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button {
  padding-right: 31px;
  padding-left: 10px;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button::after {
  left: auto;
  right: 13px;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button i {
  margin-left: 0;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button .trezo-badge {
  right: auto;
  left: 34px;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button.with-icon {
  padding-left: 0;
  padding-right: 12px;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link {
  padding-right: 31px;
  padding-left: 12px;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link::after {
  left: auto;
  right: 13px;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge {
  margin-left: 0;
  margin-right: 5px;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge::before {
  left: auto;
  right: -3px;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link.with-icon {
  padding-left: 0;
  padding-right: 12px;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
  left: auto;
  right: 100%;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item.megamenu .accordion-body {
  left: 0;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body {
  left: 0;
  right: auto;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
  left: auto;
  right: -100%;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
  left: auto;
  right: 100%;
}

[dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
  left: auto;
  right: 100%;
}

.main-wrapper-content.with-horizontal-navbar .horizontal-navbar-area {
  display: block;
}

.main-wrapper-content.with-horizontal-navbar .main-content {
  padding-left: 25px;
  padding-right: 25px;
  padding-top: 162px;
  max-width: 1340px;
  margin-right: auto;
  margin-left: auto;
}

/* Max width 575px */
@media only screen and (max-width: 575px) {
  .main-wrapper-content.with-horizontal-navbar .main-content {
    padding-top: 140px;
    padding-left: 15px;
    padding-right: 15px;
  }
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .horizontal-navbar-area {
    display: none;
  }

  .main-wrapper-content.with-horizontal-navbar .horizontal-navbar-area {
    display: none;
  }

  .main-wrapper-content.with-horizontal-navbar .header-area::before {
    display: none;
  }

  .main-wrapper-content.with-horizontal-navbar .header-area .logo-box {
    display: none !important;
  }
}

/* Min width 576px to Max width 767px */
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .main-wrapper-content.with-horizontal-navbar .main-content {
    padding-top: 95px;
  }
}

/* Min width 768px to Max width 991px */
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .horizontal-navbar-area {
    display: none;
  }

  .main-wrapper-content.with-horizontal-navbar .horizontal-navbar-area {
    display: none;
  }

  .main-wrapper-content.with-horizontal-navbar .header-area::before {
    display: none;
  }

  .main-wrapper-content.with-horizontal-navbar .header-area .logo-box {
    display: none !important;
  }

  .main-wrapper-content.with-horizontal-navbar.with-horizontal-navbar .main-content {
    padding-top: 95px;
  }
}

/* Min width 992px to Max width 1199px */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .main-wrapper-content.with-horizontal-navbar .left-header-content ul li .src-form .form-control {
    width: 215px;
  }

  .horizontal-navbar-area {
    max-width: 100%;
  }

  .horizontal-navbar-area .accordion .accordion-item .accordion-body {
    width: 250px;
  }

  .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body,
  .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body {
    left: auto;
    right: 0;
  }

  .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,
  .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
    left: -100%;
  }

  .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,
  .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
    left: -100%;
  }

  .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,
  .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
    left: 100%;
  }

  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body,
  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body {
    left: 0;
    right: auto;
  }

  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,
  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
    left: auto;
    right: -100%;
  }

  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,
  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
    left: auto;
    right: -100%;
  }

  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,
  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
    left: auto;
    right: 100%;
  }
}

/* Min width 992px */
@media only screen and (min-width: 992px) {
  .with-horizontal-navbar .header-area .hbm {
    display: none;
  }

  .with-horizontal-navbar .header-area .logo.white-logo {
    display: none;
  }

  .main-wrapper-content.with-horizontal-navbar .sidebar-area {
    display: none;
  }
}

/* Min width 1200px to Max width 1399px */
@media only screen and (min-width: 1200px) and (max-width: 1399px) {
  .horizontal-navbar-area {
    max-width: 100%;
  }

  .horizontal-navbar-area .accordion .accordion-item .accordion-body {
    width: 250px;
  }

  .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body,
  .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body {
    left: auto;
    right: 0;
  }

  .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,
  .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
    left: -100%;
  }

  .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,
  .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
    left: -100%;
  }

  .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,
  .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
    left: 100%;
  }

  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body,
  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body {
    left: 0;
    right: auto;
  }

  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,
  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
    left: auto;
    right: -100%;
  }

  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,
  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
    left: auto;
    right: -100%;
  }

  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,
  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {
    left: auto;
    right: 100%;
  }
}

/* Min width 1600px */
@media only screen and (min-width: 1600px) {

  .with-horizontal-navbar .header-area .container-fluid,
  .with-horizontal-navbar .header-area .container-sm,
  .with-horizontal-navbar .header-area .container-md,
  .with-horizontal-navbar .header-area .container-lg,
  .with-horizontal-navbar .header-area .container-xl,
  .with-horizontal-navbar .header-area .container-xxl {
    max-width: 1545px;
  }

  .horizontal-navbar-area {
    max-width: 1545px;
  }

  .main-wrapper-content.with-horizontal-navbar .main-content {
    max-width: 1596px;
  }
}

.theme-settings-btn {
  background-color: transparent;
}

.theme-settings-btn i {
  animation: roundedAnimation 2s infinite linear;
  transition: transform 0.3s ease;
}

@keyframes roundedAnimation {
  0% {
    transform: rotate(0deg);
    border-radius: 0%;
  }

  50% {
    transform: rotate(180deg);
    border-radius: 50%;
  }

  100% {
    transform: rotate(360deg);
    border-radius: 0%;
  }
}

[dir=rtl] .theme-settings-btn {
  right: auto;
  left: 20px;
}

.settings-sidebar {
  bottom: 0;
  opacity: 0;
  z-index: 100;
  right: -100%;
  width: 380px;
  height: 100%;
  position: fixed;
  visibility: hidden;
  box-shadow: 0 4px 20px rgba(47, 143, 232, 0.0705882353) !important;
  overflow-y: auto;
}

.settings-sidebar .settings-header {
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  position: sticky;
  padding: 16.5px 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.settings-sidebar .settings-header h4,
.settings-sidebar .settings-header .h4 {
  font-size: 16px;
  margin: 0;
  line-height: 1;
  font-weight: 500;
}

.settings-sidebar .settings-header .close-btn {
  padding: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: block !important;
  line-height: 1;
}

.settings-sidebar .settings-header .close-btn i {
  font-size: 20px;
  color: #fff !important;
}

.settings-sidebar .settings-body {
  padding-top: 25px;
  padding-left: 25px;
  padding-right: 25px;
  padding-bottom: 25px;
}

.settings-sidebar .settings-body .title {
  margin-bottom: 15px;
  display: block;
  color: #3A4252;
  font-weight: 600;
}

.settings-sidebar .settings-body .switch-btn {
  gap: 25px;
  display: grid;
  color: #3A4252;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding: 0;
  cursor: pointer;
  border: none;
}

.settings-sidebar .settings-body .switch-btn .box {
  width: 140px;
  height: 100px;
  border-radius: 5px;
  border: 1px solid #f1f0f3;
  transition: all ease 0.5s;
  position: relative;
}

.settings-sidebar .settings-body .switch-btn .box span:nth-child(1) {
  top: 0;
  right: 0;
  width: 96px;
  height: 11px;
  position: absolute;
  background: #f1f0f3;
  border-radius: 0 5px 0 5px;
}

.settings-sidebar .settings-body .switch-btn .box span:nth-child(2) {
  right: 0;
  bottom: 0;
  width: 96px;
  height: 11px;
  position: absolute;
  background: #f1f0f3;
  border-radius: 5px 0 5px 0;
}

.settings-sidebar .settings-body .switch-btn .box span:nth-child(3) {
  top: 0;
  left: 0;
  bottom: 0;
  width: 36px;
  position: absolute;
  background: #f1f0f3;
  border-radius: 5px 0 0 5px;
}

.settings-sidebar .settings-body .switch-btn .box span:nth-child(4) {
  top: 14px;
  left: 7px;
  width: 20px;
  height: 20px;
  position: absolute;
  border-radius: 50%;
  background: #d6d2df;
}

.settings-sidebar .settings-body .switch-btn .box span:nth-child(5) {
  left: 7px;
  top: 45px;
  width: 20px;
  height: 5px;
  position: absolute;
  border-radius: 30px;
  background: #d6d2df;
}

.settings-sidebar .settings-body .switch-btn .box span:nth-child(6) {
  left: 7px;
  top: 55px;
  width: 20px;
  height: 5px;
  position: absolute;
  border-radius: 30px;
  background: #d6d2df;
}

.settings-sidebar .settings-body .switch-btn .box span:nth-child(7) {
  left: 7px;
  top: 65px;
  width: 20px;
  height: 5px;
  position: absolute;
  border-radius: 30px;
  background: #d6d2df;
}

.settings-sidebar .settings-body .switch-btn .box span:nth-child(8) {
  top: 35px;
  left: 46px;
  width: 20px;
  height: 11px;
  position: absolute;
  background: #f1f0f3;
  border: 1px solid #f1f0f3;
}

.settings-sidebar .settings-body .switch-btn .box span:nth-child(9) {
  top: 35px;
  left: 78px;
  width: 20px;
  height: 11px;
  position: absolute;
  background: #f1f0f3;
  border: 1px solid #f1f0f3;
}

.settings-sidebar .settings-body .switch-btn .box span:nth-child(10) {
  top: 35px;
  left: 110px;
  width: 20px;
  height: 11px;
  position: absolute;
  background: #f1f0f3;
  border: 1px solid #f1f0f3;
}

.settings-sidebar .settings-body .switch-btn .box span:nth-child(11) {
  top: 55px;
  left: 46px;
  width: 20px;
  height: 11px;
  position: absolute;
  background: #f1f0f3;
  border: 1px solid #f1f0f3;
}

.settings-sidebar .settings-body .switch-btn .box span:nth-child(12) {
  top: 55px;
  left: 78px;
  width: 20px;
  height: 11px;
  position: absolute;
  background: #f1f0f3;
  border: 1px solid #f1f0f3;
}

.settings-sidebar .settings-body .switch-btn .box span:nth-child(13) {
  top: 55px;
  left: 110px;
  width: 20px;
  height: 11px;
  position: absolute;
  background: #f1f0f3;
  border: 1px solid #f1f0f3;
}

.settings-sidebar .settings-body .switch-btn .box:hover {
  border-color: #d08f2c;
}

.settings-sidebar .settings-body .switch-btn .first .box {
  border-color: #d08f2c;
}

.settings-sidebar .settings-body .switch-btn .first .sub-title {
  display: flex;
  align-items: center;
}

.settings-sidebar .settings-body .switch-btn .first .sub-title .dot-checkbox {
  border-color: #d08f2c;
  background-color: #d08f2c;
  position: relative;
}

.settings-sidebar .settings-body .switch-btn .first .sub-title .dot-checkbox::before {
  opacity: 1;
  visibility: visible;
}

.settings-sidebar .settings-body .switch-btn .sub-title {
  gap: 8px;
  margin-top: 10px;
  display: flex;
  align-items: center;
}

.settings-sidebar .settings-body .switch-btn .sub-title .dot-checkbox {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #f1f0f3;
  transition: all ease 0.5s;
  position: relative;
}

.settings-sidebar .settings-body .switch-btn .sub-title .dot-checkbox::before {
  left: 0;
  right: 0;
  top: 50%;
  opacity: 0;
  content: "\\eb7b";
  visibility: hidden;
  position: absolute;
  font-family: remixicon;
  color: #fff;
  transform: translateY(-48%);
  transition: all ease 0.5s;
}

.settings-sidebar .settings-body .switch-btn .sub-title .dot-checkbox.active {
  border-color: #d08f2c;
  background-color: #d08f2c;
}

.settings-sidebar .settings-body .switch-btn .sub-title .dot-checkbox.active::before {
  opacity: 1;
  visibility: visible;
}

.settings-sidebar .settings-body .switch-btn.ltr-rtl-btn .second span:nth-child(1),
.settings-sidebar .settings-body .switch-btn.left-right-sidebar-btn .second span:nth-child(1) {
  left: 0;
  right: auto;
  border-radius: 5px 0 5px 0;
}

.settings-sidebar .settings-body .switch-btn.ltr-rtl-btn .second span:nth-child(2),
.settings-sidebar .settings-body .switch-btn.left-right-sidebar-btn .second span:nth-child(2) {
  border-radius: 0 5px 0 5px;
  right: auto;
  left: 0;
}

.settings-sidebar .settings-body .switch-btn.ltr-rtl-btn .second span:nth-child(3),
.settings-sidebar .settings-body .switch-btn.left-right-sidebar-btn .second span:nth-child(3) {
  right: 0;
  left: auto;
  border-radius: 0 5px 5px 0;
}

.settings-sidebar .settings-body .switch-btn.ltr-rtl-btn .second span:nth-child(4),
.settings-sidebar .settings-body .switch-btn.left-right-sidebar-btn .second span:nth-child(4) {
  left: auto;
  right: 7px;
}

.settings-sidebar .settings-body .switch-btn.ltr-rtl-btn .second span:nth-child(5),
.settings-sidebar .settings-body .switch-btn.left-right-sidebar-btn .second span:nth-child(5) {
  left: auto;
  right: 7px;
}

.settings-sidebar .settings-body .switch-btn.ltr-rtl-btn .second span:nth-child(6),
.settings-sidebar .settings-body .switch-btn.left-right-sidebar-btn .second span:nth-child(6) {
  left: auto;
  right: 7px;
}

.settings-sidebar .settings-body .switch-btn.ltr-rtl-btn .second span:nth-child(7),
.settings-sidebar .settings-body .switch-btn.left-right-sidebar-btn .second span:nth-child(7) {
  left: auto;
  right: 7px;
}

.settings-sidebar .settings-body .switch-btn.light-dark-btn .second .box {
  background-color: #000000;
}

.settings-sidebar .settings-body .switch-btn.light-dark-btn .second .box span:nth-child(1) {
  background: rgba(255, 255, 255, 0.2);
}

.settings-sidebar .settings-body .switch-btn.light-dark-btn .second .box span:nth-child(2) {
  background: rgba(255, 255, 255, 0.2);
}

.settings-sidebar .settings-body .switch-btn.light-dark-btn .second .box span:nth-child(3) {
  background: rgba(255, 255, 255, 0.2);
}

.settings-sidebar .settings-body .switch-btn.light-dark-btn .second .box span:nth-child(4) {
  background: rgba(214, 210, 223, 0.5);
}

.settings-sidebar .settings-body .switch-btn.light-dark-btn .second .box span:nth-child(5) {
  background: rgba(214, 210, 223, 0.5);
}

.settings-sidebar .settings-body .switch-btn.light-dark-btn .second .box span:nth-child(6) {
  background: rgba(214, 210, 223, 0.5);
}

.settings-sidebar .settings-body .switch-btn.light-dark-btn .second .box span:nth-child(7) {
  background: rgba(214, 210, 223, 0.5);
}

.settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(8),
.settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(9),
.settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(10),
.settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(11),
.settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(12),
.settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(13) {
  border-color: #d6d2df;
}

.settings-sidebar .settings-body .switch-btn.card-shape-btn .first .box span:nth-child(8),
.settings-sidebar .settings-body .switch-btn.card-shape-btn .first .box span:nth-child(9),
.settings-sidebar .settings-body .switch-btn.card-shape-btn .first .box span:nth-child(10),
.settings-sidebar .settings-body .switch-btn.card-shape-btn .first .box span:nth-child(11),
.settings-sidebar .settings-body .switch-btn.card-shape-btn .first .box span:nth-child(12),
.settings-sidebar .settings-body .switch-btn.card-shape-btn .first .box span:nth-child(13) {
  border-radius: 10px;
}

.settings-sidebar .settings-body .switch-btn.compact-sidebar-btn .second .box span:nth-child(1) {
  width: 108px;
}

.settings-sidebar .settings-body .switch-btn.compact-sidebar-btn .second .box span:nth-child(2) {
  width: 108px;
}

.settings-sidebar .settings-body .switch-btn.compact-sidebar-btn .second .box span:nth-child(3) {
  width: 24px;
}

.settings-sidebar .settings-body .switch-btn.compact-sidebar-btn .second .box span:nth-child(4) {
  left: 4px;
  width: 15px;
  height: 15px;
}

.settings-sidebar .settings-body .switch-btn.compact-sidebar-btn .second .box span:nth-child(5) {
  left: 4px;
  width: 15px;
}

.settings-sidebar .settings-body .switch-btn.compact-sidebar-btn .second .box span:nth-child(6) {
  left: 4px;
  width: 15px;
}

.settings-sidebar .settings-body .switch-btn.compact-sidebar-btn .second .box span:nth-child(7) {
  left: 4px;
  width: 15px;
}

.settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(8),
.settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(9),
.settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(10),
.settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(11),
.settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(12),
.settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(13) {
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.settings-sidebar .settings-body .switch-btn.sidebar-btn .second span:nth-child(3) {
  background: #000000;
}

.settings-sidebar .settings-body .switch-btn.sidebar-btn .second span:nth-child(4) {
  background: rgba(214, 210, 223, 0.5);
}

.settings-sidebar .settings-body .switch-btn.sidebar-btn .second span:nth-child(5) {
  background: rgba(214, 210, 223, 0.5);
}

.settings-sidebar .settings-body .switch-btn.sidebar-btn .second span:nth-child(6) {
  background: rgba(214, 210, 223, 0.5);
}

.settings-sidebar .settings-body .switch-btn.sidebar-btn .second span:nth-child(7) {
  background: rgba(214, 210, 223, 0.5);
}

.settings-sidebar .settings-body .switch-btn.header-btn .second span:nth-child(1) {
  background: #000000;
}

.settings-sidebar .settings-body .switch-btn.active .first .box {
  border-color: #f1f0f3;
}

.settings-sidebar .settings-body .switch-btn.active .first .box:hover {
  border-color: #d08f2c;
}

.settings-sidebar .settings-body .switch-btn.active .first .sub-title .dot-checkbox {
  border-color: #f1f0f3;
  background-color: transparent;
}

.settings-sidebar .settings-body .switch-btn.active .first .sub-title .dot-checkbox::before {
  opacity: 0;
  visibility: hidden;
}

.settings-sidebar .settings-body .switch-btn.active .second .box {
  border-color: #d08f2c;
}

.settings-sidebar .settings-body .switch-btn.active .second .dot-checkbox {
  border-color: #d08f2c;
  background-color: #d08f2c;
}

.settings-sidebar .settings-body .switch-btn.active .second .dot-checkbox::before {
  opacity: 1;
  visibility: visible;
}

.settings-sidebar .settings-body .mat-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.settings-sidebar .ng-scroll-content {
  padding-right: 0 !important;
}

.settings-sidebar.active {
  right: 0;
  opacity: 1;
  visibility: visible;
}

.dark .settings-sidebar .settings-body .title {
  color: #fff;
}

.dark .settings-sidebar .settings-body .switch-btn .box {
  border-color: #172036;
}

.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(1),
.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(2),
.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(3),
.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(8),
.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(9),
.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(10),
.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(11),
.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(12),
.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(13) {
  background: #172036;
}

.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(8),
.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(9),
.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(10),
.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(11),
.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(12),
.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(13) {
  border-color: #ECEEF2;
}

.dark .settings-sidebar .settings-body .switch-btn .box:hover {
  border-color: #d08f2c;
}

.dark .settings-sidebar .settings-body .switch-btn .first .box {
  border-color: #d08f2c;
}

.dark .settings-sidebar .settings-body .switch-btn .first .sub-title .dot-checkbox {
  border-color: #d08f2c;
  background-color: #d08f2c;
}

.dark .settings-sidebar .settings-body .switch-btn .sub-title .dot-checkbox {
  border-color: #ECEEF2;
}

.dark .settings-sidebar .settings-body .switch-btn .sub-title span {
  color: #fff !important;
}

.dark .settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(8),
.dark .settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(9),
.dark .settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(10),
.dark .settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(11),
.dark .settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(12),
.dark .settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(13) {
  border-color: #2a395d;
}

.dark .settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(8),
.dark .settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(9),
.dark .settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(10),
.dark .settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(11),
.dark .settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(12),
.dark .settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(13) {
  background: #3A4252;
  box-shadow: rgba(255, 255, 255, 0.24) 0px 3px 8px;
}

.dark .settings-sidebar .settings-body .switch-btn.sidebar-btn .second span:nth-child(3) {
  background: #000000;
}

.dark .settings-sidebar .settings-body .switch-btn.header-btn .second span:nth-child(1) {
  background: #000000;
}

.dark .settings-sidebar .settings-body .switch-btn.active .first .box {
  border-color: #172036;
}

.dark .settings-sidebar .settings-body .switch-btn.active .first .box:hover {
  border-color: #d08f2c;
}

.dark .settings-sidebar .settings-body .switch-btn.active .first .sub-title .dot-checkbox {
  border-color: #ECEEF2;
  background-color: transparent;
}

.dark .settings-sidebar .settings-body .switch-btn.active .second .box {
  border-color: #d08f2c;
}

.dark .settings-sidebar .settings-body .switch-btn.active .second .dot-checkbox {
  border-color: #d08f2c;
  background-color: #d08f2c;
}

.dark .settings-sidebar .settings-body .switch-btn.light-dark-btn .first .box {
  border-color: #0C1427;
}

.dark .settings-sidebar .settings-body .switch-btn.light-dark-btn .first .sub-title .dot-checkbox {
  border-color: #ECEEF2;
  background-color: transparent;
}

.dark .settings-sidebar .settings-body .switch-btn.light-dark-btn .first .sub-title .dot-checkbox::before {
  display: none;
}

.dark .settings-sidebar .settings-body .switch-btn.light-dark-btn .second .box {
  border-color: #d08f2c;
}

.dark .settings-sidebar .settings-body .switch-btn.light-dark-btn .second .dot-checkbox {
  border-color: #d08f2c;
  background-color: #d08f2c;
}

.dark .settings-sidebar .settings-body .switch-btn.light-dark-btn .second .dot-checkbox::before {
  opacity: 1;
  visibility: visible;
}

[dir=rtl] .settings-sidebar {
  text-align: end;
  right: auto;
  left: -100%;
}

[dir=rtl] .settings-sidebar .settings-body .title {
  text-align: right;
}

[dir=rtl] .settings-sidebar .settings-body .switch-btn {
  margin-left: auto;
}

[dir=rtl] .settings-sidebar.active {
  right: auto;
  left: 0;
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .settings-sidebar {
    width: 320px;
  }

  .settings-sidebar .settings-header {
    padding: 14.5px 20px;
  }

  .settings-sidebar .settings-header h4,
  .settings-sidebar .settings-header .h4 {
    font-size: 15px;
  }

  .settings-sidebar .settings-header .close-btn i {
    font-size: 18px;
  }

  .settings-sidebar .settings-body {
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
  }

  .settings-sidebar .settings-body .title {
    margin-bottom: 13px;
  }

  .settings-sidebar .settings-body .switch-btn {
    gap: 20px;
  }

  .settings-sidebar .settings-body .mat-divider {
    margin-top: 17px;
    margin-bottom: 17px;
  }
}

/* Min width 576px to Max width 767px */
/* Min width 768px to Max width 991px */
/* Min width 992px to Max width 1199px */
/* Min width 1200px to Max width 1399px */
/* Min width 1600px */


.phone-input-dark .PhoneInputInput {
  background-color: #212121;
  /* fondo negro */
  color: #fff;
  /* texto blanco */
  border: 1px solid #212121;
  /* borde gris oscuro */
  padding: 0.5rem;
  border-radius: 5px;
}

.phone-input-dark .PhoneInputInput::placeholder {
  color: #aaa;
}

.phone-input-dark .PhoneInputCountry {
  background-color: #111;
  border: 1px solid #444;
  border-radius: 5px 0 0 5px;
}

.phone-input-dark .PhoneInputCountrySelect {
  background-color: #111;
  color: #fff;
}

html,
body,
#root,
.main-wrapper-content {
  height: 100%;
}

.react-flow__controls-button {
  color: #000 !important;
}
input::placeholder,
textarea::placeholder,
.form-control::placeholder {
  opacity: 0.4;
}

.google-signin-btn span {
  color: inherit !important;
}

.login-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 400px;
}
.login-option-btn {
  position: relative;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #dadce0;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}
.login-option-btn:hover {
  background: #f8faff;
}
.login-option-btn, .login-option-btn span, .login-option-btn i {
  color: #3c4043 !important;
}
.login-option-btn i {
  position: absolute;
  left: 12px;
  font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/style.scss","webpack://./src/styles/style.css","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./src/styles/_variables.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/styles/components/_global.scss","webpack://./src/styles/components/_sidebar-menu.scss","webpack://./src/styles/components/_main-content.scss","webpack://./src/styles/components/_header-area.scss","webpack://./src/styles/components/_footer-area.scss","webpack://./src/styles/components/_stats-box.scss","webpack://./src/styles/components/_sales-by-locations.scss","webpack://./src/styles/components/_default-table.scss","webpack://./src/styles/components/_pagination.scss","webpack://./src/styles/components/_calendar.scss","webpack://./src/styles/components/_chat.scss","webpack://./src/styles/components/_timeline.scss","webpack://./src/styles/components/_priceing.scss","webpack://./src/styles/components/_products.scss","webpack://./src/styles/components/_rtl.scss","webpack://./src/styles/components/_dark-mode.scss","webpack://./src/styles/components/_card-style.scss","webpack://./src/styles/components/_card-bg-style.scss","webpack://./src/styles/components/_fluid-boxed-style.scss","webpack://./src/styles/components/_landing-page.scss","webpack://./src/styles/components/_analytics.scss","webpack://./src/styles/components/_marketing.scss","webpack://./src/styles/components/_nft.scss","webpack://./src/styles/components/_restaurant.scss","webpack://./src/styles/components/_horizontal-navbar.scss","webpack://./src/styles/components/_settings-sidebar.scss"],"names":[],"mappings":";AAUA,gBAAA;;ACPA,aDSI;ACRJ;EDUI,wCAAA;EACA,kBAAA;ECRF,gBAAgB;EDWlB,yMAAA;ACTA;;AAEA;EDWI,wCAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;ECTF,cAAc;EACd,qCAAqC;ECvBvC,mCAAA;AAAA;;AD2BA;;EClBI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAIA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,yBAAA;EAAA,4BAAA;EAAA,4BAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,qBAAA;EAAA,wBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,0BAAA;EAAA,uBAAA;EAAA,yBAAA;EAAA,wBAAA;EAAA,0BAAA;EAAA,6BAAA;EAAA,sBAAA;EAAA,2BAAA;EAIA,2BAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,sBAAA;EAAA,kCAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,+BAAA;EAAA,kCAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,mCAAA;EAIA,qCAAA;EAAA,kCAAA;EAAA,gCAAA;EAAA,iDAAA;EAAA,mDAAA;EAAA,4CAAA;EAAA,0CAAA;EAAA,gDAAA;EAIA,gDAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,4CAAA;EAAA,yCAAA;EAAA,8CAAA;EAIA,+CAAA;EAAA,0CAAA;EAAA,4BAAA;EAAA,oDAAA;EAAA,sDAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,kDAAA;EAGF,mDAAA;EACA,iCAAA;EAMA,gCAAA;EACA,6BAAA;EACA,uBAAA;EAOA,qNAAA;EC2OI,yGALI;EDpOR,yFAAA;EACA,gDAAA;EAKA,4BAAA;EACA,0BAAA;EACA,0BAAA;EACA,qBAAA;EAEA,kCAAA;EACA,qBAAA;EAEA,+BAAA;EACA,yBAAA;EACA,gCAAA;EACA,+CAAA;EAEA,uCAAA;EACA,0BAAA;EACA,oCAAA;EACA,6CAAA;EAGA,sCAAA;EAEA,yBAAA;EACA,mCAAA;EACA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EAMA,+BAAA;EACA,8CAAA;EACA,uCAAA;EAGA,wBAAA;EACA,0BAAA;EACA,yCAAA;EACA,sBAAA;EAEA,wBAAA;EACA,0BAAA;EACA,mDAAA;EACA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EAGA,4BAAA;EACA,mDAAA;EACA,8BAAA;EACA,0DAAA;EAIA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EACA,8BAAA;EDgFA,qCAAqC;EACrC,gCAAgC;EGjM9B,uCAAA;AHmMJ;;AAEA;EC1EI,kBAAA;EACA,wBAAA;EAEA,kCAAA;EACA,qBAAA;EAEA,4BAAA;EACA,yBAAA;EACA,sCAAA;EACA,+CAAA;EAEA,uCAAA;EACA,0BAAA;EACA,iCAAA;EACA,6CAAA;EAGE,sCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,oDAAA;EAAA,sDAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,kDAAA;EAIA,mDAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,4CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,qCAAA;EAAA,0CAAA;EAIA,2CAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,kDAAA;EAAA,mDAAA;EAAA,6CAAA;EAAA,4CAAA;EAAA,iDAAA;EAGF,iDAAA;EAEA,iCAAA;EACA,gCAAA;EACA,2BAAA;EACA,yCAAA;EAEA,kDAAA;EACA,kCAAA;EACA,wCAAA;EAEA,yCAAA;EACA,6BAAA;EAEA,sCAAA;EACA,0BAAA;EACA,wDAAA;EACA,2CAAA;EDgFF,kDAAkD;EAClD,+CAA+C;EIzPjD,sDAAA;AAAA;;AJ6PA;;;EI3OI,sBAAA;AJ+OJ;;AAEA;EACE;IACE,uBAAuB;EIpO3B;AJsOA;;AAEA;EIpOE,SAAA;EACA,uCAAA;EACA,mCAAA;EACA,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EJsOA,mCAAmC;EACnC,8BAA8B;EI9NhC,6CAAA;AJgOA;;AAEA;EI9NE,cAAA;EACA,cCynB4B;ELzZ5B,SAAS;EACT,wCAAwC;EIvN1C,aAAA;AJyNA;;AAEA;;;;;;;;;;;;EAYE,aAAa;EACb,qBAAqB;EIzNvB,gBAAA;EFkMQ,gBAAA;EF0BN,8BAA8B;AEtL5B;;AFyLJ;;EAEE,kCAAkC;AACpC;;AAEA;;EE9LI;;IAmKI,iBAAA;EFgCN;AACF;;AIhOA;;EJoOE,qCAAqC;AACvC;;AAEA;;EAEE;;IErDI,mBALI;EF6DR;AACF;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EIhNE;;IJoNE,mBAAmB;EI9MvB;AJgNA;;AAEA;;EAEE,mBAAmB;AI3MrB;;AJ8MA;;EAEE,kBAAkB;AI3MpB;;AAAA;;EAIE,kBAAA;AJ6MF;;AI1MA;EAAA,aAAA;EAAA,mBAAA;AAAA;;AJiNA;EACE,yCAAiC;UAAjC,iCAAiC;EI3MnC,YAAA;EACE,8BC6b4B;ALhP9B;;AIxMA;EACE,mBAAA;EACA,kBAAA;EJ2MA,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;AIjMpB;;AJoMA;;;EI1LA,aAAA;EF6EM,mBALI;AFuHV;;AIxLA;;;;EJ8LE,gBAAgB;AAClB;;AInLA;EAEE,gBAAA;AJqLF;;AAEA;EACE,qBAAqB;EACrB,cAAc;AInLhB;;AJsLA;EACE,gBAAgB;AItLlB;;AJyLA;;EIpLA,mBAAA;AJuLA;;AAEA;;EIpLI,kBAAA;AJuLJ;;AI5KE;;EAGE,iBAAA;EJ8KF,gCAAgC;EAChC,wCAAwC;AIxK1C;;AAAA;;EAIE,kBCgV4B;EHlUxB,iBALI;EFkKR,cAAc;EACd,wBAAwB;AIpK1B;;AJuKA;EIpKE,eAAA;AJsKF;;AAEA;EIlKE,WAAA;AJoKF;;AAEA;EACE,gEAAgE;EAChE,0BAA0B;AIjK5B;;AJoKA;EIjKE,mDAAA;AJmKF;;AAEA;;EAEE,cAAc;EI/JhB,qBAAA;AJiKA;;AAEA;;;;EI5JE,qCAAA;EACE,cAAA;AJiKJ;;AAEA;EIxJA,cAAA;EACE,aAAA;EJ0JA,mBAAmB;EACnB,cAAc;EIrJhB,kBAAA;AAAA;;AJyJA;EACE,kBAAkB;EIhJpB,cAAA;EACE,kBAAA;AJkJF;;AAEA;EIhJA,kBAAA;EACE,2BC4X4B;ED3X5B,qBC2X4B;ALzO9B;;AAEA;EACE,cAAc;AI5IhB;;AJ+IA;EACE,2BAA2B;EAC3B,kBAAkB;EI3IpB,wBAAA;EAAA,sCAAA;EAAA,sBAAA;AAAA;;AAAA;EAME,UAAA;EACA,cAAA;AJ6IF;;AAEA;EItIA,gBAAA;AJwIA;;AAEA;;EIjIE,sBAAA;AJoIF;;AI5HA;EACE,oBAAA;EJ+HA,yBAAyB;AAC3B;;AI3HA;EAAA,mBAAA;EAAA,sBAAA;EAAA,gCAAA;EAKE,gBAAA;AJ6HF;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AI1HlC;;AJ6HA;;;;;;EAME,qBAAqB;EIxHvB,mBAAA;EAGE,eAAA;AJwHF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AI5GA;EAAA,UAAA;AAAA;;AJkHA;;;;;EI1GM,SAAA;EJgHJ,oBAAoB;EACpB,kBAAkB;EI1GpB,oBAAA;AJ4GA;;AAEA;;EIvGA,oBAAA;AJ0GA;;AAEA;EIjGA,eAAA;AJmGA;;AAEA;EIjGE,iBAAA;AJmGF;;AI3FA;EACE,UAAA;AJ8FF;;AAEA;EI3FE,wBAAA;AJ6FF;;AE5cI;;;;EFkdF,0BAA0B;AIhG1B;;AJmGF;;;;EI3FA,eAAA;AAAA;;AAAA;EAAA,UAAA;EAOE,kBAAA;AJ8FF;;AI3FA;EACE,gBAAA;AJ8FF;;AIrFA;EACE,YAAA;EACA,UAAA;EJwFA,SAAS;EACT,SAAS;AIjFX;;AAAA;EAAA,WAAA;EAAA,WAAA;EAAA,UAAA;EAAA,qBAAA;EAAA,oBAAA;EAWA,iCAAA;AJgFA;;AAEA;EI5EA;IACE,iBAAA;EJ8EA;AACF;;AAEA;EIxEE,WAAA;AJ0EF;;AIrEA;;;;;;;EJ8EE,UAAU;AIhEZ;;AJmEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AItDtB;;AJyDA;;;;;;;CMtnBE;AN8nBF;EM1nBI,wBDymB0B;ALmB9B;;AE5hBI;EIpGF,UAAA;ANooBF;;AAEA;EACE,aAAa;EMvoBb,0BAAA;ANyoBF;;AAEA;EACE,qBAAqB;AExiBnB;;AF2iBJ;EACE,SAAS;AACX;;AMjpBE;EAGE,kBD0nBkB;ECznBlB,eDymB0B;ALyC9B;;AEljBI;EIpGF,wBAAA;AN0pBF;;AAEA;EACE,wBAAwB;AM7pBxB;;ANgqBF;EEhaQ,iBAAA;EFkaN,gBAAgB;AE9jBd;;AFikBJ;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AMxqBjC;;AN2qBF;EE3aQ;IF6aJ,eAAe;EEzkBf;AF2kBJ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EMnrBhB,iCAAA;ANqrBF;;AAEA;EACE;IEplBE,iBAAA;EIpGF;AN2rBF;;AAEA;EACE,gBAAgB;EMtqBlB,gBAAA;ECvDE,iCAAA;APguBF;;AAEA;EMtqBA;IC5DE,eAAA;EACA;APquBF;;AMvqBA;EACE,gBAAA;EN0qBA,gBAAgB;EMxqBhB,iCAAA;AN0qBF;;AAEA;EMjqBA;IJ8MM,iBALI;EIvMR;ANmqBF;;AM/pBA;EACE,gBDiUO;EH1HH,gBALI;EFieR,iCAAiC;AMhqBjC;;ANmqBF;EACE;IM/pBF,eAAA;EACE;ANiqBF;;AAEA;EACE,gBAAgB;EM/pBhB,gBAAA;EACE,iCAAA;ANiqBJ;;AQvwBE;EAAA;IAAA,iBAAA;EAAA;AAAA;;APDF;EASI,eAAA;EAAA,gBAAA;AD0wBJ;;AAEA;EC5wBI,eAAA;EAAA,gBAAA;AD+wBJ;;AAEA;ECjxBI,qBAAA;ADmxBJ;;AAEA;ECjxBI,oBAAA;ADmxBJ;;AAEA;ECrxBI,kBAAA;EAAA,yBAAA;ADwxBJ;;AAEA;ECtxBI,mBAAA;EAAA,iBAAA;ADyxBJ;;AAEA;EC3xBI,gBAAA;AD6xBJ;;AAEA;EC/xBI,iBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,cAAA;ADoyBJ;;AAEA;ECtyBI,aAAA;ADwyBJ;;AAEA;;;;EC1yBI;AD+yBJ;;EC/yBI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,yBAAA;EAAA,4BAAA;EAAA,4BAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,qBAAA;EAAA,wBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,0BAAA;EAAA,uBAAA;EAIA,yBAAA;EAAA,wBAAA;EAAA,0BAAA;EAAA,6BAAA;EAAA,sBAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,wBAAA;EAIA,sBAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,6BAAA;EAIA,sBAAA;EAAA,kCAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,+BAAA;EAGF,+BAAA;EACA,iCAAA;EAMA,kCAAA;EACA,kCAAA;EACA,mCAAA;EAOA,+BAAA;EC2OI,kCALI;EDpOR,8BAAA;EACA,8BAAA;EAKA,8BAAA;EACA,iCAAA;EACA,+BAAA;EACA,8BAAA;EAEA,kCAAA;EACA,mCAAA;EAEA,gCAAA;EACA,mCAAA;EACA,kCAAA;EACA,oCAAA;EAEA,uCAAA;EACA,gCAAA;EACA,mCAAA;EACA,qCAAA;EAGA,kCAAA;EAEA,gCAAA;EACA,iDAAA;EACA,mDAAA;EAEA,4CAAA;EACA,0CAAA;EAMA,gDAAA;EACA,gDAAA;EACA,iCAAA;EAGA,gCAAA;EACA,gDAAA;EACA,kDAAA;EACA,4CAAA;EAEA,yCAAA;EACA,8CAAA;EACA,+CAAA;EACA,0CAAA;EACA,4BAAA;EACA,oDAAA;EACA,sDAAA;EAGA,gDAAA;EACA,6CAAA;EACA,kDAAA;EACA,mDAAA;EAIA,iCAAA;EACA,gCAAA;EACA,6BAAA;EAIA,uBAAA;EACA,qNAAA;EACA,yGAAA;EACA,yFAAA;EDu0BA,gDAAgD;EAChD,4BAA4B;EGx7B1B,0BAAA;EFsHA,0BAAA;EAGA,qBAAA;EACA,kCAAA;EACA,qBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,yBAAA;EACA,mCAAA;EAGE,2BAAA;EAAA,wBAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,8CAAA;EAAA,uCAAA;EAAA,wBAAA;EAAA,0BAAA;EAIA,yCAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,0BAAA;EAAA,mDAAA;EAAA,4BAAA;EAAA,8BAAA;EAAA,6BAAA;EAIA,2BAAA;EAAA,4BAAA;EAAA,mDAAA;EAAA,8BAAA;EAAA,0DAAA;EAAA,2DAAA;EAAA,oDAAA;EAAA,2DAAA;EAGF,8BAAA;EAEA,6BAAA;EACA,+CAAA;EACA,8BAAA;EACA,qCAAA;EAEA,gCAAA;EACA,uCAAA;ADy0BJ;;AAEA;ECr0BI,kBAAA;EACA,wBAAA;EACA,kCAAA;EACA,qBAAA;EDu0BF,4BAA4B;EAC5B,yBAAyB;EIh/B3B,sCAAA;EAAA,+CAAA;EAAA,uCAAA;EAGE,0BAAA;EJk/BA,iCAAiC;EACjC,6CAA6C;EIp+B3C,sCAAA;EANJ,uCAAA;EJ6+BE,gCIt+BI;EJu+BJ,oDAAoD;EACpD,sDAAsD;EACtD,gDAAgD;EI39BlD,6CAAA;EACE,kDAAA;EACA,mDAAA;EF6OI,iCALI;EEtOR,gCAAA;EACA,4CAAA;EACA,+CAAA;EACA,wCAAA;EACA,qCAAA;EACA,0CAAA;EACA,2CAAA;EJ69BA,6BAA6B;EAC7B,4BAA4B;EIr9B9B,kDAAA;EACE,mDAAA;EACA,6CCmnB4B;EDlnB5B,4CAAA;EACA,iDAAA;EACA,iDCynB4B;EL8V5B,iCAAiC;EACjC,gCAAgC;EI98BlC,2BAAA;EACE,yCAAA;EACA,kDCwjB4B;EDrjB5B,kCCwjB4B;EDvjB5B,wCCwjB4B;EDvjB5B,yCAAA;EJ88BA,6BAA6B;EAC7B,sCAAsC;EI58BxC,0BAAA;EFuMQ,wDAAA;EFwwBN,2CAA2C;EEp6BzC,kDAAA;EE3CJ,+CAAA;EJk9BE,sDEpwBM;AFqwBR;;AAEA;;;EAGE,sBAAsB;AE76BpB;;AFg7BJ;EACE;IACE,uBAAuB;EACzB;AIp9BF;;AJu9BA;EEt7BI,SAAA;EEjCJ,uCAAA;EJ09BE,mCEtxBM;EFuxBN,uCAAuC;EACvC,uCAAuC;EACvC,2BAA2B;EIx9B7B,qCAAA;EFoLM,mCALI;EF4yBR,8BAA8B;EAC9B,6CAA6C;AIv9B/C;;AJ09BA;EACE,cAAc;EIt9BhB,cAAA;EF0KM,SAAA;EF+yBJ,wCAAwC;EACxC,aAAa;AI/8Bf;;AJk9BA;;;;;;;;;;;;EI17BE,aAAA;EJu8BA,qBAAqB;EACrB,gBAAgB;EIl8BlB,gBAAA;EAAA,8BAAA;AJq8BA;;AAEA;;EIl8BA,kCAAA;AAAA;;AJu8BA;;EAEE;;IIl8BF,iBAAA;EAAA;AAAA;;AJw8BA;;EIj8BA,qCAAA;AJo8BA;;AAEA;;EI/7BE;;IJm8BE,mBAAmB;EACrB;AI77BF;;AJg8BA;;EIv7BA,qCAAA;AAAA;;AJ47BA;;EIl7BA;;IJs7BI,mBAAmB;EACrB;AIh7BF;;AJm7BA;;EAEE,mBAAmB;AACrB;;AI16BA;;EF0DM,kBALI;AF03BV;;AAEA;;EIz6BA,kBAAA;AJ46BA;;AAEA;EI76BA,aAAA;EAAM,mBAAA;AJg7BN;;AI36BA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EJ86BA,8BAA8B;AI56B9B;;AJ+6BF;EACE,mBAAmB;EIp6BnB,kBAAA;EAEE,oBAAA;AJq6BJ;;AAEA;;EI/5BA,kBAAA;AAAA;;AJo6BA;;;EAGE,aAAa;EI35Bf,mBAAA;AJ65BA;;AAEA;;;;EIt5BE,gBAAA;AJ25BF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EIx5BE,qBAAA;EACA,cAAA;AJ05BF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EIr5BE,mBC25CkC;ALngBpC;;AAEA;;EIr5BI,kBAAA;AJw5BJ;;AAEA;;EI94BE,iBAAA;EJi5BA,gCAAgC;EAChC,wCAAwC;AI54B1C;;AJ+4BA;;EAEE,kBAAkB;EIv4BpB,iBAAA;EACE,cAAA;EACA,wBAAA;AJy4BF;;AIt4BA;EACE,eC4X4B;AL6gB9B;;AAEA;EACE,WAAW;AACb;;AAEA;EIl4BE,gEAAA;EJo4BA,0BAA0B;AAC5B;;AIl4BA;EAAA,mDAAA;AAAA;;AAAA;;EAOE,cAAA;EACA,qBAAA;AJo4BF;;AI53BA;;;;EAOA,qCAAA;EAEE,cAAA;AJ23BF;;AIn3BA;EACE,cAAA;EJs3BA,aAAa;EACb,mBAAmB;EIl3BrB,cAAA;EAAA,kBAAA;AAAA;;AAAA;EAKE,kBAAA;EACA,cAAA;EF5HI,kBALI;AFs/BV;;AAEA;EIj3BA,kBAAA;EAAA,2BAAA;EAEE,qBAAA;AJm3BF;;AI92BA;EACE,cAAA;AJi3BF;;AI92BA;EAGE,2BAAA;EJ+2BA,kBAAkB;EI52BlB,wBAAA;EACE,sCAAA;EJ82BF,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,cAAc;AIn2BhB;;AAAA;EAAA,gBAAA;AJw2BA;;AIj2BI;;EAAA,sBAAA;AAAA;;AJw2BJ;EACE,oBAAoB;EIj2BtB,yBAAA;AJm2BA;;AAEA;EACE,mBAAmB;EI/1BrB,sBAAA;EACE,gCAAA;EJi2BA,gBAAgB;AAClB;;AAEA;EIx1BE,mBAAA;EACA,gCAAA;AJ01BF;;AAEA;;;;;;EI70BE,qBAAA;EFnNM,mBAAA;EFwiCN,eAAe;AEpsCb;;AFusCJ;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AIn1BA;EAAA,UAAA;AAAA;;AAAA;;;;;EAUA,SAAA;EACE,oBAAA;EJq1BA,kBAAkB;EAClB,oBAAoB;AI70BtB;;AJg1BA;;EAEE,oBAAoB;AIx0BtB;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,iBAAA;AAWA;;AJw0BA;EACE,UAAU;AIn0BZ;;AJs0BA;EACE,wBAAwB;AI/zB1B;;AJk0BA;;;;EI1zBE,0BAAA;AJ+zBF;;AI1zBA;;;;EAQA,eAAA;AJyzBA;;AAEA;EACE,UAAU;EIlzBZ,kBAAA;AJozBA;;AAEA;EI7yBA,gBAAA;AJ+yBA;;AAEA;EMr3CA,YAAA;EJmQM,UAAA;EIjQJ,SAAA;ENu3CA,SAAS;AACX;;AAEA;EMj3CI,WAAA;EJ4PI,WAAA;EFwnCN,UAAU;EEpxCR,qBAAA;EIpGF,oBAAA;EN23CA,iCEpnCM;AFqnCR;;AAEA;EM93CE;IAGE,iBD0nBkB;ECznBlB;AN83CJ;;AE9xCI;EIpGF,WAAA;ANs4CF;;AAEA;;;;;;;EEpyCI,UAAA;AF4yCJ;;AAEA;EACE,YAAY;AACd;;AAEA;EMl5CI,6BDymB0B;EH7WtB,oBAAA;AFypCR;;AAEA;;;;;;;CAOC;AACD;EACE,wBAAwB;AEh0CtB;;AFm0CJ;EACE,UAAU;AACZ;;AMz6CE;EAGE,aD0nBkB;ECznBlB,0BDymB0B;ALi0B9B;;AE10CI;EIpGF,qBAAA;ANk7CF;;AAEA;EACE,SAAS;AM75CX;;ANg6CA;EACE,kBAAkB;EAClB,eAAe;AM75CjB;;ANg6CA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AM/5CxB;;ANk6CF;EACE,iBAAiB;EMx5CnB,gBAAA;AN05CA;;AAEA;EACE,gBAAgB;EMv5ClB,gBAAA;EACE,iCDiUO;ALwlCT;;AMt5CE;EACE;INy5CA,eAAe;EACjB;AMt5CF;;ANy5CA;EE1tCM,gBALI;EItLR,gBDtFS;EL8+CT,iCAAiC;AMt5CjC;;ANy5CF;EACE;ISz/CF,iBAAA;ECIE;AVw/CF;;AAEA;ESx/CA,gBAAA;EACE,gBJ+jDkC;EI9jDlC,iCJ+jDkC;ALrEpC;;AAEA;EU7/CE;IV+/CE,eAAe;EACjB;ASl/CF;;ATq/CA;EACE,gBAAgB;ESj/ClB,gBAAA;EACE,iCAAA;ATm/CF;;AAEA;ESj/CA;IPyPM,iBALI;EOlPR;ATm/CF;;AWrhDE;EAAA,gBAAA;EAAA,gBAAA;EAAA,iCAAA;AAAA;;AAAA;ECHA;IACA,eAAA;EACA;AZkiDF;;AAEA;EYhiDE,gBAAA;EZkiDA,gBAAgB;EAChB,iCAAiC;Aa7+C/B;;Abg/CJ;EACE;IACE,iBAAiB;Eal/CjB;Abo/CJ;;AAEA;EACE,eAAe;Eav/Cb,gBAAA;Aby/CJ;;AAEA;EACE,eAAe;Ea5/Cb,gBAAA;Ab8/CJ;;AAEA;EACE,qBAAqB;AajgDnB;;AbogDJ;EACE,oBAAoB;AACtB;;AAEA;EcjkDI,kBAAA;EAAA,yBAAA;AdokDJ;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AcnkDjB;;AdskDF;Ee1kDE,gBAAA;Af4kDF;;AAEA;EezkDE,iBAAA;Ef2kDA,mBAAmB;EczkDjB,kBAAA;ECOF,cAAA;AfqkDF;;AAEA;EenkDE,aAAA;AfqkDF;;AAEA;EevhDM,eAAA;EACE,YAAA;AfyhDR;;AethDM;EApCJ,gBAAA;EACA,mCAAA;Ef8jDA,2DAA2D;EAC3D,sCAAsC;EejjDtC,eAAA;EACE,YAAA;AfmjDJ;;AAEA;EetjDE,qBAAA;AfwjDF;;AAEA;EACE,qBAAqB;Ee3jDrB,cAAA;Af6jDF;;AAEA;EACE,kBAAkB;EehkDlB,gCAAA;AfkkDF;;AAEA;;;;;;;EepkDE,qBAAA;EACE,gBAAA;EACA,WAAA;Ef4kDF,6CAA6C;EAC7C,4CAA4C;Ee9iDxC,kBAAA;EAhDJ,iBAAA;AfimDF;;AAEA;;Ee7mDI;;IfinDA,gBAAgB;EAClB;AeljDQ;;AfqjDV;;EAEE;;;IetnDE,gBAAA;Ef0nDF;AACF;;AAEA;;EAEE;;;;Ie/nDE,gBAAA;EfooDF;AACF;;AAEA;;EAEE;;;;;IAKE,iBAAiB;EACnB;AehlDQ;;AfmlDV;;EAEE;;;;;;IerlDQ,iBAAA;EAhEN;Af6pDJ;;AAEA;Ee/lDU,qBAAA;EAhEN,yBAAA;EACA,yBAAA;EfkqDF,yBAAyB;EACzB,0BAA0B;EepmDlB,2BAAA;AfsmDV;;AAEA;EACE,qBAAqB;EejmDX,gBAAA;EAxDV,aAAA;Ef4pDA,eAAe;EACf,yCAAyC;EermD/B,6CAAA;EAxDV,4CAAA;AfgqDF;;AexmDY;EAxDV,cAAA;EfoqDA,WAAW;EACX,eAAe;Ee7mDL,6CAAA;EAxDV,4CAAA;EfwqDA,8BAA8B;AAChC;;AAEA;EACE,SAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AeznDD;;Af4nDZ;EACE,cAAc;Ee7nDJ,WAAA;Af+nDZ;;AAEA;EejoDY,cAAA;EAxDV,UAAA;Af4rDF;;AepoDY;EAxDV,cAAA;EfgsDA,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,UAAU;AeloDJ;;AfqoDR;EACE,cAAc;EACd,UAAU;AeloDJ;;AfqoDR;EACE,cAAc;EACd,mBAAmB;Ae5oDb;;Af+oDR;EACE,cAAc;EACd,WAAW;Ae5oDL;;Af+oDR;EACE,cAAc;EACd,kBAAkB;AetpDZ;;AfypDR;EACE,cAAc;EACd,mBAAmB;AetpDb;;AfypDR;EACE,cAAc;EACd,UAAU;AehqDJ;;AfmqDR;EACE,cAAc;EACd,mBAAmB;AehqDb;;AfmqDR;EACE,cAAc;EACd,mBAAmB;Ae1qDb;;Af6qDR;EACE,cAAc;EACd,UAAU;Ae1qDJ;;Af6qDR;EACE,cAAc;EACd,mBAAmB;AeprDb;;AfurDR;EACE,cAAc;EACd,mBAAmB;AeprDb;;AfurDR;EACE,cAAc;EACd,UAAU;AajvDR;;AbovDJ;EACE,cAAc;EevuDV,mBAAA;AfyuDN;;AAEA;EehwDE,cAAA;EfkwDA,mBejwDE;AfkwDJ;;AAEA;EACE,cerwDE;EfswDF,WerwDE;AfswDJ;;AAEA;EACE,wBezwDE;Af0wDJ;;AAEA;EACE,yBe7wDE;Af8wDJ;;AAEA;EACE,gBejxDE;AfkxDJ;;AAEA;EACE,yBerxDE;AfsxDJ;;AAEA;EACE,yBezyDA;Af0yDF;;AAEA;EACE,gBevzDE;AfwzDJ;;AAEA;EACE,yBe3zDE;Af4zDJ;;AAEA;EACE,yBe/zDE;Afg0DJ;;AAEA;EACE,gBen0DE;Afo0DJ;;AAEA;EACE,yBev0DE;Afw0DJ;;AAEA;EACE,yBe30DE;Af40DJ;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EepxDU,gBAAA;AfuxDV;;AAEA;;EAEE,sBe31DE;Af41DJ;;AAEA;;EAEE,sBe/1DE;Afg2DJ;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBe11DA;Af21DF;;AAEA;;EeryDY,mBAAA;AfwyDZ;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,qBez2DA;Af02DF;;AAEA;;EepzDY,qBAAA;AfuzDZ;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBex3DA;Afy3DF;;AetzDQ;EfyzDN;IACE,SAAW;EerzDP;;EfwzDN;IACE,cAAc;Ie9zDV,WAAA;EAAA;;Efk0DN;Ie7zDM,cAAA;IAAA,WAAA;Efg0DN;;Eer0DM;IAAA,cAAA;IAEE,UAAA;Efw0DR;;Eer0DM;IAEE,cAAA;Ifu0DN,mBAAmB;Ee90Df;;Efi1DN;IACE,cAAc;Ie70DV,UAAA;EAAA;;Efi1DN;Iet1DM,cAAA;IAAA,UAAA;Efy1DN;;Eep1DM;IAAA,cAAA;IAEE,mBAAA;Efu1DR;;Ee91DM;IAEE,cAAA;Ifg2DN,WAAW;Ee71DP;;Efg2DN;IACE,cAAc;IACd,kBAAkB;Ea15DlB;;Eb65DF;IACE,cAAc;Ieh5DZ,mBAAA;Efk5DJ;;EAEA;Iez6DA,cAAA;IACE,UAAA;Ef26DF;;Ee56DA;IACE,cAAA;IACA,mBAAA;Ef+6DF;;EAEA;Iej7DE,cAAA;Ifm7DA,mBAAmB;Eer7DrB;;Efw7DA;IACE,cAAc;Iez7DhB,UAAA;Ef27DA;;EAEA;Ie77DA,cAAA;IACE,mBAAA;Ef+7DF;;Ee/5DI;IAhDJ,cAAA;IACA,mBAAA;Efm9DA;;EAEA;Ie/9DE,cAAA;Ifi+DA,UAAU;Eel6DJ;;Efq6DR;IACE,cAAc;Iet6DR,mBAAA;Efw6DR;;EAEA;Ie16DQ,cAAA;IAhEN,mBAAA;Ef6+DF;;Ee76DQ;IAhEN,cAAA;IACA,WAAA;Efi/DF;;EAEA;Ien/DE,cAAA;Efq/DF;;EAEA;Iev/DE,wBAAA;Efy/DF;;EAEA;Ie3/DE,yBAAA;Ef6/DF;;EAEA;Ie//DE,gBAAA;EfigEF;;EAEA;IengEE,yBAAA;EfqgEF;;EAEA;IevgEE,yBAAA;EfygEF;;EAEA;Ie3gEE,gBAAA;Ef6gEF;;EAEA;IACE,yBAAyB;Eez8DjB;;Ef48DV;Ie58DU,yBAAA;Ef88DV;;Ee98DU;IAxDV,gBAAA;Ef0gEA;;EAEA;IACE,yBAAyB;Eer9DjB;;Efw9DV;Iex9DU,yBAAA;Ef09DV;;Ee19DU;;If89DR,gBAAgB;Ee99DR;;Efi+DV;;IezhEA,gBAAA;Ef4hEA;;EAEA;;Iet+DU,sBAAA;Efy+DV;;Ee99DM;;IAEE,sBAAA;Efi+DR;;Ee99DM;;Ifk+DJ,qBAAqB;Eev+DjB;;Ef0+DN;;Ier+DM,qBAAA;EAAA;;Ef0+DN;;Ie/+DM,mBAAA;Efk/DN;;Ee7+DM;;IAEE,mBAAA;Efg/DR;;Eev/DM;;If2/DJ,qBAAqB;Eet/DjB;;Efy/DN;;Ie9/DM,qBAAA;EAAA;;EfmgEN;;Ie9/DM,mBAAA;EfigEN;;EetgEM;;IAEE,mBAAA;EfygER;AACF;;AAEA;EACE;IACE,SAAW;EankEX;;EbskEF;IACE,cAAc;IezjEZ,WAAA;Ef2jEJ;;EAEA;IellEA,cAAA;IACE,WAAA;EfolEF;;EerlEA;IACE,cAAA;IACA,UAAA;EfwlEF;;EAEA;Ie1lEE,cAAA;If4lEA,mBAAmB;Ee9lErB;;EfimEA;IACE,cAAc;IelmEhB,UAAA;EfomEA;;EAEA;IetmEA,cAAA;IACE,UAAA;EfwmEF;;EexkEI;IAhDJ,cAAA;IACA,mBAAA;Ef4nEA;;EAEA;IexoEE,cAAA;If0oEA,WAAW;Ee3kEL;;Ef8kER;IACE,cAAc;Ie/kER,kBAAA;EfilER;;EAEA;IenlEQ,cAAA;IAhEN,mBAAA;EfspEF;;EetlEQ;IAhEN,cAAA;IACA,UAAA;Ef0pEF;;EAEA;Ie5pEE,cAAA;If8pEA,mBAAmB;Ee/lEb;;EfkmER;IACE,cAAc;IenmER,mBAAA;EfqmER;;EAEA;IevmEQ,cAAA;IAhEN,UAAA;Ef0qEF;;Ee1mEQ;IAhEN,cAAA;IACA,mBAAA;Ef8qEF;;EAEA;IehrEE,cAAA;IfkrEA,mBAAmB;EennEb;;EfsnER;IACE,cAAc;Ie/mEN,UAAA;EfinEV;;EejnEU;IAxDV,cAAA;If6qEE,mBAAmB;EernEX;;EfwnEV;IexnEU,cAAA;IAxDV,mBAAA;EfmrEA;;EAEA;IACE,cAAc;Ie9nEN,WAAA;EfgoEV;;EehoEU;IAxDV,cAAA;Ef4rEA;;EAEA;IACE,wBAAwB;EevoEhB;;Ef0oEV;Ie1oEU,yBAAA;Ef4oEV;;Ee5oEU;IAxDV,gBAAA;EfwsEA;;EAEA;IACE,yBAAyB;EexoErB;;Ef2oEN;IACE,yBAAyB;EevoErB;;Ef0oEN;IACE,gBAAgB;EehpEZ;;EfmpEN;IACE,yBAAyB;Ee/oErB;;EfkpEN;IACE,yBAAyB;EexpErB;;Ef2pEN;IACE,gBAAgB;EevpEZ;;Ef0pEN;IACE,yBAAyB;EehqErB;;EfmqEN;IACE,yBAAyB;Ee/pErB;;EfkqEN;;IevqEM,gBAAA;EAAA;;Ef4qEN;;IevqEM,gBAAA;Ef0qEN;;Ee/qEM;;IAEE,sBAAA;EfkrER;;Ee/qEM;;IfmrEJ,sBAAsB;EACxB;;EeluEI;;IfsuEF,qBAAqB;EeluEnB;;EfquEJ;;Ie1vEA,qBAAA;Ef6vEA;;EAEA;;Ie9vEE,mBAAA;EfiwEF;;EelwEA;;IAEE,mBAAA;EfqwEF;;EAEA;;IAEE,qBAAqB;Ee3wEvB;;Ef8wEA;;Ie9wEA,qBAAA;EfixEA;;EAEA;;IelyEA,mBAAA;EfqyEA;;Ee/uEQ;;IA/DN,mBAAA;EfmzEF;AACF;;AAEA;EACE;IexvEQ,SAAA;Ef0vER;;EAEA;Ie5vEQ,cAAA;IAhEN,WAAA;Ef+zEF;;Ee/vEQ;IAhEN,cAAA;IACA,WAAA;Efm0EF;;EAEA;Ier0EE,cAAA;Ifu0EA,UAAU;EexwEJ;;Ef2wER;IACE,cAAc;Ie5wER,mBAAA;Ef8wER;;EAEA;IehxEQ,cAAA;IAhEN,UAAA;Efm1EF;;EenxEQ;IAhEN,cAAA;IACA,UAAA;Efu1EF;;EAEA;Iez1EE,cAAA;If21EA,mBAAmB;Ee5xEb;;Ef+xER;IACE,cAAc;IexxEN,WAAA;Ef0xEV;;Ee1xEU;IAxDV,cAAA;Ifs1EE,kBAAkB;Ee9xEV;;EfiyEV;IejyEU,cAAA;IAxDV,mBAAA;Ef41EA;;EAEA;IACE,cAAc;IevyEN,UAAA;EfyyEV;;EezyEU;IAxDV,cAAA;Ifq2EE,mBAAmB;Ee7yEX;;EfgzEV;IehzEU,cAAA;IAxDV,mBAAA;Ef22EA;;EAEA;IACE,cAAc;IetzEN,UAAA;EfwzEV;;EexzEU;IAxDV,cAAA;Ifo3EE,mBAAmB;EejzEf;;EfozEN;IACE,cAAc;IehzEV,mBAAA;EAAA;;EfozEN;IezzEM,cAAA;IAAA,UAAA;Ef4zEN;;EevzEM;IAAA,cAAA;IAEE,mBAAA;Ef0zER;;Eej0EM;IAEE,cAAA;Ifm0EN,mBAAmB;Eeh0Ef;;Efm0EN;IACE,cAAc;Iez0EV,WAAA;EAAA;;Ef60EN;Iex0EM,cAAA;EAAA;;Ef40EN;Iej1EM,wBAAA;EAAA;;Efq1EN;Ieh1EM,yBAAA;EAAA;;Efo1EN;Iez1EM,gBAAA;EAAA;;Ef61EN;Iex1EM,yBAAA;EAAA;;Ef41EN;IACE,yBAAyB;Ear5EzB;;Ebw5EF;IACE,gBAAgB;Ee34Ed;;Ef84EJ;IACE,yBAAyB;Eep6E3B;;Efu6EA;IACE,yBAAyB;Eex6E3B;;Ef26EA;IACE,gBAAgB;Ee56ElB;;Ef+6EA;IACE,yBAAyB;Eeh7E3B;;Efm7EA;IACE,yBAAyB;Eep7E3B;;Efu7EA;;Iev7EA,gBAAA;Ef07EA;;EAEA;;Ie38EA,gBAAA;Ef88EA;;Eex5EQ;;IA/DN,sBAAA;Ef49EF;;EAEA;;IAEE,sBAAsB;Eej6EhB;;Efo6ER;;Iep6EQ,qBAAA;Efu6ER;;EAEA;;Iez+EE,qBAAA;Ef4+EF;;Ee56EQ;;IA/DN,mBAAA;Efg/EF;;EAEA;;IAEE,mBAAmB;Eer7Eb;;Efw7ER;;Iex7EQ,qBAAA;Ef27ER;;EAEA;;Ie7/EE,qBAAA;EfggFF;;Eeh8EQ;;IA/DN,mBAAA;EfogFF;;EAEA;;IAEE,mBAAmB;Eej8EX;Afm8EZ;;AAEA;EACE;IACE,SAAW;Eev8EH;;Ef08EV;Ie18EU,cAAA;IAxDV,WAAA;EfqgFA;;EAEA;IACE,cAAc;Ieh9EN,WAAA;Efk9EV;;Eel9EU;IAxDV,cAAA;If8gFE,UAAU;Eet9EF;;Efy9EV;Iez9EU,cAAA;IAxDV,mBAAA;EfohFA;;EAEA;IACE,cAAc;Ie/9EN,UAAA;Efi+EV;;Eej+EU;IAxDV,cAAA;If6hFE,UAAU;Ee19EN;;Ef69EN;IACE,cAAc;Iez9EV,mBAAA;EAAA;;Ef69EN;Iel+EM,cAAA;IAAA,WAAA;Efq+EN;;Eeh+EM;IAAA,cAAA;IAEE,kBAAA;Efm+ER;;Ee1+EM;IAEE,cAAA;If4+EN,mBAAmB;Eez+Ef;;Ef4+EN;IACE,cAAc;Iel/EV,UAAA;EAAA;;Efs/EN;Iej/EM,cAAA;IAAA,mBAAA;Efo/EN;;Eez/EM;IAAA,cAAA;IAEE,mBAAA;Ef4/ER;;Eez/EM;IAEE,cAAA;If2/EN,UAAU;EelgFN;;EfqgFN;IACE,cAAc;IejgFV,mBAAA;EAAA;;EfqgFN;IACE,cAAc;IgBznFlB,mBAAA;EAEE;;EAEA;IACA,cAAA;IAEA,UAAA;EACA;;EAEA;IACA,cAAA;IACA,mBAAA;EACA;;EAEA;IACA,cAAA;IAEA,mBAAA;EACA;;EAEA;IhBwnFE,cAAc;IgBjnFhB,WAAA;EACE;;EAGA;IACA,cAAA;EACA;;EAGF;IACE,wBAAA;EhBinFF;;EgB7mFE;IhBgnFA,yBAAyB;EAC3B;;EgB5mFA;IhB+mFE,gBAAgB;EAClB;;EgBxmFA;IhB2mFE,yBAAyB;EAC3B;;EgBjmFE;IhBomFA,yBAAyB;EAC3B;;EgBrlFE;IhBwlFA,gBAAgB;EgBrlFhB;;EhBwlFF;IACE,yBAAyB;EgBjlF3B;;EhBolFA;IgBhlFA,yBAAA;EACE;;EhBmlFF;IgBzkFA,gBAAA;EACE;;EhB4kFF;IACE,yBAAyB;EgBtkF3B;;EAEE;IhBwkFA,yBAAyB;EAC3B;;EgBhkFA;;IhBokFE,gBAAgB;EAClB;;EgB3jFE;;IhB+jFA,gBAAgB;EAClB;;EiBpsFE;;IAEA,sBAAA;EACA;;EAEA;;IAEA,sBAAA;EACA;;EAGA;;IjBusFA,qBAAqB;EiBztFvB;;EAQE;;IAEA,qBAAA;EACA;;EAEA;;IAEA,mBAAA;EAEA;;EjBqtFF;;IiBtuFA,mBAAA;EAOE;;EAEA;;IAEA,qBAAA;EACA;;EAEA;;IAGA,qBAAA;EACA;;EjBmuFF;;IiB9uFE,mBAAA;EACA;;EAEA;;IAEA,mBAAA;EACA;AjBivFJ;;AAEA;EiB9uFI;IjBgvFA,SAAW;EACb;;EiB5vFE;IACA,cAAA;IACA,WAAA;EACA;;EAEA;IACA,cAAA;IACA,WAAA;EACA;;EAGA;IjB8vFA,cAAc;IACd,UAAU;EiBjxFZ;;EAQE;IACA,cAAA;IACA,mBAAA;EACA;;EAEA;IACA,cAAA;IACA,UAAA;EAEA;;EjB6wFF;IACE,cAAc;IiB/xFhB,UAAA;EAOE;;EAEA;IACA,cAAA;IACA,mBAAA;EACA;;EAEA;IACA,cAAA;IAEA,WAAA;EACA;;EjB2xFF;IiB7yFA,cAAA;IAOE,kBAAA;EACA;;EAEA;IACA,cAAA;IACA,mBAAA;EACA;;EAEA;IAEA,cAAA;IACA,UAAA;EjBwyFF;;EgBvpFE;IACE,cAAA;IACA,mBAAA;EhB0pFJ;;EarvFE;IGyFA,cAAA;IACE,mBAAA;EhBgqFJ;;EAEA;Ia5vFE,cAAA;IGyFA,UAAA;EhBsqFF;;EAEA;IACE,cAAc;IalwFd,mBAAA;EGyFA;;EhB6qFF;IACE,cAAc;IACd,mBAAmB;EaxwFnB;;Eb2wFF;IgBhrFI,cAAA;IhBkrFF,UAAU;EACZ;;EgBrrFE;IACE,cAAA;IACA,mBAAA;EhBwrFJ;;EkB31FF;IACE,cbu2BsC;ILu/DpC,mBAAmB;EACrB;;EkBr1FA;IACA,cAAA;IACA,WAAA;EhB8QI;;EF4kFJ;IACE,cAAc;EkBn1FlB;;EAEE;IhBoQI,wBALI;EFulFR;;EkBl1FF;IACE,yBAAA;EACA;;ElBs1FA;IACE,gBAAgB;EmBp3FpB;;EjB2RM;IiBtRJ,yBd+1BsC;ELqhEtC;;EoBz3FF;IACE,yBAAA;EACA;;ElByRI;IkBrRJ,gBfkmB4B;EejmB5B;;EAEA;IACA,yBfq3BsC;Eep3BtC;;ECIE;ICHE,yBFMJ;EpBu3FA;;EoBz4FF;IEiBQ,gBAAA;EtB43FN;;EoBz3FA;IACE,yBAAA;EpB43FF;;EoBz3FI;IpB43FF,yBAAyB;EoBv3F3B;;EAEE;;IAEA,gBAAA;EAKE;;EAIJ;;IAYE,gBAAA;EAKA;;EAKF;;IAEE,sBAAA;EpBk2FF;;EoB71FE;;IpBi2FA,sBAAsB;EoBv1FxB;;EAKE;;IAIF,qBAAA;EACE;;EAEA;;IG7FF,qBlBqiCgC;Eer8B9B;;EAEA;;IAEA,mBAAA;EACA;;EpBq1FF;;IoBh2FA,mBAAA;EpBm2FA;;EAEA;;IoBr1FE,qBf47B8B;EL45DhC;;EoB/0FF;;IAEE,qBAAA;EACA;;EAEA;;IAEA,mBAAA;EACA;;EpBm1FA;;IoB/0FE,mBAAA;EpBk1FF;AoB/0FA;;ApBk1FF;EACE,8BAA8B;EAC9B,2BAA2B;EoBt0F7B,+BAAA;EACE,4Bf4wBsC;Ee3wBtC,0CAAA;ElByII,gCALI;EmBvQN,+CAAA;ErB68FF,iCAAiC;EoBt0FjC,kDAAA;EACE,+DAAA;EACA,iDAAA;EACA,6DfooB0B;ELosE5B,gDAAgD;EAChD,8DAA8D;EoBr0FhE,WAAA;EACE,mBfgwBsC;Ee/vBtC,mBAAA;ElB4HI,0CALI;AFitFV;;AoBp0FE;EACE,sBAAA;EACA,qFAAA;EACA,oCf2nB0B;EL4sE5B,2CAA2C;EAC3C,2GAA2G;AoBh0F3G;;ApBm0FF;EoB/zFE,uBAAA;ApBi0FF;;AoB7zFE;EACE,sBfuuBoC;ALylExC;;AoB3zFA;EACE,+DfquBsC;ALylExC;;AAEA;EoB5zFE,iBAAA;ApB8zFF;;AoB1zFE;EACE,wBAAA;ApB6zFJ;;AoBzzFE;EACE,sCAAA;ApB4zFJ;;AoBxzFE;EAAoB,sCf8sBkB;AL8mExC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EwB7gGE,mBAAA;AxB+gGF;;AAEA;EwB5gGE,oDnB+lB4B;EmB9lB5B,8CnBsmB4B;ALw6E9B;;AAEA;EwB5gGE,oDAAA;EACA,8CAAA;AxB8gGF;;AAEA;EqBhhGI,oDAAA;ECHE,8CESJ;AxB6gGF;;AAEA;EACE,mDsBphGM;EtBqhGN,6CAA6C;AAC/C;;AAEA;EwBhhGI,sBAAA;EAKE,uCnBi+B4B;EL6iEhC,oDAAoD;EwB1gGpD,kDAAA;EAEE,8BnB6uB0B;EmB5uB1B,iDAAA;ExB2gGF,6BAA6B;EwBxgG7B,iDAAA;EAEE,4BnBu1BoC;ELkrEtC,4BAA4B;EwBpgG5B,0CAAA;AxBsgGF;;AAEA;EACE,sBAAsB;EwBngGxB,uCAAA;EACE,oDnBsuB4B;EmBruB5B,kDnBquB4B;EmBpuB5B,8BnBquB4B;EHlgBxB,iDALI;EmBvQN,6BAAA;ErBgjGF,gDAAgD;EAChD,4BAA4B;EwBngG9B,4BAAA;EACE,0CnBkuB4B;ALmyE9B;;AAEA;EqBtjGI,sBAAA;ErBwjGF,mCAAmC;EACnC,gDAAgD;EwBjgG9C,iDAAA;EACE,8BAAA;ExBmgGJ,+CAA+C;EAC/C,6BAA6B;EyB5kG/B,iDAAA;EACE,4BAAA;EACA,4BpBq6BwC;EoBp6BxC,0CpBq6BwC;ALyqE1C;;AyB3kGE;EACE,sBAAA;EACA,mCAAA;EzB8kGF,kDAAkD;EAClD,kDAAkD;EyB3kGpD,8BAAA;EACE,+CpB25BwC;EoB15BxC,6BAAA;EACA,kDAAA;EzB6kGA,4BAA4B;EyB3kG5B,4BAAA;EACE,0CAAA;AzB6kGJ;;AAEA;EACE,sBAAsB;EyB1kGxB,qCAAA;EACE,iDAAA;EAEA,kDAAA;EACA,8BpB04BwC;EoBz4BxC,gDpBy4BwC;EoBx4BxC,6BAAA;EACA,kDAAA;EACA,4BAAA;EACA,4BAAA;EACA,0CAAA;AzB2kGF;;AAEA;EyBzkGE,sBpB24BwC;EoB14BxC,uCAAA;EzB2kGA,oDAAoD;EyBxkGpD,kDAAA;EJ3BE,8BAAA;ErBsmGF,iDAAiD;EyBvkGjD,6BAAA;EAEE,iDpBm4BsC;ELqsExC,4BAA4B;EyBrkG5B,4BAAA;EACE,0CpB03BsC;AL6sE1C;;AAEA;EyBpkGI,sBAAA;EACA,sBpB8foB;ELwkFtB,iDAAiD;EyBnkGjD,iDAAA;EACE,8BC9DM;ED+DN,8CC/DM;E1BooGR,6BAA6B;EyBnkG3B,kDAAA;EAII,4BAAA;EzBkkGN,4BAA4B;EyB9jG1B,0CAAA;AzBgkGJ;;AyBvjGE;EACE,sBCnFM;EDoFN,sBCpFM;EDyFJ,gCAAA;EzBsjGJ,+CAA+C;EyBljG/C,8BAAA;EACE,2CAAA;EACA,6BAAA;EACA,gDpBk2BuC;ELktEzC,4BAA4B;EyB7iG1B,4BAAA;EACE,0CAAA;AzB+iGN;;AAEA;EyBliGA,gBAAA;EACE,iCpBo1BgC;ALgtElC;;AAEA;EyBjiGI;IACA,gBAAA;IACA,iCAAA;EACA;AzBmiGJ;;AAEA;EsBrpGM;IG0GJ,gBAAA;IHzGM,iCAAA;EtBwpGN;AACF;;AAEA;EACE;IyBriGE,gBAAA;IACE,iCpB60B4B;EoBx0B1B;AzBmiGR;;AAEA;EyB9hGI;IzBgiGA,gBAAgB;IyB9hGhB,iCAAA;EACE;AzBgiGN;;AAEA;EyB5hGA;IACE,gBAAA;IACA,iCpBsyBgC;ELwvEhC;AACF;;AAEA;EyB5hGE,qBAAA;AzB8hGF;;AyBzhGI;EACE,oDAAA;EACA,uDAAA;EACA,gBpBspBwB;ELs4E5B,kBAAkB;EAClB,gBAAgB;AyBthGd;;AzByhGJ;EACE,kDAAkD;E2B5sGpD,qDAAA;EACE,iBAAA;A3B8sGF;;AAEA;E2B5sGE,mDAAA;E3B8sGA,sDAAsD;E2B5sGtD,kBAAA;A3B8sGF;;A2BzsGI;EAA0B,mBtB8gCa;EL+rEzC,kBAAkB;E2B5sGhB,gCAAA;A3B8sGJ;;A2B3sGE;EACE,cAAA;E3B8sGF,WAAW;E2B3sGX,yBAAA;EACE,kBtB+/BuC;EsB9/BvC,gBtB8/BuC;EsB7/BvC,gBAAA;EACA,2BAAA;EJ1BF,gBAAA;EI4BE,mCtB6/BuC;EgB1gCvC,4BAAA;ECHE,2DKmBF;E3B4sGF,sCAAsC;EsB3tGlC,wEAAA;AtB6tGN;;AAEA;EACE;I2B/sGE,gBAAA;EJjCF;AvBmvGF;;AAEA;E2B7sGI,gBtBw+B8B;ALuuElC;;AAEA;E2B7sGI,eAAA;A3B+sGJ;;A2B1sGE;EACE,2BtBo+BuC;EsBn+BvC,mCtBm+BuC;EsBl+BvC,oCAAA;EJpDF,UAAA;EIsDE,kDtBm+BuC;AL0uE3C;;AAEA;EsBrvGM,eAAA;EKiCJ,aAAA;E3ButGA,SsBvvGM;AtBwvGR;;A2B9sGI;EJ3DF,cAAA;EvB6wGA,UAAU;A2B7sGV;;A3BgtGF;E2B7sGI,gCAAA;EACA,UtB68B8B;ALkwElC;;AAEA;EACE,wCAAwC;E2B3sGxC,UAAA;A3B6sGF;;A2B1sGI;EACE,yBtBg9BqC;EL6vEzC,0BAA0B;E2B1sGxB,0BAAA;EACE,2BtB48BqC;ELgwEzC,uCAAuC;EACvC,oBAAoB;E4BpyGtB,qBAAA;EACE,mBAAA;E5BsyGA,eAAe;E4BpyGf,+CAAA;EAAA,gBAAA;EAAA,qIAAA;A5BwyGF;;AAEA;EACE;I4BnyGA,gBAAA;EACE;A5BqyGJ;;AAEA;E4BnyGI,wCAAA;A5BqyGJ;;AAEA;E4BnyGI,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,6BAAA;ENVE,yBMWF;E5BqyGF,sCAAsC;AsB5yGlC;;AtB+yGN;EACE,UAAU;AACZ;;A4BvyGE;;E5B2yGA,gBAAgB;E4BvyGd,eAAA;AAAA;;A5B2yGJ;E4BvyGI,mEAAA;EAAA,uBAAA;EAAA,kBAAA;EAEE,yCvB0gCkC;ALgyExC;;A4BtyGI;EAAA,uBAAA;EACE,wBvBqgCkC;EuBpgClC,yBvBqgCkC;ALqyExC;;AAEA;E4BtyGI,iEvB+/BoC;EuB9/BpC,oBvBguB0B;ELwkF5B,iBAAiB;E4BjyGf,yCAAA;AAAA;;AAAA;EACE,oBvBy/BkC;EL6yEtC,qBAAqB;E4BjyGnB,uBAAA;A5BmyGJ;;A4B7xGI;EAAA,oEAAA;A5BiyGJ;;AAEA;E4B/xGM,mEvBw+BkC;ALyzExC;;AAEA;EACE,iEAAiE;A4B9xGjE;;A5BiyGF;E4B5xGI,WAAA;EACE,gEAAA;E5B8xGJ,iBAAiB;A4B1xGjB;;A5B6xGF;EACE,eAAe;AACjB;;AAEA;E6Bv3GE,oBAAA;EACA,sCAAA;A7By3GF;;AAEA;E6Bv3GE,oBAAA;EAAA,sCAAA;AAAA;;A7B43GF;E6Bv3GI,+DAAA;A7By3GJ;;A6Bp3GE;EAAA,6DAAA;AAAA;;A7B03GF;E6Bj3GE,gEAAA;EACE,cAAA;EACA,WAAA;E7Bm3GF,0CAA0C;E6Bj3GxC,kBAAA;EACE,gBAAA;E7Bm3GJ,gBAAgB;EAChB,2BAA2B;E6Bz2G7B,gBAAA;EACE,mCAAA;EACA,mFAAA;EACA,4BAAA;E3B8OI,yCALI;E2BvOR,0BxByjB4B;EwBxjB5B,2DxBgkB4B;EwB/jB5B,sCxBm1BsC;EwBl1BtC,wEAAA;A7B22GF;;AAEA;EqBh5GI;IrBk5GA,gBAAgB;EAClB;A6Bn2GF;;AAAA;EAAA,oCAAA;EAIE,UAAA;E3BwNI,kDALI;AFmpGV;;AAEA;;E6Bn2GA,sBAAA;EAAA,sBAAA;AAAA;;A7By2GA;EqBl6GI,wCAAA;ArBo6GJ;;A6Bl2GA;EAAA,kBAAA;EAEE,uCAAA;A7Bq2GF;;A6Bx1GI;EAAA,oBAAA;EAAA,uBAAA;EAAA,oBAAA;ERjEA,kBAAA;EACA,yCAAA;ArBg6GJ;;A6Bv1GI;EAAA,mBAAA;EAAA,sBAAA;ER1EA,kBAAA;EACA,iBAAA;ErBu6GF,yCAAyC;A6Bj1GzC;;A7Bo1GF;EqB55GI,gEAAA;ArB85GJ;;A6Bj1GE;ER9EE,cAAA;EACA,mBAAA;ErBm6GF,mBAAmB;EACnB,uBAAuB;A8B57GvB;;A9B+7GF;E8B57GI,WAAA;E5BkQE,mBALI;AFksGV;;AAEA;E8B37GE,oBAAA;EACE,eAAA;EACA,iBAAA;A9B67GJ;;AAEA;E8B37GI,YAAA;EACA,oBAAA;E5BqPE,cALI;AF8sGV;;AAEA;EACE,qCAAqC;EACrC,cAAc;E8Bz7GZ,UAAA;EAAA,WAAA;EAAA,kBAAA;EAAA,mBAAA;EAEE,gBAAA;E9B67GJ,yCAAyC;EACzC,+CAA+C;E8B7+G7C,4BAAA;EAqDE,2BzBuhCmB;EyBphCjB,wBzB81BgC;EyB71BhC,2DAAA;EACA,yBAAA;A9By7GR;;AAEA;E8Bt7GM,qBAAA;A9Bw7GN;;AAEA;EACE,kBAAkB;A8B1/GhB;;A9B6/GJ;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;E8Bx6G9B,UAAA;EAEE,kDAAA;A9By6GV;;AAEA;EACE,yBAAyB;E8Br6GrB,qBAAA;A9Bu6GN;;AAEA;EACE,iEAAuP;A8B7gHrP;;A9BghHJ;EACE,iEAA+J;A8BjhH7J;;A9BohHJ;E8Bz5GM,yBAAA;EACE,qBzBg9BiB;EL28EvB,iEAAiP;A8Bx5G7O;;A9B25GN;E8Bv5GM,oBAAA;EACE,YzBw8BiB;ELi9EvB,YAAY;AACd;;AAEA;;EAEE,eAAe;E8BliHb,YAAA;AAAA;;AAAA;EAAA,mBAAA;A9BwiHJ;;AAEA;E8BthHE,4DAAA;EACE,UAAA;EACA,mBAAA;EACA,0CzBu0BoC;EHrkBlC,gCALI;E4B1PN,kBzBkjCqB;ELq+EvB,iDAAiD;AACnD;;AAEA;E8BrhHI;IACA,gBAAA;EACA;A9BuhHJ;;AAEA;EEjyGM,4DALI;AFwyGV;;AAEA;EACE,iCAAiC;EACjC,4DAA0J;A8BnhHxJ;;AAAA;EAAA,oBAAA;EAEE,eAAA;A9BuhHN;;A8BtkHI;EAqDE,oBzBuhCmB;EyBphCjB,cAAA;A9BmhHR;;AAEA;E8BjhHQ,qBAAA;E9BmhHN,kBAAkB;A8BhhHd;;A9BmhHN;EACE,kBAAkB;EAClB,sBAAsB;E8BplHpB,oBAAA;A9BslHJ;;AAEA;;E8BxlHI,oBAAA;EAuFE,YAAA;E9BqgHJ,aAAa;A8BlgHP;;A9BqgHR;E8BjgHU,4DAAA;A9BmgHV;;A8B9/GM;EACE,WAAA;EAKE,czBm+Be;EL0hFvB,UAAU;EACV,gBAAgB;E8BvmHd,6BAAA;A9BymHJ;;AAEA;E8B3mHI,UAAA;A9B6mHJ;;A8Bl/GM;EACE,qEzBg9BiB;ALqiFzB;;AAEA;EACE,qEAAqE;A8Bj/GjE;;A9Bo/GN;EACE,SAAS;A8B/+GP;;A9Bk/GJ;EACE,WAAW;E8B5nHT,YAAA;EAAA,oBAAA;EAAA,gBAAA;EAAA,yBAAA;EAAA,SAAA;EAsJM,mBAAA;E9B6+GR,oHAA4G;EAA5G,4GAA4G;AAC9G;;AAEA;E+BroHE;IACA,wBAAA;IAAA,gBAAA;E7BuRI;AFi3GN;;AAEA;E+BroHE,0CAAA;A/BuoHF;;AAEA;E+BroHE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EAGA,wCAAA;EACA,yBAAA;EACA,mBAAA;A/BqoHF;;AAEA;E+BnoHE,WAAA;EACA,YAAA;EACA,gBAAA;EAEA,yBAAA;EACA,SAAA;EACA,mBAAA;EACA,iHAAA;EAAA,4GAAA;A/BooHF;;AAEA;EACE;IsBvpHI,qBAAA;IAAA,gBAAA;EShBN;A/B0qHA;;AAEA;E+BtoHE,0CAAA;A/BwoHF;;AAEA;EACE,WAAW;E+BpoHX,cAAA;EAEE,kBAAA;EACA,eAAA;EACA,wCAAA;E/BqoHF,yBAAyB;E+BloHzB,mBAAA;A/BooHF;;AAEA;E+BloHI,oBAAA;A/BooHJ;;A+B3nHE;EACE,2CAAA;A/B8nHJ;;AAEA;E+BtnHE,2CAAA;A/BwnHF;;AAEA;EACE,kBAAkB;A+B/mHhB;;A/BknHJ;;;EAGE,uDAAuD;E+BlmHvD,2DAAA;EAGE,iBAAA;A/BkmHJ;;AAEA;E+B/lHI,kBAAA;E/BimHF,MAAM;EACN,OAAO;E+BtlHP,UAAA;EC/GA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,2CAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;EACA,gEAAA;AhCwsHF;;AAEA;EACE;I+BvmHA,gBAAA;EC/GA;AhCytHF;;AAEA;;EgCttHE,qBAAA;AhCytHF;;AAEA;;EgCttHE,kBAAA;AhCytHF;;AAEA;;;;EgCruHE,qBAAA;EACA,wBAAA;AhC0uHF;;AAEA;;EgCvuHE,qBAAA;EACA,wBAAA;AhC0uHF;;AAEA;EgCxuHE,qBAAA;EACA,wBAAA;EACA,qBAAA;AhC0uHF;;A+BxoHE;;;;EC5GA,8DAAA;AhC2vHF;;AAEA;EgCzvHE,8DAAA;AhC2vHF;;AAEA;;EgCxvHE,kBAAA;EACA,oBAAA;EhC2vHA,WAAW;EACX,aAAa;E+B1pHb,WAAA;EC/GA,mCAAA;EACA,sCAAA;AhC4wHF;;AAEA;EgC1wHE,wCAAA;AhC4wHF;;AAEA;EgC1wHE,sCAAA;AhC4wHF;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EgC3xHE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AhC6xHF;;AAEA;;;EgCzxHE,kBAAA;EACA,cAAA;EACA,SAAA;EhC6xHA,YAAY;AACd;;AAEA;;;EgC1yHE,UAAA;AhC8yHF;;AAEA;EgC5yHE,kBAAA;EACA,UAAA;AhC8yHF;;AAEA;EgC5yHE,UAAA;AhC8yHF;;AAEA;E+B7sHE,aAAA;EC/GA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,mBAAA;EACA,uCAAA;EACA,2DAAA;EACA,sCAAA;AhC+zHF;;AAEA;;;;EgC30HE,oBAAA;EACA,iBAAA;EACA,yCAAA;AhCg1HF;;AAEA;;;;EgC30HE,uBAAA;EACA,kBAAA;EACA,yCAAA;AhCg1HF;;AAEA;;E+B9uHE,mBAAA;A/BivHF;;AAEA;;;;EgC51HE,0BAAA;EACA,6BAAA;AhCi2HF;;AAEA;;;;EAIE,0BAA0B;EAC1B,6BAA6B;A+BhwH7B;;A/BmwHF;EgCh3HE,8CAAA;EACA,yBAAA;EACA,4BAAA;AhCk3HF;;AAEA;;EgC/2HE,yBAAA;EACA,4BAAA;AhCk3HF;;AAEA;EACE,aAAa;EACb,WAAW;E+BjxHX,mBAAA;EC/GA,kBAAA;EACA,iCAAA;AhCm4HF;;AAEA;EgCj4HE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EhCm4HA,mCAAmC;EACnC,sCAAsC;A+BlyHtC;;A/BqyHF;;;;EgC/4HE,cAAA;AhCo5HF;;AAEA;;EgCj5HE,+CAAA;EACA,oCAAA;EACA,yDAAA;EACA,4BAAA;EhCo5HA,2DAA2D;EAC3D,gEAAgE;A+BnzHhE;;A/BszHF;;EgCl6HE,+CAAA;EACA,2DAAA;AhCq6HF;;AAEA;;EgCl6HE,oCAAA;EACA,kFAAA;AhCq6HF;;AAEA;;EAEE,+CAA+C;A+Bp0H/C;;A/Bu0HF;;;;EgCj7HE,iEAAA;EACA,uBAAA;EACA,+DAAA;EACA,2EAAA;AhCs7HF;;AAEA;;EgCn7HE,+CAAA;EhCs7HA,2DAA2D;AAC7D;;AAEA;;EgCp8HE,yCAAA;AhCu8HF;;AAEA;;EgCp8HE,+CAAA;AhCu8HF;;AAEA;;EgCp8HE,4CAAA;AhCu8HF;;AAEA;;EgCr9HE,2DAAA;AhCw9HF;;AAEA;;EgCr9HE,iCAAA;AhCw9HF;;AAEA;EgCt9HE,kBAAA;AhCw9HF;;AAEA;;;;;;EgCl+HE,UAAA;AhCy+HF;;AAEA;EgCv+HE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,mCAAA;AhCy+HF;;AAEA;EgCv+HE,kBAAA;EhCy+HA,SAAS;EACT,UAAU;E+Bx4HV,aAAA;EC/GA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kCAAA;EACA,sCAAA;AhC0/HF;;AAEA;;;;EgCr/HE,cAAA;AhC0/HF;;A+Bx5HE;;EC9GA,iDAAA;EACA,oCAAA;EACA,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;AhC2gIF;;AAEA;;EgCxgIE,iDAAA;EACA,0DAAA;AhC2gIF;;AAEA;;EgCzhIE,oCAAA;EACA,kFAAA;AhC4hIF;;AAEA;;EgCzhIE,iDAAA;AhC4hIF;;AAEA;;;;EgCvhIE,kEAAA;EhC4hIA,uBAAuB;EACvB,+DAA+D;E+B37H/D,2EAAA;A/B67HF;;AAEA;;EgC1iIE,iDAAA;EACA,0DAAA;AhC6iIF;;AAEA;;EgC1iIE,yCAAA;AhC6iIF;;AAEA;;EAEE,iDAAiD;A+B58HjD;;A/B+8HF;;EgC3jIE,8CAAA;AhC8jIF;;AAEA;;EgC3jIE,0DAAA;AhC8jIF;;AAEA;;EgC3jIE,mCAAA;AhC8jIF;;A+B59HE;EC/GA,kBAAA;AhC+kIF;;AAEA;;;;;;EgCxkIE,UAAA;AhC+kIF;;AAEA;EgC7kIE,2BAAA;EhC+kIA,4BAA4B;EAC5B,sBAAsB;E+B9+HtB,2BAAA;EC/GA,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EACA,qBAAA;EACA,wDAAA;EACA,sCAAA;EhCgmIA,kCAAkC;EAClC,sCAAsC;E+B//HtC,sCAAA;EC/GA,0BAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EACA,0CAAA;EACA,kCAAA;EACA,qIAAA;AhCinIF;;AAEA;EgC/mIE;IhCinIE,gBAAgB;EAClB;A+BhhIA;;A/BmhIF;EgChoIE,gCAAA;EACA,wCAAA;EACA,8CAAA;AhCkoIF;;AAEA;EgChoIE,0BAAA;EACA,kCAAA;EACA,wCAAA;AhCkoIF;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;E+BjiIxC,8CAAA;EC/GA,UAAA;EACA,0CAAA;AhCmpIF;;AAEA;EgCjpIE,8CAAA;EACA,UAAA;EACA,0CAAA;AhCmpIF;;AAEA;;;;;EAKE,iCAAiC;E+BljIjC,yCAAA;EC/GA,+CAAA;AhCoqIF;;AAEA;;;;;EgC9pIE,0CAAA;AhCoqIF;;AAEA;EgClqIE,0CAAA;AhCoqIF;;AAEA;;;EgCjrIE,mCAAA;EACA,oBAAA;EACA,2CAAA;EACA,iDAAA;EACA,uCAAA;AhCqrIF;;AAEA;EgCnrIE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EhCqrIA,oDAAoD;EACpD,uCAAuC;E+BplIvC,2BAAA;EC/GA,2CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCssIF;;AAEA;EgCpsIE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EhCssIA,kDAAkD;EAClD,sCAAsC;E+BrmItC,2BAAA;EC/GA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCutIF;;AAEA;EgCrtIE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EhCutIA,iDAAiD;EACjD,qCAAqC;E+BtnIrC,2BAAA;EC/GA,sCAAA;EACA,kDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCwuIF;;AAEA;EgCtuIE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EhCwuIA,gDAAgD;EAChD,uCAAuC;E+BvoIvC,2BAAA;EC/GA,uCAAA;EACA,iDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCyvIF;;AAEA;EgCvvIE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EhCyvIA,kDAAkD;EAClD,uCAAuC;E+BxpIvC,2BAAA;EC/GA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC0wIF;;AAEA;EgCxwIE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EhC0wIA,oDAAoD;EACpD,sCAAsC;E+BzqItC,2BAAA;EC/GA,2CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC2xIF;;AAEA;EgCzxIE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6CAAA;EhC2xIA,qDAAqD;EACrD,wCAAwC;E+B1rIxC,2BAAA;EC/GA,4CAAA;EACA,wDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC4yIF;;AAEA;EgC1yIE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EhC4yIA,kDAAkD;EAClD,qCAAqC;E+B3sIrC,2BAAA;EC/GA,2BAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC6zIF;;AAEA;EgC3zIE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EhC6zIA,oDAAoD;EACpD,uCAAuC;E+B5tIvC,2BAAA;EC/GA,2CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC80IF;;AAEA;EgC50IE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6CAAA;EhC80IA,oDAAoD;EACpD,uCAAuC;E+B7uIvC,2BAAA;EC/GA,2CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC+1IF;;AAEA;EgC71IE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EhC+1IA,iDAAiD;EACjD,uCAAuC;E+BpuIvC,2BAAA;EChHA,wCAAA;EACA,iDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCu1IF;;AAEA;EgCr1IE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6CAAA;EhCu1IA,oDAAoD;EACpD,uCAAuC;E+BrvIvC,2BAAA;EChHA,2CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCw2IF;;AAEA;EgCt2IE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EhCw2IA,iDAAiD;EACjD,uCAAuC;E+BtwIvC,2BAAA;EChHA,wCAAA;EACA,iDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCy3IF;;AAEA;EgCv3IE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EhCy3IA,kDAAkD;EAClD,uCAAuC;E+BvxIvC,2BAAA;EChHA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC04IF;;AAEA;EgCx4IE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EhC04IA,gDAAgD;EAChD,sCAAsC;E+BxyItC,2BAAA;EChHA,uCAAA;EACA,iDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC25IF;;AAEA;EgCz5IE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EhC25IA,mDAAmD;EACnD,qCAAqC;E+BzzIrC,2BAAA;EChHA,0CAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC46IF;;AAEA;EgC16IE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,8CAAA;EhC46IA,qDAAqD;EACrD,uCAAuC;E+B10IvC,2BAAA;EChHA,wCAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC67IF;;AAEA;EgC37IE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EhC67IA,mDAAmD;EACnD,wCAAwC;E+B31IxC,2BAAA;EChHA,wCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC88IF;;AAEA;EgC58IE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EhC88IA,mDAAmD;EACnD,wCAAwC;E+B52IxC,2BAAA;EChHA,0CAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC+9IF;;AAEA;EgC79IE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EhC+9IA,mDAAmD;EACnD,wCAAwC;E+B73IxC,2BAAA;EChHA,wCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCg/IF;;AAEA;EgC9+IE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EhCg/IA,qDAAqD;EACrD,wCAAwC;E+B94IxC,2BAAA;EChHA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCigJF;;AAEA;EgC//IE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EhCigJA,mDAAmD;EACnD,wCAAwC;E+B/5IxC,2BAAA;EChHA,0CAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCkhJF;;AAEA;EgChhJE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,uCAAA;EhCkhJA,8CAA8C;EAC9C,sCAAsC;E+Bh7ItC,2BAAA;EChHA,qCAAA;EACA,gDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCmiJF;;AAEA;EgCjiJE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EhCmiJA,mDAAmD;EACnD,qCAAqC;E+Bj8IrC,2BAAA;EChHA,2CAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCojJF;;AAEA;EgCljJE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EhCojJA,mDAAmD;EACnD,qCAAqC;E+Bl9IrC,2BAAA;EChHA,wCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCqkJF;;AAEA;EgCnkJE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EhCqkJA,iDAAiD;EACjD,wCAAwC;E+Bn+IxC,2BAAA;EChHA,wCAAA;EACA,kDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCslJF;;AAEA;EgCplJE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,sCAAA;EhCslJA,+CAA+C;EAC/C,sCAAsC;E+Bp/ItC,2BAAA;EChHA,uCAAA;EACA,gDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCumJF;;AAEA;EgCrmJE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EhCumJA,kDAAkD;EAClD,sCAAsC;E+BrgJtC,2BAAA;EChHA,yCAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCwnJF;;AAEA;EgCtnJE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EhCwnJA,iDAAiD;EACjD,wCAAwC;E+BthJxC,2BAAA;EChHA,wCAAA;EACA,kDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCyoJF;;AAEA;EgCvoJE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6CAAA;EhCyoJA,oDAAoD;EACpD,uCAAuC;E+BviJvC,2BAAA;EChHA,2CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC0pJF;;AAEA;EgCxpJE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EhC0pJA,oDAAoD;EACpD,uCAAuC;E+BxjJvC,2BAAA;EChHA,2CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC2qJF;;AAEA;EgCzqJE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EhC2qJA,mDAAmD;EACnD,wCAAwC;E+BzkJxC,2BAAA;EChHA,0CAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC4rJF;;AAEA;EgC1rJE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,8CAAA;EhC4rJA,qDAAqD;EACrD,wCAAwC;E+B1lJxC,2BAAA;EChHA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC6sJF;;AAEA;EgC3sJE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,8CAAA;EhC6sJA,qDAAqD;EACrD,wCAAwC;E+B3mJxC,2BAAA;EChHA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC8tJF;;AAEA;EgC5tJE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EhC8tJA,mDAAmD;EACnD,wCAAwC;E+B5nJxC,2BAAA;EChHA,wCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC+uJF;;AAEA;EgC7uJE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EhC+uJA,mDAAmD;EACnD,wCAAwC;E+B7oJxC,2BAAA;EChHA,0CAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCgwJF;;AAEA;EgC9vJE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EhCgwJA,kDAAkD;EAClD,wCAAwC;E+B9pJxC,2BAAA;EChHA,yCAAA;EACA,kDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCixJF;;AAEA;EgC/wJE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6CAAA;EhCixJA,qDAAqD;EACrD,wCAAwC;E+B/qJxC,2BAAA;EChHA,0CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCkyJF;;AAEA;EgChyJE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EhCkyJA,mDAAmD;EACnD,wCAAwC;E+BhsJxC,2BAAA;EChHA,0CAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCmzJF;;AAEA;EgCjzJE,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EhCmzJA,iDAAiD;EACjD,wCAAwC;E+BjtJxC,2BAAA;EChHA,wCAAA;EACA,kDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCo0JF;;AAEA;EgCl0JE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EhCo0JA,uCAAuC;EACvC,2BAA2B;E+BluJ3B,2BAAA;EChHA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCq1JF;;AAEA;EgCn1JE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EhCq1JA,qCAAqC;EACrC,2BAA2B;E+BnvJ3B,2BAAA;EChHA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCs2JF;;AAEA;EgCp2JE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EhCs2JA,sCAAsC;EACtC,2BAA2B;E+BpwJ3B,2BAAA;EChHA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCu3JF;;AAEA;EgCr3JE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EhCu3JA,uCAAuC;EACvC,2BAA2B;E+BrxJ3B,2BAAA;EChHA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCw4JF;;AAEA;EgCt4JE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EhCw4JA,uCAAuC;EACvC,2BAA2B;E+BtyJ3B,2BAAA;EChHA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCy5JF;;AAEA;EgCv5JE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EhCy5JA,sCAAsC;EACtC,2BAA2B;E+BvzJ3B,2BAAA;EChHA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC06JF;;AAEA;EgCx6JE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EhC06JA,wCAAwC;EACxC,2BAA2B;E+Bx0J3B,2BAAA;EChHA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC27JF;;AAEA;EgCz7JE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EhC27JA,kCAAkC;EAClC,2BAA2B;E+Bz1J3B,2BAAA;EChHA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC48JF;;AAEA;EgC18JE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EhC48JA,uCAAuC;EACvC,2BAA2B;E+B12J3B,2BAAA;EChHA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC69JF;;AAEA;EgC39JE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EhC69JA,uCAAuC;EACvC,2BAA2B;E+B33J3B,2BAAA;EChHA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC8+JF;;AAEA;EgC5+JE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EhC8+JA,uCAAuC;EACvC,2BAA2B;E+Bh4J7B,2BAAA;EACE,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/Bk4JF;;AAEA;E+Bh4JE,uBAAA;EACA,8BAAA;EACA,0BAAA;EAEA,0B1B8QwC;ELmnJxC,oCAAoC;E+Bv3JpC,uCAAA;EACE,2BAAA;E/By3JF,2BAA2B;E+Bt3J3B,qCAAA;EACE,4DAAA;E/Bw3JF,gCAAgC;EAChC,iCAAiC;E+B92JnC,uCAAA;ECjJE,mBAAA;AhCkgKF;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;E+Bj3JhC,0BAAA;ECrJE,0BAAA;EACA,oCAAA;E9B8NI,uCALI;E8BvNR,2BAAA;EhCygKA,2BAA2B;EAC3B,qCAAqC;EiC7kKvC,4DAAA;EXgBM,gCWfJ;EjC+kKA,iCAAiC;EsB5jK7B,uCAAA;EWpBN,mBAAA;AjCmlKA;;AAEA;EiCllKE,uBAAA;EACE,8BAAA;EjColKF,0BAA0B;EAC1B,0BAA0B;EiC/kK1B,oCAAA;EACE,sCAAA;EjCilKF,2BAA2B;EAC3B,2BAA2B;EiC9kK7B,qCAAA;EACE,4DAAA;EACA,gCAAA;EXDI,iCWEJ;EjCglKA,uCAAuC;EsB9kKnC,mBAAA;AtBglKN;;AAEA;EACE,uBAAuB;EiCnlKvB,8BAAA;EACE,0BAAA;EACA,0BAAA;EXNE,oCWOF;EjCqlKF,qCAAqC;EsBxlKjC,2BAAA;EWAJ,2BAAA;EjC2lKA,qCsB1lKM;EtB2lKN,4DAA4D;EAC5D,gCAAgC;EAChC,iCAAiC;EkCjnKnC,uCAAA;EAAA,mBAAA;AAAA;;AAAA;EAAA,uBAAA;EAME,8BAAA;ElCmnKA,0BAA0B;EAC1B,0BAA0B;EkCjnK5B,oCAAA;EACE,qCAAA;ElCmnKA,2BAA2B;EmC3lKzB,2BAAA;EACE,qCAAA;EACA,4D9B6hBwB;E8B5hBxB,gC9B2hBwB;E8B1hBxB,iCAAA;EArCJ,uCAAA;EACA,mBAAA;AnCmoKF;;AAEA;EmCzkKI,uBAAA;EACE,8BAAA;EnC2kKJ,0BAA0B;EAC1B,0BAA0B;EkC1nK5B,oCAAA;EAEE,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EhCuQI,gCALI;EgChQR,iCAAA;EACA,uCAAA;EACA,mBAAA;AlC2nKF;;AAEA;EkCznKE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlC2nKF;;AAEA;EkCvnKE,uBAAA;EACA,8BAAA;EACA,0BAAA;EhC0OI,0BALI;EgCnOR,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EbzCE,gCAAA;ErBmqKF,iCAAiC;EkCtnKjC,uCAAA;EACE,mBAAA;AlCwnKJ;;AAEA;EACE,uBAAuB;EkCjmKrB,8BAAA;EACE,0BAAA;ElCmmKJ,0BAA0B;EkCjmKtB,oCAAA;EACE,wCAAA;EACA,2BAAA;ElCmmKN,2BAA2B;EAC3B,qCAAqC;EkChmKnC,4DAAA;EACE,gCAAA;ElCkmKJ,iCAAiC;EkChmK7B,uCAAA;EACE,mBAAA;AlCkmKR;;AAEA;Ea7oKI,uBAAA;EqB4BA,8BAAA;ElConKF,0BkCnnKI;ElConKJ,0BAA0B;EkClnKtB,oCAAA;ElConKJ,wCkCnnKM;ElConKN,2BkCnnKM;ElConKN,2BAA2B;EkChnKzB,qCAAA;ElCknKF,4DkCjnKI;ElCknKJ,gCAAgC;EkChnK5B,iCAAA;ElCknKJ,uCkCjnKM;ElCknKN,mBkCjnKM;AlCknKR;;Aa5pKI;EqB4BA,uBAAA;ElCooKF,8BkCnoKI;ElCooKJ,0BAA0B;EkCloKtB,0BAAA;ElCooKJ,oCkCnoKM;ElCooKN,wCkCnoKM;ElCooKN,2BAA2B;EkChoKzB,2BAAA;ElCkoKF,qCkCjoKI;ElCkoKJ,4DAA4D;EkChoKxD,gCAAA;ElCkoKJ,iCkCjoKM;ElCkoKN,uCkCjoKM;ElCkoKN,mBAAmB;AACrB;;AAEA;EACE,uBkCnpKI;ElCopKJ,8BAA8B;EkClpK1B,0BAAA;ElCopKJ,0BkCnpKM;ElCopKN,oCkCnpKM;ElCopKN,qCAAqC;EkChpKnC,2BAAA;ElCkpKF,2BkCjpKI;ElCkpKJ,qCAAqC;EkChpKjC,4DAAA;ElCkpKJ,gCkCjpKM;ElCkpKN,iCkCjpKM;ElCkpKN,uCAAuC;EACvC,mBAAmB;Aa7rKjB;;AbgsKJ;EACE,uBAAuB;EkClqKnB,8BAAA;ElCoqKJ,0BkCnqKM;ElCoqKN,0BkCnqKM;ElCoqKN,oCAAoC;EkChqKlC,qCAAA;ElCkqKF,2BkCjqKI;ElCkqKJ,2BAA2B;EkChqKvB,qCAAA;ElCkqKJ,4DkCjqKM;ElCkqKN,gCkCjqKM;ElCkqKN,iCAAiC;EACjC,uCAAuC;Ea7sKrC,mBAAA;Ab+sKJ;;AAEA;EkClrKM,uBAAA;ElCorKJ,8BkCnrKM;ElCorKN,0BkCnrKM;ElCorKN,0BAA0B;EkChrKxB,oCAAA;ElCkrKF,qCkCjrKI;ElCkrKJ,2BAA2B;EkChrKvB,2BAAA;ElCkrKJ,qCkCjrKM;ElCkrKN,4DkCjrKM;ElCkrKN,gCAAgC;EAChC,iCAAiC;EkCzqKjC,uCAAA;EACE,mBAAA;AlC2qKJ;;AAEA;EACE,uBAAuB;EmC/vKrB,8BAAA;EACE,0BAAA;EACA,0B9B6hBwB;E8B5hBxB,oC9B2hBwB;E8B1hBxB,wCAAA;EA9BJ,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EnCgyKA,gCAAgC;EmC7uK9B,iCAAA;EACE,uCAAA;EnC+uKJ,mBAAmB;AACrB;;AAEA;EkChrKI,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;ElCkrKF,oCAAoC;EmCpxKlC,sCAAA;EACE,2BAAA;EACA,2B9B6hBwB;E8B5hBxB,qC9B2hBwB;E8B1hBxB,4DAAA;EAvBJ,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AnC8yKF;;AAEA;EACE,uBAAuB;EkC1rKrB,8BAAA;EACE,0BAAA;ElC4rKJ,0BAA0B;EAC1B,oCAAoC;EkCvrKpC,qCAAA;EACE,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;ElCyrKF,iCAAiC;EmC5yK/B,uCAAA;EACE,mBAAA;AnC8yKN;;AAEA;EACE,uBAAuB;EmCnyKnB,8BAAA;EACE,0BAAA;EnCqyKN,0BAA0B;EmClyKtB,oCAAA;EACE,wCAAA;EACA,2B9B0gBsB;E8BzgBtB,2B9BwgBsB;E8BvgBtB,qCAAA;EAnCN,4DAAA;EACA,gCAAA;EACA,iCAAA;EnCw0KA,uCAAuC;EmClyKrC,mBAAA;AnCoyKJ;;AkCxsKI;EACE,uBAAA;ElC2sKJ,8BAA8B;EAC9B,0BAA0B;EkCrsK5B,0BAAA;EACE,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;ElCusKA,4DAA4D;EAC5D,gCAAgC;EkClsKlC,iCAAA;EACE,uCAAA;EACA,mBAAA;AlCosKF;;AAEA;EkClsKE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EbtKE,2BAAA;ErB22KF,2BAA2B;EkClsK3B,qCAAA;EAEE,4DAAA;EX1LF,gCW4LuB;ElCksKvB,iCAAiC;EkC/rKjC,uCAAA;EAEE,mBAAA;AlCgsKJ;;AAEA;EkC7rKE,uBAAA;EAEE,8BAAA;EACA,0BAAA;EACA,0BAAA;ElC8rKF,oCAAoC;EACpC,wCAAwC;EkCzrK1C,2BAAA;EACE,2BAAA;ElC2rKA,qCAAqC;EACrC,4DAA4D;EkCxrK9D,gCAAA;EACE,iCAAA;EACA,uCAAA;EACA,mBAAA;AlC0rKF;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EkCvrKhC,0BAAA;EACE,0BAAA;EACA,oCAAA;EACA,wCAAA;ElCyrKA,2BAA2B;EAC3B,2BAA2B;EkCtrK7B,qCAAA;EAEE,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AlCurKF;;AAEA;EkCrrKE,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;ElCurKA,oCAAoC;EACpC,wCAAwC;EoC96K1C,2BAAA;EAAA,2BAAA;EAEE,qCAAA;EACA,4DAAA;EACA,gCAAA;EpCg7KA,iCAAiC;EoC96KjC,uCAAA;EAAA,mBAAA;ApCi7KF;;AAEA;EoC56KE,uBAAA;EAAA,8BAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,qCAAA;EAAA,4DAAA;EAAA,gCAAA;EAAA,iCAAA;EAME,uCAAA;EpCo7KF,mBAAmB;AACrB;;AAEA;EoCh7KE,uBAAA;EACA,8BAAA;EpCk7KA,0BAA0B;EoCh7K1B,0BAAA;EACE,oCAAA;EpCk7KF,wCAAwC;EACxC,2BAA2B;EoC/6K7B,2BAAA;EfhBI,qCAAA;ErBk8KF,4DAA4D;EoC96K5D,gCAAA;EAAA,iCAAA;EAEE,uCAAA;EpCg7KF,mBAAmB;AoC56KnB;;AAAA;EfVE,uBAAA;EACA,8BAAA;ErB27KF,0BAA0B;EoCx6K1B,0BAAA;EAAA,oCAAA;EAAA,sCAAA;EfNE,2BAAA;EACA,2BAAA;ErBm7KF,qCAAqC;EACrC,4DAA4D;EoC55K9D,gCAAA;EACE,iCAAA;EACA,uCAAA;EpC85KA,mBAAmB;AoC55KnB;;ApC+5KF;EoCz5KE,uBAAA;EACE,8BAAA;EpC25KF,0BAA0B;EAC1B,0BAA0B;EoCx5K5B,oCAAA;EACE,wCAAA;EACA,2BAAA;EpC05KA,2BAA2B;EAC3B,qCAAqC;EoCx5KvC,4DAAA;EACE,gCAAA;EACA,iCAAA;EpC05KA,uCAAuC;EACvC,mBAAmB;AoCv4KrB;;ApC04KA;EoCv4KE,uBAAA;EpCy4KA,8BAA8B;EoCv4K9B,0BAAA;EAAA,0BAAA;EAEE,oCAAA;EpCy4KF,wCAAwC;EoCt4KxC,2BAAA;EAAA,2BAAA;EAEE,qCAAA;EpCw4KF,4DAA4D;EoCp4K5D,gCAAA;EAAA,iCAAA;Ef1FE,uCAAA;EACA,mBAAA;ArBk+KJ;;AoCh4KE;EAAA,uBAAA;EfjHE,8BAAA;EACA,0BAAA;ErBs/KF,0BAA0B;EAC1B,oCAAoC;EqC/gLtC,wCAAA;EAEE,2BAAA;EACA,2BAAA;EAEA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EAGA,uCAAA;EACA,mBAAA;ArC6gLF;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EqC3gLtC,wBAAA;EACE,kCAAA;EACA,gDAAA;EnCsQI,wCALI;EmC/PR,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EffI,uCegBJ;ErC6gLA,0BAA0B;AsBzhLtB;;AtB4hLN;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AqC7gLhC;;ArCghLF;;EqC1gLE,0BAAA;EAEE,wBAAA;EACA,0BAAA;EACA,kDAAA;ArC4gLJ;;AqCpgLA;;EAGE,2BAAA;EACA,0BAAA;EACA,2BAAA;EACA,kDAAA;ArCsgLF;;AAEA;EACE,gCAAgC;AqClgLhC;;ArCqgLF;EqBhjLI;IACA,gBAAA;ErBkjLF;AqCngLE;;ArCsgLJ;EACE,UAAU;AqC//KV;;ArCkgLF;EqC//KI,aAAA;ArCigLJ;;AqC7/KE;EAEE,SAAA;EhBjEA,gBAAA;EACA,6BAAA;ArBikLJ;;AqCt/KA;EAEE;IACA,gBAAA;EACA;ArCw/KF;;AAEA;EACE,QAAQ;EqCp/KR,YAAA;EAAA,4BAAA;ArCu/KF;;AAEA;EACE;IqC9+KF,gBAAA;EAEE;ArC++KF;;AAEA;;;;;;EAME,kBAAkB;AqC3+KhB;;ArC8+KJ;EqCx+KE,mBAAA;AAAA;;ArC4+KF;EqCx+KI,qBAAA;ErC0+KF,oBAAoB;EACpB,uBAAuB;EqCj+KvB,WAAA;EAAA,uBAAA;EAEE,qCAAA;EACA,gBAAA;ErCm+KF,oCAAoC;AACtC;;AqC/9KE;EAEE,cAAA;ArCi+KJ;;AAEA;EACE,0BAA0B;EqC59K1B,8BAAA;EAAA,0BAAA;EACE,+BAAA;ErC+9KF,8BAA8B;EAC9B,gCAAgC;EqCt9KhC,yCAAA;EACE,mCAAA;ErCw9KF,8DAA8D;EqCt9K9D,oDAAA;EACE,kDAAA;ErCw9KF,yFAAyF;EACzF,4DAA4D;EsCtpL9D,sCAAA;EAEE,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EACA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;EACA,uCAAA;EACA,+BAAA;EAGA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;EACA,+CAAA;AtCqpLF;;AsC/oLE;EAAA,SAAA;EAAA,OAAA;EAAA,qCAAA;AAAA;;AtCupLF;EsCrpLI,oBAAA;AtCupLJ;;AAEA;EsCnoLA,WAAA;EACE,OAAA;AtCqoLF;;AAEA;EsCnoLE,kBAAA;AtCqoLF;;AAEA;EsCnoLE,QAAA;EAEE,UAAA;AtCooLJ;;AsC1nLA;EAEE;IACA,oBAAA;EAEA;;EAEA;IACA,WAAA;IAGA,OAAA;EACA;;EAEA;IACA,kBAAA;EtCynLA;;EsCpnLI;ItCunLF,QAAQ;IsCnnLV,UAAA;EACE;AtCqnLJ;;AsC5mLA;EACE;IACA,oBjC6gCkC;EiC5gClC;;EAEA;IAAA,WAAA;IAAA,OAAA;EAGE;;EtCgnLF;IsCnmLF,kBAAA;EACE;;EAIA;ItCmmLE,QAAQ;IACR,UAAU;EsChmLd;AtCkmLA;;AAEA;EsChmLE;IACA,oBAAA;EACA;;EhB3II;ItB+uLF,WAAW;IsB3uLT,OAAA;EgBiIN;;EtC8mLE;IACE,kBAAkB;EsCrmLpB;;EtCwmLA;IsCpmLA,QAAA;IACE,UAAA;EACA;AtCsmLJ;;AAEA;EsCjmLA;IACE,oBAAA;EACA;;EAEA;IACA,WAAA;IACA,OAAA;EACA;;EtComLA;IACE,kBAAkB;EsCjmLtB;;EAEE;ItCmmLE,QAAQ;IACR,UAAU;Ea9tLV;AbguLJ;;AAEA;EACE;IsCxlLM,oBAAA;EtC0lLN;;EsCvlLQ;IACE,WAAA;ItC0lLR,OAAO;EsCvlLD;;EtC0lLR;IACE,kBAAkB;EsCrlLd;;EtCwlLN;IsCplLM,QAAA;IACE,UAAA;EtCslLR;AACF;;AAEA;EACE,SAAS;EsCllLH,YAAA;EtColLN,asCllLQ;EtCmlLR,wCsCllLQ;AtCmlLV;;AAEA;EACE,qBsCllLQ;EtCmlLR,oBsCllLQ;EtCmlLR,uBsCllLQ;EtCmlLR,WsCllLQ;EtCmlLR,asBjzLI;EtBkzLJ,qCAAqC;EsC/kL7B,0BAAA;EtCilLR,oCsChlLU;AtCilLZ;;AAEA;EACE,csC/kLU;AtCglLZ;;AAEA;EACE,MAAM;Ea7wLJ,WAAA;EyBsIA,UAAA;EtC0oLF,asCxoLM;EtCyoLN,sCsCxoLM;AtCyoLR;;AAEA;EACE,qBAAqB;EsCvoLb,oBAAA;EtCyoLR,uBsCxoLU;EtCyoLV,WAAW;EsCtoLH,mCAAA;EtCwoLR,esCvoLU;EtCwoLV,sCsCvoLU;EtCwoLV,wBAAwB;AAC1B;;AAEA;EsCnoLQ,cAAA;AtCqoLR;;AAEA;EsCloLQ,iBAAA;AtCooLR;;AAEA;EACE,MsCjoLQ;EtCkoLR,WsCjoLQ;EtCkoLR,UsCjoLQ;EtCkoLR,asCjoLQ;EtCkoLR,uCsCjoLQ;AtCkoLV;;AAEA;EACE,qBsCjoLQ;EtCkoLR,oBsChoLQ;EtCioLR,uBAAuB;EsC9nLf,WAAA;AtCgoLV;;AAEA;EACE,asC9nLU;AtC+nLZ;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;Ea5zLnB,uBAAA;EyBsIA,WAAA;EtCyrLF,mCsCvrLM;EtCwrLN,yBsCvrLM;EtCwrLN,sCAAsC;AACxC;;AAEA;EsCtrLU,cAAA;AtCwrLV;;AAEA;EACE,iBsCtrLU;AtCurLZ;;AAEA;EACE,SsCprLQ;EtCqrLR,6CAA6C;EsClrLvC,gBAAA;EtCorLN,mDsCnrLQ;EtCorLR,UsCnrLQ;AtCorLV;;AAEA;EACE,cAAc;EsChrLR,WAAA;EtCkrLN,4EsChrLQ;EtCirLR,WsChrLQ;EtCirLR,gBsChrLQ;EtCirLR,oCsChrLQ;EtCirLR,mBsChrLQ;EtCirLR,qBsChrLQ;EtCirLR,mBsChrLQ;EtCirLR,6BsChrLQ;EtCirLR,SsChrLQ;EtCirLR,uDsC/qLQ;AtCgrLV;;AAEA;;EsC3qLU,0CAAA;EtC8qLR,kDsC7qLU;AtC8qLZ;;AAEA;;EAEE,2CAA2C;Ea32LzC,qBAAA;EyBsIA,mDAAA;AtCwuLJ;;AAEA;;EAEE,6CsCtuLQ;EtCuuLR,oBAAoB;EsCruLZ,6BAAA;AtCuuLV;;AAEA;EACE,csCruLU;AtCsuLZ;;AAEA;EACE,csCnuLQ;EtCouLR,gFAAgF;EsCjuL1E,gBAAA;EtCmuLN,kBsCluLQ;EtCmuLR,sCsCluLQ;EtCmuLR,mBAAmB;AACrB;;AAEA;EsC/tLQ,cAAA;EtCiuLN,4EsC/tLQ;EtCguLR,oCsC/tLQ;AtCguLV;;AAEA;EACE,4BsC/tLQ;EtCguLR,yBsC/tLQ;EtCguLR,8DsC/tLQ;EtCguLR,0BsC/tLQ;EtCguLR,iCsC9tLQ;EtC+tLR,oCAAoC;EsC5tL5B,4DAAA;EtC8tLR,sDsC7tLU;EtC8tLV,qCAAqC;EsC3tL7B,qCAAA;EtC6tLR,0CsC5tLU;EtC6tLV,mCsC5tLU;AtC6tLZ;;AAEA;;Eaz5LI,kBAAA;EyBsIA,oBAAA;EtCuxLF,sBsCrxLM;AtCsxLR;;AAEA;;EAEE,kBAAkB;EsCpxLV,cAAA;AtCsxLV;;AAEA;;;;;;;;;;;;EAYE,UsChxLQ;AtCixLV;;AAEA;EACE,asC9wLQ;EtC+wLR,esC9wLQ;EtC+wLR,2BsC9wLQ;AtC+wLV;;AAEA;EACE,WsC9wLQ;AtC+wLV;;AAEA;EsC3wLU,sCAAA;AtC6wLV;;AAEA;;EAEE,8CsC3wLU;AtC4wLZ;;AAEA;;;EsCh0LQ,0BAAA;EACA,6BAAA;AtCo0LR;;AAEA;;;EsCh0LY,yBAAA;EtCo0LV,4BAA4B;AsCj0LpB;;AtCo0LV;EACE,wBAAwB;EsC/zLlB,uBAAA;AtCi0LR;;AsC7zLQ;;;EtCk0LN,cAAc;AsC7zLR;;AtCg0LR;EsC5zLQ,eAAA;AtC8zLR;;AAEA;;EsC1zLU,uBAAA;EACA,sBAAA;AtC6zLV;;AAEA;;EAEE,sBAAsB;EsCzzLd,qBAAA;AtC2zLV;;AsCvzLU;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AtC0zLZ;;AAEA;;EsC1yLA,WAAA;AtC6yLA;;AAEA;;EsCxyLE,6CAAA;AtC2yLF;;AAEA;;EAEE,6BAA6B;EsCtyL3B,4BAAA;AtCwyLJ;;AAEA;;;EuC/jME,yBAAA;EACA,0BAAA;AvCmkMF;;AAEA;EuCjkME,6BAAA;EACA,+BAAA;EACA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AvCmkMF;;AAEA;EuC/jME,cAAA;EACA,kEAAA;EACA,uCAAA;EACA,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EACA,uGAAA;AvCikMF;;AuC7jME;EACE;IACA,gBAAA;EvCgkMF;AuC7jMA;;AvCgkMF;;EuC5jMI,qCAAA;AvC+jMJ;;AAEA;EACE,UAAU;EuC7jMR,kDAAA;AvC+jMJ;;AAEA;;EuCzjME,wCAAA;EAAA,oBAAA;EAEE,eAAA;AvC4jMJ;;AuCxjMA;EAGE,kDAAA;EACA,kDAAA;EACA,oDAAA;EvCyjMA,2GAA2G;EAC3G,yDAAyD;EuCvjM3D,+CAAA;EACE,uGAAA;EACA,oFAAA;AvCyjMF;;AuCtjMA;EACE,yDAAA;EACA,yDAAA;EACA,wDAAA;EvCyjMA,yDAAyD;AAC3D;;AAEA;;EAEE,kBAAkB;EuCljMlB,wDAAA;AvCojMF;;AAEA;;EuC5iME,2CAAA;EACA,mDAAA;EACA,yDAAA;AvC+iMF;;AAEA;EuC7iME,sDAAA;ElB7FE,yBAAA;ErB6oMF,0BAA0B;AAC5B;;AAEA;EuC5iME,qDAAA;EACA,sCAAA;EACA,sCAAA;AvC8iMF;;AAEA;EACE,gDAAgD;AAClD;;AAEA;;EuCriME,4CAAA;EACA,oDAAA;AvCwiMF;;AAEA;EuCtiMI,4BAAA;EvCwiMF,yCAAyC;EACzC,8DAA8D;EuCriMhE,gCAAA;AvCuiMA;;AAEA;EACE,gBAAgB;EuCpiMlB,eAAA;EACE,qEAAA;AvCsiMF;;AAEA;;EuCniME,iCAAA;AvCsiMF;;AAEA;;EuCpiMA,gBAAA;EAAA,gDAAA;EAGE,iCAAA;AvCsiMF;;AuCniMA;;ElB3II,cAAA;EACA,kBAAA;ArBmrMJ;;AuCpiMA;;ElBlII,YAAA;EACA,aAAA;ErB2qMF,kBAAkB;AACpB;;AAEA;;Ea1pMI,WAAA;Ab6pMJ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EuC1hMlB,6BAAA;EvC4hMN,2DqBtsME;ErBusMF,gEqBtsME;ErBusMF,mEAAmE;EuC3hM3D,+DAAA;EAAA,qCAAA;EvC8hMR,kCuC3hMU;EvC4hMV,mCAAmC;EuC1hM3B,8DAAA;EAAA,oEAAA;EvC6hMR,sCuC1hMU;EvC2hMV,sCAAsC;EuCvhMhC,sCAAA;EvCyhMN,qCqBpsME;ErBqsMF,qEqBpsME;ErBqsMF,0EAA0E;EuCxhMlE,0DAAA;EAAA,wCAAA;EvC2hMR,4DuCxhMU;EvCyhMV,kBAAkB;EuCvhMV,aAAA;EAAA,eAAA;EvC0hMR,mBuCvhMU;EvCwhMV,8BAA8B;EAC9B,8DAA8D;AAChE;;AAEA;;;;;;;EwCtvME,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AxC8vMF;;AAEA;EwC5vME,6CAAA;EACA,gDAAA;EACA,+CAAA;EACA,2CAAA;EACA,mCAAA;EACA,qBAAA;EACA,mBAAA;AxC8vMF;;AwC1vMA;;EAEE,yCAAA;AxC6vMF;;AAEA;EEhgMM,0BALI;EsCrPR,+BAAA;EACA,2BAAA;EACA,2CAAA;EACA,uDAAA;EnBrBE,6DAAA;EmBuBF,aAAA;ElB1BI,sBkB2BJ;ExC6vMA,eAAe;EsBpxMX,gBAAA;EkBUN,gBAAA;AxC6wMA;;AAEA;;EwC/vMI,oCAAA;AxCkwMJ;;AAEA;EwChwMI,gBAAA;AxCkwMJ;;AAEA;EwC7vME,mBAAA;EACE,sBAAA;EACA,6BAAA;AxC+vMJ;;AAEA;;;EwC3vMI,oCAAA;AxC+vMJ;;AsB5yMM;EkBqCJ,YAAA;ExC2wMA,gBsB/yMM;EtBgzMN,mBAAmB;AACrB;;AAEA;EACE,8EAA8E;EwChwM9E,6CAAA;EACE,cAAA;EACA,6BAAA;EACA,6BAAA;ExCkwMF,0EAA0E;EAC1E,qDAAqD;EwC/vMvD,+CAAA;AxCiwMA;;AAEA;EwC/vMA;IACE,gBAAA;EACA;AxCiwMF;;AwC9vME;EnB7DE,qBAAA;ArB+zMJ;;AwC/vMI;EnBhEA,qBAAA;EACA,UAAA;ErBm0MF,sDAAsD;AwC/vMtD;;AxCkwMF;EwC7vME,qBAAA;EnB5DE,YAAA;EACA,aAAA;ErB4zMF,sBAAsB;EwC7vMlB,kDAAA;EnBhEF,4BAAA;EACA,2BAAA;ErBg0MF,qBAAqB;AwC5vMnB;;AxC+vMJ;EACE,yCAAyC;EACzC,gBAAgB;AwC3vMlB;;AxC8vMA;EACE;IwCrvMA,iBAAA;IACE,2BAAA;EACA;;ExCwvMF;IwCrvME,mBAAA;EAAgB;;EAChB;IAAe,kBAAA;ExC0vMjB;;EwCvvME;IAAA,kDAAA;InBrHA,iDAAA;ErBi3MF;;EwCjvME;IACE,iBAAA;EACA;;ExCqvMJ;IyC14MF,wBAAA;IAEE,gBAAA;EACA;;EAGA;IACA,aAAA;EACA;;EAEA;IAGA,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IvC+QI,uBALI;IuCxQR,8BAAA;IACA,wCAAA;IpBAE,oBAAA;IrBy4MA,0BAA0B;IAC1B,gBAAgB;EyCp4MlB;;EzCu4MA;IyCp4ME,aAAA;EACE;;EAEA;IACA,aAAA;IzCs4MF,YAAY;IyCl4Md,UAAA;IACE,mBAAA;EzCo4MF;AACF;;AAEA;E0Cz6ME;IxC4RI,iBAAA;IwC1RJ,2BAAA;EACA;;EAEA;IACA,mBAAA;EACA;;EAEA;IACA,kBAAA;EACA;;EAEA;IACA,kDAAA;IACA,iDAAA;EACA;;EAEA;IAGA,iBAAA;EnCpBA;;EP+7MA;IACE,wBAAwB;I0Cx6M5B,gBAAA;EACE;;EAEA;IxCgQI,aALI;EwCzPR;;EAEA;IACA,gBAAA;IpBpBI,aoBqBJ;I1C06ME,YAAY;IsB37MV,sBAAA;IoBQN,uBAAA;IpBPQ,8BAAA;ItB87MJ,wCAAwC;IACxC,oBAAoB;I0C76MtB,0BAAA;IACE,gBAAA;EACA;;EAGA;I1C86MA,aAAa;E0C36Mf;;EAEE;IACA,aAAA;IACA,YrC2uCgC;IqC1uChC,UAAA;I1C66MA,mBAAmB;E0C16MrB;A1C46MF;;AAEA;E0Cz6MI;I1C26MA,iBAAiB;I0Cx6MnB,2BAAA;EAEE;;EAEA;IACA,mBAAA;E1Cy6MF;;E0Cp6MA;IACE,kBrC8sCgC;ELytKlC;;EqBh8ME;IACA,kDAAA;IrBm8MA,iDAAiD;E0Ch6M/C;;ErBjDF;IrBq9MA,iBAAiB;EACnB;;E2Ct/MA;IACA,wBAAA;IzC0RI,gBAAA;EyCxRJ;;E3C0/MA;I0Cv5MF,aAAA;ECtGE;;EzC2RI;IyCxRJ,gBAAA;I3CggNE,aAAa;IACb,YAAY;I4CngNhB,sBAAA;IAEE,uBAAA;IACA,8BAAA;I1CuRI,wCALI;I0ChRR,oBAAA;IACA,0BAAA;IACA,gBAAA;EAGA;;E1CgRI;I0C7QJ,aAAA;EACA;;EAEA;IACA,aAAA;IACA,YAAA;IvBJE,UAAA;IrBugNA,mBAAmB;E4C9/MrB;A5CggNF;;AAEA;E4C5/MA;IACE,iBAAA;IACA,2BAAA;E5C8/MA;;E6C9hNF;IAEE,mBAAA;EACA;;EAEA;IACA,kBAAA;EACA;;EAEA;IACA,kDAAA;IAGA,iDAAA;EACA;;EAEA;IACA,iBAAA;EACA;;E7C+hNA;IACE,wBAAwB;I6C3hN5B,gBAAA;EAEE;;E7C6hNA;I6CzhNF,aAAA;EACE;;E7C4hNA;IACE,gBAAgB;I6CphNpB,aAAA;IACE,YAAA;I7CshNE,sBAAsB;I6CnhNxB,uBAAA;IACE,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IACA,gBAAA;E7CqhNF;;E6C7gNA;IACE,aAAA;EACA;;EAEA;I7CghNA,aAAa;IACb,YAAY;I6CrhNd,UAAA;IACE,mBAAA;EACA;A7CuhNJ;;AAEA;EACE;I6C5hNA,iBAAA;IACE,2BAAA;EACA;;EAEA;I7C8hNA,mBAAmB;EACrB;;E6CliNE;IACA,kBAAA;EACA;;E7CsiNF;IACE,kDAAkD;I6C1iNpD,iDAAA;EACE;;EAEA;IACA,iBAAA;E7C4iNF;;E6ChjNA;IACE,wBAAA;IACA,gBAAA;EACA;;E7CojNF;IACE,aAAa;E6CxjNf;;EAEE;IACA,gBAAA;IACA,aAAA;I7C0jNA,YAAY;IACZ,sBAAsB;I6C/jNxB,uBAAA;IACE,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I7CikNA,gBAAgB;EAClB;;E6CrkNE;IACA,aAAA;EACA;;E7CykNF;IACE,aAAa;I6C7kNf,YAAA;IACE,UAAA;IACA,mBAAA;EACA;A7C+kNJ;;AAEA;E6CplNE,iBAAA;EACE,2BAAA;A7CslNJ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;E6C3lNI,kBAAA;A7C6lNJ;;AAEA;EACE,kDAAkD;E6ClmNlD,iDAAA;A7ComNF;;AAEA;E6ClmNI,iBAAA;A7ComNJ;;A6CxmNE;EACE,wBAAA;EACA,gBAAA;A7C2mNJ;;AAEA;EACE,aAAa;A6ChnNb;;A7CmnNF;E6ChnNI,gBAAA;EACA,aAAA;E7CknNF,YAAY;EACZ,sBAAsB;E6CvnNtB,uBAAA;EACE,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;E7CynNF,gBAAgB;AAClB;;AAEA;E6C9nNI,aAAA;A7CgoNJ;;AAEA;EACE,aAAa;E6CroNb,YAAA;EACE,UAAA;EACA,mBAAA;A7CuoNJ;;AAEA;;E6C3oNE,4CAAA;EACE,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;E7C8oNF,mCAAmC;EACnC,0DAA0D;E6CnpN1D,qEAAA;A7CqpNF;;AAEA;E6CnpNI,qEAAA;A7CqpNJ;;A6CzpNE;EACE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;E7C4pNF,0BAA0B;EAC1B,8CAA8C;E6CjqN9C,0DAAA;EACE,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;E7CmqNF,6BAA6B;EAC7B,sDAAsD;E6CxqNtD,qBAAA;EACE,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;E7C0qNF,+BAA+B;EAC/B,kBAAkB;E6C/qNlB,aAAA;EACE,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;E7CirNF,qBAAqB;EACrB,mCAAmC;E6CtrNnC,2BAAA;EACE,qEAAA;EACA,2CAAA;A7CwrNJ;;AAEA;EACE,eAAe;E6C7rNf,cAAA;A7C+rNF;;AAEA;E6C7rNI,mBAAA;E7C+rNF,sBAAsB;AACxB;;AAEA;E6CpsNI,mBAAA;EACA,0DAAA;EACA,2DAAA;A7CssNJ;;A6C1sNE;EACE,sBAAA;EACA,8DAAA;EACA,6DAAA;A7C6sNJ;;AAEA;;E6CjtNI,aAAA;A7CotNJ;;AAEA;EACE,cAAc;EACd,wDAAwD;E6CztNxD,2BAAA;A7C2tNF;;AAEA;E6CztNI,4CAAA;E7C2tNF,iCAAiC;AACnC;;AAEA;E6ChuNI,sDAAA;EACA,gBAAA;EACA,oCAAA;A7CkuNJ;;A6CtuNE;EACE,gBAAA;A7CyuNJ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;E6C9uNI,kEAAA;EACA,gBAAA;EACA,+BAAA;E7CgvNF,uCAAuC;EACvC,4EAA4E;A6CrvN5E;;A7CwvNF;E6CrvNI,wFAAA;A7CuvNJ;;AAEA;E6C5vNE,kEAAA;EACE,+BAAA;EACA,uCAAA;EACA,yEAAA;A7C8vNJ;;AAEA;E6CnwNE,wFAAA;A7CqwNF;;AAEA;E6CnwNI,uDAAA;E7CqwNF,sDAAsD;EACtD,sDAAsD;E6C1wNtD,gBAAA;A7C4wNF;;AAEA;E6C1wNI,mCAAA;E7C4wNF,sCAAsC;AACxC;;AAEA;E6CjxNI,uDAAA;EACA,sDAAA;A7CmxNJ;;AAEA;E6CxxNE,kBAAA;EACE,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;E7C0xNF,2CAA2C;EAC3C,iDAAiD;A6C/xNjD;;A7CkyNF;;;EAGE,WAAW;AACb;;AAEA;;EAEE,0DAA0D;EAC1D,2DAA2D;A8C71N7D;;A9Cg2NA;;E8C31NE,8DAAA;EACA,6DAAA;A9C81NF;;AAEA;E8C51NE,0CAAA;A9C81NF;;AAEA;EErlNM;I4CpQJ,aAAA;IzBRE,mBAAA;ErBq2NF;;E8Cx1NF;IACE,SAAA;IACA,gBAAA;EACA;;EAEA;IACA,cAAA;IACA,cAAA;EACA;;E9C41NA;IsBh3NI,0BAAA;IwBYN,6BAAA;E9Cu2NE;;EAEA;;I8C71NF,0BAAA;EvBAE;;EvBk2NA;;I8C71NF,6BAAA;EACE;;E9Ci2NA;I8C91NF,yBAAA;IACE,4BAAA;E9Cg2NA;;E8C51NA;;I9Cg2NE,yBAAyB;E8C51NvB;;E9C+1NJ;;IAEE,4BAA4B;EAC9B;A+C55NF;;A/C+5NA;E+C35NE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EAGA,wEAAA;EACA,2EAAA;EAGA,sCAAA;EACA,mCAAA;E1BXE,4DAAA;ErBq6NF,qDAAqD;AACvD;;AAEA;E+Cv5NE,kBAAA;E/Cy5NA,aAAa;E+Cv5Nb,mBAAA;EAEE,WAAA;EACA,4EAAA;E/Cw5NF,kBAAkB;EAClB,oCAAoC;E+Cj5NtC,gBAAA;EACE,4CAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;EACA,0CAAA;A/Cm5NF;;AAEA;E+Cj5NE;I1B9BE,gBAAA;EACA;ArBk7NJ;;AAEA;EqBt6NI,uCAAA;ErBw6NF,+CAA+C;E+Cj5N/C,kGAAA;A/Cm5NF;;AAEA;EACE,qDAAqD;E+C94NrD,iDAAA;A/Cg5NF;;AAEA;E+C94NI,cAAA;E/Cg5NF,yCAAyC;E+C54NzC,0CAAA;EACE,iBAAA;E/C84NF,WAAW;E+C54NT,8CAAA;EACE,4BAAA;EACA,mDAAA;E/C84NJ,mDAAmD;AACrD;;AAEA;E+Cr4NE;IACA,gBAAA;E/Cu4NA;A+Cn4NE;;A/Cs4NJ;E+Cl4NM,UAAA;A/Co4NN;;A+Ch4NI;EACE,UAAA;EACA,UAAA;E/Cm4NJ,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;A+Ct3NV;;A/Cy3NR;EACE,gCAAgC;E+Cr3N1B,wCAAA;E1B1EJ,+EAAA;ArBk8NJ;;A+Cn3NQ;EACE,yDAAA;E/Cs3NR,0DAA0D;A+Cn3NpD;;A/Cs3NR;EACE,+DAA+D;E+Cn3NvD,gEAAA;A/Cq3NV;;AAEA;EACE,aAAa;Aa98NX;;Abi9NJ;EACE,6DAA6D;E+C94NvD,4DAAA;A/Cg5NR;;AAEA;E+C74NQ,mEAAA;E/C+4NN,kEqBz9NE;ArB09NJ;;AAEA;EACE,6D+C74NQ;E/C84NR,4DAA4D;AAC9D;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,eAAe;EACf,cAAc;Eat+NZ,gBAAA;Abw+NJ;;AAEA;E+Ct6NQ,aAAA;A/Cw6NR;;AAEA;E+Cr6NQ,gBAAA;A/Cu6NR;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,iEAA0T;E+Cn6NlT,wEAAA;A/Cq6NV;;AAEA;EACE,4BAA4B;Ea9/N1B,4BAAA;EkCgEA,mCAAA;E/Ci8NF,oB+Ch8NI;E/Ci8NJ,+BAA+B;E+C97NzB,wDAAA;E/Cg8NN,sCqBz/NE;ErB0/NF,4DqBtgOE;ErBugOF,aAAa;E+C77NP,eAAA;E/C+7NN,sEqBzgOE;ErB0gOF,iDqB9/NE;ErB+/NF,yCAAyC;E+C57NnC,gBAAA;E/C87NN,yC+C77NQ;E/C87NR,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,kDAAkD;EathOhD,yCAAA;EkCgEA;;E/C09NF;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;E+Cp9N5B,mCAAA;E/Cs9NN,kC+Cr9NQ;E/Cs9NR,2CAA2C;E+Cn9NrC,qCAAA;E/Cq9NN,oD+Cp9NQ;E/Cq9NR,oD+Cp9NQ;E/Cq9NR,sDAAsD;E+Cn9N9C,uDAAA;E/Cq9NR,+C+Cp9NU;E/Cq9NV,0D+Cp9NU;E/Cq9NV,uDAAuD;EACvD,gDAAgD;Ea9iO9C,wEAAA;EkCgEA,kCAAA;E/Ci/NF,kC+Ch/NI;E/Ci/NJ,4CAA4C;E+C9+NtC,yDAAA;E/Cg/NN,mDqBziOE;ErB0iOF,6DqBtjOE;ErBujOF,aAAa;E+C7+NP,eAAA;E/C++NN,gBqBzjOE;ArB0jOJ;;AAEA;EACE,kB+C7+NQ;E/C8+NR,cAAc;E+C3+NR,sEAAA;E/C6+NN,yC+C5+NQ;E/C6+NR,iC+C5+NQ;E/C6+NR,qBAAqB;E+C3+Nb,yCAAA;E/C6+NR,iF+C5+NU;E/C6+NV,qI+C5+NU;A/C6+NZ;;A+C/9NA;E1BlJI;IrBqnOA,gBAAgB;E+Ch+NlB;A/Ck+NF;;A+C/9NI;EACE,UAAA;E/Ck+NJ,uCAAuC;EACvC,+CAA+C;E+Ct9N/C,qDAAA;A/Cw9NF;;AAEA;E+Ct9NI,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UAAA;EACA,iDAAA;A/Cw9NJ;;AAEA;;E+Cl+NE,UAAA;EACE,wCAAA;EACA,gDAAA;EACA,sDAAA;A/Cq+NJ;;AAEA;;E+Cl+NI,0CAAA;EACA,oBAAA;EACA,kDAAA;E/Cq+NF,wDAAwD;AAC1D;;AAEA;E+Ch/NI,8CAAA;A/Ck/NJ;;AAEA;E+Ch/NI,0DAAA;EACA,6DAAA;A/Ck/NJ;;AAEA;EACE,2DAA2D;EAC3D,8DAA8D;A+C7/N9D;;A/CggOF;E+C7/NI,iCAAA;EACA,kCAAA;EACA,iCAAA;EACA,yDAAA;A/C+/NJ;;AAEA;E+C7/NI,iCAAA;E/C+/NF,kCAAkC;EAClC,kCAAkC;E+C1gOlC,yDAAA;A/C4gOF;;AAEA;E+C1gOI,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;EACA,iDAAA;EACA,qBAAA;E/C4gOF,4DAA4D;EAC5D,oCAAoC;E+CvhOpC,wCAAA;EACE,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,4CAAA;A/CyhOJ;;AAEA;E+CvhOI,aAAA;A/CyhOJ;;A+CniOE;EACE,kBAAA;EACA,SAAA;A/CsiOJ;;AAEA;E+CpiOI,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;E/CsiOF,oCAAoC;EACpC,4EAA4E;E+CjjO5E,iDAAA;EACE,8BAAA;EACA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;EACA,4CAAA;A/CmjOJ;;AAEA;EACE,cAAc;A+C9jOd;;A/CikOF;E+C9jOI,gBAAA;EACA,iCAAA;A/CgkOJ;;AAEA;E+C9jOI,mBAAA;A/CgkOJ;;AAEA;EACE,kBAAkB;E+C3kOlB,MAAA;EACE,QAAA;EACA,UAAA;EACA,qBAAA;A/C6kOJ;;AAEA;E+C3kOI,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A/C6kOJ;;A+CvlOE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A/C0lOJ;;AAEA;E+CxlOI,iDAAA;EACA,0CAAA;EACA,wDAAA;E/C0lOF,sDAAsD;AACxD;;AAEA;E+CrmOI,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A/CumOJ;;AAEA;E+CrmOI,iDAAA;EACA,0CAAA;E/CumOF,wDAAwD;EACxD,sDAAsD;A+ClnOtD;;A/CqnOF;E+ClnOI,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A/ConOJ;;AAEA;E+ClnOI,+CAAA;E/ConOF,wCAAwC;EACxC,sDAAsD;E+C/nOtD,oDAAA;A/CioOF;;AAEA;E+C/nOI,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A/CioOJ;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;E+C5oO9C,4DAAA;EACE,0DAAA;A/C8oOJ;;AAEA;E+C5oOI,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,6DAAA;A/C8oOJ;;AAEA;EACE,wDAAwD;E+CzpOxD,iDAAA;EACE,+DAAA;EACA,6DAAA;A/C2pOJ;;AAEA;E+CzpOI,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,yDAAA;A/C2pOJ;;AAEA;E+CtqOE,oDAAA;EACE,6CAAA;EACA,2DAAA;EACA,yDAAA;A/CwqOJ;;AAEA;E+CtqOI,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,yDAAA;A/CwqOJ;;A+ClrOE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,yDAAA;A/CqrOJ;;AAEA;E+CnrOI,oDAAA;EACA,6CAAA;EACA,2DAAA;E/CqrOF,yDAAyD;AAC3D;;AAEA;E+ChsOI,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,yDAAA;A/CksOJ;;AAEA;E+ChsOI,oDAAA;EACA,6CAAA;E/CksOF,2DAA2D;EAC3D,yDAAyD;A+C7sOzD;;A/CgtOF;E+C7sOI,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,yDAAA;A/C+sOJ;;AAEA;E+C7sOI,qDAAA;E/C+sOF,8CAA8C;EAC9C,4DAA4D;E+C1tO5D,0DAAA;A/C4tOF;;AAEA;E+C1tOI,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A/C4tOJ;;AAEA;EACE,oDAAoD;EACpD,6CAA6C;E+CvuO7C,2DAAA;EACE,yDAAA;A/CyuOJ;;AAEA;E+CvuOI,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A/CyuOJ;;AAEA;EACE,mDAAmD;E+CpvOnD,4CAAA;EACE,0DAAA;EACA,wDAAA;A/CsvOJ;;AAEA;E+CpvOI,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A/CsvOJ;;AAEA;E+CjwOE,mDAAA;EACE,4CAAA;EACA,0DAAA;EACA,wDAAA;A/CmwOJ;;AAEA;E+CjwOI,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A/CmwOJ;;A+C7wOE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A/CgxOJ;;AAEA;E+C9wOI,oDAAA;EACA,6CAAA;EACA,2DAAA;E/CgxOF,yDAAyD;AAC3D;;AAEA;E+C3xOI,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,2DAAA;A/C6xOJ;;AAEA;E+C3xOI,mDAAA;EACA,4CAAA;E/C6xOF,0DAA0D;EAC1D,wDAAwD;A+CxyOxD;;A/C2yOF;E+CxyOI,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,0DAAA;A/C0yOJ;;AAEA;E+CxyOI,oDAAA;E/C0yOF,6CAA6C;EAC7C,2DAA2D;E+CrzO3D,yDAAA;A/CuzOF;;AAEA;E+CrzOI,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,2DAAA;A/CuzOJ;;AAEA;EACE,yDAAyD;EACzD,kDAAkD;E+Cl0OlD,gEAAA;EACE,8DAAA;A/Co0OJ;;AAEA;E+Cl0OI,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A/Co0OJ;;AAEA;EACE,uDAAuD;E+C/0OvD,gDAAA;EACE,8DAAA;EACA,4DAAA;A/Ci1OJ;;AAEA;E+C/0OI,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;A/Ci1OJ;;AAEA;E+C51OE,oDAAA;EACE,6CAAA;EACA,2DAAA;EACA,yDAAA;A/C81OJ;;AAEA;E+C51OI,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A/C81OJ;;A+Cx2OE;EACE;IACA,gDAAA;EACA;A/C22OJ;;AAEA;;E+Cx2OI,0BAAA;EACA,gCAAA;EACA,wCAAA;E/C22OF,oDAAoD;EACpD,oDAAoD;E+Ct3OpD,6BAAA;EACE,6BAAA;EACA,6CAAA;EACA,aAAA;EACA,iCAAA;EACA,gBAAA;EACA,uCAAA;EACA,uCAAA;EACA,+CAAA;A/Cw3OJ;;AAEA;EACE,aAAa;E+Cn4Ob,sBAAA;EACE,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EACA,6CAAA;A/Cq4OJ;;AAEA;EACE;IACE,gBAAgB;E+Ch5OlB;A/Ck5OF;;AAEA;E+Ch5OI,qMAAA;EACA,oEAAA;A/Ck5OJ;;AAEA;E+Ch5OI,iBAAA;A/Ck5OJ;;AAEA;E+C75OE,WAAA;A/C+5OF;;AAEA;E+C75OI,kDAAA;A/C+5OJ;;AAEA;E+C75OI;IACA,eAAA;EACA;A/C+5OJ;;A+Cz6OE;EACE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;E/C46OF,yDAAyD;EACzD,wDAAwD;E+Cv7OxD,yDAAA;EACE,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iDAAA;A/Cy7OJ;;AAEA;E+Cp8OE,qBAAA;EACE,sBAAA;A/Cs8OJ;;AAEA;E+Cp8OI,oCAAA;EACA,0BAAA;A/Cs8OJ;;AAEA;E+Cp8OI,kBAAA;E/Cs8OF,cAAc;EACd,gFAAgF;E+Cj9OhF,iCAAA;EACE,qBAAA;EACA,yCAAA;EACA,iFAAA;A/Cm9OJ;;AAEA;E+Cj9OI,+BAAA;EACA,gCAAA;A/Cm9OJ;;AAEA;EACE,mCAAmC;EgDlpPrC,kCAAA;AhDopPA;;AAEA;;EgDhpPE,0CAAA;EACA,oBAAA;EACA,kDAAA;AhDmpPF;;AAEA;EgD/oPE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AhDipPF;;AAEA;EACE,mBAAmB;AgD9oPnB;;AhDipPF;EgD9oPI,wDAAA;EhDgpPF,mDAAmD;AgD7oPnD;;AhDgpPF;EgD7oPI,WAAA;EhD+oPF,wCAAwC;EgD5oPxC,mBAAA;AhD8oPF;;AAEA;;EAEE,UAAU;EgDtoPZ,8CAAA;EAHE,qBAAA;EhD4oPA,sDAAsD;AACxD;;AgDtoPA;EAEE,+CAAA;EhDwoPA,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EiDtsPE,6DAAA;EACA,0BAAA;AjDwsPF;;AAEA;EiDtsPE,2DAAA;EACA,4BAAA;AjDwsPF;;AAEA;EiDtsPE,aAAA;AjDwsPF;;AAEA;EiDpsPE,mDAAA;EACA,oBAAA;AjDssPF;;AAEA;EiDpsPE,yDAAA;EACA,oDAAA;AjDssPF;;AAEA;EACE;IiDpsPA,mBAAA;EACE;;EAGF;IACE,6DAAA;IjDqsPA,0BAA0B;EAC5B;;EiDjsPA;IAEA,2DAAA;IACA,4BAAA;EACA;;EAEA;IjDmsPE,aAAa;EiDjsPf;;EjDosPA;IACE,mDAAmD;IiDhsPvD,oBAAA;EACE;;EAEA;IACA,yDAAA;IACA,oDAAA;EACA;AjDksPF;;AAEA;EACE;IiDjsPA,mBAAA;EACE;;EjDosPF;IACE,6DAA6D;IiDhsPjE,0BAAA;EACE;;EjDmsPA;IACE,2DAA2D;IkDjwP/D,4BAAA;EAEE;;EAEA;IACA,aAAA;EACA;;EAEA;IACA,mDAAA;IACA,oBAAA;EACA;;EAEA;IACA,yDAAA;IACA,oDAAA;EACA;AlDkwPF;;AAEA;EkDhwPE;IACA,mBAAA;EACA;;EAIA;IACA,6DAAA;IACA,0BAAA;EACA;;EAEA;IACA,2DAAA;IACA,4BAAA;EAGA;;ElD+vPA;IkDxvPF,aAAA;EACE;;EAEA;IAEA,mDAAA;IlDyvPE,oBAAoB;EkDtvPtB;;E5B5CI;ItBsyPF,yDAAyD;IsBlyPvD,oDAAA;E4BwCJ;AlD6vPF;;AAEA;EkD3vPE;IACE,mB7Cg8CgC;EL6zMlC;;EkDxvPE;IlD2vPA,6DAA6D;IAC7D,0BAA0B;EkDxvP9B;;ElD2vPE;IkDxvPA,2DAAA;IACE,4BAAA;EACA;;EAGF;IACE,aAAA;ElDyvPF;;EkDrvPF;IACE,mDAAA;IACA,oBAAA;EACA;;ElDyvPA;IkDrvPF,yDAAA;IACE,oDAAA;EACA;AlDuvPF;;AAEA;EkDpvPE;IACA,mBAAA;EACA;;E7BpFE;I6ByFF,6DAAA;IlDovPE,0BAA0B;EAC5B;;EkD/uPA;IACA,2DAAA;IACA,4BAAA;EClHA;;EAEA;IACA,aDkH0B;ECjH1B;;EAEA;InDq2PE,mDAAmD;ImDl2PrD,oBAAA;EAAS;;EACT;IAAS,yDD2GiF;IlD4vPxF,oDAAoD;EACtD;AkDxvPF;;AlD2vPA;EkDxvPE,gBAAA;AlD0vPF;;AAEA;EqB91PI,mDAAA;ArBg2PJ;;AAEA;EkDxvPI,sBAAA;AlD0vPJ;;AAEA;EACE,sDAAsD;EACtD,+CAA+C;EkDtvPjD,6DAAA;EACE,4DAAA;EACA,gEAAA;ElDwvPA,6DAA6D;EAC7D,iEAAiE;EkDpvPnE,yDAAA;EACE,0DAAA;EAGA,oEAAA;AlDovPF;;AAEA;EkDjvPA,wDAAA;EACE,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;E7B7HE,sEAAA;ArBi3PJ;;AkD9uPE;EACE,sDAAA;ElDivPF,+CAA+C;EAC/C,6DAA6D;Eaj2P3D,4DAAA;EqCqHF,gEAAA;ElD+uPA,6DkD9uPE;ElD+uPF,iEkD9uPE;ElD+uPF,yDAAyD;EkD3uPzD,0DAAA;ElD6uPA,oEkD5uPE;AlD6uPJ;;AAEA;EkD1uPE,mDAAA;ElD4uPA,4CkD3uPE;ElD4uPF,0DAA0D;EAC1D,4DAA4D;Ea/2P1D,6DAAA;EqCuIF,6DAAA;EAAA,8DAAA;ElD4uPA,sDkD1uPE;ElD2uPF,uDAAuD;EACvD,iEAAiE;Aar3P/D;;Abw3PJ;EACE,sDAAsD;EACtD,+CAA+C;EkDjuP7C,6DAAA;EACE,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;ElDmuPJ,yDAAyD;EkDjuPrD,0DAAA;EACE,oEAAA;AlDmuPR;;AAEA;EkDhuPM,qDAAA;EAAA,8CAAA;E7BjNF,4DAAA;ErBq7PF,4DAA4D;EkD/tPxD,+DAAA;EACE,6DAAA;ElDiuPN,gEAAgE;EAChE,wDAAwD;Eah4PtD,yDAAA;EqC4IA,mEAAA;AlDuvPJ;;AAEA;EACE,oDkDtvPI;ElDuvPJ,6CAA6C;EkDrvPzC,2DAAA;ElDuvPJ,4DkDtvPM;ElDuvPN,8DkDtvPM;ElDuvPN,6DqBp8PE;ErBq8PF,+DAA+D;EkDpvP3D,uDAAA;EAAA,wDAAA;ElDuvPJ,kEqBx8PE;ArBy8PJ;;AAEA;EACE,mDAAmD;EACnD,4CAA4C;Eap5P1C,0DAAA;EqC4IA,4DAAA;ElD2wPF,6DkD1wPI;ElD2wPJ,6DkD1wPI;ElD2wPJ,8DkD1wPI;ElD2wPJ,sDkD1wPI;ElD2wPJ,uDAAuD;EkDzwPnD,iEAAA;AlD2wPN;;AAEA;EACE,0DAA0D;EkDxwPtD,mDAAA;EAAA,iEAAA;ElD2wPJ,4DqB59PE;ErB69PF,oEAAoE;EkDvwPhE,6DAAA;ElDywPJ,qEkDxwPM;ElDywPN,6DAA6D;EAC7D,8DAA8D;Eax6P5D,wEAAA;Ab06PJ;;AAEA;EACE,6DkD9xPI;ElD+xPJ,sDkD9xPI;ElD+xPJ,oEAAoE;EkD7xPhE,4DAAA;ElD+xPJ,uEkD9xPM;ElD+xPN,6DkD9xPM;ElD+xPN,wEqB5+PE;ErB6+PF,gEAAgE;EkD5xP5D,iEAAA;EAAA,2EAAA;AlD+xPN;;AAEA;EACE,6DkD5xPM;ElD6xPN,sDAAsD;EACtD,oEAAoE;Ea57PlE,4DAAA;EqC4IA,uEAAA;ElDmzPF,6DkDlzPI;ElDmzPJ,wEkDlzPI;ElDmzPJ,gEkDlzPI;ElDmzPJ,iEkDlzPI;ElDmzPJ,2EAA2E;AAC7E;;AAEA;EACE,yDqBhgQE;ErBigQF,kDAAkD;EkDhzP9C,gEAAA;EAAA,4DAAA;ElDmzPJ,mEqBpgQE;ErBqgQF,6DAA6D;EkD/yPzD,oEAAA;ElDizPJ,4DkDhzPM;ElDizPN,6DAA6D;EAC7D,uEAAuE;Aah9PrE;;Abm9PJ;EACE,yDkDt0PI;ElDu0PJ,kDkDt0PI;ElDu0PJ,gEkDt0PI;ElDu0PJ,4DAA4D;EkDr0PxD,mEAAA;ElDu0PJ,6DkDt0PM;ElDu0PN,oEkDt0PM;ElDu0PN,4DqBphQE;ErBqhQF,6DAA6D;EkDp0PzD,uEAAA;AAAA;;AlDw0PN;EkDn0PM,yDAAA;ElDq0PJ,kDkDp0PM;ElDq0PN,gEAAgE;EAChE,4DAA4D;EoD/iQ9D,mEAAA;EAEE,6DAAA;EACA,oEAAA;EACA,4DAAA;EACA,6DAAA;EACA,uEAAA;ApDgjQF;;AAEA;EoD9iQE,yDAAA;EACA,kDAAA;EACA,gEAAA;EACA,4DAAA;EAGA,mEAAA;EACA,6DAAA;EACA,oEAAA;EClBA,4DhD+lB4B;EgD7lB5B,6DAAA;EACA,uEhDwmB4B;ALw9O9B;;AAEA;EqD9jQE,yDAAA;EACA,kDAAA;EACA,gEAAA;EACA,4DAAA;EACA,mEAAA;EACA,6DAAA;EACA,oEAAA;EACA,4DAAA;EnDgRI,6DALI;EkDhQR,uEAAA;ApDujQF;;AoDpjQE;EAAS,yDAAA;EpDwjQT,kDAAkD;EoDtjQlD,gEAAA;EACE,4DAAA;EACA,mEAAA;EACA,6DAAA;EpDwjQF,oEAAoE;EoDtjQlE,4DAAA;EACE,6DAAA;EACA,uEAAA;ApDwjQN;;AAEA;EACE,yDAAyD;EoDpjQ3D,kDAAA;EACE,gEAAA;EpDsjQA,4DAA4D;EoDpjQ5D,mEAAA;EACE,6DAAA;EACA,oEAAA;EACA,4DAAA;EpDsjQF,6DAA6D;EAC7D,uEAAuE;AoDnjQzE;;ApDsjQA;EoDnjQE,yDAAA;EACA,kDAAA;EpDqjQA,gEAAgE;EoDnjQhE,4DAAA;EACE,mEAAA;EACA,6DAAA;EACA,oEAAA;EpDqjQF,4DAA4D;EAC5D,6DAA6D;EoDljQ/D,uEAAA;AAEA;;ApDojQA;EoDjjQE,0DAAA;EACE,mDAAA;EACA,iEAAA;EACA,4DAAA;EpDmjQF,oEAAoE;EACpE,6DAA6D;EoDhjQ/D,qEAAA;EACA,6DAAA;EACE,8DAAA;EACA,wEAAA;ApDkjQF;;AoD/iQE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EpDkjQF,4DAA4D;EAC5D,gEAAgE;EoD/iQlE,6DAAA;EAkBA,iEAAA;EACE,yDAAA;EACA,0DAAA;EACA,oEAAA;ApDgiQF;;AAEA;EACE,yDAAyD;EACzD,kDAAkD;EsDtpQpD,gEAAA;EAEE,4DAAA;EACA,mEAAA;EpD4RI,6DALI;EoDrRR,oEAAA;EACA,4DAAA;EACA,6DAAA;EACA,uEAAA;AtDupQF;;AAEA;EsDrpQE,wDAAA;EpDmRI,iDALI;EoD5QR,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;AtDupQF;;AAEA;EqD7qQE,wDhD+lB4B;EgD7lB5B,iDAAA;EACA,+DhDwmB4B;EgDvmB5B,4DhD+mB4B;EgD9mB5B,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;ArD8qQF;;AAEA;EqD5qQE,wDAAA;EnDgRI,iDALI;EoD1PR,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EjChBE,mEAAA;ErBgrQF,2DAA2D;EsD5pQ3D,4DAAA;EACE,sEAAA;AtD8pQJ;;AAEA;EsD5pQI,wDAAA;EAEE,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EtD6pQJ,2DAA2D;EAC3D,4DAA4D;EsDxpQ5D,sEAAA;AtD0pQF;;AsDvpQI;EAEE,wDAAA;EtDypQJ,iDAAiD;EsDtpQ/C,+DAAA;EACE,4DAAA;EACA,kEAAA;EtDwpQJ,6DAA6D;EsDrpQ3D,mEAAA;EACE,2DAAA;EACA,4DAAA;EtDupQJ,sEAAsE;AACxE;;AsDjpQE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EtDopQF,4DAA4D;EsDlpQ1D,kEAAA;EAEE,6DAAA;EtDmpQJ,mEAAmE;EsDhpQjE,2DAAA;EACE,4DAAA;EACA,sEAAA;AtDkpQN;;AAEA;EsD/oQM,yDAAA;EtDipQJ,kDAAkD;EAClD,gEAAgE;EsD7oQlE,4DAAA;EAGE,mEAAA;EACE,6DAAA;EtD6oQF,oEAAoE;EsD3oQlE,4DAAA;EAEE,6DAAA;EtD4oQJ,uEAAuE;AsDzoQrE;;AtD4oQJ;EACE,2DAA2D;EsDxoQzD,oDAAA;EACE,kEAAA;EACA,4DAAA;EtD0oQJ,qEAAqE;EsDroQrE,6DAAA;EACE,sEAAA;EACA,8DAAA;EACA,+DAAA;EACA,yEAAA;AtDuoQJ;;AAEA;EsDroQI,wDAAA;EtDuoQF,iDAAiD;EACjD,+DAA+D;EsDpoQjE,4DAAA;EAEE,kEAAA;EACE,6DAAA;EACA,mEAAA;EACA,2DAAA;EtDqoQF,4DAA4D;EsDnoQ1D,sEAAA;AtDqoQJ;;AsDhoQI;EACE,0DAAA;EACA,mDAAA;EtDmoQJ,iEAAiE;EsDhoQ/D,4DAAA;EACE,oEAAA;EACA,6DAAA;EtDkoQJ,qEAAqE;EACrE,6DAA6D;EsD9nQ/D,8DAAA;EAkBA,wEAAA;AtD+mQA;;AAEA;EsD7mQE,yDAAA;EACA,kDAAA;EACA,gEAAA;EjC5JE,4DAAA;EACA,mEAAA;ErB4wQF,6DAA6D;EsD9mQ7D,oEAAA;EACE,4DAAA;EtDgnQF,6DAA6D;EAC7D,uEAAuE;AsD7mQzE;;AtDgnQA;EACE,2DAA2D;EAC3D,oDAAoD;EuDryQtD,kEAAA;EACE,4DAAA;EvDuyQA,qEAAqE;EACrE,6DAA6D;EuDryQ/D,sEAAA;EACE,8DAAA;EvDuyQA,+DAA+D;EAC/D,yEAAyE;AuDryQ3E;;AvDwyQA;EuDryQE,8DAAA;EvDuyQA,uDAAuD;EwD7zQvD,qEAAA;EACE,4DAAA;EACA,wEAAA;EACA,6DAAA;ExD+zQF,yEAAyE;EACzE,iEAAiE;EuDzyQnE,kEAAA;EACE,4EAAA;AvD2yQF;;AAEA;EuDzyQE,uDAAA;EACA,gDAAA;EjClBI,8DiCmBJ;EvD2yQA,4DAA4D;EsB1zQxD,iEAAA;EiCQN,6DAAA;EvDqzQE,kEsB5zQM;EtB6zQN,0DAA0D;EAC1D,2DAA2D;EAC3D,qEAAqE;AuD9yQvE;;AAAA;EAGE,4DAAA;EvDgzQA,qDAAqD;EACrD,mEAAmE;EuD9yQrE,4DAAA;EAAA,sEAAA;EAEE,6DAAA;EvDgzQA,uEAAuE;EACvE,+DAA+D;EuD9yQjE,gEAAA;EAAA,0EAAA;AvDizQA;;AAEA;EuDxyQE,4DAAA;EACE,qDAAA;EACA,mEAAA;EACA,4DAAA;EvD0yQF,sEAAsE;EuDvyQtE,6DAAA;EAAA,uEAAA;EAAA,+DAAA;EAGE,gEAAA;EACA,0EAAA;AvDyyQJ;;AuDtyQE;EAEE,yDAAA;EACA,kDAAA;EjC5DE,gEiC6DF;EvDwyQF,4DAA4D;EsBj2QxD,mEAAA;EiCqDJ,6DAAA;EAAA,oEAAA;EvDgzQA,4DsBp2QM;EtBq2QN,6DAA6D;EAC7D,uEAAuE;AACzE;;AuDtyQA;EAEE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EAEA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DlDkhDmC;EkDjhDnC,2DAAA;EACA,qElD1FS;ALi4QX;;AAEA;EuDryQE,0BAAA;EACA,2DlD4gDmC;EiBnmD/B,2BiCwFJ;EvDuyQA,kCAAkC;EsB33Q9B,mEAAA;EiCkEN,+BAAA;EAAA,qCAAA;EvD6zQE,uBsB93QM;EtB+3QN,UAAU;EACV,WAAW;EuD1yQX,sBAAA;EAAA,gCAAA;EAAA,wEAAA;EAEE,kClDrGO;EkDsGP,SAAA;EACA,uBAAA;EACA,oClDogDiC;ALyyNrC;;AuD1yQA;EACE,gCAAA;EvD6yQA,qBAAqB;EACrB,0CAA0C;AuD3yQ5C;;AvD8yQA;EACE,UAAU;EuDzyQZ,4CAAA;EAAA,0CAAA;AvD4yQA;;AAEA;;EuDxyQE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EvD2yQA,6CAA6C;AAC/C;;AAEA;EACE,iEAAiE;AACnE;;AAEA;;EAEE,uBAAuB;AuDryQzB;;AvDwyQA;EuDryQE,iEAAA;AvDuyQF;;AAEA;EuDryQE,uBAAA;EACA,6BAAA;EAEA,4BlDq9CmC;EkDp9CnC,0BAAA;EACA,2BlDm9CmC;ELm1NnC,8BAA8B;EuDpyQ9B,kBAAA;EACE,gDAAA;EACA,+CAAA;EACA,2DlDo9CiC;EkDn9CjC,iDlDo9CiC;EkDn9CjC,2CAAA;EACA,kDlDo9CiC;EkDn9CjC,uDlDm9CiC;EkDl9CjC,kEAAA;EACA,gCAAA;EACA,eAAA;EACA,oCAAA;EACA,4BAAA;EAEA,oBAAA;EACA,oCAAA;EACA,4BlD28CiC;EiB5mD/B,uEiCkKF;EvDqyQF,sCAAsC;EsBn8QlC,4CAAA;AtBq8QN;;AAEA;EACE,UAAU;AuDvyQV;;AvD0yQF;EACE,aAAa;AuDjyQf;;AvDoyQA;EuDjyQE,uBlDk8CmC;EkDj8CnC,kBAAA;EACA,+BlD+7CmC;EkD97CnC,kBlD87CmC;EkD77CnC,eAAA;EACA,oBAAA;AvDmyQF;;AuDxxQA;EALE,sCAAA;AvDiyQF;;AAEA;EACE,aAAa;EuD3xQf,mBAAA;EAAA,4DAAA;EAEE,mCAAA;EACA,2CAAA;EACA,4BAAA;EvD6xQA,qFAAqF;EACrF,0FAA0F;EGz+QxF,2FAAA;AH2+QJ;;AAEA;EACE,oDAAoD;EACpD,sCAAsC;AyD1/QxC;;AzD6/QA;EyD1/QE,kCAAA;EACA,qBAAA;AzD4/QF;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EyDx/QzB,wBAAA;EACE,yBAAA;EzD0/QA,sCyD1/QK;EzD2/QL,gCAAgC;EAChC,2DAA2D;EyDx/Q7D,+CAAA;EAEE,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EAGA,sDAAA;EACA,sDAAA;EzDu/QA,iCAAiC;EACjC,6BAA6B;EyDr/Q/B,sBAAA;EAEE,sDAAA;EACA,sDAAA;EACA,eAAA;EzDs/QA,MAAM;EACN,OAAO;EyD9+QT,+BAAA;EACE,aAAA;EzDg/QA,WyD/+QE;EzDg/QF,YAAY;EyD9+QZ,kBAAA;EzDg/QA,gByD/+QE;EzDg/QF,UyD/+QE;AzDg/QJ;;AyD3+QA;EAEE,kBAAA;EACA,WAAA;EACA,8BAAA;EACA,oBAAA;AzD6+QF;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;AyDz+QrC;;AzD4+QA;EACE;IACE,gBAAgB;EyDx+QlB;AzD0+QF;;AAEA;EACE,eAAe;AACjB;;AAEA;E0DzjRE,sBAAA;A1D2jRF;;AAEA;E0DzjRE,+CAAA;A1D2jRF;;AAEA;E0DzjRE,gBAAA;EACA,gBAAA;A1D2jRF;;AAEA;Ea//QI,gBAAA;AbigRJ;;AAEA;EACE,a0D5iRI;E1D6iRJ,mB0D5iRI;E1D6iRJ,mD0D5iRI;A1D6iRN;;AAEA;EACE,kB0D5iRI;E1D6iRJ,a0D5iRI;E1D6iRJ,sB0D5iRI;E1D6iRJ,WsBzkRI;EtB0kRJ,4BAA4B;EAC5B,oBAAoB;EsBvkRhB,oCAAA;EoCYJ,4BAAA;E1D8jRA,uEsBzkRM;EtB0kRN,4CAA4C;EAC5C,UAAU;AaphRR;;AbuhRJ;EACE,0B0DljRM;E1DmjRN,sB0DljRM;E1DmjRN,0B0DljRM;E1DmjRN,e0DljRM;E1DmjRN,MAAM;E0DhjRF,OAAA;E1DkjRJ,kC0DjjRM;E1DkjRN,Y0DjjRM;E1DkjRN,a0DjjRM;E1DkjRN,uC0DjjRM;A1DkjRR;;AAEA;EACE,U0DhjRM;A1DijRR;;AAEA;EACE,mC0DhjRM;A1DijRR;;AAEA;E0D9iRM,aAAA;E1DgjRJ,c0D/iRM;E1DgjRN,mB0D/iRM;E1DgjRN,uC0D/iRM;E1DgjRN,4F0D/iRM;E1DgjRN,2D0D/iRM;E1DgjRN,4D0D/iRM;A1DgjRR;;AAEA;EACE,kGAAkG;E0D3iR9F,yDAAA;E1D6iRJ,2D0D1iRM;E1D2iRN,4DAA4D;EAC5D,iBAAiB;AaxkRf;;Ab2kRJ;EACE,gB0DziRM;E1D0iRN,8C0DziRM;A1D0iRR;;AAEA;EACE,kBAAkB;E0DviRZ,cAAA;E1DyiRN,gC0DxiRQ;A1DyiRV;;AAEA;EACE,a0DviRQ;E1DwiRR,cAAc;EACd,eAAe;EACf,mBAAmB;Ea7kRjB,yBAAA;E6C5CF,yEAAA;E1D4nRA,2C0D1nRI;E1D2nRJ,yF0D1nRI;E1D2nRJ,+D0D1nRI;E1D2nRJ,8D0D1nRI;A1D2nRN;;AAEA;EACE,8C0D1nRI;A1D2nRN;;AAEA;EACE;IACE,0BAA0B;IAC1B,2CAA2C;EsBrpRzC;;EtBwpRJ;IACE,gCAAgC;IAChC,kBAAkB;IalmRlB,iBAAA;E6C5BE;;E1DkoRJ;I0D/nRM,uBAAA;E1DioRN;AACF;;AAEA;;EAEE;;I0D7nRM,uBAAA;E1DgoRN;AACF;;AAEA;EACE;I0D7nRM,wBAAA;E1D+nRN;AACF;;AAEA;EACE,YAAY;E0D5nRR,eAAA;E1D8nRJ,Y0D7nRM;E1D8nRN,S0D7nRM;A1D8nRR;;AAEA;EACE,Y0D7nRM;E1D8nRN,SAAS;E0D3nRL,gBAAA;A1D6nRN;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gB0DvnRM;A1DwnRR;;AAEA;E0DtnRQ;IACE,YAAA;I1DwnRN,eAAe;I0DrnRX,YAAA;IACE,SAAA;E1DunRR;;EAEA;I0DpnRQ,YAAA;I1DsnRN,SAAS;IACT,gBAAgB;EAClB;;E0DvsRA;;IAGI,gBAAA;E1DysRJ;;EAEA;I0DvsRI,gBAAA;E1DysRJ;AACF;;AAEA;EACE;IsBpuRI,YoC8BA;I1DwsRF,eAAe;IACf,YAAY;IsBnuRV,SAAA;EoCYJ;;E1D2tRA;IACE,YAAY;IahrRZ,SAAA;I6C5BE,gBAAA;E1D+sRJ;;EAEA;;I0D5sRM,gBAAA;E1D+sRN;;EAEA;I0D5sRM,gBAAA;E1D8sRN;AACF;;AAEA;E0D3sRM;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;E1D6sRN;;EAEA;IACE,YAAY;I0D1sRV,SAAA;IACE,gBAAA;E1D4sRN;;EAEA;;I0DzsRM,gBAAA;E1D4sRN;;EAEA;IACE,gBAAgB;E0DvsRd;A1DysRN;;AAEA;EapuRI;I6C/BF,YAAA;IAiEM,eAAA;IACA,YAAA;IACA,SAAA;E1DssRN;;EAEA;IACE,YAAY;I0DnsRR,SAAA;IACE,gBAAA;E1DqsRR;;EAEA;;IAEE,gBAAgB;EAClB;;EaxuRE;I6C5CF,gBAAA;E1DwxRA;AACF;;AAEA;EACE;I0DrxRI,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;E1DuxRJ;;EAEA;IACE,YAAY;IACZ,SAAS;IsBjzRP,gBAAA;EoCYJ;;E1DyyRA;;Ia7vRE,gBAAA;E6C5BE;;E1D8xRJ;I0D3xRM,gBAAA;E1D6xRN;AACF;;AAEA;EACE,yB0D3xRM;E1D4xRN,6B0D3xRM;E1D4xRN,8B0D3xRM;E1D4xRN,+B0D3xRM;E1D4xRN,qB0D3xRM;E1D4xRN,+BAA+B;E0DzxR3B,qCAAA;E1D2xRJ,yC0D1xRM;E1D2xRN,mD0D1xRM;E1D2xRN,yB0D1xRM;E1D2xRN,gC0D1xRM;E1D2xRN,iC0D1xRM;E1D2xRN,iC0D1xRM;E1D2xRN,c0D1xRM;E1D2xRN,gCAAgC;E0DxxR5B,sCAAA;E1D0xRJ,kB0DzxRM;E1D0xRN,gB0DzxRM;E1D0xRN,gB0DzxRM;E1D0xRN,gB0DzxRM;E1D0xRN,iB0DzxRM;E1D0xRN,qB0DzxRM;E1D0xRN,iBAAiB;E0DvxRb,oBAAA;E1DyxRJ,sB0DvxRM;E1DwxRN,kBAAkB;E0DrxRd,mBAAA;E1DuxRJ,oB0DpxRM;E1DqxRN,gBAAgB;EAChB,sCAAsC;EalzRpC,qBAAA;E6C/BF,UAAA;A1Do1RF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;E0DjxRQ,cAAA;E1DmxRN,oC0DlxRQ;E1DmxRR,sC0DlxRQ;A1DmxRV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EavzRvB,mBAAA;AbyzRJ;;AAEA;;EAEE,iD0Dp2RI;A1Dq2RN;;AAEA;;EAEE,S0Dp2RI;E1Dq2RJ,wF0Dp2RI;E1Dq2RJ,sC0Dp2RI;A1Dq2RN;;AAEA,qBAAqB;AsB/3Rf;;EtBk4RJ,+CsBj4RM;EtBk4RN,qCAAqC;EACrC,qCAAqC;Aa50RnC;;Ab+0RJ;;EAEE,W0D12RM;E1D22RN,kI0D12RM;E1D22RN,wC0D12RM;A1D22RR;;AAEA,mB0Dz2RQ;A1D02RR;;EAEE,8C0Dz2RM;A1D02RR;;AAEA;;EAEE,Y0Dx2RM;E1Dy2RN,wF0Dx2RM;E1Dy2RN,yC0Dx2RM;A1Dy2RR;;AAEA,qB0Dx2RQ;A1Dy2RR;;EAEE,gD0Dv2RM;E1Dw2RN,qC0Dv2RM;E1Dw2RN,qC0Dv2RM;A1Dw2RR;;AAEA;;E0Dp2RM,UAAA;E1Du2RJ,kI0Dr2RM;E1Ds2RN,uCAAuC;AACzC;;AAEA,mBAAmB;AACnB;Eah4RI,sCAAA;E6C/BF,gEAAA;E1Dk6RA,8B0Dj2RM;E1Dk2RN,kB0Dj2RM;E1Dk2RN,sC0Dj2RM;E1Dk2RN,8CAA8C;AAChD;;AAEA;E0D/1RQ,yBAAA;E1Di2RN,6B0Dh2RQ;E1Di2RR,+B0Dh2RQ;E1Di2RR,kC0Dh2RQ;E1Di2RR,iD0Dh2RQ;E1Di2RR,6D0D/1RQ;E1Dg2RR,sDAAsD;EACtD,2FAA2F;EAC3F,6CAA6C;E0Dj7R7C,mCAAA;EAEI,qCAAA;EACA,sCAAA;EACA,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EACA,iCAAA;EpC5BA,coC8BA;E1Di7RJ,sCAAsC;EsB38RlC,sCAAA;EoCYJ,kBAAA;E1Dk8RA,gBsB78RM;EtB88RN,gBAAgB;EAChB,gBAAgB;E0Dp7RZ,iBAAA;EACE,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;E1Ds7RN,mBAAmB;E0Dn7Rf,oBAAA;EACE,gBAAA;EACA,sCAAA;EACA,qBAAA;EACA,sCAAA;EACA,4BAAA;E1Dq7RN,2EAA2E;E0Dl7RvE,8CAAA;A1Do7RN;;AAEA;E0Dl7RQ,cAAA;EACA,oCAAA;EACA,sCAAA;A1Do7RR;;A0Dh7RM;;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;E1Dm7RN,eAAe;A0Dh7RX;;A1Dm7RN;;E0D36RQ,oFAAA;A1D86RR;;A0Dn5RA;;;;EPjHE,wF9C0mCkC;ALi6PpC;;AAEA;;EmDvgSE,SAAA;EAAS,gDAAA;AnD2gSX;;AAEA;;EAEE,sCAAsC;E0Dh6RxC,sCAAA;A1Dk6RA;;AAEA,qB0Dj6RE;A1Dk6RF;;E0D/5RI,kFAAA;EAEA,qCAAA;EACA,qCAAA;A1Di6RJ;;AAEA;;;;E0D35RE,kIAAA;A1Dg6RF;;A0D75RA;;EAEE,OAAA;EACA,kDAAA;A1Dg6RF;;A2DjjSA;;EAEE,oCAAA;EACA,wCAAA;A3DojSF;;AAEA,mBKnwPoC;ALowPpC;;E2DjjSI,iFAAA;A3DojSJ;;AAEA;;;;EAIE,wFAAwF;A2DhjS1F;;A3DmjSA;;E2D/iSA,MAAA;EACE,mDAAA;A3DkjSF;;A2D7iSE;;E3DijSA,mCAAmC;EACnC,yCAAyC;A2D7iS3C;;A3DgjSA;;EAEE,kBAAkB;E2D5iSpB,MAAA;EACE,SAAA;EACA,cAAA;EACA,oCAAA;E3D8iSA,uDAAuD;EACvD,WAAW;E2D5iSb,+EAAA;A3D8iSA;;AAEA,qBAAqB;AACrB;;EwD5lSI,mFAAA;EACA,qCAAA;EACA,qCAAA;AxD+lSJ;;A4DlmSE;;;;E5DwmSA,kIAAkI;A4DxmSlI;;A5D2mSF;;EAEE,QAAQ;E4D7mSR,iDAAA;A5D+mSF;;AAEA;;E4DjnSE,qCAAA;EACE,uCAAA;A5DonSJ;;AAEA,mBAAmB;A4DvnSjB;EACE,8EAAA;EACA,gBAAA;E5DynSF,6CAA6C;EAC7C,qCAAqC;E4D5nSrC,6CAAA;EACE,kFAAA;EACA,6DAAA;E5D8nSF,8DAA8D;AAChE;;AAEA;E4DjoSI,aAAA;A5DmoSJ;;A4DroSE;EACE,0EAAA;EACA,mCAAA;A5DwoSJ;;A4D1oSE;EACE,kBAAA;A5D6oSJ;;AAEA;E4DhpSE,mBAAA;A5DkpSF;;AAEA;EACE,kBAAkB;E4DrpSlB,WAAA;EACE,gBAAA;A5DupSJ;;AAEA;E4D1pSE,cAAA;EACE,WAAA;EACA,WAAA;A5D4pSJ;;A4D9pSE;EACE,kBAAA;EACA,aAAA;E5DiqSF,WAAW;EACX,WAAW;E4DpqSX,mBAAA;EACE,2BAAA;EACA,sCAAA;A5DsqSJ;;A4DxqSE;EACE;IACA,gBAAA;E5D2qSF;AACF;;AAEA;;;EAGE,cAAc;A4DnrSd;;A5DsrSF;;EAEE,2BAA2B;A4DxrS3B;;A5D2rSF;;EAEE,4BAA4B;A4D7rS5B;;A5DgsSF;EACE,UAAU;EACV,4BAA4B;E4DlsS5B,eAAA;A5DosSF;;AAEA;;;E4DrsSI,UAAA;EACA,UAAA;A5DysSJ;;A4D3sSE;;EAEE,UAAA;E5D8sSF,UAAU;EACV,2BAA2B;A4DjtS3B;;A5DotSF;;EAEE;;I4DrtSE,gBAAA;EACA;A5DwtSJ;;A4D1tSE;;EAEE,kBAAA;E5D6tSF,MAAM;EACN,SAAS;E4DhuST,UAAA;EACE,aAAA;EACA,mBAAA;E5DkuSF,uBAAuB;EACvB,UAAU;E4DruSV,UAAA;EACE,WAAA;EACA,kBAAA;E5DuuSF,gBAAgB;EAChB,8CAA8C;E4D1uS9C,SAAA;EACE,YAAA;EACA,8BAAA;A5D4uSJ;;A4D9uSE;;EAEE;;I5DkvSA,gBAAgB;E4DpvSlB;A5DsvSF;;AAEA;;;;E4DtvSI,WAAA;E5D2vSF,qBAAqB;EACrB,UAAU;E4D9vSV,YAAA;A5DgwSF;;AAEA;EACE,OAAO;A4DnwSP;;A5DswSF;EACE,QAAQ;AACV;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;E4D7wSX,YAAA;EACE,4BAAA;EACA,wBAAA;E5D+wSF,0BAA0B;AAC5B;;AAEA;E4DlxSI;;E5DqxSF;A4DvxSA;;A5D0xSF;EACE;;E4D3xSA;A5D8xSF;;AAEA;EACE,kBAAkB;E4DjySlB,QAAA;EACE,SAAA;EACA,OAAA;E5DmySF,UAAU;EACV,aAAa;E4DtySb,uBAAA;EACE,UAAA;EACA,iBAAA;E5DwySF,mBAAmB;EACnB,gBAAgB;A6D3yShB;;A7D8ySF;EACE,uBAAuB;E6D1ySnB,cAAA;EAGE,WAAA;EACA,WAAA;E7D0ySN,UAAU;EACV,iBAAiB;E6DpzSjB,gBAAA;EACE,mBAAA;EACA,eAAA;E7DszSF,wDAAwD;E6DnzSpD,4BAAA;EAGE,SAAA;EACA,kCAAA;E7DmzSN,qCAAqC;EACrC,YAAY;E6D7zSZ,6BAAA;A7D+zSF;;AAEA;E6D5zSM;IAGE,gBAAA;EACA;A7D4zSR;;A6Dr0SE;EACE,UAAA;A7Dw0SJ;;A6Dp0SM;EAGE,kBAAA;EACA,UAAA;E7Dq0SN,eAAe;EACf,SAAS;E6D/0ST,oBAAA;EACE,uBAAA;EACA,uCAAA;E7Di1SF,kBAAkB;A6D90Sd;;A7Di1SN;EACE,uCAAuC;EACvC,iCAAiC;E6Dx1SjC,2DAAA;A7D01SF;;AAEA;;E6Dp1SQ,uCAAA;EACA,iCAAA;E7Du1SN,mCAAmC;AACrC;;AAEA;E6Dj2SI,uCAAA;E7Dm2SF,iCAAiC;E6Dh2S7B,2DAAA;A7Dk2SN;;AAEA;;E6Dz2SE,qBAAA;EACE,8BAAA;EACA,gCAAA;E7D42SF,gDAAgD;E6Dz2S5C,kBAAA;EAGE,6FAAA;A7Dy2SR;;AAEA;E6Dn3SE;IACE;;I7Ds3SA;E6Dl3SE;A7Do3SN;;AAEA;EACE,wBAAwB;E6D53SxB,yBAAA;EACE,qCAAA;EACA,iCAAA;E7D83SF,mCAAmC;E6D33S/B,2CAAA;EAGE,yDAAA;EACA,+BAAA;A7D23SR;;A6Dp4SE;EACE,wBAAA;EACA,yBAAA;E7Du4SF,gCAAgC;A6Dp4S5B;;A7Du4SN;EACE;IACE,mBAAmB;E6D94SrB;;EAEE;I7Dg5SA,UAAU;I6D74SR,eAAA;EAGE;A7D64SR;;AAEA;E6Dv5SE,wBAAA;EACE,yBAAA;EACA,qCAAA;E7Dy5SF,mCAAmC;E6Dt5S/B,yCAAA;EAGE,8BAAA;EACA,UAAA;A7Ds5SR;;A6D/5SE;EACE,wBAAA;EACA,yBAAA;A7Dk6SJ;;AAEA;;EAEE;;I6Dx6SA,kCAAA;EACE;A7D26SJ;;A6Dv6SM;;;;;;EAJF,2BAAA;EACA,2BAAA;E7Do7SF,2BAA2B;E6Dj7SvB,8BAAA;EAGE,8BAAA;EACA,0CAAA;E7Di7SN,oCAAoC;EACpC,mDAAmD;E6D37SnD,+DAAA;EACE,kDAAA;EACA,qDAAA;E7D67SF,qCAAqC;A6D17SjC;;A7D67SN;EACE;IACE,eAAe;I6Dp8SjB,SAAA;IACE,mCAAA;IACA,aAAA;I7Ds8SA,sBAAsB;I6Dn8SpB,eAAA;IAGE,gCAAA;IACA,kBAAA;I7Dm8SJ,wCAAwC;IACxC,4BAA4B;I6D78S9B,UAAA;IACE,0CAAA;EACA;A7D+8SJ;;AAEA;E6D18SQ;I7D48SJ,gBAAgB;EAClB;A6Dt9SA;;A7Dy9SF;EACE;I6Dr9SI,MAAA;IAGE,OAAA;IACA,gCAAA;I7Dq9SJ,qFAAqF;IACrF,4BAA4B;E6D/9S9B;;EAEE;I7Di+SA,MAAM;I6D99SJ,QAAA;IAGE,gCAAA;IACA,oFAAA;I7D89SJ,2BAA2B;EAC7B;;E6Dv+SE;IACA,MAAA;I7D0+SA,QAAQ;I6Dv+SN,OAAA;IAGE,kCAAA;IACA,gBAAA;I7Du+SJ,sFAAsF;IACtF,4BAA4B;E6Dj/S9B;;EAEE;I7Dm/SA,QAAQ;I6Dh/SN,OAAA;IAGE,kCAAA;IACA,gBAAA;I7Dg/SJ,mFAAmF;IACnF,2BAA2B;E6D1/S7B;;EAEE;;IAGE,eAAA;EAGE;;E7D0/SN;;;I6DjgTE,mBAAA;EACA;A7DqgTJ;;AAEA;E6DhgTQ;I7DkgTJ,2BAA2B;IAC3B,8BAA8B;I6D5gThC,wCAAA;EACE;;E7D+gTF;I6D3gTI,aAAA;EAGE;;E7D4gTN;IACE,aAAa;I6DrhTf,YAAA;IACE,UAAA;IACA,mBAAA;I7DuhTA,wCAAwC;E6DphTtC;A7DshTN;;AAEA;EACE;I6D9hTA,eAAA;IACE,SAAA;IACA,mCAAA;I7DgiTA,aAAa;I6D7hTX,sBAAA;IAGE,eAAA;IACA,gCAAA;I7D6hTJ,kBAAkB;IAClB,wCAAwC;I6DviT1C,4BAAA;IACE,UAAA;IACA,0CAAA;E7DyiTF;A6DtiTI;;A7DyiTN;EACE;IACE,gBAAgB;E6DhjTlB;A7DkjTF;;AAEA;E6D/iTM;IAGE,MAAA;IACA,OAAA;I7D+iTJ,gCAAgC;IAChC,qFAAqF;I6DzjTvF,4BAAA;EACE;;E7D4jTF;I6DxjTI,MAAA;IAGE,QAAA;IACA,gCAAA;I7DwjTJ,oFAAoF;IACpF,2BAA2B;E6DlkT7B;;EAEE;I7DokTA,MAAM;I6DjkTJ,QAAA;IAGE,OAAA;IACA,kCAAA;I7DikTJ,gBAAgB;IAChB,sFAAsF;I6D3kTxF,4BAAA;EACE;;E7D8kTF;I6D1kTI,QAAA;IAGE,OAAA;IACA,kCAAA;I7D0kTJ,gBAAgB;IAChB,mFAAmF;I6DplTrF,2BAAA;EACE;;E7DulTF;;I6DhlTM,eAAA;EACA;;E7DolTN;;;I6D3lTE,mBAAA;E7D+lTF;A6D5lTI;;A7D+lTN;EACE;IACE,2BAA2B;I6DtmT7B,8BAAA;IACE,wCAAA;EACA;;EAGE;IAGE,aAAA;EACA;;E7DsmTN;I6D/mTA,aAAA;IACE,YAAA;IACA,UAAA;I7DinTA,mBAAmB;I6D9mTjB,wCAAA;EAGE;A7D8mTR;;AAEA;E6DxnTE;IACE,eAAA;IACA,SAAA;I7D0nTA,mCAAmC;I6DvnTjC,aAAA;IAGE,sBAAA;IACA,eAAA;I7DunTJ,gCAAgC;IAChC,kBAAkB;I6DjoTpB,wCAAA;IACE,4BAAA;IACA,UAAA;I7DmoTA,0CAA0C;E6DhoTxC;A7DkoTN;;AAEA;EACE;I6D1oTA,gBAAA;EACE;A7D4oTJ;;A6DxoTM;EAGE;IACA,MAAA;I7DyoTJ,OAAO;IACP,gCAAgC;I6DnoTpC,qFAAA;IACE,4BAAA;EACA;;EAGE;IAEE,MAAA;IACA,QAAA;I7DmoTF,gCAAgC;IAChC,oFAAoF;I8D9pTxF,2BAAA;EACE;;E9DiqTA;IACE,MAAM;I+DnqTV,QAAA;IACE,OAAA;IACA,kC1D6c4B;I0D5c5B,gBAAA;IACA,sFAAA;IACA,4B1D2c4B;E0D1c5B;;EAEA;IACE,QAAA;IACA,O1Duc0B;I0Dtc1B,kC1Dsc0B;I0Drc1B,gBAAA;IzCIE,mFyCHF;I/DqqTA,2BAA2B;EsB9pTzB;;EtBiqTJ;;IAEE,eAAe;EACjB;;E+DnqTI;;;ICnBN,mBAAA;EACE;AhE4rTF;;AgEzrTE;EACE;IACA,2BAAA;IACA,8BAAA;IhE4rTA,wCAAwC;EgEzrT1C;;EAEE;IACA,aAAA;EACA;;EhE4rTF;IACE,aAAa;IgEvrTf,YAAA;IACE,UAAA;IhEyrTA,mBAAmB;IACnB,wCAAwC;EgE3rT1C;AhE6rTF;;AAEA;EgE/rTE;IACE,eAAA;IhEisTA,SAAS;IACT,mCAAmC;IgEnsTrC,aAAA;IACE,sBAAA;IhEqsTA,eAAe;IACf,gCAAgC;IiE3tTpC,kBAAA;IACE,wCAAA;IACA,4BAAA;IACA,UAAA;IACA,0CAAA;EACA;AjE6tTF;;AiE1tTA;EACE;IACA,gBAAA;EACA;AjE6tTF;;AAEA;EACE;IiEttTE,MAAA;IACE,OAAA;IACA,gCAAA;IACA,qF5DmlC8B;ILqoRhC,4BAA4B;EAC9B;;EiErtTI;IACA,MAAA;IACA,Q5D6kC8B;IL2oRhC,gCAAgC;IAChC,oFAAoF;Ia1rTpF,2BAAA;EoDxCA;;EjEsuTF;IiEnuTI,MAAA;IjEquTF,QAAQ;IiEluTR,OAAA;IACE,kCAAA;IACA,gBAAA;IACA,sF5D6kC8B;ILupRhC,4BAA4B;EAC9B;;EiE9uTE;IACE,QAAA;IACA,OAAA;IACA,kC5DmlC8B;IL8pRhC,gBAAgB;IiE9uThB,mFAAA;IACE,2BAAA;EjEgvTJ;;EAEA;;IajtTE,eAAA;EoDxCA;;EjE8vTF;;;IiExvTE,mBAAA;EjE4vTF;AACF;;AAEA;EACE;Ia9tTE,2BAAA;IoDxCA,8BAAA;IACE,wCAAA;EjEywTJ;;EAEA;IiEtwTE,aAAA;EjEwwTF;;EAEA;IACE,aAAa;IACb,YAAY;Ia1uTZ,UAAA;IoDxCA,mBAAA;IACE,wCAAA;EjEqxTJ;AACF;;AAEA;EACE;IiElxTI,eAAA;IACA,S5D6kC8B;ILusRhC,mCAAmC;IACnC,aAAa;IkEpzTjB,sBAAA;IACE,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IlEszTE,4BAA4B;IAC5B,UAAU;IkEpzTd,0CAAA;EACE;AlEszTF;;AAEA;EACE;IACE,gBAAgB;EmE/zTpB;AAAA;;AnEm0TA;EoE7zTE;IACA,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EpE+zTA;;EoE5zTA;IACE,MAAA;IpE+zTA,QAAQ;IoE3zTV,gCAAA;IAAA,oFAAA;IACE,2BAAA;EpE8zTF;;EqEj1TA;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFhEgcsC;IgE/btC,4BAAA;ErEo1TF;;EsE51TF;ICAE,QAAA;IACA,OAAA;IACA,kCAAA;IvEg2TE,gBAAgB;IAChB,mFAAmF;IwEv2TvF,2BAAA;EACE;;EAEA;;IAEA,eAAA;EACA;;ExE02TA;;;IAGE,mBAAmB;EACrB;AyElzTM;;AzEqzTR;EACE;IyEtzTM,2BAAA;IAOI,8BAAA;IzEkzTR,wCAAwC;EAC1C;;EyEnzTU;IzEszTR,aAAa;EACf;;EyEvzTU;IzE0zTR,aAAa;IACb,YAAY;IyEl0TR,UAAA;IAOI,mBAAA;IzE8zTR,wCAAwC;EAC1C;AyEt0TM;;AzEy0TR;EACE,eAAe;EyE10TT,SAAA;EAOI,mCAAA;EzEs0TV,aAAa;EACb,sBAAsB;EyE90ThB,eAAA;EAOI,gCAAA;EzE00TV,kBAAkB;EAClB,wCAAwC;EyEl1TlC,4BAAA;EAOI,UAAA;EzE80TV,0CAA0C;AAC5C;;AAEA;EACE;IACE,gBAAgB;EyE11TZ;AzE41TR;;AAEA;EyE91TQ,MAAA;EAOI,OAAA;EzE01TV,gCAAgC;EAChC,qFAAqF;EyEl2T/E,4BAAA;AzEo2TR;;AAEA;EyEt2TQ,MAAA;EAOI,QAAA;EzEk2TV,gCAAgC;EAChC,oFAAoF;EyE12T9E,2BAAA;AzE42TR;;AAEA;EyE92TQ,MAAA;EAOI,QAAA;EzE02TV,OAAO;EACP,kCAAkC;EyEl3T5B,gBAAA;EAOI,sFAAA;EzE82TV,4BAA4B;AAC9B;;AAEA;EACE,QAAQ;EACR,OAAO;EyE13TD,kCAAA;EAOI,gBAAA;EzEs3TV,mFAAmF;EACnF,2BAA2B;AyE93TrB;;AzEi4TR;;EyEj4TQ,eAAA;AzEo4TR;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EyE94TA,OAAA;EAOI,aAAA;EzE04TV,YAAY;EACZ,aAAa;EyEl5TP,sBAAA;AzEo5TR;;AAEA;EyEt5TQ,UAAA;AzEw5TR;;AAEA;EyE15TQ,YAAA;AzE45TR;;AAEA;EyE95TQ,aAAA;EAOI,mBAAA;EzE05TV,oEAAoE;AACtE;;AAEA;EACE,4FAA4F;EAC5F,sDAAsD;EyEt6ThD,wDAAA;EAOI,yDAAA;EzEk6TV,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kDAAkD;AyE96T5C;;AzEi7TR;EACE,YAAY;EyEl7TN,oEAAA;EAOI,gBAAA;AzE86TZ;;AyEr7TQ;EAOI,qBAAA;EzEk7TV,eAAe;EACf,sBAAsB;EyE17ThB,YAAA;EAOI,8BAAA;EzEs7TV,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;AyEl8TL;;AzEq8TR;EACE,iBAAiB;AyEt8TX;;AzEy8TR;EACE,iBAAiB;AyE18TX;;AzE68TR;EACE,iBAAiB;AyE98TX;;AzEi9TR;EACE,mDAAmD;AyEl9T7C;;AzEq9TR;EACE;IyEt9TM,YAAA;EAOI;AzEk9TZ;;AyEz9TQ;EAOI,+EAAA;EzEs9TV,oBAAoB;EACpB,8CAA8C;AyE99TxC;;AzEi+TR;EACE;IyEl+TM,uBAAA;EAOI;AzE89TZ;;AyE/+TQ;EACE,cAAA;EzEk/TR,WAAW;EACX,WAAW;AyEp/TL;;AzEu/TR;EACE,sBAAsB;EyEx/ThB,iFAAA;AzE0/TR;;AAEA;EyE5/TQ,sBAAA;EACE,mFAAA;AzE8/TV;;AyE//TQ;EACE,sBAAA;EzEkgUR,iFAAiF;AACnF;;AAEA;EACE,sBAAsB;EACtB,8EAA8E;AyExgUxE;;AzE2gUR;EACE,sBAAsB;EyE5gUhB,iFAAA;AzE8gUR;;AAEA;EyEhhUQ,sBAAA;EACE,gFAAA;AzEkhUV;;AyEnhUQ;EACE,sBAAA;EzEshUR,+EAA+E;AACjF;;AAEA;EACE,sBAAsB;EACtB,8EAA8E;AyE5hUxE;;AzE+hUR;EACE,sBAAsB;EyEhiUhB,qFAAA;AzEkiUR;;AAEA;EyEpiUQ,sBAAA;EACE,wFAAA;AzEsiUV;;AyEviUQ;EACE,sBAAA;EzE0iUR,wFAAwF;AAC1F;;AAEA;EACE,sBAAsB;EACtB,oFAAoF;AyEhjU9E;;AzEmjUR;EACE,sBAAsB;EyEpjUhB,oFAAA;AzEsjUR;;AAEA;EyExjUQ,sBAAA;EACE,oFAAA;AzE0jUV;;AyE3jUQ;EACE,sBAAA;EzE8jUR,oFAAoF;AACtF;;AAEA;EACE,sBAAsB;EACtB,oFAAoF;AyEpkU9E;;AzEukUR;EACE,sBAAsB;EyExkUhB,oFAAA;AzE0kUR;;AAEA;EyE5kUQ,sBAAA;EACE,oFAAA;AzE8kUV;;AyE/kUQ;EACE,sBAAA;EzEklUR,oFAAoF;AACtF;;AAEA;EACE,sBAAsB;EACtB,qFAAqF;AyExlU/E;;AzE2lUR;EACE,sBAAsB;EyE5lUhB,iFAAA;AzE8lUR;;AAEA;EyEhmUQ,sBAAA;EACE,oFAAA;AzEkmUV;;AyEnmUQ;EACE,sBAAA;EzEsmUR,mFAAmF;AACrF;;AAEA;EACE,sBAAsB;EACtB,mFAAmF;AyE5mU7E;;AzE+mUR;EACE,sBAAsB;EyEhnUhB,mFAAA;AzEknUR;;AAEA;EyEpnUQ,sBAAA;EACE,mFAAA;AzEsnUV;;AyEvnUQ;EACE,sBAAA;EzE0nUR,mFAAmF;AACrF;;AAEA;EACE,sBAAsB;EACtB,mFAAmF;AyEhoU7E;;AzEmoUR;EACE,sBAAsB;EyEpoUhB,oFAAA;AzEsoUR;;AAEA;EyExoUQ,sBAAA;EACE,sFAAA;AzE0oUV;;AyE3oUQ;EACE,sBAAA;EzE8oUR,mFAAmF;AACrF;;AAEA;EACE,sBAAsB;EACtB,qFAAqF;AyE1oU/E;;AzE6oUR;EACE,sBAAsB;EyE9oUhB,oFAAA;AzEgpUR;;AAEA;EyElpUQ,sBAAA;EAOI,sFAAA;AzE8oUZ;;AyErpUQ;EAOI,sBAAA;EzEkpUV,yFAAyF;AAC3F;;AAEA;EACE,sBAAsB;EACtB,kFAAkF;AyE9pU5E;;AzEiqUR;EACE,sBAAsB;EyElqUhB,uFAAA;AzEoqUR;;AAEA;EyEtqUQ,sBAAA;EAOI,uFAAA;AzEkqUZ;;AyEzqUQ;EAOI,sBAAA;EzEsqUV,oFAAoF;AACtF;;AAEA;EACE,sBAAsB;EACtB,kFAAkF;AyElrU5E;;AzEqrUR;EACE,wEAAwE;EyEtrUlE,kGAAA;AzEwrUR;;AAEA;;EyEnrUY,+DAAA;EzEsrUV,yFAAyF;AAC3F;;AAEA;EACE,0EAA0E;EAC1E,oGAAoG;AyElsU9F;;AzEqsUR;;EyErsUQ,6DAAA;EAOI,uFAAA;AzEksUZ;;AyEzsUQ;EAOI,wEAAA;EzEssUV,kGAAkG;AACpG;;AAEA;;EAEE,8DAA8D;EyEltUxD,wFAAA;AzEotUR;;AAEA;EyEttUQ,qEAAA;EAOI,+FAAA;AzEktUZ;;AyEztUQ;;EzE6tUN,+DAA+D;EAC/D,yFAAyF;AyE9tUnF;;AzEiuUR;EACE,wEAAwE;EyEluUlE,kGAAA;AzEouUR;;AAEA;;EyE/tUY,+DAAA;EzEkuUV,yFAAyF;AAC3F;;AAEA;EACE,uEAAuE;EACvE,iGAAiG;AyE9uU3F;;AzEivUR;;EyEjvUQ,+DAAA;EAOI,yFAAA;AzE8uUZ;;AyErvUQ;EAOI,sEAAA;EzEkvUV,gGAAgG;AAClG;;AAEA;;EAEE,gEAAgE;EyE9vU1D,0FAAA;AzEgwUR;;AAEA;EACE,qEAAqE;EyEnwU/D,+FAAA;AzEqwUR;;AAEA;;EyEvwUQ,0DAAA;EAIQ,oFAAA;AzEuwUhB;;AAEA;EyE7wUQ,4EAAA;EAIQ,sGAAA;AzE4wUhB;;AAEA;;EyE9wUgB,+DAAA;EAGJ,yFAAA;AzE+wUZ;;AyEtxUQ;EAIQ,+EAAA;EAGJ,yGAAA;AzEoxUZ;;AyE3xUQ;;EAOI,+DAAA;EzEyxUV,yFAAyF;AAC3F;;AAEA;EyE5xUY,+EAAA;EzE8xUV,yGAAyG;AAC3G;;AAEA;;EAEE,8DAA8D;EAC9D,wFAAwF;AyE3yUlF;;AzE8yUR;EACE,2EAA2E;EAC3E,qGAAqG;AyEhzU/F;;AzEmzUR;;EAEE,+DAA+D;EyErzUzD,yFAAA;AzEuzUR;;AAEA;EACE,2EAA2E;EyE1zUrE,qGAAA;AzE4zUR;;AAEA;;EyE9zUQ,8DAAA;EAIQ,wFAAA;AzE8zUhB;;AAEA;EyEp0UQ,2EAAA;EAIQ,qGAAA;AzEm0UhB;;AAEA;;EyEr0UgB,6DAAA;EAGJ,uFAAA;AzEs0UZ;;AyE70UQ;EAIQ,2EAAA;EAGJ,qGAAA;AzE20UZ;;AyEl1UQ;;EAOI,6DAAA;EzEg1UV,uFAAuF;AACzF;;AAEA;EyEn1UY,2EAAA;EzEq1UV,qGAAqG;AACvG;;AAEA;;EAEE,8DAA8D;EAC9D,wFAAwF;AyEl2UlF;;AzEq2UR;EACE,2EAA2E;EAC3E,qGAAqG;AyEv2U/F;;AzE02UR;;EAEE,gEAAgE;EyE52U1D,0FAAA;AzE82UR;;AAEA;EACE,2EAA2E;EyEj3UrE,qGAAA;AzEm3UR;;AAEA;;EyEr3UQ,gEAAA;EAIQ,0FAAA;AzEq3UhB;;AAEA;EyE33UQ,2EAAA;EAIQ,qGAAA;AzE03UhB;;AAEA;;EyE53UgB,gEAAA;EAGJ,0FAAA;AzE63UZ;;AyEp4UQ;EAIQ,4EAAA;EAGJ,sGAAA;AzEk4UZ;;AyEz4UQ;;EAOI,gEAAA;EzEu4UV,0FAA0F;AAC5F;;AAEA;EyE14UY,wEAAA;EzE44UV,kGAAkG;AACpG;;AAEA;;EAEE,gEAAgE;EAChE,0FAA0F;AyEz5UpF;;AzE45UR;EACE,2EAA2E;EAC3E,qGAAqG;AyE95U/F;;AzEi6UR;;EAEE,gEAAgE;EyEn6U1D,0FAAA;AzEq6UR;;AAEA;EACE,0EAA0E;EyEx6UpE,oGAAA;AzE06UR;;AAEA;;EyE56UQ,6DAAA;EAIQ,uFAAA;AzE46UhB;;AAEA;EyEl7UQ,0EAAA;EAIQ,oGAAA;AzEi7UhB;;AAEA;;EyEn7UgB,+DAAA;EAGJ,yFAAA;AzEo7UZ;;AyE37UQ;EAIQ,0EAAA;EAGJ,oGAAA;AzEy7UZ;;AyEh8UQ;;EAOI,8DAAA;EzE87UV,wFAAwF;AAC1F;;AAEA;EyEj8UY,0EAAA;EzEm8UV,oGAAoG;AACtG;;AAEA;;EAEE,gEAAgE;EAChE,0FAA0F;AyEh9UpF;;AzEm9UR;EACE,0EAA0E;EyEp9UpE,oGAAA;AzEs9UR;;AAEA;;EyEj9UY,+DAAA;EzEo9UV,yFAAyF;AAC3F;;AAEA;EACE,0EAA0E;EAC1E,oGAAoG;AyEh+U9F;;AzEm+UR;;EyEn+UQ,6DAAA;EAOI,uFAAA;AzEg+UZ;;AyEv+UQ;EAOI,2EAAA;EzEo+UV,qGAAqG;AACvG;;AAEA;;EAEE,gEAAgE;EyEh/U1D,0FAAA;AzEk/UR;;AAEA;EyEp/UQ,6EAAA;EAOI,uGAAA;AzEg/UZ;;AyEv/UQ;;EzE2/UN,+DAA+D;EAC/D,yFAAyF;AyE5/UnF;;AzE+/UR;EACE,0EAA0E;EyEhgVpE,oGAAA;AzEkgVR;;AAEA;;EyE7gVU,+DAAA;EzEghVR,yFAAyF;AAC3F;;AAEA;EACE,4EAA4E;EAC5E,sGAAsG;AyEthVhG;;AzEyhVR;;EyEzhVQ,gEAAA;EACE,0FAAA;AzE4hVV;;AyE7hVQ;EACE,2EAAA;EzEgiVR,qGAAqG;AACvG;;AAEA;;EAEE,gEAAgE;EyE5hV1D,0FAAA;AzE8hVR;;AAEA;EyEhiVQ,6EAAA;EAOI,uGAAA;AzE4hVZ;;AyEniVQ;;EzEuiVN,gEAAgE;EAChE,0FAA0F;AyExiVpF;;AzE2iVR;EACE,gFAAgF;EyE5iV1E,0GAAA;AzE8iVR;;AAEA;;EyEziVY,gEAAA;EzE4iVV,0FAA0F;AAC5F;;AAEA;EACE,yEAAyE;EACzE,mGAAmG;AyExjV7F;;AzE2jVR;;EyE3jVQ,gEAAA;EAOI,0FAAA;AzEwjVZ;;AyE/jVQ;EAOI,8EAAA;EzE4jVV,wGAAwG;AAC1G;;AAEA;;EAEE,6DAA6D;EyExkVvD,uFAAA;AzE0kVR;;AAEA;EyE5kVQ,8EAAA;EAOI,wGAAA;AzEwkVZ;;AyE/kVQ;;EzEmlVN,gEAAgE;EAChE,0FAA0F;AyEplVpF;;AzEulVR;EACE,2EAA2E;EyExlVrE,qGAAA;AzE0lVR;;AAEA;;EyErlVY,gEAAA;EzEwlVV,0FAA0F;AAC5F;;AAEA;EACE,yEAAyE;EACzE,mGAAmG;AyEpmV7F;;AzEumVR;;EyEvmVQ,gEAAA;EAOI,0FAAA;AzEomVZ;;AyE3mVQ;EAOI,+EAAA;EzEwmVV,yGAAyG;AAC3G;;AAEA;;EAEE,kFAAkF;EyEpnV5E,4GAAA;AzEsnVR;;AAEA;EyExnVQ,UAAA;EAOI,kJAAA;AzEonVZ;;AyE3nVQ;EAOI,oBAAA;EzEwnVV,aAAa;EACb,mBAAmB;EyEhoVb,kFAAA;EAOI,6BAAA;EzE4nVV,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,UAAU;EyExoVJ,WAAA;EAOI,kBAAA;EzEooVV,sCAAsC;AACxC;;AAEA;EACE;IACE,gBAAgB;EyEhpVZ;AzEkpVR;;AAEA;;EyE7oVY,mEAAA;AzEgpVZ;;AyEvpVQ;EAOI,kBAAA;EzEopVV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mCAAmC;EyEhqV7B,WAAA;AzEkqVR;;AAEA;EyEpqVQ,kBAAA;EAOI,MAAA;EzEgqVV,OAAO;EACP,WAAW;EyExqVL,YAAA;AzE0qVR;;AAEA;EyE5qVQ,uBAAA;AzE8qVR;;AAEA;EyEhrVQ,sBAAA;AzEkrVR;;AAEA;EyEprVQ,yBAAA;AzEsrVR;;AAEA;EyExrVQ,iCAAA;AzE0rVR;;AAEA;EyE5rVQ,eAAA;EAOI,MAAA;EzEwrVV,QAAQ;EACR,OAAO;EyEhsVD,aAAA;AzEksVR;;AAEA;EyEpsVQ,eAAA;EAOI,QAAA;EzEgsVV,SAAS;EACT,OAAO;EyExsVD,aAAA;AzE0sVR;;AAEA;EyE5sVQ,gBAAA;EAOI,MAAA;EzEwsVV,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EyEptVH,aAAA;AzEstVR;;AAEA;EyExtVQ;IAOI,gBAAA;IzEotVR,MAAM;IACN,aAAa;EyE5tVT;;EzE+tVN;IACE,gBAAgB;IyEhuVZ,SAAA;IAOI,aAAA;EzE4tVV;AACF;;AAEA;EACE;IACE,gBAAgB;IyExuVZ,MAAA;IAOI,aAAA;EzEouVV;;EyE3uVM;IAOI,gBAAA;IzEwuVR,SAAS;IACT,aAAa;EyEhvVT;AzEkvVR;;AAEA;EyEpvVQ;IAOI,gBAAA;IzEgvVR,MAAM;IACN,aAAa;EyExvVT;;EzE2vVN;IACE,gBAAgB;IyE5vVZ,SAAA;IAOI,aAAA;EzEwvVV;AACF;;AAEA;EACE;IACE,gBAAgB;IyEpwVZ,MAAA;IAOI,aAAA;EzEgwVV;;EyEvwVM;IAOI,gBAAA;IzEowVR,SAAS;IACT,aAAa;EyE5wVT;AzE8wVR;;AAEA;EyEhxVQ;IAOI,gBAAA;IzE4wVR,MAAM;IACN,aAAa;EyEpxVT;;EzEuxVN;IACE,gBAAgB;IyExxVZ,SAAA;IAOI,aAAA;EzEoxVV;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EyEhyVb,mBAAA;EAOI,mBAAA;AzE4xVZ;;AAEA;EyEryVQ,aAAA;EAOI,cAAA;EAAA,sBAAA;EzEkyVV,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;EyE/yVhB,qBAAA;EAOI,uBAAA;EAAA,2BAAA;EzE4yVV,iCAAiC;EACjC,8BAA8B;EyEpzVxB,oBAAA;AzEszVR;;AAEA;;EyExzVQ,6BAAA;AzE2zVR;;AAEA;;EyE7zVQ,2BAAA;AzEg0VR;;AAEA;EACE,kBAAkB;EyEn0VZ,MAAA;EAOI,QAAA;EAAA,SAAA;EzEg0VV,OAAO;EACP,UAAU;EyEx0VJ,WAAA;AzE00VR;;AAEA;EACE,gBAAgB;EyE70VV,uBAAA;EAOI,mBAAA;AzEy0VZ;;AAEA;EyEl1VQ,qBAAA;EAOI,mBAAA;EAAA,6BAAA;EzE+0VV,eAAe;EACf,8BAA8B;EyEv1VxB,aAAA;AzEy1VR;;AAEA;EACE,mCAAmC;AyE51V7B;;AzE+1VR;EACE,8BAA8B;AAChC;;AAEA;EyE51VY,iCAAA;AzE81VZ;;AyEr2VQ;EAOI,iCAAA;AzEk2VZ;;AyEz2VQ;EAOI,sCAAA;AzEs2VZ;;AyE72VQ;EAOI,mCAAA;AzE02VZ;;AyEj3VQ;EAOI,sBAAA;AzE82VZ;;AyEr3VQ;EAOI,uBAAA;AzEk3VZ;;AyEz3VQ;EAOI,sBAAA;AzEs3VZ;;AyE73VQ;EAOI,8BAAA;AzE03VZ;;AyEj4VQ;EAOI,4BAAA;AzE83VZ;;AyEr4VQ;EAOI,2BAAA;AzEk4VZ;;AyEz4VQ;EAOI,iCAAA;AzEs4VZ;;AyE74VQ;EAOI,2BAAA;AzE04VZ;;AyEj5VQ;EAOI,qBAAA;AzE84VZ;;AyEr5VQ;EAOI,wBAAA;AzEk5VZ;;AyEz5VQ;EAOI,uBAAA;AzEs5VZ;;AyE75VQ;EAOI,wBAAA;AzE05VZ;;AyEj6VQ;EAOI,qBAAA;AzE85VZ;;AyEr6VQ;EAOI,yBAAA;AzEk6VZ;;AyEz6VQ;EAOI,2BAAA;AzEs6VZ;;AyE76VQ;EAOI,4BAAA;AzE06VZ;;AyEj7VQ;EAOI,2BAAA;AzE86VZ;;AyEr7VQ;EAOI,2BAAA;AzEk7VZ;;AyEz7VQ;EAOI,6BAAA;AzEs7VZ;;AyE77VQ;EAOI,8BAAA;AzE07VZ;;AyEj8VQ;EAOI,6BAAA;AzE87VZ;;AyEr8VQ;EAOI,2BAAA;AzEk8VZ;;AyEz8VQ;EAOI,6BAAA;AzEs8VZ;;AyE78VQ;EAOI,8BAAA;AzE08VZ;;AyEj9VQ;EAOI,6BAAA;AzE88VZ;;AyEr9VQ;EAOI,0BAAA;AzEk9VZ;;AyEz9VQ;EAOI,gCAAA;AzEs9VZ;;AyE79VQ;EAOI,yBAAA;AzE09VZ;;AyEj+VQ;EAOI,wBAAA;AzE89VZ;;AyEr+VQ;EAOI,+BAAA;AzEk+VZ;;AyEz+VQ;EAOI,yBAAA;AzEs+VZ;;AyE7+VQ;EAOI,6BAAA;AzE0+VZ;;AAEA;EyEn/VQ,8BAAA;AzEq/VR;;AAEA;EACE,wBAAwB;AyEx/VlB;;AzE2/VR;EACE,+BAA+B;AACjC;;AAEA;EyEx/VY,wBAAA;AzE0/VZ;;AyEjgWQ;EAOI,2CAAA;AzE8/VZ;;AAEA;EyEvgWQ,8CAAA;AzEygWR;;AAEA;EACE,8CAA8C;AyE5gWxC;;AzE+gWR;EACE,2BAA2B;AAC7B;;AAEA;EyE5gWY,gFAAA;AzE8gWZ;;AyErhWQ;EAOI,kFAAA;AzEkhWZ;;AAEA;EyE3hWQ,gFAAA;AzE6hWR;;AAEA;EACE,6EAA6E;AyEhiWvE;;AzEmiWR;EACE,gFAAgF;AAClF;;AAEA;EyEhiWY,+EAAA;AzEkiWZ;;AyEziWQ;EAOI,8EAAA;AzEsiWZ;;AyE7iWQ;EAOI,6EAAA;AzE0iWZ;;AyEjjWQ;EAOI,oFAAA;AzE8iWZ;;AyErjWQ;EAOI,uFAAA;AzEkjWZ;;AyEzjWQ;EAOI,uFAAA;AzEsjWZ;;AyE7jWQ;EAOI,mFAAA;AzE0jWZ;;AyEjkWQ;EAOI,mFAAA;AzE8jWZ;;AyErkWQ;EAOI,mFAAA;AzEkkWZ;;AyEzkWQ;EAOI,mFAAA;AzEskWZ;;AyE7kWQ;EAOI,mFAAA;AzE0kWZ;;AyEjlWQ;EAOI,mFAAA;AzE8kWZ;;AyErlWQ;EAOI,mFAAA;AzEklWZ;;AyEzlWQ;EAOI,mFAAA;AzEslWZ;;AyE7lWQ;EAOI,oFAAA;AzE0lWZ;;AyEjmWQ;EAOI,gFAAA;AzE8lWZ;;AyErmWQ;EAOI,mFAAA;AzEkmWZ;;AyEzmWQ;EAOI,kFAAA;AzEsmWZ;;AyE7mWQ;EAOI,kFAAA;AzE0mWZ;;AyEjnWQ;EAOI,kFAAA;AzE8mWZ;;AyErnWQ;EAOI,kFAAA;AzEknWZ;;AyEznWQ;EAOI,kFAAA;AzEsnWZ;;AyE7nWQ;EAOI,kFAAA;AzE0nWZ;;AyEjoWQ;EAOI,mFAAA;AzE8nWZ;;AyEroWQ;EAOI,qFAAA;AzEkoWZ;;AyEzoWQ;EAOI,kFAAA;AzEsoWZ;;AyE7oWQ;EAOI,oFAAA;AzE0oWZ;;AyEjpWQ;EAOI,mFAAA;AzE8oWZ;;AyErpWQ;EAOI,qFAAA;AzEkpWZ;;AyEzpWQ;EAOI,wFAAA;AzEspWZ;;AyE7pWQ;EAOI,iFAAA;AzE0pWZ;;AyEjqWQ;EAOI,sFAAA;AzE8pWZ;;AyErqWQ;EAOI,sFAAA;AzEkqWZ;;AyEzqWQ;EAOI,mFAAA;AzEsqWZ;;AyE7qWQ;EAOI,iFAAA;AzE0qWZ;;AyEjrWQ;EAOI,2BAAA;AzE8qWZ;;AyErrWQ;EAOI,6BAAA;AzEkrWZ;;AyEzrWQ;EAOI,6BAAA;AzEsrWZ;;AyE7rWQ;EAOI,0BAAA;AzE0rWZ;;AyEjsWQ;EAOI,2BAAA;AzE8rWZ;;AyErsWQ;EAOI,iBAAA;AzEksWZ;;AyEzsWQ;EAOI,mBAAA;AzEssWZ;;AyE7sWQ;EAOI,oBAAA;AzE0sWZ;;AyEjtWQ;EAOI,oBAAA;AzE8sWZ;;AyErtWQ;EAOI,sBAAA;AzEktWZ;;AyEztWQ;EAOI,uBAAA;AzEstWZ;;AyE7tWQ;EAOI,kBAAA;AzE0tWZ;;AyEjuWQ;EAOI,oBAAA;AzE8tWZ;;AyEruWQ;EAOI,qBAAA;AzEkuWZ;;AyEzuWQ;EAOI,mBAAA;AzEsuWZ;;AyE7uWQ;EAOI,qBAAA;AzE0uWZ;;AyEjvWQ;EAOI,sBAAA;AzE8uWZ;;AyErvWQ;EAOI,2CAAA;AzEkvWZ;;AyEzvWQ;EAOI,sCAAA;AzEsvWZ;;AyE7vWQ;EAOI,sCAAA;AzE0vWZ;;AyEjwWQ;EAOI,uFAAA;AzE8vWZ;;AyErwWQ;EAOI,oBAAA;AzEkwWZ;;AyEzwWQ;EAOI,2FAAA;AzEswWZ;;AyE7wWQ;EAOI,wBAAA;AzE0wWZ;;AyEjxWQ;EAOI,6FAAA;AzE8wWZ;;AyErxWQ;EAOI,0BAAA;AzEkxWZ;;AyEzxWQ;EAOI,8FAAA;AzEsxWZ;;AyE7xWQ;EAOI,2BAAA;AzE0xWZ;;AyEjyWQ;EAOI,4FAAA;AzE8xWZ;;AyEryWQ;EAOI,yBAAA;AzEkyWZ;;AyEzyWQ;EAOI,sBAAA;EzEsyWV,8EAA8E;AAChF;;AAEA;EACE,sBAAsB;EACtB,gFAAgF;AyElzW1E;;AzEqzWR;EACE,sBAAsB;EyEtzWhB,8EAAA;AzEwzWR;;AAEA;EyE1zWQ,sBAAA;EAOI,2EAAA;AzEszWZ;;AyE7zWQ;EAOI,sBAAA;EzE0zWV,8EAA8E;AAChF;;AAEA;EACE,sBAAsB;EACtB,6EAA6E;AyEt0WvE;;AzEy0WR;EACE,sBAAsB;EyE10WhB,4EAAA;AzE40WR;;AAEA;EyE51WQ,sBAAA;EAcA,2EAAA;AzEi1WR;;AAEA;EACE,sBAAsB;EyE1zWhB,kFAAA;AA1BA;;AzEw1WR;EACE,sBAAsB;EACtB,qFAAqF;AyE11W/E;;AzE61WR;EACE,sBAAsB;EACtB,qFAAqF;AyE/1W/E;;AzEk2WR;EACE,sBAAsB;EACtB,iFAAiF;AyEp2W3E;;AzEu2WR;EACE,sBAAsB;EACtB,iFAAiF;AyEz2W3E;;AzE42WR;EACE,sBAAsB;EACtB,iFAAiF;AyE92W3E;;AzEi3WR;EACE,sBAAsB;EACtB,iFAAiF;AyEn3W3E;;AzEs3WR;EACE,sBAAsB;EACtB,iFAAiF;AyEx3W3E;;AzE23WR;EACE,sBAAsB;EACtB,iFAAiF;AyE73W3E;;AzEg4WR;EACE,sBAAsB;EACtB,iFAAiF;AyEl4W3E;;AzEq4WR;EACE,sBAAsB;EACtB,iFAAiF;AyEv4W3E;;AzE04WR;EACE,sBAAsB;EACtB,kFAAkF;AyE54W5E;;AzE+4WR;EACE,sBAAsB;EACtB,8EAA8E;AyEj5WxE;;AzEo5WR;EACE,sBAAsB;EACtB,iFAAiF;AyEt5W3E;;AzEy5WR;EACE,sBAAsB;EACtB,gFAAgF;AyE35W1E;;AzE85WR;EACE,sBAAsB;EACtB,gFAAgF;AyEh6W1E;;AzEm6WR;EACE,sBAAsB;EACtB,gFAAgF;AyEr6W1E;;AzEw6WR;EACE,sBAAsB;EACtB,gFAAgF;AyE16W1E;;AzE66WR;EACE,sBAAsB;EACtB,gFAAgF;AyE/6W1E;;AzEk7WR;EACE,sBAAsB;EACtB,gFAAgF;AyEp7W1E;;AzEu7WR;EACE,sBAAsB;EACtB,iFAAiF;AyEz7W3E;;AzE47WR;EACE,sBAAsB;EACtB,mFAAmF;AyE97W7E;;AzEi8WR;EACE,sBAAsB;EACtB,gFAAgF;AyEn8W1E;;AzEs8WR;EACE,sBAAsB;EACtB,kFAAkF;AyEx8W5E;;AzE28WR;EACE,sBAAsB;EACtB,iFAAiF;AyE78W3E;;AzEg9WR;EACE,sBAAsB;EACtB,mFAAmF;AyEl9W7E;;AzEq9WR;EACE,sBAAsB;EACtB,sFAAsF;AyEv9WhF;;AzE09WR;EACE,sBAAsB;EACtB,+EAA+E;AyE59WzE;;AzE+9WR;EACE,sBAAsB;EACtB,oFAAoF;AyEj+W9E;;AzEo+WR;EACE,sBAAsB;EACtB,oFAAoF;AyEt+W9E;;AzEy+WR;EACE,sBAAsB;EACtB,iFAAiF;AyE3+W3E;;AzE8+WR;EACE,sBAAsB;EACtB,+EAA+E;AyEh/WzE;;AzEm/WR;EACE,sBAAsB;EACtB,4EAA4E;AyEr/WtE;;AzEw/WR;EACE,sBAAsB;EACtB,4EAA4E;AyE1/WtE;;AzE6/WR;EACE,wDAAwD;AAC1D;;AAEA;EyE1/WY,0DAAA;AzE4/WZ;;AyEngXQ;EAIQ,wDAAA;AzEmgXhB;;AAEA;EyEzgXQ,qDAAA;AzE2gXR;;AAEA;EACE,wDAAwD;AyE9gXlD;;AzEihXR;EACE,uDAAuD;AACzD;;AAEA;EyE9gXY,sDAAA;AzEghXZ;;AyEvhXQ;EAIQ,qDAAA;AzEuhXhB;;AAEA;EyE7hXQ,4BAAA;AzE+hXR;;AAEA;EACE,4BAA4B;AyEliXtB;;AzEqiXR;EACE,4BAA4B;AAC9B;;AAEA;EyEliXY,4BAAA;AzEoiXZ;;AyE3iXQ;EAIQ,4BAAA;AzE2iXhB;;AAEA;EyEjjXQ,wBAAA;AzEmjXR;;AAEA;EACE,yBAAyB;AyEtjXnB;;AzEyjXR;EACE,wBAAwB;AAC1B;;AAEA;EyEtjXY,yBAAA;AzEwjXZ;;AyE/jXQ;EAIQ,sBAAA;AzE+jXhB;;AAEA;EyErkXQ,qBAAA;AzEukXR;;AAEA;EACE,qBAAqB;AyE1kXf;;AzE6kXR;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EyE1rXY,yCAAA;AzE4rXZ;;AyEnsXQ;EAIQ,wCAAA;AzEmsXhB;;AAEA;EyEzsXQ,wCAAA;AzE2sXR;;AAEA;EACE,kCAAkC;AyE9sX5B;;AzEitXR;EACE,gCAAgC;AAClC;;AAEA;EyE9sXY,8BAAA;AzEgtXZ;;AyEvtXQ;EAIQ,gCAAA;AzEutXhB;;AAEA;EyE7tXQ,+BAAA;AzE+tXR;;AAEA;EACE,oCAAoC;AyEluX9B;;AzEquXR;EACE,kCAAkC;AACpC;;AAEA;EyEluXY,gCAAA;AzEouXZ;;AyE3uXQ;EAIQ,uCAAA;AzE2uXhB;;AAEA;EyEjvXQ,sCAAA;AzEmvXR;;AAEA;EACE,iCAAiC;AyEtvX3B;;AzEyvXR;EACE,2BAA2B;AAC7B;;AAEA;EyEtvXY,iCAAA;AzEwvXZ;;AyE/vXQ;EAIQ,+BAAA;AzE+vXhB;;AAEA;EyErwXQ,6BAAA;AzEuwXR;;AAEA;EACE,+BAA+B;AyE1wXzB;;AzE6wXR;EACE,8BAA8B;AAChC;;AAEA;EyE1wXY,oBAAA;AzE4wXZ;;AyEnxXQ;EAIQ,mBAAA;AzEmxXhB;;AAEA;EyEzxXQ,mBAAA;AzE2xXR;;AAEA;EACE,mBAAmB;AyE9xXb;;AzEiyXR;EACE,mBAAmB;AACrB;;AAEA;EyE9xXY,mBAAA;AzEgyXZ;;AyEvyXQ;EAIQ,mBAAA;AzEuyXhB;;AAEA;EyE7yXQ,mBAAA;AzE+yXR;;AAEA;EACE,oBAAoB;AyElzXd;;AzEqzXR;EACE,0BAA0B;AAC5B;;AAEA;EyElzXY,yBAAA;AzEozXZ;;AyE3zXQ;EAIQ,uBAAA;AzE2zXhB;;AAEA;EyEj0XQ,yBAAA;AzEm0XR;;AAEA;EACE,uBAAuB;AyEt0XjB;;AzEy0XR;EACE,uBAAuB;AACzB;;AAEA;EyEt0XY,0BAAA;EzEw0XV,yBAAyB;AAC3B;;AAEA;EyE30XY,gCAAA;EzE60XV,+BAA+B;AACjC;;AAEA;EyEh1XY,+BAAA;EzEk1XV,8BAA8B;AAChC;;AAEA;EyEr1XY,6BAAA;EzEu1XV,4BAA4B;AAC9B;;AAEA;EyE11XY,+BAAA;EzE41XV,8BAA8B;AAChC;;AAEA;EyE/1XY,6BAAA;EzEi2XV,4BAA4B;AAC9B;;AAEA;EyEp2XY,6BAAA;EzEs2XV,4BAA4B;AAC9B;;AAEA;EyEz2XY,wBAAA;EzE22XV,2BAA2B;AAC7B;;AAEA;EyE92XY,8BAAA;EzEg3XV,iCAAiC;AACnC;;AAEA;EyEn3XY,6BAAA;EzEq3XV,gCAAgC;AAClC;;AAEA;EyEx3XY,2BAAA;EzE03XV,8BAA8B;AAChC;;AAEA;EyE73XY,6BAAA;EzE+3XV,gCAAgC;AAClC;;AAEA;EyEl4XY,2BAAA;EzEo4XV,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AyEr5XtB;;AzEw5XV;EACE,wBAAwB;AyE95XlB;;AzEi6XR;EACE,8BAA8B;AyE75XtB;;AzEg6XV;EACE,6BAA6B;AyEt6XvB;;AzEy6XR;EACE,2BAA2B;AyEr6XnB;;AzEw6XV;EACE,6BAA6B;AyE96XvB;;AzEi7XR;EACE,2BAA2B;AyE76XnB;;AzEg7XV;EACE,2BAA2B;AyEt7XrB;;AzEy7XR;EACE,0BAA0B;AyEr7XlB;;AzEw7XV;EACE,gCAAgC;AyE97X1B;;AzEi8XR;EACE,+BAA+B;AyE77XvB;;AzEg8XV;EACE,6BAA6B;AyE57XvB;;AzE+7XR;EACE,+BAA+B;AACjC;;AAEA;EyE57XY,6BAAA;AzE87XZ;;AyEr8XQ;EAIQ,6BAAA;AzEq8XhB;;AAEA;EyE38XQ,2BAAA;AzE68XR;;AAEA;EACE,iCAAiC;AyEh9X3B;;AzEm9XR;EACE,gCAAgC;AAClC;;AAEA;EyEh9XY,8BAAA;AzEk9XZ;;AyEz9XQ;EAIQ,gCAAA;AzEy9XhB;;AAEA;EyE/9XQ,8BAAA;AzEi+XR;;AAEA;EACE,8BAA8B;AyEp+XxB;;AzEu+XR;EACE,yBAAyB;AAC3B;;AAEA;EyEp+XY,+BAAA;AzEs+XZ;;AyE7+XQ;EAIQ,8BAAA;AzE6+XhB;;AAEA;EyEn/XQ,4BAAA;AzEq/XR;;AAEA;EACE,8BAA8B;AyEx/XxB;;AzE2/XR;EACE,4BAA4B;AAC9B;;AAEA;EyEx/XY,4BAAA;AzE0/XZ;;AyEjgYQ;EAIQ,qBAAA;AzEigYhB;;AAEA;EyEvgYQ,2BAAA;AzEygYR;;AAEA;EACE,0BAA0B;AyE5gYpB;;AzE+gYR;EACE,wBAAwB;AAC1B;;AAEA;EyE5gYY,0BAAA;AzE8gYZ;;AyErhYQ;EAIQ,wBAAA;AzEqhYhB;;AAEA;EyE3hYQ,2BAAA;EAIQ,0BAAA;AzE0hYhB;;AAEA;EyEhiYQ,iCAAA;EAIQ,gCAAA;AzE+hYhB;;AAEA;EyEriYQ,gCAAA;EAIQ,+BAAA;AzEoiYhB;;AAEA;EyE1iYQ,8BAAA;EAIQ,6BAAA;AzEyiYhB;;AAEA;EyE/iYQ,gCAAA;EAIQ,+BAAA;AzE8iYhB;;AAEA;EyEpjYQ,8BAAA;EAIQ,6BAAA;AzEmjYhB;;AAEA;EyEzjYQ,yBAAA;EAIQ,4BAAA;AzEwjYhB;;AAEA;EyE9jYQ,+BAAA;EAIQ,kCAAA;AzE6jYhB;;AAEA;EyEnkYQ,8BAAA;EAIQ,iCAAA;AzEkkYhB;;AAEA;EyExkYQ,4BAAA;EAIQ,+BAAA;AzEukYhB;;AAEA;EyE7kYQ,8BAAA;EAIQ,iCAAA;AzE4kYhB;;AAEA;EyEllYQ,4BAAA;EAIQ,+BAAA;AzEilYhB;;AAEA;EyEvlYQ,yBAAA;AzEylYR;;AAEA;EACE,+BAA+B;AyE5lYzB;;AzE+lYR;EACE,8BAA8B;AAChC;;AAEA;EyE5lYY,4BAAA;AzE8lYZ;;AyErmYQ;EAIQ,8BAAA;AzEqmYhB;;AAEA;EyE3mYQ,4BAAA;AzE6mYR;;AAEA;EACE,2BAA2B;AyEhnYrB;;AzEmnYR;EACE,iCAAiC;AACnC;;AAEA;EyEhnYY,gCAAA;AzEknYZ;;AyEznYQ;EAIQ,8BAAA;AzEynYhB;;AAEA;EyE/nYQ,gCAAA;AzEioYR;;AAEA;EACE,8BAA8B;AyEpoYxB;;AzEuoYR;EACE,4BAA4B;AAC9B;;AAEA;EyEpoYY,kCAAA;AzEsoYZ;;AyE7oYQ;EAIQ,iCAAA;AzE6oYhB;;AAEA;EyEnpYQ,+BAAA;AzEqpYR;;AAEA;EACE,iCAAiC;AyExpY3B;;AzE2pYR;EACE,+BAA+B;AACjC;;AAEA;EyExpYY,0BAAA;AzE0pYZ;;AyE3qYQ;EACE,gCAAA;AzE8qYV;;AyE/qYQ;EACE,+BAAA;AzEkrYV;;AyEnrYQ;EACE,6BAAA;AzEsrYV;;AyEvrYQ;EACE,+BAAA;AzE0rYV;;AyE3rYQ;EACE,6BAAA;AzE8rYV;;AyErrYQ;EAOI,iBAAA;AzEkrYZ;;AyEzrYQ;EAOI,uBAAA;AzEsrYZ;;AyE7rYQ;EAOI,sBAAA;AzE0rYZ;;AyEjsYQ;EAOI,oBAAA;AzE8rYZ;;AyErsYQ;EAOI,sBAAA;AzEksYZ;;AyEzsYQ;EAOI,oBAAA;AzEssYZ;;AyE7sYQ;EAOI,qBAAA;AzE0sYZ;;AyEjtYQ;EAOI,2BAAA;AzE8sYZ;;AyErtYQ;EAOI,0BAAA;AzEktYZ;;AyEztYQ;EAOI,wBAAA;AzEstYZ;;AyE7tYQ;EAOI,0BAAA;AzE0tYZ;;AyEjuYQ;EAOI,wBAAA;AzE8tYZ;;AyEruYQ;EAOI,wBAAA;AzEkuYZ;;AyEzuYQ;EAOI,8BAAA;AzEsuYZ;;AyE7uYQ;EAOI,6BAAA;AzE0uYZ;;AyEjvYQ;EAOI,2BAAA;AzE8uYZ;;AyErvYQ;EAOI,6BAAA;AzEkvYZ;;AyEzvYQ;EAOI,2BAAA;AzEsvYZ;;AyE7vYQ;EAOI,gDAAA;AzE0vYZ;;AyEjwYQ;EAOI,6CAAA;AzE8vYZ;;AyErwYQ;EAOI,gDAAA;AzEkwYZ;;AyEzwYQ;EAOI,gDAAA;AzEswYZ;;AyE7wYQ;EAOI,8BAAA;AzE0wYZ;;AyEjxYQ;EAOI,6BAAA;AzE8wYZ;;AAEA;EyEvxYQ,6BAAA;AzEyxYR;;AAEA;EACE,6BAA6B;AyE5xYvB;;AzE+xYR;EACE,6BAA6B;AAC/B;;AAEA;EyE5xYY,+BAAA;AzE8xYZ;;AyEryYQ;EAOI,2BAAA;AzEkyYZ;;AAEA;EyE3yYQ,2BAAA;AzE6yYR;;AAEA;EACE,2BAA2B;AyEhzYrB;;AzEmzYR;EACE,2BAA2B;AAC7B;;AAEA;EyEhzYY,2BAAA;AzEkzYZ;;AyEzzYQ;EAOI,8BAAA;AzEszYZ;;AAEA;EyE/zYQ,yBAAA;AzEi0YR;;AAEA;EACE,4BAA4B;AyEp0YtB;;AzEu0YR;EACE,2BAA2B;AAC7B;;AAEA;EyEp0YY,yBAAA;AzEs0YZ;;AyE70YQ;EAOI,2BAAA;AzE00YZ;;AAEA;EyEn1YQ,4BAAA;AzEq1YR;;AAEA;EACE,6BAA6B;AyEx1YvB;;AzE21YR;EACE,gCAAgC;AAClC;;AAEA;EyEx1YY,qCAAA;AzE01YZ;;AyEj2YQ;EAOI,wCAAA;AzE81YZ;;AAEA;EyEv2YQ,oCAAA;AzEy2YR;;AAEA;EACE,oCAAoC;AyE52Y9B;;AzE+2YR;EACE,qCAAqC;AACvC;;AAEA;EyE52YY,8BAAA;AzE82YZ;;AyEr3YQ;EAOI,8BAAA;AzEk3YZ;;AAEA,qBAAqB;AyE33Yb;EAOI,gCAAA;EAAA,iCAAA;AzEw3YZ;;AyE/3YQ,mBAAA;AzEk4YR;EyE33YY,oBAAA;EzE63YV,qEAAqE;AACvE;;AAEA;EyEh4YY,oBAAA;EzEk4YV,uEAAuE;AACzE;;AAEA;EyEr4YY,oBAAA;EzEu4YV,qEAAqE;AACvE;;AAEA;EyE14YY,oBAAA;EzE44YV,kEAAkE;AACpE;;AAEA;EyE/4YY,oBAAA;EzEi5YV,qEAAqE;AACvE;;AAEA;EyEp5YY,oBAAA;EzEs5YV,oEAAoE;AACtE;;AAEA;EyEz5YY,oBAAA;EzE25YV,mEAAmE;AACrE;;AAEA;EyE95YY,oBAAA;EzEg6YV,kEAAkE;AACpE;;AAEA;EyEn6YY,oBAAA;EzEq6YV,yEAAyE;AAC3E;;AAEA;EyEx6YY,oBAAA;EzE06YV,4EAA4E;AAC9E;;AAEA;EyE76YY,oBAAA;EzE+6YV,4EAA4E;AAC9E;;AAEA;EyEl7YY,oBAAA;EzEo7YV,wEAAwE;AAC1E;;AAEA;EyEv7YY,oBAAA;EzEy7YV,wEAAwE;AAC1E;;AAEA;EyE57YY,oBAAA;EzE87YV,wEAAwE;AAC1E;;AAEA;EACE,oBAAoB;EACpB,wEAAwE;AyE18YlE;;AzE68YR;EACE,oBAAoB;EyE98Yd,wEAAA;AzEg9YR;;AAEA;EyEl9YQ,oBAAA;EAOI,wEAAA;AzE88YZ;;AyEr9YQ;EAOI,oBAAA;EzEk9YV,wEAAwE;AAC1E;;AAEA;EACE,oBAAoB;EACpB,wEAAwE;AyE99YlE;;AzEi+YR;EACE,oBAAoB;Ear+YlB,yEAAA;Abu+YJ;;AAEA;EyEt+YQ,oBAAA;EzEw+YN,qEyEj+YU;AzEk+YZ;;AAEA;EACE,oBAAoB;EyE5+Yd,wEAAA;AzE8+YR;;AAEA;EACE,oByE1+YU;EzE2+YV,uEAAuE;AACzE;;AAEA;EyEr/YQ,oBAAA;EzEu/YN,uEyEh/YU;AzEi/YZ;;AAEA;EACE,oBAAoB;EyE3/Yd,uEAAA;AzE6/YR;;AAEA;EACE,oByEz/YU;EzE0/YV,uEAAuE;AACzE;;AAEA;EyEpgZQ,oBAAA;EzEsgZN,uEyE//YU;AzEggZZ;;AAEA;EACE,oBAAoB;EyE1gZd,uEAAA;AzE4gZR;;AAEA;EACE,oByExgZU;EzEygZV,wEAAwE;AAC1E;;AAEA;EyEnhZQ,oBAAA;EzEqhZN,0EyE9gZU;AzE+gZZ;;AAEA;EACE,oBAAoB;EyEzhZd,uEAAA;AzE2hZR;;AAEA;EACE,oByEvhZU;EzEwhZV,yEAAyE;AAC3E;;AAEA;EyEliZQ,oBAAA;EzEoiZN,wEyE7hZU;AzE8hZZ;;AAEA;EACE,oBAAoB;EyExiZd,0EAAA;AzE0iZR;;AAEA;EACE,oByEtiZU;EzEuiZV,6EAA6E;AAC/E;;AAEA;EyEjjZQ,oBAAA;EzEmjZN,sEyE5iZU;AzE6iZZ;;AAEA;EACE,oBAAoB;EyEvjZd,2EAAA;AzEyjZR;;AAEA;EACE,oByErjZU;EzEsjZV,2EAA2E;AAC7E;;AAEA;EyEhkZQ,oBAAA;EzEkkZN,wEyE3jZU;AzE4jZZ;;AAEA;EACE,oBAAoB;EyEtkZd,sEAAA;AzEwkZR;;AAEA;EACE,oByEpkZU;EzEqkZV,mEAAmE;AACrE;;AAEA;EyE/kZQ,oBAAA;EzEilZN,mEyE1kZU;AzE2kZZ;;AAEA;EACE,oBAAoB;EyErlZd,wEAAA;AzEulZR;;AAEA;EACE,oByEnlZU;EzEolZV,2CAA2C;AAC7C;;AAEA;EyE9lZQ,oBAAA;EzEgmZN,oCyEzlZU;AzE0lZZ;;AAEA;EACE,oBAAoB;EyEpmZd,0CAAA;AzEsmZR;;AAEA;EACE,oByElmZU;EzEmmZV,2CAA2C;AAC7C;;AAEA;EyE7mZQ,oBAAA;EzE+mZN,0CyExmZU;AzEymZZ;;AAEA;EACE,oBAAoB;EyEnnZd,0CAAA;AzEqnZR;;AAEA;EACE,oByEjnZU;EzEknZV,yBAAyB;AAC3B;;AAEA;EyE5nZQ,uBAAA;AzE8nZR;;AAEA;EACE,sByE1nZU;AzE2nZZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EyExoZQ,oBAAA;AzE0oZR;;AAEA;EACE,iDyEtoZU;AzEuoZZ;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EyEppZQ,iDAAA;AzEspZR;;AAEA;EACE,8CyElpZU;AzEmpZZ;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EyEhqZQ,gDAAA;AzEkqZR;;AAEA;EACE,+CyE9pZU;AzE+pZZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EyE5qZQ,sBAAA;AzE8qZR;;AAEA;EACE,sByE1qZU;AzE2qZZ;;AAEA;EACE,uByE9qZU;AzE+qZZ;;AAEA;EACE,uByElrZU;AzEmrZZ;;AAEA;EACE,sByEtrZU;AzEurZZ;;AAEA;EACE,sByE1rZU;AzE2rZZ;;AAEA;EACE,uByE9rZU;AzE+rZZ;;AAEA;EACE,uByElsZU;AzEmsZZ;;AAEA;EACE,oByEtsZU;AzEusZZ;;AAEA;EACE,oByE1sZU;AzE2sZZ;;AAEA;EACE,yCyE9sZU;AzE+sZZ;;AAEA;EACE,yCyEltZU;AzEmtZZ;;AAEA;EACE,wCyEttZU;AzEutZZ;;AAEA;EACE,wCyE1tZU;AzE2tZZ;;AAEA;EACE,yCyE9tZU;AzE+tZZ;;AAEA;EACE,yCyEluZU;AzEmuZZ;;AAEA;EACE,8BAA8B;EyE7uZxB,+FAAA;AzE+uZR;;AAEA;EACE,8ByE3uZU;EzE4uZV,iGAAiG;AACnG;;AAEA;EyEtvZQ,8BAAA;EzEwvZN,+FyEjvZU;AzEkvZZ;;AAEA;EACE,8BAA8B;EyE5vZxB,4FAAA;AzE8vZR;;AAEA;EACE,8ByE1vZU;EzE2vZV,+FAA+F;AACjG;;AAEA;EyErwZQ,8BAAA;EzEuwZN,8FyEhwZU;AzEiwZZ;;AAEA;EACE,8BAA8B;EyE3wZxB,6FAAA;AzE6wZR;;AAEA;EACE,8ByEzwZU;EzE0wZV,4FAA4F;AAC9F;;AAEA;EyEpxZQ,8BAAA;EzEsxZN,mGyE/wZU;AzEgxZZ;;AAEA;EACE,8BAA8B;EyE1xZxB,sGAAA;AzE4xZR;;AAEA;EACE,8ByExxZU;EzEyxZV,sGAAsG;AACxG;;AAEA;EyEnyZQ,8BAAA;EzEqyZN,kGyE9xZU;AzE+xZZ;;AAEA;EACE,8BAA8B;EyEzyZxB,kGAAA;AzE2yZR;;AAEA;EACE,8ByEvyZU;EzEwyZV,kGAAkG;AACpG;;AAEA;EyElzZQ,8BAAA;EzEozZN,kGyE7yZU;AzE8yZZ;;AAEA;EACE,8BAA8B;EyExzZxB,kGAAA;AzE0zZR;;AAEA;EACE,8ByEtzZU;EzEuzZV,kGAAkG;AACpG;;AAEA;EyEj0ZQ,8BAAA;EzEm0ZN,kGyE5zZU;AzE6zZZ;;AAEA;EACE,8BAA8B;EyEv0ZxB,kGAAA;AzEy0ZR;;AAEA;EACE,8ByEr0ZU;EzEs0ZV,mGAAmG;AACrG;;AAEA;EyEh1ZQ,8BAAA;EzEk1ZN,+FyE30ZU;AzE40ZZ;;AAEA;EACE,8ByE/0ZU;EzEg1ZV,kGyEh1ZU;AzEi1ZZ;;AAEA;EACE,8ByEp1ZU;EzEq1ZV,iGAAiG;AACnG;;AAEA;EACE,8BAA8B;EyEh2ZxB,iGAAA;AzEk2ZR;;AAEA;EyEp2ZQ,8BAAA;EzEs2ZN,iGyE/1ZU;AzEg2ZZ;;AAEA;EACE,8ByEn2ZU;EzEo2ZV,iGyEp2ZU;AzEq2ZZ;;AAEA;EACE,8ByEx2ZU;EzEy2ZV,iGAAiG;AACnG;;AAEA;EACE,8BAA8B;EyEp3ZxB,iGAAA;AzEs3ZR;;AAEA;EyEx3ZQ,8BAAA;EzE03ZN,kGyEn3ZU;AzEo3ZZ;;AAEA;EACE,8ByEv3ZU;EzEw3ZV,oGyEx3ZU;AzEy3ZZ;;AAEA;EACE,8BAA8B;EyEn4ZxB,iGAAA;AzEq4ZR;;AAEA;EACE,8ByEj4ZU;EzEk4ZV,mGAAmG;AACrG;;AAEA;EyE54ZQ,8BAAA;EzE84ZN,kGyEv4ZU;AzEw4ZZ;;AAEA;EACE,8BAA8B;EyEl5ZxB,oGAAA;AzEo5ZR;;AAEA;EACE,8ByEh5ZU;EzEi5ZV,uGAAuG;AACzG;;AAEA;EyE35ZQ,8BAAA;EzE65ZN,gGyEt5ZU;AzEu5ZZ;;AAEA;EACE,8BAA8B;EyEj6ZxB,qGAAA;AzEm6ZR;;AAEA;EACE,8ByE/5ZU;EzEg6ZV,qGAAqG;AACvG;;AAEA;EyE16ZQ,8BAAA;EzE46ZN,kGyEr6ZU;AzEs6ZZ;;AAEA;EACE,8BAA8B;EyEh7ZxB,gGAAA;AzEk7ZR;;AAEA;EACE,8ByE96ZU;EzE+6ZV,qGAAqG;AACvG;;AAEA;EyEz7ZQ,8BAAA;AzE27ZR;;AAEA;EACE,8ByEv7ZU;AzEw7ZZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EyEr8ZQ,gCAAA;AzEu8ZR;;AAEA;EACE,iCyEn8ZU;AzEo8ZZ;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EyEj9ZQ,gCAAA;AzEm9ZR;;AAEA;EACE,gCyE/8ZU;AzEg9ZZ;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EyE79ZQ,iCAAA;AzE+9ZR;;AAEA;EACE,8ByE39ZU;AzE49ZZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EyEz+ZQ,kBAAA;EzE2+ZN,8EyEp+ZU;AzEq+ZZ;;AAEA;EACE,kBAAkB;EyE/+ZZ,gFAAA;AzEi/ZR;;AAEA;EACE,kByE7+ZU;EzE8+ZV,8EAA8E;AAChF;;AAEA;EyEx/ZQ,kBAAA;EzE0/ZN,2EyEn/ZU;AzEo/ZZ;;AAEA;EACE,kBAAkB;EyE9/ZZ,8EAAA;AzEggaR;;AAEA;EACE,kByE5/ZU;EzE6/ZV,6EAA6E;AAC/E;;AAEA;EACE,kBAAkB;Ea3gahB,4EAAA;Ab6gaJ;;AAEA;EyE5gaQ,kBAAA;EzE8gaN,2EyEvgaU;AzEwgaZ;;AAEA;EACE,kBAAkB;EyElhaZ,kFAAA;AzEohaR;;AAEA;EACE,kByEhhaU;EzEihaV,qFAAqF;AACvF;;AAEA;EyE3haQ,kBAAA;EzE6haN,qFyEthaU;AzEuhaZ;;AAEA;EACE,kBAAkB;EyEjiaZ,iFAAA;AzEmiaR;;AAEA;EACE,kByE/haU;EzEgiaV,iFAAiF;AACnF;;AAEA;EyE1iaQ,kBAAA;EzE4iaN,iFyEriaU;AzEsiaZ;;AAEA;EACE,kBAAkB;EyEhjaZ,iFAAA;AzEkjaR;;AAEA;EACE,kByE9iaU;EzE+iaV,iFAAiF;AACnF;;AAEA;EyEzjaQ,kBAAA;EzE2jaN,iFyEpjaU;AzEqjaZ;;AAEA;EACE,kBAAkB;EyE/jaZ,iFAAA;AzEikaR;;AAEA;EACE,kByE7jaU;EzE8jaV,iFAAiF;AACnF;;AAEA;EyExkaQ,kBAAA;EzE0kaN,kFyEnkaU;AzEokaZ;;AAEA;EACE,kBAAkB;EyE9kaZ,8EAAA;AzEglaR;;AAEA;EACE,kByE5kaU;EzE6kaV,iFAAiF;AACnF;;AAEA;EyEvlaQ,kBAAA;EzEylaN,gFyEllaU;AzEmlaZ;;AAEA;EACE,kBAAkB;EyE7laZ,gFAAA;AzE+laR;;AAEA;EACE,kByE3laU;EzE4laV,gFAAgF;AAClF;;AAEA;EyEtmaQ,kBAAA;EzEwmaN,gFyEjmaU;AzEkmaZ;;AAEA;EACE,kBAAkB;EyE5maZ,gFAAA;AzE8maR;;AAEA;EACE,kByE1maU;EzE2maV,gFAAgF;AAClF;;AAEA;EyErnaQ,kBAAA;EzEunaN,iFyEhnaU;AzEinaZ;;AAEA;EACE,kBAAkB;EyE3naZ,mFAAA;AzE6naR;;AAEA;EACE,kByEznaU;EzE0naV,gFAAgF;AAClF;;AAEA;EyEpoaQ,kBAAA;EzEsoaN,kFyE/naU;AzEgoaZ;;AAEA;EACE,kBAAkB;EyE1oaZ,iFAAA;AzE4oaR;;AAEA;EACE,kByExoaU;EzEyoaV,mFAAmF;AACrF;;AAEA;EyEnpaQ,kBAAA;EzEqpaN,sFyE9oaU;AzE+oaZ;;AAEA;EACE,kBAAkB;EyEzpaZ,+EAAA;AzE2paR;;AAEA;EACE,kByEvpaU;EzEwpaV,oFAAoF;AACtF;;AAEA;EyElqaQ,kBAAA;EzEoqaN,oFyE7paU;AzE8paZ;;AAEA;EACE,kBAAkB;EyExqaZ,iFAAA;AzE0qaR;;AAEA;EACE,kByEtqaU;EzEuqaV,+EAA+E;AACjF;;AAEA;EyEjraQ,kBAAA;EzEmraN,4EyE5qaU;AzE6qaZ;;AAEA;EACE,kBAAkB;EyEvraZ,4EAAA;AzEyraR;;AAEA;EACE,kByErraU;EzEsraV,8EAA8E;AAChF;;AAEA;EyEhsaQ,kBAAA;EzEksaN,wCyE3raU;AzE4raZ;;AAEA;EACE,kBAAkB;EyEtsaZ,mFAAA;AzEwsaR;;AAEA;EACE,kByEpsaU;EzEqsaV,kFAAkF;AACpF;;AAEA;EyE/saQ,oBAAA;AzEitaR;;AAEA;EACE,qByE7saU;AzE8saZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,oCAA4B;UAA5B,4BAA4B;AAC9B;;AAEA;EACE,oCAA4B;UAA5B,4BAA4B;AAC9B;;AAEA;EyEnxaQ,+BAAA;AzEqxaR;;AAEA;EACE,+ByEjxaU;AzEkxaZ;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EyE/xaQ,2BAAA;AzEiyaR;;AAEA;EACE,oDyE7xaU;AzE8xaZ;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EyE3yaQ,oDAAA;AzE6yaR;;AAEA;EACE,oDyEzyaU;AzE0yaZ;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EyEvzaQ,6BAAA;AzEyzaR;;AAEA;EACE,sDyErzaU;AzEszaZ;;AAEA;EACE,0DAA0D;EyEh0apD,2DAAA;AzEk0aR;;AAEA;EACE,oCyE9zaU;EzE+zaV,qCAAqC;AACvC;;AAEA;EyEz0aQ,6DAAA;EzE20aN,8DyEp0aU;AzEq0aZ;;AAEA;EACE,0DAA0D;EyE/0apD,2DAAA;AzEi1aR;;AAEA;EACE,6DyE70aU;EzE80aV,8DAA8D;AAChE;;AAEA;EyEx1aQ,6DAAA;EzE01aN,8DyEn1aU;AzEo1aZ;;AAEA;EACE,8DAA8D;EyE91axD,+DAAA;AzEg2aR;;AAEA;EACE,sCyE51aU;EzE61aV,uCAAuC;AACzC;;AAEA;EyEv2aQ,+DAAA;EzEy2aN,gEyEl2aU;AzEm2aZ;;AAEA;EACE,2DAA2D;EyE72arD,8DAAA;AzE+2aR;;AAEA;EACE,qCyE32aU;EzE42aV,wCAAwC;AAC1C;;AAEA;EyEt3aQ,8DAAA;EzEw3aN,iEyEj3aU;AzEk3aZ;;AAEA;EACE,2DyEr3aU;EzEs3aV,8DyEt3aU;AzEu3aZ;;AAEA;EACE,8DyE13aU;EzE23aV,iEAAiE;AACnE;;AAEA;EACE,8DAA8D;EyEt4axD,iEAAA;AzEw4aR;;AAEA;EyE14aQ,+DAAA;EzE44aN,kEyEr4aU;AzEs4aZ;;AAEA;EACE,uCyEz4aU;EzE04aV,0CyE14aU;AzE24aZ;;AAEA;EACE,gEyE94aU;EzE+4aV,mEAAmE;AACrE;;AAEA;EACE,8DAA8D;EyE15axD,6DAAA;AzE45aR;;AAEA;EyE95aQ,wCAAA;EzEg6aN,uCyEz5aU;AzE05aZ;;AAEA;EACE,iEyE75aU;EzE85aV,gEyE95aU;AzE+5aZ;;AAEA;EACE,8DAA8D;EyEz6axD,6DAAA;AzE26aR;;AAEA;EACE,iEyEv6aU;EzEw6aV,gEAAgE;AAClE;;AAEA;EyEl7aQ,iEAAA;EzEo7aN,gEyE76aU;AzE86aZ;;AAEA;EACE,kEAAkE;EyEx7a5D,iEAAA;AzE07aR;;AAEA;EACE,0CyEt7aU;EzEu7aV,yCAAyC;AAC3C;;AAEA;EyEj8aQ,mEAAA;EzEm8aN,kEyE57aU;AzE67aZ;;AAEA;EACE,6DAA6D;EyEv8avD,0DAAA;AzEy8aR;;AAEA;EACE,uCyEr8aU;EzEs8aV,oCAAoC;AACtC;;AAEA;EyEh9aQ,gEAAA;EzEk9aN,6DyE38aU;AzE48aZ;;AAEA;EACE,6DAA6D;EyEt9avD,0DAAA;AzEw9aR;;AAEA;EACE,gEyEp9aU;EzEq9aV,6DAA6D;AAC/D;;AAEA;EyE/9aQ,gEAAA;EzEi+aN,6DyE19aU;AzE29aZ;;AAEA;EACE,iEAAiE;EyEr+a3D,8DAAA;AzEu+aR;;AAEA;EACE,yCyEn+aU;EzEo+aV,sCAAsC;AACxC;;AAEA;EyE9+aQ,kEAAA;EzEg/aN,+DyEz+aU;AzE0+aZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EyEv/aQ,6BAAA;AzEy/aR;;AAEA;EACE,sByEr/aU;AzEs/aZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EyEngbQ,qBAAA;AzEqgbR;;AAEA;EACE,qByEjgbU;AzEkgbZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EyE/gbQ;IAOI,sBAAA;EzE2gbV;;EAEA;IACE,uBAAuB;EyErhbnB;;EzEwhbN;IyExhbM,sBAAA;EzE0hbN;;EyE1hbM;IAOI,8BAAA;EzEuhbV;;EAEA;IACE,4BAA4B;EyEjibxB;;EzEoibN;IyEpibM,2BAAA;EzEsibN;;EyEtibM;IAOI,iCAAA;EzEmibV;;EAEA;IACE,2BAA2B;EAC7B;;EyE9ibM;IAOI,0BAAA;EzE2ibV;;EAEA;IACE,gCAAgC;EyErjb5B;;EzEwjbN;IyExjbM,yBAAA;EzE0jbN;;EyE1jbM;IAOI,wBAAA;EzEujbV;;EAEA;IACE,+BAA+B;EyEjkb3B;;EzEokbN;IyEpkbM,yBAAA;EzEskbN;;EyEtkbM;IAOI,6BAAA;EzEmkbV;;EAEA;IACE,8BAA8B;EyE7kb1B;;EzEglbN;IyEhlbM,wBAAA;EzEklbN;;EyEllbM;IAOI,+BAAA;EzE+kbV;;EAEA;IACE,wBAAwB;EyEzlbpB;;EzE4lbN;IyE5lbM,yBAAA;EzE8lbN;;EyE9lbM;IAOI,8BAAA;EzE2lbV;;EAEA;IACE,iCAAiC;EyErmb7B;;EzEwmbN;IyExmbM,sCAAA;EzE0mbN;;EyE1mbM;IAOI,yCAAA;EzEumbV;;EAEA;IACE,uBAAuB;EyEjnbnB;;EzEonbN;IyEpnbM,uBAAA;EzEsnbN;;EyEtnbM;IAOI,yBAAA;EzEmnbV;;EAEA;IACE,yBAAyB;EyE7nbrB;;EzEgobN;IyEhobM,0BAAA;EzEkobN;;EyElobM;IAOI,4BAAA;EzE+nbV;;EAEA;IACE,kCAAkC;EyEzob9B;;EzE4obN;IyE5obM,sCAAA;EzE8obN;;EyE9obM;IAOI,oCAAA;EzE2obV;;EAEA;IACE,kCAAkC;EyErpb9B;;EzEwpbN;IyExpbM,yCAAA;EzE0pbN;;EyE1pbM;IAOI,wCAAA;EzEupbV;;EAEA;IACE,wCAAwC;EyEjqbpC;;EzEoqbN;IyEpqbM,kCAAA;EzEsqbN;;EyEtqbM;IAOI,gCAAA;EzEmqbV;;EAEA;IACE,8BAA8B;EyE7qb1B;;EzEgrbN;IyEhrbM,gCAAA;EzEkrbN;;EyElrbM;IAOI,+BAAA;EzE+qbV;;EAEA;IACE,oCAAoC;EyEzrbhC;;EzE4rbN;IyE5rbM,kCAAA;EzE8rbN;;EyE9rbM;IAOI,gCAAA;EzE2rbV;;EAEA;IACE,uCAAuC;EyErsbnC;;EzEwsbN;IyExsbM,sCAAA;EzE0sbN;;EyE1sbM;IAOI,iCAAA;EzEusbV;;EAEA;IACE,2BAA2B;EyEjtbvB;;EzEotbN;IyEptbM,iCAAA;EzEstbN;;EyEttbM;IAOI,+BAAA;EzEmtbV;;EAEA;IACE,6BAA6B;EyE7tbzB;;EzEgubN;IyEhubM,+BAAA;EzEkubN;;EyElubM;IAOI,8BAAA;EzE+tbV;;EAEA;IACE,oBAAoB;EyEzubhB;;EzE4ubN;IyE5ubM,mBAAA;EzE8ubN;;EyE9ubM;IAOI,mBAAA;EzE2ubV;;EAEA;IACE,mBAAmB;EyErvbf;;EzEwvbN;IyExvbM,mBAAA;EzE0vbN;;EyE1vbM;IAOI,mBAAA;EzEuvbV;;EAEA;IyEzvbU,mBAAA;EzE2vbV;;EAEA;IyE7vbU,mBAAA;EzE+vbV;;EAEA;IyEjwbU,oBAAA;EzEmwbV;;EAEA;IyErwbU,0BAAA;EzEuwbV;;EAEA;IyEzwbU,yBAAA;EzE2wbV;;EAEA;IyE7wbU,uBAAA;EzE+wbV;;EAEA;IyEjxbU,yBAAA;EzEmxbV;;EAEA;IyErxbU,uBAAA;EzEuxbV;;EAEA;IyEzxbU,uBAAA;EzE2xbV;;EAEA;IyE7xbU,0BAAA;IzE+xbR,yBAAyB;EyEtybrB;;EzEyybN;IACE,gCAAgC;IyE1yb5B,+BAAA;EzE4ybN;;EAEA;IyE9ybM,+BAAA;IAOI,8BAAA;EzE0ybV;;EyEjzbM;IAOI,6BAAA;IAAA,4BAAA;EzE+ybV;;EAEA;IACE,+BAA+B;IyEzzb3B,8BAAA;EzE2zbN;;EyE3zbM;IAOI,6BAAA;IzEwzbR,4BAA4B;EyE/zbxB;;EzEk0bN;IyEl0bM,6BAAA;IAOI,4BAAA;EzE8zbV;;EAEA;IACE,wBAAwB;IyEx0bpB,2BAAA;EzE00bN;;EyE10bM;IAOI,8BAAA;IzEu0bR,iCAAiC;EyE90b7B;;EzEi1bN;IyEj1bM,6BAAA;IAOI,gCAAA;EzE60bV;;EAEA;IACE,2BAA2B;IyEv1bvB,8BAAA;EzEy1bN;;EyEz1bM;IAOI,6BAAA;IzEs1bR,gCAAgC;EyE71b5B;;EzEg2bN;IyEh2bM,2BAAA;IAOI,8BAAA;EzE41bV;;EAEA;IACE,2BAA2B;IyEt2bvB,8BAAA;EzEw2bN;;EyEx2bM;IAOI,wBAAA;EzEq2bV;;EAEA;IACE,8BAA8B;EyE/2b1B;;EzEk3bN;IyEl3bM,6BAAA;EzEo3bN;;EyEp3bM;IAOI,2BAAA;EzEi3bV;;EAEA;IACE,6BAA6B;EyE33bzB;;EzE83bN;IyE93bM,2BAAA;EzEg4bN;;EyEh4bM;IAOI,2BAAA;EzE63bV;;EAEA;IACE,0BAA0B;EyEv4btB;;EzE04bN;IyE14bM,gCAAA;EzE44bN;;EyE54bM;IAOI,+BAAA;EzEy4bV;;EAEA;IACE,6BAA6B;EyEn5bzB;;EzEs5bN;IyEt5bM,+BAAA;EzEw5bN;;EyEx5bM;IAOI,6BAAA;EzEq5bV;;EAEA;IyEv5bU,6BAAA;EzEy5bV;;EAEA;IyE35bU,2BAAA;EzE65bV;;EAEA;IyE/5bU,iCAAA;EzEi6bV;;EAEA;IyEn6bU,gCAAA;EzEq6bV;;EAEA;IyEv6bU,8BAAA;EzEy6bV;;EAEA;IyE36bU,gCAAA;EzE66bV;;EAEA;IyE/6bU,8BAAA;EzEi7bV;;EAEA;IyEn7bU,8BAAA;EzEq7bV;;EAEA;IyEv7bU,yBAAA;EzEy7bV;;EAEA;IyE37bU,+BAAA;EzE67bV;;EAEA;IyE/7bU,8BAAA;EzEi8bV;;EAEA;IyEn8bU,4BAAA;EzEq8bV;;EAEA;IACE,8BAA8B;EyE/8b1B;;EzEk9bN;IyEl9bM,4BAAA;EzEo9bN;;EyEp9bM;IAOI,4BAAA;EzEi9bV;;EAEA;IACE,qBAAqB;EyE39bjB;;EzE89bN;IyE99bM,2BAAA;EzEg+bN;;EyEh+bM;IAOI,0BAAA;EzE69bV;;EAEA;IACE,wBAAwB;EyEv+bpB;;EzE0+bN;IyE1+bM,0BAAA;EzE4+bN;;EyE5+bM;IAOI,wBAAA;EzEy+bV;;EAEA;IACE,2BAA2B;IyEn/bvB,0BAAA;EzEq/bN;;EyEr/bM;IAOI,iCAAA;IzEk/bR,gCAAgC;EyEz/b5B;;EzE4/bN;IyE5/bM,gCAAA;IAOI,+BAAA;EzEw/bV;;EAEA;IACE,8BAA8B;IyElgc1B,6BAAA;EzEogcN;;EyEpgcM;IAOI,gCAAA;IzEigcR,+BAA+B;EyExgc3B;;EzE2gcN;IyE3gcM,8BAAA;IAOI,6BAAA;EzEugcV;;EAEA;IACE,yBAAyB;IyEjhcrB,4BAAA;EzEmhcN;;EyEnhcM;IAOI,+BAAA;IzEghcR,kCAAkC;EyEvhc9B;;EzE0hcN;IyE1hcM,8BAAA;IAOI,iCAAA;EzEshcV;;EAEA;IACE,4BAA4B;IyEhicxB,+BAAA;EzEkicN;;EyElicM;IAOI,8BAAA;IzE+hcR,iCAAiC;EyEtic7B;;EzEyicN;IyEzicM,4BAAA;IAOI,+BAAA;EzEqicV;;EAEA;IACE,yBAAyB;EyE/icrB;;EzEkjcN;IyEljcM,+BAAA;EzEojcN;;EyEpjcM;IAOI,8BAAA;EzEijcV;;EAEA;IACE,4BAA4B;EyE3jcxB;;EzE8jcN;IyE9jcM,8BAAA;EzEgkcN;;EyEhkcM;IAOI,4BAAA;EzE6jcV;;EAEA;IACE,2BAA2B;EyEvkcvB;;EzE0kcN;IyE1kcM,iCAAA;EzE4kcN;;EyE5kcM;IAOI,gCAAA;EzEykcV;;EAEA;IACE,8BAA8B;EAChC;;EyEplcM;IAOI,gCAAA;EzEilcV;;EAEA;IACE,8BAA8B;EyE3lc1B;;EzE8lcN;IyE9lcM,4BAAA;EzEgmcN;;EyEhmcM;IAOI,kCAAA;EzE6lcV;;EAEA;IACE,iCAAiC;EyEvmc7B;;EzE0mcN;IyE1mcM,+BAAA;EzE4mcN;;EyE5mcM;IAOI,iCAAA;EzEymcV;;EAEA;IACE,+BAA+B;EyEnnc3B;;EzEsncN;IyEtncM,0BAAA;EzEwncN;;EyExncM;IAOI,gCAAA;EzEqncV;;EAEA;IACE,+BAA+B;EyE/nc3B;;EzEkocN;IyElocM,6BAAA;EzEoocN;;EyEpocM;IAOI,+BAAA;EzEiocV;;EAEA;IACE,6BAA6B;EyE3oczB;;EzE8ocN;IyE9ocM,iBAAA;EzEgpcN;;EyEhpcM;IAOI,uBAAA;EzE6ocV;;EAEA;IACE,sBAAsB;EyEvpclB;;EzE0pcN;IyE1pcM,oBAAA;EzE4pcN;;EyE5pcM;IAOI,sBAAA;EzEypcV;;EAEA;IACE,oBAAoB;EyEnqchB;;EzEsqcN;IyEtqcM,qBAAA;EzEwqcN;;EyExqcM;IAOI,2BAAA;EzEqqcV;;EAEA;IACE,0BAA0B;EyE/qctB;;EzEkrcN;IyElrcM,wBAAA;EzEorcN;;EyEprcM;IAOI,0BAAA;EzEircV;;EAEA;IACE,wBAAwB;EyE3rcpB;;EzE8rcN;IyE9rcM,wBAAA;EzEgscN;;EyEhscM;IAOI,8BAAA;EzE6rcV;;EAEA;IACE,6BAA6B;EyEvsczB;;EzE0scN;IyE1scM,2BAAA;EzE4scN;;EyE5scM;IAOI,6BAAA;EzEyscV;;EAEA;IACE,2BAA2B;EyEntcvB;;EzEstcN;IyEttcM,2BAAA;EzEwtcN;;EyExtcM;IAOI,4BAAA;EzEqtcV;;EAEA;IACE,6BAA6B;EyE/tczB;AzEiucR;;AAEA;EACE;IACE,sBAAsB;EyEruclB;;EzEwucN;IyExucM,uBAAA;EzE0ucN;;EyE1ucM;IAOI,sBAAA;EzEuucV;;EAEA;IACE,8BAA8B;EyEjvc1B;;EzEovcN;IyEpvcM,4BAAA;EzEsvcN;;EyEtvcM;IAOI,2BAAA;EzEmvcV;;EAEA;IACE,iCAAiC;EyE7vc7B;;EzEgwcN;IyEhwcM,2BAAA;EzEkwcN;;EyElwcM;IAOI,0BAAA;EzE+vcV;;EAEA;IACE,gCAAgC;EyEzwc5B;;EzE4wcN;IyE5wcM,yBAAA;EzE8wcN;;EyE9wcM;IAOI,wBAAA;EzE2wcV;;EAEA;IACE,+BAA+B;EyErxc3B;;EzEwxcN;IyExxcM,yBAAA;EzE0xcN;;EyE1xcM;IAOI,6BAAA;EzEuxcV;;EAEA;IACE,8BAA8B;EyEjyc1B;;EzEoycN;IyEpycM,wBAAA;EzEsycN;;EAEA;IyExycM,+BAAA;EzE0ycN;;EAEA;IyE5ycM,wBAAA;EzE8ycN;;EAEA;IyEhzcM,yBAAA;EzEkzcN;;EAEA;IyEpzcM,8BAAA;EzEszcN;;EAEA;IyExzcM,iCAAA;EzE0zcN;;EAEA;IyE5zcM,sCAAA;EzE8zcN;;EAEA;IyEh0cM,yCAAA;EzEk0cN;;EAEA;IyEp0cM,uBAAA;EzEs0cN;;EAEA;IyEx0cM,uBAAA;EzE00cN;;EAEA;IyE50cM,yBAAA;EzE80cN;;EAEA;IyEh1cM,yBAAA;EzEk1cN;;EAEA;IyEp1cM,0BAAA;EzEs1cN;;EAEA;IyEx1cM,4BAAA;EzE01cN;;EAEA;IyE51cM,kCAAA;EzE81cN;;EyE91cM;IAOI,sCAAA;EzE21cV;;EAEA;IACE,oCAAoC;EyEr2chC;;EzEw2cN;IyEx2cM,kCAAA;EzE02cN;;EyE12cM;IAOI,yCAAA;EzEu2cV;;EAEA;IACE,wCAAwC;EyEj3cpC;;EzEo3cN;IyEp3cM,wCAAA;EzEs3cN;;EyEt3cM;IAOI,kCAAA;EzEm3cV;;EAEA;IACE,gCAAgC;EyE73c5B;;EzEg4cN;IyEh4cM,8BAAA;EzEk4cN;;EyEl4cM;IAOI,gCAAA;EzE+3cV;;EAEA;IACE,+BAA+B;EyEz4c3B;;EzE44cN;IyE54cM,oCAAA;EzE84cN;;EyE94cM;IAOI,kCAAA;EzE24cV;;EAEA;IACE,gCAAgC;EyEr5c5B;;EzEw5cN;IyEx5cM,uCAAA;EzE05cN;;EyE15cM;IAOI,sCAAA;EzEu5cV;;EAEA;IACE,iCAAiC;EyEj6c7B;;EzEo6cN;IyEp6cM,2BAAA;EzEs6cN;;EyEt6cM;IAOI,iCAAA;EzEm6cV;;EAEA;IACE,+BAA+B;EyE76c3B;;EzEg7cN;IyEh7cM,6BAAA;EzEk7cN;;EyEl7cM;IAOI,+BAAA;EzE+6cV;;EAEA;IACE,8BAA8B;EyEz7c1B;;EzE47cN;IyE57cM,oBAAA;EzE87cN;;EyE97cM;IAOI,mBAAA;EzE27cV;;EAEA;IyE77cU,mBAAA;EzE+7cV;;EAEA;IyEj8cU,mBAAA;EzEm8cV;;EAEA;IyEr8cU,mBAAA;EzEu8cV;;EAEA;IyEz8cU,mBAAA;EzE28cV;;EAEA;IyE78cU,mBAAA;EzE+8cV;;EAEA;IyEj9cU,mBAAA;EzEm9cV;;EAEA;IyEr9cU,oBAAA;EzEu9cV;;EAEA;IyEz9cU,0BAAA;EzE29cV;;EAEA;IyE79cU,yBAAA;EzE+9cV;;EAEA;IyEj+cU,uBAAA;EzEm+cV;;EAEA;IyEr+cU,yBAAA;EzEu+cV;;EAEA;IyEz+cU,uBAAA;EzE2+cV;;EAEA;IACE,uBAAuB;EyEr/cnB;;EzEw/cN;IyEx/cM,0BAAA;IAOI,yBAAA;EzEo/cV;;EAEA;IACE,gCAAgC;IyE9/c5B,+BAAA;EzEggdN;;EyEhgdM;IAOI,+BAAA;IzE6/cR,8BAA8B;EyEpgd1B;;EzEugdN;IyEvgdM,6BAAA;IAOI,4BAAA;EzEmgdV;;EAEA;IACE,+BAA+B;IyE7gd3B,8BAAA;EzE+gdN;;EyE/gdM;IAOI,6BAAA;IzE4gdR,4BAA4B;EyEnhdxB;;EzEshdN;IyEthdM,6BAAA;IAOI,4BAAA;EzEkhdV;;EAEA;IACE,wBAAwB;IyE5hdpB,2BAAA;EzE8hdN;;EyE9hdM;IAOI,8BAAA;IzE2hdR,iCAAiC;EyElid7B;;EzEqidN;IyEridM,6BAAA;IAOI,gCAAA;EzEiidV;;EAEA;IACE,2BAA2B;IyE3idvB,8BAAA;EzE6idN;;EyE7idM;IAOI,6BAAA;IzE0idR,gCAAgC;EyEjjd5B;;EzEojdN;IyEpjdM,2BAAA;IAOI,8BAAA;EzEgjdV;;EAEA;IACE,2BAA2B;IyE1jdvB,8BAAA;EzE4jdN;;EyE5jdM;IAOI,wBAAA;EzEyjdV;;EAEA;IACE,8BAA8B;EyEnkd1B;;EzEskdN;IyEtkdM,6BAAA;EzEwkdN;;EyExkdM;IAOI,2BAAA;EzEqkdV;;EAEA;IACE,6BAA6B;EyE/kdzB;;EzEkldN;IyElldM,2BAAA;EzEoldN;;EyEpldM;IAOI,2BAAA;EzEildV;;EAEA;IACE,0BAA0B;EyE3ldtB;;EzE8ldN;IyE9ldM,gCAAA;EzEgmdN;;EyEhmdM;IAOI,+BAAA;EzE6ldV;;EAEA;IACE,6BAA6B;EyEvmdzB;;EzE0mdN;IyE1mdM,+BAAA;EzE4mdN;;EyE5mdM;IAOI,6BAAA;EzEymdV;;EAEA;IACE,6BAA6B;EyEnndzB;;EzEsndN;IyEtndM,2BAAA;EzEwndN;;EAEA;Ia7ndE,iCAAA;E4DGI;;EzE8ndN;IyE9ndM,gCAAA;EzEgodN;;EyEhodM;IAOI,8BAAA;EzE6ndV;;EAEA;IACE,gCAAgC;EyEvod5B;;EzE0odN;IyE1odM,8BAAA;EzE4odN;;EyE5odM;IAOI,8BAAA;EzEyodV;;EAEA;IACE,yBAAyB;EyEnpdrB;;EzEspdN;IyEtpdM,+BAAA;EzEwpdN;;EyExpdM;IAOI,8BAAA;EzEqpdV;;EAEA;IACE,4BAA4B;EyE/pdxB;;EzEkqdN;IyElqdM,8BAAA;EzEoqdN;;EyEpqdM;IAOI,4BAAA;EzEiqdV;;EAEA;IACE,4BAA4B;EyE3qdxB;;EzE8qdN;IyE9qdM,qBAAA;EzEgrdN;;EyEhrdM;IAOI,2BAAA;EzE6qdV;;EAEA;IACE,0BAA0B;EyEvrdtB;;EzE0rdN;IyE1rdM,wBAAA;EzE4rdN;;EyE5rdM;IAOI,0BAAA;EzEyrdV;;EAEA;IACE,wBAAwB;EyEnsdpB;;EzEssdN;IyEtsdM,2BAAA;IAOI,0BAAA;EzEksdV;;EAEA;IACE,iCAAiC;IyE5sd7B,gCAAA;EzE8sdN;;EyE9sdM;IAOI,gCAAA;IzE2sdR,+BAA+B;EyEltd3B;;EzEqtdN;IyErtdM,8BAAA;IAOI,6BAAA;EzEitdV;;EAEA;IACE,gCAAgC;IyE3td5B,+BAAA;EzE6tdN;;EyE7tdM;IAOI,8BAAA;IzE0tdR,6BAA6B;EyEjudzB;;EzEoudN;IyEpudM,yBAAA;IAOI,4BAAA;EzEgudV;;EAEA;IACE,+BAA+B;IyE1ud3B,kCAAA;EzE4udN;;EyE5udM;IAOI,8BAAA;IzEyudR,iCAAiC;EyEhvd7B;;EzEmvdN;IyEnvdM,4BAAA;IAOI,+BAAA;EzE+udV;;EAEA;IACE,8BAA8B;IyEzvd1B,iCAAA;EzE2vdN;;EyE3vdM;IAOI,4BAAA;IzEwvdR,+BAA+B;EyE/vd3B;;EzEkwdN;IyElwdM,yBAAA;EzEowdN;;EyEpwdM;IAOI,+BAAA;EzEiwdV;;EAEA;IACE,8BAA8B;EyE3wd1B;;EzE8wdN;IyE9wdM,4BAAA;EzEgxdN;;EyEhxdM;IAOI,8BAAA;EzE6wdV;;EAEA;IACE,4BAA4B;EyEvxdxB;;EzE0xdN;IyE1xdM,2BAAA;EzE4xdN;;EyE5xdM;IAOI,iCAAA;EzEyxdV;;EAEA;IACE,gCAAgC;EyEnyd5B;;EzEsydN;IyEtydM,8BAAA;EzEwydN;;EyExydM;IAOI,gCAAA;EzEqydV;;EAEA;IACE,8BAA8B;EyE/yd1B;;EzEkzdN;IyElzdM,4BAAA;EzEozdN;;EyEpzdM;IAOI,kCAAA;EzEizdV;;EAEA;IACE,iCAAiC;EyE3zd7B;;EzE8zdN;IyE9zdM,+BAAA;EzEg0dN;;EyEh0dM;IAOI,iCAAA;EzE6zdV;;EAEA;IACE,+BAA+B;EyEv0d3B;;EzE00dN;IyE10dM,0BAAA;EzE40dN;;EAEA;IyE90dM,gCAAA;EzEg1dN;;EAEA;IyEl1dM,+BAAA;EzEo1dN;;EAEA;IyEt1dM,6BAAA;EzEw1dN;;EAEA;IyE11dM,+BAAA;EzE41dN;;EAEA;IyE91dM,6BAAA;EzEg2dN;;EAEA;IyEl2dM,iBAAA;EzEo2dN;;EAEA;IyEt2dM,uBAAA;EzEw2dN;;EAEA;IyE12dM,sBAAA;EzE42dN;;EAEA;IyE92dM,oBAAA;EzEg3dN;;EAEA;IyEl3dM,sBAAA;EzEo3dN;;EAEA;IyEt3dM,oBAAA;EzEw3dN;;EAEA;IyE13dM,qBAAA;EzE43dN;;EAEA;IyE93dM,2BAAA;EzEg4dN;;EAEA;IyEl4dM,0BAAA;EzEo4dN;;EyEp4dM;IAOI,wBAAA;EzEi4dV;;EAEA;IACE,0BAA0B;EyE34dtB;;EzE84dN;IyE94dM,wBAAA;EzEg5dN;;EyEh5dM;IAOI,wBAAA;EzE64dV;;EAEA;IACE,8BAA8B;EyEv5d1B;;EzE05dN;IyE15dM,6BAAA;EzE45dN;;EyE55dM;IAOI,2BAAA;EzEy5dV;;EAEA;IACE,6BAA6B;EyEn6dzB;;EzEs6dN;IyEt6dM,2BAAA;EzEw6dN;;EyEx6dM;IAOI,2BAAA;EzEq6dV;;EAEA;IACE,4BAA4B;EyE/6dxB;;EzEk7dN;IyEl7dM,6BAAA;EzEo7dN;AACF;;AAEA;EACE;IyEx7dM,sBAAA;EzE07dN;;EyE17dM;IAOI,uBAAA;EzEu7dV;;EAEA;IACE,sBAAsB;EyEj8dlB;;EzEo8dN;IyEp8dM,8BAAA;EzEs8dN;;EyEt8dM;IAOI,4BAAA;EzEm8dV;;EAEA;IACE,2BAA2B;EyE78dvB;;EzEg9dN;IyEh9dM,iCAAA;EzEk9dN;;EyEl9dM;IAOI,2BAAA;EzE+8dV;;EAEA;IACE,0BAA0B;EyEz9dtB;;EzE49dN;IyE59dM,gCAAA;EzE89dN;;EyE99dM;IAOI,yBAAA;EzE29dV;;EAEA;IACE,wBAAwB;EyEr+dpB;;EzEw+dN;IyEx+dM,+BAAA;EzE0+dN;;EAEA;IyE5+dM,yBAAA;EzE8+dN;;EAEA;IyEh/dM,6BAAA;EzEk/dN;;EAEA;IyEp/dM,8BAAA;EzEs/dN;;EAEA;IyEx/dM,wBAAA;EzE0/dN;;EAEA;IyE5/dM,+BAAA;EzE8/dN;;EAEA;IyEhgeM,wBAAA;EzEkgeN;;EAEA;IyEpgeM,yBAAA;EzEsgeN;;EAEA;IyExgeM,8BAAA;EzE0geN;;EAEA;IyE5geM,iCAAA;EzE8geN;;EAEA;IyEhheM,sCAAA;EzEkheN;;EAEA;IyEpheM,yCAAA;EzEsheN;;EAEA;IyExheM,uBAAA;EzE0heN;;EyE1heM;IAOI,uBAAA;EzEuheV;;EAEA;IACE,yBAAyB;EyEjierB;;EzEoieN;IyEpieM,yBAAA;EzEsieN;;EyEtieM;IAOI,0BAAA;EzEmieV;;EAEA;IACE,4BAA4B;EyE7iexB;;EzEgjeN;IyEhjeM,kCAAA;EzEkjeN;;EyEljeM;IAOI,sCAAA;EzE+ieV;;EAEA;IACE,oCAAoC;EyEzjehC;;EzE4jeN;IyE5jeM,kCAAA;EzE8jeN;;EyE9jeM;IAOI,yCAAA;EzE2jeV;;EAEA;IACE,wCAAwC;EyErkepC;;EzEwkeN;IyExkeM,wCAAA;EzE0keN;;EyE1keM;IAOI,kCAAA;EzEukeV;;EAEA;IACE,gCAAgC;EyEjle5B;;EzEoleN;IyEpleM,8BAAA;EzEsleN;;EyEtleM;IAOI,gCAAA;EzEmleV;;EAEA;IACE,+BAA+B;EyE7le3B;;EzEgmeN;IyEhmeM,oCAAA;EzEkmeN;;EyElmeM;IAOI,kCAAA;EzE+leV;;EAEA;IACE,gCAAgC;EyEzme5B;;EzE4meN;IyE5meM,uCAAA;EzE8meN;;EyE9meM;IAOI,sCAAA;EzE2meV;;EAEA;IACE,iCAAiC;EyErne7B;;EzEwneN;IyExneM,2BAAA;EzE0neN;;EyE1neM;IAOI,iCAAA;EzEuneV;;EAEA;IACE,+BAA+B;EyEjoe3B;;EzEooeN;IyEpoeM,6BAAA;EzEsoeN;;EyEtoeM;IAOI,+BAAA;EzEmoeV;;EAEA;IACE,8BAA8B;EyE7oe1B;;EzEgpeN;IyEhpeM,oBAAA;EzEkpeN;;EyElpeM;IAOI,mBAAA;EzE+oeV;;EAEA;IACE,mBAAmB;EyEzpef;;EzE4peN;IyE5peM,mBAAA;EzE8peN;;EAEA;I0E/seF,mBAAA;ED+CQ;;EzEoqeN;IyEpqeM,mBAAA;EzEsqeN;;EyEtqeM;IAOI,mBAAA;EzEmqeV;;E0EtseF;ID4BQ,mBAAA;EzE8qeN;;EyE9qeM;IAOI,oBAAA;EzE2qeV;;EAEA;IACE,0BAA0B;EyErretB;;EzEwreN;IyExreM,yBAAA;EzE0reN;;EyE1reM;IAOI,uBAAA;EzEureV;;EAEA;IACE,yBAAyB;EyEjserB;;EzEoseN;IyEpseM,uBAAA;EzEsseN;;EyEtseM;IAOI,uBAAA;EzEmseV;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;E2Ehxe7B;;EAEA;IACI,gCjD2Ce;I1Buuef,+BAA+B;EACjC;;E2EhxeE;IACA,+BjDNS;I1ByxeT,8BAA8B;E2ElxejC;;E3EqxeC;I2ElxeE,6BAAA;IACI,4BAAA;E3EoxeN;;E2EjxeF;IACI,+BjDRQ;IiDUV,8BAAA;E3EmxeA;;E2EhxeF;IACI,6BAAA;I3EmxeA,4BAA4B;EAC9B;;E2EjxeD;IACG,6BAAA;I3EoxeA,4BAA4B;E2Elxe/B;;E3EqxeC;IACE,wBAAwB;I2Elxe5B,2BAAA;EACI;;E3EqxeF;IACE,8BAA8B;I2EnxelC,iCAAA;EACI;;EAEA;I3EqxeA,6BAA6B;IAC7B,gCAAgC;E2EpxepC;;E3EuxeE;IACE,2BAA2B;I2EnxevB,8BAAA;EACI;;E3EsxeV;I2ElxeF,6BAAA;IACC,gCtE5CU;EsE6CV;;EAEG;IACH,2BAAA;IACA,8BAAA;EACA;;EAEG;I3EoxeA,2BAA2B;I2Enxe9B,8BAAA;EACC;;E3EsxeA;I2EnxeD,wBAAA;EACC;;EAEA;IACA,8BAAA;EACM;;EAEP;IACC,6BAAA;EACM;;EAEJ;IACI,2BAAA;E3EqxeN;;E2ElxeM;I3EqxeJ,6BAA6B;E2Enxe7B;;E3EsxeF;IACE,2BAA2B;E2Elxe3B;;E3EqxeF;IACE,2BAA2B;E2Elxe/B;;E3EqxeE;I2EnxeE,0BAAA;EACI;;EAEA;IACA,gCAAA;E3EqxeN;;E2EnxeU;IACA,+BjDhGF;E1Bs3eR;;E2ElxeM;I3EqxeJ,6BAA6B;E2Enxe7B;;E3EsxeF;IACE,+BAA+B;E2EnxenC;;EAEI;IACA,6BAAA;EACA;;EAEA;IACA,6BAAA;E3EqxeF;;E2ElxeM;I3EqxeJ,2BAA2B;E2Enxe3B;;E3EsxeF;I2EnxeE,iCAAA;EACI;;EAEJ;IACI,gCAAA;E3EqxeN;;E2EjxeE;IACI,8BAAA;EACA;;E3EqxeN;IACE,gCAAgC;E2EjxehC;;EAEI;I3EmxeJ,8BAA8B;EAChC;;E2E9weU;IACA,8BAAA;E3EixeV;;E2E3weM;IACI,yBAAA;EACA;;E3E+weV;IACE,+BAA+B;E2Ezwe3B;;EAEI;I3E2weR,8BAA8B;EAChC;;E2EtweM;I3EyweJ,4BAA4B;EAC9B;;E2EtweE;I3EyweA,8BAA8B;EAChC;;E2EtweE;IACA,4BAAA;E3EyweF;;E2EtweE;IACI,4BAAA;EACA;;EAEA;I3EyweJ,qBAAqB;E2EvwerB;;E3E0weF;IACE,2BAA2B;E2Etwe3B;;E3EyweF;I2EtweU,0BAAA;EACI;;E3Eywed;I2EnweF,wBAAA;EACI;;E3EsweF;I2EnweF,0BAAA;EAAA;;EAGI;IACA,wBAAA;EACA;;E3EsweF;I2EnweF,2BAAA;IAAA,0BAAA;EAEA;;EAEI;IACA,iCAAA;IACA,gCAAA;EACA;;EAEA;I3EqweA,gCAAgC;I2EnwehC,+BAAA;EACI;;EAEA;IACA,8BAAA;I3EqweJ,6BAA6B;E2EnwezB;;EAEI;IACA,gCAAA;IACA,+BAAA;EACA;;EAGI;I3EoweZ,8BAA8B;I2ElwetB,6BAAA;EACI;;EAGR;IACI,yBAAA;IACA,4BAAA;EACA;;EAGI;IACA,+BjD3PN;I1B6/eN,kCAAkC;E2E/ve9B;;EAEI;IACA,8BAAA;IAEI,iCAAA;EACA;;EAEJ;IACI,4BAAA;IACA,+BjDjPT;EiDkPS;;EAEA;I3EgweZ,8BAA8B;I2E9velB,iCAAA;EACI;;EAEJ;IACI,4BAAA;I3EgwehB,+BAA+B;E2E9venB;;E3Eiwed;I2E9vec,yBAAA;EACI;;E3EiwelB;I2E3veF,+BAAA;EACI;;E3E8veF;I2E3veE,8BAAA;E3E6veF;;E2E1veE;IACI,4BAAA;E3E6veN;;E2E1veF;IACI,8BAAA;E3E6veF;;E2E1veE;IACI,4BAAA;E3E6veN;;E2E1veF;IACA,2BAAA;EAIY;;E3E2veV;IACE,iCAAiC;E2EjverC;;EAEC;I3EmveG,gCAAgC;E2EjvenC;;EAEC;I3EmveE,8BAA8B;E2EjvejC;;EAEC;I3EmveE,gCAAgC;E2EjvenC;;EAEC;I3EmveE,8BAA8B;E2EjvejC;;EAEC;I3EmveE,4BAA4B;E2Ejve/B;;EAEC;I3EmveE,kCAAkC;EACpC;;E2EhveF;IAAA,iCAAA;EAIC;;EAEO;IACA,+BAAA;E3EiveN;;E2E9ueU;I3EiveR,iCAAiC;E2E/uenC;;EAEC;I3EiveC,+BAA+B;E2E/ue3B;;EAEI;IACA,0BAAA;EACA;;EAEA;I3EiveR,gCAAgC;E2E/uexB;;EAEI;I3EiveZ,+BAA+B;E2E5ue3B;;EAEI;IACA,6BAAA;EACA;;EAEA;IACI,+BAAA;EACA;;EAEA;I3E8ueZ,6BAA6B;E2E5uerB;;EAEI;I3E8ueZ,iBAAiB;E2EzuenB;;EAEC;IACA,uBjDvWU;E1BklfX;;E2EvueE;I3E0ueA,sBAAsB;EACxB;;E2ErueF;IAAA,oBAAA;EAGA;;E3EwueE;IACE,sBAAsB;E2Etue1B;;EAEI;I3EwueA,oBAAoB;EACtB;;E2EtueE;IACA,qBAAA;E3EyueF;;E2EvueF;IACI,2BAAA;EACA;;E3E2ueF;I2EzueF,0BAAA;EACI;;E3E4ueF;IACE,wBAAwB;E2E1ue5B;;EAEI;I3E4ueA,0BAA0B;EAC5B;;E2E1ueE;IACA,wBAAA;E3E6ueF;;E2E3ueF;IACI,wBAAA;EACA;;E3E+ueF;I2E7ueF,8BAAA;EACI;;E3EgveF;IACE,6BAA6B;E2E9uejC;;EAEI;I3EgveA,2BAA2B;EAC7B;;E2E9ueE;IACA,6BAAA;E3EiveF;;E2E/ueF;IACI,2BAAA;EACA;;E3EmveF;I2EjveF,2BAAA;EACI;;E3EoveF;IACE,4BAA4B;E2ElvehC;;EAEI;I3EoveA,6BAA6B;EAC/B;A2EnveF;;A3EsveA;EACE;IACE,sBAAsB;E2Epve1B;;EAEI;I3EsveA,uBAAuB;EACzB;;E2EpveE;IACA,sBAAA;E3EuveF;;E2ErveF;IACI,8BAAA;EACA;;E3EyveF;I2EvveF,4BAAA;EACI;;E3E0veF;IACE,2BAA2B;E2Exve/B;;EAEI;I3E0veA,iCAAiC;EACnC;;E2ExveE;IACA,2BAAA;E3E2veF;;E2EzveF;IACI,0BAAA;EACA;;E3E6veF;I2E3veF,gCAAA;EACI;;E3E8veF;IACE,yBAAyB;E2E5ve7B;;EAEI;I3E8veA,wBAAwB;EAC1B;;E2E5veE;IACA,+BAAA;E3E+veF;;E2E7veF;IACI,yBAAA;EACA;;E3EiweF;I2E/veF,6BAAA;EACI;;E3EkweF;IACE,8BAA8B;E2EhwelC;;EAEI;I3EkweA,wBAAwB;EAC1B;;E2EhweE;I3EmweA,+BAA+B;EACjC;;E2EjweE;I3EoweA,wBAAwB;EAC1B;;E2ElweE;I3EqweA,yBAAyB;EAC3B;;E2EnweE;I3EsweA,8BAA8B;EAChC;;E2EpweE;I3EuweA,iCAAiC;EACnC;;E2ErweE;I3EwweA,sCAAsC;EACxC;;E2EtweE;I3EyweA,yCAAyC;EAC3C;;E2EtweF;IACI,uBAAA;EACA;;E3E0weF;I2ExweF,uBAAA;EACI;;E3E2weF;IACE,yBAAyB;E2Ezwe7B;;EAEI;I3E2weA,yBAAyB;EAC3B;;E2EzweE;IACA,0BAAA;E3E4weF;;E2E1weF;IACI,4BAAA;EACA;;E3E8weF;I2E5weF,kCAAA;EACI;;E3E+weF;IACE,sCAAsC;E2E5we1C;;EAKI;IAIA,oCAAA;EAIA;;EAXA;IACI,kCAAA;E3EkxeN;;E2E9weM;I3EixeJ,yCAAyC;E2E9wezC;;E3EixeF;I2E7weE,wCAAA;EACI;;E3EgxeN;I2E5weF,wCAAA;EAAA;;EAGA;IACI,kCAAA;E3E8weF;;E2E5weF;IACI,gCAAA;E3E+weF;;E2E5weF;IAAA,8BAAA;EAAA;;EAII;I3E+weA,gCAAgC;EAClC;;E2E7weE;I3EgxeA,+BAA+B;E2E/we/B;;E3EkxeF;IACE,oCAAoC;E2E/wexC;;E3EkxeE;I2EhxeE,kCAAA;EACI;;E3EmxeN;I2EhxeF,gCAAA;EACI;;EACA;IACI,uCAAA;E3EmxeN;;E2EhxeF;IACI,sCjDzkBS;E1B41fX;;E2EjxeM;I3EoxeJ,iCAAiC;EACnC;;E2EjxeE;I3EoxeA,2BAA2B;E2Enxe3B;;E3EsxeF;IACE,iCAAiC;E2ElxerC;;EAAA;IAGA,+BAAA;EACI;;E3EqxeF;I2EnxeF,6BAAA;EACI;;E3EsxeF;I2EpxeF,+BAAA;EACI;;E3EuxeF;I2ErxeF,8BAAA;EACI;;E3EwxeF;I2EtxeF,oBAAA;EACI;;E3EyxeF;I2EvxeF,mBAAA;EACI;;E3E0xeF;I2ExxeF,mBAAA;EACI;;E3E2xeF;I2EzxeF,mBAAA;EACI;;E3E4xeF;I2E1xeF,mBAAA;EACI;;E3E6xeF;I2E3xeF,mBAAA;EACI;;E3E8xeF;I2E5xeF,mBAAA;EACI;;E3E+xeF;I2E7xeF,mBAAA;EACI;;E3EgyeF;I2E9xeF,oBAAA;EACI;;E3EiyeF;I2E/xeF,0BAAA;EACI;;E3EkyeF;I2EhyeF,yBAAA;EACI;;E3EmyeF;I2EjyeF,uBAAA;EACI;;E3EoyeF;I2ElyeF,yBAAA;EACI;;E3EqyeF;I2EnyeF,uBAAA;EACI;;E3EsyeF;I2EpyeF,uBAAA;EACI;;E3EuyeF;I2EryeF,0BAAA;IACI,yBAAA;E3EuyeF;;E2EryeF;IACI,gCAAA;I3EwyeA,+BAA+B;EACjC;;E2EtyeE;I3EyyeA,+BAA+B;IAC/B,8BAA8B;E2ExyelC;;E3E2yeE;IACE,6BAA6B;I2EzyejC,4BAAA;EACI;;E3E4yeF;I2E1yeF,+BAAA;IACI,8BAAA;E3E4yeF;;E2EzyeF;IAAA,6BAAA;IAAA,4BAAA;EAGA;;E3E6yeE;IACE,6BAA6B;I2E3yejC,4BAAA;EACI;;E3E8yeF;I2E5yeF,wBAAA;IACI,2BAAA;E3E8yeF;;E2E5yeF;IACI,8BAAA;I3E+yeA,iCAAiC;EACnC;;E2E7yeE;I3EgzeA,6BAA6B;IAC7B,gCAAgC;E2E/yepC;;E3EkzeE;I2E/yeE,2BAAA;IACI,8BAAA;E3EizeN;;E2E9yeF;IACI,6BAAA;I3EizeA,gCAAgC;E2E/yehC;;E3EkzeF;IACE,2BAA2B;I2E/ye/B,8BAAA;EACI;;E3EkzeF;I2EhzeF,2BAAA;IACI,8BAAA;E3EkzeF;;E2EhzeF;IACI,wBAAA;E3EmzeF;;E2EjzeF;IACI,8BAAA;E3EozeF;;E2ElzeF;IACI,6BAAA;E3EqzeF;;E2EnzeF;IACI,2BAAA;E3EszeF;;E2EnzeM;I3EszeJ,6BAA6B;EAC/B;;E2EnzeE;I3EszeA,2BAA2B;EAC7B;;E2EpzeF;IAAA,2BAAA;EAGA;;E3EuzeE;IACE,0BAA0B;E2Erze9B;;E3EwzeE;IACE,gCAAgC;E2EtzepC;;E3EyzeE;IACE,+BAA+B;E2EvzenC;;E3E0zeE;IACE,6BAA6B;E2ExzejC;;E3E2zeE;IACE,+BAA+B;E2EzzenC;;E3E4zeE;IACE,6BAA6B;E2E1zejC;;E3E6zeE;IACE,6BAA6B;E2E3zejC;;E3E8zeE;IACE,2BAA2B;E2E5ze/B;;E3E+zeE;IACE,iCAAiC;E2E7zerC;;E3Eg0eE;IACE,gCAAgC;E2E9zepC;;E3Ei0eE;IACE,8BAA8B;E2E/zelC;;E3Ek0eE;IACE,gCAAgC;E2Eh0epC;;E3Em0eE;IACE,8BAA8B;E2Ej0elC;;E3Eo0eE;IACE,8BAA8B;E2Ej0elC;;EAAA;IAGA,yBAAA;EACI;;E3Eo0eF;I2Ej0eE,+BAAA;EACI;;EAEA;I3Em0eJ,8BAA8B;E2El0e1B;;EAEI;IACA,4BAAA;EACA;;EAEA;IACA,8BtEl0BD;EsEm0BC;;E3Eq0eV;I2El0eM,4BAAA;EACI;;E3Eq0eV;I2En0eU,4BAAA;EACI;;E3Es0ed;I2Eh0eF,qBAAA;EAAA;;EAGA;IACI,2BjDhzBS;E1BkngBX;;E2Eh0eM;I3Em0eJ,0BAA0B;E2El0etB;;E3Eq0eN;IACE,wBAAwB;E2Ej0e5B;;E3Eo0eE;I2El0eE,0BAAA;EACI;;EACA;IACI,wBAAA;E3Eq0eV;;E2Ej0eF;IACI,2BjDl0BS;I1BsogBT,0BAA0B;E2En0e1B;;EAEI;I3Eq0eJ,iCAAiC;I2Ep0e7B,gCAAA;EACI;;E3Eu0eV;I2En0eF,gCAAA;IACI,+BAAA;E3Eq0eF;;E2En0eF;IACI,8BAAA;I3Es0eA,6BAA6B;EAC/B;;E2En0eA;I3Es0eE,gCAAgC;I2Ep0enC,+BAAA;EACC;;EAEA;IACA,8BAAA;IACA,6BAAA;EACA;;E3Eu0eA;I2Ep0eF,yBAAA;IACI,4BAAA;EACA;;E3Eu0eF;I2En0eM,+BAAA;IACI,kCAAA;EACA;;EAEA;IACA,8BAAA;IACA,iCAAA;E3Eq0eV;;E2El0ec;IACA,4BAAA;IACA,+BAAA;EACA;;EAEA;IACA,8BjD35BN;IiD45BM,iCAAA;EACA;;EAEJ;IACI,4BAAA;I3Eq0eZ,+BAA+B;E2En0enB;;E3Es0ed;I2En0ec,yBAAA;EACI;;E3Es0elB;I2E7zeU,+BAAA;EACI;;E3Eg0ed;IACE,8BAA8B;E2ExzetB;;EAEI;I3E0zeZ,4BAA4B;E2ExzepB;;EAEI;I3E0zeZ,8BAA8B;EAChC;;E2ErzeE;IACA,4BAAA;E3EwzeF;;E2EtzeM;IACA,2BAAA;EACA;;EAEA;IACA,iCAAA;EACA;;E3E0zeN;I2EvzeE,gCAAA;EACI;;EAEA;IACA,8BAAA;EACA;;EAEA;I3EyzeJ,gCAAgC;E2Exze5B;;E3E2zeN;I2EtzeM,8BAAA;EACI;;EAEJ;IACI,4BjDl+BF;E1B0xgBR;;E2Etzec;I3EyzeZ,kCAAkC;EACpC;;E2EpzeE;I3EuzeA,iCAAiC;EACnC;;E2ErzeE;I3EwzeA,+BAA+B;EACjC;;E2EtzeE;I3EyzeA,iCAAiC;EACnC;;E2EvzeE;I3E0zeA,+BAA+B;EACjC;;E2ExzeE;I3E2zeA,0BAA0B;EAC5B;;E2ExzeM;I3E2zeJ,gCAAgC;E2Exze5B;;E3E2zeN;IACE,+BAA+B;E2Etze/B;;E3EyzeF;IACE,6BAA6B;E2EtzejC;;EAEI;I3EwzeA,+BAA+B;E2Evze/B;;EAEI;I3EyzeJ,6BAA6B;EAC/B;;E2EtzeE;IACA,iBAAA;EACA;;EAEA;IACA,uBAAA;EACA;;EAEA;IACA,sBAAA;E3EyzeF;;E2EvzeF;IACI,oBAAA;EACA;;EAEA;IACA,sBAAA;EACA;;EAEA;IACA,oBAAA;EACA;;E3E2zeF;I2ExzeE,qBAAA;EACI;;EAEA;I3E0zeJ,2BAA2B;E2EvzevB;;E3E0zeN;IACE,0BAA0B;E2Erze9B;;EAAA;IAGA,wBAAA;EACI;;EAEH;IACG,0BAAA;EAOA;;EAYA;I3EuyeA,wBAAwB;E2EzzexB;;EAEF;IACM,wBjDvhCK;EiDwhCX;;EAGE;IACI,8BAAA;EACN;;E3E2zeA;I2EvzeE,6BAAA;EACI;;EAEN;I3EyzeE,2BAA2B;E2Etze3B;;EAEF;I3EwzeE,6BAA6B;E2EtzehC;;EAYC;I3E8yeE,2BAA2B;E2Ezze7B;;EAEC;IACA,2BAAA;E3E2zeD;;E2EvzeC;IACA,4BjDpjCU;EiDqjCV;;EAGD;IACC,6BjDjmCO;EiDkmCP;A3EyzeH;;A2EnzeQ;EACI;IACA,sBAAA;E3EszeV;;E2EhzeM;IACI,uBAAA;EACA;;E3EozeV;I2EhzeF,sBAAA;EACI;;EAEA;IACA,8BAAA;E3EkzeF;;E2EhzeM;IACA,4BtEznCG;EsE0nCH;;EAEA;IACA,2BAAA;EACA;;EAEJ;IACI,iCAAA;EACA;;E3EozeN;I2EjzeF,2BAAA;EACI;;EAEA;IACA,0BAAA;E3EmzeF;;E2EjzeF;IACC,gCAAA;EACA;;EAEG;I3EozeA,yBAAyB;EAC3B;;E2EhzeU;I3EmzeR,wBAAwB;E2EhzeZ;;EAEI;IACA,+BAAA;EACA;;EAEA;I3EkzehB,yBAAyB;E2EhzeT;;E3EmzelB;I2EhzekB,6BAAA;EACI;;EAIZ;IACI,8BAAA;E3Egzed;;E2E3yeF;IACI,wBAAA;EACA;;EACA;IACI,+BAAA;EACA;;EAEA;IACA,wBAAA;EACA;;EAEA;IACA,yBAAA;EACA;;EAGA;IACI,8BAAA;E3E8yeV;;E2E5yec;I3E+yeZ,iCAAiC;E2E9yerB;;E3Eized;IACE,sCAAsC;E2E3ye1C;;EAEI;I3E6yeA,yCAAyC;E2E5yezC;;EAEI;IACA,uBAAA;EACA;;EAEA;IACA,uBAAA;EACA;;EAEA;I3E8yeJ,yBAAyB;E2E3yerB;;EAEI;IACA,yBAAA;E3E6yeV;;E2E3yec;IACA,0BAAA;E3E8yed;;E2E1yekB;IACA,4BAAA;E3E6yelB;;E2Evyec;I3E0yeZ,kCAAkC;E2Etye1B;;E3EyyeV;IACE,sCAAsC;E2Enye1C;;EAAA;IAGA,oCAAA;EACI;;EAEA;IACA,kCtE3vCO;EsE4vCP;;EAEA;IACA,yCAAA;EACA;;EACA;IACI,wCAAA;EACA;;EAEA;I3EsyeJ,wCAAwC;E2EpyexC;;E3EuyeF;I2EryeM,kCAAA;EACI;;E3EwyeV;I2EryeM,gCAAA;EACI;;EAEA;IACA,8BAAA;EACA;;E3EwyeV;IACE,gCAAgC;E2EpyepC;;E3EuyeE;IACE,+BAA+B;E2EryenC;;E3EwyeE;IACE,oCAAoC;E2EtyexC;;E3EyyeE;IACE,kCAAkC;E2EvyetC;;E3E0yeE;IACE,gCAAgC;E2ExyepC;;E3E2yeE;IACE,uCAAuC;E2Ezye3C;;E3E4yeE;IACE,sCAAsC;E2E1ye1C;;E3E6yeE;IACE,iCAAiC;E2E3yerC;;E3E8yeE;IACE,2BAA2B;E2E3ye/B;;EAAA;IAGA,iCAAA;EACI;;EAEA;IACA,+BAAA;EACA;;E3E8yeF;I2E5yeE,6BAAA;EACI;;E3E+yeN;I2E7yeM,+BAAA;EACI;;E3EgzeV;I2E3yeF,8BAAA;EAAA;;EAKY;I3E2yeR,oBAAoB;E2EzyehB;;E3E4yeN;IACE,mBAAmB;E2EtyenB;;EAEI;IACA,mBAAA;E3EwyeN;;E2Enyec;I3EsyeZ,mBAAmB;EACrB;;E2EjyeF;IAEA,mBAAA;EACI;;EAEA;I3EmyeA,mBAAmB;E2ElyenB;;EAEI;IACA,mBAAA;E3EoyeN;;E2ElyeU;I3EqyeR,mBAAmB;E2Enyef;;EAEI;IACA,oBAAA;EACA;;EAEA;IACA,0BAAA;EACA;;EAEA;I3EqyeR,yBAAyB;EAC3B;;E2EjyeF;IAEA,uBAAA;EACI;;EAEA;I3EmyeA,yBAAyB;E2EjyezB;;E3EoyeF;I2EhyeU,uBAAA;EACI;;EAEJ;IACI,uBtE14CL;EL4qhBT;;E2E7xeM;IACA,0BAAA;I3EgyeJ,yBAAyB;E2E9xerB;;EAEI;IACA,gCAAA;IACA,+BAAA;EACA;;EAEA;IACA,+BAAA;IACA,8BAAA;EACA;;EAEA;IACI,6BjDn6CN;IiDo6CM,4BAAA;E3Egyed;;E2E5xeU;IACA,+BAAA;IACA,8BAAA;EACA;;EAEA;IACA,6BAAA;IACA,4BAAA;EACA;;E3EgyeV;I2E7xeU,6BAAA;IACI,4BjDp7CN;EiDq7CM;;E3Egyed;IACE,wBAAwB;I2E3xe5B,2BAAA;EACI;;E3E8xeF;I2E5xeF,8BAAA;IACI,iCAAA;E3E8xeF;;E2E5xeF;IACI,6BAAA;I3E+xeA,gCAAgC;E2E7xehC;;EAEI;I3E+xeJ,2BAA2B;I2E7xevB,8BAAA;EACI;;E3EgyeV;I2E7xeU,6BAAA;IACI,gCjD78CN;E1B4uhBR;;E2EzxeE;IACI,2BAAA;I3E4xeJ,8BAA8B;EAChC;;E2Epxec;I3EuxeZ,2BAA2B;IAC3B,8BAA8B;E2E9wetB;;E3EixeV;IACE,wBAAwB;E2ExwepB;;EAEI;IACA,8BAAA;EACA;;EAEA;IACA,6BjDp/CA;EiDq/CA;;EAEA;IACI,2BjD5/CN;EiD6/CM;;E3E2wed;I2ErweF,6BAAA;EACI;;E3EwweF;I2ErweF,2BAAA;EACI;;E3EwweF;I2EtweF,2BAAA;EACI;;E3EyweF;I2EvweF,0BAAA;EACI;;E3E0weF;I2EvweE,gCAAA;EACI;;EAII;IACI,+BjDvhDN;E1B8xhBR;;E2EhweE;IACI,6BAAA;EACA;;E3EoweN;I2EhweU,+BAAA;EACI;;E3Emwed;I2E5veE,6BAAA;EACI;;EAEA;IACA,6BAAA;E3E8veN;;E2E3veU;I3E8veR,2BAA2B;E2E5vevB;;EAEI;I3E8veR,iCAAiC;E2E5vezB;;EAEI;I3E8veZ,gCAAgC;E2E1vehC;;EAEI;I3E4veJ,8BAA8B;EAChC;;E2EvveE;IACA,gCAAA;EACA;;EAEA;IACA,8BAAA;EACA;;E3E2veF;I2ExveE,8BAAA;EACI;;E3E2veN;I2ExveE,yBAAA;EACI;;EAEA;IACA,+BAAA;E3E0veN;;E2EvveM;I3E0veJ,8BAA8B;E2Evve9B;;EAEI;I3EyveJ,4BAA4B;E2EvvexB;;EAEI;I3EyveR,8BAA8B;E2Evve1B;;E3E0veN;I2EtveE,4BAAA;EACI;;E3EyveN;I2EtveM,4BAAA;EACI;;E3EyveV;I2ErveE,qBAAA;EACI;;E3EwveN;I2ErveM,2BAAA;EACI;;EAEJ;IACI,0BAAA;EACA;;E3EwveV;I2EpveE,wBAAA;EACI;;EAEA;IACA,0BAAA;EACA;;E3EuveN;IACE,wBAAwB;E2Enve5B;;EAEI;IACA,2BAAA;I3EqveA,0BAA0B;E2Epve1B;;EAEI;IACA,iCAAA;IACA,gCAAA;E3EsveN;;E2EpveU;I3EuveR,gCAAgC;I2EtvexB,+BAAA;EACI;;EAEA;IACA,8BAAA;IACA,6BAAA;EACA;;EAEA;IACA,gCAAA;IACA,+BAAA;EACA;;EAEA;I3EwveZ,8BAA8B;I2EvvelB,6BAAA;EACI;;EAEA;IACA,yBAAA;IACA,4BAAA;EACA;;EAEA;IACA,+BAAA;I3EyvehB,kCAAkC;E2EpvelC;;EAEI;IACA,8BAAA;IACA,iCAAA;EACA;;E3EuveN;I2ErveM,4BAAA;IACI,+BAAA;EACA;;EAEA;IACA,8BAAA;IACA,iCAAA;E3EuveV;;E2E/ueM;IACI,4BAAA;I3EkveR,+BAA+B;EACjC;;E2E9ueF;IAGI,yBAAA;EACI;;EAEA;IACA,+BAAA;EACA;;EAEA;I3E+ueJ,8BAA8B;E2E7ue9B;;EAEI;IACA,4BAAA;EACA;;EAEA;IACA,8BAAA;EACA;;E3EgveN;I2E7ueE,4BAAA;EACI;;EAEA;IACA,2BAAA;EACA;;E3EgveN;I2E7ueE,iCAAA;EACI;;EAEA;IACA,gCAAA;EACA;;EAEA;IACA,8BAAA;EACA;;E3EgveN;I2E9ueM,gCAAA;EACI;;E3EiveV;IACE,8BAA8B;E2E5uelC;;EAEA;IACI,4BAAA;E3E8ueF;;E2E5ueF;IACI,kCAAA;E3E+ueF;;E2E5ueE;IACI,iCAAA;EACA;;E3EgveN;I2E7ueM,+BAAA;EACI;;EAEA;IACA,iCAAA;E3E+ueV;;E2E5uec;I3E+ueZ,+BAA+B;EACjC;;E2E1ueE;I3E6ueA,0BAA0B;EAC5B;;E2E3ueE;I3E8ueA,gCAAgC;EAClC;;E2E1ueU;IACA,+BAAA;EACA;;E3E8ueV;I2E1ueF,6BAAA;EACI;;EAEA;IACA,+BAAA;E3E4ueF;;E2EzueM;IACA,6BAAA;E3E4ueN;;E2EvueF;IACI,iBAAA;E3E0ueF;;E2ExueF;IACI,uBAAA;E3E2ueF;;E2EzueF;IACI,sBAAA;E3E4ueF;;E2E1ueF;IACI,oBAAA;E3E6ueF;;E2EzueU;I3E4ueR,sBAAsB;E2EvuelB;;E3E0ueN;I2EvueU,oBAAA;EACI;;EAGR;IACI,qBAAA;E3EwueV;;E2ElueF;IACA,2BAAA;EAEI;;E3EqueF;I2ElueE,0BAAA;E3EoueF;;E2EjueE;IACI,wBAAA;E3EoueN;;EAEA;IACE,0BAA0B;E2Elue1B;;E3EqueF;I2ElueE,wBAAA;E3EoueF;;E2EjueE;IACI,wBAAA;E3EoueN;;E2EjueE;IACI,8BAAA;E3EoueN;;EAEA;IACE,6BAA6B;E2EjuezB;;E3EoueN;I2EhueU,2BAAA;E3EkueV;;EAEA;I2E7teF,6BAAA;EAEI;;E3E+teF;IACE,2BAA2B;E2E1te/B;;EAGI;IACI,2BAAA;E3E2teN;;EAEA;IACE,4BAA4B;EAC9B;;E2EvteF;IAEI,6BAAA;E3EyteF;AACF;;AAEA;EACE;I2EvteE,4BAAA;E3EyteF;;E2EvteM;IACI,8BAAA;E3E0teV;;EAEA;I2ExteU,8BAAA;E3E0teV;AACF;;A2EpteA;EAEI;IACI,0BAAA;E3EsteN;;EAEA;IACE,gCAAgC;E2EptehC;;E3EuteF;IACE,yBAAyB;E2EptezB;;E3EuteF;I2EpteE,wBAAA;E3EsteF;;E2EnteE;IACI,+BAAA;E3EsteN;;EAEA;IACE,yBAAyB;E2ErterB;;E3EwteN;IACE,6BAA6B;EAC/B;;E2EjteF;IACI,8BAAA;E3EoteF;;EAEA;IACE,wBAAwB;E2Ehte5B;;E3EmteE;IACE,+BAA+B;E2E/se/B;;E3EkteF;IACE,wBAAwB;E2E7se5B;A3E+seA;;AAEA;6CAC6C;A2E1se7C;EAEQ,gCAAA;A3E2seR;;AAEA;EACE,yB2E1sec;E3E2sed,W2E1sec;A3E2sehB;;AAEA;EACE,c2E1sec;A3E2sehB;;AAEA;E2EvsegB,UAAA;A3EysehB;;AAEA;;;;;;;;;;;;E2EvreQ,cAAA;E3EoseN,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;A2E/reT;;A3EkseR;E2E/reY,mBAAA;EACA,iBAAA;A3EiseZ;;AAEA;EACE,gBAAgB;A2E7reV;;A3EgseR;E2E3reQ,eAAA;EACI,YAAA;A3E6reZ;;A2E1reY;;E3E8reV,eAAe;EACf,gBAAgB;E2EtreV,mBAAA;A3EwreR;;A2ErreY;EACI,yBjDpjEN;A1B4uiBV;;AAEA;EACE,sBAAsB;AACxB;;AAEA;E2EhreQ,sBAAA;E3EkreN,yBAAyB;EACzB,YAAY;E2E/qed,yBAAA;EAAA,eAAA;EAGI,kBAAA;EACI,WAAA;E3EgreN,yBAAyB;E2E9qevB,kBAAA;A3EgreJ;;AAEA;EACE,WAAW;E2E7qeb,eAAA;AAAA;;A3EireA;EACE,sBAAsB;E2E5qehB,iBAAA;EACI,UAAA;E3E8qeV,yBAAyB;E2E5qef,cAAA;A3E8qeZ;;AAEA;EACE,eAAe;E2Ezqeb,cAAA;A3E2qeJ;;AAEA;E2ExqeQ,iBAAA;A3E0qeR;;A2ErqeQ;EACI,YAAA;A3EwqeZ;;A2EpqeA;EACI,YAAA;A3EuqeJ;;A2EpqeI;EACI,YAAA;A3EuqeR;;AAEA;E2ErqeQ,gBAAA;A3EuqeR;;AAEA;EACE,sBAAsB;E2ErqepB,WAAA;EACI,YAAA;E3EuqeN,eAAe;AACjB;;AAEA;E2EpqeQ,gBAAA;EACA,qBAAA;A3EsqeR;;AAEA;EACE,qBAAqB;A2EnqenB;;A3EsqeJ;E2EnqeI,iBAAA;A3EqqeJ;;A2EjqeI;EACI,YAAA;E3EoqeN,Y2EnqeU;E3EoqeV,gBAAgB;E2ElqeV,oBAAA;E3EoqeN,0B2EnqeU;E3EoqeV,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;E2EhqeQ,YAAA;A3EkqeR;;AAEA;E2EhqeQ,WAAA;A3EkqeR;;AAEA;EACE,YAAY;A2EhqeN;;A3EmqeR;E2EhqeY,4BAAA;EACA,2BAAA;EACA,8BjD5oEC;A1B8yiBb;;A2E/peY;EACI,2BjDhqED;EiDiqEC,2BAAA;A3EkqehB;;A2E1peY;EACI,mBAAA;E3E6ped,4BAA4B;A2E3ped;;A3E8pehB;E2E3pegB,4BAAA;EACI,2BAAA;E3E6pelB,8BAA8B;A2E3pehB;;A3E8pehB;E2E3peoB,2BAAA;EACI,8BAAA;A3E6pexB;;AAEA;EACE,sBAAsB;A2E1peR;;A3E6pehB;E2EvpeY,eAAA;A3EypeZ;;A2EtpegB;EACI,4BAAA;E3EypelB,+BAA+B;A2EvpejB;;A3E0pehB;E2EvpegB,YAAA;EACI,yBAAA;E3EypelB,qBAAqB;E2EvpeH,kBAAA;A3EypepB;;A2EtpeoB;EACI,qBAAA;A3EypexB;;AAEA;EACE,SAAS;A2EnpeC;;A3EspeZ;E2EnpegB,qBAAA;A3EqpehB;;A2ElpegB;EACI,yBAAA;A3EqpepB;;AAEA;6CAC6C;A2EnpezB;EACI,kCAAA;E3EqpetB,4BAA4B;E2EnpeV,sBAAA;A3EqpepB;;A2EjpegB;6CACI;A3EopepB;EACE,MAAM;E2E/oeR,OAAA;EACI,QAAA;E3EipeF,SAAS;E2EhpeP,aAAA;EACI,eAAA;EACA,sBAAA;A3EkpeR;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;E2EhpepB,SAAA;EACI,QAAA;A3EkpeJ;;AAEA;E2EjpeQ,kBAAA;EACA,gBAAA;E3EmpeN,cAAc;EACd,aAAa;E2E5oeK,YAAA;EACI,iBAAA;EACA,kBAAA;A3E8oexB;;AAEA;EACE,YAAY;AACd;;AAEA;;E2EhoewB,YAAA;E3EmoetB,kBAAkB;E2EhoeI,6BAAA;EACI,sCAAA;E3Ekoe1B,yBAAyB;EACzB,6BAA6B;A2EtneX;;A3EynepB;EACE,kBAAkB;E2ElneA,kBAAA;EACI,iFAAA;EACA,eAAA;EACA,gBAAA;A3EonexB;;AAEA;EACE,kBAAkB;EAClB,cAAc;E2E1meZ,qBAAA;EACI,qBAAA;E3E4meN,4BAA4B;A2E1me1B;;A3E6meJ;EACE,qBAAqB;A2EzmenB;;A3E4meJ;E2EzmeI,qBAAA;A3E2meJ;;AAEA;E2EzmeA,qBAAA;A3E2meA;;A2ExmeI;EACI,qBAAA;A3E2meR;;A2EtmeA;EAGY;IACI,uBAAA;E3Eumed;;EAEA;IACE,yBAAyB;EAC3B;;E2EtleU;IACI,yBAAA;E3Eyled;AACF;;AAEA;;EAEE;;;I2E3keE,wBAAA;E3E+keF;;E2E3keE;IACI,4BAAA;EACA;A3E8keR;;A2ExkeA,oBAAA;A3E2keA;EACE;IACE,eAAe;E2E1kenB;A3E4keA;;AAEA;E2E1keI,yBAAA;EACI,cAAA;A3E4keR;;AAEA;;EAEE,yCAAyC;E2E1kenC,cAAA;A3E4keR;;A2EzkeQ;;;;;;;;;;E3EqleN,yBAAyB;EACzB,cAAc;A2ElkeJ;;A3EqkeZ;;;;;;;;;;;;;;EAcE,yBAAyB;E2E5jevB,cAAA;A3E8jeJ;;AAEA;;;;;E2ExjeY,yBAAA;E3E8jeV,cAAc;A2E5jeJ;;A3E+jeZ;EACE,yBAAyB;EACzB,cAAc;A2ExjehB;;A3E2jeA;;uDAEuD;A2E7ievD;EAMwB,YAAA;E3E0ietB,c2Ezie0B;E3E0ie1B,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;E2EjieI,YAAA;E3EmieF,gBAAgB;AAClB;;AAEA;E2ElieI,WAAA;E3EoieF,YAAY;EACZ,iBAAiB;E2Ejief,kBAAA;EACI,yBAAA;E3EmieN,kBAAkB;A2EjiehB;;A3EoieJ;E2EjieI,0BAAA;EACI,uBAAA;A3EmieR;;AAEA;EACE,eAAe;E2Ejieb,iBAAA;EACI,aAAA;E3EmieN,mBAAmB;A2EjiejB;;A3EoieJ;;E2EhieQ,eAAA;EACA,iBAAA;EACA,kBAAA;E3EmieN,MAAM;A2EjieA;;A3EoieR;EACE,mCAAmC;E2EjiezB,cAAA;A3EmieZ;;AAEA;E2EjieY,yBAAA;EACI,UAAA;E3Emied,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;;uDAEuD;AACvD;E2E9heQ,YAAA;A3EgieR;;AAEA;E2E3heI,WAAA;EACI,YAAA;A3E6heR;;A2EzheQ;EACI,WAAA;EACA,YAAA;A3E4heZ;;AAEA;E2EzheQ,WAAA;E3E2heN,YAAY;A2EzheV;;A3E4heJ;E2EzheQ,WAAA;EACA,YAAA;A3E2heR;;A2EtheA;EAMwB,WAAA;E3EohetB,Y2Enhe0B;A3Eohe5B;;A2E3geA;EACI,WAAA;E3E8geF,Y2E7geM;A3E8geR;;AAEA;E2E5geI,WAAA;E3E8geF,Y2E7geM;A3E8geR;;AAEA;EACE,WAAW;E2E1geb,YAAA;A3E4geA;;AAEA;EACE,WAAW;E2E1geT,YAAA;A3E4geJ;;AAEA;EACE,WAAW;EACX,YAAY;A2Ezged;;A3E4geA;EACE,W2E1geM;E3E2geN,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;A2Etged;;A3EygeA;EACE,WAAW;E2Evgeb,YAAA;A3EygeA;;AAEA;E2ExgeA,WAAA;EACI,YAAA;A3E0geJ;;AAEA;E2Elge4B,WAAA;EACI,YAAA;A3EogehC;;AAEA;E2EngegC,WAAA;EACI,YAAA;A3EqgepC;;AAEA;EACE,WAAW;E2E9/de,YAAA;A3Egge5B;;AAEA;E2E9/dgC,WAAA;E3Egge9B,YAAY;A2E//dkB;;A3EkgehC;E2E//dgC,WAAA;EACI,YAAA;A3EigepC;;A2Et/dI;EACI,WAAA;EACA,YAAA;A3Ey/dR;;AAEA;E2Ev/dY,WAAA;E3Ey/dV,YAAY;A2Ev/dF;;A3E0/dZ;EACE,WAAW;EACX,YAAY;A2En/dd;;A3Es/dA;EACE,YAAY;EACZ,aAAa;A2E1+df;;A3E6+dA;EACE,Y2Ep+dkC;E3Eq+dlC,aAAa;AACf;;AAEA;EACE,YAAY;E2Ex9dd,aAAA;A3E09dA;;AAEA;EACE,YAAY;EACZ,aAAa;A2Ez9df;;A3E49dA;EACE,YAAY;E2Ez9dV,aAAA;A3E29dJ;;AAEA;E2Ez9dQ,eAAA;A3E29dR;;AAEA;E2Ez9dY,gBAAA;A3E29dZ;;AAEA;EACE,gBAAgB;A2Ev9dlB;;A3E09dA;E2Ev9dI,gBAAA;A3Ey9dJ;;AAEA;E2Ev9dI,gBAAA;A3Ey9dJ;;A2Et9dI;EACI,gBAAA;A3Ey9dR;;AAEA;E2Et9dI,gBAAA;A3Ew9dJ;;AAEA,UAAU;A2Et9dF;EACI,iBAAA;EACA,gBAAA;A3Ew9dZ;;AAEA;E2Et9dgB,mBjDv1FN;E1B+yjBR,gBAAgB;AAClB;;AAEA;EACE,iB2En9dM;E3Eo9dN,gB2En9dM;A3Eo9dR;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;A2Eh9dlB;;A3Em9dA;EACE,iBAAiB;EACjB,gBAAgB;A2E38dlB;;A3E88dA;EACE,iBAAiB;EACjB,gBAAgB;A2E97dU;;A3Ei8d5B;EACE,UAAU;EACV,UAAU;E2Et7dZ,WAAA;EAKoB,oBAAA;A3Eo7dpB;;AAEA;E2Ep6d4B,UAAA;A3Es6d5B;;AAEA;EACE,gBAAgB;A2E55dlB;;A3E+5dA;EACE,mBAAmB;AACrB;;AAEA;E2El5dgC,gBAAA;A3Eo5dhC;;AAEA;;uD2Eh4dgC;A3Em4dhC;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;A4Ez2jB5B;;AAEA;;uDAEC;A5E22jBD;E4Ez2jBC,yBAAA;A5E22jBD;;AAEA;E4Ez2jBC,yBvEFU;AL62jBX;;AAEA;E4Ez2jBQ,2BAAA;A5E22jBR;;AAEA;E4Ez2jBY,yBAAA;A5E22jBZ;;AAEA;E4Ez2jBY,0BAAA;A5E22jBZ;;AAEA;EACE,yBAAyB;A4Et2jBvB;;A5Ey2jBJ;EACE,2BAA2B;AAC7B;;AAEA;E4Er2jBQ,yBAAA;A5Eu2jBR;;AAEA;E4Ep2jBI,0BAAA;A5Es2jBJ;;A4E/1jBI;EAIA,yBAAA;AAIA;;AAXA;EACI,qBAAA;A5Ey2jBR;;AAEA;;uD4Ep2jBI;A5Eu2jBJ;EACE,eAAe;A4Ep2jBb;;A5Eu2jBJ;E4En2jBI,eAAA;A5Eq2jBJ;;AAEA;E4En2jBQ,0BAAA;A5Eq2jBR;;AAEA;EACE,eAAe;A4El2jBD;;A5Eq2jBhB;E4El2jBoB,eAAA;A5Eo2jBpB;;AAEA;E4El2jBoB,eAAA;A5Eo2jBpB;;AAEA;E4El2jBoB,eAAA;A5Eo2jBpB;;AAEA;EACE,eAAe;A4El2jBG;;A5Eq2jBpB;E4El2jBwB,elD3FX;A1B+7jBb;;AAEA;EACE,eAAe;A4Ej2jBO;;A5Eo2jBxB;E4E/1jBoB,eAAA;A5Ei2jBpB;;A4E91jBoB;EACI,eAAA;A5Ei2jBxB;;AAEA;E4E/1jBwB,eAAA;A5Ei2jBxB;;AAEA;E4E/1jBwB,eAAA;A5Ei2jBxB;;AAEA;E4E/1jBwB,eAAA;A5Ei2jBxB;;A4E71jBgB;EACI,eAAA;A5Eg2jBpB;;AAEA;EACE,eAAe;A4Ex1jBb;;A5E21jBJ;EACE,eAAe;A4Ex1jBf;;A5E21jBF;E4Ex1jBG,eAAA;A5E01jBH;;AAEA;E4Ex1jBY,eAAA;A5E01jBZ;;A4Ev1jBY;EACI,elD1GH;A1Bo8jBb;;AAEA;E4Ex1jBgB,eAAA;A5E01jBhB;;AAEA;E4Ex1jBgB,eAAA;A5E01jBhB;;AAEA;E4Ex1jBgB,eAAA;A5E01jBhB;;AAEA;E4Ex1jBoB,eAAA;A5E01jBpB;;AAEA;;uD4Ev1jBoB;A5E01jBpB;E4Ex1jBoB,mBAAA;A5E01jBpB;;A4Ev1jBgB;EACI,mBAAA;A5E01jBpB;;A4Ev1jBoB;EACI,mBAAA;A5E01jBxB;;AAEA;E4Et1jBgB,mBAAA;A5Ew1jBhB;;A4Er1jBY;EACI,mBAAA;A5Ew1jBhB;;AAEA;E4Er1jBgB,kBlDhMN;A1BuhkBV;;AAEA;EACE,cAAc;A4Ep1jBA;;A5Eu1jBhB;EACE,kBAAkB;A4Ep1jBJ;;A5Eu1jBhB;E4Ej1jBC,cAAA;A5Em1jBD;;AAEA;EACE,kBAAkB;A4Ej1jBlB;;A5Eo1jBF;E4Ej1jBG,mBAAA;A5Em1jBH;;AAEA;E4Ej1jBI,aAAA;A5Em1jBJ;;AAEA;E4Ej1jBgB,kBAAA;A5Em1jBhB;;AAEA;E4Ej1jBK,kBAAA;A5Em1jBL;;AAEA;E4Ej1jBK,kBAAA;A5Em1jBL;;AAEA;E4Ej1jBK,clDpMQ;A1BuhkBb;;AAEA;E4Ej1jBoB,qDlDhPV;A1BmkkBV;;AAEA;;uDAEuD;A4Ej1jBnC;EACI,8BvEnPb;ALskkBX;;AAEA;E4E70jBE,4BAAA;A5E+0jBF;;AAEA;E4E70jBE,4BAAA;A5E+0jBF;;AAEA;E4E70jBY,4BAAA;A5E+0jBZ;;A4E50jBQ;EACI,4BAAA;A5E+0jBZ;;A4E10jBA;EAGY,4BAAA;A5E20jBZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4B4E10jBsB;A5E20jBxB;;AAEA;EACE,4B4Ex0jBkB;A5Ey0jBpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;E4Ep0jBoC,4BAAA;A5Es0jBpC;;AAEA;EACE,4B4Er0jBsC;A5Es0jBxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;uD4E3zjBwB;A5E8zjBxB;E4E5zjBoB,6BAAA;A5E8zjBpB;;AAEA;EACE,kB4E7zjBsB;E5E8zjBtB,mB4E7zjBsB;E5E8zjBtB,kBAAkB;AACpB;;AAEA;EACE,W4E7zjB0B;E5E8zjB1B,kB0BvmkBW;E1BwmkBX,QAAQ;E4E5zjBkB,QAAA;E5E8zjB1B,U4E7zjB8B;E5E8zjB9B,W4E7zjB8B;E5E8zjB9B,sB4E7zjB8B;E5E8zjB9B,mB4E7zjB8B;E5E8zjB9B,2B4E7zjB8B;A5E8zjBhC;;AAEA;E4ExzjBgB,gBAAA;E5E0zjBd,e4EzzjBkB;A5E0zjBpB;;AAEA;EACE,a4ElzjB0B;A5EmzjB5B;;AAEA;;uD4E7yjBwC;A5EgzjBxC;EACE,yBAAyB;AAC3B;;AAEA;E4E9yjBwC,yBAAA;A5EgzjBxC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;E4EzyjBgC,yBAAA;A5E2yjBhC;;AAEA;EACE,sB4EtyjBkC;A5EuyjBpC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;E4E/xjBwB,oCAAA;E5EiyjBtB,sB4EhyjB0B;A5EiyjB5B;;AAEA;;EAEE,sB4E/xjBsB;A5EgyjBxB;;AAEA;E4E1xjBY,eAAA;A5E4xjBZ;;AAEA;EACE,Y4ExxjB8B;A5EyxjBhC;;AAEA;EACE,a4EpxjBc;A5EqxjBhB;;AAEA;EACE,qB4EpxjBkB;E5EqxjBlB,eAAe;E4ElxjBD,iBAAA;E5EoxjBd,kB4EnxjBkB;E5EoxjBlB,e4EnxjBkB;E5EoxjBlB,WAAW;AACb;;AAEA;EACE,0B4EnxjBsB;E5EoxjBtB,+BAA+B;E4EhxjBjB,oBAAA;A5EkxjBhB;;AAEA;E4E7wjBgC,kBAAA;E5E+wjB9B,U4E9wjBkC;E5E+wjBlC,gBAAgB;E4E7wjBkB,WAAA;E5E+wjBlC,Y4E9wjBsC;E5E+wjBtC,6BAA6B;AAC/B;;AAEA;E4E7wjBoC,WAAA;E5E+wjBlC,kB4E9wjBsC;E5E+wjBtC,aAAa;E4E7wjBqB,OAAA;E5E+wjBlC,W4E9wjBsC;E5E+wjBtC,WAAW;E4EvwjBe,yBAAA;E5EywjB1B,U4ExwjB8B;E5EywjB9B,yBAAyB;AAC3B;;AAEA;E4ErwjBoB,yBAAA;A5EuwjBpB;;AAEA;EACE,U4EtwjBsB;A5EuwjBxB;;AAEA;;EAEE,yB4EtwjB0B;A5EuwjB5B;;AAEA;E4ErwjB4B,oCAAA;E5EuwjB1B,sB4EtwjB8B;A5EuwjBhC;;AAEA;EACE,oC4EtwjB8B;E5EuwjB9B,sB4EtwjB8B;A5EuwjBhC;;AAEA;EACE,oC4ElwjBkB;E5EmwjBlB,sB4ElwjBkB;A5EmwjBpB;;AAEA;EACE,kBAAkB;E4E7vjBgB,UAAA;A5E+vjBpC;;AAEA;EACE,W4E9vjB0C;E5E+vjB1C,kBAAkB;E4E7vjBoB,SAAA;E5E+vjBtC,O4E9vjB0C;E5E+vjB1C,QAAQ;E4E7vjB8B,2BAAA;E5E+vjBtC,W4E9vjB0C;E5E+vjB1C,oBAAoB;AACtB;;AAEA;E4EzvjBwB,WAAA;E5E2vjBtB,Y4E1vjB0B;E5E2vjB1B,iBAAiB;E4ExvjBa,uBAAA;E5E0vjB9B,qB4EzvjBkC;E5E0vjBlC,mBAAmB;E4EpvjBW,yBAAA;A5EsvjBhC;;AAEA;EACE,yB4EnvjB0B;A5EovjB5B;;AAEA;EACE,qB4EnvjB8B;A5EovjBhC;;AAEA;EACE,qB4EnvjBkC;A5EovjBpC;;AAEA;EACE,yB4E/ujB0B;A5EgvjB5B;;AAEA;EACE,Q4ElujBkC;A5EmujBpC;;A4EvtjBA;EACI,QAAA;A5E0tjBJ;;AAEA;EACE,Q4ExtjBkB;A5EytjBpB;;AAEA;EACE,QAAQ;A4EptjBV;;A5EutjBA;EACE,Q4EptjBA;A5EqtjBF;;AAEA;;EAEE,yB4EptjBA;A5EqtjBF;;AAEA;;EAEE,cAAc;AAChB;;A4EhtjBA;EAEC,gBAAA;A5EktjBD;;AAEA;EACE,iB4EjtjBC;E5EktjBD,kBAAkB;AACpB;;A4E5sjBA;EAEC,oCAAA;E5E8sjBC,W4E7sjBA;A5E8sjBF;;AAEA;EACE,W4E7sjBU;E5E8sjBV,YAAY;E4E7sjBF,yBAAA;E5E+sjBV,a4E9sjBc;E5E+sjBd,kBAAkB;E4E5sjBZ,QAAA;E5E8sjBN,U4E7sjBU;E5E8sjBV,2BAA2B;E4ExsjBjB,kBAAA;E5E0sjBV,U4EzsjBc;A5E0sjBhB;;AAEA;E4EvsjBoB,WAAA;E5EysjBlB,Y4ExsjBsB;E5EysjBtB,yB4ExsjBsB;E5EysjBtB,a4ExsjBsB;E5EysjBtB,kBAAkB;E4EtsjBJ,QAAA;E5EwsjBd,W4EvsjBkB;E5EwsjBlB,2B4EvsjBkB;E5EwsjBlB,kB4EvsjBkB;E5EwsjBlB,UAAU;AACZ;;AAEA;;EAEE,yB4EtsjBkB;E5EusjBlB,eAAe;E4ErsjBG,eAAA;A5EusjBpB;;AAEA;;E4E9rjBA,cAAA;A5EisjBA;;AAEA;;uD4E7rjBG;A5EgsjBH;EACE,wBAAwB;E4E3rjB1B,cAAA;EACA,kBAAA;EAEC,UAAA;E5E4rjBC,U4E3rjBA;E5E4rjBA,W4E3rjBM;E5E4rjBN,oBAAoB;AACtB;;AAEA;EACE,U4E3rjBM;E5E4rjBN,WAAW;E4EzrjBD,iCAAA;EAAA,yBAAA;E5E2rjBV,mB4E1rjBc;A5E2rjBhB;;AAEA;EACE,mBAAmB;E4EhrjBjB,iCAAA;EAAA,yBAAA;E5EkrjBF,mB4EjrjBG;A5EkrjBL;;AAEA;EACE,mBAAmB;EACnB,iCAAyB;EAAzB,yBAAyB;E4E5qjB3B,mBAAA;AACA;;A5E+qjBA;EACE,mBAAmB;E4E3qjBpB,mBAAA;A5E6qjBD;;AAEA;EACE,WAAW;E4E1qjBD,oBAAA;A5E4qjBZ;;AAEA;EACE,mB4EvqjBsB;E5EwqjBtB,iCAAyB;EAAzB,yBAAyB;E4EjqjBvB,gBAAA;A5EmqjBJ;;AAEA;EACE,mB4ElqjBsB;E5EmqjBtB,iCAAyB;EAAzB,yBAAyB;EACzB,gBAAgB;A6E58kBlB;;AAEA;EACC,mBAAA;EACA,gBnDwCY;A1Bs6kBb;;AAEA;E6E58kBC,oCAAA;EACC,sBAAA;A7E88kBF;;AAEA;E6E58kBE,oCAAA;EACA,sBAAA;A7E88kBF;;A6E18kBA;EAGG,aAAA;E7E28kBD,e6E18kBE;E7E28kBF,QAAQ;EACR,YAAY;A6Er8kBd;;A7Ew8kBA;EACE,yB6Er8kBA;E7Es8kBA,W6Er8kBA;E7Es8kBA,gB6Er8kBA;E7Es8kBA,kBAAkB;EAClB,aAAa;E6El8kBf,mBAAA;EACA,eAAA;A7Eo8kBA;;AAEA;EACE,gB6El8kBA;E7Em8kBA,eAAe;AACjB;;A6E97kBA;EAEC,mBAAA;E7Eg8kBC,e6E/7kBA;E7Eg8kBA,Y6E/7kBA;E7Eg8kBA,iBAAiB;AACnB;;A8Ez/kBA;EAEA,mBAAA;EACI,eAAA;EACA,YAAA;EACA,iBAAA;A9E2/kBJ;;A8Ex/kBI;EACI,kBpDoCK;A1Bu9kBb;;A8Ex/kBA;EACC,kBAAA;E9E2/kBC,e8E1/kBC;E9E2/kBD,gB8E1/kBC;E9E2/kBD,sBAAsB;E8Ez/kBvB,gBAAA;E9E2/kBC,W8E1/kBC;A9E2/kBH;;AAEA;E8Ev/kBQ,gBAAA;A9Ey/kBR;;A8Ep/kBgB;EACI,gBpDcP;A1By+kBb;;AAEA;E8Er/kBoB,gBpDjCP;A1BwhlBb;;AAEA;EACE,kBAAkB;E8El/kBJ,UAAA;A9Eo/kBhB;;AAEA;E8El/kBoB,WAAA;EACA,kBAAA;EACA,SAAA;E9Eo/kBlB,OAAO;E8El/kBW,QAAA;EACI,WAAA;E9Eo/kBtB,WAAW;E8Ej/kBG,yBAAA;EACI,YAAA;E9Em/kBlB,WAAW;A8Ej/kBO;;A9Eo/kBpB;E8Ej/kBwB,oCAAA;A9Em/kBxB;;A8E5+kBoB;EACI,oCAAA;A9E++kBxB;;A8E5+kBwB;EACI,sBAAA;A9E++kB5B;;AAEA;E8E7+kB4B,kBpDhCf;E1B+glBX,UAAU;A8E3+kBgB;;A9E8+kB5B;E8Ez+kBoB,WAAA;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;E9E2+kBtB,YAAY;E8Ez+kBU,WAAA;A9E2+kBxB;;AAEA;E8Ez+kB4B,sBAAA;EACI,0BAAA;EACA,YAAA;A9E2+kBhC;;AAEA;E8Ez+kB4B,oCAAA;EACI,iBAAA;A9E2+kBhC;;AAEA;EACE,sBAAsB;E8Er+kBZ,oCAAA;A9Eu+kBZ;;AAEA;E8El+kBI,0BAAA;A9Eo+kBJ;;AAEA;EACE,2BAA2B;A8Ej+kBjB;;A9Eo+kBZ;;uDAEuD;A8E99kBvC;EACI,yBAAA;E9Eg+kBlB,iBAAiB;E8E99kBC,qBAAA;EACI,WAAA;EACA,epD3IX;E1B2mlBX,kBAAkB;E8E99kBA,eAAA;EACI,YAAA;E9Eg+kBtB,yBAAyB;A8E99kBH;;A9Ei+kBxB;E8E99kB4B,QAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;A9Eg+kB5B;;AAEA;E8E79kBoB,kBAAA;A9E+9kBpB;;A8E59kBwB;EACI,uBAAA;EACA,eAAA;A9E+9kB5B;;AAEA;E8E79kB4B,uBAAA;EACA,eAAA;EACA,kBpDtKf;E1BqolBX,MAAM;E8E39kBQ,OAAA;EACI,UAAA;A9E69kBpB;;AAEA;E8E39kBoB,6BAAA;A9E69kBpB;;AAEA;E8E39kBoB,aAAA;A9E69kBpB;;AAEA;E8E39kBoB,aAAA;A9E69kBpB;;AAEA;E8E19kB4B,aAAA;A9E49kB5B;;A8Ex9kBwB;EACI,aAAA;A9E29kB5B;;AAEA;E8Ez9kBgC,aAAA;A9E29kBhC;;AAEA;E8Ez9kBgC,aAAA;A9E29kBhC;;AAEA;EACE,aAAa;A8Ev9kBK;;A9E09kBpB;;uD8Et9kBwB;A9Ey9kBxB;E8Ev9kB4B,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,UAAA;EACA,2BAAA;EACA,uBAAA;A9Ey9kB5B;;A8Et9kBwB;EACI,sBAAA;E9Ey9kB1B,UAAU;A8Ev9kBY;;A9E09kBxB;EACE,yBAAyB;A8Ev9kBC;;A9E09kB5B;6CAC6C;A8Et9kBrB;EACI,gBAAA;A9Ew9kB5B;;AAEA;E8Er9kBwB,gBAAA;A9Eu9kBxB;;AAEA;E8Er9kB4B,YAAA;EACA,UAAA;E9Eu9kB1B,gBAAgB;A8Er9kBU;;A9Ew9kB5B;E8Er9kBgC,sBAAA;A9Eu9kBhC;;AAEA;6C0BhtlBU;A1BktlBV;E8Er9kBgC,kBpDrNnB;E1B4qlBX,gBAAgB;E8El9kBc,mBAAA;A9Eo9kBhC;;A8E18kBoB;EACI,kBAAA;E9E68kBtB,kBAAkB;E8E18kBI,mBAAA;A9E48kBxB;;A8Ez8kB4B;EACI,gBAAA;A9E48kBhC;;AAEA;EACE,OAAO;E8Er8kBO,QAAA;EACI,UAAA;E9Eu8kBlB,WAAW;E8Er8kBG,WAAA;EACI,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBAAA;A9Eu8kBpB;;AAEA;6C8Ep8kBoB;A9Es8kBpB;E8El8kBQ,yBAAA;EACI,kBAAA;E9Eo8kBV,qBAAqB;A8El8kBX;;A9Eq8kBZ;E8El8kBgB,yBAAA;A9Eo8kBhB;;AAEA;E8El8kBgB,yBAAA;A9Eo8kBhB;;AAEA;;E8Ej8kBgB,sBAAA;A9Eo8kBhB;;AAEA;E8El8kBoB,aAAA;EACA,YAAA;A9Eo8kBpB;;AAEA;E8El8kBoB,sBpD1UP;E1B8wlBX,yBAAyB;E8Ej8kBf,kBAAA;EACI,eAAA;EACA,gBAAA;EACA,czEzUL;EyE0UK,kBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;A9Em8kBhB;;A8Eh8kBgB;EACI,qBAAA;EACA,aAAA;A9Em8kBpB;;A8E/7kBwB;;EAEI,yBAAA;EACA,WAAA;E9Ek8kB1B,YAAY;E8Eh8kBc,iBAAA;EACI,kBAAA;EACA,yBAAA;EACA,mCAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;A9Ek8kBhC;;AAEA;;E8E/7kB4B,yBAAA;EACI,WAAA;EACA,qBpDxWpB;A1B0ylBZ;;A8E/7kB4B;EACI,cpDxUnB;A1B0wlBb;;AAEA;EACE,aAAa;A8Eh8kBiB;;A9Em8kBhC;E8Eh8kBgC,cAAA;A9Ek8kBhC;;A8E/7kBgC;EACI,iBpD5X1B;E1B8zlBR,gBAAgB;A8E/7kBU;;A9Ek8kB5B;EACE,UAAU;E8E/7kBoB,WAAA;A9Ei8kBhC;;A8E57kBwB;EACI,yBAAA;A9E+7kB5B;;AAEA;E8Ex7kBgB,sBpD9YJ;A1Bw0lBZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;E8Et7kBQ,cAAA;A9Ey7kBR;;AAEA;E8Er7kBA,eAAA;EACA,gBAAA;EAMoB,uBAAA;E9Ek7kBlB,kB8Ej7kBsB;E9Ek7kBtB,yBAAyB;E8E36kBnB,kBAAA;E9E66kBN,c8E56kBU;E9E66kBV,0BAA0B;AAC5B;;AAEA;EACE,yB8En6kB0B;E9Eo6kB1B,W8En6kB0B;A9Eo6kB5B;;AAEA;EACE,2B8Ej6kBkB;A9Ek6kBpB;;A8E15kBA;EAGQ,UAAA;A9E25kBR;;AAEA;E8Et5kBA,UAAA;A9Ew5kBA;;AAEA;EACE,UAAU;AACZ;;A8Ez4kBA;EAMoB,SAAA;A9Eu4kBpB;;AAEA;E8E/3kBA,yBAAA;AACA;;A9Ek4kBA;EACE,iBAAiB;E8E53kBP,cAAA;E9E83kBV,gB8E73kBc;A9E83kBhB;;A+Ex4lBA;EAAA,yBAAA;AAEA;;A/E44lBA;EACE,sBAAsB;E+Ez4lBxB,mBAAA;EACA,iBAAA;EAEI,mBAAA;A/E04lBJ;;AAEA;EgFr5lBA,eAAA;AAAA;;AhFy5lBA;EgFp5lBQ,UAAA;EACA,gBAAA;AhFs5lBR;;AAEA;EACE,gBAAgB;EgFp5lBV,WAAA;AhFs5lBR;;AAEA;EACE,yBAAyB;EgFp5lBnB,aAAA;AhFs5lBR;;AAEA;EgFl5lBI,oCAAA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,yBtDzBE;A1B66lBV;;AAEA;EACE,eAAe;EgFl5lBT,cAAA;AhFo5lBR;;AAEA;EgFh5lBQ,YAAA;EACI,YAAA;EACA,yBAAA;EhFk5lBV,gBAAgB;AgF/4lBF;;AhFk5lBhB;EACE,yBAAyB;AAC3B;;AAEA;EgFz4lBQ,YtDxCC;EsDyCD,UAAA;AhF24lBR;;AAEA;EgFz4lBQ,QAAA;EACA,OAAA;AhF24lBR;;AAEA;EgFz4lBQ,iBAAA;AhF24lBR;;AAEA;EgFz4lBY,WAAA;EACA,WAAA;AhF24lBZ;;AAEA;EACE,QAAQ;EgFv4lBE,OAAA;AhFy4lBZ;;AAEA;EgFv4lBgB,mBAAA;EACI,aAAA;AhFy4lBpB;;AAEA;EgFv4lBoB,mBAAA;AhFy4lBpB;;AAEA;EgFv4lBoB,YAAA;EhFy4lBlB,iBAAiB;EgFt4lBP,kBAAA;AhFw4lBZ;;AgFp4lBoB;EACI,kBAAA;EhFu4lBtB,OAAO;EACP,MAAM;EgFj4lBR,iBAAA;EACI,WAAA;EACA,YAAA;AhFm4lBJ;;AAEA,4BAA4B;AAC5B;EgFl4lBA,kBAAA;EACI,gBAAA;AhFo4lBJ;;AAEA;EgFl4lBA,kBAAA;EACA,YAAA;EAGQ,aAAA;EhFk4lBN,UgFj4lBU;AhFk4lBZ;;AAEA;EgF73lBA,aAAA;AACA;;AhFg4lBA;EACE,qBAAqB;EACrB,WAAW;EgFt3lBb,YAAA;EACA,iBAAA;EAIY,gBAAA;EhFq3lBV,mBgFp3lBc;EhFq3lBd,mBAAmB;EACnB,6BAA6B;EgF/2lB/B,gDAAA;EAIY,eAAA;EhF82lBV,mBgF72lBc;EhF82lBd,yBAAyB;EgFx2lBf,eAAA;AhF02lBZ;;AAEA;EgFl2lBA,gBAAA;EACA,iCAAA;EAGY,cAAA;EhFk2lBV,kBgFj2lBc;EhFk2lBd,MAAM;EACN,SAAS;EiF1hmBX,QAAA;EAAA,kBAAA;EAGI,YAAA;AjF2hmBJ;;AAEA;EACE,YAAY;EiFzhmBN,aAAA;EACI,kBAAA;EjF2hmBV,kBAAkB;EiFzhmBZ,yBAAA;EACI,8CAAA;AjF2hmBZ;;AAEA;EACE,WAAW;EiFzhmBL,YAAA;EACI,kBAAA;EjF2hmBV,sBAAsB;EiFzhmBhB,4BAAA;EACI,2BAAA;AjF2hmBZ;;AAEA;EACE,yBAAyB;AiFvhmBnB;;AjF0hmBR;6CiFvhmBY;AjFyhmBZ;EACE,kBAAkB;EAClB,WAAW;EkFxjmBL,YAAA;EACI,MAAA;ElF0jmBV,OAAO;EACP,eAAe;EkFtjmBjB,UAAA;AAAA;;AAgSI;EAmCA,aAAA;EAyGA,WAAA;EAmCA,cAAA;EAmCA,8BAAA;EAoCA,mBAAA;EAmCA,yBAAA;EAwBA,aAAA;ElFi/kBF,gBAAgB;EkF/jmBd,kBAAA;AlFikmBJ;;AkF9jmBQ;EACI,eAAA;EACA,cAAA;ElFikmBV,gBAAgB;EkF7jmBE,mBAAA;EACI,gBAAA;EACA,uBxDaX;A1BkjmBb;;AAEA;EkF7jmBwB,eAAA;ElF+jmBtB,cAAc;EkF7jmBQ,qBAAA;EACI,yCAAA;EACA,WAAA;ElF+jmB1B,YAAY;EkF7jmBU,iBAAA;EACI,kBAAA;EACA,kBAAA;ElF+jmB1B,qBAAqB;AkFxjmBH;;AlF2jmBpB;EkFxjmBwB,yBxDhBT;EwDiBS,WAAA;AlF0jmBxB;;AAEA;6CkFxjmB4B;AlF0jmB5B;EkFxjmBwB,aAAA;AlF0jmBxB;;AAEA;EkFxjmBwB,+CAAA;AlF0jmBxB;;AkFvjmB4B;EACI,iBAAA;EACA,cxDhBnB;E1B0kmBX,SAAS;AkFvjmBqB;;AlF0jmBhC;EkFrjmBwB,yBAAA;EACI,mBAAA;ElFujmB1B,yBAAyB;EkF3imBH,WAAA;AlF6imBxB;;AkFhimBwB;EACI,WAAA;AlFmimB5B;;AAEA;EACE,gBAAgB;AkF5gmBU;;AlF+gmB5B;EkFtgmBI,gBAAA;AlFwgmBJ;;AAEA;EkFtgmBQ,2BAAA;ElFwgmBN,4BAA4B;EkFrgmBtB,2BAAA;AlFugmBR;;AkFlgmBwB;EACI,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;AlFqgmB5B;;AAEA;EACE,iBAAiB;EkFngmBS,8BAAA;AlFqgmB5B;;AkF7/lBwB;EACI,yBAAA;AlFggmB5B;;AAEA;EkF1/lBQ,yBAAA;AlF4/lBR;;AAEA;EkFp/lBwB,yBAAA;AlFs/lBxB;;AkF/+lBwB;EACI,eAAA;AlFk/lB5B;;AAEA;EACE,aAAa;AkFn+lBa;;AlFs+lB5B;EkF59lBQ,aAAA;AlF89lBR;;AkF39lBY;EACI,cAAA;AlF89lBhB;;AAEA;;;;;EAKE,sBAAsB;AkF39lBI;;AlF89lB5B,oBAAoB;AkFt9lBZ;EACI;IACA,wBAAA;EACA;;EAQY;IACI,eAAA;ElFk9lB1B;;EkF38lB0B;IlF88lBxB,eAAe;EkFj8lBK;;EAEI;IlFm8lBxB,eAAe;EkFv7lBK;;ElF07lBtB;IkFz7lB0B,eAAA;EACI;;EAEJ;IACI,0BAAA;ElF27lB9B;;EkFz6lBkC;IlF46lBhC,YAAY;IkF16lBgB,aAAA;EACI;;EAOR;IACI,eAAA;EACA;;EACA;IACI,aAAA;ElFw6lBlC;;EkFr6lBkC;IlFw6lBhC,YAAY;EkFv5lBgB;;ElF05lB9B;IkFv5lB8B,YAAA;EACI;AlFy5lBpC;;AAEA;EkFl5lBgC;IlFo5lB5B,gBAAgB;EkFn5lBY;AlFq5lBhC;;AkFl5lBgC,uCAAA;AlFq5lBhC;EACE;IkFv4lBsB,wBAAA;EACI;;EAEI;IACI,eAAA;ElFy4lBlC;AkFv4lB8B;;AlF04lBhC,wCAAwC;AkFl4lBZ;EACI;IACA,eAAA;EACA;;EACA;IACI,8BAAA;ElFq4lBlC;;EkFl4lBkC;IlFq4lBhC,6BAA6B;EkFr3lBD;;ElFw3lB9B;IkFr3lB8B,qCAAA;EACI;;EAOR;IACI,uBAAA;IACA,wCAAA;ElFk3lB9B;AkFj3lB8B;;AlFo3lBhC,yCAAyC;AkFj3lBT;EACI;IlFm3lBhC,wBAAwB;EkFl2lBI;;ElFq2lB9B;IkFl2lB8B,4BAAA;EACI;;EAOR;IACI,4BAAA;IACA,+BAAA;ElF+1lB9B;;EkF71lBkC;IlFg2lBhC,eAAe;EkF91lBa;;ElFi2lB9B;IkF/0lB8B,8BAAA;EACI;;EAEJ;IACI,6BAAA;ElFi1lBlC;;EkFz0lB8B;IACA,qCAAA;ElF40lB9B;;EkF10lBkC;IlF60lBhC,uBAAuB;IkF30lBK,wCAAA;EACI;AlF60lBpC;;AAEA,yCkF7zlBoC;AlF8zlBpC;EkF5zlBgC;IACI,4BAAA;IlF8zlBhC,+BAA+B;EkFvzlBP;AlFyzlB5B;;AAEA;EkFxzlBgC;IACI,8BAAA;ElF0zlBlC;;EkFvzlBkC;IlF0zlBhC,YAAY;EkFxylBgB;AlF0ylBhC;;AkFvylBgC;EACI;IlF0ylBhC,YAAY;EkFnylBY;AlFqylB5B;;AAEA;EkFpylBgC;IACI,kBAAA;ElFsylBlC;;EkFnylBkC;IlFsylBhC,WAAW;IkF1xlBH,kBAAA;IACI,MAAA;IlF4xlBZ,UAAU;IkFxxlBc,2BAAA;IACI,YAAA;IACA,YAAA;IlF0xlB5B,yBAAyB;EkFzxlBG;;ElF4xlB9B;IkFzxlB8B,aAAA;EACI;AlF2xlBpC;;AAEA;EkF3wlBgC;IlF6wlB5B,cAAc;IkF/vlBU,UAAA;EACI;;ElFkwlB9B;IkFnvlB0B,cAAA;IACI,UAAA;EACA;AlFqvlBhC;;AAEA;EkFxulB4B,axDhpBf;A1B03mBb;;AAEA;EACE,mBAAmB;EkFzulBO,kBAAA;AlF2ulB5B;;AkFnulBwB;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;AlFsulB5B;;AAEA;EACE,aAAa;AkFrulBa;;AlFwulB5B;EkF7tlBY,sBAAA;AlF+tlBZ;;AkF7tlBgB;EACI,UAAA;ElFgulBlB,oBAAoB;AkF7tlBM;;AlFgulB5B;EkF7tlBgC,QAAA;AlF+tlBhC;;AAEA;EkF7tlBgC,qBAAA;AlF+tlBhC;;AAEA;EACE,qBAAqB;AkF7tlBS;;AlFgulBhC;EkFrtlBQ,gCAAA;AlFutlBR;;AAEA;;;;;EAKE,gCAAgC;EkFrtlB1B,oCAAA;AlFutlBR;;AAEA;6CkFntlBA;AlFqtlBA;EACE,yBAAyB;AkFntlBvB;;AlFstlBJ;EACE,oCAAoC;EkFntlBlC,sBAAA;AlFqtlBJ;;AAEA;6CkFntlBQ;AlFqtlBR;EkFntlBQ,mBAAA;AlFqtlBR;;AkFjtlBA;EACA,mBAAA;AlFotlBA;;AAEA;EkFltlBY,oCAAA;ElFotlBV,sBkFntlBc;AlFotlBhB;;AAEA;EACE,UAAU;EkF9slBA,yBAAA;AlFgtlBZ;;AAEA;EACE,UkF7slBc;AlF8slBhB;;AAEA;EACE,UAAU;AACZ;;AAEA;EkF7rlBgC,kBAAA;ElF+rlB9B,UkF9rlBkC;AlF+rlBpC;;AAEA;EACE,WAAW;EkFvrlBmB,kBAAA;ElFyrlB9B,SkFxrlBkC;ElFyrlBlC,OAAO;EkF3qlBe,WAAA;ElF6qlBtB,YkF5qlB0B;ElF6qlB1B,sBAAsB;EkFpqlBhB,WAAA;AlFsqlBR;;AAEA;EACE,akFlqlBM;AlFmqlBR;;AAEA;EACE,UAAU;EkFjqlBR,YAAA;ElFmqlBF,yBkFlqlBM;ElFmqlBN,gBAAgB;EkFjqlBd,iDAAA;ElFmqlBF,4BkFlqlBM;AlFmqlBR;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AkFzplBA;;EAOoB;;IlFwplBhB,oBAAoB;EkF/olBJ;;ElFkplBlB;IACE,oBAAoB;EkFzolBxB;AlF2olBA;;AAEA;EkFzolBY,kBAAA;AlF2olBZ;;AAEA;EACE,iBkFpolBsB;ElFqolBtB,kBAAkB;EAClB,iBAAiB;EkF7nlBnB,mBAAA;EAIY,cAAA;ElF4nlBV,kBkF3nlBc;ElF4nlBd,UAAU;EkFxnlBA,YAAA;ElF0nlBV,UkFznlBc;AlF0nlBhB;;AAEA;EACE,yBAAyB;EkFpnlBf,WAAA;ElFsnlBV,WkFrnlBc;ElFsnlBd,kBAAkB;EkFlnlBR,yBAAA;ElFonlBV,UkFnnlBc;AlFonlBhB;;AAEA;EACE,yBAAyB;EkF9mlBf,WAAA;AlFgnlBZ;;AAEA;EACE,oCkF7mlBc;AlF8mlBhB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EkFvmlBA,sBAAA;AACA;;AlF2mlBA;EkFvmlBQ,sBAAA;AlFymlBR;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AkFzllBxB;;AlF4llBA;EACE,uBAAuB;AACzB;;AAEA;EkFlllBY,oCAAA;AlFollBZ;;AAEA;EkF9klBA,yBAAA;AACA;;AlFillBA;;EAEE,sBAAsB;AACxB;;AAEA;EkF7jlBoB,sBAAA;AlF+jlBpB;;AAEA;EkFvjlBA,sBAAA;AACA;;AlF0jlBA;EACE,sBAAsB;AACxB;;AAEA;EkFhjlBY,uBAAA;AlFkjlBZ;;AAEA;EACE,oCkF/ilBc;AlFgjlBhB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,sBkFlilBkC;AlFmilBpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EkFthlBI,sBAAA;AlFwhlBJ;;AAEA;EkFrhlBA,sBAAA;AlFuhlBA;;AAEA;EkFrhlBY,uBAAA;AlFuhlBZ;;AAEA;EACE,akFphlBc;AlFqhlBhB;;AAEA;EACE,eAAe;EkF5glBG,YAAA;AlF8glBpB;;AAEA;EACE,ekFvglBsB;AlFwglBxB;;AkF//kBA;EACA,wBAAA;AlFkglBA;;AAEA;EkF3/kBY,yBAAA;ElF6/kBV,oCkF5/kBc;ElF6/kBd,sBAAsB;AACxB;;AAEA;EkFv/kBY,qBAAA;ElFy/kBV,6BkFx/kBc;AlFy/kBhB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EkF9+kBvB,6BAAA;EACA,8BAAA;AlFg/kBA;;AAEA;EkFz+kBY,YAAA;AlF2+kBZ;;AAEA;EACE,kBkFx+kBc;ElFy+kBd,mBAAmB;AACrB;;AAEA;EkF99kBY,qBAAA;ElFg+kBV,kBkF/9kBc;ElFg+kBd,mBAAmB;AACrB;;AAEA;EkF19kBY,YAAA;AlF49kBZ;;AAEA;EACE,yBkFz9kBc;AlF09kBhB;;AAEA;EACE,aAAa;AACf;;AkFj9kBA;EAEI,aAAA;AlFm9kBJ;;AAEA;EkF98kBA,cAAA;AlFg9kBA;;AAEA;EkFz8kBY,4BAAA;AlF28kBZ;;AAEA;EACE,0BkFx8kBc;AlFy8kBhB;;AAEA;EACE;IACE,YAAY;EkFl8kBhB;;ElFq8kBE;IACE,YAAY;EkFv7kBI;AlFy7kBpB;;AAEA;EACE;IACE,YAAY;EkFl7kBJ;AlFo7kBZ;;AAEA;EACE;IACE,YAAY;EACd;AmFhunBF;;AAGI;EACI,YAAA;AnFiunBR;;AAEA;EmF/tnBY,WAAA;EACA,WAAA;AnFiunBZ;;AAEA;EmF/tnBY,sBzDZC;A1B6unBb;;AAEA;EACE,mBAAmB;AmF/tnBT;;AnFkunBZ;;EmF9tnBoB,yBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AnFiunBpB;;AAEA;;EmF7tnBgB,eAAA;AnFgunBhB;;AAEA;;EAEE,YAAY;EmF9tnBE,oBAAA;AnFgunBhB;;AmFttnBQ;EACI,yBAAA;EnFytnBV,mBAAmB;EACnB,sBAAsB;EoF3wnBxB,YAAA;AAAA;;ApF+wnBA;EACE,sBAAsB;EoF1wnBpB,sBAAA;ApF4wnBJ;;AAEA;EACE,kBAAkB;EoFzwnBZ,kBAAA;ApF2wnBR;;AoFvwnBI;EACI,+BAAA;EpF0wnBN,kBAAkB;AACpB;;AAEA;EoFvwnBQ,sBAAA;ApFywnBR;;AAEA;EACE,iBAAiB;EoFvwnBf,mBAAA;ApFywnBJ;;AAEA;EoFvwnBI,eAAA;EACI,mBAAA;EpFywnBN,iBAAiB;EACjB,gCAAgC;AoFrwnBlC;;AAEA;EACI,qBAAA;EACA,uBAAA;ApFuwnBJ;;AoFpwnBI;EACI;IACA,uBAAA;EpFuwnBN;AoFpwnBU;;ApFuwnBZ;EACE;IoFnwnBM,uBAAA;EACI;ApFqwnBZ;;AAEA;EoFnwnBY,kBAAA;ApFqwnBZ;;AAEA;EACE,mBAAmB;EoFjwnBb,mBAAA;ApFmwnBR;;AAEA;EACE,kBAAkB;EoFhwnBhB,mBAAA;ApFkwnBJ;;AoF9vnBQ;;EpFkwnBN,eAAe;AoF/vnBT;;ApFkwnBR;;EoF9vnBY,eAAA;ApFiwnBZ;;AoF9vnBgB;;EAEI,eAAA;ApFiwnBpB;;AAEA;;EoF9vnBoB,eAAA;ApFiwnBpB;;AAEA;;EoFtvnBgB,eAAA;ApFyvnBhB;;AAEA;;EoFlvnBY,eAAA;ApFqvnBZ;;AoF/unBQ;;EAEI,gBAAA;EpFkvnBV,gBAAgB;EoFhvnBV,kBAAA;ApFkvnBR;;AoF9unBY;;EpFkvnBV,gBAAgB;EoF5unBV,kBAAA;ApF8unBR;;AoF3unBQ;;EpF+unBN,cAAc;EoF3unBZ,eAAA;ApF6unBJ;;AAEA;;EAEE,gBAAgB;AqFh4nBlB;;AAEA;EACI,sBAAA;ArFk4nBJ;;AAEA;EqFj4nBA,+BAAA;EACI,kBAAA;ArFm4nBJ;;AAEA;EqFl4nBA,sBAAA;ArFo4nBA;;AAEA;EqFj4nBQ,gBAAA;EACI,iBAAA;ArFm4nBZ;;AAEA;;EAEE,eAAe;EqFj4nBL,mBAAA;ArFm4nBZ;;AAEA;EqFj4nBgB,kBAAA;EACA,uBAAA;ArFm4nBhB;;AAEA;EACE,iBAAiB;EqFj4nBP,gCAAA;EACI,eAAA;EACA,mBAAA;ArFm4nBhB;;AAEA;EqFj4nBoB;IACA,sBAAA;ErFm4nBlB;AACF;;AAEA;EACE;IqF93nBM,iBAAA;IACI,kBAAA;IACA,mBAAA;EACA;;EAEA;IACA,eAAA;IrFg4nBR,gBAAgB;IqF73nBR,2BAAA;EACI;ArF+3nBhB;;AqF13nBY;EACI;IACA,kB3D7DN;I2D8DM,mBhF1DL;ELu7nBT;;EqFv3nBkB;IrF03nBhB,eAAe;IACf,gBAAgB;IqFp3nBpB,2BAAA;EACA;ArFs3nBA;;AAEA;EACE;IqF72nBF,kBAAA;IACA,mBAAA;EAKY;;ErF42nBV;IACE,kBAAkB;IqFr2nBtB,mBAAA;EC1GA;AAAA;;AtFo9nBA;EsFh9nBI,aAAA;AtFk9nBJ;;AAEA;EsFj9nBI,gBAAA;AtFm9nBJ;;AAEA;EsFj9nBQ,qDAAA;EACA,iDAAA;AtFm9nBR;;AAEA;EsFj9nBI,mBAAA;EACI,kBAAA;EtFm9nBN,mBAAmB;AsFl9nBb;;AtFq9nBR;EsFl9nBY,0BAAA;AtFo9nBZ;;AAEA;EACE,2BAA2B;AsFn9nBjB;;AtFs9nBZ;EsFn9nBgB,iBAAA;EACA,oBAAA;EACA,kB5D1BN;E4D2BM,mB5DcH;A1Bu8nBb;;AAEA;EsFl9nBgB,0BAAA;AtFo9nBhB;;AsF/8nBgB;EACI,2B5DXN;A1B69nBd;;AAEA;EACE,iBAAiB;EsF58nBX,gBAAA;AtF88nBR;;AsF58nBY;EACI,mBAAA;EACA,WAAA;AtF+8nBhB;;AAEA;EsF78nBgB,WAAA;EACA,yBAAA;AtF+8nBhB;;AAEA;EsF98nBoB;IACA,uBAAA;EACA;AtFg9nBpB;;AAEA;EsF98nBoB;IACA,kBAAA;ItFg9nBhB,mBAAmB;EsF58nBf;;EtF+8nBN;IsF38nBkB,0BAAA;EACI;AtF68nBxB;;AsFv8nBQ;EACI,uBAAA;EtF08nBV,kBAAkB;EAClB,mBAAmB;AsFv8nBrB;;AtF08nBA;EACE,iBAAiB;AsFx8nBf;;AtF28nBJ;EsFx8nBQ,iBAAA;EtF08nBN,gBAAgB;AsFx8nBd;;AtF28nBJ;EsFx8nBQ,mBAAA;EACA,WAAA;AtF08nBR;;AAEA;EsFz8nBY,WAAA;EACA,yBAAA;AtF28nBZ;;AAEA;EsFz8nBY,mBAAA;EACA,mBAAA;EtF28nBV,qBAAqB;EsFx8nBX,uBAAA;EACI,sBAAA;EtF08nBd,yBAAyB;EsFt8nBf,eAAA;EACI,qBAAA;AtFw8nBhB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AsFj8nBb;;AtFo8nBA;EACE,iBsFj8nBM;EtFk8nBN,gBAAgB;AAClB;;AAEA;EsFj8nBQ,mBAAA;EtFm8nBN,WsFl8nBU;AtFm8nBZ;;AAEA;EACE,WsFn8nBc;EtFo8nBd,yBAAyB;AAC3B;;AAEA;EsFh8nBoB;IACI,iBAAA;ItFk8nBpB,kBAAkB;EsF97nBV;;EtFi8nBV;IsF97nBc,eAAA;EtFg8nBd;AACF;;AAEA;EsF97nBY;IACI,kBAAA;EtFg8nBd;AACF;;AAEA;EACE;IsF97nBc,YAAA;EtFg8nBd;AACF;;AuF3moBA;EAAA,iBAAA;EAEA,oBAAA;AvF8moBA;;AuF5moBI;EACI;IACA,YAAA;EACA;AvF+moBR;;AAEA;EuF7moBQ,mBAAA;EvF+moBN,sBAAsB;AuF5moBhB;;AvF+moBR;EACE;IuF3moBF,YAAA;EACI;;EAEA;IvF6moBA,eAAe;EACjB;;EuF3moBE;IACA,eAAA;EvF8moBF;AACF;;AuF3moBA;EAGQ;IACI,eAAA;EvF4moBV;;EAEA;IACE,eAAe;EACjB;AuFvmoBF;;AvF0moBA;qCuFrmoBY;AvFumoBZ;EuFpmoBI,eAAA;EvFsmoBF,MuFrmoBM;EvFsmoBN,OAAO;EACP,YAAY;EuFlmoBd,YAAA;EACA,yBAAA;EAGQ,oBAAA;EvFkmoBN,sBuFjmoBU;AvFkmoBZ;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AuF7loBlC;;AvFgmoBA;EACE,eAAe;EuF1loBb,kBAAA;EvF4loBF,SuF3loBM;EvF4loBN,UuF3loBM;EvF4loBN,yBuF3loBM;EvF4loBN,gBAAgB;AAClB;;AwF9qoBA;EAII,gCAAA;AxF8qoBJ;;AAEA;EwF5qoBQ,yBAAA;ExF8qoBN,sBAAsB;AwF5qoBpB;;AxF+qoBJ;EwF5qoBQ,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;ExF8qoBN,WAAW;EwF5qoBL,YAAA;EACI,gBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;AxF8qoBZ;;AwF3qoBY;EACI,UAAA;AxF8qoBhB;;AwFxqoBI;EACI,gBAAA;AxF2qoBR;;AwFvqoBI;EACI,mBAAA;AxF0qoBR;;AAEA;EACE,gBAAgB;AwFzqoBV;;AxF4qoBR;EACE,YAAY;EwF1qoBF,6BAAA;AxF4qoBZ;;AwFxqoBQ;EACI,YAAA;EACA,6BAAA;ExF2qoBV,kBAAkB;AwFzqoBZ;;AxF4qoBR;EACE,6BAA6B;EwFxqoB/B,kBAAA;EACC,YAAA;ExF0qoBC,gBAAgB;EwFzqoBjB,gBAAA;EACC,mBAAA;EACA,a9D9DW;E8D+DX,mBAAA;EACA,yBAAA;AxF2qoBF;;AAEA;EACE,WAAW;EwF1qoBL,YAAA;EACI,wBAAA;AxF4qoBZ;;AAEA;EwFzqoBC,iBAAA;EACC,eAAA;EACA,WAAA;AxF2qoBF;;AAEA;EwFzqoBE,yBAAA;AxF2qoBF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AwFxqoBR;;AxF2qoBR;EwFvqoBY,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;ExFyqoBV,eAAe;EwFvqoBL,gBAAA;EACG,WAAA;EACA,YAAA;ExFyqoBb,iBAAiB;EACjB,kBAAkB;EwFpqoBpB,kBAAA;EAKA,QAAA;EAKA,WAAA;EAKA,2BAAA;AAKA;;AChIA;EAEA,yBAAA;AzFuxoBA;;AyFpxoBI;EACI,UAAA;AzFuxoBR;;AyFpxoBI;EACI,qBAAA;EACA,kBAAA;AzFuxoBR;;AAEA;EyFrxoBQ,qBAAA;EzFuxoBN,eAAe;EyFrxoBb,gBAAA;EACI,cAAA;EACA,mBAAA;EzFuxoBN,kBAAkB;EyFrxoBhB,aAAA;EACI,mBAAA;AzFuxoBR;;AyFpxoBI;EACI,yBAAA;AzFuxoBR;;AyFpxoBI;EACI,yBAAA;EACA,WAAA;EzFuxoBN,YAAY;EyFrxoBV,eAAA;EACI,cAAA;EACA,qBAAA;EzFuxoBN,kBAAkB;EyFrxoBhB,kBAAA;EACI,kBAAA;EACA,gBAAA;AzFuxoBR;;AAEA;EyFrxoBQ,WAAA;EzFuxoBN,kBAAkB;EyFrxoBhB,QAAA;EACI,UAAA;EACA,UAAA;EzFuxoBN,WAAW;EyFrxoBT,yBAAA;EACI,kBAAA;EACA,wBAAA;EzFuxoBN,WAAW;AyFrxoBT;;AzFwxoBJ;EACE,yBAAyB;EyFrxoBvB,cAAA;AzFuxoBJ;;AAEA;EyFrxoBI,yBAAA;AzFuxoBJ;;AAEA;EyFrxoBI,iBAAA;EACI,eAAA;EACA,WAAA;AzFuxoBR;;AAEA;EyFrxoBQ,yBAAA;AzFuxoBR;;AAEA;;EAEE,yBAAyB;EyFrxoBvB,cAAA;AzFuxoBJ;;AAEA;;EyFpxoBQ,cAAA;AzFuxoBR;;AyFpxoBI;;EAEI,UAAA;EzFuxoBN,qBAAqB;AyFrxoBnB;;AzFwxoBJ;;EyFpxoBI,kBAAA;AzFuxoBJ;;AAEA;EyFrxoBI,UAAA;EACI,eAAA;EACA,gBAAA;AzFuxoBR;;AAEA;EyFrxoBQ,kBAAA;AzFuxoBR;;AAEA;EACE,mBAAmB;EyFrxoBjB,kBAAA;EACI,yBAAA;EzFuxoBN,kBAAkB;EyFrxoBhB,eAAA;EACI,WAAA;EzFuxoBN,aAAa;EyFrxoBX,mBAAA;AzFuxoBJ;;AAEA;EyFpxoBI,WAAA;EAEQ,kBAAA;EzFqxoBV,QyFpxoBc;EzFqxoBd,2ByFpxoBc;EzFqxoBd,WAAW;EACX,YAAY;EyFjxoBV,sBAAA;EACI,UAAA;EACA,mBAAA;EzFmxoBN,yBAAyB;AyFhxoBf;;AzFmxoBZ;;EyFxwoBwB,yBAAA;EACI,cAAA;AzF2woB5B;;AyFxwoBwB;;EAEI,UAAA;EzF2woB1B,qBAAqB;AyFnwoBP;;AzFswoBhB;;EyFlwoBgB,kBAAA;AzFqwoBhB;;AAEA;EyF/voBgB,kBAAA;EACI,cAAA;EACA,UAAA;EzFiwoBlB,gBAAgB;AyF/voBE;;AzFkwoBpB;EACE,eAAe;EyFvvoBD,gBAAA;EACI,WAAA;EACA,cAAA;EzFyvoBlB,kBAAkB;AyFvvoBJ;;AzF0voBhB;EACE,aAAa;AyFtvoBK;;AzFyvoBpB;EyFtvoBwB;IzFwvoBpB,WAAW;IyFpvoBH,UAAA;IACI,yBAAA;EzFsvoBd;;EyFhvoBkB;IACA,kBAAA;IzFmvoBhB,mBAAmB;EyFlvoBH;;EAEI;IzFovoBpB,OAAO;IyFlvoBS,UAAA;IACI,kBAAA;EACA;;EACA;IACI,aAAA;IACA,oBAAA;EzFqvoB1B;;EyF5uoBU;IACA,aAAA;EzF+uoBV;;EyF1uoBsB;IACA,aAAA;EzF6uoBtB;;EyF1uoB0B;IzF6uoBxB,eAAe;EyF3uoBS;;EAEI;IzF6uoB5B,aAAa;EyF1uoBO;;EAEI;IzF4uoBxB,aAAa;EyFtuoBL;;EzFyuoBV;IyFruoBc,aAAA;EACI;;EzFwuoBlB;IyFruoBc,aAAA;EACI;;EzFwuoBlB;IyFruoBkB,aAAA;EACI;;EzFwuoBtB;IyFpuoBc,gBAAA;IACI,mBAAA;EzFsuoBlB;;EyF9toBU;IACA,gBAAA;IzFiuoBR,YAAY;IyF5toBJ,kBAAA;IACI,yBAAA;EACA;;EACA;IACI,QAAA;IzF+toBhB,WAAW;IyF5toBK,WAAA;IACI,WAAA;IACA,kBAAA;IzF8toBpB,2BAA2B;IyFvtoB3B,mBAAA;EACI;;EzF0toBN;IACE,YAAY;IACZ,qDAAqD;EyFrtoBjD;;EAEI;IzFutoBR,cAAc;EyFptoBd;;EAEI;IzFstoBJ,aAAa;EyFntoBT;;EAEI;IzFqtoBR,cAAc;EyFltoBd;;EAEI;IzFotoBJ,iBAAiB;EyFltoBb;;EAEI;IzFotoBR,cAAc;EyFltoBV;;EAEI;IzFotoBR,cAAc;EyFjtoBd;;EAEI;IzFmtoBJ,cAAc;EyF3soBU;;EAEI;IzF6soB5B,kBAAkB;EyF3soBM;;EAEI;IzF6soB5B,cAAc;EyFrsoBU;;EAEI;IzFusoB5B,gBAAgB;IyFrsoBQ,gBAAA;EACI;;EzFwsoB9B;IyF1roB8B,kBAAA;IACI,eAAA;EACA;;EAEJ;IACI,aAAA;EACA;;EAOxB;IACI,UAAA;IACA,UAAA;IzFuroBZ,mBAAmB;EyFjroBX;;EAEI;IzFmroBZ,qBAAqB;IyF/qoBrB,qBAAA;IACI,sBAAA;EzFiroBN;;EyF9qoBM;IzFiroBJ,kBAAkB;EyF/qoBlB;;EzFkroBF;IyFhroBM,wBAAA;EACI;;EzFmroBV;IyFhroBM,WAAA;IACI,UAAA;IACA,yBAAA;EACA;;EAIJ;IACI,wBAAA;EzFgroBV;;EyF7qoBU;IzFgroBR,kBAAkB;IyF9qoBd,mBAAA;EACI;;EAGR;IACI,OAAA;IzF+qoBJ,UAAU;IyF9qoBN,kBAAA;EACI;;EAGR;IACI,aAAA;IACA,oBAAA;EzF+qoBN;;EyF3qoBU;IACA,aAAA;EzF8qoBV;;EyF1qoBM;IACA,aAAA;EzF6qoBN;;EyF1qoBM;IACA,eAAA;EzF6qoBN;;EyFzqoBU;IACA,aAAA;EzF4qoBV;;EyFxqoBc;IACA,aAAA;EzF2qoBd;;EyFtqoBM;IACA,aAAA;EzFyqoBN;;EyFrqoBU;IACA,aAAA;EACA;;EzFyqoBV;IyFvqoBU,aAAA;EACI;;EzF0qoBd;IyFtqoBM,gBAAA;IACI,mBAAA;EACA;;EAGR;IACI,gBAAA;IACA,YAAA;IzFuqoBJ,kBAAkB;IyFrqoBlB,yBAAA;EACI;;EzFwqoBN;IyFtqoBM,QAAA;IACI,WAAA;IACA,WAAA;IzFwqoBR,WAAW;IyFvqoBH,kBAAA;IACI,2BAAA;IACA,mBAAA;EzFyqoBd;;EyFnqoBU;IACA,YAAA;IzFsqoBR,qDAAqD;EyFnqoBrD;;EzFsqoBF;IyFnqoBE,cAAA;EACI;;EAEJ;IACI,aAAA;EzFqqoBN;;EyFlqoBM;IzFqqoBJ,cAAc;EyFnqoBd;;EAEI;IzFqqoBJ,iBAAiB;EyFnqoBjB;;EAEI;IzFqqoBJ,cAAc;EyFnqoBd;;EAEI;IzFqqoBJ,cAAc;EyFnqoBd;;EAEI;IzFqqoBJ,cAAc;EyFnqoBd;;EAEI;IzFqqoBJ,kBAAkB;EyFnqoBlB;;EAEI;IzFqqoBJ,cAAc;EyFnqoBd;;EAEI;IzFqqoBJ,gBAAgB;IyFnqoBhB,gBAAA;EACI;;EAEJ;IACI,kBAAA;IzFqqoBJ,eAAe;EyFnqoBf;;EzFsqoBF;IyFnqoBE,aAAA;EACI;;EAEJ;IACI,UAAA;IzFqqoBJ,UAAU;IyFnqoBV,mBAAA;EACI;;EAEJ;IACI,gBAAA;EzFqqoBN;AyFnqoBE;;AzFsqoBJ;EyFnqoBI,qBAAA;AzFqqoBJ;;AyFlqoBI;EACI;IACA,kBAAA;IACA,oBAAA;EACA;AzFqqoBR;;AAEA,oByFjqoBoB;AzFkqoBpB;EACE;IyF7poBE,MAAA;IACI,UAAA;IzF+poBJ,uBAAuB;EyF9poBnB;;EAEI;IzFgqoBR,eAAe;IyF/poBP,cAAA;EACI;;EAIZ;IACI,gBAAA;EACA;AzF+poBR;;AyF7poBQ,uCAAA;AzFgqoBR;EACE;IyF7poBE,eAAA;EACI;;EzFgqoBN;IACE,gBAAgB;EAClB;AyF5poBE;;AzF+poBJ,qByF7poBY;AzF8poBZ;EACE;IyF5poBM,UAAA;IACI,YAAA;EzF8poBV;;EAEA;IyFxpoBkB,gCAAA;EACI;;EzF2poBtB;IyFppoBE,UAAA;EACI;;EzFupoBN;IyFrpoBM,sBAAA;EACI;;EAEA;IzFupoBR,YAAY;IyFrpoBR,OAAA;IACI,iDAAA;EACA;;EAGR;IACI,UAAA;IACA,UAAA;IzFspoBJ,mBAAmB;EyFrpoBf;;EAEI;IzFupoBR,qBAAqB;IyFppoBrB,qBAAA;IACI,sBAAA;EACA;;EAEJ;IACI,qBAAA;IzFspoBJ,aAAa;IyFnpoBT,iBAAA;IACI,oBAAA;EACA;;EAGR;IACI,cAAA;EzFopoBN;AACF;;AAEA,wCAAwC;AyFlpoBpC;EACI;IACI,eAAA;EzFopoBV;;EAEA;IyFlpoBE,gBAAA;EACI;AzFopoBR;;AAEA,yCAAyC;AACzC;EyFlpoBI;IACI,YAAA;IACA,UAAA;EzFopoBN;;EyF5ooB0B;IACA,kBAAA;IzF+ooBxB,mBAAmB;IyF9ooBK,iBAAA;EACI;;EzFipoB9B;IyFxooBE,eAAA;EACI;;EAEJ;IACI,SAAA;EzF0ooBN;;EAEA;IACE,kBAAkB;EyFxooBlB;;EzF2ooBF;IyFxooBU,UAAA;EzF0ooBV;AACF;;AAEA,yCyFxooBY;AzFyooBZ;EACE;IyFtooBE,YAAA;EACI;;EzFyooBN;IyFtooBU,kBAAA;IzFwooBR,mBAAmB;IyFtooBX,iBAAA;EzFwooBV;;EAEA;IyFtooBc,eAAA;EzFwooBd;;EAEA;IACE,SAAS;EyFpooBG;;EzFuooBd;IACE,kBAAkB;EyFlooBd;;EzFqooBN;IACE,UAAU;EyFhooBF;AzFkooBZ;;AAEA;6CyF9noBI;AzFgooBJ;EACE,mByF1noB0B;EzF2noB1B,yByF1noB0B;EzF2noB1B,mBAAmB;EyFvnoBL,iBAAA;AzFynoBhB;;AAEA;EyFhnoB4B,mBAAA;EzFknoB1B,yByFjnoB8B;EzFknoB9B,aAAa;EACb,sBAAsB;EyF3moBpB,uBAAA;EACI,kBAAA;AzF6moBR;;AAEA;EACE;IyF1moBE,kBAAA;EACI;AzF4moBR;;AAEA,yCAAyC;AACzC;EyFzmoBI;IACI,mB/DlzBE;I1B65pBN,yBAAyB;IyFxmoBrB,mBAAA;EACI;AzF0moBZ;;AAEA,yCyF1moBgB;AzF2moBhB;EyFzmoBY;IACI,mBAAA;IzF2moBZ,yBAAyB;IyFpmoBjB,mBAAA;EACI;AzFsmoBhB;;AyFjmoBI,qBAAA;AzFomoBJ;EACE;IyFlmoBE,kBAAA;IACI,mBAAA;EACA;AzFomoBR;;AAEA;6CAC6C;AyF/loBrC;EACI,kBAAA;EzFimoBV,gBAAgB;EyF9loBd,MAAA;EACI,UAAA;AzFgmoBR;;AAEA;EACE,qDAAqD;AyF5loB/C;;AzF+loBR;EyF1loBQ;IACI,UAAA;IACA,mCAAA;EzF4loBV;;EyFzloBU;IzF4loBR,UAAU;IyFnloBc,wBAAA;EACI;AzFqloBhC;;AAEA;EACE,kBAAkB;AyF5koBZ;;AzF+koBR;EACE,yBAAyB;EyFxkoBnB,eAAA;EACI,kBAAA;EACA,UAAA;EzF0koBV,WAAW;AyFxkoBD;;AzF2koBZ;EACE,cAAc;AyFvkoBJ;;AzF0koBZ;EACE,YAAY;EyFtkoBN,yBAAA;EACI,qBAAA;EACA,kBAAA;EzFwkoBV,kBAAkB;EyFtkoBR,YAAA;AzFwkoBZ;;AAEA;EyFlkoBQ,qBAAA;AzFokoBR;;AAEA;EyF/joBQ,sBAAA;AzFikoBR;;AAEA;EACE,cAAc;EyF7joBR,eAAA;EACI,kBAAA;EACA,QAAA;AzF+joBZ;;AAEA;EACE,6BAA6B;EyFzjoBnB,cAAA;AzF2joBZ;;AAEA;EyFvjoBI,eAAA;EACI,WAAA;EACA,kBAAA;EzFyjoBN,QAAQ;EyFnjoBM,yBAAA;AzFqjoBhB;;AAEA;EyFhjoBI,cAAA;AzFkjoBJ;;AAEA;EyF5ioBgB,YAAA;EACI,kBAAA;EACA,gBAAA;EACA,+CAAA;EzF8ioBlB,0CAA0C;EyFvioBxC,qBAAA;EACI,mBAAA;AzFyioBR;;AyFtioBQ;EACI,oBAAA;EzFyioBV,WAAW;AyFtioBT;;AzFyioBJ;EACE,eAAe;EyFtioBb,eAAA;EACI,cAAA;EACA,cAAA;AzFwioBR;;AAEA;EyFtioBY,6BAAA;AzFwioBZ;;AAEA;EACE,eyFrioBU;AzFsioBZ;;AAEA;EACE,aAAa;AACf;;A0FziqBA;EAAA,kBAAA;EAEA,kBAAA;EACI,UAAA;A1F4iqBJ;;AAEA;E0F1iqBQ,eAAA;E1F4iqBN,cAAc;E0F1iqBZ,eAAA;A1F4iqBJ;;A0FziqBI;EACI,uBhEqCU;A1BugqBlB;;AAEA;EACE,eAAe;E0F1iqBb,WAAA;A1F4iqBJ;;A0FxiqBQ;EACI,kBAAA;A1F2iqBZ;;AAEA;EACE,WAAW;E0FtiqBT,kBAAA;EACI,QrFxBG;ELgkqBT,UAAU;E0FtiqBR,UAAA;EACI,WAAA;E1FwiqBN,yBAAyB;E0FtiqBvB,mBAAA;A1FwiqBJ;;A0FriqBI;EACI,8BAAA;A1FwiqBR;;AAEA;EACE,wBAAwB;E0FviqBlB,gBAAA;EACI,kBAAA;E1FyiqBV,QAAQ;E0FriqBM,WAAA;EACI,SAAA;E1FuiqBlB,SAAS;E0FniqBH,WAAA;A1FqiqBR;;A0FhiqBQ;EACI,YAAA;E1FmiqBV,kBAAkB;E0FhiqBhB,gBAAA;EACI,+CAAA;EACA,0CAAA;EACA,qBAAA;E1FkiqBN,mBAAmB;A0FjiqBb;;A1FoiqBR;E0FhiqBI,kBAAA;EACI,qBAAA;A1FkiqBR;;AAEA;EACE,UAAU;E0FhiqBR,8BAAA;A1FkiqBJ;;A0F/hqBI;EACI,0BAAA;A1FkiqBR;;AAEA;EACE,kBAAkB;A0F/hqBhB;;A1FkiqBJ;E0FhiqBQ,WAAA;EACI,kBrFnFD;ELqnqBT,QAAQ;E0F/hqBN,2BAAA;EACI,UAAA;E1FiiqBN,WAAW;E0FzhqBe,yBAAA;EACI,mBhEtDd;E1BilqBhB,WAAW;A0FxhqBW;;A1F2hqBxB;E0FxhqBgC,oBAAA;EACI,kBhE7DlB;A1BulqBlB;;AAEA;EACE,WAAW;E0F/gqBO,YAAA;EACI,iBhE5EN;E1B6lqBhB,yBAAyB;E0FtgqBH,kBAAA;EACI,mBhExFV;E1BgmqBhB,eAAe;E0FrgqBG,yBAAA;A1FugqBpB;;AAEA;E0FrgqBwB,gBAAA;A1FugqBxB;;A0FpgqBwB;;;;EAGQ,yBAAA;E1FwgqB9B,WAAW;A0FtgqBe;;A1FygqB5B;;;;;;;;E0F5/pBgC,yBAAA;EACI,sBAAA;A1FqgqBpC;;AAEA;EACE,yBAAyB;A0FjgqBH;;A1FogqBxB;E0FlgqB4B,kBAAA;EACI,8BAAA;A1FogqBhC;;AAEA;E0F7/pBoB,kBAAA;E1F+/pBlB,qBAAqB;E0F7/pBH,mBAAA;A1F+/pBpB;;A0F1/pBgC;EACI,WhEhJlB;E1B6oqBhB,kBAAkB;E0Fr/pBJ,SAAA;EACI,OhEzJF;E1BgpqBhB,WAAW;E0Fj/pBL,WAAA;EACI,yBrF1MD;EL6rqBT,mBAAmB;E0Fh/pBjB,yBAAA;A1Fk/pBJ;;A0F/+pBQ;EACI,mBAAA;A1Fk/pBZ;;AAEA;EACE,YAAY;A0F7+pBE;;A1Fg/pBhB;E0F1+pBI,qBAAA;AACI;;AAQA;E1Fs+pBN,aAAa;A0F7+pBP;;A1Fg/pBR;E0F5+pBQ,kBAAA;A1F8+pBR;;A0F1+pBQ;;E1F8+pBN,UAAU;A0F1+pBA;;A1F6+pBZ;E0Fr+pBwB,WAAA;EACI,kBAAA;E1Fu+pB1B,MAAM;E0Fr+pBoB,OAAA;EACI,WAAA;E1Fu+pB9B,YAAY;E0Fp+pBU,kCAAA;EACI,4BAAA;EACA,wBhEpPnB;A1B0tqBT;;AAEA;EACE,SAAS;A0Fp+pBa;;A1Fu+pBxB;;E0Fl+pBwB,eAAA;E1Fq+pBtB,gBAAgB;E0F99pBN,gBAAA;A1Fg+pBZ;;A0F79pBgB;EACI,yBhEzOF;E1BysqBhB,cAAc;A0F99pBA;;A1Fi+pBhB;E0F99pBgB,8BAAA;A1Fg+pBhB;;A0F79pBgB;EACI,wBAAA;E1Fg+pBlB,gBAAgB;E0Fz9pBF,kBAAA;EACI,QhE1PF;E1BqtqBhB,WAAW;E0Fz9pBO,SAAA;EACI,SAAA;E1F29pBtB,2BAA2B;E0Fz9pBT,WAAA;A1F29pBpB;;AAEA;E0Fz9pBwB,YAAA;EACI,kBAAA;EACA,gBhEnTlB;E1B8wqBR,+CAA+C;E0Fz9pBzB,0CAAA;EACI,aAAA;E1F29pB1B,qBAAqB;E0Fj9pBP,mBAAA;A1Fm9pBhB;;A0Fh9pBgB;EACI,6BrFhUT;ELmxqBT,gBAAgB;E0Fj9pBF,iBAAA;A1Fm9pBhB;;A0Fh9pBgB;EACI,UAAA;E1Fm9pBlB,gBAAgB;E0F98pBE,kBAAA;A1Fg9pBpB;;AAEA;E0F/8pBwB,WAAA;EACI,kBrF/UjB;ELgyqBT,MAAM;E0F/8pBgB,WAAA;EACI,UAAA;E1Fi9pB1B,YAAY;E0F18pBF,yBAAA;EACI,oBhEhTE;E1B4vqBhB,yBAAyB;A0Fv8pBX;;A1F08pBhB;E0Fx8pBoB,eAAA;EACI,chExTN;E1BkwqBhB,yBAAyB;A0Fx8pBP;;A1F28pBpB;E0Fv8pBwB,yBAAA;A1Fy8pBxB;;AAEA;E0Fj8pBQ,6BAAA;A1Fm8pBR;;A0Fh8pBgB;EACI,oBrFtXT;ALyzqBX;;AAEA;EACE,cAAc;A0F37pBQ;;A1F87pBxB;;EAEE,cAAc;A0Fv7pBQ;;A1F07pBxB;EACE,yBAAyB;E0Fv7pBK,wCAAA;A1Fy7pBhC;;A0Fh7pBQ;;E1Fo7pBN,yBAAyB;A0F16pBK;;A1F66pBhC;EACE,gBAAgB;A0Fj6pBN;;A1Fo6pBZ;E0Fj6pBgB,sCrFjbL;ELo1qBT,cAAc;A0Fl6pBA;;A1Fq6pBhB;E0Fl6pBgB;IACI,uBhE1bV;E1B81qBR;;E0F95pBM;I1Fi6pBJ,yBAAyB;E0F/5pBzB;A1Fi6pBJ;;A0F95pBI;EACI,eAAA;A1Fi6pBR;;AAEA,oB0BxzqBc;A1ByzqBd;E0F95pBQ;IACI,WhE9ZG;E1B8zqBb;;E0F35pBU;I1F85pBR,kBAAkB;E0F15pBd;A1F45pBR;;A0Fv5pBQ;EACI;I1F05pBR,YAAY;I0Fv5pBZ,4CAAA;EACI;;EAGA;IACI,kBAAA;IACA,sBAAA;E1Fw5pBV;A0Ft5pBM;;A1Fy5pBR;E0Fr5pBI;IACI,kBAAA;E1Fu5pBN;A0Fp5pBM;;A1Fu5pBR;E0Fr5pBY;IACI,YhEpcE;I1B21qBd,2CAA2C;E0Fl5pBvC;A1Fo5pBR;;A0F94pBY,uCAAA;A1Fi5pBZ;EACE;I0Fh5pBc,WAAA;EACI;A1Fk5pBpB;;A0F94pBoB,qBAAA;A1Fi5pBpB;EACE;I0F94pBsB,aAAA;EACI;;EAShB;IACI,kBhEneA;E1B42qBd;A0Fp4pBE;;A1Fu4pBJ;6C0Fj4pBoB;A1Fm4pBpB;E0Fj4pBwB,kBhEhfR;A1Bm3qBhB;;AAEA,oBKj6qBW;ALk6qBX;E0F/3pBY;IACI,kBrFpiBL;ELq6qBT;A0F73pBU;;A1Fg4pBZ;6C0F33pBY;A1F63pBZ;EACE,gCAAgC;E0Fz3pBtB,oBAAA;EACI,mBhEtgBF;A1Bi4qBd;;AAEA;EACE,gEAAgE;A0Fx3pB1D;;A1F23pBR;E0Fp3pBY,kBAAA;EACI,MAAA;E1Fs3pBd,QAAQ;A0Fn3pBM;;A1Fs3pBhB;EACE,yBAAyB;A0F92pBf;;A1Fi3pBZ;;E0F92pBoB,WAAA;E1Fi3pBlB,YAAY;E0F32pBN,iBAAA;EACI,kBAAA;E1F62pBV,kBAAkB;E0F12pBhB,yBAAA;EACI,cAAA;E1F42pBN,kBAAkB;E0F12pBhB,SAAA;EACI,eAAA;A1F42pBR;;A0Fz2pBI;;E1F62pBF,yBAAyB;E0F32pBnB,cAAA;A1F62pBR;;A0Fz2pBI;;E1F62pBF,yBAAyB;E0Fz2pBnB,cAAA;A1F22pBR;;A0Ft2pBQ;;E1F02pBN,yBAAyB;E0Ft2pBvB,cAAA;A1Fw2pBJ;;A0Fn2pBY;EACI,yBAAA;E1Fs2pBd,cAAc;E0Fr2pBA,yBAAA;EACI,qBAAA;E1Fu2pBlB,mBAAmB;E0Fj2pBb,eAAA;EACI,gBAAA;E1Fm2pBV,WAAW;E0Fh2pBT,YAAA;EACI,iBAAA;E1Fk2pBN,kBAAkB;E0Fj2pBZ,gBAAA;A1Fm2pBR;;A0Fj2pBY;EACI,yBAAA;E1Fo2pBd,qBAAqB;E0Fh2pBX,cAAA;A1Fk2pBZ;;AAEA;EACE,kBAAkB;A0F/1pBZ;;A1Fk2pBR;E0F91pBI,kBAAA;EACI,kBhE9mBQ;A1B88qBhB;;AAEA;EACE,WAAW;E0F91pBT,kBAAA;EACI,QAAA;E1Fg2pBN,2BAA2B;E0F/1pBrB,OAAA;EACI,WAAA;E1Fi2pBV,WAAW;E0F51pBD,yBAAA;EACI,mBAAA;A1F81pBhB;;AAEA;EACE,gBAAgB;A0F11pBN;;A1F61pBZ;E0F31pBgB,yBAAA;A1F61pBhB;;A0Fr1pBY;EACI,SAAA;E1Fw1pBd,WAAW;E0Fv1pBG,gBAAA;EACI,kBAAA;A1Fy1pBpB;;AAEA;EACE,YAAY;E0Fh1pBV,UAAA;A1Fk1pBJ;;A0F70pBY,oBAAA;A1Fg1pBZ;EACE;I0F90pBc,oBAAA;IACI,mBAAA;E1Fg1pBlB;A0F70pBkB;;A1Fg1pBpB,uCAAuC;A0F70pBf;EACI;IACA,wBAAA;E1F+0pB1B;A0F30pBsB;;A1F80pBxB,wCAAwC;A0Ft0pBpC;EACI;IACA,wBAAA;E1Fw0pBN;A0Fv0pBM;;A1F00pBR;E0Fx0pBY;IACI,wBAAA;E1F00pBd;;E0Ft0pBU;IACA,YhEnsBE;EgEosBF;A1Fy0pBZ;;AAEA,yC0BhhrBgB;A1BihrBhB;E0Ft0pBI;IACI,YAAA;EACA;A1Fw0pBR;;AAEA;6C0Ft0pBQ;A1Fw0pBR;E0Ft0pBI,qBAAA;EACI,kBhEptBQ;E1B4hrBd,mBAAmB;A0Ft0pBjB;;A1Fy0pBJ;EACE,gBAAgB;A0Ft0pBd;;A1Fy0pBJ;EACE,eAAe;E0Ft0pBb,mBAAA;EACI,WAAA;E1Fw0pBN,yBAAyB;A0Ft0pBvB;;A1Fy0pBJ;E0Ft0pBI,mBAAA;A1Fw0pBJ;;AAEA;E0Fv0pBQ,kBAAA;EACI,SAAA;E1Fy0pBV,QAAQ;E0Ft0pBN,eAAA;A1Fw0pBJ;;AAEA;E0Fr0pBQ,mBAAA;A1Fu0pBR;;AAEA;E0Fr0pBQ,gBAAA;A1Fu0pBR;;A0Fl0pBQ;EACI,yBrFtyBD;AL2mrBX;;AAEA;6CAC6C;A0Fj0pB7B;EACI,4BAAA;E1Fm0pBlB,yBAAyB;E0F5zpBf,wBAAA;EACI,2BhE3wBD;E1BykrBb,4BAA4B;E0F7zpBd,sBAAA;EACI,sBAAA;E1F+zpBlB,0BAA0B;A0F5zpBR;;A1F+zpBpB;E0FtzpBI,qCAAA;A1FwzpBJ;;A0FrzpBI;EACI,gBAAA;E1FwzpBN,yBAAyB;A0FtzpBvB;;A1FyzpBJ;EACE,yBAAyB;E0FtzpBvB,cAAA;EACI,gBAAA;E1FwzpBN,kBAAkB;E0FtzpBhB,YAAA;EACI,gCAAA;A1FwzpBR;;AAEA;EACE,wBAAwB;E0FtzpBtB,6BAAA;A1FwzpBJ;;A0FrzpBI;EACI,wBhEjzBU;E1BymrBhB,8BAA8B;A0FtzpB5B;;A1FyzpBJ;EACE,6BAA6B;E0FrzpBvB,cAAA;EACI,qBAAA;E1FuzpBV,kBAAkB;A0FjzpBR;;A1FozpBZ;E0FjzpBgB,8BAAA;E1FmzpBd,6BAA6B;A0FjzpBnB;;A1FozpBZ;E0FjzpBgB,+BAAA;EACA,8BAAA;A1FmzpBhB;;A0F/ypBQ;EACI,qBAAA;A1FkzpBZ;;A0F9ypBI;;E1FkzpBF,gBAAgB;E0F9ypBN,yBAAA;A1FgzpBZ;;A0F3ypBY;;E1F+ypBV,cAAc;A0F1ypBZ;;A1F6ypBJ;E0F1ypBQ,eAAA;A1F4ypBR;;A0FxypBI;EACI,oBAAA;A1F2ypBR;;AAEA;E0FzypBQ,oBAAA;A1F2ypBR;;AAEA;EACE,kBAAkB;A0FrypBhB;;A1FwypBJ;EACE,mBAAmB;A0FrypBb;;A1FwypBR;EACE,yBAAyB;E0FrypBf,gBAAA;EACI,kBhE33BA;EgE43BA,0BAAA;A1FuypBhB;;AAEA;E0FlypBQ,2BhEn4BQ;A1BuqrBhB;;AAEA;EACE,yBAAyB;E0FjypBvB,eAAA;EACI,iBAAA;E1FmypBN,uBAAuB;A0FjypBrB;;A1FoypBJ;E0F/xpBQ,gBAAA;A1FiypBR;;AAEA;E0F9xpBgB,gBAAA;A1FgypBhB;;A0F3xpBQ;EACI,iBAAA;E1F8xpBV,iBAAiB;E0F1xpBf,kBAAA;A1F4xpBJ;;A0FzxpBQ;EACI,SAAA;E1F4xpBV,UAAU;A0F1xpBJ;;A1F6xpBR;E0F1xpBQ,iBAAA;A1F4xpBR;;A0FvxpBQ;EACI,iBAAA;A1F0xpBZ;;AAEA;EACE,kBAAkB;A0FvxpBhB;;A1F0xpBJ;E0FtxpBQ,mBAAA;A1FwxpBR;;A0FlxpBI;EACI,YAAA;A1FqxpBR;;AAEA;EACE,YAAY;A0FhxpBF;;A1FmxpBZ;E0F3wpBY,YAAA;EACI,gCAAA;A1F6wpBhB;;A0FvwpBQ;EACI,0BAAA;A1F0wpBZ;;AAEA;EACE,2BAA2B;A0FpwpBrB;;A1FuwpBR;E0FhwpBI,kBAAA;EACI,SAAA;E1FkwpBN,WAAW;A0FhwpBT;;A1FmwpBJ;E0F9vpBY,iBAAA;A1FgwpBZ;;AAEA;E0F9vpBgB,iBAAA;A1FgwpBhB;;A0FvvpBI;EACI,iBAAA;E1F0vpBN,oBAAoB;A0FxvpBd;;A1F2vpBR;E0FvvpBI,oBAAA;A1FyvpBJ;;A0FtvpBI;EACI,0BAAA;A1FyvpBR;;AAEA;EACE,2BAA2B;A0FnvpBjB;;A1FsvpBZ;EACE,0BAA0B;A0FnvpBZ;;A1FsvpBhB;E0FhvpBI,2BAAA;A1FkvpBJ;;A0F/upBI;EACI,gBAAA;E1FkvpBN,mBAAmB;A0FhvpBjB;;A1FmvpBJ;EACE,0BAA0B;A0F5upBxB;;A1F+upBJ;E0F3upBQ,2BAAA;A1F6upBR;;A0FvupBoB;EACI,0BhEpjCR;A1B8xrBhB;;AAEA;E0FpupB4B,2BAAA;A1FsupB5B;;A0FlupBwB;EACI,gBAAA;E1FqupB1B,mBAAmB;A0FnupBW;;A1FsupBhC;E0F9tpB4B,0BAAA;A1FgupB5B;;A0FztpBoB;EACI,2BhErlCN;A1BizrBlB;;AAEA;EACE,gCAAgC;A0FjtpBV;;A1FotpBxB;E0FhtpBoB,0BAAA;A1FktpBpB;;AAEA;E0FhtpBwB,2BAAA;A1FktpBxB;;A0F/spBwB;EACI,qBAAA;E1FktpB1B,iBAAiB;E0FjtpBS,oBAAA;A1FmtpB5B;;A0FhtpB4B;EACI,0BAAA;A1FmtpBhC;;AAEA;EACE,2BAA2B;A0F/spBD;;A1FktpB5B;EACE,0BAA0B;A0F/spBA;;A1FktpB5B;E0FhtpBgC,2BAAA;A1FktpBhC;;A0F9spB4B;EACI,iBAAA;E1FitpB9B,oBAAoB;A0F9spBE;;A1FitpBxB;E0F/spB4B,0BAAA;A1FitpB5B;;A0FzspBgB;EACI,2BAAA;A1F4spBpB;;AAEA;E0F1spBoB,0BAAA;A1F4spBpB;;AAEA;EACE,2BAA2B;A0FxspBG;;A1F2spBhC;E0FlspBgB,iBAAA;EACI,oBhEzqCF;A1B62rBlB;;A0F3rpBI;EACI,0BhElrCO;A1Bg3rBf;;AAEA;EACE,2BAA2B;A0F5rpBjB;;A1F+rpBZ;E0F3rpBQ,0BAAA;A1F6rpBR;;A0FxrpBgB;EACI,2BrF5uCT;ALu6rBX;;A0FrrpBQ;EAIA,gBAAA;EAIA,mBAAA;A1FkrpBR;;AAEA;EACE,0BAA0B;A0FxrpBpB;;A1F2rpBR;E0FvrpBQ,2BAAA;A1FyrpBR;;A0FprpBY;EACI,0BhEvtCE;A1B84rBlB;;AAEA;EACE,2BAA2B;A0FhrpBD;;A1FmrpB5B;E0F/qpBwB,iBAAA;EACI,oBhEtuCV;A1Bu5rBlB;;AAEA;EACE,0BAA0B;A0F9qpBR;;A1FirpBpB;E0FzqpBY,2BAAA;A1F2qpBZ;;A0FxqpBgB;EACI,0BhExvCF;A1Bm6rBlB;;AAEA;EACE,2BAA2B;A0FzqpBb;;A1F4qpBhB;E0FzqpBgB,iBAAA;EACI,oBAAA;A1F2qpBpB;;AAEA;EACE,0BAA0B;A0FpqpBR;;A1FuqpBpB;E0FpqpBoB,2BAAA;A1FsqpBpB;;AAEA;E0FpqpBwB,aAAA;A1FsqpBxB;;AAEA;E0FpqpBwB,iBAAA;EACI,oBrFj0CjB;ALu+rBX;;A2F/+rBA;EAAA,0BAAA;AAGI;;A3Fk/rBJ;E2F/+rBI,2BAAA;A3Fi/rBJ;;A2F9+rBI;EACI,mBAAA;E3Fi/rBN,sBAAsB;A2F/+rBpB;;A3Fk/rBJ;E2F/+rBI,mBAAA;EACI,sBAAA;A3Fi/rBR;;AAEA;EACE,iBAAiB;E2F7+rBP,oBAAA;A3F++rBZ;;A2F1+rBI;EACI,eAAA;E3F6+rBN,WAAW;A2F3+rBT;;A3F8+rBJ;E2F3+rBI,6BAAA;A3F6+rBJ;;A2F1+rBI;EACI,mBAAA;A3F6+rBR;;AAEA;EACE,iBAAiB;E2F3+rBf,oBAAA;EACI,iBAAA;E3F6+rBN,kBAAkB;AACpB;;A4F1hsBA;EAEA,6BAAA;A5F4hsBA;;A4F1hsBI;EACI,mBlEDE;A1B8hsBV;;AAEA;EACE,2BAA2B;A4F3hsBrB;;A5F8hsBR;E4F3hsBQ,oBAAA;A5F6hsBR;;A4FzhsBI;EACI,wBAAA;E5F4hsBN,iBAAiB;E4F1hsBf,kBAAA;EACI,mBAAA;E5F4hsBN,2BAA2B;E4F1hsBzB,yBAAA;EACI,2BAAA;A5F4hsBR;;AAEA;EACE,uCAAuC;A4F1hsBrC;;A5F6hsBJ;E4F1hsBI,uCAAA;A5F4hsBJ;;A4FzhsBI;EACI,wCAAA;E5F4hsBN,kBAAkB;AACpB;;A6FjksBA;EAGI,gBAAA;EACI,iCAAA;EACA,gBAAA;A7FkksBR;;AAEA;EACE,aAAa;A6FhksBX;;A7FmksBJ;E6FhksBI,kBAAA;A7FkksBJ;;A6F/jsBI;;E7FmksBF,qBAAqB;E6F/jsBf,eAAA;A7FiksBR;;A6F7jsBI;EACI,kBAAA;E7FgksBN,yBAAyB;E6F9jsBvB,YAAA;EACI,YAAA;E7FgksBN,gB6F/jsBU;E7FgksBV,mB6F/jsBU;A7FgksBZ;;AAEA,oB6F/jsBY;A7FgksBZ;EACE;IACE,4BAA4B;EAC9B;;E8FpmsBF;IAEA,eAAA;EACI;;E9FumsBF;IACE,YAAY;E8FrmsBhB;;E9FwmsBE;IACE,aAAa;E8FtmsBjB;;E9FymsBE;IACE,YAAY;E8FvmsBhB;;E9F0msBE;IACE,YAAY;E8FxmsBhB;;E9F2msBE;IACE,6BAA6B;E8FzmsBjC;;E9F4msBE;IACE,8BAA8B;E8F1msBlC;;EAEI;I9F4msBA,6BAA6B;E8F3msB7B;;EAEI;IACA,8BAAA;E9F6msBN;;E8F1msBM;IACA,uBAAA;EACA;;EAEJ;IACI,YAAA;EACA;;EAEJ;IACI,YAAA;EACA;;EAEJ;IACI,YAAA;EACA;;EAEJ;IACI,YAAA;EACA;;EAEJ;IACI,YAAA;EACA;;E9F8msBN;I8F3msBE,YAAA;EACI;;EAEA;I9F6msBJ,iBAAiB;I8F3msBjB,gBAAA;EACI;A9F6msBR;;AAEA,oBAAoB;A8F3msBhB;;EAEI,4BAAA;EACA;I9F6msBJ,uBAAuB;EACzB;;E8FzmsBE;I9F4msBA,YAAY;E8F3msBZ;A9F6msBJ;;AAEA;E8F3msBQ;IACA,yBAAA;EACA;;E9F8msBN;I8F3msBE,eAAA;EACI;;EAGA;IACI,eAAA;E9F4msBV;AACF;;AAEA;EACE;IACE,eAAe;E8FtmsBnB;;E9FymsBE;IACE,YAAY;E8FvmsBhB;;EAEI;IACA,YAAA;EACA;;E9F0msBF;IACE,eAAe;E8FxmsBnB;;EAEI;IACA,cAAA;EACA;;E9F2msBF;IACE,cAAc;E8FxmsBlB;;E9F2msBE;IACE,YAAY;E8FxmsBhB;;EAEI;IACA,YAAA;E9F0msBF;;E8FxmsBF;IACI,kBAAA;E9F2msBF;;E8FzmsBF;IACI,YpEnGU;EoEoGV;A9F4msBJ;;AAEA,oB8F3msBI;A9F4msBJ;;EAEE,4BAA4B;E8F3msB1B;IACI,4BAAA;EACA;;EAEA;IACA,uBAAA;EACA;;E9F8msBN;I8F3msBE,uBAAA;EACI;A9F6msBR;;A8FzmsBQ;EACI;IACA,YAAA;EACA;;EAEA;IACA,YAAA;EACA;;EAEJ;IACI,YAAA;EACA;A9F4msBZ;;A8FxmsBA,qBAAA;A9F2msBA;;E8FxmsBI,yBAAA;EACA;I9F2msBA,uBAAuB;E8F1msBvB;;E9F6msBF;I8F1msBE,aAAA;EACI;;EAEA;I9F4msBJ,aAAa;E8F3msBT;A9F6msBR;;AAEA,uCAAuC;A8F1msBvC;EACI;I9F4msBA,YAAY;E8F3msBZ;;EAEI;IACA,YAAA;EACA;;EAEA;IACA,aAAA;E9F6msBN;;E8F1msBM;IACA,YAAA;EACA;;E9F8msBN;I8F1msBE,6BAAA;EACI;;EAEA;IACA,8BAAA;E9F4msBN;;E8FxmsBU;I9F2msBR,6BAA6B;E8F1msBrB;;E9F6msBV;IACE,8BAA8B;E8FxmsBlC;;EAEC;IACA,aAAA;EACA;;EACA;IACC,YAAA;EACA;A9F2msBF;;A8FxmsBC;EACC;IACA,0BAAA;EACA;;E9F4msBA;I8F1msBA,YAAA;EACC;;EAEA;I9F4msBC,YAAY;EACd;;E8FxmsBD;IACA,YAAA;EACA;;EAEA;I9F2msBG,YAAY;E8F1msBf;;E9F6msBC;I8F3msBA,YAAA;EACC;A9F6msBH;;AAEA,wC0Br1sBU;A1Bs1sBV;EACE;I8F1msBD,YAAA;EACC;;EAEA;IACM,cAAA;E9F4msBN;;E8FxmsBC;IACA,YAAA;E9F2msBD;;E8FxmsBC;I9F2msBC,aAAa;EACf;;E8FtmsBM;IACA,YAAA;E9FymsBN;;E8FtmsBU;IACA,YAAA;E9FymsBV;A8FvmsBU;;A9F0msBZ,yCAAyC;AACzC;E8FpmsBI;IACI,YAAA;EACA;;EAEA;IACA,YAAA;E9FsmsBN;;E8FpmsBU;I9FumsBR,YAAY;E8FpmsBZ;;EAEI;IACA,cAAA;EACA;;EAEA;I9FsmsBJ,YAAY;EACd;;E8FlmsBM;IACA,YAAA;EACA;;EAEA;IACA,aAAA;EACA;;EAEA;I9FqmsBJ,YAAY;E8FpmsBR;;EAEI;I9FsmsBR,YAAY;EACd;A8FnmsBF;;A9FsmsBA,yC8FpmsBI;A9FqmsBJ;E8FnmsBI;IACA,YAAA;E9FqmsBF;A8FpmsBE;;A9FumsBJ;EACE;I8FnmsBE,aAAA;EACI;;EAEA;IACA,aAAA;E9FqmsBN;;E8FlmsBF;IACI,aAAA;EACA;;E9FsmsBF;I8FpmsBE,wBAAA;EACI;A9FsmsBR;;AAEA;EACE;I8FpmsBE,uBAAA;EACI;;E9FumsBN;I8FpmsBF,aAAA;EACC;;EAEA;IACG,aAAA;EACH;;EAEA;IACA,wBAAA;EACA;;EAEA;IACA,YpElUY;EoEmUT;A9FsmsBJ;;A8FnmsBI;6CzF1WO;ALi9sBX;E8FpmsBI,iBAAA;A9FsmsBJ;;AAEA;E8FnmsBA,iBAAA;EACA,kBAAA;EAEI,yBAAA;E9FomsBF,gB8FnmsBM;E9FomsBN,yB8FnmsBM;E9FomsBN,gBAAgB;E8FlmsBd,WAAA;A9FomsBJ;;AAEA;EACE,gB8FnmsBM;A9FomsBR;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,W8FnmsBM;E9FomsBN,YAAY;E8FlmsBV,iBAAA;E9FomsBF,kB8FnmsBM;E9FomsBN,e8FnmsBM;A9FomsBR;;AAEA;EACE,yBAAyB;E8FnmsBnB,WAAA;E9FqmsBN,qB8FpmsBU;A9FqmsBZ;;AAEA;EACE,yBAAyB;E8FnmsBnB,WAAA;A9FqmsBR;;AAEA;;EAEE,W8FlmsBU;A9FmmsBZ;;AAEA;E8FjmsBQ,eAAA;A9FmmsBR;;AAEA;6C8FhmsBQ;A9FkmsBR;E8FjmsBQ,yBAAA;A9FmmsBR;;AAEA;E8FhmsBI,yBAAA;E9FkmsBF,e8FjmsBM;E9FkmsBN,gBAAgB;AAClB;;AAEA;;EAEE,yB8FlmsBU;A9FmmsBZ;;AAEA;EACE,qB8FhmsBU;A9FimsBZ;;AAEA;E8F7lsBQ,eAAA;E9F+lsBN,gB8F9lsBU;A9F+lsBZ;;AAEA;EACE,0B8F5lsBU;A9F6lsBZ;;AAEA;EACE,gB8F1lsBU;E9F2lsBV,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;6CAC6C;A8FrlsB7C;EACA,WAAA;EAEI,YAAA;E9FslsBF,gC8FrlsBM;A9FslsBR;;AAEA;EACE,mB8FrlsBM;E9FslsBN,YAAY;AACd;;AAEA;E8FplsBI,gBAAA;E9FslsBF,e8FrlsBM;A9FslsBR;;AAEA;;E8FnlsBI,aAAA;A9FslsBJ;;AAEA;;EAEE,yB8FrlsBM;E9FslsBN,WAAW;E8FplsBT,YAAA;E9FslsBF,e8FrlsBM;E9FslsBN,mBAAmB;AACrB;;AAEA;E8FplsBI,0BAAA;E9FslsBF,c8FrlsBM;E9FslsBN,eAAe;AACjB;;AAEA;E8FnlsBQ,yBAAA;A9FqlsBR;;AAEA;EACE,Y8FplsBU;A9FqlsBZ;;AAEA;EACE,cAAc;E8FllsBZ,eAAA;A9FolsBJ;;AAEA;EACE,6B8FplsBU;A9FqlsBZ;;AAEA;EACE,yB8FnlsBM;E9FolsBN,sBAAsB;E8FnlsBhB,mBAAA;E9FqlsBN,U8FplsBU;E9FqlsBV,WAAW;E8FnlsBL,YAAA;E9FqlsBN,qB8FplsBU;E9FqlsBV,iB8FplsBU;A9FqlsBZ;;AAEA;;EAEE,yB8FllsBU;A9FmlsBZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;E8F3ksBnB,WAAA;A9F6ksBR;;AAEA;E8FzksBA,yBAAA;AACA;;A9F4ksBA;;EAEE,yBAAyB;A8FpksB3B;;A9FuksBA;EACE,WAAW;AACb;;AAEA;E8FjksBQ,WAAA;A9FmksBR;;AAEA;E8F7jsBI,yBAAA;EACI,yBAAA;E9F+jsBN,WAAW;AACb;;AAEA;6C8FxjsBgB;A9F0jsBhB;EACE,QAAQ;E8FjjsBF,WAAA;A9FmjsBR;;A8FhjsBQ;EACI,WAAA;E9FmjsBV,WAAW;A8FjjsBL;;A9FojsBR;E8F/isBI,8BAAA;EACI,gCpEzkBO;A1B0ntBf;;AAEA;E8F9isBY,kBpE9kBG;E1B8ntBb,YAAY;E8F9isBN,iBAAA;EACI,gBAAA;EACA,WAAA;A9FgjsBZ;;AAEA;EACE,WAAW;E8FlisBL,kBAAA;EACI,SAAA;E9FoisBV,QAAQ;E8FlisBF,QAAA;EACI,WAAA;E9FoisBV,yBAAyB;E8FhisBnB,yBAAA;A9FkisBR;;A8F7hsBI;;E9FiisBF,yB8F/hsBU;E9FgisBV,6BAA6B;AAC/B;;A+FtstBA;;EAEA,WAAA;EACE,WAAA;EACA,OAAA;A/FystBF;;AAEA;E+FvstBU,gBAAA;A/FystBV;;AAEA;E+FxstBU,iCAAA;EACI,yBAAA;E/F0stBZ,gBAAgB;E+FxstBR,kBAAA;EACI,kBAAA;E/F0stBZ,qBAAqB;A+FtstBb;;A/FystBV;EACE,UAAU;EACV,yBAAyB;A+FnstBzB;;A/FsstBF;E+FnstBM,+BAAA;EACA,yBAAA;EACA,WAAA;A/FqstBN;;AAEA;E+FnstBM,UAAA;A/FqstBN;;AAEA,oB0B5stBc;A1B6stBd;EACE;IACE,aAAa;E+FjstBjB;A/FmstBA;;AAEA,uCAAuC;AACvC;EACE;IACE,aAAa;EACf;A+F9rtBF;;A/FistBA,yC+F9rtBE;A/F+rtBF;6CAC6C;AAC7C;EACE,a+F9rtBI;E/F+rtBJ,sBAAsB;E+F7rtBtB,kBAAA;E/F+rtBA,Y+F9rtBI;A/F+rtBN;;AgGjwtBA;EAAA,WAAA;EAEA,cAAA;EACA,kBAAA;EACI,SAAA;EACA,2BAAA;EACA,0BAAA;EhGowtBF,WAAW;AgGjwtBL;;AhGowtBR;EgGjwtBY,aAAA;AhGmwtBZ;;AgGhwtBY;EACI,YAAA;EAAA,cAAA;EAAA,4BAAA;EACA,kBAAA;EACA,yBAAA;AhGmwtBhB;;AAEA;EgGjwtBgB,eAAA;AhGmwtBhB;;AgG9vtBY;EACI,WAAA;EhGiwtBd,YAAY;EgG/vtBE,kBAAA;EACI,YAAA;EACA,mBAAA;EACA,qDAAA;EhGiwtBlB,kBAAkB;EAClB,UAAU;AgG5vtBZ;;AhG+vtBA;EgG5vtBI,mBAAA;AhG8vtBJ;;AAEA;EgG7vtBQ,mBAAA;AhG+vtBR;;AAEA;EgG7vtBQ,mBAAA;AhG+vtBR;;AAEA;EgG9vtBQ,YAAA;EAAA,cAAA;EAAA,4BAAA;AhGgwtBR;;AAEA;EgG9vtBY,eAAA;EACA,yBtErDF;EsEsDE,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AhGgwtBZ;;AgG7vtBU;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EhGgwtBV,UAAU;EgG9vtBJ,WAAA;EACI,YAAA;EhGgwtBV,yBAAyB;EgG7vtBvB,wBAAA;EACI,kBAAA;AhG+vtBR;;AAEA;EgG7vtBQ,2BAAA;AhG+vtBR;;AAEA;EgG5vtBY,UAAA;EACA,WAAA;AhG8vtBZ;;AgG5vtBY;EACI,eAAA;AhG+vtBhB;;AAEA;EgG7vtBY,kBAAA;EACI,kBAAA;AhG+vtBhB;;AgG3vtBQ;EACI,kBAAA;EACA,SAAA;EACA,OAAA;AhG8vtBZ;;AgGzvtBA;EACI,+BAAA;EhG4vtBF,kBAAkB;EgGzvtBZ,kBAAA;EACI,oBAAA;AhG2vtBZ;;AgGxvtBQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AhG2vtBZ;;AAEA;EACE,yBAAyB;AgGzvtBnB;;AhG4vtBR;EgGxvtBY,yBAAA;AhG0vtBZ;;AAEA;EACE,yBAAyB;AgGxvtBX;;AhG2vtBhB,oBgGzvtBoB;AhG0vtBpB;EgGxvtBoB;IACA,SAAA;EACA;;EAEA;IACA,aAAA;EhG0vtBlB;;EgGvvtBkB;IACA,sBAAA;IACA,YAAA;EACA;;EAEA;IACA,sB3FjJT;E2FkJS;;EhG2vtBlB;IgGvvtBU,iBAAA;EACI;;EAEA;;IhG0vtBZ,YAAY;EgGvvtBA;;EhG0vtBd;IACE,QAAQ;IgGlvtBR,cAAA;IACI,YAAA;EhGovtBN;;EgGlvtBU;IhGqvtBR,wBAAwB;EgGnvtBpB;;EhGsvtBN;IgGnvtBU,QAAA;IACI,cAAA;IACA,wBAAA;EACA;;EAEA;IACA,QAAA;IACA,YAAA;IAAA,cAAA;IAAA,6BAAA;IACA,uBAAA;EACA;AhGqvtBhB;;AgG9utBA;6CACI;AhGivtBJ;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EgG1utBD,kBAAA;EACI,SAAA;EhG4utBd,YAAY;EgG1utBF,UAAA;EACI,YAAA;EACA,+BAAA;AhG4utBhB;;AAEA;EgG1utBgB,kBAAA;AhG4utBhB;;AgGlutBY;EACI,SAAA;EhGqutBd,WAAW;EgGnutBD,yBAAA;AhGqutBZ;;AAEA;EiG/8tBA,SAAA;EAAA,WAAA;AAEA;;AjGk9tBA,wC0Bx6tBa;A1By6tBb;EiG78tBQ;IACI,WAAA;EjG+8tBV;;EiG18tBF;IACI,WAAA;EjG68tBF;AiG38tBE;;AjG88tBJ,yCiG58tBQ;AjG68tBR;EiG38tBQ;IACA,WAAA;EACA;;EAEA;IjG68tBJ,WAAW;EiG38tBP;AjG68tBR;;AiG18tBQ,yCAAA;AjG68tBR;EACE;IiG38tBM,WAAA;EACI;;EAGR;IACI,WAAA;EjG48tBN;AiG18tBE;;AjG68tBJ;EACE;IiGx8tBE,aAAA;EACI;;EAEA;IACA,UAAA;IACA,WAAA;IACA,SAAA;EACA;AjG08tBR;;AiGv8tBQ;6CACI;AjG08tBZ;EiGx8tBQ,yBAAA;EACI,wBvExDF;E1BkguBR,kBAAkB;EiGx8tBZ,kBAAA;AjG08tBR;;AiGt8tBI;EACI,SAAA;EjGy8tBN,UAAU;EiGv8tBR,aAAA;EACI,uBAAA;EjGy8tBN,YAAY;EACZ,SAAS;AiGr8tBP;;AjGw8tBJ;EiGr8tBQ,gBAAA;EjGu8tBN,yBAAyB;EACzB,kBAAkB;EiGp8tBpB,kBAAA;EACE,aAAA;EACA,oCAAA;AjGs8tBF;;AAEA;EiGn8tBU,oCAAA;AjGq8tBV;;AAEA;;;;;EiGh8tBU,gCAAA;AjGs8tBV;;AAEA;EACE,WAAW;EiGj8tBX,YAAA;EACI,sBAAA;EjGm8tBJ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EiGh8tBjB,mBAAA;AjGk8tBV;;AAEA;EiG97tBA,qBAAA;AjGg8tBA;;AAEA;EiG97tBE,yBAAA;EACA,mBAAA;AjGg8tBF;;AAEA;EACE,qBAAqB;AiG/7tBrB;;AjGk8tBF;EiG/7tBM,aAAA;AjGi8tBN;;AiG/7tBM;EACI,yBAAA;EACA,WAAA;EACA,yBAAA;EjGk8tBR,eAAe;EiG97tBP,kBAAA;EACI,eAAA;EjGg8tBZ,SAAS;AiG57tBT;;AjG+7tBF;EACE,gBAAgB;EiG77tBZ,YAAA;EACI,aAAA;AjG+7tBV;;AAEA;;EAEE,+BAA+B;EiG57tB/B,WAAA;EACI,YAAA;EACA,mBAAA;EjG87tBJ,yBAAyB;EiG77tBrB,qCAAA;AjG+7tBN;;AAEA;EiG77tBU,qCAAA;AjG+7tBV;;AiG37tBE;EACI,kBAAA;AjG87tBN;;AiG57tBM;EACI,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,2CAAA;EjG+7tBR,kBAAkB;AiG57tBlB;;AjG+7tBF;EACE,sBAAsB;EiG77tBlB,gCAAA;AjG+7tBN;;AAEA,oBiG97tBU;AjG+7tBV,uCiG97tBU;AjG+7tBV,wCiG97tBU;AjG+7tBV,yCAAyC;AACzC,yCAAyC;AiGz7tBzC;6CACA;AjG27tBA;EACE,iBiG17tBI;AjG27tBN;;AAEA;EACE,yBiGx7tBY;EjGy7tBZ,gCAAgC;AAClC;;AiG/6tBA;EACA,yBAAA;EAIU,+BAAA;AjG+6tBV;;AAEA;EiGz6tBA,yBAAA;EACA,6BAAA;AjG26tBA;;AAEA;EACE,yBAAyB;EiGl6tB3B,+BAAA;AC9OA;;AAEA;EACE,yBAAA;EACA,6BAAA;AlGmpuBF;;AAEA;EkGjpuBQ,0BAAA;EACA,+BAAA;AlGmpuBR;;AAEA;EkGjpuBQ,0BAAA;ElGmpuBN,8BAA8B;AkGjpuB5B;;AlGopuBJ;EkGjpuBQ,0BAAA;EACA,4BAAA;AlGmpuBR;;AAEA;EACE,0BAA0B;EkGjpuBpB,8BAAA;AlGmpuBR;;AAEA;EACE,0BAA0B;EkGjpuBpB,4BAAA;AlGmpuBR;;AAEA;EACE,cAAc;EkGjpuBR,mBAAA;AlGmpuBR;;AAEA;EACE,cAAc;EACd,mBAAmB;AkGhpuBrB;;AlGmpuBA;EACE,yBAAyB;EkGlpuBvB,6BAAA;AlGopuBJ;;AAEA;EACE,0BkGtpuBS;ElGupuBT,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EkGvpuBxB,gCAAA;AlGypuBJ;;AAEA;EkGvpuBQ,0BAAA;EACA,8BAAA;AlGypuBR;;AkGppuBA;EACA,0BAAA;EAEI,gCAAA;AlGspuBJ;;AAEA;EACE,0BkGtpuBU;ElGupuBV,8BkGtpuBU;AlGupuBZ;;AAEA;EkGlpuBA,2BAAA;EACI,gCAAA;AlGopuBJ;;AAEA;EkGjpuBA,2BAAA;EAKA,+BAAA;AAKA;;AAgBI;EACI,2BAAA;ElG6nuBN,6BAA6B;AAC/B;;AAEA;EkGxnuBY,2BAAA;ElG0nuBV,+BAA+B;AACjC;;AAEA;EkGpnuBI,2BAAA;EACA,6BAAA;AlGsnuBJ;;AkGpnuBA;EACI,0BAAA;EACA,2BAAA;AlGunuBJ;;AAEA;EACE,0BAA0B;EkGpnuBpB,gCAAA;AlGsnuBR;;AAEA;EACE,4BAA4B;AkGlnuBtB;;AlGqnuBR;EACE,2BAA2B;AkGlnuBrB;;AlGqnuBR;EACE,2BAA2B;AkGlnuBjB;;AlGqnuBZ;EkGlnuBgB,kBAAA;EACI,oBAAA;AlGonuBpB;;AAEA;EkGhnuBoB;IlGknuBhB,kBAAkB;IkG9muBd,oBAAA;EACI;AlGgnuBZ;;AAEA;EkG5muBQ,UAAA;EACI,QAAA;AlG8muBZ;;AkG3muBQ;EAEQ,UAAA;EACA,WAAA;AlG6muBhB;;AAEA;;EAEE,eAAe;EkGzmuBG,gBAAA;AlG2muBpB;;AkGtmuBoB;EACI,WAAA;ElGymuBtB,UAAU;AACZ;;AAEA;;EkG1luBY,eAAA;EACI,gBAAA;AlG6luBhB;;AAEA;EACE,cAAc;EACd,kBAAkB;AkGrluBpB;;AlGwluBA;EACE,ekGrluBM;ElGsluBN,mBAAmB;AACrB;;AAEA;EACE,UkGnluBkB;ElGoluBlB,WAAW;AACb;;AAEA;EkGjluBY,WAAA;ElGmluBV,UkGlluBc;AlGmluBhB;;AAEA;EACE,ekGjluBkB;ElGkluBlB,gBAAgB;AAClB;;AAEA;EkG/kuBY,WAAA;ElGiluBV,UkGhluBc;ElGiluBd,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EkG5kuBwB,eAAA;ElG8kuBtB,mBkG7kuB0B;AlG8kuB5B;;AAEA;EACE,UAAU;EACV,WAAW;AkGnkuBb;;AlGskuBA;EACE,ckGhkuBkB;ElGikuBlB,kBkGhkuBkB;AlGikuBpB;;AAEA;EACE,UAAU;EkG9juBA,WAAA;AlGgkuBZ;;AAEA;EkG1juBA,eAAA;EACA,iBAAA;AlG4juBA;;AAEA;EkGxjuBY,kBAAA;ElG0juBV,sBkGzjuBc;AlG0juBhB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EkGpjuBb,UAAA;AAGA;;ACpUE;EACE,cAAA;EACA,iBAAA;AnG03uBJ;;AAEA;EmGx3uBI,cAAA;AnG03uBJ;;AAEA;EmGx3uBM,kBAAA;EACA,sBAAA;AnG03uBN;;AAEA;EmGx3uBI,2BAAA;EACE,6BAAA;AnG03uBN;;AAEA;EACE,WAAW;EACX,qBAAqB;AmGr3uBvB;;AnGw3uBA;EmGp3uBI,iBAAA;AnGs3uBJ;;AAEA;EmGj3uBE,kBAAA;EnGm3uBA,cAAc;AmGj3uBd;;AnGo3uBF;EmGj3uBI,eAAA;EACE,iBAAA;AnGm3uBN;;AAEA;EACE,cAAc;AmGj3uBV;;AnGo3uBN;EmGj3uBQ,sBzE3CI;EyE4CJ,qBAAA;AnGm3uBR;;AAEA;EmGh3uBU;IACA,sBAAA;InGk3uBN,qBAAqB;EmGh3uBjB;AnGk3uBR;;AAEA;EmGh3uBU,cAAA;EACA,iBAAA;AnGk3uBV;;AAEA;EmGh3uBU,sBAAA;EACA,kBAAA;AnGk3uBV;;AAEA;EmGh3uBU,gBAAA;EAEE,kBAAA;AnGi3uBZ;;AmG92uBU;EACE,eAAA;EACA,iBAAA;AnGi3uBZ;;AAEA;;EAEE,qBAAqB;EmG92uBf,sBAAA;AnGg3uBR;;AmG72uBQ;EACE,eAAA;EACA,mBAAA;AnGg3uBV;;AAEA;EmG92uBU,WzEhGG;EyEiGH,UAAA;AnGg3uBV;;AAEA;EACE,6BAA6B;EmG52uBvB,6BAAA;AnG82uBR;;AAEA;EmG52uBU,4BAAA;EACE,8BzEtGA;A1Bo9uBZ;;AAEA;EACE,6BAA6B;EmG12uBzB,6BAAA;AnG42uBN;;AAEA;EmG12uBQ,4BAAA;EACE,8BzElHE;A1B89uBZ;;AAEA;EACE,6BAA6B;EmGz2uBzB,0BAAA;AnG22uBN;;AAEA;EmGz2uBQ,4BAAA;EACA,2BAAA;AnG22uBR;;AAEA;EmGz2uBQ,WAAA;EACA,UAAA;AnG22uBR;;AAEA;EmGz2uBQ,WAAA;EACE,OzE9IG;A1By/uBb;;AAEA;EmGx2uBY,cAAA;AnG02uBZ;;AAEA;EmGx2uBU,cAAA;AnG02uBV;;AAEA;EmGx2uBY,cAAA;AnG02uBZ;;AAEA;EmGx2uBY,eAAA;EACA,4BAAA;AnG02uBZ;;AAEA;EACE,qBAAqB;EmGx2uBb,sBAAA;EACE,iBAAA;AnG02uBZ;;AAEA;EmGv2uBY,8BzExKF;A1BihvBV;;AAEA;EACE,6BAA6B;AmGv2uBnB;;AnG02uBZ;EmGv2uBY,6BAAA;AnGy2uBZ;;AmGr2uBU;EACE,gDAAA;AnGw2uBZ;;AAEA;EmGt2uBY,6CAAA;AnGw2uBZ;;AAEA;EmGt2uBY,WzE/KH;EyEgLG,OAAA;AnGw2uBZ;;AmGr2uBY;EACE,0BAAA;EACA,+BAAA;AnGw2uBd;;AAEA;EmGt2uBc,UAAA;EnGw2uBZ,YAAY;AmGr2uBJ;;AnGw2uBV;EmGr2uBY,WAAA;EACA,UAAA;AnGu2uBZ;;AAEA;EACE,UAAU;EmGr2uBA,aAAA;AnGu2uBZ;;AmGj2uBU;EACE,WAAA;EAEE,YAAA;AnGm2uBd;;AmGh2uBY;EACE,ezEnOD;EyEoOC,mBAAA;AnGm2uBd;;AAEA;EmGh2uBgB,eAAA;EACA,mBAAA;EACA,iBAAA;EnGk2uBd,gCAAgC;AmGh2uBpB;;AnGm2uBd;EmGh2uBgB,UAAA;EACA,WAAA;AnGk2uBhB;;AAEA;EmGh2uBgB,UAAA;EACA,QAAA;AnGk2uBhB;;AmG/1uBc;EAEE,eAAA;EACA,8BzEzPN;A1B0lvBV;;AAEA;EACE,eAAe;EmG91uBH,mBAAA;AnGg2uBd;;AAEA;EmG91uBgB,eAAA;EACA,mBAAA;AnGg2uBhB;;AAEA;EmG71uBkB,UAAA;EnG+1uBhB,QAAQ;AmG71uBM;;AnGg2uBhB;EmG71uBkB,2BAAA;EACA,+BAAA;AnG+1uBlB;;AAEA;EmG71uBkB,qCAAA;AnG+1uBlB;;AAEA;EmG71uBkB,qCAAA;AnG+1uBlB;;AAEA;EACE,wCAAwC;AmG51uB1B;;AnG+1uBhB;EACE,cAAc;AmG51uBE;;AnG+1uBlB;EmG11uBc,sBAAA;EACE,qBAAA;AnG41uBhB;;AAEA;EACE,sBAAsB;EmG11uBR,qBAAA;AnG41uBhB;;AmGz1uBgB;EACE,UAAA;EnG41uBhB,QAAQ;AmGx1uBE;;AnG21uBZ;EmGx1uBc,eAAA;EACA,mBAAA;AnG01uBd;;AmGr1uBkB;EACE,sBAAA;EAEA,kBAAA;AnGu1uBpB;;AAEA;EmGl1uB0B,yBAAA;EnGo1uBxB,6BAA6B;AmGj1uBL;;AnGo1uB1B;EACE,sBAAsB;EmG50uBJ,qBAAA;AnG80uBpB;;AAEA;EmGv0uBc,cAAA;AnGy0uBd;;AAEA;EmGn0uBM,cAAA;AnGq0uBN;;AmGl0uBQ;EACE,cAAA;AnGq0uBV;;AAEA;EACE,cAAc;AmGl0uBN;;AnGq0uBV;EmGl0uBY,cAAA;AnGo0uBZ;;AAEA;EmGj0uBY,cAAA;AnGm0uBZ;;AAEA;EmGh0uBgB,cAAA;AnGk0uBhB;;AAEA;EmG3zuBU,cAAA;AnG6zuBV;;AAEA;EmGzzuBU,cAAA;AnG2zuBV;;AAEA;EACE,eAAe;EmGrzuBG,kBAAA;EACE,cAAA;EnGuzuBpB,eAAe;AmGnzuBS;;AnGszuB1B;EACE,WAAW;EmGlyuBP,OAAA;AnGoyuBN;;AmGjyuBM;EACE,gBAAA;AnGoyuBR;;AAEA;EACE,eAAe;EmG7xuBX,gBAAA;AnG+xuBN;;AmG5xuBQ;EACE,c9F3bC;AL0tvBX;;AAEA;EACE,WAAW;EmG7xuBH,OAAA;EACE,4BAAA;AnG+xuBZ;;AAEA;EACE,wBAAwB;AmG7xuBd;;AnGgyuBZ;EmG5xuBU;IACE,yB9F3cD;I8F4cC,6BAAA;EnG8xuBV;AmG5xuBU;;AnG+xuBZ;EmG5xuBY;IACE,yB9FldH;ILgvvBP,6BAA6B;EmG1xuBzB;;EAEE;InG4xuBN,yBAAyB;ImG1xuBnB,+BAAA;EACE;AnG4xuBZ;;AAEA;EACE,eAAe;EmGzxuBT,gBAAA;AnG2xuBR;;AmGvxuBY;EAEE,eAAA;EnGyxuBZ,oBAAoB;AmGvxuBV;;AnG0xuBZ;EmGvxuBc,YAAA;EACE,cAAA;EnGyxuBd,oBAAoB;AmGvxuBR;;AnG0xuBd;EmGnxuBc,eAAA;EACE,kBAAA;AnGqxuBhB;;AAEA;EACE,eAAe;EmGlxuBD,mBAAA;AnGoxuBhB;;AAEA;EmGjxuBkB,UAAA;EACE,QAAA;AnGmxuBpB;;AAEA;EACE,yBAAyB;EmGhxuBT,kBAAA;AnGkxuBlB;;AmG/wuBkB;EACE,gBAAA;AnGkxuBpB;;AAEA;EACE,cAAc;EmG/wuBE,kBAAA;AnGixuBlB;;AmG9wuBoB;EACE;InGixuBlB,yBAAyB;IACzB,6BAA6B;EmGnwuB3B;AnGqwuBN;;AmGlwuBM;EACE;InGqwuBJ,0BAA0B;ImGnwuBtB,8BAAA;EACE;AnGqwuBV;;AmGxvuBQ;EAEI;IACA,yBAAA;InG0vuBR,6BAA6B;EmGxvuBvB;AnG0vuBV;;AAEA;EmGtvuBU,yBAAA;EAEI,+BAAA;AnGuvuBd;;AmGnvuBU;EACE,eAAA;EACA,8BAAA;AnGsvuBZ;;AAEA;EmGnvuBU,UAAA;EnGqvuBR,QAAQ;AmGnvuBA;;AnGsvuBV;EACE,qBAAqB;AmGlvuBX;;AnGqvuBZ;EACE;ImGlvuBU,2BAAA;IACE,6BAAA;EnGovuBZ;AmGlvuBU;;AnGqvuBZ;EACE;ImGlvuBU,0BAAA;IAEI,4BAAA;EACA;AnGmvuBhB;;AAEA;EmG5uuBkB,sBAAA;EnG8uuBhB,qBAAqB;AmG5uuBP;;AnG+uuBhB;EACE;ImG5uuBc,UAAA;IAEI,YAAA;IACA,UAAA;EnG6uuBlB;;EmG1uuBkB;IACA,sBAAA;InG6uuBhB,qBAAqB;ImG1uuBT,qBAAA;IAEI,qBAAA;EACA;;EAIN;IACE,QAAA;EACA;;EAwBN;IACE,sBAAA;InGmtuBR,qBAAqB;EmG/suBf;;EAEE;InGituBR,mBAAmB;ImG7suBP,kBAAA;EACE;;EnGgtuBhB;ImG3suBoB,iBAAA;EACE;AnG6suBxB;;AmGxsuB4B;EACE;IACA,YAAA;InG2suB1B,6CAA6C;EAC/C;;EmGvruBI;InG0ruBF,qBAAqB;ImGxruBrB,mBAAA;EACE;;EAEA;IACA,4CAAA;EACA;AnG0ruBN;;AAEA;EmGtruBA;IACA,kBAAA;IAGM,oBAAA;EnGsruBJ;AACF;;AAEA;EACE;ImGjruBF,kBAAA;IACA,oBAAA;EACE;AnGmruBF;;AAEA;EACE,yBmGhruBM;AnGiruBR;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AmG1quBZ;;AnG6quBA;EACE,UmGzquBM;AnG0quBR;;AmGpquBA;EACA,WAAA;EACE,OAAA;AnGuquBF;;AAEA;EACE,cmGnquBM;AnGoquBR;;AAEA;EACE,cAAc;EmGjquBR,mBAAA;AnGmquBR;;AAEA;EACE,emGhquBQ;AnGiquBV;;AmG1puBA;EACA,oBAAA;AnG6puBA;;AAEA;EmG9ouBE,YAAA;EnGgpuBA,UmG/ouBE;EnGgpuBF,WAAW;EmG5ouBL,iBAAA;AnG8ouBR;;AAEA;EACE,oBmG3ouBU;AnG4ouBZ;;AAEA;EACE,emGzouBgB;EnG0ouBhB,mBAAmB;AACrB;;AAEA;EmGpouB4B,WAAA;AnGsouB5B;;AAEA;EACE,iBmGhnuBY;AnGinuBd;;AAEA;EACE,kBmG9muBkB;AnG+muBpB;;AAEA;EACE,kBmG5muBwB;EnG6muBxB,cmG5muBwB;AnG6muB1B;;AAEA;EACE,WmG1muB8B;EnG2muB9B,WAAW;AACb;;AmGzluBA;EAGM,OAAA;EnG0luBJ,QmGzluBM;AnG0luBR;;AAEA;EACE,cAAc;EmGjluBV,kBAAA;AnGmluBN;;AAEA;EmG9kuBA,UAAA;EACA,YAAA;AnGgluBA;;AAEA;EmG5kuBQ,OAAA;EnG8kuBN,QmG7kuBQ;AnG8kuBV;;AAEA;;EAEE,WAAW;EmGxkuBG,OAAA;AnG0kuBhB;;AAEA;EACE,yBmGvkuBsB;EnGwkuBtB,6BAA6B;EmGpkuBH,iBAAA;AnGskuB5B;;AAEA;EACE,qBmGhjuBY;EnGijuBZ,QmGhjuBY;AnGijuBd;;AAEA;EACE,mBmG9iuBkB;AnG+iuBpB;;AAEA;EACE,cmG5iuBwB;EnG6iuBxB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AmG1huBpB;;AnG6huBA;;EAEE,eAAe;EmGrhuBf,gBAAA;AnGuhuBF;;AAEA;EACE,WmGnhuBM;EnGohuBN,WAAW;AACb;;AAEA;EACE,YAAY;EoG/iwBZ,gBAAA;EACE,oBAAA;ApGijwBJ;;AAEA;EoG/iwBA,mBAAA;EACE,WAAA;ApGijwBF;;AAEA;EoG/iwBE,iBAAA;ApGijwBF;;AAEA;EoG/iwBE,sBAAA;EpGijwBA,WoGhjwBE;ApGijwBJ;;AAEA;EoG7iwBE,qBAAA;EACE,mBAAA;ApG+iwBJ;;AAEA;EoG5iwBA,yBAAA;EACE,+BAAA;ApG8iwBF;;AAEA;EoG5iwBE;IACA,4BAAA;EACA;;EAED;IACC,+BAAA;EpG8iwBA;AoG5iwBA;;ApG+iwBF;6CoG5iwBI;ApG8iwBJ;EoG5iwBI,oCAAA;ApG8iwBJ;;AAEA;EoG5iwBE,oCAAA;EpG8iwBA,sBAAsB;AoG5iwBpB;;ApG+iwBJ;;;;;;;;EoGriwBG,WAAA;ApG8iwBH;;AAEA;EoG5iwBM,UAAA;ApG8iwBN;;AAEA;EoG1iwBE,sBAAA;ApG4iwBF;;AAEA;EoGziwBM,sBAAA;ApG2iwBN;;AAEA;EoGziwBG,sBAAA;ApG2iwBH;;AAEA;EoGziwBI,sBAAA;ApG2iwBJ;;AAEA;;;;;;;;;;;;EoG9hwBI,WAAA;ApG2iwBJ;;AAEA;EoGxiwBY,sBAAA;ApG0iwBZ;;AAEA;EoGxiwBY,sBAAA;ApG0iwBZ;;AoGviwBU;EACE,oCAAA;ApG0iwBZ;;AAEA;EoGxiwBY,oCAAA;ApG0iwBZ;;AAEA;EoGxiwBU,oCAAA;ApG0iwBV;;AAEA;EoGxiwBY,sBAAA;ApG0iwBZ;;AAEA;EACE,oCAAoC;AoGxiwB5B;;ApG2iwBV;EoGxiwBY,sBAAA;ApG0iwBZ;;AAEA;EoGxiwBY,oCAAA;EpG0iwBV,gCAAgC;EoGxiwBxB,sBAAA;ApG0iwBV;;AAEA;EoGxiwBY,gCAAA;ApG0iwBZ;;AAEA;EACE,gCAAgC;AoGxiwBxB;;ApG2iwBV;EoGxiwBY,gCAAA;ApG0iwBZ;;AAEA;EoGxiwBY,gCAAA;ApG0iwBZ;;AAEA;EoGxiwBY,gCAAA;ApG0iwBZ;;AAEA;EoGxiwBY,gCAAA;ApG0iwBZ;;AoGviwBU;EACE,WAAA;ApG0iwBZ;;AAEA;EoGxiwBY,WAAA;ApG0iwBZ;;AAEA;EoGxiwBU,oCAAA;ApG0iwBV;;AAEA;;EoGviwBY,WAAA;ApG0iwBZ;;AAEA;EoGxiwBU,yBAAA;ApG0iwBV;;AAEA;EoGxiwBY,WAAA;ApG0iwBZ;;AAEA;EACE,aAAa;AoGxiwBL;;ApG2iwBV;;EoGviwBY,WAAA;ApG0iwBZ;;AAEA;;EoGviwBU,WAAA;ApG0iwBV;;AAEA;EoGxiwBY,oCAAA;EACA,iCAAA;ApG0iwBZ;;AAEA;EoGxiwBU,gCAAA;ApG0iwBV;;AAEA;EoGxiwBY,sBAAA;ApG0iwBZ;;AAEA;EACE,sBAAsB;AoGviwBhB;;ApG0iwBR;EoGriwBQ,sBAAA;ApGuiwBR;;AoGpiwBQ;EACH,yBAAA;ApGuiwBL;;AoGpiwBU;EACE,yB1ExOF;E0EyOE,sB1EzOF;A1BgxwBV;;AoGpiwBY;EACE,sBAAA;ApGuiwBd;;AoGjiwBM;;;;EAIF,oCAAA;ApGoiwBJ;;AAEA;EoGliwBU,qBAAA;ApGoiwBV;;AAEA;EoGliwBK,sBAAA;ApGoiwBL;;AAEA;EoGliwBY,oCAAA;EACA,iCAAA;ApGoiwBZ;;AAEA;EoGliwBY,qBAAA;ApGoiwBZ;;AAEA;;EAEE,WAAW;AoGliwBH;;ApGqiwBV;;EoGjiwBY,WAAA;ApGoiwBZ;;AAEA;EoG3hwBY,YAAA;ApG6hwBZ;;AAEA;EACE,yBAAyB;AoG3hwBf;;ApG8hwBZ;EoG3hwBc,gCAAA;ApG6hwBd;;AAEA;EoG3hwBc,sBAAA;ApG6hwBd;;AoG1hwBY;EACE,WAAA;ApG6hwBd;;AoG1hwBY;EACE,UAAA;EACA,WAAA;EpG6hwBZ,oBAAoB;AoG3hwBV;;ApG8hwBZ;EACE,gBAAgB;AoG3hwBN;;ApG8hwBZ;EACE,gBAAgB;AoGthwBR;;ApGyhwBV;EoGrhwBc,gBAAA;ApGuhwBd;;AoGphwBc;EACE,WAAA;ApGuhwBhB;;AAEA;EACE,yBAAyB;AoGrhwBb;;ApGwhwBd;;EoGphwBgB,WAAA;ApGuhwBhB;;AAEA;EACE,8DAA8D;EoGrhwBlD,cAAA;ApGuhwBd;;AoG5gwBc;;EpGghwBZ,WAAW;AoGhgwBC;;ApGmgwBd;EoGn/vBc,WAAA;ApGq/vBd;;AoGl/vBc;EACE,yBAAA;ApGq/vBhB;;AAEA;EACE,cAAc;AoGn/vBF;;ApGs/vBd;;EAEE,WAAW;AoGn/vBC;;ApGs/vBd;EACE,WAAW;AoGn/vBC;;ApGs/vBd;EACE,yBAAyB;AoGn/vBb;;ApGs/vBd;;EoG1+vBc,yBAAA;ApG6+vBd;;AAEA;EoG/9vBY,WAAA;ApGi+vBZ;;AoG99vBY;EACE,sBAAA;ApGi+vBd;;AAEA;;EoG99vBY,yBAAA;EACE,cAAA;ApGi+vBd;;AAEA;;EoGx9vBY,UAAA;EACE,qBAAA;ApG29vBd;;AAEA;;EoGn9vBY,kBAAA;ApGs9vBZ;;AoGj9vBY;EACE,WAAA;ApGo9vBd;;AoGj9vBc;;EAEE,WAAA;ApGo9vBhB;;AAEA;EACE,yBAAyB;AoG98vBjB;;ApGi9vBV;EACE,oCAAoC;AoG98vB1B;;ApGi9vBZ;EACE,yBAAyB;EoG18vBvB,cAAA;ApG48vBJ;;AAEA;EoGv8vBE,WAAA;ApGy8vBF;;AoGt8vBE;EACE,qBAAA;ApGy8vBJ;;AAEA;EACE,WAAW;AoGl8vBP;;ApGq8vBN;EoGj8vBQ,cAAA;ApGm8vBR;;AoG/7vBY;EASE,kBAAA;ApG07vBd;;AAEA;EACE,WAAW;AoGl7vBH;;ApGq7vBV;EoGh7vBU,qBAAA;EACE,6B1E3iBF;A1B69wBV;;AAEA;EoG/6vBc,oC1EhjBJ;A1Bi+wBV;;AAEA;EACE,WAAW;AoG56vBH;;ApG+6vBV;EoGv6vBgB,qBAAA;ApGy6vBhB;;AoGz5vBgB;EAME,yB1EllBN;E0EmlBM,WAAA;EpGu5vBhB,qBAAqB;AoG94vBT;;ApGi5vBd;EoGx4vBc,WAAA;EACE,qBAAA;ApG04vBhB;;AAEA;;EoGl4vBc,WAAA;ApGq4vBd;;AoGh4vBc;EACE,qB1ElmBD;A1Bq+wBf;;AoG73vBY;EACE,8B1EjoBJ;E1BigxBR,yBAAyB;AoG93vBf;;ApGi4vBZ;EACE,mBAAmB;EoGz3vBT,qBAAA;EACE,WAAA;ApG23vBd;;AAEA;EoGx3vBgB,yBAAA;ApG03vBhB;;AAEA;EACE,yBAAyB;AoGp3vBf;;ApGu3vBZ;EoGp3vBY,oCAAA;ApGs3vBZ;;AAEA;EoGp3vBc,qBAAA;ApGs3vBd;;AAEA;EACE,wBAAwB;AoG32vBzB;;ApG82vBD;EoG32vBE,eAAA;ApG62vBF;;AAEA;EACE,eAAe;AoG12vBd;;ApG62vBH;EoGz2vBE,eAAA;ApG22vBF;;AAEA;EACE,eAAe;AoGv2vBjB;;ApG02vBA;EACE,eoGx2vBE;ApGy2vBJ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EoGt2vBQ,UAAA;EpGw2vBN,iBoGv2vBQ;ApGw2vBV;;AAEA;EACE,oCoGp2vBM;ApGq2vBR;;AAEA;EACE,6BoGp2vBM;ApGq2vBR;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AoG11vBA;EAIA,qBAAA;AAIA;;ApGw1vBA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;;;;;;EASE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,UAAU;EACV,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;6CAC6C;AAC7C;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;6CAC6C;AAC7C;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;6CAC6C;AAC7C;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;AACF;;AAEA;6CAC6C;AAC7C;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,OAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,MAAM;EACN,OAAO;AACT;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,OAAO;AACT;;AAEA;EACE,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,WAAW;EACX,gEAAgE;EAChE,qDAAqD;EACrD,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;EACrC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B,UAAU;EACV,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,SAAS;EACX;;EAEA;;IAEE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,eAAe;IACf,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,wCAAwC;AACxC;;EAEE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;6CAC6C;AAC7C;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;6CAC6C;AAC7C,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,OAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;6CAC6C;AAC7C,sBAAsB;AACtB;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE;IACE,wBAAwB;IACxB,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,uCAAuC;AACvC,wCAAwC;AACxC;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA,yCAAyC;AACzC;6CAC6C;AAC7C;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,uCAAuC;AACvC,wCAAwC;AACxC,yCAAyC;AACzC,yCAAyC;AACzC;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;;;;;;EAME,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE;IACE,YAAY;EACd;;EAEA;;IAEE,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;;;;IAME,uBAAuB;EACzB;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,YAAY;EACd;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA,wCAAwC;AACxC,yCAAyC;AACzC,qBAAqB;AACrB;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,qCAAqC;AACvC;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,SAAS;EACT,UAAU;EACV,UAAU;EACV,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,MAAM;EACN,UAAU;EACV,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;EACP,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,UAAU;IACV,QAAQ;EACV;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,OAAO;IACP,WAAW;EACb;;EAEA;;IAEE,UAAU;IACV,YAAY;EACd;;EAEA;;IAEE,UAAU;IACV,YAAY;EACd;;EAEA;;IAEE,UAAU;IACV,WAAW;EACb;AACF;;AAEA,oBAAoB;AACpB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,UAAU;IACV,QAAQ;EACV;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,OAAO;IACP,WAAW;EACb;;EAEA;;IAEE,UAAU;IACV,YAAY;EACd;;EAEA;;IAEE,UAAU;IACV,YAAY;EACd;;EAEA;;IAEE,UAAU;IACV,WAAW;EACb;AACF;;AAEA,qBAAqB;AACrB;;EAEE;;;;;;IAME,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA;EACE;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kEAAkE;EAClE,gBAAgB;AAClB;;AAEA;EACE,MAAM;EACN,OAAO;EACP,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;EAEE,eAAe;EACf,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,cAAc;EACd,gDAAgD;EAChD,UAAU;EACV,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,MAAM;EACN,OAAO;EACP,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;EAEE,OAAO;EACP,WAAW;EACX,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;EAC1B,WAAW;EACX,OAAO;AACT;;AAEA;;EAEE,QAAQ;EACR,UAAU;EACV,0BAA0B;AAC5B;;AAEA;;EAEE,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;;;;EAME,qBAAqB;AACvB;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;;;;;;EAME,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;;;;;EASE,mBAAmB;AACrB;;AAEA;;;;;;EAME,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;EAME,qBAAqB;AACvB;;AAEA;;;;;;EAME,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA,oBAAoB;AACpB;EACE;IACE,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA,uCAAuC;AACvC,uCAAuC;AACvC,wCAAwC;AACxC,yCAAyC;AACzC,qBAAqB;;;AAGrB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;AACA;;;EAGE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB","sourcesContent":["// Required\n@import \"../../node_modules/bootstrap/scss/functions\";\n\n// Default variable overrides\n@import \"./variables\";\n\n@import \"../../node_modules/bootstrap/scss/variables\";\n@import \"../../node_modules/bootstrap/scss/variables-dark\";\n@import \"../../node_modules/bootstrap/scss/mixins\";\n\n/* fallback */\n@font-face {\n    font-family: 'Material Symbols Outlined';\n    font-style: normal;\n    font-weight: 400;\n    src: url(https://fonts.gstatic.com/s/materialsymbolsoutlined/v192/kJF1BvYX7BgnkSrUwT8OhrdQw4oELdPIeeII9v6oDMzByHX9rA6RzaxHMPdY43zj-jCxv3fzvRNU22ZXGJpEpjC_1v-p_4MrImHCIJIZrDCvHOej.woff2) format('woff2');\n}\n  \n.material-symbols-outlined {\n    font-family: 'Material Symbols Outlined';\n    font-weight: normal;\n    font-style: normal;\n    font-size: 24px;\n    line-height: 1;\n    letter-spacing: normal;\n    text-transform: none;\n    display: inline-block;\n    white-space: nowrap;\n    word-wrap: normal;\n    direction: ltr;\n    -webkit-font-feature-settings: 'liga';\n    -webkit-font-smoothing: antialiased;\n}\n\n// Create your own map\n$custom-colors: (\n    \"primary-div\": $primary-div,\n    \"primary-div-50\": $primary-div-50,\n    \"primary-div-60\": $primary-div-60,\n    \"primary-50\": $primary-50,\n    \"primary-60\": $primary-60,\n    \"primary-70\": $primary-70,\n \n    \"success-50\": $success-50,\n    \"success-60\": $success-60,\n    \"success-70\": $success-70,\n    \"success-80\": $success-80,\n    \"success-90\": $success-90,\n    \"success-100\": $success-100,\n\n    \"body-bg\": $body-bg,\n    \n    \"danger-div\": $danger-div,\n    \"danger-40\": $danger-40,\n    \"danger-50\": $danger-50,\n    \"danger-60\": $danger-60,\n    \"danger-70\": $danger-70,\n    \"danger-80\": $danger-80,\n    \"danger-90\": $danger-90,\n    \"danger-100\": $danger-100,\n\n    \"rating-color\": $rating-color,\n    \"card-bg-c\": $card-bg-c,\n    \"card-text-c\": $card-text-c,\n    \"gary-light\": $gary-light,\n\n    \"border-color\": $border-color,\n    \"border-color-50\": $border-color-50,\n\n    \"gray-100\": $gray-100,\n\n    \"body-color-50\": $body-color-50,\n    \"body-color-60\": $body-color-60,\n\n    \"purple-100\": $purple-100,\n    \"info-100\": $info-100,  \n);\n\n// Merge the maps\n$theme-colors: map-merge($theme-colors, $custom-colors);\n\n$font-sizes: (\n    1: $h1-font-size,\n    2: $h2-font-size,\n    3: $h3-font-size,\n    4: $h4-font-size,\n    5: $h5-font-size,\n    6: $h6-font-size,\n);\n\n// Required Utilities Parts\n$utilities: (\n    \"font-size\": (\n        rfs: true,\n        property: font-size,\n        class: fs,\n        values: $font-sizes\n    ),\n);\n\n// Required\n@import \"../../node_modules/bootstrap/scss/maps\";\n@import \"../../node_modules/bootstrap/scss/root\";\n\n// Optional Bootstrap components here\n@import \"../../node_modules/bootstrap/scss/reboot\"; \n@import \"../../node_modules/bootstrap/scss/type\";\n\n// Required\n@import \"../../node_modules/bootstrap/scss/bootstrap\";\n\n// Page & Components\n// global Styles\n@import \"./components/global\";\n\n// Left Sidebar Menu\n@import \"./components/sidebar-menu\";\n@import \"./components/main-content\";\n@import \"./components/header-area\";\n@import \"./components/footer-area\";\n@import \"./components/stats-box\";\n@import \"./components/sales-by-locations\";\n@import \"./components/default-table\";\n@import \"./components/pagination\";\n@import \"./components/calendar\";\n@import \"./components/chat\";\n@import \"./components/timeline\";\n@import \"./components/priceing\";\n@import \"./components/products\";\n\n// RTL Style\n@import \"./components/rtl\";\n\n// Dark mode Style\n@import \"./components/dark-mode\";\n\n@import \"./components/card-style\";\n@import \"./components/card-bg-style\";\n@import \"./components/fluid-boxed-style\";\n@import \"./components/landing-page\";\n@import \"./components/analytics\";\n@import \"./components/marketing\";\n@import \"./components/nft\";\n@import \"./components/restaurant\";\n\n// Horizontal navbar.scss\n@import \"./components/horizontal-navbar\";\n\n// settings-sidebar\n@import \"./components/settings-sidebar\";\n// Placeholders tenues para distinguirlos del texto ingresado. Incluye\n// .form-control porque Bootstrap le fija opacity: 1 y el tema color #fff.\ninput::placeholder,\ntextarea::placeholder,\n.form-control::placeholder {\n  opacity: 0.4;\n}\n\n// El modo oscuro pinta todos los span (.dark span); el botón de Google\n// renderiza su texto en un span y quedaba blanco sobre blanco.\n.google-signin-btn span {\n  color: inherit !important;\n}\n\n// Opciones de ingreso: mismo tamaño y estilo que el botón oficial de Google.\n.login-options {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  max-width: 400px;\n}\n.login-option-btn {\n  position: relative;\n  width: 100%;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  border: 1px solid #dadce0;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n\n  &:hover {\n    background: #f8faff;\n  }\n  // .dark pinta span/i en claro; aquí el fondo es blanco.\n  &,\n  span,\n  i {\n    color: #3c4043 !important;\n  }\n  i {\n    position: absolute;\n    left: 12px;\n    font-size: 20px;\n  }\n}\n","\n@charset \"UTF-8\";\n\n/* fallback */\n@font-face {\n  font-family: \"Material Symbols Outlined\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/materialsymbolsoutlined/v192/kJF1BvYX7BgnkSrUwT8OhrdQw4oELdPIeeII9v6oDMzByHX9rA6RzaxHMPdY43zj-jCxv3fzvRNU22ZXGJpEpjC_1v-p_4MrImHCIJIZrDCvHOej.woff2) format(\"woff2\");\n}\n\n.material-symbols-outlined {\n  font-family: \"Material Symbols Outlined\";\n  font-weight: normal;\n  font-style: normal;\n  font-size: 24px;\n  line-height: 1;\n  letter-spacing: normal;\n  text-transform: none;\n  display: inline-block;\n  white-space: nowrap;\n  word-wrap: normal;\n  direction: ltr;\n  -webkit-font-feature-settings: \"liga\";\n  -webkit-font-smoothing: antialiased;\n}\n\n:root,\n[data-bs-theme=light] {\n  --bs-blue: #0d6efd;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-black: #000;\n  --bs-white: #fff;\n  --bs-gray: #6c757d;\n  --bs-gray-dark: #343a40;\n  --bs-gray-100: #f5f7f8;\n  --bs-gray-200: #e9ecef;\n  --bs-gray-300: #dee2e6;\n  --bs-gray-400: #ced4da;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #6c757d;\n  --bs-gray-700: #495057;\n  --bs-gray-800: #343a40;\n  --bs-gray-900: #212529;\n  --bs-primary: #d08f2c;\n  --bs-secondary: #3A4252;\n  --bs-success: #37D80A;\n  --bs-info: #2DB6F5;\n  --bs-warning: #FFBC2B;\n  --bs-danger: #FD5812;\n  --bs-light: #D5D9E2;\n  --bs-dark: #000000;\n  --bs-primary-div: #d08f2c;\n  --bs-primary-div-50: #b27c26;\n  --bs-primary-div-60: #946920;\n  --bs-primary-50: #b27c26;\n  --bs-primary-60: #946920;\n  --bs-primary-70: #76561a;\n  --bs-success-50: #1E8308;\n  --bs-success-60: #25B003;\n  --bs-success-70: #82FC5A;\n  --bs-success-80: #D8FFC8;\n  --bs-success-90: #eeffe5;\n  --bs-success-100: #d8ffc8;\n  --bs-body-bg: #F6F7F9;\n  --bs-danger-div: #ffed9d;\n  --bs-danger-40: #D71C00;\n  --bs-danger-50: #EE3E08;\n  --bs-danger-60: #EC1F00;\n  --bs-danger-70: #FFE1DD;\n  --bs-danger-80: #ff4023;\n  --bs-danger-90: #C52B09;\n  --bs-danger-100: #ffe1dd;\n  --bs-rating-color: #FE7A36;\n  --bs-card-bg-c: #3584FC;\n  --bs-card-text-c: #FFE8D4;\n  --bs-gary-light: #F4F6FC;\n  --bs-border-color: #ECEEF2;\n  --bs-border-color-50: #ECF0FF;\n  --bs-gray-100: #f5f7f8;\n  --bs-body-color-50: #526077;\n  --bs-body-color-60: #8695AA;\n  --bs-purple-100: #f3e8ff;\n  --bs-info-100: #daebff;\n  --bs-primary-rgb: 208, 143, 44;\n  --bs-secondary-rgb: 58, 66, 82;\n  --bs-success-rgb: 55, 216, 10;\n  --bs-info-rgb: 45, 182, 245;\n  --bs-warning-rgb: 255, 188, 43;\n  --bs-danger-rgb: 253, 88, 18;\n  --bs-light-rgb: 213, 217, 226;\n  --bs-dark-rgb: 0, 0, 0;\n  --bs-primary-div-rgb: 208, 143, 44;\n  --bs-primary-div-50-rgb: 178, 124, 38;\n  --bs-primary-div-60-rgb: 148, 105, 32;\n  --bs-primary-50-rgb: 178, 124, 38;\n  --bs-primary-60-rgb: 148, 105, 32;\n  --bs-primary-70-rgb: 118, 86, 26;\n  --bs-success-50-rgb: 30, 131, 8;\n  --bs-success-60-rgb: 37, 176, 3;\n  --bs-success-70-rgb: 130, 252, 90;\n  --bs-success-80-rgb: 216, 255, 200;\n  --bs-success-90-rgb: 238, 255, 229;\n  --bs-success-100-rgb: 216, 255, 200;\n  --bs-body-bg-rgb: 246, 247, 249;\n  --bs-danger-div-rgb: 255, 237, 157;\n  --bs-danger-40-rgb: 215, 28, 0;\n  --bs-danger-50-rgb: 238, 62, 8;\n  --bs-danger-60-rgb: 236, 31, 0;\n  --bs-danger-70-rgb: 255, 225, 221;\n  --bs-danger-80-rgb: 255, 64, 35;\n  --bs-danger-90-rgb: 197, 43, 9;\n  --bs-danger-100-rgb: 255, 225, 221;\n  --bs-rating-color-rgb: 254, 122, 54;\n  --bs-card-bg-c-rgb: 53, 132, 252;\n  --bs-card-text-c-rgb: 255, 232, 212;\n  --bs-gary-light-rgb: 244, 246, 252;\n  --bs-border-color-rgb: 236, 238, 242;\n  --bs-border-color-50-rgb: 236, 240, 255;\n  --bs-gray-100-rgb: 245, 247, 248;\n  --bs-body-color-50-rgb: 82, 96, 119;\n  --bs-body-color-60-rgb: 134, 149, 170;\n  --bs-purple-100-rgb: 243, 232, 255;\n  --bs-info-100-rgb: 218, 235, 255;\n  --bs-primary-text-emphasis: rgb(83.2, 57.2, 17.6);\n  --bs-secondary-text-emphasis: rgb(23.2, 26.4, 32.8);\n  --bs-success-text-emphasis: rgb(22, 86.4, 4);\n  --bs-info-text-emphasis: rgb(18, 72.8, 98);\n  --bs-warning-text-emphasis: rgb(102, 75.2, 17.2);\n  --bs-danger-text-emphasis: rgb(101.2, 35.2, 7.2);\n  --bs-light-text-emphasis: #495057;\n  --bs-dark-text-emphasis: #495057;\n  --bs-primary-bg-subtle: rgb(245.6, 232.6, 212.8);\n  --bs-secondary-bg-subtle: rgb(215.6, 217.2, 220.4);\n  --bs-success-bg-subtle: rgb(215, 247.2, 206);\n  --bs-info-bg-subtle: rgb(213, 240.4, 253);\n  --bs-warning-bg-subtle: rgb(255, 241.6, 212.6);\n  --bs-danger-bg-subtle: rgb(254.6, 221.6, 207.6);\n  --bs-light-bg-subtle: rgb(250, 251, 251.5);\n  --bs-dark-bg-subtle: #ced4da;\n  --bs-primary-border-subtle: rgb(236.2, 210.2, 170.6);\n  --bs-secondary-border-subtle: rgb(176.2, 179.4, 185.8);\n  --bs-success-border-subtle: rgb(175, 239.4, 157);\n  --bs-info-border-subtle: rgb(171, 225.8, 251);\n  --bs-warning-border-subtle: rgb(255, 228.2, 170.2);\n  --bs-danger-border-subtle: rgb(254.2, 188.2, 160.2);\n  --bs-light-border-subtle: #e9ecef;\n  --bs-dark-border-subtle: #adb5bd;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-black-rgb: 0, 0, 0;\n  --bs-font-sans-serif: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 0.88rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #fff;\n  --bs-body-color-rgb: 255, 255, 255;\n  --bs-body-bg: #F6F7F9;\n  --bs-body-bg-rgb: 246, 247, 249;\n  --bs-emphasis-color: #000;\n  --bs-emphasis-color-rgb: 0, 0, 0;\n  --bs-secondary-color: rgba(255, 255, 255, 0.75);\n  --bs-secondary-color-rgb: 255, 255, 255;\n  --bs-secondary-bg: #e9ecef;\n  --bs-secondary-bg-rgb: 233, 236, 239;\n  --bs-tertiary-color: rgba(255, 255, 255, 0.5);\n  --bs-tertiary-color-rgb: 255, 255, 255;\n  --bs-tertiary-bg: #f5f7f8;\n  --bs-tertiary-bg-rgb: 245, 247, 248;\n  --bs-heading-color: inherit;\n  --bs-link-color: #d08f2c;\n  --bs-link-color-rgb: 208, 143, 44;\n  --bs-link-decoration: underline;\n  --bs-link-hover-color: rgb(166.4, 114.4, 35.2);\n  --bs-link-hover-color-rgb: 166, 114, 35;\n  --bs-code-color: #d63384;\n  --bs-highlight-color: #fff;\n  --bs-highlight-bg: rgb(255, 242.6, 205.4);\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #ECEEF2;\n  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);\n  --bs-border-radius: 0.375rem;\n  --bs-border-radius-sm: 0.25rem;\n  --bs-border-radius-lg: 0.5rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-xxl: 2rem;\n  --bs-border-radius-2xl: var(--bs-border-radius-xxl);\n  --bs-border-radius-pill: 50rem;\n  --bs-box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);\n  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  --bs-focus-ring-width: 0.25rem;\n  --bs-focus-ring-opacity: 0.25;\n  --bs-focus-ring-color: rgba(208, 143, 44, 0.25);\n  --bs-form-valid-color: #37D80A;\n  --bs-form-valid-border-color: #37D80A;\n  --bs-form-invalid-color: #FD5812;\n  --bs-form-invalid-border-color: #FD5812;\n}\n\n[data-bs-theme=dark] {\n  color-scheme: dark;\n  --bs-body-color: #dee2e6;\n  --bs-body-color-rgb: 222, 226, 230;\n  --bs-body-bg: #212529;\n  --bs-body-bg-rgb: 33, 37, 41;\n  --bs-emphasis-color: #fff;\n  --bs-emphasis-color-rgb: 255, 255, 255;\n  --bs-secondary-color: rgba(222, 226, 230, 0.75);\n  --bs-secondary-color-rgb: 222, 226, 230;\n  --bs-secondary-bg: #343a40;\n  --bs-secondary-bg-rgb: 52, 58, 64;\n  --bs-tertiary-color: rgba(222, 226, 230, 0.5);\n  --bs-tertiary-color-rgb: 222, 226, 230;\n  --bs-tertiary-bg: rgb(42.5, 47.5, 52.5);\n  --bs-tertiary-bg-rgb: 43, 48, 53;\n  --bs-primary-text-emphasis: rgb(226.8, 187.8, 128.4);\n  --bs-secondary-text-emphasis: rgb(136.8, 141.6, 151.2);\n  --bs-success-text-emphasis: rgb(135, 231.6, 108);\n  --bs-info-text-emphasis: rgb(129, 211.2, 249);\n  --bs-warning-text-emphasis: rgb(255, 214.8, 127.8);\n  --bs-danger-text-emphasis: rgb(253.8, 154.8, 112.8);\n  --bs-light-text-emphasis: #f5f7f8;\n  --bs-dark-text-emphasis: #dee2e6;\n  --bs-primary-bg-subtle: rgb(41.6, 28.6, 8.8);\n  --bs-secondary-bg-subtle: rgb(11.6, 13.2, 16.4);\n  --bs-success-bg-subtle: rgb(11, 43.2, 2);\n  --bs-info-bg-subtle: rgb(9, 36.4, 49);\n  --bs-warning-bg-subtle: rgb(51, 37.6, 8.6);\n  --bs-danger-bg-subtle: rgb(50.6, 17.6, 3.6);\n  --bs-light-bg-subtle: #343a40;\n  --bs-dark-bg-subtle: #1a1d20;\n  --bs-primary-border-subtle: rgb(124.8, 85.8, 26.4);\n  --bs-secondary-border-subtle: rgb(34.8, 39.6, 49.2);\n  --bs-success-border-subtle: rgb(33, 129.6, 6);\n  --bs-info-border-subtle: rgb(27, 109.2, 147);\n  --bs-warning-border-subtle: rgb(153, 112.8, 25.8);\n  --bs-danger-border-subtle: rgb(151.8, 52.8, 10.8);\n  --bs-light-border-subtle: #495057;\n  --bs-dark-border-subtle: #343a40;\n  --bs-heading-color: inherit;\n  --bs-link-color: rgb(226.8, 187.8, 128.4);\n  --bs-link-hover-color: rgb(232.44, 201.24, 153.72);\n  --bs-link-color-rgb: 227, 188, 128;\n  --bs-link-hover-color-rgb: 232, 201, 154;\n  --bs-code-color: rgb(230.4, 132.6, 181.2);\n  --bs-highlight-color: #dee2e6;\n  --bs-highlight-bg: rgb(102, 77.2, 2.8);\n  --bs-border-color: #495057;\n  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);\n  --bs-form-valid-color: rgb(117, 183, 152.4);\n  --bs-form-valid-border-color: rgb(117, 183, 152.4);\n  --bs-form-invalid-color: rgb(234, 133.8, 143.4);\n  --bs-form-invalid-border-color: rgb(234, 133.8, 143.4);\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :root {\n    scroll-behavior: smooth;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-body-color);\n  text-align: var(--bs-body-text-align);\n  background-color: var(--bs-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  margin: 1rem 0;\n  color: inherit;\n  border: 0;\n  border-top: var(--bs-border-width) solid;\n  opacity: 0.25;\n}\n\nh6,\n.h6,\nh5,\n.h5,\nh4,\n.h4,\nh3,\n.h3,\nh2,\n.h2,\nh1,\n.h1 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n  color: var(--bs-heading-color);\n}\n\nh1,\n.h1 {\n  font-size: calc(1.345rem + 1.14vw);\n}\n\n@media (min-width: 1200px) {\n\n  h1,\n  .h1 {\n    font-size: 2.2rem;\n  }\n}\n\nh2,\n.h2 {\n  font-size: calc(1.3274rem + 0.9288vw);\n}\n\n@media (min-width: 1200px) {\n\n  h2,\n  .h2 {\n    font-size: 2.024rem;\n  }\n}\n\nh3,\n.h3 {\n  font-size: calc(1.2834rem + 0.4008vw);\n}\n\n@media (min-width: 1200px) {\n\n  h3,\n  .h3 {\n    font-size: 1.584rem;\n  }\n}\n\nh4,\n.h4 {\n  font-size: 1.232rem;\n}\n\nh5,\n.h5 {\n  font-size: 0.88rem;\n}\n\nh6,\n.h6 {\n  font-size: 0.88rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall,\n.small {\n  font-size: 0.875em;\n}\n\nmark,\n.mark {\n  padding: 0.1875em;\n  color: var(--bs-highlight-color);\n  background-color: var(--bs-highlight-bg);\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));\n  text-decoration: underline;\n}\n\na:hover {\n  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);\n}\n\na:not([href]):not([class]),\na:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 0.875em;\n}\n\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 0.875em;\n  color: var(--bs-code-color);\n  word-wrap: break-word;\n}\n\na>code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.1875rem 0.375rem;\n  font-size: 0.875em;\n  color: var(--bs-body-bg);\n  background-color: var(--bs-body-color);\n  border-radius: 0.25rem;\n}\n\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-secondary-color);\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\n\nselect:disabled {\n  opacity: 1;\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\n\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  line-height: inherit;\n  font-size: calc(1.275rem + 0.3vw);\n}\n\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\n\nlegend+* {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.1rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-weight: 300;\n  line-height: 1.2;\n  font-size: calc(1.625rem + 4.5vw);\n}\n\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n\n.display-2 {\n  font-weight: 300;\n  line-height: 1.2;\n  font-size: calc(1.575rem + 3.9vw);\n}\n\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n\n.display-3 {\n  font-weight: 300;\n  line-height: 1.2;\n  font-size: calc(1.525rem + 3.3vw);\n}\n\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n\n.display-4 {\n  font-weight: 300;\n  line-height: 1.2;\n  font-size: calc(1.475rem + 2.7vw);\n}\n\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n\n.display-5 {\n  font-weight: 300;\n  line-height: 1.2;\n  font-size: calc(1.425rem + 2.1vw);\n}\n\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n\n.display-6 {\n  font-weight: 300;\n  line-height: 1.2;\n  font-size: calc(1.375rem + 1.5vw);\n}\n\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 0.875em;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.1rem;\n}\n\n.blockquote> :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  font-size: 0.875em;\n  color: #6c757d;\n}\n\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n/*!\n * Bootstrap  v5.3.7 (https://getbootstrap.com/)\n * Copyright 2011-2025 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root,\n[data-bs-theme=light] {\n  --bs-blue: #0d6efd;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-black: #000;\n  --bs-white: #fff;\n  --bs-gray: #6c757d;\n  --bs-gray-dark: #343a40;\n  --bs-gray-100: #f5f7f8;\n  --bs-gray-200: #e9ecef;\n  --bs-gray-300: #dee2e6;\n  --bs-gray-400: #ced4da;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #6c757d;\n  --bs-gray-700: #495057;\n  --bs-gray-800: #343a40;\n  --bs-gray-900: #212529;\n  --bs-primary: #d08f2c;\n  --bs-secondary: #3A4252;\n  --bs-success: #37D80A;\n  --bs-info: #2DB6F5;\n  --bs-warning: #FFBC2B;\n  --bs-danger: #FD5812;\n  --bs-light: #D5D9E2;\n  --bs-dark: #000000;\n  --bs-primary-div: #d08f2c;\n  --bs-primary-div-50: #b27c26;\n  --bs-primary-div-60: #946920;\n  --bs-primary-50: #b27c26;\n  --bs-primary-60: #946920;\n  --bs-primary-70: #76561a;\n  --bs-success-50: #1E8308;\n  --bs-success-60: #25B003;\n  --bs-success-70: #82FC5A;\n  --bs-success-80: #D8FFC8;\n  --bs-success-90: #eeffe5;\n  --bs-success-100: #d8ffc8;\n  --bs-body-bg: #F6F7F9;\n  --bs-danger-div: #ffed9d;\n  --bs-danger-40: #D71C00;\n  --bs-danger-50: #EE3E08;\n  --bs-danger-60: #EC1F00;\n  --bs-danger-70: #FFE1DD;\n  --bs-danger-80: #ff4023;\n  --bs-danger-90: #C52B09;\n  --bs-danger-100: #ffe1dd;\n  --bs-rating-color: #FE7A36;\n  --bs-card-bg-c: #3584FC;\n  --bs-card-text-c: #FFE8D4;\n  --bs-gary-light: #F4F6FC;\n  --bs-border-color: #ECEEF2;\n  --bs-border-color-50: #ECF0FF;\n  --bs-gray-100: #f5f7f8;\n  --bs-body-color-50: #526077;\n  --bs-body-color-60: #8695AA;\n  --bs-purple-100: #f3e8ff;\n  --bs-info-100: #daebff;\n  --bs-primary-rgb: 208, 143, 44;\n  --bs-secondary-rgb: 58, 66, 82;\n  --bs-success-rgb: 55, 216, 10;\n  --bs-info-rgb: 45, 182, 245;\n  --bs-warning-rgb: 255, 188, 43;\n  --bs-danger-rgb: 253, 88, 18;\n  --bs-light-rgb: 213, 217, 226;\n  --bs-dark-rgb: 0, 0, 0;\n  --bs-primary-div-rgb: 208, 143, 44;\n  --bs-primary-div-50-rgb: 178, 124, 38;\n  --bs-primary-div-60-rgb: 148, 105, 32;\n  --bs-primary-50-rgb: 178, 124, 38;\n  --bs-primary-60-rgb: 148, 105, 32;\n  --bs-primary-70-rgb: 118, 86, 26;\n  --bs-success-50-rgb: 30, 131, 8;\n  --bs-success-60-rgb: 37, 176, 3;\n  --bs-success-70-rgb: 130, 252, 90;\n  --bs-success-80-rgb: 216, 255, 200;\n  --bs-success-90-rgb: 238, 255, 229;\n  --bs-success-100-rgb: 216, 255, 200;\n  --bs-body-bg-rgb: 246, 247, 249;\n  --bs-danger-div-rgb: 255, 237, 157;\n  --bs-danger-40-rgb: 215, 28, 0;\n  --bs-danger-50-rgb: 238, 62, 8;\n  --bs-danger-60-rgb: 236, 31, 0;\n  --bs-danger-70-rgb: 255, 225, 221;\n  --bs-danger-80-rgb: 255, 64, 35;\n  --bs-danger-90-rgb: 197, 43, 9;\n  --bs-danger-100-rgb: 255, 225, 221;\n  --bs-rating-color-rgb: 254, 122, 54;\n  --bs-card-bg-c-rgb: 53, 132, 252;\n  --bs-card-text-c-rgb: 255, 232, 212;\n  --bs-gary-light-rgb: 244, 246, 252;\n  --bs-border-color-rgb: 236, 238, 242;\n  --bs-border-color-50-rgb: 236, 240, 255;\n  --bs-gray-100-rgb: 245, 247, 248;\n  --bs-body-color-50-rgb: 82, 96, 119;\n  --bs-body-color-60-rgb: 134, 149, 170;\n  --bs-purple-100-rgb: 243, 232, 255;\n  --bs-info-100-rgb: 218, 235, 255;\n  --bs-primary-text-emphasis: rgb(83.2, 57.2, 17.6);\n  --bs-secondary-text-emphasis: rgb(23.2, 26.4, 32.8);\n  --bs-success-text-emphasis: rgb(22, 86.4, 4);\n  --bs-info-text-emphasis: rgb(18, 72.8, 98);\n  --bs-warning-text-emphasis: rgb(102, 75.2, 17.2);\n  --bs-danger-text-emphasis: rgb(101.2, 35.2, 7.2);\n  --bs-light-text-emphasis: #495057;\n  --bs-dark-text-emphasis: #495057;\n  --bs-primary-bg-subtle: rgb(245.6, 232.6, 212.8);\n  --bs-secondary-bg-subtle: rgb(215.6, 217.2, 220.4);\n  --bs-success-bg-subtle: rgb(215, 247.2, 206);\n  --bs-info-bg-subtle: rgb(213, 240.4, 253);\n  --bs-warning-bg-subtle: rgb(255, 241.6, 212.6);\n  --bs-danger-bg-subtle: rgb(254.6, 221.6, 207.6);\n  --bs-light-bg-subtle: rgb(250, 251, 251.5);\n  --bs-dark-bg-subtle: #ced4da;\n  --bs-primary-border-subtle: rgb(236.2, 210.2, 170.6);\n  --bs-secondary-border-subtle: rgb(176.2, 179.4, 185.8);\n  --bs-success-border-subtle: rgb(175, 239.4, 157);\n  --bs-info-border-subtle: rgb(171, 225.8, 251);\n  --bs-warning-border-subtle: rgb(255, 228.2, 170.2);\n  --bs-danger-border-subtle: rgb(254.2, 188.2, 160.2);\n  --bs-light-border-subtle: #e9ecef;\n  --bs-dark-border-subtle: #adb5bd;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-black-rgb: 0, 0, 0;\n  --bs-font-sans-serif: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 0.88rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #fff;\n  --bs-body-color-rgb: 255, 255, 255;\n  --bs-body-bg: #F6F7F9;\n  --bs-body-bg-rgb: 246, 247, 249;\n  --bs-emphasis-color: #000;\n  --bs-emphasis-color-rgb: 0, 0, 0;\n  --bs-secondary-color: rgba(255, 255, 255, 0.75);\n  --bs-secondary-color-rgb: 255, 255, 255;\n  --bs-secondary-bg: #e9ecef;\n  --bs-secondary-bg-rgb: 233, 236, 239;\n  --bs-tertiary-color: rgba(255, 255, 255, 0.5);\n  --bs-tertiary-color-rgb: 255, 255, 255;\n  --bs-tertiary-bg: #f5f7f8;\n  --bs-tertiary-bg-rgb: 245, 247, 248;\n  --bs-heading-color: inherit;\n  --bs-link-color: #d08f2c;\n  --bs-link-color-rgb: 208, 143, 44;\n  --bs-link-decoration: underline;\n  --bs-link-hover-color: rgb(166.4, 114.4, 35.2);\n  --bs-link-hover-color-rgb: 166, 114, 35;\n  --bs-code-color: #d63384;\n  --bs-highlight-color: #fff;\n  --bs-highlight-bg: rgb(255, 242.6, 205.4);\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #ECEEF2;\n  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);\n  --bs-border-radius: 0.375rem;\n  --bs-border-radius-sm: 0.25rem;\n  --bs-border-radius-lg: 0.5rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-xxl: 2rem;\n  --bs-border-radius-2xl: var(--bs-border-radius-xxl);\n  --bs-border-radius-pill: 50rem;\n  --bs-box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);\n  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  --bs-focus-ring-width: 0.25rem;\n  --bs-focus-ring-opacity: 0.25;\n  --bs-focus-ring-color: rgba(208, 143, 44, 0.25);\n  --bs-form-valid-color: #37D80A;\n  --bs-form-valid-border-color: #37D80A;\n  --bs-form-invalid-color: #FD5812;\n  --bs-form-invalid-border-color: #FD5812;\n}\n\n[data-bs-theme=dark] {\n  color-scheme: dark;\n  --bs-body-color: #dee2e6;\n  --bs-body-color-rgb: 222, 226, 230;\n  --bs-body-bg: #212529;\n  --bs-body-bg-rgb: 33, 37, 41;\n  --bs-emphasis-color: #fff;\n  --bs-emphasis-color-rgb: 255, 255, 255;\n  --bs-secondary-color: rgba(222, 226, 230, 0.75);\n  --bs-secondary-color-rgb: 222, 226, 230;\n  --bs-secondary-bg: #343a40;\n  --bs-secondary-bg-rgb: 52, 58, 64;\n  --bs-tertiary-color: rgba(222, 226, 230, 0.5);\n  --bs-tertiary-color-rgb: 222, 226, 230;\n  --bs-tertiary-bg: rgb(42.5, 47.5, 52.5);\n  --bs-tertiary-bg-rgb: 43, 48, 53;\n  --bs-primary-text-emphasis: rgb(226.8, 187.8, 128.4);\n  --bs-secondary-text-emphasis: rgb(136.8, 141.6, 151.2);\n  --bs-success-text-emphasis: rgb(135, 231.6, 108);\n  --bs-info-text-emphasis: rgb(129, 211.2, 249);\n  --bs-warning-text-emphasis: rgb(255, 214.8, 127.8);\n  --bs-danger-text-emphasis: rgb(253.8, 154.8, 112.8);\n  --bs-light-text-emphasis: #f5f7f8;\n  --bs-dark-text-emphasis: #dee2e6;\n  --bs-primary-bg-subtle: rgb(41.6, 28.6, 8.8);\n  --bs-secondary-bg-subtle: rgb(11.6, 13.2, 16.4);\n  --bs-success-bg-subtle: rgb(11, 43.2, 2);\n  --bs-info-bg-subtle: rgb(9, 36.4, 49);\n  --bs-warning-bg-subtle: rgb(51, 37.6, 8.6);\n  --bs-danger-bg-subtle: rgb(50.6, 17.6, 3.6);\n  --bs-light-bg-subtle: #343a40;\n  --bs-dark-bg-subtle: #1a1d20;\n  --bs-primary-border-subtle: rgb(124.8, 85.8, 26.4);\n  --bs-secondary-border-subtle: rgb(34.8, 39.6, 49.2);\n  --bs-success-border-subtle: rgb(33, 129.6, 6);\n  --bs-info-border-subtle: rgb(27, 109.2, 147);\n  --bs-warning-border-subtle: rgb(153, 112.8, 25.8);\n  --bs-danger-border-subtle: rgb(151.8, 52.8, 10.8);\n  --bs-light-border-subtle: #495057;\n  --bs-dark-border-subtle: #343a40;\n  --bs-heading-color: inherit;\n  --bs-link-color: rgb(226.8, 187.8, 128.4);\n  --bs-link-hover-color: rgb(232.44, 201.24, 153.72);\n  --bs-link-color-rgb: 227, 188, 128;\n  --bs-link-hover-color-rgb: 232, 201, 154;\n  --bs-code-color: rgb(230.4, 132.6, 181.2);\n  --bs-highlight-color: #dee2e6;\n  --bs-highlight-bg: rgb(102, 77.2, 2.8);\n  --bs-border-color: #495057;\n  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);\n  --bs-form-valid-color: rgb(117, 183, 152.4);\n  --bs-form-valid-border-color: rgb(117, 183, 152.4);\n  --bs-form-invalid-color: rgb(234, 133.8, 143.4);\n  --bs-form-invalid-border-color: rgb(234, 133.8, 143.4);\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :root {\n    scroll-behavior: smooth;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-body-color);\n  text-align: var(--bs-body-text-align);\n  background-color: var(--bs-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  margin: 1rem 0;\n  color: inherit;\n  border: 0;\n  border-top: var(--bs-border-width) solid;\n  opacity: 0.25;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  line-height: 1.2;\n  color: var(--bs-heading-color);\n}\n\nh1,\n.h1 {\n  font-size: calc(1.345rem + 1.14vw);\n}\n\n@media (min-width: 1200px) {\n\n  h1,\n  .h1 {\n    font-size: 2.2rem;\n  }\n}\n\nh2,\n.h2 {\n  font-size: calc(1.3274rem + 0.9288vw);\n}\n\n@media (min-width: 1200px) {\n\n  h2,\n  .h2 {\n    font-size: 2.024rem;\n  }\n}\n\nh3,\n.h3 {\n  font-size: calc(1.2834rem + 0.4008vw);\n}\n\n@media (min-width: 1200px) {\n\n  h3,\n  .h3 {\n    font-size: 1.584rem;\n  }\n}\n\nh4,\n.h4 {\n  font-size: 1.232rem;\n}\n\nh5,\n.h5 {\n  font-size: 0.88rem;\n}\n\nh6,\n.h6 {\n  font-size: 0.88rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall,\n.small {\n  font-size: 0.875em;\n}\n\nmark,\n.mark {\n  padding: 0.1875em;\n  color: var(--bs-highlight-color);\n  background-color: var(--bs-highlight-bg);\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));\n  text-decoration: underline;\n}\n\na:hover {\n  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);\n}\n\na:not([href]):not([class]),\na:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 0.875em;\n}\n\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 0.875em;\n  color: var(--bs-code-color);\n  word-wrap: break-word;\n}\n\na>code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.1875rem 0.375rem;\n  font-size: 0.875em;\n  color: var(--bs-body-bg);\n  background-color: var(--bs-body-color);\n  border-radius: 0.25rem;\n}\n\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-secondary-color);\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\n\nselect:disabled {\n  opacity: 1;\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\n\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  line-height: inherit;\n  font-size: calc(1.275rem + 0.3vw);\n}\n\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\n\nlegend+* {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.1rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-weight: 300;\n  line-height: 1.2;\n  font-size: calc(1.625rem + 4.5vw);\n}\n\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n\n.display-2 {\n  font-weight: 300;\n  line-height: 1.2;\n  font-size: calc(1.575rem + 3.9vw);\n}\n\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n\n.display-3 {\n  font-weight: 300;\n  line-height: 1.2;\n  font-size: calc(1.525rem + 3.3vw);\n}\n\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n\n.display-4 {\n  font-weight: 300;\n  line-height: 1.2;\n  font-size: calc(1.475rem + 2.7vw);\n}\n\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n\n.display-5 {\n  font-weight: 300;\n  line-height: 1.2;\n  font-size: calc(1.425rem + 2.1vw);\n}\n\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n\n.display-6 {\n  font-weight: 300;\n  line-height: 1.2;\n  font-size: calc(1.375rem + 1.5vw);\n}\n\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 0.875em;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.1rem;\n}\n\n.blockquote> :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  font-size: 0.875em;\n  color: #6c757d;\n}\n\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: var(--bs-body-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 0.875em;\n  color: var(--bs-secondary-color);\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n\n  .container-sm,\n  .container {\n    max-width: 540px;\n  }\n}\n\n@media (min-width: 768px) {\n\n  .container-md,\n  .container-sm,\n  .container {\n    max-width: 720px;\n  }\n}\n\n@media (min-width: 992px) {\n\n  .container-lg,\n  .container-md,\n  .container-sm,\n  .container {\n    max-width: 960px;\n  }\n}\n\n@media (min-width: 1200px) {\n\n  .container-xl,\n  .container-lg,\n  .container-md,\n  .container-sm,\n  .container {\n    max-width: 1140px;\n  }\n}\n\n@media (min-width: 1400px) {\n\n  .container-xxl,\n  .container-xl,\n  .container-lg,\n  .container-md,\n  .container-sm,\n  .container {\n    max-width: 1320px;\n  }\n}\n\n:root {\n  --bs-breakpoint-xs: 0;\n  --bs-breakpoint-sm: 576px;\n  --bs-breakpoint-md: 768px;\n  --bs-breakpoint-lg: 992px;\n  --bs-breakpoint-xl: 1200px;\n  --bs-breakpoint-xxl: 1400px;\n}\n\n.row {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-0.5 * var(--bs-gutter-x));\n  margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n\n.row>* {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col {\n  flex: 1 0 0;\n}\n\n.row-cols-auto>* {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1>* {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2>* {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3>* {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.row-cols-4>* {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5>* {\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6>* {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n  --bs-gutter-x: 0;\n}\n\n.g-0,\n.gy-0 {\n  --bs-gutter-y: 0;\n}\n\n.g-1,\n.gx-1 {\n  --bs-gutter-x: 0.25rem;\n}\n\n.g-1,\n.gy-1 {\n  --bs-gutter-y: 0.25rem;\n}\n\n.g-2,\n.gx-2 {\n  --bs-gutter-x: 0.5rem;\n}\n\n.g-2,\n.gy-2 {\n  --bs-gutter-y: 0.5rem;\n}\n\n.g-3,\n.gx-3 {\n  --bs-gutter-x: 1rem;\n}\n\n.g-3,\n.gy-3 {\n  --bs-gutter-y: 1rem;\n}\n\n.g-4,\n.gx-4 {\n  --bs-gutter-x: 1.5rem;\n}\n\n.g-4,\n.gy-4 {\n  --bs-gutter-y: 1.5rem;\n}\n\n.g-5,\n.gx-5 {\n  --bs-gutter-x: 3rem;\n}\n\n.g-5,\n.gy-5 {\n  --bs-gutter-y: 3rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex: 1 0 0;\n  }\n\n  .row-cols-sm-auto>* {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-sm-1>* {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-sm-2>* {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-sm-3>* {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .row-cols-sm-4>* {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-sm-5>* {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-sm-6>* {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-sm-0,\n  .gx-sm-0 {\n    --bs-gutter-x: 0;\n  }\n\n  .g-sm-0,\n  .gy-sm-0 {\n    --bs-gutter-y: 0;\n  }\n\n  .g-sm-1,\n  .gx-sm-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n\n  .g-sm-1,\n  .gy-sm-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n\n  .g-sm-2,\n  .gx-sm-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n\n  .g-sm-2,\n  .gy-sm-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n\n  .g-sm-3,\n  .gx-sm-3 {\n    --bs-gutter-x: 1rem;\n  }\n\n  .g-sm-3,\n  .gy-sm-3 {\n    --bs-gutter-y: 1rem;\n  }\n\n  .g-sm-4,\n  .gx-sm-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n\n  .g-sm-4,\n  .gy-sm-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n\n  .g-sm-5,\n  .gx-sm-5 {\n    --bs-gutter-x: 3rem;\n  }\n\n  .g-sm-5,\n  .gy-sm-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .col-md {\n    flex: 1 0 0;\n  }\n\n  .row-cols-md-auto>* {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-md-1>* {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-md-2>* {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-md-3>* {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .row-cols-md-4>* {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-md-5>* {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-md-6>* {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-md-0 {\n    margin-left: 0;\n  }\n\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-md-0,\n  .gx-md-0 {\n    --bs-gutter-x: 0;\n  }\n\n  .g-md-0,\n  .gy-md-0 {\n    --bs-gutter-y: 0;\n  }\n\n  .g-md-1,\n  .gx-md-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n\n  .g-md-1,\n  .gy-md-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n\n  .g-md-2,\n  .gx-md-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n\n  .g-md-2,\n  .gy-md-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n\n  .g-md-3,\n  .gx-md-3 {\n    --bs-gutter-x: 1rem;\n  }\n\n  .g-md-3,\n  .gy-md-3 {\n    --bs-gutter-y: 1rem;\n  }\n\n  .g-md-4,\n  .gx-md-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n\n  .g-md-4,\n  .gy-md-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n\n  .g-md-5,\n  .gx-md-5 {\n    --bs-gutter-x: 3rem;\n  }\n\n  .g-md-5,\n  .gy-md-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .col-lg {\n    flex: 1 0 0;\n  }\n\n  .row-cols-lg-auto>* {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-lg-1>* {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-lg-2>* {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-lg-3>* {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .row-cols-lg-4>* {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-lg-5>* {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-lg-6>* {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-lg-0,\n  .gx-lg-0 {\n    --bs-gutter-x: 0;\n  }\n\n  .g-lg-0,\n  .gy-lg-0 {\n    --bs-gutter-y: 0;\n  }\n\n  .g-lg-1,\n  .gx-lg-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n\n  .g-lg-1,\n  .gy-lg-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n\n  .g-lg-2,\n  .gx-lg-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n\n  .g-lg-2,\n  .gy-lg-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n\n  .g-lg-3,\n  .gx-lg-3 {\n    --bs-gutter-x: 1rem;\n  }\n\n  .g-lg-3,\n  .gy-lg-3 {\n    --bs-gutter-y: 1rem;\n  }\n\n  .g-lg-4,\n  .gx-lg-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n\n  .g-lg-4,\n  .gy-lg-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n\n  .g-lg-5,\n  .gx-lg-5 {\n    --bs-gutter-x: 3rem;\n  }\n\n  .g-lg-5,\n  .gy-lg-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .col-xl {\n    flex: 1 0 0;\n  }\n\n  .row-cols-xl-auto>* {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-xl-1>* {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-xl-2>* {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-xl-3>* {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .row-cols-xl-4>* {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-xl-5>* {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-xl-6>* {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-xl-0,\n  .gx-xl-0 {\n    --bs-gutter-x: 0;\n  }\n\n  .g-xl-0,\n  .gy-xl-0 {\n    --bs-gutter-y: 0;\n  }\n\n  .g-xl-1,\n  .gx-xl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n\n  .g-xl-1,\n  .gy-xl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n\n  .g-xl-2,\n  .gx-xl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n\n  .g-xl-2,\n  .gy-xl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n\n  .g-xl-3,\n  .gx-xl-3 {\n    --bs-gutter-x: 1rem;\n  }\n\n  .g-xl-3,\n  .gy-xl-3 {\n    --bs-gutter-y: 1rem;\n  }\n\n  .g-xl-4,\n  .gx-xl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n\n  .g-xl-4,\n  .gy-xl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n\n  .g-xl-5,\n  .gx-xl-5 {\n    --bs-gutter-x: 3rem;\n  }\n\n  .g-xl-5,\n  .gy-xl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n\n@media (min-width: 1400px) {\n  .col-xxl {\n    flex: 1 0 0;\n  }\n\n  .row-cols-xxl-auto>* {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-xxl-1>* {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-xxl-2>* {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-xxl-3>* {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .row-cols-xxl-4>* {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-xxl-5>* {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-xxl-6>* {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-xxl-0,\n  .gx-xxl-0 {\n    --bs-gutter-x: 0;\n  }\n\n  .g-xxl-0,\n  .gy-xxl-0 {\n    --bs-gutter-y: 0;\n  }\n\n  .g-xxl-1,\n  .gx-xxl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n\n  .g-xxl-1,\n  .gy-xxl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n\n  .g-xxl-2,\n  .gx-xxl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n\n  .g-xxl-2,\n  .gy-xxl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n\n  .g-xxl-3,\n  .gx-xxl-3 {\n    --bs-gutter-x: 1rem;\n  }\n\n  .g-xxl-3,\n  .gy-xxl-3 {\n    --bs-gutter-y: 1rem;\n  }\n\n  .g-xxl-4,\n  .gx-xxl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n\n  .g-xxl-4,\n  .gy-xxl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n\n  .g-xxl-5,\n  .gx-xxl-5 {\n    --bs-gutter-x: 3rem;\n  }\n\n  .g-xxl-5,\n  .gy-xxl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n\n.table {\n  --bs-table-color-type: initial;\n  --bs-table-bg-type: initial;\n  --bs-table-color-state: initial;\n  --bs-table-bg-state: initial;\n  --bs-table-color: var(--bs-emphasis-color);\n  --bs-table-bg: var(--bs-body-bg);\n  --bs-table-border-color: var(--bs-border-color);\n  --bs-table-accent-bg: transparent;\n  --bs-table-striped-color: var(--bs-emphasis-color);\n  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);\n  --bs-table-active-color: var(--bs-emphasis-color);\n  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);\n  --bs-table-hover-color: var(--bs-emphasis-color);\n  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);\n  width: 100%;\n  margin-bottom: 1rem;\n  vertical-align: top;\n  border-color: var(--bs-table-border-color);\n}\n\n.table> :not(caption)>*>* {\n  padding: 0.5rem 0.5rem;\n  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));\n  background-color: var(--bs-table-bg);\n  border-bottom-width: var(--bs-border-width);\n  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));\n}\n\n.table>tbody {\n  vertical-align: inherit;\n}\n\n.table>thead {\n  vertical-align: bottom;\n}\n\n.table-group-divider {\n  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm> :not(caption)>*>* {\n  padding: 0.25rem 0.25rem;\n}\n\n.table-bordered> :not(caption)>* {\n  border-width: var(--bs-border-width) 0;\n}\n\n.table-bordered> :not(caption)>*>* {\n  border-width: 0 var(--bs-border-width);\n}\n\n.table-borderless> :not(caption)>*>* {\n  border-bottom-width: 0;\n}\n\n.table-borderless> :not(:first-child) {\n  border-top-width: 0;\n}\n\n.table-striped>tbody>tr:nth-of-type(odd)>* {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-striped-columns> :not(caption)>tr> :nth-child(even) {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-active {\n  --bs-table-color-state: var(--bs-table-active-color);\n  --bs-table-bg-state: var(--bs-table-active-bg);\n}\n\n.table-hover>tbody>tr:hover>* {\n  --bs-table-color-state: var(--bs-table-hover-color);\n  --bs-table-bg-state: var(--bs-table-hover-bg);\n}\n\n.table-primary {\n  --bs-table-color: #000;\n  --bs-table-bg: rgb(245.6, 232.6, 212.8);\n  --bs-table-border-color: rgb(196.48, 186.08, 170.24);\n  --bs-table-striped-bg: rgb(233.32, 220.97, 202.16);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(221.04, 209.34, 191.52);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(227.18, 215.155, 196.84);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-secondary {\n  --bs-table-color: #000;\n  --bs-table-bg: rgb(215.6, 217.2, 220.4);\n  --bs-table-border-color: rgb(172.48, 173.76, 176.32);\n  --bs-table-striped-bg: rgb(204.82, 206.34, 209.38);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(194.04, 195.48, 198.36);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(199.43, 200.91, 203.87);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-success {\n  --bs-table-color: #000;\n  --bs-table-bg: rgb(215, 247.2, 206);\n  --bs-table-border-color: rgb(172, 197.76, 164.8);\n  --bs-table-striped-bg: rgb(204.25, 234.84, 195.7);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(193.5, 222.48, 185.4);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(198.875, 228.66, 190.55);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-info {\n  --bs-table-color: #000;\n  --bs-table-bg: rgb(213, 240.4, 253);\n  --bs-table-border-color: rgb(170.4, 192.32, 202.4);\n  --bs-table-striped-bg: rgb(202.35, 228.38, 240.35);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(191.7, 216.36, 227.7);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(197.025, 222.37, 234.025);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-warning {\n  --bs-table-color: #000;\n  --bs-table-bg: rgb(255, 241.6, 212.6);\n  --bs-table-border-color: rgb(204, 193.28, 170.08);\n  --bs-table-striped-bg: rgb(242.25, 229.52, 201.97);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(229.5, 217.44, 191.34);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(235.875, 223.48, 196.655);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-danger {\n  --bs-table-color: #000;\n  --bs-table-bg: rgb(254.6, 221.6, 207.6);\n  --bs-table-border-color: rgb(203.68, 177.28, 166.08);\n  --bs-table-striped-bg: rgb(241.87, 210.52, 197.22);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(229.14, 199.44, 186.84);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(235.505, 204.98, 192.03);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-light {\n  --bs-table-color: #000;\n  --bs-table-bg: #D5D9E2;\n  --bs-table-border-color: rgb(170.4, 173.6, 180.8);\n  --bs-table-striped-bg: rgb(202.35, 206.15, 214.7);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(191.7, 195.3, 203.4);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(197.025, 200.725, 209.05);\n  --bs-table-hover-color: #000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-dark {\n  --bs-table-color: #fff;\n  --bs-table-bg: #000000;\n  --bs-table-border-color: #333333;\n  --bs-table-striped-bg: rgb(12.75, 12.75, 12.75);\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: rgb(25.5, 25.5, 25.5);\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: rgb(19.125, 19.125, 19.125);\n  --bs-table-hover-color: #fff;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n@media (max-width: 1399.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n.form-label {\n  margin-bottom: 0.5rem;\n}\n\n.col-form-label {\n  padding-top: calc(0.375rem + var(--bs-border-width));\n  padding-bottom: calc(0.375rem + var(--bs-border-width));\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + var(--bs-border-width));\n  padding-bottom: calc(0.5rem + var(--bs-border-width));\n  font-size: 1.1rem;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + var(--bs-border-width));\n  padding-bottom: calc(0.25rem + var(--bs-border-width));\n  font-size: 0.77rem;\n}\n\n.form-text {\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-secondary-color);\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.88rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  appearance: none;\n  background-color: var(--bs-body-bg);\n  background-clip: padding-box;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n\n.form-control[type=file] {\n  overflow: hidden;\n}\n\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n\n.form-control:focus {\n  color: var(--bs-body-color);\n  background-color: var(--bs-body-bg);\n  border-color: rgb(231.5, 199, 149.5);\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(208, 143, 44, 0.25);\n}\n\n.form-control::-webkit-date-and-time-value {\n  min-width: 85px;\n  height: 1.5em;\n  margin: 0;\n}\n\n.form-control::-webkit-datetime-edit {\n  display: block;\n  padding: 0;\n}\n\n.form-control::placeholder {\n  color: var(--bs-secondary-color);\n  opacity: 1;\n}\n\n.form-control:disabled {\n  background-color: var(--bs-secondary-bg);\n  opacity: 1;\n}\n\n.form-control::file-selector-button {\n  padding: 0.375rem 0.75rem;\n  margin: -0.375rem -0.75rem;\n  margin-inline-end: 0.75rem;\n  color: var(--bs-body-color);\n  background-color: var(--bs-tertiary-bg);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: var(--bs-border-width);\n  border-radius: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-control::file-selector-button {\n    transition: none;\n  }\n}\n\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: var(--bs-secondary-bg);\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  background-color: transparent;\n  border: solid transparent;\n  border-width: var(--bs-border-width) 0;\n}\n\n.form-control-plaintext:focus {\n  outline: 0;\n}\n\n.form-control-plaintext.form-control-sm,\n.form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n  padding: 0.25rem 0.5rem;\n  font-size: 0.77rem;\n  border-radius: var(--bs-border-radius-sm);\n}\n\n.form-control-sm::file-selector-button {\n  padding: 0.25rem 0.5rem;\n  margin: -0.25rem -0.5rem;\n  margin-inline-end: 0.5rem;\n}\n\n.form-control-lg {\n  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n  padding: 0.5rem 1rem;\n  font-size: 1.1rem;\n  border-radius: var(--bs-border-radius-lg);\n}\n\n.form-control-lg::file-selector-button {\n  padding: 0.5rem 1rem;\n  margin: -0.5rem -1rem;\n  margin-inline-end: 1rem;\n}\n\ntextarea.form-control {\n  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));\n}\n\ntextarea.form-control-sm {\n  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n}\n\ntextarea.form-control-lg {\n  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n}\n\n.form-control-color {\n  width: 3rem;\n  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));\n  padding: 0.375rem;\n}\n\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n\n.form-control-color::-moz-color-swatch {\n  border: 0 !important;\n  border-radius: var(--bs-border-radius);\n}\n\n.form-control-color::-webkit-color-swatch {\n  border: 0 !important;\n  border-radius: var(--bs-border-radius);\n}\n\n.form-control-color.form-control-sm {\n  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));\n}\n\n.form-control-color.form-control-lg {\n  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));\n}\n\n.form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  display: block;\n  width: 100%;\n  padding: 0.375rem 2.25rem 0.375rem 0.75rem;\n  font-size: 0.88rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  appearance: none;\n  background-color: var(--bs-body-bg);\n  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 16px 12px;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    transition: none;\n  }\n}\n\n.form-select:focus {\n  border-color: rgb(231.5, 199, 149.5);\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(208, 143, 44, 0.25);\n}\n\n.form-select[multiple],\n.form-select[size]:not([size=\"1\"]) {\n  padding-right: 0.75rem;\n  background-image: none;\n}\n\n.form-select:disabled {\n  background-color: var(--bs-secondary-bg);\n}\n\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 var(--bs-body-color);\n}\n\n.form-select-sm {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.77rem;\n  border-radius: var(--bs-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 1.1rem;\n  border-radius: var(--bs-border-radius-lg);\n}\n\n[data-bs-theme=dark] .form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23dee2e6' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n}\n\n.form-check {\n  display: block;\n  min-height: 1.32rem;\n  padding-left: 1.5em;\n  margin-bottom: 0.125rem;\n}\n\n.form-check .form-check-input {\n  float: left;\n  margin-left: -1.5em;\n}\n\n.form-check-reverse {\n  padding-right: 1.5em;\n  padding-left: 0;\n  text-align: right;\n}\n\n.form-check-reverse .form-check-input {\n  float: right;\n  margin-right: -1.5em;\n  margin-left: 0;\n}\n\n.form-check-input {\n  --bs-form-check-bg: var(--bs-body-bg);\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  margin-top: 0.25em;\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--bs-form-check-bg);\n  background-image: var(--bs-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  print-color-adjust: exact;\n}\n\n.form-check-input[type=checkbox] {\n  border-radius: 0.25em;\n}\n\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n\n.form-check-input:active {\n  filter: brightness(90%);\n}\n\n.form-check-input:focus {\n  border-color: rgb(231.5, 199, 149.5);\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(208, 143, 44, 0.25);\n}\n\n.form-check-input:checked {\n  background-color: #d08f2c;\n  border-color: #d08f2c;\n}\n\n.form-check-input:checked[type=checkbox] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\");\n}\n\n.form-check-input:checked[type=radio] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\");\n}\n\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: #d08f2c;\n  border-color: #d08f2c;\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n\n.form-check-input[disabled]~.form-check-label,\n.form-check-input:disabled~.form-check-label {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.form-switch {\n  padding-left: 2.5em;\n}\n\n.form-switch .form-check-input {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n  width: 2em;\n  margin-left: -2.5em;\n  background-image: var(--bs-form-switch-bg);\n  background-position: left center;\n  border-radius: 2em;\n  transition: background-position 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    transition: none;\n  }\n}\n\n.form-switch .form-check-input:focus {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgb%28231.5, 199, 149.5%29'/%3e%3c/svg%3e\");\n}\n\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n\n.form-switch.form-check-reverse {\n  padding-right: 2.5em;\n  padding-left: 0;\n}\n\n.form-switch.form-check-reverse .form-check-input {\n  margin-right: -2.5em;\n  margin-left: 0;\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n\n.btn-check[disabled]+.btn,\n.btn-check:disabled+.btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.65;\n}\n\n[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\");\n}\n\n.form-range {\n  width: 100%;\n  height: 1.5rem;\n  padding: 0;\n  appearance: none;\n  background-color: transparent;\n}\n\n.form-range:focus {\n  outline: 0;\n}\n\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #F6F7F9, 0 0 0 0.25rem rgba(208, 143, 44, 0.25);\n}\n\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #F6F7F9, 0 0 0 0.25rem rgba(208, 143, 44, 0.25);\n}\n\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  appearance: none;\n  background-color: #d08f2c;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n\n.form-range::-webkit-slider-thumb:active {\n  background-color: rgb(240.9, 221.4, 191.7);\n}\n\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-secondary-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  appearance: none;\n  background-color: #d08f2c;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n\n.form-range::-moz-range-thumb:active {\n  background-color: rgb(240.9, 221.4, 191.7);\n}\n\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-secondary-bg);\n  border-color: transparent;\n  border-radius: 1rem;\n}\n\n.form-range:disabled {\n  pointer-events: none;\n}\n\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: var(--bs-secondary-color);\n}\n\n.form-range:disabled::-moz-range-thumb {\n  background-color: var(--bs-secondary-color);\n}\n\n.form-floating {\n  position: relative;\n}\n\n.form-floating>.form-control,\n.form-floating>.form-control-plaintext,\n.form-floating>.form-select {\n  height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));\n  line-height: 1.25;\n}\n\n.form-floating>label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  max-width: 100%;\n  height: 100%;\n  padding: 1rem 0.75rem;\n  overflow: hidden;\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: var(--bs-border-width) solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-floating>label {\n    transition: none;\n  }\n}\n\n.form-floating>.form-control,\n.form-floating>.form-control-plaintext {\n  padding: 1rem 0.75rem;\n}\n\n.form-floating>.form-control::placeholder,\n.form-floating>.form-control-plaintext::placeholder {\n  color: transparent;\n}\n\n.form-floating>.form-control:focus,\n.form-floating>.form-control:not(:placeholder-shown),\n.form-floating>.form-control-plaintext:focus,\n.form-floating>.form-control-plaintext:not(:placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n\n.form-floating>.form-control:-webkit-autofill,\n.form-floating>.form-control-plaintext:-webkit-autofill {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n\n.form-floating>.form-select {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n  padding-left: 0.75rem;\n}\n\n.form-floating>.form-control:focus~label,\n.form-floating>.form-control:not(:placeholder-shown)~label,\n.form-floating>.form-control-plaintext~label,\n.form-floating>.form-select~label {\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n\n.form-floating>.form-control:-webkit-autofill~label {\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n\n.form-floating>textarea:focus~label::after,\n.form-floating>textarea:not(:placeholder-shown)~label::after {\n  position: absolute;\n  inset: 1rem 0.375rem;\n  z-index: -1;\n  height: 1.5em;\n  content: \"\";\n  background-color: var(--bs-body-bg);\n  border-radius: var(--bs-border-radius);\n}\n\n.form-floating>textarea:disabled~label::after {\n  background-color: var(--bs-secondary-bg);\n}\n\n.form-floating>.form-control-plaintext~label {\n  border-width: var(--bs-border-width) 0;\n}\n\n.form-floating> :disabled~label,\n.form-floating>.form-control:disabled~label {\n  color: #6c757d;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n\n.input-group>.form-control,\n.input-group>.form-select,\n.input-group>.form-floating {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n\n.input-group>.form-control:focus,\n.input-group>.form-select:focus,\n.input-group>.form-floating:focus-within {\n  z-index: 5;\n}\n\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n\n.input-group .btn:focus {\n  z-index: 5;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.88rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-tertiary-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n}\n\n.input-group-lg>.form-control,\n.input-group-lg>.form-select,\n.input-group-lg>.input-group-text,\n.input-group-lg>.btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.1rem;\n  border-radius: var(--bs-border-radius-lg);\n}\n\n.input-group-sm>.form-control,\n.input-group-sm>.form-select,\n.input-group-sm>.input-group-text,\n.input-group-sm>.btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.77rem;\n  border-radius: var(--bs-border-radius-sm);\n}\n\n.input-group-lg>.form-select,\n.input-group-sm>.form-select {\n  padding-right: 3rem;\n}\n\n.input-group:not(.has-validation)> :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group:not(.has-validation)>.dropdown-toggle:nth-last-child(n+3),\n.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-control,\n.input-group:not(.has-validation)>.form-floating:not(:last-child)>.form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group.has-validation> :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation>.dropdown-toggle:nth-last-child(n+4),\n.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-control,\n.input-group.has-validation>.form-floating:nth-last-child(n+3)>.form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group> :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: calc(-1 * var(--bs-border-width));\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group>.form-floating:not(:first-child)>.form-control,\n.input-group>.form-floating:not(:first-child)>.form-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-form-valid-color);\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.77rem;\n  color: #fff;\n  background-color: var(--bs-success);\n  border-radius: var(--bs-border-radius);\n}\n\n.was-validated :valid~.valid-feedback,\n.was-validated :valid~.valid-tooltip,\n.is-valid~.valid-feedback,\n.is-valid~.valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid,\n.form-control.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2337D80A' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.was-validated .form-control:valid:focus,\n.form-control.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:valid,\ntextarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:valid,\n.form-select.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n\n.was-validated .form-select:valid:not([multiple]):not([size]),\n.was-validated .form-select:valid:not([multiple])[size=\"1\"],\n.form-select.is-valid:not([multiple]):not([size]),\n.form-select.is-valid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2337D80A' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/%3e%3c/svg%3e\");\n  padding-right: 4.125rem;\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.was-validated .form-select:valid:focus,\n.form-select.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated .form-control-color:valid,\n.form-control-color.is-valid {\n  width: calc(3rem + calc(1.5em + 0.75rem));\n}\n\n.was-validated .form-check-input:valid,\n.form-check-input.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n\n.was-validated .form-check-input:valid:checked,\n.form-check-input.is-valid:checked {\n  background-color: var(--bs-form-valid-color);\n}\n\n.was-validated .form-check-input:valid:focus,\n.form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated .form-check-input:valid~.form-check-label,\n.form-check-input.is-valid~.form-check-label {\n  color: var(--bs-form-valid-color);\n}\n\n.form-check-inline .form-check-input~.valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group>.form-control:not(:focus):valid,\n.input-group>.form-control:not(:focus).is-valid,\n.was-validated .input-group>.form-select:not(:focus):valid,\n.input-group>.form-select:not(:focus).is-valid,\n.was-validated .input-group>.form-floating:not(:focus-within):valid,\n.input-group>.form-floating:not(:focus-within).is-valid {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: var(--bs-form-invalid-color);\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.77rem;\n  color: #fff;\n  background-color: var(--bs-danger);\n  border-radius: var(--bs-border-radius);\n}\n\n.was-validated :invalid~.invalid-feedback,\n.was-validated :invalid~.invalid-tooltip,\n.is-invalid~.invalid-feedback,\n.is-invalid~.invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid,\n.form-control.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23FD5812'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23FD5812' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.was-validated .form-control:invalid:focus,\n.form-control.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:invalid,\ntextarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:invalid,\n.form-select.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n\n.was-validated .form-select:invalid:not([multiple]):not([size]),\n.was-validated .form-select:invalid:not([multiple])[size=\"1\"],\n.form-select.is-invalid:not([multiple]):not([size]),\n.form-select.is-invalid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23FD5812'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23FD5812' stroke='none'/%3e%3c/svg%3e\");\n  padding-right: 4.125rem;\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.was-validated .form-select:invalid:focus,\n.form-select.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated .form-control-color:invalid,\n.form-control-color.is-invalid {\n  width: calc(3rem + calc(1.5em + 0.75rem));\n}\n\n.was-validated .form-check-input:invalid,\n.form-check-input.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n\n.was-validated .form-check-input:invalid:checked,\n.form-check-input.is-invalid:checked {\n  background-color: var(--bs-form-invalid-color);\n}\n\n.was-validated .form-check-input:invalid:focus,\n.form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated .form-check-input:invalid~.form-check-label,\n.form-check-input.is-invalid~.form-check-label {\n  color: var(--bs-form-invalid-color);\n}\n\n.form-check-inline .form-check-input~.invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group>.form-control:not(:focus):invalid,\n.input-group>.form-control:not(:focus).is-invalid,\n.was-validated .input-group>.form-select:not(:focus):invalid,\n.input-group>.form-select:not(:focus).is-invalid,\n.was-validated .input-group>.form-floating:not(:focus-within):invalid,\n.input-group>.form-floating:not(:focus-within).is-invalid {\n  z-index: 4;\n}\n\n.btn {\n  --bs-btn-padding-x: 0.75rem;\n  --bs-btn-padding-y: 0.375rem;\n  --bs-btn-font-family: ;\n  --bs-btn-font-size: 0.88rem;\n  --bs-btn-font-weight: 400;\n  --bs-btn-line-height: 1.5;\n  --bs-btn-color: var(--bs-body-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-width: var(--bs-border-width);\n  --bs-btn-border-color: transparent;\n  --bs-btn-border-radius: var(--bs-border-radius);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n  --bs-btn-disabled-opacity: 0.65;\n  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);\n  display: inline-block;\n  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n  font-family: var(--bs-btn-font-family);\n  font-size: var(--bs-btn-font-size);\n  font-weight: var(--bs-btn-font-weight);\n  line-height: var(--bs-btn-line-height);\n  color: var(--bs-btn-color);\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n  border-radius: var(--bs-btn-border-radius);\n  background-color: var(--bs-btn-bg);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n\n.btn:hover {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n}\n\n.btn-check+.btn:hover {\n  color: var(--bs-btn-color);\n  background-color: var(--bs-btn-bg);\n  border-color: var(--bs-btn-border-color);\n}\n\n.btn:focus-visible {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n\n.btn-check:focus-visible+.btn {\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n\n.btn-check:checked+.btn,\n:not(.btn-check)+.btn:active,\n.btn:first-child:active,\n.btn.active,\n.btn.show {\n  color: var(--bs-btn-active-color);\n  background-color: var(--bs-btn-active-bg);\n  border-color: var(--bs-btn-active-border-color);\n}\n\n.btn-check:checked+.btn:focus-visible,\n:not(.btn-check)+.btn:active:focus-visible,\n.btn:first-child:active:focus-visible,\n.btn.active:focus-visible,\n.btn.show:focus-visible {\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n\n.btn-check:checked:focus-visible+.btn {\n  box-shadow: var(--bs-btn-focus-box-shadow);\n}\n\n.btn:disabled,\n.btn.disabled,\nfieldset:disabled .btn {\n  color: var(--bs-btn-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-btn-disabled-bg);\n  border-color: var(--bs-btn-disabled-border-color);\n  opacity: var(--bs-btn-disabled-opacity);\n}\n\n.btn-primary {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #d08f2c;\n  --bs-btn-border-color: #d08f2c;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(215.05, 159.8, 75.65);\n  --bs-btn-hover-border-color: rgb(212.7, 154.2, 65.1);\n  --bs-btn-focus-shadow-rgb: 177, 122, 37;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(217.4, 165.4, 86.2);\n  --bs-btn-active-border-color: rgb(212.7, 154.2, 65.1);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #d08f2c;\n  --bs-btn-disabled-border-color: #d08f2c;\n}\n\n.btn-secondary {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #3A4252;\n  --bs-btn-border-color: #3A4252;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(49.3, 56.1, 69.7);\n  --bs-btn-hover-border-color: rgb(46.4, 52.8, 65.6);\n  --bs-btn-focus-shadow-rgb: 88, 94, 108;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(46.4, 52.8, 65.6);\n  --bs-btn-active-border-color: rgb(43.5, 49.5, 61.5);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #3A4252;\n  --bs-btn-disabled-border-color: #3A4252;\n}\n\n.btn-success {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #37D80A;\n  --bs-btn-border-color: #37D80A;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(85, 221.85, 46.75);\n  --bs-btn-hover-border-color: rgb(75, 219.9, 34.5);\n  --bs-btn-focus-shadow-rgb: 47, 184, 9;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(95, 223.8, 59);\n  --bs-btn-active-border-color: rgb(75, 219.9, 34.5);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #37D80A;\n  --bs-btn-disabled-border-color: #37D80A;\n}\n\n.btn-info {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #2DB6F5;\n  --bs-btn-border-color: #2DB6F5;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(76.5, 192.95, 246.5);\n  --bs-btn-hover-border-color: rgb(66, 189.3, 246);\n  --bs-btn-focus-shadow-rgb: 38, 155, 208;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(87, 196.6, 247);\n  --bs-btn-active-border-color: rgb(66, 189.3, 246);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #2DB6F5;\n  --bs-btn-disabled-border-color: #2DB6F5;\n}\n\n.btn-warning {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #FFBC2B;\n  --bs-btn-border-color: #FFBC2B;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(255, 198.05, 74.8);\n  --bs-btn-hover-border-color: rgb(255, 194.7, 64.2);\n  --bs-btn-focus-shadow-rgb: 217, 160, 37;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(255, 201.4, 85.4);\n  --bs-btn-active-border-color: rgb(255, 194.7, 64.2);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #FFBC2B;\n  --bs-btn-disabled-border-color: #FFBC2B;\n}\n\n.btn-danger {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #FD5812;\n  --bs-btn-border-color: #FD5812;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(253.3, 113.05, 53.55);\n  --bs-btn-hover-border-color: rgb(253.2, 104.7, 41.7);\n  --bs-btn-focus-shadow-rgb: 215, 75, 15;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(253.4, 121.4, 65.4);\n  --bs-btn-active-border-color: rgb(253.2, 104.7, 41.7);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #FD5812;\n  --bs-btn-disabled-border-color: #FD5812;\n}\n\n.btn-light {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #D5D9E2;\n  --bs-btn-border-color: #D5D9E2;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(181.05, 184.45, 192.1);\n  --bs-btn-hover-border-color: rgb(170.4, 173.6, 180.8);\n  --bs-btn-focus-shadow-rgb: 181, 184, 192;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(170.4, 173.6, 180.8);\n  --bs-btn-active-border-color: rgb(159.75, 162.75, 169.5);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #D5D9E2;\n  --bs-btn-disabled-border-color: #D5D9E2;\n}\n\n.btn-dark {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #000000;\n  --bs-btn-border-color: #000000;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(38.25, 38.25, 38.25);\n  --bs-btn-hover-border-color: rgb(25.5, 25.5, 25.5);\n  --bs-btn-focus-shadow-rgb: 38, 38, 38;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #333333;\n  --bs-btn-active-border-color: rgb(25.5, 25.5, 25.5);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #000000;\n  --bs-btn-disabled-border-color: #000000;\n}\n\n.btn-primary-div {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #d08f2c;\n  --bs-btn-border-color: #d08f2c;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(215.05, 159.8, 75.65);\n  --bs-btn-hover-border-color: rgb(212.7, 154.2, 65.1);\n  --bs-btn-focus-shadow-rgb: 177, 122, 37;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(217.4, 165.4, 86.2);\n  --bs-btn-active-border-color: rgb(212.7, 154.2, 65.1);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #d08f2c;\n  --bs-btn-disabled-border-color: #d08f2c;\n}\n\n.btn-primary-div-50 {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #b27c26;\n  --bs-btn-border-color: #b27c26;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(189.55, 143.65, 70.55);\n  --bs-btn-hover-border-color: rgb(185.7, 137.1, 59.7);\n  --bs-btn-focus-shadow-rgb: 151, 105, 32;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(193.4, 150.2, 81.4);\n  --bs-btn-active-border-color: rgb(185.7, 137.1, 59.7);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #b27c26;\n  --bs-btn-disabled-border-color: #b27c26;\n}\n\n.btn-primary-div-60 {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #946920;\n  --bs-btn-border-color: #946920;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(125.8, 89.25, 27.2);\n  --bs-btn-hover-border-color: rgb(118.4, 84, 25.6);\n  --bs-btn-focus-shadow-rgb: 164, 128, 65;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(118.4, 84, 25.6);\n  --bs-btn-active-border-color: rgb(111, 78.75, 24);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #946920;\n  --bs-btn-disabled-border-color: #946920;\n}\n\n.btn-primary-50 {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #b27c26;\n  --bs-btn-border-color: #b27c26;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(189.55, 143.65, 70.55);\n  --bs-btn-hover-border-color: rgb(185.7, 137.1, 59.7);\n  --bs-btn-focus-shadow-rgb: 151, 105, 32;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(193.4, 150.2, 81.4);\n  --bs-btn-active-border-color: rgb(185.7, 137.1, 59.7);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #b27c26;\n  --bs-btn-disabled-border-color: #b27c26;\n}\n\n.btn-primary-60 {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #946920;\n  --bs-btn-border-color: #946920;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(125.8, 89.25, 27.2);\n  --bs-btn-hover-border-color: rgb(118.4, 84, 25.6);\n  --bs-btn-focus-shadow-rgb: 164, 128, 65;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(118.4, 84, 25.6);\n  --bs-btn-active-border-color: rgb(111, 78.75, 24);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #946920;\n  --bs-btn-disabled-border-color: #946920;\n}\n\n.btn-primary-70 {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #76561a;\n  --bs-btn-border-color: #76561a;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(100.3, 73.1, 22.1);\n  --bs-btn-hover-border-color: rgb(94.4, 68.8, 20.8);\n  --bs-btn-focus-shadow-rgb: 139, 111, 60;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(94.4, 68.8, 20.8);\n  --bs-btn-active-border-color: rgb(88.5, 64.5, 19.5);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #76561a;\n  --bs-btn-disabled-border-color: #76561a;\n}\n\n.btn-success-50 {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #1E8308;\n  --bs-btn-border-color: #1E8308;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(25.5, 111.35, 6.8);\n  --bs-btn-hover-border-color: rgb(24, 104.8, 6.4);\n  --bs-btn-focus-shadow-rgb: 64, 150, 45;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(24, 104.8, 6.4);\n  --bs-btn-active-border-color: rgb(22.5, 98.25, 6);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #1E8308;\n  --bs-btn-disabled-border-color: #1E8308;\n}\n\n.btn-success-60 {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #25B003;\n  --bs-btn-border-color: #25B003;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(69.7, 187.85, 40.8);\n  --bs-btn-hover-border-color: rgb(58.8, 183.9, 28.2);\n  --bs-btn-focus-shadow-rgb: 31, 150, 3;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(80.6, 191.8, 53.4);\n  --bs-btn-active-border-color: rgb(58.8, 183.9, 28.2);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #25B003;\n  --bs-btn-disabled-border-color: #25B003;\n}\n\n.btn-success-70 {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #82FC5A;\n  --bs-btn-border-color: #82FC5A;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(148.75, 252.45, 114.75);\n  --bs-btn-hover-border-color: rgb(142.5, 252.3, 106.5);\n  --bs-btn-focus-shadow-rgb: 111, 214, 77;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(155, 252.6, 123);\n  --bs-btn-active-border-color: rgb(142.5, 252.3, 106.5);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #82FC5A;\n  --bs-btn-disabled-border-color: #82FC5A;\n}\n\n.btn-success-80 {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #D8FFC8;\n  --bs-btn-border-color: #D8FFC8;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(221.85, 255, 208.25);\n  --bs-btn-hover-border-color: rgb(219.9, 255, 205.5);\n  --bs-btn-focus-shadow-rgb: 184, 217, 170;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(223.8, 255, 211);\n  --bs-btn-active-border-color: rgb(219.9, 255, 205.5);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #D8FFC8;\n  --bs-btn-disabled-border-color: #D8FFC8;\n}\n\n.btn-success-90 {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #eeffe5;\n  --bs-btn-border-color: #eeffe5;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(240.55, 255, 232.9);\n  --bs-btn-hover-border-color: rgb(239.7, 255, 231.6);\n  --bs-btn-focus-shadow-rgb: 202, 217, 195;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(241.4, 255, 234.2);\n  --bs-btn-active-border-color: rgb(239.7, 255, 231.6);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #eeffe5;\n  --bs-btn-disabled-border-color: #eeffe5;\n}\n\n.btn-success-100 {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #d8ffc8;\n  --bs-btn-border-color: #d8ffc8;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(221.85, 255, 208.25);\n  --bs-btn-hover-border-color: rgb(219.9, 255, 205.5);\n  --bs-btn-focus-shadow-rgb: 184, 217, 170;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(223.8, 255, 211);\n  --bs-btn-active-border-color: rgb(219.9, 255, 205.5);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #d8ffc8;\n  --bs-btn-disabled-border-color: #d8ffc8;\n}\n\n.btn-body-bg {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #F6F7F9;\n  --bs-btn-border-color: #F6F7F9;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(247.35, 248.2, 249.9);\n  --bs-btn-hover-border-color: rgb(246.9, 247.8, 249.6);\n  --bs-btn-focus-shadow-rgb: 209, 210, 212;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(247.8, 248.6, 250.2);\n  --bs-btn-active-border-color: rgb(246.9, 247.8, 249.6);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #F6F7F9;\n  --bs-btn-disabled-border-color: #F6F7F9;\n}\n\n.btn-danger-div {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #ffed9d;\n  --bs-btn-border-color: #ffed9d;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(255, 239.7, 171.7);\n  --bs-btn-hover-border-color: rgb(255, 238.8, 166.8);\n  --bs-btn-focus-shadow-rgb: 217, 201, 133;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(255, 240.6, 176.6);\n  --bs-btn-active-border-color: rgb(255, 238.8, 166.8);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #ffed9d;\n  --bs-btn-disabled-border-color: #ffed9d;\n}\n\n.btn-danger-40 {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #D71C00;\n  --bs-btn-border-color: #D71C00;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(182.75, 23.8, 0);\n  --bs-btn-hover-border-color: rgb(172, 22.4, 0);\n  --bs-btn-focus-shadow-rgb: 221, 62, 38;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(172, 22.4, 0);\n  --bs-btn-active-border-color: rgb(161.25, 21, 0);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #D71C00;\n  --bs-btn-disabled-border-color: #D71C00;\n}\n\n.btn-danger-50 {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #EE3E08;\n  --bs-btn-border-color: #EE3E08;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(240.55, 90.95, 45.05);\n  --bs-btn-hover-border-color: rgb(239.7, 81.3, 32.7);\n  --bs-btn-focus-shadow-rgb: 202, 53, 7;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(241.4, 100.6, 57.4);\n  --bs-btn-active-border-color: rgb(239.7, 81.3, 32.7);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #EE3E08;\n  --bs-btn-disabled-border-color: #EE3E08;\n}\n\n.btn-danger-60 {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #EC1F00;\n  --bs-btn-border-color: #EC1F00;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(238.85, 64.6, 38.25);\n  --bs-btn-hover-border-color: rgb(237.9, 53.4, 25.5);\n  --bs-btn-focus-shadow-rgb: 201, 26, 0;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(239.8, 75.8, 51);\n  --bs-btn-active-border-color: rgb(237.9, 53.4, 25.5);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #EC1F00;\n  --bs-btn-disabled-border-color: #EC1F00;\n}\n\n.btn-danger-70 {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #FFE1DD;\n  --bs-btn-border-color: #FFE1DD;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(255, 229.5, 226.1);\n  --bs-btn-hover-border-color: rgb(255, 228, 224.4);\n  --bs-btn-focus-shadow-rgb: 217, 191, 188;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(255, 231, 227.8);\n  --bs-btn-active-border-color: rgb(255, 228, 224.4);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #FFE1DD;\n  --bs-btn-disabled-border-color: #FFE1DD;\n}\n\n.btn-danger-80 {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #ff4023;\n  --bs-btn-border-color: #ff4023;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(255, 92.65, 68);\n  --bs-btn-hover-border-color: rgb(255, 83.1, 57);\n  --bs-btn-focus-shadow-rgb: 217, 54, 30;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(255, 102.2, 79);\n  --bs-btn-active-border-color: rgb(255, 83.1, 57);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #ff4023;\n  --bs-btn-disabled-border-color: #ff4023;\n}\n\n.btn-danger-90 {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #C52B09;\n  --bs-btn-border-color: #C52B09;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(167.45, 36.55, 7.65);\n  --bs-btn-hover-border-color: rgb(157.6, 34.4, 7.2);\n  --bs-btn-focus-shadow-rgb: 206, 75, 46;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(157.6, 34.4, 7.2);\n  --bs-btn-active-border-color: rgb(147.75, 32.25, 6.75);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #C52B09;\n  --bs-btn-disabled-border-color: #C52B09;\n}\n\n.btn-danger-100 {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #ffe1dd;\n  --bs-btn-border-color: #ffe1dd;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(255, 229.5, 226.1);\n  --bs-btn-hover-border-color: rgb(255, 228, 224.4);\n  --bs-btn-focus-shadow-rgb: 217, 191, 188;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(255, 231, 227.8);\n  --bs-btn-active-border-color: rgb(255, 228, 224.4);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #ffe1dd;\n  --bs-btn-disabled-border-color: #ffe1dd;\n}\n\n.btn-rating-color {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #FE7A36;\n  --bs-btn-border-color: #FE7A36;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(254.15, 141.95, 84.15);\n  --bs-btn-hover-border-color: rgb(254.1, 135.3, 74.1);\n  --bs-btn-focus-shadow-rgb: 216, 104, 46;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(254.2, 148.6, 94.2);\n  --bs-btn-active-border-color: rgb(254.1, 135.3, 74.1);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #FE7A36;\n  --bs-btn-disabled-border-color: #FE7A36;\n}\n\n.btn-card-bg-c {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #3584FC;\n  --bs-btn-border-color: #3584FC;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(83.3, 150.45, 252.45);\n  --bs-btn-hover-border-color: rgb(73.2, 144.3, 252.3);\n  --bs-btn-focus-shadow-rgb: 45, 112, 214;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(93.4, 156.6, 252.6);\n  --bs-btn-active-border-color: rgb(73.2, 144.3, 252.3);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #3584FC;\n  --bs-btn-disabled-border-color: #3584FC;\n}\n\n.btn-card-text-c {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #FFE8D4;\n  --bs-btn-border-color: #FFE8D4;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(255, 235.45, 218.45);\n  --bs-btn-hover-border-color: rgb(255, 234.3, 216.3);\n  --bs-btn-focus-shadow-rgb: 217, 197, 180;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(255, 236.6, 220.6);\n  --bs-btn-active-border-color: rgb(255, 234.3, 216.3);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #FFE8D4;\n  --bs-btn-disabled-border-color: #FFE8D4;\n}\n\n.btn-gary-light {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #F4F6FC;\n  --bs-btn-border-color: #F4F6FC;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(245.65, 247.35, 252.45);\n  --bs-btn-hover-border-color: rgb(245.1, 246.9, 252.3);\n  --bs-btn-focus-shadow-rgb: 207, 209, 214;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(246.2, 247.8, 252.6);\n  --bs-btn-active-border-color: rgb(245.1, 246.9, 252.3);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #F4F6FC;\n  --bs-btn-disabled-border-color: #F4F6FC;\n}\n\n.btn-border-color {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #ECEEF2;\n  --bs-btn-border-color: #ECEEF2;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(238.85, 240.55, 243.95);\n  --bs-btn-hover-border-color: rgb(237.9, 239.7, 243.3);\n  --bs-btn-focus-shadow-rgb: 201, 202, 206;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(239.8, 241.4, 244.6);\n  --bs-btn-active-border-color: rgb(237.9, 239.7, 243.3);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #ECEEF2;\n  --bs-btn-disabled-border-color: #ECEEF2;\n}\n\n.btn-border-color-50 {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #ECF0FF;\n  --bs-btn-border-color: #ECF0FF;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(238.85, 242.25, 255);\n  --bs-btn-hover-border-color: rgb(237.9, 241.5, 255);\n  --bs-btn-focus-shadow-rgb: 201, 204, 217;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(239.8, 243, 255);\n  --bs-btn-active-border-color: rgb(237.9, 241.5, 255);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #ECF0FF;\n  --bs-btn-disabled-border-color: #ECF0FF;\n}\n\n.btn-gray-100 {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #f5f7f8;\n  --bs-btn-border-color: #f5f7f8;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(246.5, 248.2, 249.05);\n  --bs-btn-hover-border-color: rgb(246, 247.8, 248.7);\n  --bs-btn-focus-shadow-rgb: 208, 210, 211;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(247, 248.6, 249.4);\n  --bs-btn-active-border-color: rgb(246, 247.8, 248.7);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #f5f7f8;\n  --bs-btn-disabled-border-color: #f5f7f8;\n}\n\n.btn-body-color-50 {\n  --bs-btn-color: #fff;\n  --bs-btn-bg: #526077;\n  --bs-btn-border-color: #526077;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgb(69.7, 81.6, 101.15);\n  --bs-btn-hover-border-color: rgb(65.6, 76.8, 95.2);\n  --bs-btn-focus-shadow-rgb: 108, 120, 139;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: rgb(65.6, 76.8, 95.2);\n  --bs-btn-active-border-color: rgb(61.5, 72, 89.25);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #526077;\n  --bs-btn-disabled-border-color: #526077;\n}\n\n.btn-body-color-60 {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #8695AA;\n  --bs-btn-border-color: #8695AA;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(152.15, 164.9, 182.75);\n  --bs-btn-hover-border-color: rgb(146.1, 159.6, 178.5);\n  --bs-btn-focus-shadow-rgb: 114, 127, 145;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(158.2, 170.2, 187);\n  --bs-btn-active-border-color: rgb(146.1, 159.6, 178.5);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #8695AA;\n  --bs-btn-disabled-border-color: #8695AA;\n}\n\n.btn-purple-100 {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #f3e8ff;\n  --bs-btn-border-color: #f3e8ff;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(244.8, 235.45, 255);\n  --bs-btn-hover-border-color: rgb(244.2, 234.3, 255);\n  --bs-btn-focus-shadow-rgb: 207, 197, 217;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(245.4, 236.6, 255);\n  --bs-btn-active-border-color: rgb(244.2, 234.3, 255);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #f3e8ff;\n  --bs-btn-disabled-border-color: #f3e8ff;\n}\n\n.btn-info-100 {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #daebff;\n  --bs-btn-border-color: #daebff;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: rgb(223.55, 238, 255);\n  --bs-btn-hover-border-color: rgb(221.7, 237, 255);\n  --bs-btn-focus-shadow-rgb: 185, 200, 217;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: rgb(225.4, 239, 255);\n  --bs-btn-active-border-color: rgb(221.7, 237, 255);\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000;\n  --bs-btn-disabled-bg: #daebff;\n  --bs-btn-disabled-border-color: #daebff;\n}\n\n.btn-outline-primary {\n  --bs-btn-color: #d08f2c;\n  --bs-btn-border-color: #d08f2c;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #d08f2c;\n  --bs-btn-hover-border-color: #d08f2c;\n  --bs-btn-focus-shadow-rgb: 208, 143, 44;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #d08f2c;\n  --bs-btn-active-border-color: #d08f2c;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #d08f2c;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #d08f2c;\n  --bs-gradient: none;\n}\n\n.btn-outline-secondary {\n  --bs-btn-color: #3A4252;\n  --bs-btn-border-color: #3A4252;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #3A4252;\n  --bs-btn-hover-border-color: #3A4252;\n  --bs-btn-focus-shadow-rgb: 58, 66, 82;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #3A4252;\n  --bs-btn-active-border-color: #3A4252;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #3A4252;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #3A4252;\n  --bs-gradient: none;\n}\n\n.btn-outline-success {\n  --bs-btn-color: #37D80A;\n  --bs-btn-border-color: #37D80A;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #37D80A;\n  --bs-btn-hover-border-color: #37D80A;\n  --bs-btn-focus-shadow-rgb: 55, 216, 10;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #37D80A;\n  --bs-btn-active-border-color: #37D80A;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #37D80A;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #37D80A;\n  --bs-gradient: none;\n}\n\n.btn-outline-info {\n  --bs-btn-color: #2DB6F5;\n  --bs-btn-border-color: #2DB6F5;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #2DB6F5;\n  --bs-btn-hover-border-color: #2DB6F5;\n  --bs-btn-focus-shadow-rgb: 45, 182, 245;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #2DB6F5;\n  --bs-btn-active-border-color: #2DB6F5;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #2DB6F5;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #2DB6F5;\n  --bs-gradient: none;\n}\n\n.btn-outline-warning {\n  --bs-btn-color: #FFBC2B;\n  --bs-btn-border-color: #FFBC2B;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #FFBC2B;\n  --bs-btn-hover-border-color: #FFBC2B;\n  --bs-btn-focus-shadow-rgb: 255, 188, 43;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #FFBC2B;\n  --bs-btn-active-border-color: #FFBC2B;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #FFBC2B;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #FFBC2B;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger {\n  --bs-btn-color: #FD5812;\n  --bs-btn-border-color: #FD5812;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #FD5812;\n  --bs-btn-hover-border-color: #FD5812;\n  --bs-btn-focus-shadow-rgb: 253, 88, 18;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #FD5812;\n  --bs-btn-active-border-color: #FD5812;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #FD5812;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #FD5812;\n  --bs-gradient: none;\n}\n\n.btn-outline-light {\n  --bs-btn-color: #D5D9E2;\n  --bs-btn-border-color: #D5D9E2;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #D5D9E2;\n  --bs-btn-hover-border-color: #D5D9E2;\n  --bs-btn-focus-shadow-rgb: 213, 217, 226;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #D5D9E2;\n  --bs-btn-active-border-color: #D5D9E2;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #D5D9E2;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #D5D9E2;\n  --bs-gradient: none;\n}\n\n.btn-outline-dark {\n  --bs-btn-color: #000000;\n  --bs-btn-border-color: #000000;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #000000;\n  --bs-btn-hover-border-color: #000000;\n  --bs-btn-focus-shadow-rgb: 0, 0, 0;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #000000;\n  --bs-btn-active-border-color: #000000;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #000000;\n  --bs-gradient: none;\n}\n\n.btn-outline-primary-div {\n  --bs-btn-color: #d08f2c;\n  --bs-btn-border-color: #d08f2c;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #d08f2c;\n  --bs-btn-hover-border-color: #d08f2c;\n  --bs-btn-focus-shadow-rgb: 208, 143, 44;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #d08f2c;\n  --bs-btn-active-border-color: #d08f2c;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #d08f2c;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #d08f2c;\n  --bs-gradient: none;\n}\n\n.btn-outline-primary-div-50 {\n  --bs-btn-color: #b27c26;\n  --bs-btn-border-color: #b27c26;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #b27c26;\n  --bs-btn-hover-border-color: #b27c26;\n  --bs-btn-focus-shadow-rgb: 178, 124, 38;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #b27c26;\n  --bs-btn-active-border-color: #b27c26;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #b27c26;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #b27c26;\n  --bs-gradient: none;\n}\n\n.btn-outline-primary-div-60 {\n  --bs-btn-color: #946920;\n  --bs-btn-border-color: #946920;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #946920;\n  --bs-btn-hover-border-color: #946920;\n  --bs-btn-focus-shadow-rgb: 148, 105, 32;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #946920;\n  --bs-btn-active-border-color: #946920;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #946920;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #946920;\n  --bs-gradient: none;\n}\n\n.btn-outline-primary-50 {\n  --bs-btn-color: #b27c26;\n  --bs-btn-border-color: #b27c26;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #b27c26;\n  --bs-btn-hover-border-color: #b27c26;\n  --bs-btn-focus-shadow-rgb: 178, 124, 38;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #b27c26;\n  --bs-btn-active-border-color: #b27c26;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #b27c26;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #b27c26;\n  --bs-gradient: none;\n}\n\n.btn-outline-primary-60 {\n  --bs-btn-color: #946920;\n  --bs-btn-border-color: #946920;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #946920;\n  --bs-btn-hover-border-color: #946920;\n  --bs-btn-focus-shadow-rgb: 148, 105, 32;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #946920;\n  --bs-btn-active-border-color: #946920;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #946920;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #946920;\n  --bs-gradient: none;\n}\n\n.btn-outline-primary-70 {\n  --bs-btn-color: #76561a;\n  --bs-btn-border-color: #76561a;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #76561a;\n  --bs-btn-hover-border-color: #76561a;\n  --bs-btn-focus-shadow-rgb: 118, 86, 26;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #76561a;\n  --bs-btn-active-border-color: #76561a;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #76561a;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #76561a;\n  --bs-gradient: none;\n}\n\n.btn-outline-success-50 {\n  --bs-btn-color: #1E8308;\n  --bs-btn-border-color: #1E8308;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #1E8308;\n  --bs-btn-hover-border-color: #1E8308;\n  --bs-btn-focus-shadow-rgb: 30, 131, 8;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #1E8308;\n  --bs-btn-active-border-color: #1E8308;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #1E8308;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #1E8308;\n  --bs-gradient: none;\n}\n\n.btn-outline-success-60 {\n  --bs-btn-color: #25B003;\n  --bs-btn-border-color: #25B003;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #25B003;\n  --bs-btn-hover-border-color: #25B003;\n  --bs-btn-focus-shadow-rgb: 37, 176, 3;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #25B003;\n  --bs-btn-active-border-color: #25B003;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #25B003;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #25B003;\n  --bs-gradient: none;\n}\n\n.btn-outline-success-70 {\n  --bs-btn-color: #82FC5A;\n  --bs-btn-border-color: #82FC5A;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #82FC5A;\n  --bs-btn-hover-border-color: #82FC5A;\n  --bs-btn-focus-shadow-rgb: 130, 252, 90;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #82FC5A;\n  --bs-btn-active-border-color: #82FC5A;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #82FC5A;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #82FC5A;\n  --bs-gradient: none;\n}\n\n.btn-outline-success-80 {\n  --bs-btn-color: #D8FFC8;\n  --bs-btn-border-color: #D8FFC8;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #D8FFC8;\n  --bs-btn-hover-border-color: #D8FFC8;\n  --bs-btn-focus-shadow-rgb: 216, 255, 200;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #D8FFC8;\n  --bs-btn-active-border-color: #D8FFC8;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #D8FFC8;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #D8FFC8;\n  --bs-gradient: none;\n}\n\n.btn-outline-success-90 {\n  --bs-btn-color: #eeffe5;\n  --bs-btn-border-color: #eeffe5;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #eeffe5;\n  --bs-btn-hover-border-color: #eeffe5;\n  --bs-btn-focus-shadow-rgb: 238, 255, 229;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #eeffe5;\n  --bs-btn-active-border-color: #eeffe5;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #eeffe5;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #eeffe5;\n  --bs-gradient: none;\n}\n\n.btn-outline-success-100 {\n  --bs-btn-color: #d8ffc8;\n  --bs-btn-border-color: #d8ffc8;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #d8ffc8;\n  --bs-btn-hover-border-color: #d8ffc8;\n  --bs-btn-focus-shadow-rgb: 216, 255, 200;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #d8ffc8;\n  --bs-btn-active-border-color: #d8ffc8;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #d8ffc8;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #d8ffc8;\n  --bs-gradient: none;\n}\n\n.btn-outline-body-bg {\n  --bs-btn-color: #F6F7F9;\n  --bs-btn-border-color: #F6F7F9;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #F6F7F9;\n  --bs-btn-hover-border-color: #F6F7F9;\n  --bs-btn-focus-shadow-rgb: 246, 247, 249;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #F6F7F9;\n  --bs-btn-active-border-color: #F6F7F9;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #F6F7F9;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #F6F7F9;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger-div {\n  --bs-btn-color: #ffed9d;\n  --bs-btn-border-color: #ffed9d;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #ffed9d;\n  --bs-btn-hover-border-color: #ffed9d;\n  --bs-btn-focus-shadow-rgb: 255, 237, 157;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #ffed9d;\n  --bs-btn-active-border-color: #ffed9d;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffed9d;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ffed9d;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger-40 {\n  --bs-btn-color: #D71C00;\n  --bs-btn-border-color: #D71C00;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #D71C00;\n  --bs-btn-hover-border-color: #D71C00;\n  --bs-btn-focus-shadow-rgb: 215, 28, 0;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #D71C00;\n  --bs-btn-active-border-color: #D71C00;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #D71C00;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #D71C00;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger-50 {\n  --bs-btn-color: #EE3E08;\n  --bs-btn-border-color: #EE3E08;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #EE3E08;\n  --bs-btn-hover-border-color: #EE3E08;\n  --bs-btn-focus-shadow-rgb: 238, 62, 8;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #EE3E08;\n  --bs-btn-active-border-color: #EE3E08;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #EE3E08;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #EE3E08;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger-60 {\n  --bs-btn-color: #EC1F00;\n  --bs-btn-border-color: #EC1F00;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #EC1F00;\n  --bs-btn-hover-border-color: #EC1F00;\n  --bs-btn-focus-shadow-rgb: 236, 31, 0;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #EC1F00;\n  --bs-btn-active-border-color: #EC1F00;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #EC1F00;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #EC1F00;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger-70 {\n  --bs-btn-color: #FFE1DD;\n  --bs-btn-border-color: #FFE1DD;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #FFE1DD;\n  --bs-btn-hover-border-color: #FFE1DD;\n  --bs-btn-focus-shadow-rgb: 255, 225, 221;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #FFE1DD;\n  --bs-btn-active-border-color: #FFE1DD;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #FFE1DD;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #FFE1DD;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger-80 {\n  --bs-btn-color: #ff4023;\n  --bs-btn-border-color: #ff4023;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #ff4023;\n  --bs-btn-hover-border-color: #ff4023;\n  --bs-btn-focus-shadow-rgb: 255, 64, 35;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #ff4023;\n  --bs-btn-active-border-color: #ff4023;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ff4023;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ff4023;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger-90 {\n  --bs-btn-color: #C52B09;\n  --bs-btn-border-color: #C52B09;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #C52B09;\n  --bs-btn-hover-border-color: #C52B09;\n  --bs-btn-focus-shadow-rgb: 197, 43, 9;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #C52B09;\n  --bs-btn-active-border-color: #C52B09;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #C52B09;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #C52B09;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger-100 {\n  --bs-btn-color: #ffe1dd;\n  --bs-btn-border-color: #ffe1dd;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #ffe1dd;\n  --bs-btn-hover-border-color: #ffe1dd;\n  --bs-btn-focus-shadow-rgb: 255, 225, 221;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #ffe1dd;\n  --bs-btn-active-border-color: #ffe1dd;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffe1dd;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ffe1dd;\n  --bs-gradient: none;\n}\n\n.btn-outline-rating-color {\n  --bs-btn-color: #FE7A36;\n  --bs-btn-border-color: #FE7A36;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #FE7A36;\n  --bs-btn-hover-border-color: #FE7A36;\n  --bs-btn-focus-shadow-rgb: 254, 122, 54;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #FE7A36;\n  --bs-btn-active-border-color: #FE7A36;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #FE7A36;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #FE7A36;\n  --bs-gradient: none;\n}\n\n.btn-outline-card-bg-c {\n  --bs-btn-color: #3584FC;\n  --bs-btn-border-color: #3584FC;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #3584FC;\n  --bs-btn-hover-border-color: #3584FC;\n  --bs-btn-focus-shadow-rgb: 53, 132, 252;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #3584FC;\n  --bs-btn-active-border-color: #3584FC;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #3584FC;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #3584FC;\n  --bs-gradient: none;\n}\n\n.btn-outline-card-text-c {\n  --bs-btn-color: #FFE8D4;\n  --bs-btn-border-color: #FFE8D4;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #FFE8D4;\n  --bs-btn-hover-border-color: #FFE8D4;\n  --bs-btn-focus-shadow-rgb: 255, 232, 212;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #FFE8D4;\n  --bs-btn-active-border-color: #FFE8D4;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #FFE8D4;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #FFE8D4;\n  --bs-gradient: none;\n}\n\n.btn-outline-gary-light {\n  --bs-btn-color: #F4F6FC;\n  --bs-btn-border-color: #F4F6FC;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #F4F6FC;\n  --bs-btn-hover-border-color: #F4F6FC;\n  --bs-btn-focus-shadow-rgb: 244, 246, 252;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #F4F6FC;\n  --bs-btn-active-border-color: #F4F6FC;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #F4F6FC;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #F4F6FC;\n  --bs-gradient: none;\n}\n\n.btn-outline-border-color {\n  --bs-btn-color: #ECEEF2;\n  --bs-btn-border-color: #ECEEF2;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #ECEEF2;\n  --bs-btn-hover-border-color: #ECEEF2;\n  --bs-btn-focus-shadow-rgb: 236, 238, 242;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #ECEEF2;\n  --bs-btn-active-border-color: #ECEEF2;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ECEEF2;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ECEEF2;\n  --bs-gradient: none;\n}\n\n.btn-outline-border-color-50 {\n  --bs-btn-color: #ECF0FF;\n  --bs-btn-border-color: #ECF0FF;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #ECF0FF;\n  --bs-btn-hover-border-color: #ECF0FF;\n  --bs-btn-focus-shadow-rgb: 236, 240, 255;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #ECF0FF;\n  --bs-btn-active-border-color: #ECF0FF;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ECF0FF;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ECF0FF;\n  --bs-gradient: none;\n}\n\n.btn-outline-gray-100 {\n  --bs-btn-color: #f5f7f8;\n  --bs-btn-border-color: #f5f7f8;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #f5f7f8;\n  --bs-btn-hover-border-color: #f5f7f8;\n  --bs-btn-focus-shadow-rgb: 245, 247, 248;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #f5f7f8;\n  --bs-btn-active-border-color: #f5f7f8;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #f5f7f8;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #f5f7f8;\n  --bs-gradient: none;\n}\n\n.btn-outline-body-color-50 {\n  --bs-btn-color: #526077;\n  --bs-btn-border-color: #526077;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #526077;\n  --bs-btn-hover-border-color: #526077;\n  --bs-btn-focus-shadow-rgb: 82, 96, 119;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #526077;\n  --bs-btn-active-border-color: #526077;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #526077;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #526077;\n  --bs-gradient: none;\n}\n\n.btn-outline-body-color-60 {\n  --bs-btn-color: #8695AA;\n  --bs-btn-border-color: #8695AA;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #8695AA;\n  --bs-btn-hover-border-color: #8695AA;\n  --bs-btn-focus-shadow-rgb: 134, 149, 170;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #8695AA;\n  --bs-btn-active-border-color: #8695AA;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #8695AA;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #8695AA;\n  --bs-gradient: none;\n}\n\n.btn-outline-purple-100 {\n  --bs-btn-color: #f3e8ff;\n  --bs-btn-border-color: #f3e8ff;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #f3e8ff;\n  --bs-btn-hover-border-color: #f3e8ff;\n  --bs-btn-focus-shadow-rgb: 243, 232, 255;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #f3e8ff;\n  --bs-btn-active-border-color: #f3e8ff;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #f3e8ff;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #f3e8ff;\n  --bs-gradient: none;\n}\n\n.btn-outline-info-100 {\n  --bs-btn-color: #daebff;\n  --bs-btn-border-color: #daebff;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #daebff;\n  --bs-btn-hover-border-color: #daebff;\n  --bs-btn-focus-shadow-rgb: 218, 235, 255;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #daebff;\n  --bs-btn-active-border-color: #daebff;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #daebff;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #daebff;\n  --bs-gradient: none;\n}\n\n.btn-link {\n  --bs-btn-font-weight: 400;\n  --bs-btn-color: var(--bs-link-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: transparent;\n  --bs-btn-hover-color: var(--bs-link-hover-color);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-active-color: var(--bs-link-hover-color);\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-disabled-color: #6c757d;\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-box-shadow: 0 0 0 #000;\n  --bs-btn-focus-shadow-rgb: 177, 122, 37;\n  text-decoration: underline;\n}\n\n.btn-link:focus-visible {\n  color: var(--bs-btn-color);\n}\n\n.btn-link:hover {\n  color: var(--bs-btn-hover-color);\n}\n\n.btn-lg,\n.btn-group-lg>.btn {\n  --bs-btn-padding-y: 0.5rem;\n  --bs-btn-padding-x: 1rem;\n  --bs-btn-font-size: 1.1rem;\n  --bs-btn-border-radius: var(--bs-border-radius-lg);\n}\n\n.btn-sm,\n.btn-group-sm>.btn {\n  --bs-btn-padding-y: 0.25rem;\n  --bs-btn-padding-x: 0.5rem;\n  --bs-btn-font-size: 0.77rem;\n  --bs-btn-border-radius: var(--bs-border-radius-sm);\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n\n.collapsing.collapse-horizontal {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.collapse-horizontal {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  --bs-dropdown-zindex: 1000;\n  --bs-dropdown-min-width: 10rem;\n  --bs-dropdown-padding-x: 0;\n  --bs-dropdown-padding-y: 0.5rem;\n  --bs-dropdown-spacer: 0.125rem;\n  --bs-dropdown-font-size: 0.88rem;\n  --bs-dropdown-color: var(--bs-body-color);\n  --bs-dropdown-bg: var(--bs-body-bg);\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-border-radius: var(--bs-border-radius);\n  --bs-dropdown-border-width: var(--bs-border-width);\n  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));\n  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n  --bs-dropdown-divider-margin-y: 0.5rem;\n  --bs-dropdown-box-shadow: var(--bs-box-shadow);\n  --bs-dropdown-link-color: var(--bs-body-color);\n  --bs-dropdown-link-hover-color: var(--bs-body-color);\n  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);\n  --bs-dropdown-link-active-color: #fff;\n  --bs-dropdown-link-active-bg: #d08f2c;\n  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);\n  --bs-dropdown-item-padding-x: 1rem;\n  --bs-dropdown-item-padding-y: 0.25rem;\n  --bs-dropdown-header-color: #6c757d;\n  --bs-dropdown-header-padding-x: 1rem;\n  --bs-dropdown-header-padding-y: 0.5rem;\n  position: absolute;\n  z-index: var(--bs-dropdown-zindex);\n  display: none;\n  min-width: var(--bs-dropdown-min-width);\n  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n  margin: 0;\n  font-size: var(--bs-dropdown-font-size);\n  color: var(--bs-dropdown-color);\n  text-align: left;\n  list-style: none;\n  background-color: var(--bs-dropdown-bg);\n  background-clip: padding-box;\n  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\n  border-radius: var(--bs-dropdown-border-radius);\n}\n\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: var(--bs-dropdown-spacer);\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 1400px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: var(--bs-dropdown-spacer);\n}\n\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: var(--bs-dropdown-spacer);\n}\n\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n\n.dropend .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: var(--bs-dropdown-spacer);\n}\n\n.dropstart .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n\n.dropstart .dropdown-toggle::after {\n  display: none;\n}\n\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n\n.dropstart .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: var(--bs-dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--bs-dropdown-divider-bg);\n  opacity: 1;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  clear: both;\n  font-weight: 400;\n  color: var(--bs-dropdown-link-color);\n  text-align: inherit;\n  text-decoration: none;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  border-radius: var(--bs-dropdown-item-border-radius, 0);\n}\n\n.dropdown-item:hover,\n.dropdown-item:focus {\n  color: var(--bs-dropdown-link-hover-color);\n  background-color: var(--bs-dropdown-link-hover-bg);\n}\n\n.dropdown-item.active,\n.dropdown-item:active {\n  color: var(--bs-dropdown-link-active-color);\n  text-decoration: none;\n  background-color: var(--bs-dropdown-link-active-bg);\n}\n\n.dropdown-item.disabled,\n.dropdown-item:disabled {\n  color: var(--bs-dropdown-link-disabled-color);\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);\n  margin-bottom: 0;\n  font-size: 0.77rem;\n  color: var(--bs-dropdown-header-color);\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  color: var(--bs-dropdown-link-color);\n}\n\n.dropdown-menu-dark {\n  --bs-dropdown-color: #dee2e6;\n  --bs-dropdown-bg: #343a40;\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-box-shadow: ;\n  --bs-dropdown-link-color: #dee2e6;\n  --bs-dropdown-link-hover-color: #fff;\n  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);\n  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);\n  --bs-dropdown-link-active-color: #fff;\n  --bs-dropdown-link-active-bg: #d08f2c;\n  --bs-dropdown-link-disabled-color: #adb5bd;\n  --bs-dropdown-header-color: #adb5bd;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n\n.btn-group>.btn,\n.btn-group-vertical>.btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n\n.btn-group>.btn-check:checked+.btn,\n.btn-group>.btn-check:focus+.btn,\n.btn-group>.btn:hover,\n.btn-group>.btn:focus,\n.btn-group>.btn:active,\n.btn-group>.btn.active,\n.btn-group-vertical>.btn-check:checked+.btn,\n.btn-group-vertical>.btn-check:focus+.btn,\n.btn-group-vertical>.btn:hover,\n.btn-group-vertical>.btn:focus,\n.btn-group-vertical>.btn:active,\n.btn-group-vertical>.btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group {\n  border-radius: var(--bs-border-radius);\n}\n\n.btn-group> :not(.btn-check:first-child)+.btn,\n.btn-group>.btn-group:not(:first-child) {\n  margin-left: calc(-1 * var(--bs-border-width));\n}\n\n.btn-group>.btn:not(:last-child):not(.dropdown-toggle),\n.btn-group>.btn.dropdown-toggle-split:first-child,\n.btn-group>.btn-group:not(:last-child)>.btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.btn-group>.btn:nth-child(n+3),\n.btn-group> :not(.btn-check)+.btn,\n.btn-group>.btn-group:not(:first-child)>.btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.5625rem;\n  padding-left: 0.5625rem;\n}\n\n.dropdown-toggle-split::after,\n.dropup .dropdown-toggle-split::after,\n.dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm+.dropdown-toggle-split,\n.btn-group-sm>.btn+.dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem;\n}\n\n.btn-lg+.dropdown-toggle-split,\n.btn-group-lg>.btn+.dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.btn-group-vertical>.btn,\n.btn-group-vertical>.btn-group {\n  width: 100%;\n}\n\n.btn-group-vertical>.btn:not(:first-child),\n.btn-group-vertical>.btn-group:not(:first-child) {\n  margin-top: calc(-1 * var(--bs-border-width));\n}\n\n.btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical>.btn-group:not(:last-child)>.btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.btn-group-vertical>.btn:nth-child(n+3),\n.btn-group-vertical> :not(.btn-check)+.btn,\n.btn-group-vertical>.btn-group:not(:first-child)>.btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  --bs-nav-link-padding-x: 1rem;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-link-color);\n  --bs-nav-link-hover-color: var(--bs-link-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-secondary-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n  font-size: var(--bs-nav-link-font-size);\n  font-weight: var(--bs-nav-link-font-weight);\n  color: var(--bs-nav-link-color);\n  text-decoration: none;\n  background: none;\n  border: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    transition: none;\n  }\n}\n\n.nav-link:hover,\n.nav-link:focus {\n  color: var(--bs-nav-link-hover-color);\n}\n\n.nav-link:focus-visible {\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(208, 143, 44, 0.25);\n}\n\n.nav-link.disabled,\n.nav-link:disabled {\n  color: var(--bs-nav-link-disabled-color);\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  --bs-nav-tabs-border-width: var(--bs-border-width);\n  --bs-nav-tabs-border-color: var(--bs-border-color);\n  --bs-nav-tabs-border-radius: var(--bs-border-radius);\n  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);\n  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);\n  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);\n  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);\n  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);\n}\n\n.nav-tabs .nav-link {\n  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));\n  border: var(--bs-nav-tabs-border-width) solid transparent;\n  border-top-left-radius: var(--bs-nav-tabs-border-radius);\n  border-top-right-radius: var(--bs-nav-tabs-border-radius);\n}\n\n.nav-tabs .nav-link:hover,\n.nav-tabs .nav-link:focus {\n  isolation: isolate;\n  border-color: var(--bs-nav-tabs-link-hover-border-color);\n}\n\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: var(--bs-nav-tabs-link-active-color);\n  background-color: var(--bs-nav-tabs-link-active-bg);\n  border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n\n.nav-tabs .dropdown-menu {\n  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills {\n  --bs-nav-pills-border-radius: var(--bs-border-radius);\n  --bs-nav-pills-link-active-color: #fff;\n  --bs-nav-pills-link-active-bg: #d08f2c;\n}\n\n.nav-pills .nav-link {\n  border-radius: var(--bs-nav-pills-border-radius);\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show>.nav-link {\n  color: var(--bs-nav-pills-link-active-color);\n  background-color: var(--bs-nav-pills-link-active-bg);\n}\n\n.nav-underline {\n  --bs-nav-underline-gap: 1rem;\n  --bs-nav-underline-border-width: 0.125rem;\n  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);\n  gap: var(--bs-nav-underline-gap);\n}\n\n.nav-underline .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n  border-bottom: var(--bs-nav-underline-border-width) solid transparent;\n}\n\n.nav-underline .nav-link:hover,\n.nav-underline .nav-link:focus {\n  border-bottom-color: currentcolor;\n}\n\n.nav-underline .nav-link.active,\n.nav-underline .show>.nav-link {\n  font-weight: 700;\n  color: var(--bs-nav-underline-link-active-color);\n  border-bottom-color: currentcolor;\n}\n\n.nav-fill>.nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified>.nav-link,\n.nav-justified .nav-item {\n  flex-grow: 1;\n  flex-basis: 0;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content>.tab-pane {\n  display: none;\n}\n\n.tab-content>.active {\n  display: block;\n}\n\n.navbar {\n  --bs-navbar-padding-x: 0;\n  --bs-navbar-padding-y: 0.5rem;\n  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);\n  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);\n  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);\n  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-padding-y: 0.335rem;\n  --bs-navbar-brand-margin-end: 1rem;\n  --bs-navbar-brand-font-size: 1.1rem;\n  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-nav-link-padding-x: 0.5rem;\n  --bs-navbar-toggler-padding-y: 0.25rem;\n  --bs-navbar-toggler-padding-x: 0.75rem;\n  --bs-navbar-toggler-font-size: 1.1rem;\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);\n  --bs-navbar-toggler-border-radius: var(--bs-border-radius);\n  --bs-navbar-toggler-focus-width: 0.25rem;\n  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);\n}\n\n.navbar>.container,\n.navbar>.container-fluid,\n.navbar>.container-sm,\n.navbar>.container-md,\n.navbar>.container-lg,\n.navbar>.container-xl,\n.navbar>.container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.navbar-brand {\n  padding-top: var(--bs-navbar-brand-padding-y);\n  padding-bottom: var(--bs-navbar-brand-padding-y);\n  margin-right: var(--bs-navbar-brand-margin-end);\n  font-size: var(--bs-navbar-brand-font-size);\n  color: var(--bs-navbar-brand-color);\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.navbar-brand:hover,\n.navbar-brand:focus {\n  color: var(--bs-navbar-brand-hover-color);\n}\n\n.navbar-nav {\n  --bs-nav-link-padding-x: 0;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-navbar-color);\n  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.navbar-nav .nav-link.active,\n.navbar-nav .nav-link.show {\n  color: var(--bs-navbar-active-color);\n}\n\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-navbar-color);\n}\n\n.navbar-text a,\n.navbar-text a:hover,\n.navbar-text a:focus {\n  color: var(--bs-navbar-active-color);\n}\n\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);\n  font-size: var(--bs-navbar-toggler-font-size);\n  line-height: 1;\n  color: var(--bs-navbar-color);\n  background-color: transparent;\n  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);\n  border-radius: var(--bs-navbar-toggler-border-radius);\n  transition: var(--bs-navbar-toggler-transition);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    transition: none;\n  }\n}\n\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--bs-navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n\n  .navbar-expand-sm .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n\n  .navbar-expand-sm .offcanvas .offcanvas-header {\n    display: none;\n  }\n\n  .navbar-expand-sm .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n\n  .navbar-expand-md .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n\n  .navbar-expand-md .offcanvas .offcanvas-header {\n    display: none;\n  }\n\n  .navbar-expand-md .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n\n  .navbar-expand-lg .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n\n  .navbar-expand-lg .offcanvas .offcanvas-header {\n    display: none;\n  }\n\n  .navbar-expand-lg .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n\n  .navbar-expand-xl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n\n  .navbar-expand-xl .offcanvas .offcanvas-header {\n    display: none;\n  }\n\n  .navbar-expand-xl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n\n@media (min-width: 1400px) {\n  .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n\n  .navbar-expand-xxl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n\n  .navbar-expand-xxl .offcanvas .offcanvas-header {\n    display: none;\n  }\n\n  .navbar-expand-xxl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n\n.navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: var(--bs-navbar-nav-link-padding-x);\n  padding-left: var(--bs-navbar-nav-link-padding-x);\n}\n\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n\n.navbar-expand .offcanvas {\n  position: static;\n  z-index: auto;\n  flex-grow: 1;\n  width: auto !important;\n  height: auto !important;\n  visibility: visible !important;\n  background-color: transparent !important;\n  border: 0 !important;\n  transform: none !important;\n  transition: none;\n}\n\n.navbar-expand .offcanvas .offcanvas-header {\n  display: none;\n}\n\n.navbar-expand .offcanvas .offcanvas-body {\n  display: flex;\n  flex-grow: 0;\n  padding: 0;\n  overflow-y: visible;\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=dark] {\n  --bs-navbar-color: rgba(255, 255, 255, 0.55);\n  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);\n  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);\n  --bs-navbar-active-color: #fff;\n  --bs-navbar-brand-color: #fff;\n  --bs-navbar-brand-hover-color: #fff;\n  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n[data-bs-theme=dark] .navbar-toggler-icon {\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.card {\n  --bs-card-spacer-y: 1rem;\n  --bs-card-spacer-x: 1rem;\n  --bs-card-title-spacer-y: 0.5rem;\n  --bs-card-title-color: ;\n  --bs-card-subtitle-color: ;\n  --bs-card-border-width: var(--bs-border-width);\n  --bs-card-border-color: var(--bs-border-color-translucent);\n  --bs-card-border-radius: var(--bs-border-radius);\n  --bs-card-box-shadow: ;\n  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));\n  --bs-card-cap-padding-y: 0.5rem;\n  --bs-card-cap-padding-x: 1rem;\n  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);\n  --bs-card-cap-color: ;\n  --bs-card-height: ;\n  --bs-card-color: ;\n  --bs-card-bg: var(--bs-body-bg);\n  --bs-card-img-overlay-padding: 1rem;\n  --bs-card-group-margin: 0.75rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: var(--bs-card-height);\n  color: var(--bs-body-color);\n  word-wrap: break-word;\n  background-color: var(--bs-card-bg);\n  background-clip: border-box;\n  border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n  border-radius: var(--bs-card-border-radius);\n}\n\n.card>hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n\n.card>.list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n\n.card>.list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n\n.card>.list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n\n.card>.card-header+.list-group,\n.card>.list-group+.card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n  color: var(--bs-card-color);\n}\n\n.card-title {\n  margin-bottom: var(--bs-card-title-spacer-y);\n  color: var(--bs-card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));\n  margin-bottom: 0;\n  color: var(--bs-card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link+.card-link {\n  margin-left: var(--bs-card-spacer-x);\n}\n\n.card-header {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  margin-bottom: 0;\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n\n.card-header:first-child {\n  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;\n}\n\n.card-footer {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n\n.card-footer:last-child {\n  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);\n}\n\n.card-header-tabs {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n  border-bottom: 0;\n}\n\n.card-header-tabs .nav-link.active {\n  background-color: var(--bs-card-bg);\n  border-bottom-color: var(--bs-card-bg);\n}\n\n.card-header-pills {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--bs-card-img-overlay-padding);\n  border-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-group>.card {\n  margin-bottom: var(--bs-card-group-margin);\n}\n\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n\n  .card-group>.card {\n    flex: 1 0 0;\n    margin-bottom: 0;\n  }\n\n  .card-group>.card+.card {\n    margin-left: 0;\n    border-left: 0;\n  }\n\n  .card-group>.card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  .card-group>.card:not(:last-child)>.card-img-top,\n  .card-group>.card:not(:last-child)>.card-header {\n    border-top-right-radius: 0;\n  }\n\n  .card-group>.card:not(:last-child)>.card-img-bottom,\n  .card-group>.card:not(:last-child)>.card-footer {\n    border-bottom-right-radius: 0;\n  }\n\n  .card-group>.card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .card-group>.card:not(:first-child)>.card-img-top,\n  .card-group>.card:not(:first-child)>.card-header {\n    border-top-left-radius: 0;\n  }\n\n  .card-group>.card:not(:first-child)>.card-img-bottom,\n  .card-group>.card:not(:first-child)>.card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion {\n  --bs-accordion-color: var(--bs-body-color);\n  --bs-accordion-bg: var(--bs-body-bg);\n  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n  --bs-accordion-border-color: var(--bs-border-color);\n  --bs-accordion-border-width: var(--bs-border-width);\n  --bs-accordion-border-radius: var(--bs-border-radius);\n  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));\n  --bs-accordion-btn-padding-x: 1.25rem;\n  --bs-accordion-btn-padding-y: 1rem;\n  --bs-accordion-btn-color: var(--bs-body-color);\n  --bs-accordion-btn-bg: var(--bs-accordion-bg);\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-icon-width: 1.25rem;\n  --bs-accordion-btn-icon-transform: rotate(-180deg);\n  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='rgb%2883.2, 57.2, 17.6%29' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(208, 143, 44, 0.25);\n  --bs-accordion-body-padding-x: 1.25rem;\n  --bs-accordion-body-padding-y: 1rem;\n  --bs-accordion-active-color: var(--bs-primary-text-emphasis);\n  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\n  font-size: 0.88rem;\n  color: var(--bs-accordion-btn-color);\n  text-align: left;\n  background-color: var(--bs-accordion-btn-bg);\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: var(--bs-accordion-transition);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    transition: none;\n  }\n}\n\n.accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: var(--bs-accordion-active-bg);\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);\n}\n\n.accordion-button:not(.collapsed)::after {\n  background-image: var(--bs-accordion-btn-active-icon);\n  transform: var(--bs-accordion-btn-icon-transform);\n}\n\n.accordion-button::after {\n  flex-shrink: 0;\n  width: var(--bs-accordion-btn-icon-width);\n  height: var(--bs-accordion-btn-icon-width);\n  margin-left: auto;\n  content: \"\";\n  background-image: var(--bs-accordion-btn-icon);\n  background-repeat: no-repeat;\n  background-size: var(--bs-accordion-btn-icon-width);\n  transition: var(--bs-accordion-btn-icon-transition);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    transition: none;\n  }\n}\n\n.accordion-button:hover {\n  z-index: 2;\n}\n\n.accordion-button:focus {\n  z-index: 3;\n  outline: 0;\n  box-shadow: var(--bs-accordion-btn-focus-box-shadow);\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--bs-accordion-color);\n  background-color: var(--bs-accordion-bg);\n  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);\n}\n\n.accordion-item:first-of-type {\n  border-top-left-radius: var(--bs-accordion-border-radius);\n  border-top-right-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-item:first-of-type>.accordion-header .accordion-button {\n  border-top-left-radius: var(--bs-accordion-inner-border-radius);\n  border-top-right-radius: var(--bs-accordion-inner-border-radius);\n}\n\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n\n.accordion-item:last-of-type {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-item:last-of-type>.accordion-header .accordion-button.collapsed {\n  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);\n}\n\n.accordion-item:last-of-type>.accordion-collapse {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-body {\n  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);\n}\n\n.accordion-flush>.accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n\n.accordion-flush>.accordion-item:first-child {\n  border-top: 0;\n}\n\n.accordion-flush>.accordion-item:last-child {\n  border-bottom: 0;\n}\n\n.accordion-flush>.accordion-item>.accordion-collapse,\n.accordion-flush>.accordion-item>.accordion-header .accordion-button,\n.accordion-flush>.accordion-item>.accordion-header .accordion-button.collapsed {\n  border-radius: 0;\n}\n\n[data-bs-theme=dark] .accordion-button::after {\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%28226.8, 187.8, 128.4%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%28226.8, 187.8, 128.4%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e\");\n}\n\n.breadcrumb {\n  --bs-breadcrumb-padding-x: 0;\n  --bs-breadcrumb-padding-y: 0;\n  --bs-breadcrumb-margin-bottom: 1rem;\n  --bs-breadcrumb-bg: ;\n  --bs-breadcrumb-border-radius: ;\n  --bs-breadcrumb-divider-color: var(--bs-secondary-color);\n  --bs-breadcrumb-item-padding-x: 0.5rem;\n  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\n  margin-bottom: var(--bs-breadcrumb-margin-bottom);\n  font-size: var(--bs-breadcrumb-font-size);\n  list-style: none;\n  background-color: var(--bs-breadcrumb-bg);\n  border-radius: var(--bs-breadcrumb-border-radius);\n}\n\n.breadcrumb-item+.breadcrumb-item {\n  padding-left: var(--bs-breadcrumb-item-padding-x);\n}\n\n.breadcrumb-item+.breadcrumb-item::before {\n  float: left;\n  padding-right: var(--bs-breadcrumb-item-padding-x);\n  color: var(--bs-breadcrumb-divider-color);\n  content: var(--bs-breadcrumb-divider, \"/\")\n    /* rtl: var(--bs-breadcrumb-divider, \"/\") */\n  ;\n}\n\n.breadcrumb-item.active {\n  color: var(--bs-breadcrumb-item-active-color);\n}\n\n.pagination {\n  --bs-pagination-padding-x: 0.75rem;\n  --bs-pagination-padding-y: 0.375rem;\n  --bs-pagination-font-size: 0.88rem;\n  --bs-pagination-color: var(--bs-link-color);\n  --bs-pagination-bg: var(--bs-body-bg);\n  --bs-pagination-border-width: var(--bs-border-width);\n  --bs-pagination-border-color: var(--bs-border-color);\n  --bs-pagination-border-radius: var(--bs-border-radius);\n  --bs-pagination-hover-color: var(--bs-link-hover-color);\n  --bs-pagination-hover-bg: var(--bs-tertiary-bg);\n  --bs-pagination-hover-border-color: var(--bs-border-color);\n  --bs-pagination-focus-color: var(--bs-link-hover-color);\n  --bs-pagination-focus-bg: var(--bs-secondary-bg);\n  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(208, 143, 44, 0.25);\n  --bs-pagination-active-color: #fff;\n  --bs-pagination-active-bg: #d08f2c;\n  --bs-pagination-active-border-color: #d08f2c;\n  --bs-pagination-disabled-color: var(--bs-secondary-color);\n  --bs-pagination-disabled-bg: var(--bs-secondary-bg);\n  --bs-pagination-disabled-border-color: var(--bs-border-color);\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n  font-size: var(--bs-pagination-font-size);\n  color: var(--bs-pagination-color);\n  text-decoration: none;\n  background-color: var(--bs-pagination-bg);\n  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    transition: none;\n  }\n}\n\n.page-link:hover {\n  z-index: 2;\n  color: var(--bs-pagination-hover-color);\n  background-color: var(--bs-pagination-hover-bg);\n  border-color: var(--bs-pagination-hover-border-color);\n}\n\n.page-link:focus {\n  z-index: 3;\n  color: var(--bs-pagination-focus-color);\n  background-color: var(--bs-pagination-focus-bg);\n  outline: 0;\n  box-shadow: var(--bs-pagination-focus-box-shadow);\n}\n\n.page-link.active,\n.active>.page-link {\n  z-index: 3;\n  color: var(--bs-pagination-active-color);\n  background-color: var(--bs-pagination-active-bg);\n  border-color: var(--bs-pagination-active-border-color);\n}\n\n.page-link.disabled,\n.disabled>.page-link {\n  color: var(--bs-pagination-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-pagination-disabled-bg);\n  border-color: var(--bs-pagination-disabled-border-color);\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: calc(-1 * var(--bs-border-width));\n}\n\n.page-item:first-child .page-link {\n  border-top-left-radius: var(--bs-pagination-border-radius);\n  border-bottom-left-radius: var(--bs-pagination-border-radius);\n}\n\n.page-item:last-child .page-link {\n  border-top-right-radius: var(--bs-pagination-border-radius);\n  border-bottom-right-radius: var(--bs-pagination-border-radius);\n}\n\n.pagination-lg {\n  --bs-pagination-padding-x: 1.5rem;\n  --bs-pagination-padding-y: 0.75rem;\n  --bs-pagination-font-size: 1.1rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-lg);\n}\n\n.pagination-sm {\n  --bs-pagination-padding-x: 0.5rem;\n  --bs-pagination-padding-y: 0.25rem;\n  --bs-pagination-font-size: 0.77rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-sm);\n}\n\n.badge {\n  --bs-badge-padding-x: 0.65em;\n  --bs-badge-padding-y: 0.35em;\n  --bs-badge-font-size: 0.75em;\n  --bs-badge-font-weight: 700;\n  --bs-badge-color: #fff;\n  --bs-badge-border-radius: var(--bs-border-radius);\n  display: inline-block;\n  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\n  font-size: var(--bs-badge-font-size);\n  font-weight: var(--bs-badge-font-weight);\n  line-height: 1;\n  color: var(--bs-badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--bs-badge-border-radius);\n}\n\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  --bs-alert-bg: transparent;\n  --bs-alert-padding-x: 1rem;\n  --bs-alert-padding-y: 1rem;\n  --bs-alert-margin-bottom: 1rem;\n  --bs-alert-color: inherit;\n  --bs-alert-border-color: transparent;\n  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);\n  --bs-alert-border-radius: var(--bs-border-radius);\n  --bs-alert-link-color: inherit;\n  position: relative;\n  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\n  margin-bottom: var(--bs-alert-margin-bottom);\n  color: var(--bs-alert-color);\n  background-color: var(--bs-alert-bg);\n  border: var(--bs-alert-border);\n  border-radius: var(--bs-alert-border-radius);\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 700;\n  color: var(--bs-alert-link-color);\n}\n\n.alert-dismissible {\n  padding-right: 3rem;\n}\n\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 1.25rem 1rem;\n}\n\n.alert-primary {\n  --bs-alert-color: var(--bs-primary-text-emphasis);\n  --bs-alert-bg: var(--bs-primary-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-text-emphasis);\n}\n\n.alert-secondary {\n  --bs-alert-color: var(--bs-secondary-text-emphasis);\n  --bs-alert-bg: var(--bs-secondary-bg-subtle);\n  --bs-alert-border-color: var(--bs-secondary-border-subtle);\n  --bs-alert-link-color: var(--bs-secondary-text-emphasis);\n}\n\n.alert-success {\n  --bs-alert-color: var(--bs-success-text-emphasis);\n  --bs-alert-bg: var(--bs-success-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-border-subtle);\n  --bs-alert-link-color: var(--bs-success-text-emphasis);\n}\n\n.alert-info {\n  --bs-alert-color: var(--bs-info-text-emphasis);\n  --bs-alert-bg: var(--bs-info-bg-subtle);\n  --bs-alert-border-color: var(--bs-info-border-subtle);\n  --bs-alert-link-color: var(--bs-info-text-emphasis);\n}\n\n.alert-warning {\n  --bs-alert-color: var(--bs-warning-text-emphasis);\n  --bs-alert-bg: var(--bs-warning-bg-subtle);\n  --bs-alert-border-color: var(--bs-warning-border-subtle);\n  --bs-alert-link-color: var(--bs-warning-text-emphasis);\n}\n\n.alert-danger {\n  --bs-alert-color: var(--bs-danger-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-text-emphasis);\n}\n\n.alert-light {\n  --bs-alert-color: var(--bs-light-text-emphasis);\n  --bs-alert-bg: var(--bs-light-bg-subtle);\n  --bs-alert-border-color: var(--bs-light-border-subtle);\n  --bs-alert-link-color: var(--bs-light-text-emphasis);\n}\n\n.alert-dark {\n  --bs-alert-color: var(--bs-dark-text-emphasis);\n  --bs-alert-bg: var(--bs-dark-bg-subtle);\n  --bs-alert-border-color: var(--bs-dark-border-subtle);\n  --bs-alert-link-color: var(--bs-dark-text-emphasis);\n}\n\n.alert-primary-div {\n  --bs-alert-color: var(--bs-primary-div-text-emphasis);\n  --bs-alert-bg: var(--bs-primary-div-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-div-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-div-text-emphasis);\n}\n\n.alert-primary-div-50 {\n  --bs-alert-color: var(--bs-primary-div-50-text-emphasis);\n  --bs-alert-bg: var(--bs-primary-div-50-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-div-50-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-div-50-text-emphasis);\n}\n\n.alert-primary-div-60 {\n  --bs-alert-color: var(--bs-primary-div-60-text-emphasis);\n  --bs-alert-bg: var(--bs-primary-div-60-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-div-60-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-div-60-text-emphasis);\n}\n\n.alert-primary-50 {\n  --bs-alert-color: var(--bs-primary-50-text-emphasis);\n  --bs-alert-bg: var(--bs-primary-50-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-50-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-50-text-emphasis);\n}\n\n.alert-primary-60 {\n  --bs-alert-color: var(--bs-primary-60-text-emphasis);\n  --bs-alert-bg: var(--bs-primary-60-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-60-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-60-text-emphasis);\n}\n\n.alert-primary-70 {\n  --bs-alert-color: var(--bs-primary-70-text-emphasis);\n  --bs-alert-bg: var(--bs-primary-70-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-70-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-70-text-emphasis);\n}\n\n.alert-success-50 {\n  --bs-alert-color: var(--bs-success-50-text-emphasis);\n  --bs-alert-bg: var(--bs-success-50-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-50-border-subtle);\n  --bs-alert-link-color: var(--bs-success-50-text-emphasis);\n}\n\n.alert-success-60 {\n  --bs-alert-color: var(--bs-success-60-text-emphasis);\n  --bs-alert-bg: var(--bs-success-60-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-60-border-subtle);\n  --bs-alert-link-color: var(--bs-success-60-text-emphasis);\n}\n\n.alert-success-70 {\n  --bs-alert-color: var(--bs-success-70-text-emphasis);\n  --bs-alert-bg: var(--bs-success-70-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-70-border-subtle);\n  --bs-alert-link-color: var(--bs-success-70-text-emphasis);\n}\n\n.alert-success-80 {\n  --bs-alert-color: var(--bs-success-80-text-emphasis);\n  --bs-alert-bg: var(--bs-success-80-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-80-border-subtle);\n  --bs-alert-link-color: var(--bs-success-80-text-emphasis);\n}\n\n.alert-success-90 {\n  --bs-alert-color: var(--bs-success-90-text-emphasis);\n  --bs-alert-bg: var(--bs-success-90-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-90-border-subtle);\n  --bs-alert-link-color: var(--bs-success-90-text-emphasis);\n}\n\n.alert-success-100 {\n  --bs-alert-color: var(--bs-success-100-text-emphasis);\n  --bs-alert-bg: var(--bs-success-100-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-100-border-subtle);\n  --bs-alert-link-color: var(--bs-success-100-text-emphasis);\n}\n\n.alert-body-bg {\n  --bs-alert-color: var(--bs-body-bg-text-emphasis);\n  --bs-alert-bg: var(--bs-body-bg-bg-subtle);\n  --bs-alert-border-color: var(--bs-body-bg-border-subtle);\n  --bs-alert-link-color: var(--bs-body-bg-text-emphasis);\n}\n\n.alert-danger-div {\n  --bs-alert-color: var(--bs-danger-div-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-div-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-div-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-div-text-emphasis);\n}\n\n.alert-danger-40 {\n  --bs-alert-color: var(--bs-danger-40-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-40-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-40-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-40-text-emphasis);\n}\n\n.alert-danger-50 {\n  --bs-alert-color: var(--bs-danger-50-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-50-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-50-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-50-text-emphasis);\n}\n\n.alert-danger-60 {\n  --bs-alert-color: var(--bs-danger-60-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-60-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-60-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-60-text-emphasis);\n}\n\n.alert-danger-70 {\n  --bs-alert-color: var(--bs-danger-70-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-70-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-70-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-70-text-emphasis);\n}\n\n.alert-danger-80 {\n  --bs-alert-color: var(--bs-danger-80-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-80-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-80-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-80-text-emphasis);\n}\n\n.alert-danger-90 {\n  --bs-alert-color: var(--bs-danger-90-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-90-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-90-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-90-text-emphasis);\n}\n\n.alert-danger-100 {\n  --bs-alert-color: var(--bs-danger-100-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-100-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-100-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-100-text-emphasis);\n}\n\n.alert-rating-color {\n  --bs-alert-color: var(--bs-rating-color-text-emphasis);\n  --bs-alert-bg: var(--bs-rating-color-bg-subtle);\n  --bs-alert-border-color: var(--bs-rating-color-border-subtle);\n  --bs-alert-link-color: var(--bs-rating-color-text-emphasis);\n}\n\n.alert-card-bg-c {\n  --bs-alert-color: var(--bs-card-bg-c-text-emphasis);\n  --bs-alert-bg: var(--bs-card-bg-c-bg-subtle);\n  --bs-alert-border-color: var(--bs-card-bg-c-border-subtle);\n  --bs-alert-link-color: var(--bs-card-bg-c-text-emphasis);\n}\n\n.alert-card-text-c {\n  --bs-alert-color: var(--bs-card-text-c-text-emphasis);\n  --bs-alert-bg: var(--bs-card-text-c-bg-subtle);\n  --bs-alert-border-color: var(--bs-card-text-c-border-subtle);\n  --bs-alert-link-color: var(--bs-card-text-c-text-emphasis);\n}\n\n.alert-gary-light {\n  --bs-alert-color: var(--bs-gary-light-text-emphasis);\n  --bs-alert-bg: var(--bs-gary-light-bg-subtle);\n  --bs-alert-border-color: var(--bs-gary-light-border-subtle);\n  --bs-alert-link-color: var(--bs-gary-light-text-emphasis);\n}\n\n.alert-border-color {\n  --bs-alert-color: var(--bs-border-color-text-emphasis);\n  --bs-alert-bg: var(--bs-border-color-bg-subtle);\n  --bs-alert-border-color: var(--bs-border-color-border-subtle);\n  --bs-alert-link-color: var(--bs-border-color-text-emphasis);\n}\n\n.alert-border-color-50 {\n  --bs-alert-color: var(--bs-border-color-50-text-emphasis);\n  --bs-alert-bg: var(--bs-border-color-50-bg-subtle);\n  --bs-alert-border-color: var(--bs-border-color-50-border-subtle);\n  --bs-alert-link-color: var(--bs-border-color-50-text-emphasis);\n}\n\n.alert-gray-100 {\n  --bs-alert-color: var(--bs-gray-100-text-emphasis);\n  --bs-alert-bg: var(--bs-gray-100-bg-subtle);\n  --bs-alert-border-color: var(--bs-gray-100-border-subtle);\n  --bs-alert-link-color: var(--bs-gray-100-text-emphasis);\n}\n\n.alert-body-color-50 {\n  --bs-alert-color: var(--bs-body-color-50-text-emphasis);\n  --bs-alert-bg: var(--bs-body-color-50-bg-subtle);\n  --bs-alert-border-color: var(--bs-body-color-50-border-subtle);\n  --bs-alert-link-color: var(--bs-body-color-50-text-emphasis);\n}\n\n.alert-body-color-60 {\n  --bs-alert-color: var(--bs-body-color-60-text-emphasis);\n  --bs-alert-bg: var(--bs-body-color-60-bg-subtle);\n  --bs-alert-border-color: var(--bs-body-color-60-border-subtle);\n  --bs-alert-link-color: var(--bs-body-color-60-text-emphasis);\n}\n\n.alert-purple-100 {\n  --bs-alert-color: var(--bs-purple-100-text-emphasis);\n  --bs-alert-bg: var(--bs-purple-100-bg-subtle);\n  --bs-alert-border-color: var(--bs-purple-100-border-subtle);\n  --bs-alert-link-color: var(--bs-purple-100-text-emphasis);\n}\n\n.alert-info-100 {\n  --bs-alert-color: var(--bs-info-100-text-emphasis);\n  --bs-alert-bg: var(--bs-info-100-bg-subtle);\n  --bs-alert-border-color: var(--bs-info-100-border-subtle);\n  --bs-alert-link-color: var(--bs-info-100-text-emphasis);\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: var(--bs-progress-height);\n  }\n}\n\n.progress,\n.progress-stacked {\n  --bs-progress-height: 1rem;\n  --bs-progress-font-size: 0.66rem;\n  --bs-progress-bg: var(--bs-secondary-bg);\n  --bs-progress-border-radius: var(--bs-border-radius);\n  --bs-progress-box-shadow: var(--bs-box-shadow-inset);\n  --bs-progress-bar-color: #fff;\n  --bs-progress-bar-bg: #d08f2c;\n  --bs-progress-bar-transition: width 0.6s ease;\n  display: flex;\n  height: var(--bs-progress-height);\n  overflow: hidden;\n  font-size: var(--bs-progress-font-size);\n  background-color: var(--bs-progress-bg);\n  border-radius: var(--bs-progress-border-radius);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--bs-progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-progress-bar-bg);\n  transition: var(--bs-progress-bar-transition);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: var(--bs-progress-height) var(--bs-progress-height);\n}\n\n.progress-stacked>.progress {\n  overflow: visible;\n}\n\n.progress-stacked>.progress>.progress-bar {\n  width: 100%;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.list-group {\n  --bs-list-group-color: var(--bs-body-color);\n  --bs-list-group-bg: var(--bs-body-bg);\n  --bs-list-group-border-color: var(--bs-border-color);\n  --bs-list-group-border-width: var(--bs-border-width);\n  --bs-list-group-border-radius: var(--bs-border-radius);\n  --bs-list-group-item-padding-x: 1rem;\n  --bs-list-group-item-padding-y: 0.5rem;\n  --bs-list-group-action-color: var(--bs-secondary-color);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);\n  --bs-list-group-action-active-color: var(--bs-body-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-bg);\n  --bs-list-group-disabled-color: var(--bs-secondary-color);\n  --bs-list-group-disabled-bg: var(--bs-body-bg);\n  --bs-list-group-active-color: #fff;\n  --bs-list-group-active-bg: #d08f2c;\n  --bs-list-group-active-border-color: #d08f2c;\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: var(--bs-list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n\n.list-group-numbered>.list-group-item::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\n  color: var(--bs-list-group-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-bg);\n  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);\n}\n\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n\n.list-group-item.disabled,\n.list-group-item:disabled {\n  color: var(--bs-list-group-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-list-group-disabled-bg);\n}\n\n.list-group-item.active {\n  z-index: 2;\n  color: var(--bs-list-group-active-color);\n  background-color: var(--bs-list-group-active-bg);\n  border-color: var(--bs-list-group-active-border-color);\n}\n\n.list-group-item+.list-group-item {\n  border-top-width: 0;\n}\n\n.list-group-item+.list-group-item.active {\n  margin-top: calc(-1 * var(--bs-list-group-border-width));\n  border-top-width: var(--bs-list-group-border-width);\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: var(--bs-list-group-action-color);\n  text-align: inherit;\n}\n\n.list-group-item-action:not(.active):hover,\n.list-group-item-action:not(.active):focus {\n  z-index: 1;\n  color: var(--bs-list-group-action-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-action-hover-bg);\n}\n\n.list-group-item-action:not(.active):active {\n  color: var(--bs-list-group-action-active-color);\n  background-color: var(--bs-list-group-action-active-bg);\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n\n.list-group-horizontal>.list-group-item:first-child:not(:last-child) {\n  border-bottom-left-radius: var(--bs-list-group-border-radius);\n  border-top-right-radius: 0;\n}\n\n.list-group-horizontal>.list-group-item:last-child:not(:first-child) {\n  border-top-right-radius: var(--bs-list-group-border-radius);\n  border-bottom-left-radius: 0;\n}\n\n.list-group-horizontal>.list-group-item.active {\n  margin-top: 0;\n}\n\n.list-group-horizontal>.list-group-item+.list-group-item {\n  border-top-width: var(--bs-list-group-border-width);\n  border-left-width: 0;\n}\n\n.list-group-horizontal>.list-group-item+.list-group-item.active {\n  margin-left: calc(-1 * var(--bs-list-group-border-width));\n  border-left-width: var(--bs-list-group-border-width);\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-sm>.list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-sm>.list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n\n  .list-group-horizontal-sm>.list-group-item.active {\n    margin-top: 0;\n  }\n\n  .list-group-horizontal-sm>.list-group-item+.list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n\n  .list-group-horizontal-sm>.list-group-item+.list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-md>.list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-md>.list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n\n  .list-group-horizontal-md>.list-group-item.active {\n    margin-top: 0;\n  }\n\n  .list-group-horizontal-md>.list-group-item+.list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n\n  .list-group-horizontal-md>.list-group-item+.list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-lg>.list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-lg>.list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n\n  .list-group-horizontal-lg>.list-group-item.active {\n    margin-top: 0;\n  }\n\n  .list-group-horizontal-lg>.list-group-item+.list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n\n  .list-group-horizontal-lg>.list-group-item+.list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-xl>.list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-xl>.list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n\n  .list-group-horizontal-xl>.list-group-item.active {\n    margin-top: 0;\n  }\n\n  .list-group-horizontal-xl>.list-group-item+.list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n\n  .list-group-horizontal-xl>.list-group-item+.list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n\n@media (min-width: 1400px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n\n  .list-group-horizontal-xxl>.list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n\n  .list-group-horizontal-xxl>.list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n\n  .list-group-horizontal-xxl>.list-group-item.active {\n    margin-top: 0;\n  }\n\n  .list-group-horizontal-xxl>.list-group-item+.list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n\n  .list-group-horizontal-xxl>.list-group-item+.list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n\n.list-group-flush {\n  border-radius: 0;\n}\n\n.list-group-flush>.list-group-item {\n  border-width: 0 0 var(--bs-list-group-border-width);\n}\n\n.list-group-flush>.list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  --bs-list-group-color: var(--bs-primary-text-emphasis);\n  --bs-list-group-bg: var(--bs-primary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-active-color: var(--bs-primary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);\n}\n\n.list-group-item-secondary {\n  --bs-list-group-color: var(--bs-secondary-text-emphasis);\n  --bs-list-group-bg: var(--bs-secondary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);\n}\n\n.list-group-item-success {\n  --bs-list-group-color: var(--bs-success-text-emphasis);\n  --bs-list-group-bg: var(--bs-success-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);\n  --bs-list-group-active-color: var(--bs-success-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-success-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);\n}\n\n.list-group-item-info {\n  --bs-list-group-color: var(--bs-info-text-emphasis);\n  --bs-list-group-bg: var(--bs-info-bg-subtle);\n  --bs-list-group-border-color: var(--bs-info-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);\n  --bs-list-group-active-color: var(--bs-info-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-info-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);\n}\n\n.list-group-item-warning {\n  --bs-list-group-color: var(--bs-warning-text-emphasis);\n  --bs-list-group-bg: var(--bs-warning-bg-subtle);\n  --bs-list-group-border-color: var(--bs-warning-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-active-color: var(--bs-warning-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);\n}\n\n.list-group-item-danger {\n  --bs-list-group-color: var(--bs-danger-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);\n}\n\n.list-group-item-light {\n  --bs-list-group-color: var(--bs-light-text-emphasis);\n  --bs-list-group-bg: var(--bs-light-bg-subtle);\n  --bs-list-group-border-color: var(--bs-light-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);\n  --bs-list-group-active-color: var(--bs-light-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-light-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);\n}\n\n.list-group-item-dark {\n  --bs-list-group-color: var(--bs-dark-text-emphasis);\n  --bs-list-group-bg: var(--bs-dark-bg-subtle);\n  --bs-list-group-border-color: var(--bs-dark-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-active-color: var(--bs-dark-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);\n}\n\n.list-group-item-primary-div {\n  --bs-list-group-color: var(--bs-primary-div-text-emphasis);\n  --bs-list-group-bg: var(--bs-primary-div-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-div-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-div-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-primary-div-border-subtle);\n  --bs-list-group-active-color: var(--bs-primary-div-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-primary-div-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-primary-div-text-emphasis);\n}\n\n.list-group-item-primary-div-50 {\n  --bs-list-group-color: var(--bs-primary-div-50-text-emphasis);\n  --bs-list-group-bg: var(--bs-primary-div-50-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-div-50-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-div-50-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-primary-div-50-border-subtle);\n  --bs-list-group-active-color: var(--bs-primary-div-50-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-primary-div-50-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-primary-div-50-text-emphasis);\n}\n\n.list-group-item-primary-div-60 {\n  --bs-list-group-color: var(--bs-primary-div-60-text-emphasis);\n  --bs-list-group-bg: var(--bs-primary-div-60-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-div-60-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-div-60-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-primary-div-60-border-subtle);\n  --bs-list-group-active-color: var(--bs-primary-div-60-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-primary-div-60-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-primary-div-60-text-emphasis);\n}\n\n.list-group-item-primary-50 {\n  --bs-list-group-color: var(--bs-primary-50-text-emphasis);\n  --bs-list-group-bg: var(--bs-primary-50-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-50-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-50-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-primary-50-border-subtle);\n  --bs-list-group-active-color: var(--bs-primary-50-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-primary-50-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-primary-50-text-emphasis);\n}\n\n.list-group-item-primary-60 {\n  --bs-list-group-color: var(--bs-primary-60-text-emphasis);\n  --bs-list-group-bg: var(--bs-primary-60-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-60-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-60-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-primary-60-border-subtle);\n  --bs-list-group-active-color: var(--bs-primary-60-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-primary-60-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-primary-60-text-emphasis);\n}\n\n.list-group-item-primary-70 {\n  --bs-list-group-color: var(--bs-primary-70-text-emphasis);\n  --bs-list-group-bg: var(--bs-primary-70-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-70-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-70-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-primary-70-border-subtle);\n  --bs-list-group-active-color: var(--bs-primary-70-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-primary-70-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-primary-70-text-emphasis);\n}\n\n.list-group-item-success-50 {\n  --bs-list-group-color: var(--bs-success-50-text-emphasis);\n  --bs-list-group-bg: var(--bs-success-50-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-50-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-50-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-success-50-border-subtle);\n  --bs-list-group-active-color: var(--bs-success-50-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-success-50-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-success-50-text-emphasis);\n}\n\n.list-group-item-success-60 {\n  --bs-list-group-color: var(--bs-success-60-text-emphasis);\n  --bs-list-group-bg: var(--bs-success-60-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-60-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-60-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-success-60-border-subtle);\n  --bs-list-group-active-color: var(--bs-success-60-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-success-60-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-success-60-text-emphasis);\n}\n\n.list-group-item-success-70 {\n  --bs-list-group-color: var(--bs-success-70-text-emphasis);\n  --bs-list-group-bg: var(--bs-success-70-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-70-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-70-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-success-70-border-subtle);\n  --bs-list-group-active-color: var(--bs-success-70-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-success-70-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-success-70-text-emphasis);\n}\n\n.list-group-item-success-80 {\n  --bs-list-group-color: var(--bs-success-80-text-emphasis);\n  --bs-list-group-bg: var(--bs-success-80-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-80-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-80-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-success-80-border-subtle);\n  --bs-list-group-active-color: var(--bs-success-80-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-success-80-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-success-80-text-emphasis);\n}\n\n.list-group-item-success-90 {\n  --bs-list-group-color: var(--bs-success-90-text-emphasis);\n  --bs-list-group-bg: var(--bs-success-90-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-90-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-90-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-success-90-border-subtle);\n  --bs-list-group-active-color: var(--bs-success-90-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-success-90-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-success-90-text-emphasis);\n}\n\n.list-group-item-success-100 {\n  --bs-list-group-color: var(--bs-success-100-text-emphasis);\n  --bs-list-group-bg: var(--bs-success-100-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-100-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-100-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-success-100-border-subtle);\n  --bs-list-group-active-color: var(--bs-success-100-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-success-100-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-success-100-text-emphasis);\n}\n\n.list-group-item-body-bg {\n  --bs-list-group-color: var(--bs-body-bg-text-emphasis);\n  --bs-list-group-bg: var(--bs-body-bg-bg-subtle);\n  --bs-list-group-border-color: var(--bs-body-bg-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-body-bg-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-body-bg-border-subtle);\n  --bs-list-group-active-color: var(--bs-body-bg-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-body-bg-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-body-bg-text-emphasis);\n}\n\n.list-group-item-danger-div {\n  --bs-list-group-color: var(--bs-danger-div-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-div-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-div-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-div-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-div-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-div-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-div-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-div-text-emphasis);\n}\n\n.list-group-item-danger-40 {\n  --bs-list-group-color: var(--bs-danger-40-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-40-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-40-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-40-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-40-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-40-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-40-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-40-text-emphasis);\n}\n\n.list-group-item-danger-50 {\n  --bs-list-group-color: var(--bs-danger-50-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-50-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-50-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-50-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-50-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-50-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-50-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-50-text-emphasis);\n}\n\n.list-group-item-danger-60 {\n  --bs-list-group-color: var(--bs-danger-60-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-60-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-60-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-60-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-60-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-60-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-60-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-60-text-emphasis);\n}\n\n.list-group-item-danger-70 {\n  --bs-list-group-color: var(--bs-danger-70-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-70-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-70-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-70-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-70-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-70-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-70-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-70-text-emphasis);\n}\n\n.list-group-item-danger-80 {\n  --bs-list-group-color: var(--bs-danger-80-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-80-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-80-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-80-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-80-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-80-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-80-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-80-text-emphasis);\n}\n\n.list-group-item-danger-90 {\n  --bs-list-group-color: var(--bs-danger-90-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-90-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-90-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-90-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-90-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-90-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-90-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-90-text-emphasis);\n}\n\n.list-group-item-danger-100 {\n  --bs-list-group-color: var(--bs-danger-100-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-100-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-100-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-100-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-100-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-100-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-100-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-100-text-emphasis);\n}\n\n.list-group-item-rating-color {\n  --bs-list-group-color: var(--bs-rating-color-text-emphasis);\n  --bs-list-group-bg: var(--bs-rating-color-bg-subtle);\n  --bs-list-group-border-color: var(--bs-rating-color-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-rating-color-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-rating-color-border-subtle);\n  --bs-list-group-active-color: var(--bs-rating-color-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-rating-color-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-rating-color-text-emphasis);\n}\n\n.list-group-item-card-bg-c {\n  --bs-list-group-color: var(--bs-card-bg-c-text-emphasis);\n  --bs-list-group-bg: var(--bs-card-bg-c-bg-subtle);\n  --bs-list-group-border-color: var(--bs-card-bg-c-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-card-bg-c-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-card-bg-c-border-subtle);\n  --bs-list-group-active-color: var(--bs-card-bg-c-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-card-bg-c-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-card-bg-c-text-emphasis);\n}\n\n.list-group-item-card-text-c {\n  --bs-list-group-color: var(--bs-card-text-c-text-emphasis);\n  --bs-list-group-bg: var(--bs-card-text-c-bg-subtle);\n  --bs-list-group-border-color: var(--bs-card-text-c-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-card-text-c-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-card-text-c-border-subtle);\n  --bs-list-group-active-color: var(--bs-card-text-c-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-card-text-c-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-card-text-c-text-emphasis);\n}\n\n.list-group-item-gary-light {\n  --bs-list-group-color: var(--bs-gary-light-text-emphasis);\n  --bs-list-group-bg: var(--bs-gary-light-bg-subtle);\n  --bs-list-group-border-color: var(--bs-gary-light-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-gary-light-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-gary-light-border-subtle);\n  --bs-list-group-active-color: var(--bs-gary-light-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-gary-light-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-gary-light-text-emphasis);\n}\n\n.list-group-item-border-color {\n  --bs-list-group-color: var(--bs-border-color-text-emphasis);\n  --bs-list-group-bg: var(--bs-border-color-bg-subtle);\n  --bs-list-group-border-color: var(--bs-border-color-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-border-color-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-border-color-border-subtle);\n  --bs-list-group-active-color: var(--bs-border-color-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-border-color-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-border-color-text-emphasis);\n}\n\n.list-group-item-border-color-50 {\n  --bs-list-group-color: var(--bs-border-color-50-text-emphasis);\n  --bs-list-group-bg: var(--bs-border-color-50-bg-subtle);\n  --bs-list-group-border-color: var(--bs-border-color-50-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-border-color-50-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-border-color-50-border-subtle);\n  --bs-list-group-active-color: var(--bs-border-color-50-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-border-color-50-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-border-color-50-text-emphasis);\n}\n\n.list-group-item-gray-100 {\n  --bs-list-group-color: var(--bs-gray-100-text-emphasis);\n  --bs-list-group-bg: var(--bs-gray-100-bg-subtle);\n  --bs-list-group-border-color: var(--bs-gray-100-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-gray-100-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-gray-100-border-subtle);\n  --bs-list-group-active-color: var(--bs-gray-100-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-gray-100-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-gray-100-text-emphasis);\n}\n\n.list-group-item-body-color-50 {\n  --bs-list-group-color: var(--bs-body-color-50-text-emphasis);\n  --bs-list-group-bg: var(--bs-body-color-50-bg-subtle);\n  --bs-list-group-border-color: var(--bs-body-color-50-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-body-color-50-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-body-color-50-border-subtle);\n  --bs-list-group-active-color: var(--bs-body-color-50-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-body-color-50-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-body-color-50-text-emphasis);\n}\n\n.list-group-item-body-color-60 {\n  --bs-list-group-color: var(--bs-body-color-60-text-emphasis);\n  --bs-list-group-bg: var(--bs-body-color-60-bg-subtle);\n  --bs-list-group-border-color: var(--bs-body-color-60-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-body-color-60-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-body-color-60-border-subtle);\n  --bs-list-group-active-color: var(--bs-body-color-60-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-body-color-60-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-body-color-60-text-emphasis);\n}\n\n.list-group-item-purple-100 {\n  --bs-list-group-color: var(--bs-purple-100-text-emphasis);\n  --bs-list-group-bg: var(--bs-purple-100-bg-subtle);\n  --bs-list-group-border-color: var(--bs-purple-100-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-purple-100-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-purple-100-border-subtle);\n  --bs-list-group-active-color: var(--bs-purple-100-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-purple-100-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-purple-100-text-emphasis);\n}\n\n.list-group-item-info-100 {\n  --bs-list-group-color: var(--bs-info-100-text-emphasis);\n  --bs-list-group-bg: var(--bs-info-100-bg-subtle);\n  --bs-list-group-border-color: var(--bs-info-100-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-info-100-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-info-100-border-subtle);\n  --bs-list-group-active-color: var(--bs-info-100-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-info-100-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-info-100-text-emphasis);\n}\n\n.btn-close {\n  --bs-btn-close-color: #000;\n  --bs-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/%3e%3c/svg%3e\");\n  --bs-btn-close-opacity: 0.5;\n  --bs-btn-close-hover-opacity: 0.75;\n  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(208, 143, 44, 0.25);\n  --bs-btn-close-focus-opacity: 1;\n  --bs-btn-close-disabled-opacity: 0.25;\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: var(--bs-btn-close-color);\n  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;\n  filter: var(--bs-btn-close-filter);\n  border: 0;\n  border-radius: 0.375rem;\n  opacity: var(--bs-btn-close-opacity);\n}\n\n.btn-close:hover {\n  color: var(--bs-btn-close-color);\n  text-decoration: none;\n  opacity: var(--bs-btn-close-hover-opacity);\n}\n\n.btn-close:focus {\n  outline: 0;\n  box-shadow: var(--bs-btn-close-focus-shadow);\n  opacity: var(--bs-btn-close-focus-opacity);\n}\n\n.btn-close:disabled,\n.btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: var(--bs-btn-close-disabled-opacity);\n}\n\n.btn-close-white {\n  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);\n}\n\n:root,\n[data-bs-theme=light] {\n  --bs-btn-close-filter: ;\n}\n\n[data-bs-theme=dark] {\n  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);\n}\n\n.toast {\n  --bs-toast-zindex: 1090;\n  --bs-toast-padding-x: 0.75rem;\n  --bs-toast-padding-y: 0.5rem;\n  --bs-toast-spacing: 1.5rem;\n  --bs-toast-max-width: 350px;\n  --bs-toast-font-size: 0.875rem;\n  --bs-toast-color: ;\n  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n  --bs-toast-border-width: var(--bs-border-width);\n  --bs-toast-border-color: var(--bs-border-color-translucent);\n  --bs-toast-border-radius: var(--bs-border-radius);\n  --bs-toast-box-shadow: var(--bs-box-shadow);\n  --bs-toast-header-color: var(--bs-secondary-color);\n  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);\n  --bs-toast-header-border-color: var(--bs-border-color-translucent);\n  width: var(--bs-toast-max-width);\n  max-width: 100%;\n  font-size: var(--bs-toast-font-size);\n  color: var(--bs-toast-color);\n  pointer-events: auto;\n  background-color: var(--bs-toast-bg);\n  background-clip: padding-box;\n  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\n  box-shadow: var(--bs-toast-box-shadow);\n  border-radius: var(--bs-toast-border-radius);\n}\n\n.toast.showing {\n  opacity: 0;\n}\n\n.toast:not(.show) {\n  display: none;\n}\n\n.toast-container {\n  --bs-toast-zindex: 1090;\n  position: absolute;\n  z-index: var(--bs-toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n\n.toast-container> :not(:last-child) {\n  margin-bottom: var(--bs-toast-spacing);\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\n  color: var(--bs-toast-header-color);\n  background-color: var(--bs-toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);\n  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n}\n\n.toast-header .btn-close {\n  margin-right: calc(-0.5 * var(--bs-toast-padding-x));\n  margin-left: var(--bs-toast-padding-x);\n}\n\n.toast-body {\n  padding: var(--bs-toast-padding-x);\n  word-wrap: break-word;\n}\n\n.modal {\n  --bs-modal-zindex: 1055;\n  --bs-modal-width: 500px;\n  --bs-modal-padding: 1rem;\n  --bs-modal-margin: 0.5rem;\n  --bs-modal-color: var(--bs-body-color);\n  --bs-modal-bg: var(--bs-body-bg);\n  --bs-modal-border-color: var(--bs-border-color-translucent);\n  --bs-modal-border-width: var(--bs-border-width);\n  --bs-modal-border-radius: var(--bs-border-radius-lg);\n  --bs-modal-box-shadow: var(--bs-box-shadow-sm);\n  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));\n  --bs-modal-header-padding-x: 1rem;\n  --bs-modal-header-padding-y: 1rem;\n  --bs-modal-header-padding: 1rem 1rem;\n  --bs-modal-header-border-color: var(--bs-border-color);\n  --bs-modal-header-border-width: var(--bs-border-width);\n  --bs-modal-title-line-height: 1.5;\n  --bs-modal-footer-gap: 0.5rem;\n  --bs-modal-footer-bg: ;\n  --bs-modal-footer-border-color: var(--bs-border-color);\n  --bs-modal-footer-border-width: var(--bs-border-width);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--bs-modal-margin);\n  pointer-events: none;\n}\n\n.modal.fade .modal-dialog {\n  transform: translate(0, -50px);\n  transition: transform 0.3s ease-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n\n.modal.show .modal-dialog {\n  transform: none;\n}\n\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: var(--bs-modal-color);\n  pointer-events: auto;\n  background-color: var(--bs-modal-bg);\n  background-clip: padding-box;\n  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n  border-radius: var(--bs-modal-border-radius);\n  outline: 0;\n}\n\n.modal-backdrop {\n  --bs-backdrop-zindex: 1050;\n  --bs-backdrop-bg: #000;\n  --bs-backdrop-opacity: 0.5;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-backdrop-zindex);\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bs-backdrop-bg);\n}\n\n.modal-backdrop.fade {\n  opacity: 0;\n}\n\n.modal-backdrop.show {\n  opacity: var(--bs-backdrop-opacity);\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--bs-modal-header-padding);\n  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);\n  border-top-left-radius: var(--bs-modal-inner-border-radius);\n  border-top-right-radius: var(--bs-modal-inner-border-radius);\n}\n\n.modal-header .btn-close {\n  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);\n  margin-top: calc(-0.5 * var(--bs-modal-header-padding-y));\n  margin-right: calc(-0.5 * var(--bs-modal-header-padding-x));\n  margin-bottom: calc(-0.5 * var(--bs-modal-header-padding-y));\n  margin-left: auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--bs-modal-title-line-height);\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: var(--bs-modal-padding);\n}\n\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);\n  background-color: var(--bs-modal-footer-bg);\n  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);\n  border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n  border-bottom-left-radius: var(--bs-modal-inner-border-radius);\n}\n\n.modal-footer>* {\n  margin: calc(var(--bs-modal-footer-gap) * 0.5);\n}\n\n@media (min-width: 576px) {\n  .modal {\n    --bs-modal-margin: 1.75rem;\n    --bs-modal-box-shadow: var(--bs-box-shadow);\n  }\n\n  .modal-dialog {\n    max-width: var(--bs-modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --bs-modal-width: 300px;\n  }\n}\n\n@media (min-width: 992px) {\n\n  .modal-lg,\n  .modal-xl {\n    --bs-modal-width: 800px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .modal-xl {\n    --bs-modal-width: 1140px;\n  }\n}\n\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n\n.modal-fullscreen .modal-header,\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-sm-down .modal-header,\n  .modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-md-down .modal-header,\n  .modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-lg-down .modal-header,\n  .modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-xl-down .modal-header,\n  .modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n\n@media (max-width: 1399.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-xxl-down .modal-header,\n  .modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.tooltip {\n  --bs-tooltip-zindex: 1080;\n  --bs-tooltip-max-width: 200px;\n  --bs-tooltip-padding-x: 0.5rem;\n  --bs-tooltip-padding-y: 0.25rem;\n  --bs-tooltip-margin: ;\n  --bs-tooltip-font-size: 0.77rem;\n  --bs-tooltip-color: var(--bs-body-bg);\n  --bs-tooltip-bg: var(--bs-emphasis-color);\n  --bs-tooltip-border-radius: var(--bs-border-radius);\n  --bs-tooltip-opacity: 0.9;\n  --bs-tooltip-arrow-width: 0.8rem;\n  --bs-tooltip-arrow-height: 0.4rem;\n  z-index: var(--bs-tooltip-zindex);\n  display: block;\n  margin: var(--bs-tooltip-margin);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-tooltip-font-size);\n  word-wrap: break-word;\n  opacity: 0;\n}\n\n.tooltip.show {\n  opacity: var(--bs-tooltip-opacity);\n}\n\n.tooltip .tooltip-arrow {\n  display: block;\n  width: var(--bs-tooltip-arrow-width);\n  height: var(--bs-tooltip-arrow-height);\n}\n\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n\n.bs-tooltip-top .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-top-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n\n.bs-tooltip-end .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-right-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.bs-tooltip-bottom .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n\n.bs-tooltip-bottom .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-bottom-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n\n.bs-tooltip-start .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-left-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.tooltip-inner {\n  max-width: var(--bs-tooltip-max-width);\n  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\n  color: var(--bs-tooltip-color);\n  text-align: center;\n  background-color: var(--bs-tooltip-bg);\n  border-radius: var(--bs-tooltip-border-radius);\n}\n\n.popover {\n  --bs-popover-zindex: 1070;\n  --bs-popover-max-width: 276px;\n  --bs-popover-font-size: 0.77rem;\n  --bs-popover-bg: var(--bs-body-bg);\n  --bs-popover-border-width: var(--bs-border-width);\n  --bs-popover-border-color: var(--bs-border-color-translucent);\n  --bs-popover-border-radius: var(--bs-border-radius-lg);\n  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));\n  --bs-popover-box-shadow: var(--bs-box-shadow);\n  --bs-popover-header-padding-x: 1rem;\n  --bs-popover-header-padding-y: 0.5rem;\n  --bs-popover-header-font-size: 0.88rem;\n  --bs-popover-header-color: inherit;\n  --bs-popover-header-bg: var(--bs-secondary-bg);\n  --bs-popover-body-padding-x: 1rem;\n  --bs-popover-body-padding-y: 1rem;\n  --bs-popover-body-color: var(--bs-body-color);\n  --bs-popover-arrow-width: 1rem;\n  --bs-popover-arrow-height: 0.5rem;\n  --bs-popover-arrow-border: var(--bs-popover-border-color);\n  z-index: var(--bs-popover-zindex);\n  display: block;\n  max-width: var(--bs-popover-max-width);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-popover-font-size);\n  word-wrap: break-word;\n  background-color: var(--bs-popover-bg);\n  background-clip: padding-box;\n  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-radius: var(--bs-popover-border-radius);\n}\n\n.popover .popover-arrow {\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  height: var(--bs-popover-arrow-height);\n}\n\n.popover .popover-arrow::before,\n.popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n  border-width: 0;\n}\n\n.bs-popover-top>.popover-arrow,\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow {\n  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n\n.bs-popover-top>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before,\n.bs-popover-top>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after {\n  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n\n.bs-popover-top>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::before {\n  bottom: 0;\n  border-top-color: var(--bs-popover-arrow-border);\n}\n\n.bs-popover-top>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after {\n  bottom: var(--bs-popover-border-width);\n  border-top-color: var(--bs-popover-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end>.popover-arrow,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow {\n  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n\n.bs-popover-end>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before,\n.bs-popover-end>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n\n.bs-popover-end>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::before {\n  left: 0;\n  border-right-color: var(--bs-popover-arrow-border);\n}\n\n.bs-popover-end>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=right]>.popover-arrow::after {\n  left: var(--bs-popover-border-width);\n  border-right-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.bs-popover-bottom>.popover-arrow,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow {\n  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n\n.bs-popover-bottom>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before,\n.bs-popover-bottom>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after {\n  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n\n.bs-popover-bottom>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::before {\n  top: 0;\n  border-bottom-color: var(--bs-popover-arrow-border);\n}\n\n.bs-popover-bottom>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=bottom]>.popover-arrow::after {\n  top: var(--bs-popover-border-width);\n  border-bottom-color: var(--bs-popover-bg);\n}\n\n.bs-popover-bottom .popover-header::before,\n.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));\n  content: \"\";\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start>.popover-arrow,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow {\n  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n\n.bs-popover-start>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before,\n.bs-popover-start>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n\n.bs-popover-start>.popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::before {\n  right: 0;\n  border-left-color: var(--bs-popover-arrow-border);\n}\n\n.bs-popover-start>.popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=left]>.popover-arrow::after {\n  right: var(--bs-popover-border-width);\n  border-left-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.popover-header {\n  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);\n  margin-bottom: 0;\n  font-size: var(--bs-popover-header-font-size);\n  color: var(--bs-popover-header-color);\n  background-color: var(--bs-popover-header-bg);\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-top-left-radius: var(--bs-popover-inner-border-radius);\n  border-top-right-radius: var(--bs-popover-inner-border-radius);\n}\n\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);\n  color: var(--bs-popover-body-color);\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .carousel-fade .active.carousel-item-start,\n  .carousel-fade .active.carousel-item-end {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #fff;\n  text-align: center;\n  background: none;\n  filter: var(--bs-carousel-control-icon-filter);\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n\n.carousel-control-prev:hover,\n.carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e\")\n    /*rtl:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e\")*/\n  ;\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e\")\n    /*rtl:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e\")*/\n  ;\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n}\n\n.carousel-indicators [data-bs-target] {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: var(--bs-carousel-indicator-active-bg);\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators [data-bs-target] {\n    transition: none;\n  }\n}\n\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: var(--bs-carousel-caption-color);\n  text-align: center;\n}\n\n.carousel-dark {\n  --bs-carousel-indicator-active-bg: #000;\n  --bs-carousel-caption-color: #000;\n  --bs-carousel-control-icon-filter: invert(1) grayscale(100);\n}\n\n:root,\n[data-bs-theme=light] {\n  --bs-carousel-indicator-active-bg: #fff;\n  --bs-carousel-caption-color: #fff;\n  --bs-carousel-control-icon-filter: ;\n}\n\n[data-bs-theme=dark] {\n  --bs-carousel-indicator-active-bg: #000;\n  --bs-carousel-caption-color: #000;\n  --bs-carousel-control-icon-filter: invert(1) grayscale(100);\n}\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--bs-spinner-width);\n  height: var(--bs-spinner-height);\n  vertical-align: var(--bs-spinner-vertical-align);\n  border-radius: 50%;\n  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg)\n      /* rtl:ignore */\n    ;\n  }\n}\n\n.spinner-border {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-border-width: 0.25em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-border;\n  border: var(--bs-spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n  --bs-spinner-border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-animation-speed: 0.75s;\n  --bs-spinner-animation-name: spinner-grow;\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n\n  .spinner-border,\n  .spinner-grow {\n    --bs-spinner-animation-speed: 1.5s;\n  }\n}\n\n.offcanvas,\n.offcanvas-xxl,\n.offcanvas-xl,\n.offcanvas-lg,\n.offcanvas-md,\n.offcanvas-sm {\n  --bs-offcanvas-zindex: 1045;\n  --bs-offcanvas-width: 400px;\n  --bs-offcanvas-height: 30vh;\n  --bs-offcanvas-padding-x: 1rem;\n  --bs-offcanvas-padding-y: 1rem;\n  --bs-offcanvas-color: var(--bs-body-color);\n  --bs-offcanvas-bg: var(--bs-body-bg);\n  --bs-offcanvas-border-width: var(--bs-border-width);\n  --bs-offcanvas-border-color: var(--bs-border-color-translucent);\n  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);\n  --bs-offcanvas-transition: transform 0.3s ease-in-out;\n  --bs-offcanvas-title-line-height: 1.5;\n}\n\n@media (max-width: 575.98px) {\n  .offcanvas-sm {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-sm {\n    transition: none;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n\n  .offcanvas-sm.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n\n  .offcanvas-sm.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n\n  .offcanvas-sm.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n\n  .offcanvas-sm.showing,\n  .offcanvas-sm.show:not(.hiding) {\n    transform: none;\n  }\n\n  .offcanvas-sm.showing,\n  .offcanvas-sm.hiding,\n  .offcanvas-sm.show {\n    visibility: visible;\n  }\n}\n\n@media (min-width: 576px) {\n  .offcanvas-sm {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n\n  .offcanvas-sm .offcanvas-header {\n    display: none;\n  }\n\n  .offcanvas-sm .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .offcanvas-md {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n\n@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-md {\n    transition: none;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n\n  .offcanvas-md.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n\n  .offcanvas-md.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n\n  .offcanvas-md.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n\n  .offcanvas-md.showing,\n  .offcanvas-md.show:not(.hiding) {\n    transform: none;\n  }\n\n  .offcanvas-md.showing,\n  .offcanvas-md.hiding,\n  .offcanvas-md.show {\n    visibility: visible;\n  }\n}\n\n@media (min-width: 768px) {\n  .offcanvas-md {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n\n  .offcanvas-md .offcanvas-header {\n    display: none;\n  }\n\n  .offcanvas-md .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .offcanvas-lg {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n\n@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-lg {\n    transition: none;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n\n  .offcanvas-lg.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n\n  .offcanvas-lg.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n\n  .offcanvas-lg.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n\n  .offcanvas-lg.showing,\n  .offcanvas-lg.show:not(.hiding) {\n    transform: none;\n  }\n\n  .offcanvas-lg.showing,\n  .offcanvas-lg.hiding,\n  .offcanvas-lg.show {\n    visibility: visible;\n  }\n}\n\n@media (min-width: 992px) {\n  .offcanvas-lg {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n\n  .offcanvas-lg .offcanvas-header {\n    display: none;\n  }\n\n  .offcanvas-lg .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .offcanvas-xl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n\n@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xl {\n    transition: none;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n\n  .offcanvas-xl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n\n  .offcanvas-xl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n\n  .offcanvas-xl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n\n  .offcanvas-xl.showing,\n  .offcanvas-xl.show:not(.hiding) {\n    transform: none;\n  }\n\n  .offcanvas-xl.showing,\n  .offcanvas-xl.hiding,\n  .offcanvas-xl.show {\n    visibility: visible;\n  }\n}\n\n@media (min-width: 1200px) {\n  .offcanvas-xl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n\n  .offcanvas-xl .offcanvas-header {\n    display: none;\n  }\n\n  .offcanvas-xl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n\n@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xxl {\n    transition: none;\n  }\n}\n\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n\n  .offcanvas-xxl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n\n  .offcanvas-xxl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n\n  .offcanvas-xxl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n\n  .offcanvas-xxl.showing,\n  .offcanvas-xxl.show:not(.hiding) {\n    transform: none;\n  }\n\n  .offcanvas-xxl.showing,\n  .offcanvas-xxl.hiding,\n  .offcanvas-xxl.show {\n    visibility: visible;\n  }\n}\n\n@media (min-width: 1400px) {\n  .offcanvas-xxl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n\n  .offcanvas-xxl .offcanvas-header {\n    display: none;\n  }\n\n  .offcanvas-xxl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n.offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: var(--bs-offcanvas-zindex);\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: var(--bs-offcanvas-color);\n  visibility: hidden;\n  background-color: var(--bs-offcanvas-bg);\n  background-clip: padding-box;\n  outline: 0;\n  transition: var(--bs-offcanvas-transition);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .offcanvas {\n    transition: none;\n  }\n}\n\n.offcanvas.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: var(--bs-offcanvas-width);\n  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(-100%);\n}\n\n.offcanvas.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: var(--bs-offcanvas-width);\n  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(100%);\n}\n\n.offcanvas.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(-100%);\n}\n\n.offcanvas.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(100%);\n}\n\n.offcanvas.showing,\n.offcanvas.show:not(.hiding) {\n  transform: none;\n}\n\n.offcanvas.showing,\n.offcanvas.hiding,\n.offcanvas.show {\n  visibility: visible;\n}\n\n.offcanvas-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n}\n\n.offcanvas-backdrop.fade {\n  opacity: 0;\n}\n\n.offcanvas-backdrop.show {\n  opacity: 0.5;\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n}\n\n.offcanvas-header .btn-close {\n  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);\n  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));\n  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));\n  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));\n  margin-left: auto;\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--bs-offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n  overflow-y: auto;\n}\n\n.placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: 0.5;\n}\n\n.placeholder.btn::before {\n  display: inline-block;\n  content: \"\";\n}\n\n.placeholder-xs {\n  min-height: 0.6em;\n}\n\n.placeholder-sm {\n  min-height: 0.8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n.placeholder-glow .placeholder {\n  animation: placeholder-glow 2s ease-in-out infinite;\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: 0.2;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.text-bg-primary {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-secondary {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-info {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-warning {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-dark {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-primary-div {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-primary-div-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-primary-div-50 {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-primary-div-50-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-primary-div-60 {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-primary-div-60-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-primary-50 {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-primary-50-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-primary-60 {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-primary-60-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-primary-70 {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-primary-70-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success-50 {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-success-50-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success-60 {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-success-60-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success-70 {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-success-70-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success-80 {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-success-80-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success-90 {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-success-90-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success-100 {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-success-100-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-body-bg {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-body-bg-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger-div {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-danger-div-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger-40 {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-danger-40-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger-50 {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-danger-50-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger-60 {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-danger-60-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger-70 {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-danger-70-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger-80 {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-danger-80-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger-90 {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-danger-90-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger-100 {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-danger-100-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-rating-color {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-rating-color-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-card-bg-c {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-card-bg-c-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-card-text-c {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-card-text-c-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-gary-light {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-gary-light-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-border-color {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-border-color-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-border-color-50 {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-border-color-50-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-gray-100 {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-gray-100-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-body-color-50 {\n  color: #fff !important;\n  background-color: RGBA(var(--bs-body-color-50-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-body-color-60 {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-body-color-60-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-purple-100 {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-purple-100-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-info-100 {\n  color: #000 !important;\n  background-color: RGBA(var(--bs-info-100-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.link-primary {\n  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-primary:hover,\n.link-primary:focus {\n  color: RGBA(217, 165, 86, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(217, 165, 86, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-secondary {\n  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-secondary:hover,\n.link-secondary:focus {\n  color: RGBA(46, 53, 66, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(46, 53, 66, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success {\n  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success:hover,\n.link-success:focus {\n  color: RGBA(95, 224, 59, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(95, 224, 59, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-info {\n  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-info:hover,\n.link-info:focus {\n  color: RGBA(87, 197, 247, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(87, 197, 247, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-warning {\n  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-warning:hover,\n.link-warning:focus {\n  color: RGBA(255, 201, 85, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 201, 85, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger {\n  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger:hover,\n.link-danger:focus {\n  color: RGBA(253, 121, 65, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(253, 121, 65, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light {\n  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-light:hover,\n.link-light:focus {\n  color: RGBA(221, 225, 232, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(221, 225, 232, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-dark {\n  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-dark:hover,\n.link-dark:focus {\n  color: RGBA(0, 0, 0, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(0, 0, 0, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-primary-div {\n  color: RGBA(var(--bs-primary-div-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-div-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-primary-div:hover,\n.link-primary-div:focus {\n  color: RGBA(217, 165, 86, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(217, 165, 86, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-primary-div-50 {\n  color: RGBA(var(--bs-primary-div-50-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-div-50-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-primary-div-50:hover,\n.link-primary-div-50:focus {\n  color: RGBA(193, 150, 81, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(193, 150, 81, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-primary-div-60 {\n  color: RGBA(var(--bs-primary-div-60-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-div-60-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-primary-div-60:hover,\n.link-primary-div-60:focus {\n  color: RGBA(118, 84, 26, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(118, 84, 26, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-primary-50 {\n  color: RGBA(var(--bs-primary-50-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-50-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-primary-50:hover,\n.link-primary-50:focus {\n  color: RGBA(193, 150, 81, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(193, 150, 81, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-primary-60 {\n  color: RGBA(var(--bs-primary-60-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-60-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-primary-60:hover,\n.link-primary-60:focus {\n  color: RGBA(118, 84, 26, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(118, 84, 26, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-primary-70 {\n  color: RGBA(var(--bs-primary-70-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-70-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-primary-70:hover,\n.link-primary-70:focus {\n  color: RGBA(94, 69, 21, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(94, 69, 21, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success-50 {\n  color: RGBA(var(--bs-success-50-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-50-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success-50:hover,\n.link-success-50:focus {\n  color: RGBA(24, 105, 6, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(24, 105, 6, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success-60 {\n  color: RGBA(var(--bs-success-60-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-60-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success-60:hover,\n.link-success-60:focus {\n  color: RGBA(81, 192, 53, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(81, 192, 53, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success-70 {\n  color: RGBA(var(--bs-success-70-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-70-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success-70:hover,\n.link-success-70:focus {\n  color: RGBA(155, 253, 123, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(155, 253, 123, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success-80 {\n  color: RGBA(var(--bs-success-80-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-80-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success-80:hover,\n.link-success-80:focus {\n  color: RGBA(224, 255, 211, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(224, 255, 211, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success-90 {\n  color: RGBA(var(--bs-success-90-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-90-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success-90:hover,\n.link-success-90:focus {\n  color: RGBA(241, 255, 234, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(241, 255, 234, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success-100 {\n  color: RGBA(var(--bs-success-100-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-100-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success-100:hover,\n.link-success-100:focus {\n  color: RGBA(224, 255, 211, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(224, 255, 211, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-bg {\n  color: RGBA(var(--bs-body-bg-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-body-bg-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-bg:hover,\n.link-body-bg:focus {\n  color: RGBA(248, 249, 250, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(248, 249, 250, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger-div {\n  color: RGBA(var(--bs-danger-div-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-div-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger-div:hover,\n.link-danger-div:focus {\n  color: RGBA(255, 241, 177, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 241, 177, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger-40 {\n  color: RGBA(var(--bs-danger-40-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-40-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger-40:hover,\n.link-danger-40:focus {\n  color: RGBA(172, 22, 0, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(172, 22, 0, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger-50 {\n  color: RGBA(var(--bs-danger-50-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-50-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger-50:hover,\n.link-danger-50:focus {\n  color: RGBA(241, 101, 57, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(241, 101, 57, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger-60 {\n  color: RGBA(var(--bs-danger-60-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-60-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger-60:hover,\n.link-danger-60:focus {\n  color: RGBA(240, 76, 51, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(240, 76, 51, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger-70 {\n  color: RGBA(var(--bs-danger-70-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-70-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger-70:hover,\n.link-danger-70:focus {\n  color: RGBA(255, 231, 228, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 231, 228, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger-80 {\n  color: RGBA(var(--bs-danger-80-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-80-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger-80:hover,\n.link-danger-80:focus {\n  color: RGBA(255, 102, 79, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 102, 79, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger-90 {\n  color: RGBA(var(--bs-danger-90-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-90-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger-90:hover,\n.link-danger-90:focus {\n  color: RGBA(158, 34, 7, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(158, 34, 7, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger-100 {\n  color: RGBA(var(--bs-danger-100-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-100-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger-100:hover,\n.link-danger-100:focus {\n  color: RGBA(255, 231, 228, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 231, 228, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-rating-color {\n  color: RGBA(var(--bs-rating-color-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-rating-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-rating-color:hover,\n.link-rating-color:focus {\n  color: RGBA(254, 149, 94, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(254, 149, 94, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-card-bg-c {\n  color: RGBA(var(--bs-card-bg-c-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-card-bg-c-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-card-bg-c:hover,\n.link-card-bg-c:focus {\n  color: RGBA(93, 157, 253, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(93, 157, 253, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-card-text-c {\n  color: RGBA(var(--bs-card-text-c-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-card-text-c-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-card-text-c:hover,\n.link-card-text-c:focus {\n  color: RGBA(255, 237, 221, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(255, 237, 221, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-gary-light {\n  color: RGBA(var(--bs-gary-light-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-gary-light-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-gary-light:hover,\n.link-gary-light:focus {\n  color: RGBA(246, 248, 253, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(246, 248, 253, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-border-color {\n  color: RGBA(var(--bs-border-color-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-border-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-border-color:hover,\n.link-border-color:focus {\n  color: RGBA(240, 241, 245, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(240, 241, 245, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-border-color-50 {\n  color: RGBA(var(--bs-border-color-50-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-border-color-50-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-border-color-50:hover,\n.link-border-color-50:focus {\n  color: RGBA(240, 243, 255, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(240, 243, 255, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-gray-100 {\n  color: RGBA(var(--bs-gray-100-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-gray-100-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-gray-100:hover,\n.link-gray-100:focus {\n  color: RGBA(247, 249, 249, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(247, 249, 249, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-color-50 {\n  color: RGBA(var(--bs-body-color-50-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-body-color-50-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-color-50:hover,\n.link-body-color-50:focus {\n  color: RGBA(66, 77, 95, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(66, 77, 95, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-color-60 {\n  color: RGBA(var(--bs-body-color-60-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-body-color-60-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-color-60:hover,\n.link-body-color-60:focus {\n  color: RGBA(158, 170, 187, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(158, 170, 187, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-purple-100 {\n  color: RGBA(var(--bs-purple-100-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-purple-100-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-purple-100:hover,\n.link-purple-100:focus {\n  color: RGBA(245, 237, 255, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(245, 237, 255, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-info-100 {\n  color: RGBA(var(--bs-info-100-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-info-100-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-info-100:hover,\n.link-info-100:focus {\n  color: RGBA(225, 239, 255, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(225, 239, 255, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-emphasis {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-emphasis:hover,\n.link-body-emphasis:focus {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;\n}\n\n.focus-ring:focus {\n  outline: 0;\n  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);\n}\n\n.icon-link {\n  display: inline-flex;\n  gap: 0.375rem;\n  align-items: center;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));\n  text-underline-offset: 0.25em;\n  backface-visibility: hidden;\n}\n\n.icon-link>.bi {\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  fill: currentcolor;\n  transition: 0.2s ease-in-out transform;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .icon-link>.bi {\n    transition: none;\n  }\n}\n\n.icon-link-hover:hover>.bi,\n.icon-link-hover:focus-visible>.bi {\n  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n\n.ratio>* {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n.sticky-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-sm-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-md-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-lg-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-xl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-xxl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.visually-hidden:not(caption),\n.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {\n  position: absolute !important;\n}\n\n.visually-hidden *,\n.visually-hidden-focusable:not(:focus):not(:focus-within) * {\n  overflow: hidden !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: var(--bs-border-width);\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.object-fit-contain {\n  object-fit: contain !important;\n}\n\n.object-fit-cover {\n  object-fit: cover !important;\n}\n\n.object-fit-fill {\n  object-fit: fill !important;\n}\n\n.object-fit-scale {\n  object-fit: scale-down !important;\n}\n\n.object-fit-none {\n  object-fit: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden !important;\n}\n\n.overflow-x-visible {\n  overflow-x: visible !important;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden !important;\n}\n\n.overflow-y-visible {\n  overflow-y: visible !important;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-inline-grid {\n  display: inline-grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: var(--bs-box-shadow) !important;\n}\n\n.shadow-sm {\n  box-shadow: var(--bs-box-shadow-sm) !important;\n}\n\n.shadow-lg {\n  box-shadow: var(--bs-box-shadow-lg) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.focus-ring-primary {\n  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-secondary {\n  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success {\n  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-info {\n  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-warning {\n  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger {\n  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-light {\n  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-dark {\n  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-primary-div {\n  --bs-focus-ring-color: rgba(var(--bs-primary-div-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-primary-div-50 {\n  --bs-focus-ring-color: rgba(var(--bs-primary-div-50-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-primary-div-60 {\n  --bs-focus-ring-color: rgba(var(--bs-primary-div-60-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-primary-50 {\n  --bs-focus-ring-color: rgba(var(--bs-primary-50-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-primary-60 {\n  --bs-focus-ring-color: rgba(var(--bs-primary-60-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-primary-70 {\n  --bs-focus-ring-color: rgba(var(--bs-primary-70-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success-50 {\n  --bs-focus-ring-color: rgba(var(--bs-success-50-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success-60 {\n  --bs-focus-ring-color: rgba(var(--bs-success-60-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success-70 {\n  --bs-focus-ring-color: rgba(var(--bs-success-70-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success-80 {\n  --bs-focus-ring-color: rgba(var(--bs-success-80-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success-90 {\n  --bs-focus-ring-color: rgba(var(--bs-success-90-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success-100 {\n  --bs-focus-ring-color: rgba(var(--bs-success-100-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-body-bg {\n  --bs-focus-ring-color: rgba(var(--bs-body-bg-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger-div {\n  --bs-focus-ring-color: rgba(var(--bs-danger-div-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger-40 {\n  --bs-focus-ring-color: rgba(var(--bs-danger-40-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger-50 {\n  --bs-focus-ring-color: rgba(var(--bs-danger-50-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger-60 {\n  --bs-focus-ring-color: rgba(var(--bs-danger-60-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger-70 {\n  --bs-focus-ring-color: rgba(var(--bs-danger-70-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger-80 {\n  --bs-focus-ring-color: rgba(var(--bs-danger-80-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger-90 {\n  --bs-focus-ring-color: rgba(var(--bs-danger-90-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger-100 {\n  --bs-focus-ring-color: rgba(var(--bs-danger-100-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-rating-color {\n  --bs-focus-ring-color: rgba(var(--bs-rating-color-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-card-bg-c {\n  --bs-focus-ring-color: rgba(var(--bs-card-bg-c-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-card-text-c {\n  --bs-focus-ring-color: rgba(var(--bs-card-text-c-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-gary-light {\n  --bs-focus-ring-color: rgba(var(--bs-gary-light-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-border-color {\n  --bs-focus-ring-color: rgba(var(--bs-border-color-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-border-color-50 {\n  --bs-focus-ring-color: rgba(var(--bs-border-color-50-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-gray-100 {\n  --bs-focus-ring-color: rgba(var(--bs-gray-100-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-body-color-50 {\n  --bs-focus-ring-color: rgba(var(--bs-body-color-50-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-body-color-60 {\n  --bs-focus-ring-color: rgba(var(--bs-body-color-60-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-purple-100 {\n  --bs-focus-ring-color: rgba(var(--bs-purple-100-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-info-100 {\n  --bs-focus-ring-color: rgba(var(--bs-info-100-rgb), var(--bs-focus-ring-opacity));\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-secondary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-info {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-warning {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-light {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-dark {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-div {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-div-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-div-50 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-div-50-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-div-60 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-div-60-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-50 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-50-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-60 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-60-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-70 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-70-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success-50 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-50-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success-60 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-60-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success-70 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-70-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success-80 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-80-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success-90 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-90-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success-100 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-100-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-body-bg {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-body-bg-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger-div {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-div-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger-40 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-40-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger-50 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-50-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger-60 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-60-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger-70 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-70-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger-80 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-80-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger-90 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-90-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger-100 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-100-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-rating-color {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-rating-color-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-card-bg-c {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-card-bg-c-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-card-text-c {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-card-text-c-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-gary-light {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-gary-light-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-border-color {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-border-color-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-border-color-50 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-border-color-50-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-gray-100 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-gray-100-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-body-color-50 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-body-color-50-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-body-color-60 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-body-color-60-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-purple-100 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-purple-100-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-info-100 {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-info-100-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-black {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-white {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-subtle {\n  border-color: var(--bs-primary-border-subtle) !important;\n}\n\n.border-secondary-subtle {\n  border-color: var(--bs-secondary-border-subtle) !important;\n}\n\n.border-success-subtle {\n  border-color: var(--bs-success-border-subtle) !important;\n}\n\n.border-info-subtle {\n  border-color: var(--bs-info-border-subtle) !important;\n}\n\n.border-warning-subtle {\n  border-color: var(--bs-warning-border-subtle) !important;\n}\n\n.border-danger-subtle {\n  border-color: var(--bs-danger-border-subtle) !important;\n}\n\n.border-light-subtle {\n  border-color: var(--bs-light-border-subtle) !important;\n}\n\n.border-dark-subtle {\n  border-color: var(--bs-dark-border-subtle) !important;\n}\n\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.border-opacity-10 {\n  --bs-border-opacity: 0.1;\n}\n\n.border-opacity-25 {\n  --bs-border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n  --bs-border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n  --bs-border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n  --bs-border-opacity: 1;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 3rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mx-3 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n\n.mx-4 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-5 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-4 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-5 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 1rem !important;\n}\n\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.25rem !important;\n}\n\n.me-2 {\n  margin-right: 0.5rem !important;\n}\n\n.me-3 {\n  margin-right: 1rem !important;\n}\n\n.me-4 {\n  margin-right: 1.5rem !important;\n}\n\n.me-5 {\n  margin-right: 3rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.25rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.5rem !important;\n}\n\n.ms-3 {\n  margin-left: 1rem !important;\n}\n\n.ms-4 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-5 {\n  margin-left: 3rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.px-3 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.px-4 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-5 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-4 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-5 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-3 {\n  padding-top: 1rem !important;\n}\n\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-5 {\n  padding-top: 3rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pe-3 {\n  padding-right: 1rem !important;\n}\n\n.pe-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-5 {\n  padding-right: 3rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 3rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.25rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.5rem !important;\n}\n\n.ps-3 {\n  padding-left: 1rem !important;\n}\n\n.ps-4 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-5 {\n  padding-left: 3rem !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.25rem !important;\n}\n\n.gap-2 {\n  gap: 0.5rem !important;\n}\n\n.gap-3 {\n  gap: 1rem !important;\n}\n\n.gap-4 {\n  gap: 1.5rem !important;\n}\n\n.gap-5 {\n  gap: 3rem !important;\n}\n\n.row-gap-0 {\n  row-gap: 0 !important;\n}\n\n.row-gap-1 {\n  row-gap: 0.25rem !important;\n}\n\n.row-gap-2 {\n  row-gap: 0.5rem !important;\n}\n\n.row-gap-3 {\n  row-gap: 1rem !important;\n}\n\n.row-gap-4 {\n  row-gap: 1.5rem !important;\n}\n\n.row-gap-5 {\n  row-gap: 3rem !important;\n}\n\n.column-gap-0 {\n  column-gap: 0 !important;\n}\n\n.column-gap-1 {\n  column-gap: 0.25rem !important;\n}\n\n.column-gap-2 {\n  column-gap: 0.5rem !important;\n}\n\n.column-gap-3 {\n  column-gap: 1rem !important;\n}\n\n.column-gap-4 {\n  column-gap: 1.5rem !important;\n}\n\n.column-gap-5 {\n  column-gap: 3rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.345rem + 1.14vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.3274rem + 0.9288vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.2834rem + 0.4008vw) !important;\n}\n\n.fs-4 {\n  font-size: 1.232rem !important;\n}\n\n.fs-5 {\n  font-size: 0.88rem !important;\n}\n\n.fs-6 {\n  font-size: 0.88rem !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-medium {\n  font-weight: 500 !important;\n}\n\n.fw-semibold {\n  font-weight: 600 !important;\n}\n\n.fw-bold {\n  font-weight: 700 !important;\n}\n\n.fw-bolder {\n  font-weight: bolder !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 2 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-primary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-primary-div {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-div-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-primary-div-50 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-div-50-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-primary-div-60 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-div-60-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-primary-50 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-50-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-primary-60 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-60-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-primary-70 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-70-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success-50 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-50-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success-60 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-60-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success-70 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-70-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success-80 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-80-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success-90 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-90-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success-100 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-100-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body-bg {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-bg-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger-div {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-div-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger-40 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-40-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger-50 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-50-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger-60 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-60-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger-70 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-70-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger-80 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-80-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger-90 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-90-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger-100 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-100-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-rating-color {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-rating-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-card-bg-c {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-card-bg-c-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-card-text-c {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-card-text-c-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-gary-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-gary-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-border-color {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-border-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-border-color-50 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-border-color-50-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-gray-100 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-gray-100-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body-color-50 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-50-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body-color-60 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-60-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-purple-100 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-purple-100-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info-100 {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-100-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-white {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-body-secondary {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-body-tertiary {\n  --bs-text-opacity: 1;\n  color: var(--bs-tertiary-color) !important;\n}\n\n.text-body-emphasis {\n  --bs-text-opacity: 1;\n  color: var(--bs-emphasis-color) !important;\n}\n\n.text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.text-primary-emphasis {\n  color: var(--bs-primary-text-emphasis) !important;\n}\n\n.text-secondary-emphasis {\n  color: var(--bs-secondary-text-emphasis) !important;\n}\n\n.text-success-emphasis {\n  color: var(--bs-success-text-emphasis) !important;\n}\n\n.text-info-emphasis {\n  color: var(--bs-info-text-emphasis) !important;\n}\n\n.text-warning-emphasis {\n  color: var(--bs-warning-text-emphasis) !important;\n}\n\n.text-danger-emphasis {\n  color: var(--bs-danger-text-emphasis) !important;\n}\n\n.text-light-emphasis {\n  color: var(--bs-light-text-emphasis) !important;\n}\n\n.text-dark-emphasis {\n  color: var(--bs-dark-text-emphasis) !important;\n}\n\n.link-opacity-10 {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-10-hover:hover {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-25 {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-25-hover:hover {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-50 {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-50-hover:hover {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-75 {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-75-hover:hover {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-100 {\n  --bs-link-opacity: 1;\n}\n\n.link-opacity-100-hover:hover {\n  --bs-link-opacity: 1;\n}\n\n.link-offset-1 {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-1-hover:hover {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-2 {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-2-hover:hover {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-3 {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-offset-3-hover:hover {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-underline-primary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-secondary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-info {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-warning {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-light {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-dark {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-primary-div {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-div-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-primary-div-50 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-div-50-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-primary-div-60 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-div-60-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-primary-50 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-50-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-primary-60 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-60-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-primary-70 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-70-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success-50 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-50-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success-60 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-60-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success-70 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-70-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success-80 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-80-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success-90 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-90-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success-100 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-100-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-body-bg {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-body-bg-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger-div {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-div-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger-40 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-40-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger-50 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-50-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger-60 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-60-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger-70 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-70-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger-80 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-80-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger-90 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-90-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger-100 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-100-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-rating-color {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-rating-color-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-card-bg-c {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-card-bg-c-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-card-text-c {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-card-text-c-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-gary-light {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-gary-light-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-border-color {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-border-color-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-border-color-50 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-border-color-50-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-gray-100 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-gray-100-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-body-color-50 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-body-color-50-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-body-color-60 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-body-color-60-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-purple-100 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-purple-100-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-info-100 {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-info-100-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-underline-opacity-0 {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-0-hover:hover {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-10 {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-10-hover:hover {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-25 {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-25-hover:hover {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-50 {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-50-hover:hover {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-75 {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-75-hover:hover {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-100 {\n  --bs-link-underline-opacity: 1;\n}\n\n.link-underline-opacity-100-hover:hover {\n  --bs-link-underline-opacity: 1;\n}\n\n.bg-primary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary-div {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-div-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary-div-50 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-div-50-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary-div-60 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-div-60-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary-50 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-50-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary-60 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-60-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary-70 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-70-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success-50 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-50-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success-60 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-60-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success-70 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-70-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success-80 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-80-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success-90 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-90-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-100-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body-bg {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger-div {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-div-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger-40 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-40-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger-50 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-50-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger-60 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-60-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger-70 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-70-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger-80 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-80-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger-90 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-90-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-100-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-rating-color {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-rating-color-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-card-bg-c {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-card-bg-c-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-card-text-c {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-card-text-c-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-gary-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-gary-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-border-color {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-border-color-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-border-color-50 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-border-color-50-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-gray-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-gray-100-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body-color-50 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-color-50-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body-color-60 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-color-60-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-purple-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-purple-100-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info-100 {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-100-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-body-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body-tertiary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-primary-subtle {\n  background-color: var(--bs-primary-bg-subtle) !important;\n}\n\n.bg-secondary-subtle {\n  background-color: var(--bs-secondary-bg-subtle) !important;\n}\n\n.bg-success-subtle {\n  background-color: var(--bs-success-bg-subtle) !important;\n}\n\n.bg-info-subtle {\n  background-color: var(--bs-info-bg-subtle) !important;\n}\n\n.bg-warning-subtle {\n  background-color: var(--bs-warning-bg-subtle) !important;\n}\n\n.bg-danger-subtle {\n  background-color: var(--bs-danger-bg-subtle) !important;\n}\n\n.bg-light-subtle {\n  background-color: var(--bs-light-bg-subtle) !important;\n}\n\n.bg-dark-subtle {\n  background-color: var(--bs-dark-bg-subtle) !important;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-2 {\n  border-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-3 {\n  border-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-4 {\n  border-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-5 {\n  border-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-top {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-top-1 {\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-top-2 {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-3 {\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-top-4 {\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-top-5 {\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-top-circle {\n  border-top-left-radius: 50% !important;\n  border-top-right-radius: 50% !important;\n}\n\n.rounded-top-pill {\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-end {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-end-1 {\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-end-2 {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-3 {\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-end-4 {\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-end-5 {\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-end-circle {\n  border-top-right-radius: 50% !important;\n  border-bottom-right-radius: 50% !important;\n}\n\n.rounded-end-pill {\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-bottom-1 {\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-bottom-2 {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-3 {\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-bottom-4 {\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-bottom-5 {\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-bottom-circle {\n  border-bottom-right-radius: 50% !important;\n  border-bottom-left-radius: 50% !important;\n}\n\n.rounded-bottom-pill {\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-0 {\n  border-bottom-left-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n\n.rounded-start-1 {\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-start-2 {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-3 {\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-start-4 {\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-start-5 {\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-start-circle {\n  border-bottom-left-radius: 50% !important;\n  border-top-left-radius: 50% !important;\n}\n\n.rounded-start-pill {\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n.z-n1 {\n  z-index: -1 !important;\n}\n\n.z-0 {\n  z-index: 0 !important;\n}\n\n.z-1 {\n  z-index: 1 !important;\n}\n\n.z-2 {\n  z-index: 2 !important;\n}\n\n.z-3 {\n  z-index: 3 !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n\n  .float-sm-end {\n    float: right !important;\n  }\n\n  .float-sm-none {\n    float: none !important;\n  }\n\n  .object-fit-sm-contain {\n    object-fit: contain !important;\n  }\n\n  .object-fit-sm-cover {\n    object-fit: cover !important;\n  }\n\n  .object-fit-sm-fill {\n    object-fit: fill !important;\n  }\n\n  .object-fit-sm-scale {\n    object-fit: scale-down !important;\n  }\n\n  .object-fit-sm-none {\n    object-fit: none !important;\n  }\n\n  .d-sm-inline {\n    display: inline !important;\n  }\n\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-sm-block {\n    display: block !important;\n  }\n\n  .d-sm-grid {\n    display: grid !important;\n  }\n\n  .d-sm-inline-grid {\n    display: inline-grid !important;\n  }\n\n  .d-sm-table {\n    display: table !important;\n  }\n\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-sm-flex {\n    display: flex !important;\n  }\n\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-sm-none {\n    display: none !important;\n  }\n\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-sm-first {\n    order: -1 !important;\n  }\n\n  .order-sm-0 {\n    order: 0 !important;\n  }\n\n  .order-sm-1 {\n    order: 1 !important;\n  }\n\n  .order-sm-2 {\n    order: 2 !important;\n  }\n\n  .order-sm-3 {\n    order: 3 !important;\n  }\n\n  .order-sm-4 {\n    order: 4 !important;\n  }\n\n  .order-sm-5 {\n    order: 5 !important;\n  }\n\n  .order-sm-last {\n    order: 6 !important;\n  }\n\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n\n  .m-sm-5 {\n    margin: 3rem !important;\n  }\n\n  .m-sm-auto {\n    margin: auto !important;\n  }\n\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-sm-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-sm-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-sm-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-sm-3 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-sm-5 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-sm-3 {\n    margin-right: 1rem !important;\n  }\n\n  .me-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-sm-5 {\n    margin-right: 3rem !important;\n  }\n\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-sm-3 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-sm-5 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n\n  .p-sm-5 {\n    padding: 3rem !important;\n  }\n\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-sm-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-sm-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-sm-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-sm-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-sm-3 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-sm-5 {\n    padding-top: 3rem !important;\n  }\n\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-sm-3 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-sm-5 {\n    padding-right: 3rem !important;\n  }\n\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-sm-5 {\n    padding-bottom: 3rem !important;\n  }\n\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-sm-3 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-sm-5 {\n    padding-left: 3rem !important;\n  }\n\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n\n  .gap-sm-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-sm-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-sm-3 {\n    gap: 1rem !important;\n  }\n\n  .gap-sm-4 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-sm-5 {\n    gap: 3rem !important;\n  }\n\n  .row-gap-sm-0 {\n    row-gap: 0 !important;\n  }\n\n  .row-gap-sm-1 {\n    row-gap: 0.25rem !important;\n  }\n\n  .row-gap-sm-2 {\n    row-gap: 0.5rem !important;\n  }\n\n  .row-gap-sm-3 {\n    row-gap: 1rem !important;\n  }\n\n  .row-gap-sm-4 {\n    row-gap: 1.5rem !important;\n  }\n\n  .row-gap-sm-5 {\n    row-gap: 3rem !important;\n  }\n\n  .column-gap-sm-0 {\n    column-gap: 0 !important;\n  }\n\n  .column-gap-sm-1 {\n    column-gap: 0.25rem !important;\n  }\n\n  .column-gap-sm-2 {\n    column-gap: 0.5rem !important;\n  }\n\n  .column-gap-sm-3 {\n    column-gap: 1rem !important;\n  }\n\n  .column-gap-sm-4 {\n    column-gap: 1.5rem !important;\n  }\n\n  .column-gap-sm-5 {\n    column-gap: 3rem !important;\n  }\n\n  .text-sm-start {\n    text-align: left !important;\n  }\n\n  .text-sm-end {\n    text-align: right !important;\n  }\n\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n\n  .float-md-end {\n    float: right !important;\n  }\n\n  .float-md-none {\n    float: none !important;\n  }\n\n  .object-fit-md-contain {\n    object-fit: contain !important;\n  }\n\n  .object-fit-md-cover {\n    object-fit: cover !important;\n  }\n\n  .object-fit-md-fill {\n    object-fit: fill !important;\n  }\n\n  .object-fit-md-scale {\n    object-fit: scale-down !important;\n  }\n\n  .object-fit-md-none {\n    object-fit: none !important;\n  }\n\n  .d-md-inline {\n    display: inline !important;\n  }\n\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-md-block {\n    display: block !important;\n  }\n\n  .d-md-grid {\n    display: grid !important;\n  }\n\n  .d-md-inline-grid {\n    display: inline-grid !important;\n  }\n\n  .d-md-table {\n    display: table !important;\n  }\n\n  .d-md-table-row {\n    display: table-row !important;\n  }\n\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-md-flex {\n    display: flex !important;\n  }\n\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-md-none {\n    display: none !important;\n  }\n\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-md-center {\n    align-items: center !important;\n  }\n\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-md-center {\n    align-content: center !important;\n  }\n\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-md-center {\n    align-self: center !important;\n  }\n\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-md-first {\n    order: -1 !important;\n  }\n\n  .order-md-0 {\n    order: 0 !important;\n  }\n\n  .order-md-1 {\n    order: 1 !important;\n  }\n\n  .order-md-2 {\n    order: 2 !important;\n  }\n\n  .order-md-3 {\n    order: 3 !important;\n  }\n\n  .order-md-4 {\n    order: 4 !important;\n  }\n\n  .order-md-5 {\n    order: 5 !important;\n  }\n\n  .order-md-last {\n    order: 6 !important;\n  }\n\n  .m-md-0 {\n    margin: 0 !important;\n  }\n\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n\n  .m-md-5 {\n    margin: 3rem !important;\n  }\n\n  .m-md-auto {\n    margin: auto !important;\n  }\n\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-md-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-md-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-md-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-md-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-md-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-md-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-md-3 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-md-4 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-md-5 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-md-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-md-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-md-3 {\n    margin-right: 1rem !important;\n  }\n\n  .me-md-4 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-md-5 {\n    margin-right: 3rem !important;\n  }\n\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-md-3 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-md-5 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-md-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-md-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-md-3 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-md-4 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-md-5 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n\n  .p-md-0 {\n    padding: 0 !important;\n  }\n\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n\n  .p-md-5 {\n    padding: 3rem !important;\n  }\n\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-md-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-md-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-md-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-md-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-md-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-md-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-md-3 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-md-4 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-md-5 {\n    padding-top: 3rem !important;\n  }\n\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-md-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-md-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-md-3 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-md-4 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-md-5 {\n    padding-right: 3rem !important;\n  }\n\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-md-3 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-md-5 {\n    padding-bottom: 3rem !important;\n  }\n\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-md-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-md-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-md-3 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-md-4 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-md-5 {\n    padding-left: 3rem !important;\n  }\n\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n\n  .gap-md-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-md-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-md-3 {\n    gap: 1rem !important;\n  }\n\n  .gap-md-4 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-md-5 {\n    gap: 3rem !important;\n  }\n\n  .row-gap-md-0 {\n    row-gap: 0 !important;\n  }\n\n  .row-gap-md-1 {\n    row-gap: 0.25rem !important;\n  }\n\n  .row-gap-md-2 {\n    row-gap: 0.5rem !important;\n  }\n\n  .row-gap-md-3 {\n    row-gap: 1rem !important;\n  }\n\n  .row-gap-md-4 {\n    row-gap: 1.5rem !important;\n  }\n\n  .row-gap-md-5 {\n    row-gap: 3rem !important;\n  }\n\n  .column-gap-md-0 {\n    column-gap: 0 !important;\n  }\n\n  .column-gap-md-1 {\n    column-gap: 0.25rem !important;\n  }\n\n  .column-gap-md-2 {\n    column-gap: 0.5rem !important;\n  }\n\n  .column-gap-md-3 {\n    column-gap: 1rem !important;\n  }\n\n  .column-gap-md-4 {\n    column-gap: 1.5rem !important;\n  }\n\n  .column-gap-md-5 {\n    column-gap: 3rem !important;\n  }\n\n  .text-md-start {\n    text-align: left !important;\n  }\n\n  .text-md-end {\n    text-align: right !important;\n  }\n\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n\n  .float-lg-end {\n    float: right !important;\n  }\n\n  .float-lg-none {\n    float: none !important;\n  }\n\n  .object-fit-lg-contain {\n    object-fit: contain !important;\n  }\n\n  .object-fit-lg-cover {\n    object-fit: cover !important;\n  }\n\n  .object-fit-lg-fill {\n    object-fit: fill !important;\n  }\n\n  .object-fit-lg-scale {\n    object-fit: scale-down !important;\n  }\n\n  .object-fit-lg-none {\n    object-fit: none !important;\n  }\n\n  .d-lg-inline {\n    display: inline !important;\n  }\n\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-lg-block {\n    display: block !important;\n  }\n\n  .d-lg-grid {\n    display: grid !important;\n  }\n\n  .d-lg-inline-grid {\n    display: inline-grid !important;\n  }\n\n  .d-lg-table {\n    display: table !important;\n  }\n\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-lg-flex {\n    display: flex !important;\n  }\n\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-lg-none {\n    display: none !important;\n  }\n\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-lg-first {\n    order: -1 !important;\n  }\n\n  .order-lg-0 {\n    order: 0 !important;\n  }\n\n  .order-lg-1 {\n    order: 1 !important;\n  }\n\n  .order-lg-2 {\n    order: 2 !important;\n  }\n\n  .order-lg-3 {\n    order: 3 !important;\n  }\n\n  .order-lg-4 {\n    order: 4 !important;\n  }\n\n  .order-lg-5 {\n    order: 5 !important;\n  }\n\n  .order-lg-last {\n    order: 6 !important;\n  }\n\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n\n  .m-lg-5 {\n    margin: 3rem !important;\n  }\n\n  .m-lg-auto {\n    margin: auto !important;\n  }\n\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-lg-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-lg-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-lg-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-lg-3 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-lg-5 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-lg-3 {\n    margin-right: 1rem !important;\n  }\n\n  .me-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-lg-5 {\n    margin-right: 3rem !important;\n  }\n\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-lg-3 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-lg-5 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n\n  .p-lg-5 {\n    padding: 3rem !important;\n  }\n\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-lg-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-lg-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-lg-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-lg-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-lg-3 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-lg-5 {\n    padding-top: 3rem !important;\n  }\n\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-lg-3 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-lg-5 {\n    padding-right: 3rem !important;\n  }\n\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-lg-5 {\n    padding-bottom: 3rem !important;\n  }\n\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-lg-3 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-lg-5 {\n    padding-left: 3rem !important;\n  }\n\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n\n  .gap-lg-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-lg-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-lg-3 {\n    gap: 1rem !important;\n  }\n\n  .gap-lg-4 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-lg-5 {\n    gap: 3rem !important;\n  }\n\n  .row-gap-lg-0 {\n    row-gap: 0 !important;\n  }\n\n  .row-gap-lg-1 {\n    row-gap: 0.25rem !important;\n  }\n\n  .row-gap-lg-2 {\n    row-gap: 0.5rem !important;\n  }\n\n  .row-gap-lg-3 {\n    row-gap: 1rem !important;\n  }\n\n  .row-gap-lg-4 {\n    row-gap: 1.5rem !important;\n  }\n\n  .row-gap-lg-5 {\n    row-gap: 3rem !important;\n  }\n\n  .column-gap-lg-0 {\n    column-gap: 0 !important;\n  }\n\n  .column-gap-lg-1 {\n    column-gap: 0.25rem !important;\n  }\n\n  .column-gap-lg-2 {\n    column-gap: 0.5rem !important;\n  }\n\n  .column-gap-lg-3 {\n    column-gap: 1rem !important;\n  }\n\n  .column-gap-lg-4 {\n    column-gap: 1.5rem !important;\n  }\n\n  .column-gap-lg-5 {\n    column-gap: 3rem !important;\n  }\n\n  .text-lg-start {\n    text-align: left !important;\n  }\n\n  .text-lg-end {\n    text-align: right !important;\n  }\n\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n\n  .float-xl-end {\n    float: right !important;\n  }\n\n  .float-xl-none {\n    float: none !important;\n  }\n\n  .object-fit-xl-contain {\n    object-fit: contain !important;\n  }\n\n  .object-fit-xl-cover {\n    object-fit: cover !important;\n  }\n\n  .object-fit-xl-fill {\n    object-fit: fill !important;\n  }\n\n  .object-fit-xl-scale {\n    object-fit: scale-down !important;\n  }\n\n  .object-fit-xl-none {\n    object-fit: none !important;\n  }\n\n  .d-xl-inline {\n    display: inline !important;\n  }\n\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-xl-block {\n    display: block !important;\n  }\n\n  .d-xl-grid {\n    display: grid !important;\n  }\n\n  .d-xl-inline-grid {\n    display: inline-grid !important;\n  }\n\n  .d-xl-table {\n    display: table !important;\n  }\n\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-xl-flex {\n    display: flex !important;\n  }\n\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-xl-none {\n    display: none !important;\n  }\n\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-xl-first {\n    order: -1 !important;\n  }\n\n  .order-xl-0 {\n    order: 0 !important;\n  }\n\n  .order-xl-1 {\n    order: 1 !important;\n  }\n\n  .order-xl-2 {\n    order: 2 !important;\n  }\n\n  .order-xl-3 {\n    order: 3 !important;\n  }\n\n  .order-xl-4 {\n    order: 4 !important;\n  }\n\n  .order-xl-5 {\n    order: 5 !important;\n  }\n\n  .order-xl-last {\n    order: 6 !important;\n  }\n\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n\n  .m-xl-5 {\n    margin: 3rem !important;\n  }\n\n  .m-xl-auto {\n    margin: auto !important;\n  }\n\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-xl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-xl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-xl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-xl-3 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-xl-5 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-xl-3 {\n    margin-right: 1rem !important;\n  }\n\n  .me-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-xl-5 {\n    margin-right: 3rem !important;\n  }\n\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-xl-3 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-xl-5 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n\n  .p-xl-5 {\n    padding: 3rem !important;\n  }\n\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-xl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-xl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-xl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-xl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-xl-3 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-xl-5 {\n    padding-top: 3rem !important;\n  }\n\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-xl-3 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-xl-5 {\n    padding-right: 3rem !important;\n  }\n\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-xl-5 {\n    padding-bottom: 3rem !important;\n  }\n\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-xl-3 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-xl-5 {\n    padding-left: 3rem !important;\n  }\n\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n\n  .gap-xl-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-xl-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-xl-3 {\n    gap: 1rem !important;\n  }\n\n  .gap-xl-4 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-xl-5 {\n    gap: 3rem !important;\n  }\n\n  .row-gap-xl-0 {\n    row-gap: 0 !important;\n  }\n\n  .row-gap-xl-1 {\n    row-gap: 0.25rem !important;\n  }\n\n  .row-gap-xl-2 {\n    row-gap: 0.5rem !important;\n  }\n\n  .row-gap-xl-3 {\n    row-gap: 1rem !important;\n  }\n\n  .row-gap-xl-4 {\n    row-gap: 1.5rem !important;\n  }\n\n  .row-gap-xl-5 {\n    row-gap: 3rem !important;\n  }\n\n  .column-gap-xl-0 {\n    column-gap: 0 !important;\n  }\n\n  .column-gap-xl-1 {\n    column-gap: 0.25rem !important;\n  }\n\n  .column-gap-xl-2 {\n    column-gap: 0.5rem !important;\n  }\n\n  .column-gap-xl-3 {\n    column-gap: 1rem !important;\n  }\n\n  .column-gap-xl-4 {\n    column-gap: 1.5rem !important;\n  }\n\n  .column-gap-xl-5 {\n    column-gap: 3rem !important;\n  }\n\n  .text-xl-start {\n    text-align: left !important;\n  }\n\n  .text-xl-end {\n    text-align: right !important;\n  }\n\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n\n  .float-xxl-end {\n    float: right !important;\n  }\n\n  .float-xxl-none {\n    float: none !important;\n  }\n\n  .object-fit-xxl-contain {\n    object-fit: contain !important;\n  }\n\n  .object-fit-xxl-cover {\n    object-fit: cover !important;\n  }\n\n  .object-fit-xxl-fill {\n    object-fit: fill !important;\n  }\n\n  .object-fit-xxl-scale {\n    object-fit: scale-down !important;\n  }\n\n  .object-fit-xxl-none {\n    object-fit: none !important;\n  }\n\n  .d-xxl-inline {\n    display: inline !important;\n  }\n\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-xxl-block {\n    display: block !important;\n  }\n\n  .d-xxl-grid {\n    display: grid !important;\n  }\n\n  .d-xxl-inline-grid {\n    display: inline-grid !important;\n  }\n\n  .d-xxl-table {\n    display: table !important;\n  }\n\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-xxl-flex {\n    display: flex !important;\n  }\n\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-xxl-none {\n    display: none !important;\n  }\n\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-xxl-first {\n    order: -1 !important;\n  }\n\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n\n  .order-xxl-last {\n    order: 6 !important;\n  }\n\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n\n  .m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-xxl-3 {\n    margin: 1rem !important;\n  }\n\n  .m-xxl-4 {\n    margin: 1.5rem !important;\n  }\n\n  .m-xxl-5 {\n    margin: 3rem !important;\n  }\n\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-xxl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-xxl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-xxl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-xxl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-xxl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-xxl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-xxl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-xxl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-xxl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-xxl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-xxl-3 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-xxl-4 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-xxl-5 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-xxl-3 {\n    margin-right: 1rem !important;\n  }\n\n  .me-xxl-4 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-xxl-5 {\n    margin-right: 3rem !important;\n  }\n\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-xxl-3 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-xxl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-xxl-5 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-xxl-3 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-xxl-4 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-xxl-5 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n\n  .p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-xxl-3 {\n    padding: 1rem !important;\n  }\n\n  .p-xxl-4 {\n    padding: 1.5rem !important;\n  }\n\n  .p-xxl-5 {\n    padding: 3rem !important;\n  }\n\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-xxl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-xxl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-xxl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-xxl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-xxl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-xxl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-xxl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-xxl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-xxl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-xxl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-xxl-3 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-xxl-4 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-xxl-5 {\n    padding-top: 3rem !important;\n  }\n\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-xxl-3 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-xxl-4 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-xxl-5 {\n    padding-right: 3rem !important;\n  }\n\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-xxl-3 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-xxl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-xxl-5 {\n    padding-bottom: 3rem !important;\n  }\n\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-xxl-3 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-xxl-4 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-xxl-5 {\n    padding-left: 3rem !important;\n  }\n\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n\n  .gap-xxl-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-xxl-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-xxl-3 {\n    gap: 1rem !important;\n  }\n\n  .gap-xxl-4 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-xxl-5 {\n    gap: 3rem !important;\n  }\n\n  .row-gap-xxl-0 {\n    row-gap: 0 !important;\n  }\n\n  .row-gap-xxl-1 {\n    row-gap: 0.25rem !important;\n  }\n\n  .row-gap-xxl-2 {\n    row-gap: 0.5rem !important;\n  }\n\n  .row-gap-xxl-3 {\n    row-gap: 1rem !important;\n  }\n\n  .row-gap-xxl-4 {\n    row-gap: 1.5rem !important;\n  }\n\n  .row-gap-xxl-5 {\n    row-gap: 3rem !important;\n  }\n\n  .column-gap-xxl-0 {\n    column-gap: 0 !important;\n  }\n\n  .column-gap-xxl-1 {\n    column-gap: 0.25rem !important;\n  }\n\n  .column-gap-xxl-2 {\n    column-gap: 0.5rem !important;\n  }\n\n  .column-gap-xxl-3 {\n    column-gap: 1rem !important;\n  }\n\n  .column-gap-xxl-4 {\n    column-gap: 1.5rem !important;\n  }\n\n  .column-gap-xxl-5 {\n    column-gap: 3rem !important;\n  }\n\n  .text-xxl-start {\n    text-align: left !important;\n  }\n\n  .text-xxl-end {\n    text-align: right !important;\n  }\n\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 2.2rem !important;\n  }\n\n  .fs-2 {\n    font-size: 2.024rem !important;\n  }\n\n  .fs-3 {\n    font-size: 1.584rem !important;\n  }\n}\n\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-print-block {\n    display: block !important;\n  }\n\n  .d-print-grid {\n    display: grid !important;\n  }\n\n  .d-print-inline-grid {\n    display: inline-grid !important;\n  }\n\n  .d-print-table {\n    display: table !important;\n  }\n\n  .d-print-table-row {\n    display: table-row !important;\n  }\n\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-print-flex {\n    display: flex !important;\n  }\n\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-print-none {\n    display: none !important;\n  }\n}\n\n/* Global Area Style\n============================================*/\nbody {\n  font-family: \"Inter\", sans-serif;\n}\n\na {\n  transition: all ease 0.5s;\n  color: #fff;\n}\n\na:hover {\n  color: #d08f2c;\n}\n\na:focus-visible {\n  outline: 0;\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  color: #3A4252;\n  font-weight: 700;\n}\n\nh3,\n.h3 {\n  font-size: 18px;\n}\n\np {\n  margin-bottom: 15px;\n  line-height: 26px;\n}\n\np:last-child {\n  margin-bottom: 0;\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n}\n\n.label,\n.form-label {\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 10px;\n}\n\n.card {\n  transition: all ease 0.5s;\n}\n\n.btn-primary:hover span {\n  color: #fff !important;\n}\n\n.form-control {\n  background-color: #fff;\n  border: 1px solid #D5D9E2;\n  height: 50px;\n  color: #3A4252 !important;\n  font-size: 15px;\n  padding: 14px 16px;\n  width: 100%;\n  transition: all ease 0.5s;\n  border-radius: 7px;\n}\n\n.form-control::placeholder {\n  color: #fff;\n  font-size: 14px;\n}\n\n.form-control:focus {\n  background-color: #fff;\n  box-shadow: unset;\n  outline: 0;\n  border: 1px solid #d08f2c;\n  color: #8695AA;\n}\n\n.form-control.form-select {\n  cursor: pointer;\n  color: #8695AA;\n}\n\n.form-control.file {\n  padding-top: 12px;\n}\n\n.form-control.h-55 {\n  height: 55px;\n}\n\n.form-control.h-60 {\n  height: 60px;\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n.form-check {\n  margin-bottom: 0;\n}\n\n.form-check .form-check-input {\n  border: 2px solid #fff;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.form-check .form-check-input:focus {\n  box-shadow: none;\n  border-color: #d08f2c;\n}\n\n.form-check .form-check-input:checked[type=checkbox] {\n  border-color: #d08f2c;\n}\n\n.form-check .form-check-label {\n  padding-left: 5px;\n}\n\n.month-select {\n  width: 114px;\n  height: 36px;\n  padding-top: 6px;\n  padding-bottom: 10px;\n  background-size: 10px 10px;\n  background-position: right 8px center;\n  font-size: 14px;\n}\n\n.month-select.w-145 {\n  width: 145px;\n}\n\n.month-select.w-135 {\n  width: 135px;\n}\n\n.month-select.w-90 {\n  width: 90px;\n}\n\n.month-select.w-99 {\n  width: 105px;\n}\n\n.lcbmp-none:last-child {\n  padding-bottom: 0 !important;\n  margin-bottom: 0 !important;\n  border-bottom: none !important;\n}\n\n.lcmb-none:last-child {\n  border-bottom: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.tr-lcbp-none:last-child td {\n  border-bottom: none;\n  padding-bottom: 0 !important;\n}\n\n.list-last-child li:last-child {\n  padding-bottom: 0 !important;\n  margin-bottom: 0 !important;\n  border-bottom: none !important;\n}\n\n.l-lcbm li:last-child {\n  margin-bottom: 0 !important;\n  border-bottom: none !important;\n}\n\n.hover-text-white:hover {\n  color: #fff !important;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.py-38 {\n  padding-top: 38px !important;\n  padding-bottom: 38px !important;\n}\n\n.default-src-form .form-control {\n  height: 40px;\n  background-color: #F6F7F9;\n  border-color: #F6F7F9;\n  padding-left: 35px;\n}\n\n.default-src-form .start-0 {\n  left: 15px !important;\n}\n\n.breadcrumb-page-list .breadcrumb {\n  margin: 0;\n}\n\n.breadcrumb-page-list .breadcrumb li a {\n  text-decoration: none;\n}\n\n.bg-4936F5 {\n  background-color: #4936F5;\n}\n\n/* BG Image Area Style\n============================================*/\n.bg-img {\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n/* Preloader Area Style\n============================================*/\n#preloader {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n  position: fixed;\n  background-color: #fff;\n}\n\n#preloader .preloader {\n  transform: translate(-50%, -50%);\n  position: absolute;\n  left: 50%;\n  top: 50%;\n}\n\n#preloader .preloader .loader {\n  position: relative;\n  overflow: hidden;\n  display: block;\n  height: 150px;\n  width: 150px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n#preloader .preloader .loader div {\n  height: 100%;\n}\n\n#preloader .preloader .loader,\n#preloader .preloader .loader div {\n  padding: 8px;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  animation: rotate linear 3.5s infinite;\n  border-top-color: #d08f2c;\n  border-border-bottom: #d08f2c;\n}\n\n#preloader .preloader .waviy {\n  position: relative;\n  text-align: center;\n  -webkit-box-reflect: below -47px linear-gradient(transparent, rgba(0, 0, 0, 0.2));\n  font-size: 50px;\n  font-weight: 700;\n}\n\n#preloader .preloader .waviy span {\n  position: relative;\n  color: #000000;\n  animation-delay: 0.1s;\n  display: inline-block;\n  animation: waviy 1s infinite;\n}\n\n#preloader .preloader .waviy span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n#preloader .preloader .waviy span:nth-child(3) {\n  animation-delay: 0.3s;\n}\n\n#preloader .preloader .waviy span:nth-child(4) {\n  animation-delay: 0.4s;\n}\n\n#preloader .preloader .waviy span:nth-child(5) {\n  animation-delay: 0.5s;\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  50% {\n    transform: rotate(180deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes waviy {\n\n  0%,\n  40%,\n  100% {\n    transform: translateY(0);\n  }\n\n  20% {\n    transform: translateY(-20px);\n  }\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n  #preloader .preloader .waviy {\n    font-size: 30px;\n  }\n}\n\n.badge {\n  background-color: #ECF0FF;\n  color: #d08f2c;\n}\n\n.badge.pending,\n.badge.Pending {\n  background-color: rgba(255, 193, 7, 0.15);\n  color: #FFBC2B;\n}\n\n.badge.rejected,\n.badge.Rejected,\n.badge.NotAvailable,\n.badge.notAvailable,\n.badge.Not.Available,\n.badge.not.available,\n.badge.Not,\n.badge.not,\n.badge.past,\n.badge.Past {\n  background-color: #FFE1DD;\n  color: #FD5812;\n}\n\n.badge.pInProgress,\n.badge.cancelled,\n.badge.Cancelled,\n.badge.draft,\n.badge.Draft,\n.badge.deactive,\n.badge.Deactive,\n.badge.Deactivate,\n.badge.deactivate,\n.badge.Unread,\n.badge.unread,\n.badge.inProgress,\n.badge.in.Progress,\n.badge.In.Progress {\n  background-color: #FFE1DD;\n  color: #FD5812;\n}\n\n.badge.finished,\n.badge .Finished,\n.badge.shipped,\n.badge.Shipped,\n.badge.pFinished {\n  background-color: #D8FFC8;\n  color: #37D80A;\n}\n\n.badge.pPending {\n  background-color: #F3E8FF;\n  color: #d08f2c;\n}\n\n/*\nAction Opt Style\n======================================================*/\n.action-opt .btn {\n  border: none;\n  color: #8F9DBD;\n  font-size: 22px;\n}\n\n.action-opt .btn:after {\n  display: none;\n}\n\n.action-opt .btn:focus {\n  border: none;\n  box-shadow: none;\n}\n\n.action-opt .btn.bg {\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  text-align: center;\n  background-color: #F3F6F9;\n  border-radius: 4px;\n}\n\n.action-opt .btn.bg svg {\n  margin-right: 0 !important;\n  stroke: #fff !important;\n}\n\n.action-opt .dropdown-menu .dropdown-item {\n  font-size: 14px;\n  padding: 8px 12px;\n  display: flex;\n  align-items: center;\n}\n\n.action-opt .dropdown-menu .dropdown-item i,\n.action-opt .dropdown-menu .dropdown-item span {\n  font-size: 16px;\n  margin-right: 5px;\n  position: relative;\n  top: 0;\n}\n\n.action-opt .dropdown-menu .dropdown-item:hover {\n  background: rgba(92, 97, 242, 0.05);\n  color: #d08f2c;\n}\n\n.action-opt.hover .dropdown-menu {\n  display: block !important;\n  opacity: 0;\n  transition: all ease 0.5s;\n}\n\n.action-opt.hover:hover .dropdown-menu {\n  opacity: 1;\n}\n\n/*\nCustom Width Area Style\n======================================================*/\n.w-330 {\n  width: 330px;\n}\n\n.wh-11 {\n  width: 11px;\n  height: 11px;\n}\n\n.wh-16 {\n  width: 16px;\n  height: 16px;\n}\n\n.wh-25 {\n  width: 25px;\n  height: 25px;\n}\n\n.wh-30 {\n  width: 30px;\n  height: 30px;\n}\n\n.wh-34 {\n  width: 34px;\n  height: 34px;\n}\n\n.wh-35 {\n  width: 35px;\n  height: 35px;\n}\n\n.wh-40 {\n  width: 40px;\n  height: 40px;\n}\n\n.wh-44 {\n  width: 44px;\n  height: 44px;\n}\n\n.wh-45 {\n  width: 45px;\n  height: 45px;\n}\n\n.wh-47 {\n  width: 47px;\n  height: 47px;\n}\n\n.wh-48 {\n  width: 48px;\n  height: 48px;\n}\n\n.wh-52 {\n  width: 52px;\n  height: 52px;\n}\n\n.wh-55 {\n  width: 55px;\n  height: 55px;\n}\n\n.wh-57 {\n  width: 57px;\n  height: 57px;\n}\n\n.wh-60 {\n  width: 60px;\n  height: 60px;\n}\n\n.wh-65 {\n  width: 65px;\n  height: 65px;\n}\n\n.wh-67 {\n  width: 67px;\n  height: 67px;\n}\n\n.wh-70 {\n  width: 70px;\n  height: 70px;\n}\n\n.wh-75 {\n  width: 75px;\n  height: 75px;\n}\n\n.wh-77 {\n  width: 77px;\n  height: 77px;\n}\n\n.wh-80 {\n  width: 80px;\n  height: 60px;\n}\n\n.wh-87 {\n  width: 87px;\n  height: 87px;\n}\n\n.wh-100 {\n  width: 100px;\n  height: 100px;\n}\n\n.wh-130 {\n  width: 130px;\n  height: 130px;\n}\n\n.wh-130-113 {\n  width: 130px;\n  height: 113px;\n}\n\n.wh-150 {\n  width: 150px;\n  height: 150px;\n}\n\n.wh-160 {\n  width: 160px;\n  height: 160px;\n}\n\n.mw-80 {\n  max-width: 80px;\n}\n\n.mw-123 {\n  max-width: 123px;\n}\n\n.mw-380 {\n  max-width: 380px;\n}\n\n.mw-430 {\n  max-width: 430px;\n}\n\n.mw-480 {\n  max-width: 480px;\n}\n\n.mw-548 {\n  max-width: 548px;\n}\n\n.mw-740 {\n  max-width: 740px;\n}\n\n/** New **/\n.max-h-198 {\n  max-height: 198px;\n  overflow-y: auto;\n}\n\n.max-h-217 {\n  max-height: 217.5px;\n  overflow-y: auto;\n}\n\n.max-h-275 {\n  max-height: 275px;\n  overflow-y: auto;\n}\n\n.max-h-312 {\n  max-height: 312px;\n  overflow-y: auto;\n}\n\n.max-h-497 {\n  max-height: 497px;\n  overflow-y: auto;\n}\n\n.max-h-419 {\n  max-height: 419px;\n  overflow-y: auto;\n}\n\n.scrollbar {\n  /* width */\n  /* Track */\n  /* Handle */\n  /* Handle on hover */\n}\n\n.scrollbar::-webkit-scrollbar {\n  width: 5px;\n}\n\n.scrollbar::-webkit-scrollbar-track {\n  background: #fff;\n}\n\n.scrollbar::-webkit-scrollbar-thumb {\n  background: #c5c5c5;\n}\n\n.scrollbar::-webkit-scrollbar-thumb:hover {\n  background: #888;\n}\n\n/*\nCustom Rounded Area Style\n======================================================*/\n.rounded-bottom-15 {\n  border-radius: 0 0 15px 15px;\n}\n\n.rounded-top-7 {\n  border-radius: 7px 7px 0 0;\n}\n\n/*\nCustom Transition Area Style\n======================================================*/\n.transition {\n  transition: all ease 0.5s;\n}\n\n.transition-x {\n  transition: all ease 0.5s;\n}\n\n.transition-x:hover {\n  transform: translateX(-5px);\n}\n\n.transition-x-right {\n  transition: all ease 0.5s;\n}\n\n.transition-x-right:hover {\n  transform: translateX(5px);\n}\n\n.transition-y {\n  transition: all ease 0.5s;\n}\n\n.transition-y:hover {\n  transform: translateY(-5px);\n}\n\n.transition-y-bottom {\n  transition: all ease 0.5s;\n}\n\n.transition-y-bottom:hover {\n  transform: translateY(5px);\n}\n\n.transition-zoom-in {\n  transition: all ease 0.5s;\n}\n\n.transition-zoom-in:hover {\n  transform: scale(1.3);\n}\n\n/*\nCustom Font Size Area Style\n======================================================*/\n.fs-10 {\n  font-size: 10px;\n}\n\n.fs-11 {\n  font-size: 11px;\n}\n\n.fs-12 {\n  font-size: 12px !important;\n}\n\n.fs-13 {\n  font-size: 13px;\n}\n\n.fs-14 {\n  font-size: 14px;\n}\n\n.fs-15 {\n  font-size: 15px;\n}\n\n.fs-16 {\n  font-size: 16px;\n}\n\n.fs-17 {\n  font-size: 17px;\n}\n\n.fs-18 {\n  font-size: 18px;\n}\n\n.fs-19 {\n  font-size: 19px;\n}\n\n.fs-20 {\n  font-size: 20px;\n}\n\n.fs-21 {\n  font-size: 21px;\n}\n\n.fs-22 {\n  font-size: 22px;\n}\n\n.fs-23 {\n  font-size: 23px;\n}\n\n.fs-24 {\n  font-size: 24px;\n}\n\n.fs-25 {\n  font-size: 25px;\n}\n\n.fs-26 {\n  font-size: 26px;\n}\n\n.fs-27 {\n  font-size: 27px;\n}\n\n.fs-28 {\n  font-size: 28px;\n}\n\n.fs-29 {\n  font-size: 29px;\n}\n\n.fs-30 {\n  font-size: 30px;\n}\n\n.fs-32 {\n  font-size: 32px;\n}\n\n.fs-35 {\n  font-size: 35px;\n}\n\n.fs-40 {\n  font-size: 40px;\n}\n\n.fs-45 {\n  font-size: 45px;\n}\n\n/*\nCustom Padding & Margin Area Style\n======================================================*/\n.mb-20 {\n  margin-bottom: 20px;\n}\n\n.mb-29 {\n  margin-bottom: 29px;\n}\n\n.mb-30 {\n  margin-bottom: 30px;\n}\n\n.mb-35 {\n  margin-bottom: 35px;\n}\n\n.mb-19 {\n  margin-bottom: 19px;\n}\n\n.ms-m-15 {\n  margin-left: -15px;\n}\n\n.ms-m-15:first-child {\n  margin-left: 0;\n}\n\n.ms-m-20 {\n  margin-left: -20px;\n}\n\n.ms-m-20:first-child {\n  margin-left: 0;\n}\n\n.ms-m-10 {\n  margin-left: -10px;\n}\n\n.ms-e-10 {\n  margin-right: -10px;\n}\n\n.p-20 {\n  padding: 20px;\n}\n\n.ps-20 {\n  padding-left: 20px;\n}\n\n.mt-minus-110 {\n  margin-top: -100px;\n}\n\n.minus-l-20 {\n  margin-left: -20px;\n}\n\n.minus-l-20:first-child {\n  margin-left: 0;\n}\n\n.box-shadow {\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n}\n\n/*\nLine Height Area Style\n======================================================*/\n.lh-16 {\n  line-height: 16.5px !important;\n}\n\n.lh-25 {\n  line-height: 25px !important;\n}\n\n.lh-30 {\n  line-height: 30px !important;\n}\n\n.lh-34 {\n  line-height: 34px !important;\n}\n\n.lh-35 {\n  line-height: 35px !important;\n}\n\n.lh-40 {\n  line-height: 40px !important;\n}\n\n.lh-44 {\n  line-height: 44px !important;\n}\n\n.lh-45 {\n  line-height: 45px !important;\n}\n\n.lh-48 {\n  line-height: 48px !important;\n}\n\n.lh-56 {\n  line-height: 56px !important;\n}\n\n.lh-55 {\n  line-height: 59px !important;\n}\n\n.lh-60 {\n  line-height: 60px !important;\n}\n\n.lh-70 {\n  line-height: 70px !important;\n}\n\n.lh-97 {\n  line-height: 97px !important;\n}\n\n/*\nCustom Border Color Area Style\n======================================================*/\n.border-color-white {\n  border-color: #fff !important;\n}\n\n.list-dot li {\n  position: relative;\n  padding-right: 14px;\n  margin-right: 10px;\n}\n\n.list-dot li::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  right: 0;\n  width: 5px;\n  height: 5px;\n  background-color: #fff;\n  border-radius: 50px;\n  transform: translateY(-50%);\n}\n\n.list-dot li:last-child {\n  padding-right: 0;\n  margin-right: 0;\n}\n\n.list-dot li:last-child::before {\n  display: none;\n}\n\n/*\nCustom Hover Area Style\n======================================================*/\n.hover {\n  transition: all ease 0.5s;\n}\n\n.hover:hover {\n  color: #d08f2c !important;\n}\n\n.hover:hover i,\n.hover:hover span {\n  color: #d08f2c !important;\n}\n\n.hover-white {\n  transition: all ease 0.5s;\n}\n\n.hover-white:hover {\n  color: #fff !important;\n}\n\n.hover-white:hover i,\n.hover-white:hover span {\n  color: #fff !important;\n}\n\n.hover-bg {\n  transition: all ease 0.5s;\n}\n\n.hover-bg:hover {\n  background-color: #d08f2c !important;\n  color: #fff !important;\n}\n\n.hover-bg:hover i,\n.hover-bg:hover span {\n  color: #fff !important;\n}\n\n.cursor {\n  cursor: pointer;\n}\n\n.cursor-move {\n  cursor: move;\n}\n\n.product-upload input[type=file] {\n  display: none;\n}\n\n.product-upload .file-upload {\n  display: inline-block;\n  cursor: pointer;\n  line-height: 40px;\n  text-align: center;\n  font-size: 16px;\n  width: 100%;\n}\n\n.inbox-tabs {\n  flex-wrap: wrap !important;\n  padding-bottom: 15px !important;\n  gap: 3rem !important;\n}\n\n.inbox-tabs .nav-item .nav-link {\n  position: relative;\n  padding: 0;\n  font-weight: 500;\n  color: #fff;\n  border: none;\n  background-color: transparent;\n}\n\n.inbox-tabs .nav-item .nav-link::before {\n  content: \"\";\n  position: absolute;\n  bottom: -15px;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: #d08f2c;\n  opacity: 0;\n  transition: all ease 0.5s;\n}\n\n.inbox-tabs .nav-item .nav-link.active {\n  color: #d08f2c !important;\n}\n\n.inbox-tabs .nav-item .nav-link.active::before {\n  opacity: 1;\n}\n\n.inbox-tabs .nav-item .nav-link.active i,\n.inbox-tabs .nav-item .nav-link.active span {\n  color: #d08f2c !important;\n}\n\n.seller-tabs .nav-item .nav-link.active {\n  background-color: #d08f2c !important;\n  color: #fff !important;\n}\n\n.profile-tabs .nav-item .nav-link.active {\n  background-color: #d08f2c !important;\n  color: #fff !important;\n}\n\n.profile-tabs .nav-item .nav-link:hover {\n  background-color: #d08f2c !important;\n  color: #fff !important;\n}\n\n.tracking-step {\n  position: relative;\n  z-index: 1;\n}\n\n.tracking-step::before {\n  content: \"\";\n  position: absolute;\n  top: 25px;\n  left: 0;\n  right: 0;\n  border-top: 1px dashed #fff;\n  z-index: -1;\n  border-spacing: 20px;\n}\n\n.tracking-step .count {\n  width: 50px;\n  height: 50px;\n  line-height: 48px;\n  border: 1px dashed #fff;\n  display: inline-block;\n  border-radius: 50px;\n  background-color: #d08f2c;\n}\n\n.tracking-step .count.active {\n  background-color: #0dcaf0;\n}\n\n.tracking-step.style-two::before {\n  border-color: #d08f2c;\n}\n\n.tracking-step.style-two .count {\n  border-color: #d08f2c;\n}\n\n.tracking-step.style-two .count.active {\n  background-color: #d08f2c;\n}\n\n.top-1 {\n  top: 1px;\n}\n\n.top-2 {\n  top: 2px;\n}\n\n.top-3 {\n  top: 3px;\n}\n\n.top-4 {\n  top: 4px;\n}\n\n.top-5 {\n  top: 5px;\n}\n\nbutton i,\nbutton span {\n  transition: all ease 0.5s;\n}\n\nbutton:hover i,\nbutton:hover span {\n  color: #d08f2c;\n}\n\n.btn-close:focus {\n  box-shadow: none;\n}\n\n.copy-btn {\n  margin-top: 144px;\n  margin-right: 35px;\n}\n\n.copy-btn:hover {\n  background-color: #d08f2c !important;\n  color: #fff;\n}\n\n.carousel-control-prev {\n  width: 38px;\n  height: 38px;\n  background-color: #d08f2c;\n  padding: 10px;\n  position: absolute;\n  top: 50%;\n  left: 10px;\n  transform: translateY(-50%);\n  border-radius: 5px;\n  opacity: 1;\n}\n\n.carousel-control-next {\n  width: 38px;\n  height: 38px;\n  background-color: #d08f2c;\n  padding: 10px;\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  border-radius: 5px;\n  opacity: 1;\n}\n\n.rating i,\n.rating span {\n  transition: all ease 0.5s;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.rating.active i,\n.rating.active span {\n  color: #f7d700;\n}\n\n/*\nScroll Bar Style\n======================================================*/\n.scroll-bar {\n  margin-top: 0 !important;\n  overflow: auto;\n  padding-right: 5px;\n  /* width */\n  /* Track */\n  /* Handle */\n  /* Handle on hover */\n}\n\n.scroll-bar::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n  transition: all ease 0.5s;\n  border-radius: 50px;\n}\n\n.scroll-bar::-webkit-scrollbar-track {\n  background: #F0F0F4;\n  transition: all ease 0.5s;\n  border-radius: 50px;\n}\n\n.scroll-bar::-webkit-scrollbar-thumb {\n  background: #e0e0e2;\n  transition: all ease 0.5s;\n  border-radius: 50px;\n}\n\n.scroll-bar::-webkit-scrollbar-thumb:hover {\n  background: #d08f2c;\n  border-radius: 50px;\n}\n\n.scroll-bar.active {\n  /* Handle */\n  /* Handle on hover */\n}\n\n.scroll-bar.active::-webkit-scrollbar-track {\n  background: #F0F0F4;\n  transition: all ease 0.5s;\n  border-radius: 0;\n}\n\n.scroll-bar.active::-webkit-scrollbar-thumb {\n  background: #d08f2c;\n  transition: all ease 0.5s;\n  border-radius: 0;\n}\n\n.scroll-bar.active::-webkit-scrollbar-thumb:hover {\n  background: #d08f2c;\n  border-radius: 0;\n}\n\n.btn-primary.bg-opacity-10:hover {\n  background-color: #d08f2c !important;\n  color: #fff !important;\n}\n\n.btn-danger.bg-opacity-10:hover {\n  background-color: #FD5812 !important;\n  color: #fff !important;\n}\n\n.tag-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 8px;\n}\n\n.tag-container .tag {\n  background-color: #d08f2c;\n  color: #fff;\n  padding: 4px 8px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.tag-container .tag-close {\n  margin-left: 4px;\n  cursor: pointer;\n}\n\n#x__PREV__X {\n  background: #EBEAF7;\n  font-size: 30px;\n  height: 34px;\n  line-height: 13px;\n}\n\na#x__NEXT__X {\n  background: #EBEAF7;\n  font-size: 30px;\n  height: 34px;\n  line-height: 13px;\n}\n\n.faq-wrapper.accordion .accordion-item {\n  border-radius: 7px;\n}\n\n.faq-wrapper.accordion .accordion-item .accordion-header .accordion-button {\n  border-radius: 7px;\n  font-size: 16px;\n  font-weight: 500;\n  background-color: #fff;\n  box-shadow: none;\n  color: #000;\n}\n\n.faq-wrapper.accordion .accordion-item .accordion-header .accordion-button:focus {\n  box-shadow: none;\n}\n\n.faq-wrapper.accordion .accordion-item .accordion-header .accordion-button:not(.collapsed) {\n  box-shadow: none;\n}\n\n.faq-wrapper.accordion .accordion-item .accordion-body {\n  padding-top: 1px;\n}\n\n.wizard-tabs {\n  position: relative;\n  z-index: 1;\n}\n\n.wizard-tabs::before {\n  content: \"\";\n  position: absolute;\n  top: 25px;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 1px;\n  background-color: #A9A9C8;\n  opacity: 0.1;\n  z-index: -1;\n}\n\n.wizard-tabs .nav-item .nav-link {\n  background-color: #f1f2fd !important;\n}\n\n.wizard-tabs .nav-item .nav-link.active {\n  background-color: #d08f2c !important;\n}\n\n.wizard-tabs .nav-item .nav-link.active span {\n  color: #fff !important;\n}\n\n.wizard-tabs2 {\n  position: relative;\n  z-index: 1;\n}\n\n.wizard-tabs2::before {\n  content: \"\";\n  position: absolute;\n  top: 25px;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 2px;\n  background-color: #A9A9C8;\n  opacity: 0.1;\n  z-index: -1;\n}\n\n.wizard-tabs2 .nav-item .nav-link {\n  background-color: #fff;\n  padding: 0 30px !important;\n  border: none;\n}\n\n.wizard-tabs2 .nav-item .nav-link span {\n  background-color: #f1f2fd !important;\n  line-height: 48px;\n}\n\n.wizard-tabs2 .nav-item .nav-link.active span {\n  color: #fff !important;\n  background-color: #d08f2c !important;\n}\n\n.wizard-tabs2 .nav-item:first-child .nav-link {\n  padding-left: 0 !important;\n}\n\n.wizard-tabs2 .nav-item:last-child .nav-link {\n  padding-right: 0 !important;\n}\n\n/*\nTheme Settings Style\n======================================================*/\n.settings-btn {\n  background-color: #3A4252;\n  padding: 8px 20px;\n  display: inline-block;\n  color: #fff;\n  font-size: 14px;\n  border-radius: 5px;\n  cursor: pointer;\n  border: none;\n  transition: all ease 0.5s;\n}\n\n.settings-btn input {\n  width: 0;\n  height: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.settings-btn .slider {\n  position: relative;\n}\n\n.settings-btn .slider:before {\n  content: \"Click To RTL\";\n  cursor: pointer;\n}\n\n.settings-btn .slider:after {\n  content: \"Click To LTR\";\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n}\n\n.offcanvas-backdrop {\n  background-color: transparent;\n}\n\n.light {\n  display: none;\n}\n\n.light1 {\n  display: none;\n}\n\n.light2 {\n  display: none;\n}\n\n.light3 {\n  display: none;\n}\n\n.radius {\n  display: none;\n}\n\n.white {\n  display: none;\n}\n\n.fluid {\n  display: none;\n}\n\n/*\nSwiper Slider Style\n======================================================*/\n.swiper-pagination2 {\n  position: absolute;\n  bottom: 57px !important;\n  left: 25px !important;\n  z-index: 1;\n  text-align: left !important;\n  width: 100px !important;\n}\n\n.swiper-pagination2.swiper-pagination-clickable .swiper-pagination-bullet {\n  background-color: #fff;\n  opacity: 1;\n}\n\n.swiper-pagination2.swiper-pagination-clickable .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  background-color: #FD5812;\n}\n\n/* Courses Area Style\n============================================*/\n.course-accordion .accordion-button:focus {\n  box-shadow: none;\n}\n\n.course-accordion .accordion-button:not(.collapsed) {\n  box-shadow: none;\n}\n\n.courses-slide .swiper-pagination {\n  bottom: 10px;\n  left: 10px;\n  text-align: left;\n}\n\n.courses-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  background-color: #fff;\n}\n\n/* File Manager Area Style\n============================================*/\n.file-subdown {\n  padding-left: 28px;\n  margin-top: 21px;\n  margin-bottom: 25px;\n}\n\n.file-subdown li {\n  position: relative;\n  padding-left: 15px;\n  margin-bottom: 18px;\n}\n\n.file-subdown li:last-child {\n  margin-bottom: 0;\n}\n\n.file-subdown li::before {\n  left: 0;\n  top: 50%;\n  width: 6px;\n  content: \"\";\n  height: 6px;\n  border-radius: 50%;\n  position: absolute;\n  transform: translateY(-50%);\n  transition: all ease 0.5s;\n  border: 1px solid #d08f2c;\n}\n\n/* Quantity Area Style\n============================================*/\n.product-quantity {\n  border: 1px solid #E2E8F0;\n  border-radius: 4px;\n  display: inline-block;\n}\n\n.product-quantity.bg-e2e8f0 {\n  background-color: #e2e8f0;\n}\n\n.product-quantity.bg-e2e8f0 .add-to-cart-counter input {\n  background-color: #e2e8f0;\n}\n\n.product-quantity.bg-e2e8f0 .add-to-cart-counter .minusBtn,\n.product-quantity.bg-e2e8f0 .add-to-cart-counter .plusBtn {\n  background-color: #fff;\n}\n\n.product-quantity .add-to-cart-counter {\n  display: flex;\n  padding: 5px;\n}\n\n.product-quantity .add-to-cart-counter input {\n  background-color: #fff;\n  border: 1px solid #E2E8F0;\n  text-align: center;\n  font-size: 16px;\n  font-weight: 500;\n  color: #5B5B98;\n  border-radius: 4px;\n  height: 36px;\n  padding: 0;\n  border-radius: 0;\n}\n\n.product-quantity .add-to-cart-counter input:focus {\n  border-color: #d08f2c;\n  outline: none;\n}\n\n.product-quantity .add-to-cart-counter .minusBtn,\n.product-quantity .add-to-cart-counter .plusBtn {\n  background-color: #E2E8F0;\n  width: 36px;\n  height: 36px;\n  line-height: 30px;\n  border-radius: 4px;\n  transition: all ease 0.5s;\n  font-family: \"remixicon\" !important;\n  padding: 0;\n  border: 0;\n  color: #5B5B98;\n}\n\n.product-quantity .add-to-cart-counter .minusBtn:hover,\n.product-quantity .add-to-cart-counter .plusBtn:hover {\n  background-color: #d08f2c;\n  color: #fff;\n  border-color: #d08f2c;\n}\n\n.for-light-logo {\n  display: block;\n}\n\n.for-dark-logo {\n  display: none;\n}\n\n.upcoming-events-slide {\n  direction: ltr;\n}\n\n.upcoming-events-slide .swiper-pagination {\n  position: initial;\n  text-align: left;\n}\n\n.upcoming-events-slide .swiper-pagination .swiper-pagination-bullet {\n  width: 8px;\n  height: 8px;\n}\n\n.upcoming-events-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  background-color: #d08f2c;\n}\n\n.card.bg-primary.border-0.rounded-3.position-relative.mb-4 .form-select {\n  color: #fff !important;\n}\n\n.email-sidebar-nav li a:hover,\n.email-sidebar-nav li a.active {\n  color: #d08f2c;\n}\n\n.fm-sidebar-nav li a:hover,\n.fm-sidebar-nav li a.active {\n  color: #d08f2c;\n}\n\n.products-list-tabs li .nav-link {\n  font-size: 16px;\n  font-weight: 500;\n  border: none !important;\n  border-radius: 7px;\n  background-color: #f6f7f9;\n  padding: 10px 30px;\n  color: #3A4252;\n  text-transform: capitalize;\n}\n\n.products-list-tabs li .nav-link.active {\n  background-color: #d08f2c;\n  color: #fff;\n}\n\n.react-select__control {\n  min-height: 60px !important;\n}\n\n.main-content:has(div.auth-main-content) {\n  padding: 0;\n}\n\n.main-content:has(div.fp-wrapper) {\n  padding: 0;\n}\n\n.main-content:has(div.not-found-content) {\n  padding: 0;\n}\n\n.cryptocurrency-slider .swiper-pagination {\n  bottom: 0;\n}\n\n.cryptocurrency-slider .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  background-color: #d08f2c;\n}\n\n.recent-property-slide .swiper-pagination {\n  position: initial;\n  line-height: 1;\n  margin-top: 10px;\n}\n\n.recent-property-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  background-color: #d08f2c;\n}\n\n.date-time-picker-demo .react-datetime-picker__wrapper {\n  border: 1px solid #eee;\n  border-radius: 10px;\n  padding: 4px 10px;\n  background: #f5f5f5;\n}\n\n.date-time-picker-demo .react-datetime-picker__wrapper .react-datetime-picker__inputGroup {\n  font-size: 13px;\n}\n\n.date-time-picker-demo .react-datetime-picker__wrapper .react-datetime-picker__button {\n  padding: 0;\n  margin-left: 5px;\n}\n\n.date-time-picker-demo .react-datetime-picker__wrapper .react-datetime-picker__button svg {\n  display: inherit;\n  width: 15px;\n}\n\n.date-time-picker-demo .react-calendar {\n  border: 1px solid #ECEEF2;\n  padding: 10px;\n}\n\n.custom-modal {\n  background-color: rgba(0, 0, 0, 0.2);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 99999;\n  transition: all ease 0.5s;\n}\n\n.custom-modal .close-link {\n  cursor: pointer;\n  line-height: 1;\n}\n\n.custom-modal .custom-modal-content {\n  width: 400px;\n  height: 100%;\n  background-color: #F6F7F9;\n  overflow-y: auto;\n}\n\n.custom-modal .custom-modal-header {\n  background-color: #F6F7F9;\n}\n\n.custom-modal.right {\n  right: -100%;\n  left: auto;\n}\n\n.custom-modal.right.show {\n  right: 0;\n  left: 0;\n}\n\n.custom-modal.right .custom-modal-content {\n  margin-left: auto;\n}\n\n.custom-modal.left {\n  left: -100%;\n  right: auto;\n}\n\n.custom-modal.left.show {\n  right: 0;\n  left: 0;\n}\n\n.custom-modal.center {\n  transform: scale(0);\n  padding: 20px;\n}\n\n.custom-modal.center.show {\n  transform: scale(1);\n}\n\n.custom-modal.center .custom-modal-content {\n  width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.custom-modal .close-outside {\n  position: absolute;\n  left: 0;\n  top: 0;\n  cursor: ne-resize;\n  width: 100%;\n  height: 100%;\n}\n\n/* Marketing Dashboard CSS */\n.avatar-upload {\n  position: relative;\n  max-width: 135px;\n}\n\n.avatar-upload .avatar-edit {\n  position: absolute;\n  right: -17px;\n  bottom: -17px;\n  z-index: 1;\n}\n\n.avatar-upload .avatar-edit input {\n  display: none;\n}\n\n.avatar-upload .avatar-edit input+label {\n  display: inline-block;\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  margin-bottom: 0;\n  border-radius: 100%;\n  background: #FFFFFF;\n  border: 1px solid transparent;\n  box-shadow: 0px 4px 34px 0px rgba(0, 0, 0, 0.15);\n  cursor: pointer;\n  font-weight: normal;\n  transition: all ease 0.5s;\n  font-size: 20px;\n}\n\n.avatar-upload .avatar-edit input+label:after {\n  content: \"\\ea13\";\n  font-family: remixicon !important;\n  color: #757575;\n  position: absolute;\n  top: 0;\n  left: 1px;\n  right: 0;\n  text-align: center;\n  margin: auto;\n}\n\n.avatar-upload .avatar-preview {\n  width: 135px;\n  height: 135px;\n  position: relative;\n  border-radius: 4px;\n  border: 6px solid #F8F8F8;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n}\n\n.avatar-upload .avatar-preview>div {\n  width: 100%;\n  height: 100%;\n  border-radius: 4px;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.dark .avatar-upload .avatar-preview {\n  border: 6px solid #2f2f2f;\n}\n\n/* File Upload Area Style\n============================================*/\n.only-file-upload .form__file {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  cursor: pointer;\n  opacity: 0;\n}\n\n.only-file-upload .form__files-container {\n  display: flex;\n  width: 100%;\n  padding: 5px 0;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #ECEEF2;\n  padding: 10px;\n  margin-top: 10px;\n  border-radius: 6px;\n}\n\n.only-file-upload .form__text {\n  font-size: 14px;\n  color: #3A4252;\n  max-width: 450px;\n  whitespace: no-wrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.only-file-upload .form__icon {\n  font-size: 22px;\n  color: #d08f2c;\n  text-decoration: none;\n  background-color: rgba(31, 100, 241, 0.1);\n  width: 35px;\n  height: 35px;\n  line-height: 35px;\n  text-align: center;\n  border-radius: 4px;\n  display: inline-block;\n}\n\n.only-file-upload .form__icon:hover {\n  background-color: #d08f2c;\n  color: #fff;\n}\n\n/* Card Body Custom Padding Area Style\n============================================*/\n.custom-padding-30 {\n  padding: 30px;\n}\n\n.custom-shadow {\n  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.05);\n}\n\n.upcoming-events-slide-two .swiper-pagination {\n  position: initial;\n  line-height: 1;\n  bottom: 0;\n}\n\n.upcoming-events-slide-two .swiper-pagination .swiper-pagination-bullet {\n  background-color: #d08f2c;\n  border-radius: 50px;\n  transition: all ease 0.5s;\n  height: 4px;\n}\n\n.upcoming-events-slide-two .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  width: 24px;\n}\n\n.fw-800 {\n  font-weight: 800;\n}\n\n.fw-900 {\n  font-weight: 900;\n}\n\n.last-child-none .child:last-child {\n  border-bottom: 0 !important;\n  padding-bottom: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.school-nb {\n  padding-left: 30px;\n  padding-right: 30px;\n  margin-bottom: 17.5px;\n  padding-bottom: 17.5px;\n}\n\n.school-nb:last-child {\n  padding-bottom: 0;\n  border-bottom: none !important;\n}\n\n.bg-ecf0ff {\n  background-color: #ecf0ff;\n}\n\n.bg-faf5ff {\n  background-color: #faf5ff;\n}\n\n.bg-fff5ed {\n  background-color: #fff5ed;\n}\n\n.cco-tab-btn {\n  cursor: pointer;\n}\n\n.cco-tab-btn img.hidden {\n  display: none;\n}\n\n.cco-tab-btn.active img {\n  display: none;\n}\n\n.cco-tab-btn.active img.hidden {\n  display: block;\n}\n\n.cco-tab-btn.active .text-body,\n.cco-tab-btn.active .text-secondary,\n.cco-tab-btn.active .text-black,\n.cco-tab-btn.active .text-success,\n.cco-tab-btn.active .text-danger-50 {\n  color: #fff !important;\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n  .p-4 {\n    padding: 15px !important;\n  }\n\n  .fs-16 {\n    font-size: 15px;\n  }\n\n  .fs-20 {\n    font-size: 18px;\n  }\n\n  .fs-24 {\n    font-size: 20px;\n  }\n\n  .fs-28 {\n    font-size: 21px;\n  }\n\n  .file-upload {\n    font-size: 13px !important;\n  }\n\n  .wh-160 {\n    width: 110px;\n    height: 110px;\n  }\n\n  .mw-123 {\n    max-width: 43px;\n  }\n\n  .custom-padding-30 {\n    padding: 20px;\n  }\n\n  .custom-modal .custom-modal-content {\n    width: 320px;\n  }\n\n  .custom-modal.center .custom-modal-content {\n    width: 320px;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .mw-123 {\n    max-width: 120px;\n  }\n}\n\n/* Min width 768px to Max width 992px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .p-4 {\n    padding: 20px !important;\n  }\n\n  .fs-28 {\n    font-size: 24px;\n  }\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .mw-123 {\n    max-width: 98px;\n  }\n\n  .custom-p1 {\n    padding-right: 12px !important;\n  }\n\n  .custom-p2 {\n    padding-left: 12px !important;\n  }\n\n  .custom-p2 .card {\n    border-radius: 0 0 8px 8px !important;\n  }\n\n  .custom-p2 .rounded-start-0 {\n    border: none !important;\n    border-top: 1px solid #ECEEF2 !important;\n  }\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .p-4 {\n    padding: 20px !important;\n  }\n\n  .pb-y-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .py-38 {\n    padding-top: 34px !important;\n    padding-bottom: 34px !important;\n  }\n\n  .mw-123 {\n    max-width: 90px;\n  }\n\n  .custom-p1 {\n    padding-right: 12px !important;\n  }\n\n  .custom-p2 {\n    padding-left: 12px !important;\n  }\n\n  .custom-p2 .card {\n    border-radius: 0 0 8px 8px !important;\n  }\n\n  .custom-p2 .rounded-start-0 {\n    border: none !important;\n    border-top: 1px solid #ECEEF2 !important;\n  }\n}\n\n/* Min width 1400px to Max width 1799px */\n@media only screen and (min-width: 1400px) and (max-width: 1799px) {\n  .py-38 {\n    padding-top: 30px !important;\n    padding-bottom: 30px !important;\n  }\n}\n\n@media only screen and (min-width: 992px) {\n  .mb-lg-30 {\n    margin-bottom: 30px !important;\n  }\n\n  .h-md-100 {\n    height: 100%;\n  }\n}\n\n@media only screen and (min-width: 768px) {\n  .h-md-100 {\n    height: 100%;\n  }\n}\n\n@media only screen and (min-width: 1600px) {\n  .employee-attendance-list li {\n    position: relative;\n  }\n\n  .employee-attendance-list li::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: -50%;\n    transform: translateX(-50%);\n    width: 0.5px;\n    height: 100%;\n    background-color: #ECEEF2;\n  }\n\n  .employee-attendance-list li:first-child::before {\n    display: none;\n  }\n}\n\n@media only screen and (min-width: 1920px) {\n  .custom-xxxl-10 {\n    flex: 0 0 auto;\n    width: 77%;\n  }\n\n  .custom-xxxl-2 {\n    flex: 0 0 auto;\n    width: 23%;\n  }\n}\n\n.c-dropdown::after {\n  display: none;\n}\n\n.select-dropdown .dropdown-toggle {\n  padding: 6.5px 14px;\n  position: relative;\n}\n\n.select-dropdown .dropdown-toggle i {\n  font-size: 18px;\n  line-height: 1;\n  position: relative;\n  top: 2px;\n}\n\n.select-dropdown .dropdown-toggle::after {\n  display: none;\n}\n\n.select-dropdown .dropdown-item:active {\n  color: #fff !important;\n}\n\n.select-dropdown.without-border .dropdown-toggle {\n  padding: 0;\n  border: 0 !important;\n}\n\n.select-dropdown.without-border .dropdown-toggle::after {\n  right: 0;\n}\n\n.categories-tabs .nav-item .nav-link {\n  border-color: #ECEEF2;\n}\n\n.categories-tabs .nav-item .nav-link.active {\n  border-color: #d08f2c;\n}\n\n.categories-tabs .nav-item .nav-link.active span .d-none {\n  display: inline-block !important;\n}\n\n.payment-method .btn-check:checked+.btn,\n.payment-method :not(.btn-check)+.btn:active,\n.payment-method .btn:first-child:active,\n.payment-method .btn.active,\n.payment-method .btn.show {\n  border-color: #d08f2c !important;\n  background-color: #ECF0FF !important;\n}\n\n/* Follow Button Style\n============================================*/\n.follow-button .followed {\n  transition: all ease 0.5s;\n}\n\n.follow-button.followed {\n  background-color: #d08f2c !important;\n  color: #fff !important;\n}\n\n/* Audio player Style\n============================================*/\n.most-popular-tabs {\n  margin-bottom: 20px;\n}\n\n.most-popular-tabs .nav-item .nav-link {\n  padding: 3.5px 12px;\n}\n\n.most-popular-tabs .nav-item .nav-link.active {\n  background-color: #d08f2c !important;\n  color: #fff !important;\n}\n\n.single-play .audio-play-btn {\n  opacity: 0;\n  transition: all ease 0.5s;\n}\n\n.single-play:hover .audio-play-btn {\n  opacity: 1;\n}\n\n.single-play.active .audio-play-btn {\n  opacity: 1;\n}\n\n.doctor-cover-bg {\n  position: relative;\n  z-index: 0;\n}\n\n.doctor-cover-bg::before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 90px;\n  background-color: #fff;\n  z-index: -1;\n}\n\n.doctor-cover-bg .avatar-upload .avatar-edit input+label:after {\n  display: none;\n}\n\n.wave-container .wave-bar {\n  width: 2px;\n  height: 25px;\n  background-color: #C2CDFF;\n  margin-left: 2px;\n  animation: wave-animation 1s infinite ease-in-out;\n  animation-play-state: paused;\n}\n\n.wave-container .wave-bar:nth-child(odd) {\n  animation-delay: 0.2s;\n}\n\n.wave-container .wave-bar:nth-child(even) {\n  animation-delay: 0.4s;\n}\n\n@keyframes wave-animation {\n\n  0%,\n  100% {\n    transform: scaleY(1);\n  }\n\n  50% {\n    transform: scaleY(2);\n  }\n}\n\n.audio-player-for-wave .ri-pause-fill {\n  left: 0 !important;\n}\n\n.mastering-digital-marketing-slide .swiper-pagination {\n  text-align: right;\n  position: absolute;\n  top: 0 !important;\n  right: 0 !important;\n  display: block;\n  padding: 20px 30px;\n  z-index: 0;\n  height: 30px;\n  z-index: 9;\n}\n\n.mastering-digital-marketing-slide .swiper-pagination .swiper-pagination-bullet {\n  background-color: #8695AA;\n  width: 10px;\n  height: 3px;\n  border-radius: 4px;\n  transition: all ease 0.5s;\n  opacity: 1;\n}\n\n.mastering-digital-marketing-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  background-color: #ECEEF2;\n  width: 30px;\n}\n\n.call-overview-tabs .calls-card.bg-primary.active {\n  background-color: #d08f2c !important;\n}\n\n.call-overview-tabs .calls-card.bg-primary.active .text-body.d-block {\n  color: #ECEEF2 !important;\n}\n\n.call-overview-tabs .calls-card.bg-primary.active h3.text-secondary,\n.call-overview-tabs .calls-card.bg-primary.active .text-secondary.h3 {\n  color: #fff !important;\n}\n\n.call-overview-tabs .calls-card.bg-primary.active span.d-flex.align-items-center.align-items-center.text-body {\n  color: #fff !important;\n}\n\n.call-overview-tabs .calls-card.bg-primary.active span.d-flex.align-items-center.align-items-center.text-body span {\n  color: #fff !important;\n}\n\n.call-overview-tabs .calls-card.bg-primary.active span.d-flex.align-items-center.align-items-center.text-body .material-symbols-outlined {\n  color: #fff !important;\n}\n\n.call-overview-tabs .calls-card.bg-primary.active img {\n  filter: brightness(100);\n}\n\n.call-overview-tabs .calls-card.bg-primary-divs.active {\n  background-color: #b27c26 !important;\n}\n\n.call-overview-tabs .calls-card.bg-primary-divs.active .text-body.d-block {\n  color: #ECEEF2 !important;\n}\n\n.call-overview-tabs .calls-card.bg-primary-divs.active h3.text-secondary,\n.call-overview-tabs .calls-card.bg-primary-divs.active .text-secondary.h3 {\n  color: #fff !important;\n}\n\n.call-overview-tabs .calls-card.bg-primary-divs.active span.d-flex.align-items-center.align-items-center.text-body {\n  color: #fff !important;\n}\n\n.call-overview-tabs .calls-card.bg-primary-divs.active span.d-flex.align-items-center.align-items-center.text-body span {\n  color: #fff !important;\n}\n\n.call-overview-tabs .calls-card.bg-primary-divs.active span.d-flex.align-items-center.align-items-center.text-body .material-symbols-outlined {\n  color: #fff !important;\n}\n\n.call-overview-tabs .calls-card.bg-primary-divs.active img {\n  filter: brightness(100);\n}\n\n.call-overview-tabs .calls-card.bg-dangers.active {\n  background-color: #EE3E08 !important;\n}\n\n.call-overview-tabs .calls-card.bg-dangers.active .text-body.d-block {\n  color: #ECEEF2 !important;\n}\n\n.call-overview-tabs .calls-card.bg-dangers.active h3.text-secondary,\n.call-overview-tabs .calls-card.bg-dangers.active .text-secondary.h3 {\n  color: #fff !important;\n}\n\n.call-overview-tabs .calls-card.bg-dangers.active span.d-flex.align-items-center.align-items-center.text-body {\n  color: #fff !important;\n}\n\n.call-overview-tabs .calls-card.bg-dangers.active span.d-flex.align-items-center.align-items-center.text-body span {\n  color: #fff !important;\n}\n\n.call-overview-tabs .calls-card.bg-dangers.active span.d-flex.align-items-center.align-items-center.text-body .material-symbols-outlined {\n  color: #fff !important;\n}\n\n.call-overview-tabs .calls-card.bg-dangers.active img {\n  filter: brightness(100);\n}\n\n.search-overlay {\n  display: none;\n}\n\n.search-overlay .form-control {\n  font-size: 12px;\n  height: 40px;\n}\n\n.search-overlay .form-control::placeholder {\n  font-size: 12px;\n}\n\n.close-btn {\n  display: none !important;\n}\n\n.close-btn.active {\n  display: block !important;\n  background-color: #FD5812 !important;\n  color: #fff !important;\n}\n\n.recently-played .table-responsive .table tbody tr td {\n  border-color: #F6F7F9;\n  padding: 12px 12px !important;\n}\n\n.recently-played .table-responsive .table tbody tr:last-child td {\n  border: none;\n}\n\n.popular-hosts .table-responsive .table tbody tr td {\n  border-color: #F6F7F9;\n  padding-left: 12px !important;\n  padding-right: 12px !important;\n}\n\n.popular-hosts .table-responsive .table tbody tr:last-child td {\n  border: none;\n}\n\n.top-podcasts .table-responsive .table thead tr th {\n  padding-left: 18px;\n  padding-right: 18px;\n}\n\n.top-podcasts .table-responsive .table tbody tr td {\n  border-color: #F6F7F9;\n  padding-left: 18px;\n  padding-right: 18px;\n}\n\n.top-podcasts .table-responsive .table tbody tr:last-child td {\n  border: none;\n}\n\n.light-mode-btn i {\n  color: #FE7A36 !important;\n}\n\n.light-mode-btn .dark_mode {\n  display: none;\n}\n\n.dark .light_mode {\n  display: none;\n}\n\n.dark .dark_mode {\n  display: block;\n}\n\n.apexcharts-tooltip-marker {\n  line-height: 13px !important;\n}\n\n.apexcharts-tooltip-marker::before {\n  font-size: 12px !important;\n}\n\n@media only screen and (max-width: 767px) {\n  .recently-played .table-responsive .table {\n    width: 770px;\n  }\n\n  .top-podcasts .table-responsive .table {\n    width: 745px;\n  }\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .recently-played .table-responsive .table {\n    width: 860px;\n  }\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .recently-played .table-responsive .table {\n    width: 860px;\n  }\n}\n\n.-right-10 {\n  right: -10px;\n}\n\n[dir=rtl] .-right-10 {\n  right: auto;\n  left: -10px;\n}\n\n.text-000 {\n  color: #000 !important;\n}\n\n.-mr-10 {\n  margin-right: -10px;\n}\n\n.bsts-products-slide .swiper-button-prev,\n.bsts-products-slide .swiper-button-next {\n  background-color: #d08f2c;\n  color: #fff;\n  width: 30px;\n  height: 30px;\n  border-radius: 100%;\n}\n\n.bsts-products-slide .swiper-button-prev::after,\n.bsts-products-slide .swiper-button-next::after {\n  font-size: 18px;\n}\n\n.bsts-products-slide .swiper-button-prev.swiper-button-disabled,\n.bsts-products-slide .swiper-button-next.swiper-button-disabled {\n  cursor: auto;\n  pointer-events: auto;\n}\n\n.ra-calendar .react-calendar__month-view__days .react-calendar__tile {\n  background-color: #E6EFF2;\n  border-radius: 10px;\n  border: 2px solid #fff;\n  height: 50px;\n}\n\n.dark .ra-calendar .react-calendar__month-view__days .react-calendar__tile {\n  background-color: #000;\n  border: 2px solid #333;\n}\n\n.bs-rs-appointments {\n  padding-left: 11px;\n  padding-right: 5px;\n}\n\n.bs-rs-appointments .bs-rs-appointments-list {\n  border-left: 1px dashed #D5D9E2;\n  padding-left: 37px;\n}\n\n.bs-rs-appointments .bs-rs-appointments-list .verifyIcon {\n  left: -37px !important;\n}\n\n[dir=rtl] .bs-rs-appointments {\n  padding-left: 5px;\n  padding-right: 11px;\n}\n\n[dir=rtl] .bs-rs-appointments .bs-rs-appointments-list {\n  padding-left: 0;\n  padding-right: 37px;\n  border-left: none;\n  border-right: 1px dashed #D5D9E2;\n}\n\n[dir=rtl] .bs-rs-appointments .bs-rs-appointments-list .verifyIcon {\n  left: auto !important;\n  right: -60px !important;\n}\n\n@media only screen and (max-width: 767px) {\n  .default-table-area.campaigns-table.style-two.bs-top-customers .table-responsive .table {\n    width: 940px !important;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .default-table-area.campaigns-table.style-two.bs-top-customers .table-responsive .table {\n    width: 940px !important;\n  }\n}\n\n.pr-5 {\n  padding-right: 5px;\n}\n\n.doctor-welcome-card {\n  padding-left: 105px;\n  padding-right: 80px;\n}\n\n.doctor-main-wrapper {\n  padding-left: 80px;\n  padding-right: 80px;\n}\n\n.pd-text-content h1,\n.pd-text-content .h1 {\n  font-size: 20px;\n}\n\n.pd-text-content h2,\n.pd-text-content .h2 {\n  font-size: 19px;\n}\n\n.pd-text-content h3,\n.pd-text-content .h3 {\n  font-size: 18px;\n}\n\n.pd-text-content h4,\n.pd-text-content .h4 {\n  font-size: 17px;\n}\n\n.pd-text-content h5,\n.pd-text-content .h5 {\n  font-size: 16px;\n}\n\n.pd-text-content h6,\n.pd-text-content .h6 {\n  font-size: 15px;\n}\n\n.pd-text-content ul,\n.pd-text-content ol {\n  margin-bottom: 0;\n  margin-top: 15px;\n  padding-left: 17px;\n}\n\n.pd-text-content ul li,\n.pd-text-content ol li {\n  line-height: 1.8;\n  margin-bottom: 5px;\n}\n\n.pd-text-content ul li::marker,\n.pd-text-content ol li::marker {\n  color: #d08f2c;\n  font-size: 18px;\n}\n\n.pd-text-content ul li:last-child,\n.pd-text-content ol li:last-child {\n  margin-bottom: 0;\n}\n\n.-po-left-26 {\n  left: -26px !important;\n}\n\n.recent-appointment-notify {\n  border-left: 1px dashed #D5D9E2;\n  padding-left: 26px;\n}\n\n.dark .doctor-cover-bg::before {\n  background-color: #000;\n}\n\n[dir=rtl] .pr-5 {\n  padding-right: 0;\n  padding-left: 5px;\n}\n\n[dir=rtl] .pd-text-content ul,\n[dir=rtl] .pd-text-content ol {\n  padding-left: 0;\n  padding-right: 17px;\n}\n\n[dir=rtl] .-po-left-26 {\n  left: 0 !important;\n  right: -50px !important;\n}\n\n[dir=rtl] .recent-appointment-notify {\n  border-left: none;\n  border-right: 1px dashed #D5D9E2;\n  padding-left: 0;\n  padding-right: 26px;\n}\n\n@media only screen and (min-width: 992px) {\n  .default-table-area.campaigns-table.latest-transaction-table.doctor-patients-table .table-responsive .table {\n    width: 100% !important;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .doctor-welcome-card {\n    padding-top: 20px;\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .doctor-main-wrapper {\n    padding-left: 0;\n    padding-right: 0;\n    margin-top: 25px !important;\n  }\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .doctor-welcome-card {\n    padding-left: 50px;\n    padding-right: 50px;\n  }\n\n  .doctor-main-wrapper {\n    padding-left: 0;\n    padding-right: 0;\n    margin-top: 25px !important;\n  }\n}\n\n@media only screen and (min-width: 1400px) and (max-width: 1599px) {\n  .doctor-welcome-card {\n    padding-left: 50px;\n    padding-right: 50px;\n  }\n\n  .doctor-main-wrapper {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n}\n\n.p-25 {\n  padding: 25px;\n}\n\n.mt-10 {\n  margin-top: 10px;\n}\n\n.gad-bg {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n  border-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.default-table-area.upcoming-vip-reservations-table.style-two .table-responsive .table thead tr th {\n  padding-bottom: 9px;\n  padding-left: 21px;\n  padding-right: 21px;\n}\n\n.default-table-area.upcoming-vip-reservations-table.style-two .table-responsive .table thead tr th:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.upcoming-vip-reservations-table.style-two .table-responsive .table thead tr th:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.upcoming-vip-reservations-table.style-two .table-responsive .table tbody tr td {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  padding-left: 21px;\n  padding-right: 21px;\n}\n\n.default-table-area.upcoming-vip-reservations-table.style-two .table-responsive .table tbody tr td:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.upcoming-vip-reservations-table.style-two .table-responsive .table tbody tr td:last-child {\n  padding-right: 0 !important;\n}\n\n.popular-rooms-slide .swiper-pagination {\n  position: initial;\n  margin-top: 10px;\n}\n\n.popular-rooms-slide .swiper-pagination .swiper-pagination-bullet {\n  border-radius: 30px;\n  height: 5px;\n}\n\n.popular-rooms-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  width: 20px;\n  background-color: #d08f2c;\n}\n\n@media only screen and (max-width: 767px) {\n  .default-table-area.upcoming-vip-reservations-table.style-two .table-responsive .table {\n    width: 693px !important;\n  }\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .default-table-area.upcoming-vip-reservations-table.style-two .table-responsive .table tbody tr td {\n    padding-left: 13px;\n    padding-right: 13px;\n  }\n\n  .default-table-area.upcoming-vip-reservations-table.style-two .table-responsive .table tbody tr td .fs-14 {\n    font-size: 12px !important;\n  }\n}\n\n.welcome-real-estate-agent {\n  padding: 10px 25px 70px;\n  padding-left: 75px;\n  padding-right: 75px;\n}\n\n.welcome-card-wrap {\n  margin-top: -90px;\n}\n\n.my-featured-listings-slide .swiper-pagination {\n  position: initial;\n  margin-top: 10px;\n}\n\n.my-featured-listings-slide .swiper-pagination .swiper-pagination-bullet {\n  border-radius: 30px;\n  height: 5px;\n}\n\n.my-featured-listings-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  width: 20px;\n  background-color: #d08f2c;\n}\n\n.rea-app-btn {\n  padding: 7px 17.5px;\n  margin-bottom: 31px;\n  display: inline-block;\n  border-radius: 0.375rem;\n  color: #fff !important;\n  background-color: #1a5710;\n  font-size: 16px;\n  text-decoration: none;\n}\n\n.rea-app-btn:hover {\n  background-color: #25b003;\n  color: #fff;\n}\n\n.rea-client-ratings-slide .swiper-pagination {\n  position: initial;\n  margin-top: 10px;\n}\n\n.rea-client-ratings-slide .swiper-pagination .swiper-pagination-bullet {\n  border-radius: 30px;\n  height: 5px;\n}\n\n.rea-client-ratings-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  width: 20px;\n  background-color: #d08f2c;\n}\n\n@media only screen and (max-width: 767px) {\n  .welcome-real-estate-agent {\n    padding: 0 0 70px;\n    text-align: center;\n  }\n\n  .welcome-real-estate-agent .fs-32 {\n    font-size: 25px;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .welcome-real-estate-agent {\n    text-align: center;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .cc-recent-transactions .table {\n    width: 767px;\n  }\n}\n\n.default-table-area.ct-gainers-losers.style-two .table-responsive .table tbody tr td {\n  padding-top: 11px;\n  padding-bottom: 11px;\n}\n\n@media only screen and (max-width: 767px) {\n  .default-table-area.ct-recent-transactions2.style-two .table-responsive .table {\n    width: 767px;\n  }\n}\n\n.default-table-area.cp-transactions-history.style-two .table-responsive .table tbody tr td {\n  padding-top: 12.5px;\n  padding-bottom: 12.5px;\n}\n\n@media only screen and (max-width: 767px) {\n  .default-table-area.cp-individual-asset-performance.style-two .table-responsive .table {\n    width: 800px;\n  }\n\n  .default-table-area.cp-individual-asset-performance.style-two .table-responsive .table thead tr th {\n    font-size: 13px;\n  }\n\n  .default-table-area.cp-individual-asset-performance.style-two .table-responsive .table tbody tr td {\n    font-size: 13px;\n  }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .default-table-area.cp-individual-asset-performance.style-two .table-responsive .table thead tr th {\n    font-size: 13px;\n  }\n\n  .default-table-area.cp-individual-asset-performance.style-two .table-responsive .table tbody tr td {\n    font-size: 13px;\n  }\n}\n\n/** Sidebar Menu Area\n===================================**/\n.sidebar-area {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 270px;\n  height: 100%;\n  transition: all ease 0.5s;\n  padding-bottom: 30px;\n  background-color: #fff;\n}\n\n.sidebar-area .logo {\n  padding: 21.5px 25px;\n  border-bottom: 1px solid #ECF0FF;\n}\n\n.sidebar-area .logo .logo-text {\n  font-size: 24px;\n  position: absolute;\n  top: -4px;\n  left: 33px;\n  transition: all ease 0.5s;\n  font-weight: 700;\n}\n\n.sidebar-area.dark .logo {\n  border-color: #262626 !important;\n}\n\n.sidebar-area .sidebar-burger-menu {\n  transition: all ease 0.5s;\n  right: 21px !important;\n}\n\n.sidebar-menu {\n  padding-top: 20px;\n  padding-left: 25px;\n  padding-right: 25px;\n  padding-bottom: 60px;\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n  /* width */\n  /* Track */\n  /* Handle */\n  /* Handle on hover */\n}\n\n.sidebar-menu::-webkit-scrollbar {\n  width: 5px;\n}\n\n.sidebar-menu::-webkit-scrollbar-track {\n  background: #fff;\n}\n\n.sidebar-menu::-webkit-scrollbar-thumb {\n  background: #c5c5c5;\n}\n\n.sidebar-menu::-webkit-scrollbar-thumb:hover {\n  background: #888;\n}\n\n.sidebar-menu .accordion {\n  border: none;\n  background-color: transparent;\n}\n\n.sidebar-menu .accordion .accordion-item {\n  border: none;\n  background-color: transparent;\n  margin-bottom: 3px;\n}\n\n.sidebar-menu .accordion .accordion-item .accordion-header .accordion-button {\n  background-color: transparent;\n  border-radius: 5px;\n  border: none;\n  box-shadow: none;\n  font-weight: 500;\n  padding: 9.5px 13px;\n  display: flex;\n  white-space: nowrap;\n  transition: all ease 0.5s;\n}\n\n.sidebar-menu .accordion .accordion-item .accordion-header .accordion-button::after {\n  width: 15px;\n  height: 15px;\n  background-size: contain;\n}\n\n.sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .material-symbols-outlined {\n  margin-right: 8px;\n  font-size: 21px;\n  color: #fff;\n}\n\n.sidebar-menu .accordion .accordion-item .accordion-header .accordion-button:hover {\n  background-color: #F6F7F9;\n}\n\n.sidebar-menu .accordion .accordion-item .accordion-header .accordion-button:hover .material-symbols-outlined {\n  color: #3A4252;\n}\n\n.sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .title {\n  color: #3A4252;\n}\n\n.sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .count {\n  background-color: #FFF5ED;\n  color: #FD5812;\n  border-radius: 50px;\n  color: #FD5812;\n  font-size: 11px;\n  font-weight: 600;\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n  text-align: center;\n  position: absolute;\n  top: 50%;\n  right: 42px;\n  transform: translateY(-50%);\n}\n\n.sidebar-menu .accordion .accordion-item .accordion-header .accordion-button[aria-expanded=true] {\n  background-color: #F6F7F9;\n}\n\n.sidebar-menu .accordion .accordion-item .accordion-collapse .accordion-body {\n  padding: 0;\n}\n\n.sidebar-menu .menu-item {\n  list-style-type: none;\n  margin-bottom: 5px;\n}\n\n.sidebar-menu .menu-item .menu-link {\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  color: #3A4252;\n  padding: 9.5px 12px;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n}\n\n.sidebar-menu .menu-item .menu-link .title {\n  transition: all ease 0.5s;\n}\n\n.sidebar-menu .menu-item .menu-link .tag {\n  background-color: #FFE8D4;\n  width: 28px;\n  height: 16px;\n  font-size: 10px;\n  color: #FD5812;\n  display: inline-block;\n  text-align: center;\n  border-radius: 2px;\n  position: relative;\n  margin-left: 8px;\n}\n\n.sidebar-menu .menu-item .menu-link .tag::before {\n  content: \"\";\n  position: absolute;\n  top: 4px;\n  left: -3px;\n  width: 8px;\n  height: 8px;\n  background-color: #FFE8D4;\n  border-radius: 1px;\n  transform: rotate(45deg);\n  z-index: -1;\n}\n\n.sidebar-menu .menu-item .menu-link .tag.new {\n  background-color: #D8FFC8;\n  color: #37D80A;\n}\n\n.sidebar-menu .menu-item .menu-link .tag.new::before {\n  background-color: #D8FFC8;\n}\n\n.sidebar-menu .menu-item .menu-link .material-symbols-outlined {\n  margin-right: 8px;\n  font-size: 21px;\n  color: #fff;\n}\n\n.sidebar-menu .menu-item .menu-link.logout {\n  background-color: #f5f5f9;\n}\n\n.sidebar-menu .menu-item .menu-link.active,\n.sidebar-menu .menu-item .menu-link:hover {\n  background-color: #f5f5f9;\n  color: #d08f2c;\n}\n\n.sidebar-menu .menu-item .menu-link.active .material-symbols-outlined,\n.sidebar-menu .menu-item .menu-link:hover .material-symbols-outlined {\n  color: #d08f2c;\n}\n\n.sidebar-menu .menu-item .menu-link.active::before,\n.sidebar-menu .menu-item .menu-link:hover::before {\n  opacity: 1;\n  border-color: #d08f2c;\n}\n\n.sidebar-menu .menu-item .menu-link.active::after,\n.sidebar-menu .menu-item .menu-link:hover::after {\n  border-color: #fff;\n}\n\n.sidebar-menu .sub-menu {\n  padding: 0;\n  margin-top: 4px;\n  margin-bottom: 0;\n}\n\n.sidebar-menu .sub-menu .menu-item {\n  margin-bottom: 4px;\n}\n\n.sidebar-menu .sub-menu .menu-item .menu-link {\n  padding: 9.5px 18px;\n  padding-left: 38px;\n  transition: all ease 0.5s;\n  position: relative;\n  font-size: 14px;\n  color: #fff;\n  display: flex;\n  white-space: nowrap;\n}\n\n.sidebar-menu .sub-menu .menu-item .menu-link::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 10px;\n  height: 10px;\n  border: 1px solid #fff;\n  left: 18px;\n  border-radius: 50px;\n  transition: all ease 0.5s;\n}\n\n.sidebar-menu .sub-menu .menu-item .menu-link.active,\n.sidebar-menu .sub-menu .menu-item .menu-link:hover {\n  background-color: #ECF0FF;\n  color: #d08f2c;\n}\n\n.sidebar-menu .sub-menu .menu-item .menu-link.active::before,\n.sidebar-menu .sub-menu .menu-item .menu-link:hover::before {\n  opacity: 1;\n  border-color: #d08f2c;\n}\n\n.sidebar-menu .sub-menu .menu-item .menu-link.active::after,\n.sidebar-menu .sub-menu .menu-item .menu-link:hover::after {\n  border-color: #fff;\n}\n\n.sidebar-menu .menu-title {\n  position: relative;\n  display: block;\n  z-index: 1;\n  margin-top: 12px;\n}\n\n.sidebar-menu .menu-title .menu-title-text {\n  font-size: 12px;\n  font-weight: 500;\n  color: #fff;\n  display: block;\n  margin-bottom: 7px;\n}\n\n.sidebar-menu .menu-title:first-child {\n  margin-top: 0;\n}\n\n@media only screen and (min-width: 1200px) {\n  .main-wrapper-content.active .sidebar-area {\n    width: 80px;\n    z-index: 2;\n    transition: all ease 0.5s;\n  }\n\n  .main-wrapper-content.active .sidebar-area .logo {\n    padding-left: 25px;\n    padding-right: 25px;\n  }\n\n  .main-wrapper-content.active .sidebar-area .logo .logo-text {\n    left: 0;\n    opacity: 0;\n    visibility: hidden;\n  }\n\n  .main-wrapper-content.active .sidebar-area .sidebar-menu {\n    padding: 17px;\n    padding-bottom: 60px;\n  }\n\n  .main-wrapper-content.active .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button {\n    padding: 10px;\n  }\n\n  .main-wrapper-content.active .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button::after {\n    display: none;\n  }\n\n  .main-wrapper-content.active .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .material-symbols-outlined {\n    margin-right: 0;\n  }\n\n  .main-wrapper-content.active .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .title {\n    display: none;\n  }\n\n  .main-wrapper-content.active .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .count {\n    display: none;\n  }\n\n  .main-wrapper-content.active .sidebar-area .sidebar-menu .menu-item .menu-link .title {\n    display: none;\n  }\n\n  .main-wrapper-content.active .sidebar-area .sidebar-menu .menu-header {\n    display: none;\n  }\n\n  .main-wrapper-content.active .sidebar-area .sidebar-menu .sub-menu {\n    display: none;\n  }\n\n  .main-wrapper-content.active .sidebar-area .sidebar-menu .menu-title {\n    margin-top: 15px;\n    margin-bottom: 15px;\n  }\n\n  .main-wrapper-content.active .sidebar-area .sidebar-menu .menu-title .menu-title-text {\n    margin-bottom: 0;\n    font-size: 0;\n    position: relative;\n    transition: all ease 0.5s;\n  }\n\n  .main-wrapper-content.active .sidebar-area .sidebar-menu .menu-title .menu-title-text::before {\n    top: 50%;\n    width: 50px;\n    content: \"\";\n    height: 1px;\n    position: absolute;\n    transform: translateY(-50%);\n    background: #ECEEF2;\n  }\n\n  .main-wrapper-content.active .sidebar-area:hover {\n    width: 270px;\n    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  }\n\n  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .menu-header {\n    display: block;\n  }\n\n  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button {\n    padding: 10px;\n  }\n\n  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button::after {\n    display: block;\n  }\n\n  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .material-symbols-outlined {\n    margin-right: 8px;\n  }\n\n  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .title {\n    display: block;\n  }\n\n  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .count {\n    display: block;\n  }\n\n  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .sub-menu {\n    display: block;\n  }\n\n  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .sub-menu .menu-item .menu-link {\n    padding-left: 35px;\n  }\n\n  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .menu-item .menu-link .title {\n    display: block;\n  }\n\n  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .menu-title {\n    margin-top: 12px;\n    margin-bottom: 0;\n  }\n\n  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .menu-title .menu-title-text {\n    margin-bottom: 7px;\n    font-size: 12px;\n  }\n\n  .main-wrapper-content.active .sidebar-area:hover .sidebar-menu .menu-title .menu-title-text::before {\n    display: none;\n  }\n\n  .main-wrapper-content.active .sidebar-area:hover .logo .logo-text {\n    left: 33px;\n    opacity: 1;\n    visibility: visible;\n  }\n\n  .main-wrapper-content.active .sidebar-area:hover .sidebar-burger-menu {\n    opacity: 1 !important;\n    z-index: 1 !important;\n    right: 21px !important;\n  }\n\n  .main-wrapper-content.compact-sidebar .main-content {\n    padding-left: 92px;\n  }\n\n  .main-wrapper-content.compact-sidebar .main-content .header-area .left-header-content ul li.hbm {\n    display: none !important;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area {\n    width: 80px;\n    z-index: 2;\n    transition: all ease 0.5s;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-burger-menu {\n    display: none !important;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area .logo {\n    padding-left: 25px;\n    padding-right: 25px;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area .logo .logo-text {\n    left: 0;\n    opacity: 0;\n    visibility: hidden;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu {\n    padding: 17px;\n    padding-bottom: 60px;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button {\n    padding: 10px;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button::after {\n    display: none;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .material-symbols-outlined {\n    margin-right: 0;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .title {\n    display: none;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .count {\n    display: none;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .menu-item .menu-link .title {\n    display: none;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .menu-header {\n    display: none;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .sub-menu {\n    display: none;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .menu-title {\n    margin-top: 15px;\n    margin-bottom: 15px;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .menu-title .menu-title-text {\n    margin-bottom: 0;\n    font-size: 0;\n    position: relative;\n    transition: all ease 0.5s;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area .sidebar-menu .menu-title .menu-title-text::before {\n    top: 50%;\n    width: 50px;\n    content: \"\";\n    height: 1px;\n    position: absolute;\n    transform: translateY(-50%);\n    background: #ECEEF2;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area:hover {\n    width: 270px;\n    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .menu-header {\n    display: block;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button {\n    padding: 10px;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button::after {\n    display: block;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .material-symbols-outlined {\n    margin-right: 8px;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .title {\n    display: block;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .count {\n    display: block;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .sub-menu {\n    display: block;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .sub-menu .menu-item .menu-link {\n    padding-left: 35px;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .menu-item .menu-link .title {\n    display: block;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .menu-title {\n    margin-top: 12px;\n    margin-bottom: 0;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .menu-title .menu-title-text {\n    margin-bottom: 7px;\n    font-size: 12px;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area:hover .sidebar-menu .menu-title .menu-title-text::before {\n    display: none;\n  }\n\n  .main-wrapper-content.compact-sidebar .sidebar-area:hover .logo .logo-text {\n    left: 33px;\n    opacity: 1;\n    visibility: visible;\n  }\n\n  .dark .main-wrapper-content.active .sidebar-area .sidebar-menu .menu-title .menu-title-text::before {\n    background: #555;\n  }\n}\n\n[dir=rtl] {\n  /* Min width 1200px */\n}\n\n@media only screen and (min-width: 1200px) {\n  [dir=rtl] .main-wrapper-content.compact-sidebar .main-content {\n    padding-left: 25px;\n    padding-right: 106px;\n  }\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n  .sidebar-area {\n    top: 0;\n    z-index: 2;\n    width: 300px !important;\n  }\n\n  .main-content {\n    padding-left: 0;\n    padding-top: 0;\n  }\n\n  .main-content .inner-main-content {\n    padding-right: 0;\n  }\n}\n\n/* Min width 768px to Max width 991px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .main-content {\n    padding-left: 0;\n  }\n\n  .main-content .inner-main-content {\n    padding-right: 0;\n  }\n}\n\n/* Max width 1199px */\n@media only screen and (max-width: 1199px) {\n  .sidebar-area {\n    z-index: 2;\n    left: -350px;\n  }\n\n  .sidebar-area .logo {\n    border-bottom: 1px solid #ededed;\n  }\n\n  .sidebar-area .logo .logo-text {\n    left: 33px;\n  }\n\n  .sidebar-area .sidebar-burger-menu {\n    right: 20px !important;\n  }\n\n  .main-wrapper-content.active .sidebar-area {\n    width: 270px;\n    left: 0;\n    box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;\n  }\n\n  .main-wrapper-content.active .sidebar-area .logo .logo-text {\n    left: 33px;\n    opacity: 1;\n    visibility: visible;\n  }\n\n  .main-wrapper-content.active .sidebar-area .sidebar-burger-menu {\n    opacity: 1 !important;\n    z-index: 1 !important;\n    right: 20px !important;\n  }\n\n  .main-wrapper-content.active .sidebar-area .sidebar-menu {\n    padding-bottom: 150px;\n    padding: 25px;\n    padding-top: 20px;\n    padding-bottom: 60px;\n  }\n\n  .main-wrapper-content.active .sidebar-area .sidebar-menu .menu-header {\n    display: block;\n  }\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .main-content {\n    padding-left: 0;\n  }\n\n  .main-content .inner-main-content {\n    padding-right: 0;\n  }\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .sidebar-area {\n    width: 250px;\n    z-index: 2;\n  }\n\n  .sidebar-menu {\n    padding-left: 15px;\n    padding-right: 15px;\n    padding-top: 15px;\n  }\n\n  .sidebar-menu .menu-title .menu-title-text {\n    font-size: 12px;\n  }\n\n  .sidebar-menu .menu-item .menu-link.menu-toggle::after {\n    top: 22px;\n  }\n\n  .sidebar-menu .sub-menu .menu-item .menu-link {\n    padding-left: 35px;\n  }\n\n  .sidebar-menu .sub-menu .menu-item .menu-link::before {\n    left: 18px;\n  }\n}\n\n/* Min width 1400px to Max width 1799px */\n@media only screen and (min-width: 1400px) and (max-width: 1799px) {\n  .sidebar-area {\n    width: 250px;\n  }\n\n  .sidebar-menu {\n    padding-left: 25px;\n    padding-right: 25px;\n    padding-top: 15px;\n  }\n\n  .sidebar-menu .menu-title .menu-title-text {\n    font-size: 12px;\n  }\n\n  .sidebar-menu .menu-item .menu-link.menu-toggle::after {\n    top: 22px;\n  }\n\n  .sidebar-menu .sub-menu .menu-item .menu-link {\n    padding-left: 35px;\n  }\n\n  .sidebar-menu .sub-menu .menu-item .menu-link::before {\n    left: 18px;\n  }\n}\n\n/* Main Content Area Style\n============================================*/\n.main-content {\n  padding-left: 300px;\n  transition: all ease 0.5s;\n  padding-right: 25px;\n  min-height: 100vh;\n}\n\n.main-content .inner-main-content {\n  padding-right: 18px;\n  transition: all ease 0.5s;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: 89.5vh;\n}\n\n@media only screen and (min-width: 1200px) {\n  .main-wrapper-content.active .main-content {\n    padding-left: 92px;\n  }\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .main-content {\n    padding-left: 262px;\n    transition: all ease 0.5s;\n    padding-right: 12px;\n  }\n}\n\n/* Min width 1400px to Max width 1799px */\n@media only screen and (min-width: 1400px) and (max-width: 1799px) {\n  .main-content {\n    padding-left: 275px;\n    transition: all ease 0.5s;\n    padding-right: 15px;\n  }\n}\n\n/* Max width 1199px */\n@media only screen and (max-width: 1199px) {\n  .main-content {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n}\n\n/* Header Area Style\n============================================*/\n.header-area {\n  padding: 12px 25px;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.header-area.sticky {\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateZ(0);\n  }\n}\n\n.left-header-content ul li {\n  margin-right: 25px;\n}\n\n.left-header-content ul li .header-burger-menu .material-symbols-outlined {\n  transition: all ease 0.5s;\n  font-size: 24px;\n  position: relative;\n  top: 3.5px;\n  color: #fff;\n}\n\n.left-header-content ul li .header-burger-menu .material-symbols-outlined:hover {\n  color: #d08f2c;\n}\n\n.left-header-content ul li .src-form .form-control {\n  height: 44px;\n  background-color: #F6F7F9;\n  border-color: #F6F7F9;\n  padding: 10px 16px;\n  border-radius: 7px;\n  width: 260px;\n}\n\n.left-header-content ul li .src-form .form-control:focus {\n  border-color: #d08f2c;\n}\n\n.left-header-content ul li .src-form .src-btn {\n  right: 16px !important;\n}\n\n.left-header-content ul li .src-form .src-btn .material-symbols-outlined {\n  color: #d08f2c;\n  font-size: 20px;\n  position: relative;\n  top: 3px;\n}\n\n.left-header-content ul li .notifications.dropdown .btn-secondary {\n  background-color: transparent;\n  line-height: 1;\n}\n\n.left-header-content ul li .notifications.dropdown .btn-secondary .material-symbols-outlined {\n  font-size: 24px;\n  color: #fff;\n  position: relative;\n  top: 2px;\n  transition: all ease 0.5s;\n}\n\n.left-header-content ul li .notifications.dropdown .btn-secondary:hover .material-symbols-outlined {\n  color: #d08f2c;\n}\n\n.left-header-content ul li .notifications.dropdown .dropdown-menu {\n  width: 240px;\n  border-radius: 7px;\n  background: #fff;\n  box-shadow: 0px 4px 45px 0px rgba(0, 0, 0, 0.1);\n  transform: translate(0px, 30px) !important;\n  left: auto !important;\n  right: 0 !important;\n}\n\n.left-header-content ul li .notifications.dropdown .dropdown-menu .dropdown-item {\n  white-space: inherit;\n  width: 53px;\n}\n\n.left-header-content ul li .notifications.dropdown .dropdown-menu .dropdown-item span {\n  font-size: 12px;\n  margin-top: 5px;\n  display: block;\n  color: #000000;\n}\n\n.left-header-content ul li .notifications.dropdown .dropdown-menu .dropdown-item:hover {\n  background-color: transparent;\n}\n\n.left-header-content ul li:last-child {\n  margin-right: 0;\n}\n\n.left-header-content ul li.logo-box {\n  display: none;\n}\n\n.right-header-content .header-right-item {\n  margin-right: 25px;\n  position: relative;\n  top: 3.5px;\n}\n\n.right-header-content .header-right-item .light-dark .material-symbols-outlined {\n  font-size: 24px;\n  color: #FE7A36;\n  cursor: pointer;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .btn-secondary {\n  background: transparent;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .btn-secondary .material-symbols-outlined {\n  font-size: 24px;\n  color: #fff;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .btn-secondary.badge {\n  position: relative;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .btn-secondary.badge::before {\n  content: \"\";\n  position: absolute;\n  top: 3px;\n  right: 3px;\n  width: 7px;\n  height: 7px;\n  background-color: #FD5812;\n  border-radius: 50px;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .btn-secondary.dropdown-toggle {\n  padding-right: 16px !important;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .btn-secondary.dropdown-toggle::after {\n  font-family: \"remixicon\";\n  content: \"\\ea4e\";\n  position: absolute;\n  top: 3px;\n  right: -2px;\n  margin: 0;\n  border: 0;\n  color: #fff;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu {\n  width: 240px;\n  border-radius: 7px;\n  background: #fff;\n  box-shadow: 0px 4px 45px 0px rgba(0, 0, 0, 0.1);\n  transform: translate(0px, 30px) !important;\n  left: auto !important;\n  right: 0 !important;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .title {\n  padding: 12px 20px;\n  display: inline-block;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .notification-menu {\n  padding: 0;\n  border-top: 1px dashed #eeeeee;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .notification-menu:last-child .dropdown-item {\n  border-radius: 0 0 6px 6px;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .notification-menu.unseen {\n  position: relative;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .notification-menu.unseen::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 5px;\n  height: 5px;\n  background-color: #d08f2c;\n  border-radius: 50px;\n  right: 20px;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item {\n  white-space: inherit;\n  padding: 12px 20px;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item .material-symbols-outlined {\n  width: 44px;\n  height: 44px;\n  line-height: 44px;\n  background-color: #f6f5fe;\n  text-align: center;\n  border-radius: 50px;\n  font-size: 22px;\n  transition: all ease 0.5s;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item p {\n  margin-bottom: 0;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:hover,\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:focus,\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item.active,\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:focus-visible {\n  background-color: #ebf2fa;\n  color: #fff;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:hover i,\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:hover .material-symbols-outlined,\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:focus i,\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:focus .material-symbols-outlined,\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item.active i,\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item.active .material-symbols-outlined,\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:focus-visible i,\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:focus-visible .material-symbols-outlined {\n  background-color: #d08f2c;\n  color: #fff !important;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:focus {\n  background-color: #ebf2fa;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .view-all {\n  padding: 12px 20px;\n  border-top: 1px dashed #eeeeee;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .view-all span {\n  position: relative;\n  display: inline-block;\n  padding-bottom: 1px;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .view-all span::before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  background-color: #d08f2c;\n  transform: scale(0);\n  transition: all ease 0.5s;\n}\n\n.right-header-content .header-right-item .notifications.dropdown .dropdown-menu .view-all:hover span::before {\n  transform: scale(1);\n}\n\n.right-header-content .header-right-item .notifications.noti.dropdown .dropdown-menu {\n  width: 350px;\n}\n\n.right-header-content .header-right-item .notifications.noti.dropdown .btn-secondary.dropdown-toggle {\n  padding: 0 !important;\n}\n\n.right-header-content .header-right-item .notifications.noti.dropdown .btn-secondary.dropdown-toggle::after {\n  display: none;\n}\n\n.right-header-content .header-right-item .fullscreen-btn {\n  position: relative;\n}\n\n.right-header-content .header-right-item .fullscreen-btn.active i,\n.right-header-content .header-right-item .fullscreen-btn.active .material-symbols-outlined {\n  opacity: 0;\n}\n\n.right-header-content .header-right-item .fullscreen-btn.active::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 24px;\n  height: 24px;\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.right-header-content .header-right-item .admin-profile {\n  top: -3px;\n}\n\n.right-header-content .header-right-item .admin-profile h3,\n.right-header-content .header-right-item .admin-profile .h3 {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 0;\n}\n\n.right-header-content .header-right-item .admin-profile .administrator {\n  border: 2px solid #C2CDFF;\n  display: block;\n}\n\n.right-header-content .header-right-item .admin-profile .dropdown-toggle {\n  padding-right: 16px !important;\n}\n\n.right-header-content .header-right-item .admin-profile .dropdown-toggle::after {\n  font-family: \"remixicon\";\n  content: \"\\ea4e\";\n  position: absolute;\n  top: 50%;\n  right: -2px;\n  margin: 0;\n  border: 0;\n  transform: translateY(-50%);\n  color: #fff;\n}\n\n.right-header-content .header-right-item .admin-profile .dropdown-menu {\n  width: 195px;\n  border-radius: 7px;\n  background: #fff;\n  box-shadow: 0px 4px 45px 0px rgba(0, 0, 0, 0.1);\n  transform: translate(0px, 55px) !important;\n  padding: 20px;\n  left: auto !important;\n  right: 0 !important;\n}\n\n.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link {\n  border-top: 1px solid #F6F7F9;\n  margin-top: 10px;\n  padding-top: 10px;\n}\n\n.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item {\n  padding: 0;\n  padding: 7.5px 0;\n  position: relative;\n}\n\n.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -20px;\n  width: 2px;\n  height: 100%;\n  background-color: #d08f2c;\n  transform: scaleY(0);\n  transition: all ease 0.5s;\n}\n\n.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item .material-symbols-outlined {\n  font-size: 22px;\n  color: #3A4252;\n  transition: all ease 0.5s;\n}\n\n.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item span {\n  transition: all ease 0.5s;\n}\n\n.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item:hover {\n  background-color: transparent;\n}\n\n.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item:hover::before {\n  transform: scaleY(1);\n}\n\n.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item:hover span {\n  color: #d08f2c;\n}\n\n.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item:hover i,\n.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item:hover .material-symbols-outlined {\n  color: #d08f2c;\n}\n\n.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item.activeLink {\n  color: #d08f2c !important;\n  background-color: transparent !important;\n}\n\n.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item.activeLink span,\n.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item.activeLink i {\n  color: #d08f2c !important;\n}\n\n.right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li:last-child {\n  margin-bottom: 0;\n}\n\n.right-header-content .header-right-item .theme-settings-btn .material-symbols-outlined {\n  animation: rotation 2s infinite linear;\n  color: #3A4252;\n}\n\n@keyframes rotation {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(359deg);\n  }\n}\n\n.right-header-content .header-right-item:last-child {\n  margin-right: 0;\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n  .left-header-content ul li .src-form .form-control {\n    width: 100%;\n  }\n\n  .right-header-content .header-right-item {\n    margin-right: 16px;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .right-header-content .header-right-item .notifications.noti.dropdown .dropdown-menu {\n    width: 290px;\n    transform: translate(150px, 30px) !important;\n  }\n\n  .right-header-content .header-right-item .notifications.language.dropdown .dropdown-menu {\n    left: 0 !important;\n    right: auto !important;\n  }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .right-header-content .header-right-item {\n    margin-right: 10px;\n  }\n}\n\n@media only screen and (min-width: 479px) and (max-width: 575px) {\n  .right-header-content .header-right-item .dropdown.noti .dropdown-menu {\n    width: 293px;\n    transform: translate(95px, 60px) !important;\n  }\n}\n\n/* Min width 768px to Max width 992px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .left-header-content ul li .src-form .form-control {\n    width: 100%;\n  }\n}\n\n/* Max width 1199px */\n@media only screen and (max-width: 1199px) {\n  .header-area {\n    padding: 12px;\n  }\n\n  .left-header-content ul li {\n    margin-right: 15px;\n  }\n}\n\n/* Footer Area Style\n============================================*/\n.footer-area {\n  padding: 25px 30px;\n}\n\n/* Max width 991px */\n@media only screen and (max-width: 991px) {\n  .footer-area {\n    padding: 10px 10px;\n  }\n}\n\n/* Stats Box Area Style\n============================================*/\n.welcome-box .border-bottom {\n  border-color: #262626 !important;\n  padding-bottom: 40px;\n  margin-bottom: 40px;\n}\n\n.welcome-box.style-two {\n  background: linear-gradient(81deg, #605DFF 3.39%, #9747FF 93.3%);\n}\n\n.welcome-box.style-two .welcome-2 {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.welcome-box.style-two p {\n  color: #F6F7F9 !important;\n}\n\n.welcome-status-item i,\n.welcome-status-item span {\n  width: 42px;\n  height: 42px;\n  line-height: 42px;\n  text-align: center;\n  border-radius: 7px;\n  background-color: #ECF0FF;\n  color: #d08f2c;\n  position: relative;\n  top: -3px;\n  font-size: 24px;\n}\n\n.welcome-status-item i.icon-bg,\n.welcome-status-item span.icon-bg {\n  background-color: #FFE8D4;\n  color: #FD5812;\n}\n\n.welcome-status-item.style-two i,\n.welcome-status-item.style-two span {\n  background-color: #FFC8C0;\n  color: #EE3E08;\n}\n\n.welcome-status-item.style-two i.icon-bg.two,\n.welcome-status-item.style-two span.icon-bg.two {\n  background-color: #D8FFC8;\n  color: #25B003;\n}\n\n.stats-box .count {\n  background-color: #FFE1DD;\n  color: #FD5812;\n  border: 1px solid #FFCEA9;\n  display: inline-block;\n  border-radius: 50px;\n  font-size: 12px;\n  font-weight: 500;\n  width: 52px;\n  height: 24px;\n  line-height: 24px;\n  text-align: center;\n  margin-left: 7px;\n}\n\n.stats-box .count.up {\n  background-color: #D8FFC8;\n  border-color: #82FC5A;\n  color: #1E8308;\n}\n\n.stats-box .stats-list li {\n  margin-bottom: 6px;\n}\n\n.stats-box .stats-list li .title {\n  position: relative;\n  padding-left: 30px;\n}\n\n.stats-box .stats-list li .title::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 0;\n  width: 20px;\n  height: 5px;\n  background-color: #d08f2c;\n  border-radius: 50px;\n}\n\n.stats-box .stats-list li:last-child {\n  margin-bottom: 0;\n}\n\n.stats-box .stats-list li:last-child .title::before {\n  background-color: #C2CDFF;\n}\n\n.chart-position {\n  top: -5px;\n  right: 15px;\n  max-width: 120px;\n  position: absolute;\n}\n\n.congratulations {\n  bottom: 12px;\n  right: 7px;\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n  .welcome-box .border-bottom {\n    padding-bottom: 25px;\n    margin-bottom: 25px;\n  }\n}\n\n/* Min width 768px to Max width 992px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .stats-box.style-three .p-4 {\n    padding: 10px !important;\n  }\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .stats-box.style-three .p-4 {\n    padding: 10px !important;\n  }\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .stats-box.style-three .p-4 {\n    padding: 10px !important;\n  }\n\n  .welcome-box.style-two .welcome-2 {\n    width: 185px;\n  }\n}\n\n/* Min width 1400px to Max width 1600px */\n@media only screen and (min-width: 1400px) and (max-width: 1600px) {\n  .welcome-box.style-two .welcome-2 {\n    width: 230px;\n  }\n}\n\n/* Sales By Locations Area Style\n============================================*/\n.sales_by_locations li {\n  margin-bottom: 21.5px;\n  position: relative;\n  padding-right: 48px;\n}\n\n.sales_by_locations li:last-child {\n  margin-bottom: 0;\n}\n\n.sales_by_locations li .progress {\n  overflow: unset;\n  border-radius: 50px;\n  height: 5px;\n  background-color: #ECF0FF;\n}\n\n.sales_by_locations li .progress-bar {\n  border-radius: 50px;\n}\n\n.sales_by_locations li .count {\n  position: absolute;\n  top: 20px;\n  right: 0;\n  font-size: 15px;\n}\n\n.sales_by_locations.style-two li {\n  margin-bottom: 22px;\n}\n\n.sales_by_locations.style-two li:last-child {\n  margin-bottom: 0;\n}\n\n.gl-tr:first-child td {\n  padding-top: 0 !important;\n}\n\n/* Default Table Area Style\n============================================*/\n.default-table-area {\n  /* Analytics Dashboard CSS */\n  /* Crypto Dashboard CSS */\n  /* Sales Dashboard CSS */\n  /* Hospital Dashboard CSS */\n  /* Marketing Dashboard CSS */\n  /* NFT Dashboard CSS */\n  /* NFT Dashboard CSS */\n  /* Finance Dashboard CSS */\n}\n\n.default-table-area .table-responsive {\n  border-radius: 8px 8px 0 0 !important;\n}\n\n.default-table-area .table-responsive .table {\n  margin-bottom: 0;\n  border: 1px solid #F6F7F9;\n}\n\n.default-table-area .table-responsive .table thead tr th {\n  background-color: #F6F7F9;\n  color: #445164;\n  font-weight: 500;\n  padding: 15px 15px;\n  border: none;\n  border-bottom: 1px solid #ECEEF2;\n}\n\n.default-table-area .table-responsive .table thead tr th:first-child {\n  border-radius: 8px 0 0 0;\n  padding-left: 25px !important;\n}\n\n.default-table-area .table-responsive .table thead tr th:last-child {\n  border-radius: 0 8px 0 0;\n  padding-right: 25px !important;\n}\n\n.default-table-area .table-responsive .table tbody tr td {\n  background-color: transparent;\n  color: #3A4252;\n  border-color: #ECEEF2;\n  padding: 15px 15px;\n}\n\n.default-table-area .table-responsive .table tbody tr td:first-child {\n  border-left: 1px solid #ECEEF2;\n  padding-left: 25px !important;\n}\n\n.default-table-area .table-responsive .table tbody tr td:last-child {\n  border-right: 1px solid #ECEEF2;\n  padding-right: 25px !important;\n}\n\n.default-table-area .table-responsive .table tbody tr td a {\n  text-decoration: none;\n}\n\n.default-table-area .table-responsive .table tbody tr td a h6,\n.default-table-area .table-responsive .table tbody tr td a .h6 {\n  margin-bottom: 0;\n  transition: all ease 0.5s;\n}\n\n.default-table-area .table-responsive .table tbody tr td a:hover h6,\n.default-table-area .table-responsive .table tbody tr td a:hover .h6 {\n  color: #d08f2c;\n}\n\n.default-table-area .table-responsive .table tbody tr td .badge {\n  font-size: 13px;\n}\n\n.default-table-area.top-selling-products .table-responsive .table tbody tr td {\n  padding: 18.5px 15px;\n}\n\n.default-table-area.recent-orders .table-responsive .table tbody tr td {\n  padding: 18.5px 15px;\n}\n\n.default-table-area.recent-orders.recent-style-two .table-responsive .table tbody tr td {\n  padding: 15px 15px;\n}\n\n.default-table-area.recent-leads.style-two .table-responsive .table tbody tr td {\n  padding: 10.8px 8px;\n}\n\n.default-table-area .showing-wrap {\n  border: 1px solid #ECEEF2;\n  border-top: none;\n  padding: 13px 25px;\n  border-radius: 0 0 8px 8px;\n}\n\n.default-table-area.style-two .table-responsive {\n  border-radius: 0 !important;\n}\n\n.default-table-area.style-two .table-responsive .table thead tr th {\n  background-color: #ECF0FF;\n  font-size: 14px;\n  padding: 15px 8px;\n  border: none !important;\n}\n\n.default-table-area.style-two .table-responsive .table thead tr th:first-child {\n  border-radius: 0;\n}\n\n.default-table-area.style-two .table-responsive .table thead tr th:last-child {\n  border-radius: 0;\n}\n\n.default-table-area.style-two .table-responsive .table tbody tr td {\n  padding: 15px 8px;\n  border-left: none;\n  border-right: none;\n}\n\n.default-table-area.style-two .showing-wrap {\n  border: 0;\n  padding: 0;\n}\n\n.default-table-area.to-do-list .table-responsive .table thead tr th {\n  padding: 15px 7px;\n}\n\n.default-table-area.to-do-list .table-responsive .table tbody tr td {\n  padding: 15px 7px;\n}\n\n.default-table-area.to-do-list.padding-style .table-responsive .table thead tr th {\n  padding: 9.5px 7px;\n}\n\n.default-table-area.to-do-list.padding-style .table-responsive .table tbody tr td {\n  padding: 11.5px 7px;\n}\n\n.default-table-area.email-list .table-responsive {\n  border: none;\n}\n\n.default-table-area.email-list .table-responsive .table {\n  border: none;\n}\n\n.default-table-area.email-list .table-responsive .table tbody tr td {\n  border: none;\n  border-bottom: 1px solid #ECEEF2;\n}\n\n.default-table-area.email-list .table-responsive .table tbody tr td:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.email-list .table-responsive .table tbody tr td:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.email-list .pagination-area {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n}\n\n.default-table-area.recent-files .table-responsive .table tbody tr td {\n  padding: 15px 5px;\n}\n\n.default-table-area.recent-files .table-responsive .table thead tr th {\n  padding: 15px 5px;\n}\n\n.default-table-area.deals-table .table-responsive .table tbody tr td {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n\n.default-table-area.connected-table .table-responsive .table tbody tr td {\n  border: 0 !important;\n}\n\n.default-table-area.connected-table .table-responsive .table tbody tr td.ps-0 {\n  padding-left: 0 !important;\n}\n\n.default-table-area.connected-table .table-responsive .table tbody tr td.pe-0 {\n  padding-right: 0 !important;\n}\n\n.default-table-area.browser-leads.style-two .table-responsive .table thead tr th:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.browser-leads.style-two .table-responsive .table thead tr th:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.browser-leads.style-two .table-responsive .table tbody tr td {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.default-table-area.browser-leads.style-two .table-responsive .table tbody tr td:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.browser-leads.style-two .table-responsive .table tbody tr td:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.transaction-table.style-two .table-responsive .table thead tr th:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.transaction-table.style-two .table-responsive .table thead tr th:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.transaction-table.style-two .table-responsive .table tbody tr td {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.default-table-area.transaction-table.style-two .table-responsive .table tbody tr td:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.transaction-table.style-two .table-responsive .table tbody tr td:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.portfolio-table.style-two .table-responsive .table thead tr {\n  border-color: #262626 !important;\n}\n\n.default-table-area.portfolio-table.style-two .table-responsive .table thead tr th:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.portfolio-table.style-two .table-responsive .table thead tr th:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.portfolio-table.style-two .table-responsive .table tbody tr td {\n  border-color: #262626;\n  padding-top: 11px;\n  padding-bottom: 11px;\n}\n\n.default-table-area.portfolio-table.style-two .table-responsive .table tbody tr td:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.portfolio-table.style-two .table-responsive .table tbody tr td:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.rankings-table.style-two .table-responsive .table thead tr th:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.rankings-table.style-two .table-responsive .table thead tr th:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.rankings-table.style-two .table-responsive .table tbody tr td {\n  padding-top: 11px;\n  padding-bottom: 11px;\n}\n\n.default-table-area.rankings-table.style-two .table-responsive .table tbody tr td:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.rankings-table.style-two .table-responsive .table tbody tr td:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.sales-locations-table.style-two .table-responsive .table thead tr th:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.sales-locations-table.style-two .table-responsive .table thead tr th:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.sales-locations-table.style-two .table-responsive .table tbody tr td {\n  padding-top: 11px;\n  padding-bottom: 11px;\n}\n\n.default-table-area.sales-locations-table.style-two .table-responsive .table tbody tr td:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.sales-locations-table.style-two .table-responsive .table tbody tr td:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.patient-table.style-two .table-responsive .table thead tr th:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.patient-table.style-two .table-responsive .table thead tr th:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.patient-table.style-two .table-responsive .table tbody tr td {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.default-table-area.patient-table.style-two .table-responsive .table tbody tr td:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.patient-table.style-two .table-responsive .table tbody tr td:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.campaigns-table.style-two .table-responsive .table thead tr th:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.campaigns-table.style-two .table-responsive .table thead tr th:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.campaigns-table.style-two .table-responsive .table tbody tr td {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.default-table-area.campaigns-table.style-two .table-responsive .table tbody tr td:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.campaigns-table.style-two .table-responsive .table tbody tr td:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.top-nfts-table.style-two .table-responsive .table thead tr th:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.top-nfts-table.style-two .table-responsive .table thead tr th:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.top-nfts-table.style-two .table-responsive .table tbody tr td {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.default-table-area.top-nfts-table.style-two .table-responsive .table tbody tr td:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.top-nfts-table.style-two .table-responsive .table tbody tr td:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.history-of-bids.style-two .table-responsive {\n  height: 438px;\n}\n\n.default-table-area.history-of-bids.style-two .table-responsive .table tbody tr td {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.default-table-area.history-of-bids.style-two .table-responsive .table tbody tr td:first-child {\n  padding-left: 0 !important;\n}\n\n.default-table-area.history-of-bids.style-two .table-responsive .table tbody tr td:last-child {\n  padding-right: 0 !important;\n}\n\n.default-table-area.transaction-history.style-two .table-responsive .table tbody tr td {\n  padding-top: 23.5px;\n  padding-bottom: 23.5px;\n}\n\n.default-table-area.transaction-history-large.style-two .table-responsive .table tbody tr td {\n  padding-top: 23.5px;\n  padding-bottom: 23.5px;\n}\n\n.default-table-area.shipment-list.style-two .table-responsive .table tbody tr td {\n  padding-top: 19px;\n  padding-bottom: 19px;\n}\n\n.default-table-area.style-three .table-responsive .table thead tr th {\n  font-size: 14px;\n  color: #fff;\n}\n\n.default-table-area.style-three .table-responsive .table thead tr th:first-child {\n  padding-left: 30px !important;\n}\n\n.default-table-area.style-three .table-responsive .table thead tr th:last-child {\n  padding-right: 30px;\n}\n\n.default-table-area.style-three .table-responsive .table tbody tr td {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  border-left: none;\n  border-right: none;\n}\n\n.default-table-area.style-three .table-responsive .table tbody tr td:first-child {\n  padding-left: 30px !important;\n}\n\n.default-table-area.style-three .table-responsive .table tbody tr td:last-child {\n  padding-right: 30px;\n}\n\n.default-table-area.agents-performance-overview.style-three .table-responsive {\n  border-radius: 0 !important;\n}\n\n.default-table-area.agents-performance-overview.style-three .table-responsive .table {\n  border-spacing: 10px;\n}\n\n.default-table-area.agents-performance-overview.style-three .table-responsive .table tbody tr td {\n  padding: 10px !important;\n  border-left: none;\n  border-right: none;\n  border-bottom: none;\n  border-top: 10px solid #fff;\n  background-color: #F6F7F9;\n  border-radius: 0 !important;\n}\n\n.default-table-area.agents-performance-overview.style-three .table-responsive .table tbody tr td:first-child {\n  border-radius: 10px 0 0 10px !important;\n}\n\n.default-table-area.agents-performance-overview.style-three .table-responsive .table tbody tr td:last-child {\n  border-radius: 0 10px 10px 0 !important;\n}\n\n.default-table-area.for-data-table .tablesorter-header {\n  background-color: transparent !important;\n  position: relative;\n}\n\n.default-table-area.for-data-table .tablesorter-header::after {\n  content: \"\\f326\";\n  font-family: remixicon !important;\n  margin-left: 4px;\n}\n\n.default-table-area.for-data-table .Selc {\n  display: none;\n}\n\n.table-src-form {\n  margin-right: 20px;\n}\n\n.table-src-form i,\n.table-src-form .material-symbols-outlined {\n  left: 15px !important;\n  font-size: 20px;\n}\n\n.table-src-form .form-control {\n  padding-left: 40px;\n  background-color: #F6F7F9;\n  height: 36px;\n  width: 240px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n  .default-table-area {\n    /* Analytics Dashboard CSS */\n  }\n\n  .default-table-area.to-do-list .table {\n    width: 738.66px;\n  }\n\n  .default-table-area.recent-files .table {\n    width: 819px;\n  }\n\n  .default-table-area.manage-reviews-table .table {\n    width: 1100px;\n  }\n\n  .default-table-area.latest-transaction .table {\n    width: 967px;\n  }\n\n  .default-table-area.transaction-history.tracking-order.style-two .table-responsive .table {\n    width: 742px;\n  }\n\n  .default-table-area.style-three .table-responsive .table thead tr th:first-child {\n    padding-left: 15px !important;\n  }\n\n  .default-table-area.style-three .table-responsive .table thead tr th:last-child {\n    padding-right: 15px !important;\n  }\n\n  .default-table-area.style-three .table-responsive .table tbody tr td:first-child {\n    padding-left: 15px !important;\n  }\n\n  .default-table-area.style-three .table-responsive .table tbody tr td:last-child {\n    padding-right: 15px !important;\n  }\n\n  .default-table-area.browser-leads.style-two .table-responsive .table.for-mobile-width {\n    width: 715px !important;\n  }\n\n  .ec-recent-orders .table {\n    width: 960px;\n  }\n\n  .analytics-bu-by-users {\n    width: 715px;\n  }\n\n  .analytics-tbpt-table {\n    width: 715px;\n  }\n\n  .crypto-th-table {\n    width: 715px;\n  }\n\n  .crypto-cr-table {\n    width: 900px;\n  }\n\n  .patient-table .table {\n    width: 730px;\n  }\n\n  .default-table-area.email-list .pagination-area {\n    position: initial;\n    margin-top: 15px;\n  }\n}\n\n/* Max width 490px */\n@media only screen and (max-width: 490px) {\n\n  /* Analytics Dashboard CSS */\n  .default-table-area.top-nfts-table.style-two .table-responsive .table {\n    width: 436px !important;\n  }\n\n  .default-table-area.agents-performance-overview.style-three .table-responsive .table {\n    width: 480px;\n  }\n}\n\n@media only screen and (max-width: 380px) {\n  .default-table-area {\n    /* Crypto Dashboard CSS */\n  }\n\n  .default-table-area.team-members .table {\n    width: 357.33px;\n  }\n\n  .default-table-area.portfolio-table.style-two .table-responsive .table {\n    width: 357.33px;\n  }\n}\n\n@media only screen and (max-width: 576px) {\n  .default-table-area.top-selling-products .table {\n    width: 595.33px;\n  }\n\n  .default-table-area.recent-orders .table {\n    width: 690px;\n  }\n\n  .default-table-area.my-tasks .table {\n    width: 547px;\n  }\n\n  .default-table-area.to-do-list .table {\n    width: 738.66px;\n  }\n\n  .default-table-area.top-instructors .table {\n    width: 551.5px;\n  }\n\n  .default-table-area.recent-customer-ratings .table {\n    width: 551.5px;\n  }\n\n  .default-table-area.speaker-table .table {\n    width: 525px;\n  }\n\n  .default-table-area.connected-table .table {\n    width: 522px;\n  }\n\n  .table-src-form {\n    margin-right: 10px;\n  }\n\n  .table-src-form .form-control {\n    width: 140px;\n  }\n}\n\n/* Max width 650px */\n@media only screen and (max-width: 650px) {\n\n  /* Analytics Dashboard CSS */\n  .default-table-area {\n    /* Marketing Dashboard CSS */\n  }\n\n  .default-table-area.campaigns-table.style-two .table-responsive .table {\n    width: 670px !important;\n  }\n\n  .default-table-area.employee-leave-request.style-three .table-responsive .table {\n    width: 626px !important;\n  }\n}\n\n@media only screen and (max-width: 685px) {\n  .default-table-area.recent-orders .table {\n    width: 690px;\n  }\n\n  .default-table-area.recent-leads .table {\n    width: 690px;\n  }\n\n  .default-table-area.email-list .table {\n    width: 680px;\n  }\n}\n\n/* Max width 1340px */\n@media only screen and (max-width: 1340px) {\n\n  /* Crypto Dashboard CSS */\n  .default-table-area.patient-table.style-two .table-responsive .table {\n    width: 927px !important;\n  }\n\n  .default-table-area.shipment-list.style-two .table-responsive .table {\n    width: 1003px;\n  }\n\n  .default-table-area.employee-list.style-three .table-responsive .table {\n    width: 1042px;\n  }\n}\n\n/* Min width 768px to Max width 992px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .default-table-area.email-list .table {\n    width: 680px;\n  }\n\n  .default-table-area.recent-files .table {\n    width: 819px;\n  }\n\n  .default-table-area.manage-reviews-table .table {\n    width: 1100px;\n  }\n\n  .default-table-area.latest-transaction .table {\n    width: 967px;\n  }\n\n  .default-table-area.style-three .table-responsive .table thead tr th:first-child {\n    padding-left: 15px !important;\n  }\n\n  .default-table-area.style-three .table-responsive .table thead tr th:last-child {\n    padding-right: 15px !important;\n  }\n\n  .default-table-area.style-three .table-responsive .table tbody tr td:first-child {\n    padding-left: 15px !important;\n  }\n\n  .default-table-area.style-three .table-responsive .table tbody tr td:last-child {\n    padding-right: 15px !important;\n  }\n\n  .ec-recent-orders .table {\n    width: 1050px;\n  }\n\n  .crypto-cr-table {\n    width: 930px;\n  }\n}\n\n@media only screen and (max-width: 685px) {\n  .default-table-area {\n    /* Finance Dashboard CSS */\n  }\n\n  .default-table-area.recent-orders .table {\n    width: 690px;\n  }\n\n  .default-table-area.recent-leads .table {\n    width: 690px;\n  }\n\n  .default-table-area.email-list .table {\n    width: 680px;\n  }\n\n  .default-table-area.transaction-history.style-two .table-responsive .table {\n    width: 685px;\n  }\n\n  .default-table-area.recent-calls.style-three .table-responsive .table {\n    width: 710px;\n  }\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .default-table-area.recent-leads .table {\n    width: 690px;\n  }\n\n  .default-table-area.recent-customer-ratings .table {\n    width: 551.5px;\n  }\n\n  .default-table-area.recent-files .table {\n    width: 819px;\n  }\n\n  .default-table-area.manage-reviews-table .table {\n    width: 1100px;\n  }\n\n  .default-table-area.speaker-table .table {\n    width: 525px;\n  }\n\n  .patient-table .table {\n    width: 730px;\n  }\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .default-table-area.top-selling-products .table {\n    width: 620px;\n  }\n\n  .default-table-area.recent-orders .table {\n    width: 719px;\n  }\n\n  .default-table-area.recent-leads .table {\n    width: 690px;\n  }\n\n  .default-table-area.recent-customer-ratings .table {\n    width: 551.5px;\n  }\n\n  .default-table-area.email-list .table {\n    width: 680px;\n  }\n\n  .default-table-area.recent-files .table {\n    width: 819px;\n  }\n\n  .default-table-area.manage-reviews-table .table {\n    width: 1100px;\n  }\n\n  .default-table-area.speaker-table .table {\n    width: 525px;\n  }\n\n  .patient-table .table {\n    width: 730px;\n  }\n}\n\n/* Min width 1400px to Max width 1500px */\n@media only screen and (min-width: 1400px) and (max-width: 1550px) {\n  .crypto-th-table {\n    width: 715px;\n  }\n}\n\n@media only screen and (max-width: 1399px) {\n  .default-table-area.all-projects .table {\n    width: 1120px;\n  }\n\n  .default-table-area.default-table-width .table {\n    width: 1120px;\n  }\n\n  .default-table-area.all-products .table {\n    width: 1300px;\n  }\n\n  .default-table-area.all-products #myTable {\n    width: 1300px !important;\n  }\n}\n\n@media only screen and (max-width: 1550px) {\n  .default-table-area.campaigns-table.latest-transaction-table .table-responsive .table {\n    width: 927px !important;\n  }\n\n  .default-table-area.real-estate-customers.style-two .table-responsive .table {\n    width: 1252px;\n  }\n\n  .default-table-area.all-products .table {\n    width: 1300px;\n  }\n\n  .default-table-area.all-products #myTable {\n    width: 1300px !important;\n  }\n\n  .default-table-area.all-carts .table {\n    width: 926px;\n  }\n}\n\n/* Pagination Area Style\n============================================*/\n.pagination .page-item {\n  margin-right: 7px;\n}\n\n.pagination .page-item .page-link {\n  padding: 6px 12px;\n  border-radius: 4px;\n  border: 1px solid #ECEEF2;\n  background: #fff;\n  transition: all ease 0.5s;\n  font-weight: 500;\n  color: #fff;\n}\n\n.pagination .page-item .page-link:focus {\n  box-shadow: none;\n}\n\n.pagination .page-item .page-link.icon {\n  padding: 0;\n}\n\n.pagination .page-item .page-link.icon i,\n.pagination .page-item .page-link.icon span {\n  width: 31px;\n  height: 31px;\n  line-height: 33px;\n  text-align: center;\n  font-size: 22px;\n}\n\n.pagination .page-item .page-link.active {\n  background-color: #d08f2c;\n  color: #fff;\n  z-index: 0 !important;\n}\n\n.pagination .page-item .page-link:hover {\n  background-color: #d08f2c;\n  color: #fff;\n}\n\n.pagination .page-item .page-link:hover i,\n.pagination .page-item .page-link:hover span {\n  color: #fff;\n}\n\n.pagination .page-item:last-child {\n  margin-right: 0;\n}\n\n/* Calendar Style\n============================================*/\n.fc-theme-standard .fc-scrollgrid {\n  border: 1px solid #ECF0FF;\n}\n\n.fc-theme-standard th {\n  background-color: #ECF0FF;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.fc-theme-standard tr th,\n.fc-theme-standard tr td {\n  border: 1px solid #ECF0FF;\n}\n\n.fc-theme-standard a {\n  text-decoration: none;\n}\n\n.fc .fc-toolbar-title {\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.fc .fc-button-primary {\n  text-transform: capitalize;\n}\n\n.fc .fc-col-header-cell-cushion {\n  padding: 8px 4px;\n  color: black;\n}\n\n.fc .fc-daygrid-day-number {\n  padding: 20px;\n}\n\n/* Calendar Area Style\n============================================*/\n.react-calendar {\n  width: 100%;\n  border: none;\n  font-family: \"Inter\", sans-serif;\n}\n\n.react-calendar .react-calendar__navigation {\n  align-items: center;\n  height: auto;\n}\n\n.react-calendar .react-calendar__navigation button .react-calendar__navigation__label__labelText {\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.react-calendar .react-calendar__navigation .react-calendar__navigation__prev2-button,\n.react-calendar .react-calendar__navigation .react-calendar__navigation__next2-button {\n  display: none;\n}\n\n.react-calendar .react-calendar__navigation .react-calendar__navigation__prev-button,\n.react-calendar .react-calendar__navigation .react-calendar__navigation__next-button {\n  background-color: #f5f5f5;\n  width: 20px;\n  height: 20px;\n  min-width: auto;\n  border-radius: 100%;\n}\n\n.react-calendar .react-calendar__month-view__weekdays .react-calendar__month-view__weekdays__weekday {\n  text-transform: capitalize;\n  color: #3A4252;\n  font-size: 12px;\n}\n\n.react-calendar .react-calendar__month-view__days__day--weekend {\n  color: #FD5812 !important;\n}\n\n.react-calendar .react-calendar__month-view__days .react-calendar__month-view__days__day--neighboringMonth {\n  opacity: 0.5;\n}\n\n.react-calendar .react-calendar__month-view__days .react-calendar__tile {\n  color: #3A4252;\n  font-size: 14px;\n}\n\n.react-calendar .react-calendar__month-view__days .react-calendar__tile.react-calendar__tile--active {\n  background-color: transparent;\n}\n\n.react-calendar .react-calendar__month-view__days .react-calendar__tile.react-calendar__tile--active abbr {\n  background-color: #d08f2c;\n  color: #fff !important;\n  border-radius: 100%;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: inline-block;\n  line-height: 30px;\n}\n\n.dark .react-calendar .react-calendar__navigation .react-calendar__navigation__prev-button,\n.dark .react-calendar .react-calendar__navigation .react-calendar__navigation__next-button {\n  background-color: #000000;\n}\n\n.dark .react-calendar .react-calendar__month-view__weekdays .react-calendar__month-view__weekdays__weekday {\n  color: #fff;\n}\n\n.dark .react-calendar .react-calendar__month-view__days .react-calendar__tile {\n  color: #3A4252;\n}\n\n.dark .fc-theme-standard th {\n  background-color: #212121;\n  color: #fff;\n}\n\n.dark .fc-theme-standard .fc-scrollgrid {\n  border: 1px solid #172036;\n}\n\n.dark .fc-theme-standard tr th,\n.dark .fc-theme-standard tr td {\n  border: 1px solid #172036;\n}\n\n.dark .fc .fc-col-header-cell-cushion {\n  color: #fff;\n}\n\n.dark .fc .fc-daygrid-day-number {\n  color: #fff;\n}\n\n.dark .mantine-1qycoz3 {\n  border: 1px solid #212121;\n  background-color: #212121;\n  color: #fff;\n}\n\n/* Chat Area Style\n============================================*/\n.status-position {\n  top: 2px;\n  right: -5px;\n}\n\n.status-position2 {\n  bottom: 4px;\n  right: -2px;\n}\n\n.chat-tabs {\n  justify-content: space-between;\n  margin-bottom: 1.5rem !important;\n}\n\n.chat-tabs .nav-item .nav-link {\n  position: relative;\n  border: none;\n  padding: 0 0 10px;\n  font-weight: 500;\n  color: #fff;\n}\n\n.chat-tabs .nav-item .nav-link::before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 0;\n  height: 2px;\n  background-color: #d08f2c;\n  transition: all ease 0.5s;\n}\n\n.chat-tabs .nav-item .nav-link.active,\n.chat-tabs .nav-item .nav-link:hover {\n  color: #d08f2c !important;\n  background-color: transparent;\n}\n\n.chat-tabs .nav-item .nav-link.active::before,\n.chat-tabs .nav-item .nav-link:hover::before {\n  width: 100%;\n  right: auto;\n  left: 0;\n}\n\n.chat-details li {\n  max-width: 800px;\n}\n\n.chat-details li p {\n  border-radius: 0px 15px 15px 15px;\n  background-color: #F5F6FA;\n  margin-bottom: 0;\n  padding: 15px 20px;\n  margin-bottom: 5px;\n  display: inline-block;\n}\n\n.chat-details li .dropdown.action-opt {\n  opacity: 0;\n  transition: all ease 0.5s;\n}\n\n.chat-details li.own-chat p {\n  border-radius: 15px 0 15px 15px;\n  background-color: #d08f2c;\n  color: #fff;\n}\n\n.chat-details li:hover .dropdown.action-opt {\n  opacity: 1;\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n  .chat-details li p {\n    padding: 10px;\n  }\n}\n\n/* Min width 768px to Max width 992px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .chat-details li p {\n    padding: 10px;\n  }\n}\n\n/* Min width 1400px to Max width 1799px */\n/* Terminals Area Style\n============================================*/\n.timeline-wrap {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin: 15px;\n}\n\n.timeline-wrap::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  left: 50%;\n  transform: translatex(-50%);\n  border: 1px dashed #d08f2c;\n  height: 80%;\n}\n\n.timeline-wrap .timeline-item-2 {\n  display: flex;\n}\n\n.timeline-wrap .timeline-item-2 .text {\n  flex: 1 1 calc(50% - 50px);\n  position: relative;\n  background-color: #ECF0FF;\n}\n\n.timeline-wrap .timeline-item-2 .icon {\n  flex: 1 1 100px;\n}\n\n.timeline-wrap .timeline-item-2 .icon div {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  margin: auto;\n  background: #d08f2c;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  position: relative;\n  z-index: 1;\n}\n\n.timeline-wrap .timeline-item-2 .icon.two div {\n  background: #37D80A;\n}\n\n.timeline-wrap .timeline-item-2 .icon.three div {\n  background: #d08f2c;\n}\n\n.timeline-wrap .timeline-item-2 .icon.four div {\n  background: #FD5812;\n}\n\n.timeline-wrap .timeline-item-2 .time {\n  flex: 1 1 calc(50% - 50px);\n}\n\n.timeline-wrap .timeline-item-2 .time time {\n  font-size: 12px;\n  background-color: #d08f2c;\n  color: #fff;\n  display: inline-block;\n  padding: 9px 15px;\n  border-radius: 7px;\n  position: relative;\n}\n\n.timeline-wrap .timeline-item-2 .time time::before {\n  content: \"\";\n  position: absolute;\n  top: 10px;\n  left: -6px;\n  width: 15px;\n  height: 15px;\n  background-color: #d08f2c;\n  transform: rotate(45deg);\n  border-radius: 2px;\n}\n\n.timeline-wrap .timeline-item-2:nth-child(even) {\n  flex-direction: row-reverse;\n}\n\n.timeline-wrap .timeline-item-2:nth-child(even) .time time::before {\n  left: auto;\n  right: -6px;\n}\n\n.timeline-wrap .timeline-item-2:nth-child(even)>div:last-child {\n  text-align: end;\n}\n\n.timeline-item {\n  position: relative;\n  padding-left: 90px;\n}\n\n.timeline-item .time-line-date {\n  position: absolute;\n  top: -5px;\n  left: 0;\n}\n\n.timeline-item .border-style-for-timeline {\n  border-left: 1px dashed #D5D9E2;\n  padding-left: 30px;\n  position: relative;\n  padding-bottom: 30px;\n}\n\n.timeline-item .border-style-for-timeline::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -6px;\n  width: 12px;\n  height: 12px;\n  background-color: #37D80A;\n  border-radius: 50px;\n}\n\n.timeline-item .border-style-for-timeline.dot-2::before {\n  background-color: #FD5812;\n}\n\n.timeline-item .border-style-for-timeline.dot-3::before {\n  background-color: #AD63F6;\n}\n\n.timeline-item .border-style-for-timeline.dot-4::before {\n  background-color: #3584FC;\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n  .timeline-wrap {\n    margin: 0;\n  }\n\n  .timeline-wrap::before {\n    display: none;\n  }\n\n  .timeline-wrap .timeline-item-2 {\n    flex-flow: column wrap;\n    height: auto;\n  }\n\n  .timeline-wrap .timeline-item-2:nth-child(even) {\n    flex-direction: column;\n  }\n\n  .timeline-wrap .timeline-item-2:nth-child(even)>.time:last-child {\n    text-align: start;\n  }\n\n  .timeline-wrap .timeline-item-2:nth-child(odd) h3::after,\n  .timeline-wrap .timeline-item-2:nth-child(odd) .h3::after {\n    border: none;\n  }\n\n  .timeline-wrap .timeline-item-2 .icon {\n    order: 1;\n    flex: 1 1 100%;\n    width: 100px;\n  }\n\n  .timeline-wrap .timeline-item-2 .icon div {\n    display: none !important;\n  }\n\n  .timeline-wrap .timeline-item-2 .time {\n    order: 2;\n    flex: 1 1 50px;\n    width: calc(100% - 90px);\n  }\n\n  .timeline-wrap .timeline-item-2 .text {\n    order: 3;\n    flex: 1 1 calc(100% - 50px);\n    width: calc(100% + 1px);\n  }\n}\n\n/* Priceing Area Style\n============================================*/\n.priceing-border {\n  position: relative;\n}\n\n.priceing-border::before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: -130px;\n  width: 1px;\n  height: 100%;\n  border-left: 1px dashed #ECEEF2;\n}\n\n.priceing-border.style-two::before {\n  left: 0 !important;\n}\n\n.popular-tag {\n  top: 25px;\n  left: 227px;\n  transform: rotate(-15deg);\n}\n\n.populartsgs {\n  top: 20px;\n  right: 20px;\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .priceing-border::before {\n    left: -51px;\n  }\n\n  .popular-tag {\n    left: 144px;\n  }\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .priceing-border::before {\n    left: -51px;\n  }\n\n  .popular-tag {\n    left: 130px;\n  }\n}\n\n/* Min width 1400px to Max width 1799px */\n@media only screen and (min-width: 1400px) and (max-width: 1799px) {\n  .priceing-border::before {\n    left: -68px;\n  }\n\n  .popular-tag {\n    left: 160px;\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .priceing-border::before {\n    display: none;\n  }\n\n  .popular-tag {\n    left: auto;\n    right: 25px;\n    top: 25px;\n  }\n}\n\n/* Products Area Style\n============================================*/\n.product-image .react-tabs__tab-panel {\n  background-color: #f6f7f9;\n  padding: 3rem !important;\n  border-radius: 7px;\n  text-align: center;\n}\n\n.product-image .react-tabs__tab-list {\n  margin: 0;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  border: none;\n  gap: 15px;\n}\n\n.product-image .react-tabs__tab-list .react-tabs__tab {\n  margin: 10px 0 0;\n  background-color: #f6f7f9;\n  border-radius: 7px;\n  text-align: center;\n  padding: 15px;\n  border: 1px solid #f6f7f9 !important;\n}\n\n.product-image .react-tabs__tab-list .react-tabs__tab.react-tabs__tab--selected {\n  border: 1px solid #FFBC2B !important;\n}\n\n.select-style .btn-check:checked+.btn,\n.select-style .btn.active,\n.select-style .btn.show,\n.select-style .btn:first-child:active,\n.select-style :not(.btn-check)+.btn:active {\n  border-color: #FFBC2B !important;\n}\n\n.select-color li {\n  width: 30px;\n  height: 30px;\n  border: 1px solid #fff;\n  cursor: pointer;\n}\n\n.select-color li.color1 {\n  background-color: #ECEEF2;\n  border-radius: 50px;\n}\n\n.select-color li.color1.active {\n  border-color: #FFBC2B;\n}\n\n.select-color li.color2 {\n  background-color: #D5D9E2;\n  border-radius: 50px;\n}\n\n.select-color li:hover {\n  border-color: #FFBC2B;\n}\n\n.add-to-cart-counter {\n  display: flex;\n}\n\n.add-to-cart-counter input {\n  background-color: #ECF0FF;\n  color: #fff;\n  border: 1px solid #ECF0FF;\n  max-width: 50px;\n  text-align: center;\n  font-size: 16px;\n  border: 0;\n}\n\n.add-to-cart-counter input:focus {\n  box-shadow: none;\n  border: none;\n  outline: none;\n}\n\n.add-to-cart-counter .minusBtn,\n.add-to-cart-counter .plusBtn {\n  border-right: 1px solid #ECF0FF;\n  width: 35px;\n  height: 42px;\n  line-height: 31.9px;\n  background-color: #ECF0FF;\n  border-radius: 0 7px 7px 0 !important;\n}\n\n.add-to-cart-counter .minusBtn {\n  border-radius: 7px 0 0 7px !important;\n}\n\n.review-tabs {\n  margin-bottom: 1px;\n}\n\n.review-tabs .nav-item .nav-link {\n  color: #fff;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  border-bottom: 2px solid #F6F7F9 !important;\n  padding: 11px 30px;\n}\n\n.review-tabs .nav-item .nav-link.active {\n  background-color: #fff;\n  border-color: #d08f2c !important;\n}\n\n/* Max width 767px */\n/* Min width 768px to Max width 992px */\n/* Min width 992px to Max width 1199px */\n/* Min width 1200px to Max width 1399px */\n/* Min width 1400px to Max width 1799px */\n/* RTL Area Style\n============================================*/\n[dir=rtl] {\n  text-align: right;\n}\n\n[dir=rtl] .ms-1 {\n  margin-left: 0 !important;\n  margin-right: 0.25rem !important;\n}\n\n[dir=rtl] .ms-2 {\n  margin-left: 0 !important;\n  margin-right: 0.5rem !important;\n}\n\n[dir=rtl] .ms-3 {\n  margin-left: 0 !important;\n  margin-right: 1rem !important;\n}\n\n[dir=rtl] .ms-4 {\n  margin-left: 0 !important;\n  margin-right: 1.5rem !important;\n}\n\n[dir=rtl] .ms-5 {\n  margin-left: 0 !important;\n  margin-right: 3rem !important;\n}\n\n[dir=rtl] .me-1 {\n  margin-right: 0 !important;\n  margin-left: 0.25rem !important;\n}\n\n[dir=rtl] .me-2 {\n  margin-right: 0 !important;\n  margin-left: 0.5rem !important;\n}\n\n[dir=rtl] .me-3 {\n  margin-right: 0 !important;\n  margin-left: 1rem !important;\n}\n\n[dir=rtl] .me-4 {\n  margin-right: 0 !important;\n  margin-left: 1.5rem !important;\n}\n\n[dir=rtl] .me-5 {\n  margin-right: 0 !important;\n  margin-left: 3rem !important;\n}\n\n[dir=rtl] .ms-m-20 {\n  margin-left: 0;\n  margin-right: -20px;\n}\n\n[dir=rtl] .ms-m-15 {\n  margin-left: 0;\n  margin-right: -15px;\n}\n\n[dir=rtl] .ms-xxl-3 {\n  margin-left: 0 !important;\n  margin-right: 1rem !important;\n}\n\n[dir=rtl] .ps-1 {\n  padding-left: 0 !important;\n  padding-right: 0.25rem !important;\n}\n\n[dir=rtl] .ps-2 {\n  padding-left: 0 !important;\n  padding-right: 0.5rem !important;\n}\n\n[dir=rtl] .ps-3 {\n  padding-left: 0 !important;\n  padding-right: 1rem !important;\n}\n\n[dir=rtl] .ps-4 {\n  padding-left: 0 !important;\n  padding-right: 1.5rem !important;\n}\n\n[dir=rtl] .ps-5 {\n  padding-left: 0 !important;\n  padding-right: 3rem !important;\n}\n\n[dir=rtl] .pe-1 {\n  padding-right: 0 !important;\n  padding-left: 0.25rem !important;\n}\n\n[dir=rtl] .pe-2 {\n  padding-right: 0 !important;\n  padding-left: 0.5rem !important;\n}\n\n[dir=rtl] .pe-3 {\n  padding-right: 0 !important;\n  padding-left: 1rem !important;\n}\n\n[dir=rtl] .pe-4 {\n  padding-right: 0 !important;\n  padding-left: 1.5rem !important;\n}\n\n[dir=rtl] .pe-5 {\n  padding-right: 0 !important;\n  padding-left: 3rem !important;\n}\n\n[dir=rtl] .ps-0 {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n[dir=rtl] .ps-xxl-4 {\n  padding-left: 0 !important;\n  padding-right: 1.5rem !important;\n}\n\n[dir=rtl] .text-start {\n  text-align: right !important;\n}\n\n[dir=rtl] .text-end {\n  text-align: left !important;\n}\n\n[dir=rtl] .text-sm-end {\n  text-align: left !important;\n}\n\n[dir=rtl] .main-content {\n  padding-left: 25px;\n  padding-right: 295px;\n}\n\n@media only screen and (min-width: 1200px) {\n  [dir=rtl] .main-wrapper-content.active .main-content {\n    padding-left: 25px;\n    padding-right: 105px;\n  }\n}\n\n[dir=rtl] .sidebar-area {\n  left: auto;\n  right: 0;\n}\n\n[dir=rtl] .sidebar-area .logo .logo-text {\n  left: auto;\n  right: 33px;\n}\n\n[dir=rtl] .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button i,\n[dir=rtl] .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button span {\n  margin-right: 0;\n  margin-left: 7px;\n}\n\n[dir=rtl] .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .count {\n  right: auto;\n  left: 42px;\n}\n\n[dir=rtl] .sidebar-menu .menu-item .menu-link i,\n[dir=rtl] .sidebar-menu .menu-item .menu-link span {\n  margin-right: 0;\n  margin-left: 8px;\n}\n\n[dir=rtl] .sidebar-menu .menu-item .menu-link .tag {\n  margin-left: 0;\n  margin-right: 12px;\n}\n\n[dir=rtl] .sidebar-menu .sub-menu .menu-item .menu-link {\n  padding-left: 0;\n  padding-right: 35px;\n}\n\n[dir=rtl] .sidebar-menu .sub-menu .menu-item .menu-link:before {\n  left: auto;\n  right: 18px;\n}\n\n[dir=rtl] .menu-vertical .menu-item .menu-link .count {\n  right: auto;\n  left: 42px;\n}\n\n[dir=rtl] .menu-vertical .menu-item .menu-link .menu-icon {\n  margin-right: 0;\n  margin-left: 4px;\n}\n\n[dir=rtl] .menu-vertical .menu-item .menu-link.menu-toggle::after {\n  right: auto;\n  left: 25px;\n  transform: translateY(-50%) rotate(225deg);\n}\n\n[dir=rtl] .menu-vertical .menu-item.open:not(.menu-item-closing)>.menu-toggle::after {\n  transform: translateY(-50%) rotate(135deg);\n}\n\n[dir=rtl] .menu-vertical .menu-sub .menu-item .menu-link {\n  padding-left: 0;\n  padding-right: 35px;\n}\n\n[dir=rtl] .menu-vertical .menu-sub .menu-item .menu-link::before {\n  left: auto;\n  right: 18px;\n}\n\n[dir=rtl] .menu-vertical .menu-sub .menu-item .menu-link .tag {\n  margin-left: 0;\n  margin-right: 12px;\n}\n\n[dir=rtl] .menu-vertical .menu-sub .menu-item .menu-link .tag::before {\n  left: auto;\n  right: -3px;\n}\n\n[dir=rtl] .right-header-content .header-right-item {\n  margin-right: 0;\n  margin-left: 25px;\n}\n\n[dir=rtl] .right-header-content .header-right-item .notifications.dropdown .dropdown-menu {\n  left: 0 !important;\n  right: auto !important;\n}\n\n[dir=rtl] .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .notification-menu {\n  text-align: right;\n}\n\n[dir=rtl] .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .notification-menu.unseen::before {\n  right: auto;\n  left: 20px;\n}\n\n[dir=rtl] .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .title {\n  display: block;\n  text-align: right;\n}\n\n[dir=rtl] .right-header-content .header-right-item:last-child {\n  margin-left: 0;\n}\n\n[dir=rtl] .right-header-content .header-right-item .admin-profile .dropdown-menu {\n  left: 0 !important;\n  right: auto !important;\n}\n\n[dir=rtl] .right-header-content .header-right-item .admin-profile .dropdown-toggle {\n  padding-right: 0 !important;\n  padding-left: 16px !important;\n}\n\n[dir=rtl] .right-header-content .header-right-item .admin-profile .dropdown-toggle::after {\n  right: auto;\n  left: -4px !important;\n}\n\n[dir=rtl] .right-header-content .header-right-item .admin-profile .info {\n  text-align: right;\n}\n\n[dir=rtl] .offcanvas-header .btn-close {\n  margin-right: auto;\n  margin-left: 0;\n}\n\n[dir=rtl] .left-header-content ul li {\n  margin-right: 0;\n  margin-left: 25px;\n}\n\n[dir=rtl] .left-header-content ul li:last-child {\n  margin-left: 0;\n}\n\n[dir=rtl] .left-header-content ul li .src-form .src-btn {\n  right: auto !important;\n  left: 20px !important;\n}\n\n@media only screen and (min-width: 1200px) {\n  [dir=rtl] .main-wrapper-content.active .sidebar-area:hover .sidebar-burger-menu {\n    right: auto !important;\n    left: 21px !important;\n  }\n}\n\n[dir=rtl] .stats-box .count {\n  margin-left: 0;\n  margin-right: 7px;\n}\n\n[dir=rtl] .apexcharts-legend.apexcharts-align-left.apx-legend-position-top {\n  right: auto !important;\n  left: 0 !important;\n}\n\n[dir=rtl] .sales_by_locations li {\n  padding-right: 0;\n  padding-left: 48px;\n}\n\n[dir=rtl] .table-src-form {\n  margin-right: 0;\n  margin-left: 20px;\n}\n\n[dir=rtl] .table-src-form i,\n[dir=rtl] .table-src-form span {\n  left: auto !important;\n  right: 15px !important;\n}\n\n[dir=rtl] .table-src-form .form-control {\n  padding-left: 0;\n  padding-right: 40px;\n}\n\n[dir=rtl] .chart-position {\n  right: auto;\n  left: 15px;\n}\n\n[dir=rtl] .default-table-area .table-responsive .table thead tr th:last-child {\n  padding-right: 8px !important;\n  padding-left: 25px !important;\n}\n\n[dir=rtl] .default-table-area .table-responsive .table thead tr th:first-child {\n  padding-left: 8px !important;\n  padding-right: 25px !important;\n}\n\n[dir=rtl] .default-table-area .table-responsive .table tbody tr td:last-child {\n  padding-right: 8px !important;\n  padding-left: 25px !important;\n}\n\n[dir=rtl] .default-table-area .table-responsive .table tbody tr td:first-child {\n  padding-left: 8px !important;\n  padding-right: 25px !important;\n}\n\n[dir=rtl] .default-table-area.email-list .table-responsive .table tbody tr td:last-child {\n  padding-right: 8px !important;\n  padding-left: 0 !important;\n}\n\n[dir=rtl] .default-table-area.email-list .table-responsive .table tbody tr td:first-child {\n  padding-left: 8px !important;\n  padding-right: 0 !important;\n}\n\n[dir=rtl] .default-table-area.email-list .pagination-area {\n  right: auto;\n  left: 20px;\n}\n\n[dir=rtl] .welcome-box.style-two .welcome-2 {\n  right: auto;\n  left: 0;\n}\n\n[dir=rtl] #projects_roadmap {\n  direction: ltr;\n}\n\n[dir=rtl] #student_interested_topics {\n  direction: ltr;\n}\n\n[dir=rtl] .courses-slide {\n  direction: ltr;\n}\n\n[dir=rtl] .courses-slide .flex-grow-1.ms-3 {\n  margin-right: 0;\n  margin-left: 15px !important;\n}\n\n[dir=rtl] .courses-slide .swiper-pagination2 {\n  left: auto !important;\n  right: 25px !important;\n  text-align: right;\n}\n\n[dir=rtl] .row.mb-4 .col-lg-8.col-sm-8.pe-sm-0 {\n  padding-right: 12px !important;\n}\n\n[dir=rtl] .row.mb-4 .col-lg-4.col-sm-4.ps-sm-0 {\n  padding-left: 12px !important;\n}\n\n[dir=rtl] .row.mb-4 .rounded-3 {\n  border-radius: 8px !important;\n}\n\n[dir=rtl] .month-select {\n  background-position: left 16px center !important;\n}\n\n[dir=rtl] .month-select.p-0 {\n  background-position: left 0 center !important;\n}\n\n[dir=rtl] .congratulations {\n  right: auto;\n  left: 0;\n}\n\n[dir=rtl] .upcoming-events-slide .ms-1 {\n  margin-right: 0 !important;\n  margin-left: 0.25rem !important;\n}\n\n[dir=rtl] .popular-tag {\n  left: auto;\n  right: 227px;\n}\n\n[dir=rtl] .populartsgs {\n  right: auto;\n  left: 20px;\n}\n\n[dir=rtl] .priceing-border::before {\n  left: auto;\n  right: -130px;\n}\n\n[dir=rtl] .priceing-border.style-two::before {\n  right: auto;\n  left: -130px;\n}\n\n[dir=rtl] .timeline-item {\n  padding-left: 0;\n  padding-right: 90px;\n}\n\n[dir=rtl] .timeline-item .border-style-for-timeline {\n  padding-left: 0;\n  padding-right: 30px;\n  border-left: none;\n  border-right: 1px dashed #D5D9E2;\n}\n\n[dir=rtl] .timeline-item .border-style-for-timeline::before {\n  left: auto;\n  right: -6px;\n}\n\n[dir=rtl] .timeline-item .time-line-date {\n  left: auto;\n  right: 0;\n}\n\n[dir=rtl] .breadcrumb-item+.breadcrumb-item {\n  padding-left: 0;\n  padding-right: 12px !important;\n}\n\n[dir=rtl] .file-subdown {\n  padding-left: 0;\n  padding-right: 28px;\n}\n\n[dir=rtl] .file-subdown li {\n  padding-left: 0;\n  padding-right: 15px;\n}\n\n[dir=rtl] .file-subdown li::before {\n  left: auto;\n  right: 0;\n}\n\n[dir=rtl] .mb-4.transition-y .ps-2 {\n  padding-right: 0 !important;\n  padding-left: 0.5rem !important;\n}\n\n[dir=rtl] .product-quantity .add-to-cart-counter .minusBtn {\n  border-radius: 0 4px 4px 0 !important;\n}\n\n[dir=rtl] .product-quantity .add-to-cart-counter .plusBtn {\n  border-radius: 4px 0 0 4px !important;\n}\n\n[dir=rtl] .form-control.form-select {\n  background-position: left 0.75rem center;\n}\n\n[dir=rtl] #projects_roadmap2 {\n  direction: ltr;\n}\n\n[dir=rtl] button.btn.border-primary.text-primary.position-absolute.hover-bg {\n  right: auto !important;\n  left: 24px !important;\n}\n\n[dir=rtl] .for-rtl-position {\n  right: auto !important;\n  left: 25px !important;\n}\n\n[dir=rtl] .start-0 {\n  left: auto;\n  right: 0;\n}\n\n[dir=rtl] .ps-20 {\n  padding-left: 0;\n  padding-right: 20px;\n}\n\n[dir=rtl] .end-0 {\n  right: auto !important;\n  left: 0 !important;\n}\n\n[dir=rtl] .ms-lg-auto {\n  margin-left: 0 !important;\n  margin-right: auto !important;\n}\n\n[dir=rtl] i.ri-eye-off-line.password-toggle-icon.translate-middle-y.top-50.end-0.position-absolute {\n  right: auto !important;\n  left: 15px !important;\n}\n\n[dir=rtl] #sales_report {\n  direction: ltr;\n}\n\n[dir=rtl] #balance_overview {\n  direction: ltr;\n}\n\n[dir=rtl] #top_sales {\n  direction: ltr;\n}\n\n[dir=rtl] #returning_customer_rate {\n  direction: ltr;\n}\n\n[dir=rtl] #projects_progress {\n  direction: ltr;\n}\n\n[dir=rtl] #project_analysis {\n  direction: ltr;\n}\n\n[dir=rtl] #time_spent {\n  direction: ltr;\n}\n\n[dir=rtl] #tickets_status {\n  direction: ltr;\n}\n\n[dir=rtl] #new_tickets_vs_solved_sickets {\n  direction: ltr;\n}\n\n[dir=rtl] .apexcharts-legend-text {\n  padding-left: 0;\n  padding-right: 5px;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n[dir=rtl] .sales_by_locations li .progress-bar .count {\n  right: auto;\n  left: 0;\n}\n\n[dir=rtl] .pagination {\n  padding-right: 0;\n}\n\n[dir=rtl] .pagination .page-item {\n  margin-right: 0;\n  margin-left: 7px;\n}\n\n[dir=rtl] .pagination .page-item:last-child {\n  margin-left: 0;\n}\n\n[dir=rtl] .offcanvas {\n  right: auto;\n  left: 0;\n  transform: translateX(-150%);\n}\n\n[dir=rtl] .offcanvas.show {\n  transform: translateX(0);\n}\n\n@media (min-width: 768px) {\n  [dir=rtl] .ms-md-3 {\n    margin-left: 0 !important;\n    margin-right: 1rem !important;\n  }\n}\n\n@media (min-width: 576px) {\n  [dir=rtl] .ms-sm-3 {\n    margin-left: 0 !important;\n    margin-right: 1rem !important;\n  }\n\n  [dir=rtl] .ms-sm-4 {\n    margin-left: 0 !important;\n    margin-right: 1.5rem !important;\n  }\n}\n\n[dir=rtl] .action-opt .dropdown-menu li .dropdown-item svg {\n  margin-right: 0;\n  margin-left: 2px;\n}\n\n[dir=rtl] .form-check {\n  padding-left: 0;\n  padding-right: 1.5em;\n}\n\n[dir=rtl] .form-check .form-check-input {\n  float: right;\n  margin-left: 0;\n  margin-right: -1.5em;\n}\n\n[dir=rtl] .form-check .form-check-label {\n  padding-left: 0;\n  padding-right: 5px;\n}\n\n[dir=rtl] .dot {\n  padding-left: 0;\n  padding-right: 15px;\n}\n\n[dir=rtl] .dot::before {\n  left: auto;\n  right: 0;\n}\n\n[dir=rtl] .chat-details .own-chat {\n  margin-left: 0 !important;\n  margin-right: auto;\n}\n\n[dir=rtl] .nav-tabs {\n  padding-right: 0;\n}\n\n[dir=rtl] .accordion-button::after {\n  margin-left: 0;\n  margin-right: auto;\n}\n\n@media (min-width: 992px) {\n  [dir=rtl] .ms-lg-5 {\n    margin-left: 0 !important;\n    margin-right: 3rem !important;\n  }\n}\n\n@media (min-width: 576px) {\n  [dir=rtl] .ps-sm-5 {\n    padding-left: 0 !important;\n    padding-right: 3rem !important;\n  }\n}\n\n@media (min-width: 576px) {\n  [dir=rtl] .ms-sm-5 {\n    margin-left: 0 !important;\n    margin-right: 3rem !important;\n  }\n}\n\n[dir=rtl] .ms-4 {\n  margin-left: 0 !important;\n  margin-right: 1.5rem !important;\n}\n\n[dir=rtl] .faq-wrapper.accordion .accordion-item .accordion-header .accordion-button.control {\n  padding-left: 0;\n  padding-right: 50px !important;\n}\n\n[dir=rtl] .faq-wrapper.accordion .accordion-item .accordion-header .accordion-button.control::after {\n  left: auto;\n  right: 0;\n}\n\n[dir=rtl] .copy-btn {\n  left: 40px !important;\n}\n\n@media (min-width: 1400px) {\n  [dir=rtl] .pe-xxl-5 {\n    padding-right: 0 !important;\n    padding-left: 3rem !important;\n  }\n}\n\n@media (min-width: 768px) {\n  [dir=rtl] .me-md-5 {\n    margin-right: 0 !important;\n    margin-left: 3rem !important;\n  }\n}\n\n[dir=rtl] .password-wrapper .password-toggle-icon {\n  right: auto !important;\n  left: 15px !important;\n}\n\n@media only screen and (max-width: 1199px) {\n  [dir=rtl] .sidebar-area {\n    left: auto;\n    right: -100%;\n    z-index: 2;\n  }\n\n  [dir=rtl] .sidebar-area .sidebar-burger-menu {\n    right: auto !important;\n    left: 17px !important;\n    z-index: 1 !important;\n    opacity: 1 !important;\n  }\n\n  [dir=rtl] .main-wrapper-content.active .sidebar-area {\n    right: 0;\n  }\n\n  [dir=rtl] .main-wrapper-content.active .sidebar-area .sidebar-burger-menu {\n    right: auto !important;\n    left: 20px !important;\n  }\n\n  [dir=rtl] .main-content {\n    padding-right: 12px;\n    padding-left: 12px;\n  }\n\n  [dir=rtl] .right-header-content .header-right-item {\n    margin-left: 13px;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  [dir=rtl] .right-header-content .header-right-item .dropdown.noti .dropdown-menu {\n    width: 275px;\n    transform: translate(-135px, 41px) !important;\n  }\n\n  [dir=rtl] .right-header-content .header-right-item .notifications.language .dropdown-menu {\n    left: auto !important;\n    right: 0 !important;\n  }\n\n  [dir=rtl] .left-header-content ul li .notifications.dropdown .dropdown-menu {\n    transform: translate(204px, 30px) !important;\n  }\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  [dir=rtl] .main-content {\n    padding-left: 12px;\n    padding-right: 262px;\n  }\n}\n\n@media only screen and (min-width: 1400px) and (max-width: 1799px) {\n  [dir=rtl] .main-content {\n    padding-left: 12px;\n    padding-right: 262px;\n  }\n}\n\n[dir=rtl] .rtl-btn {\n  background-color: #d08f2c;\n}\n\n[dir=rtl] .settings-btn .slider {\n  position: relative;\n}\n\n[dir=rtl] .settings-btn .slider:before {\n  opacity: 0;\n}\n\n[dir=rtl] .settings-btn .slider:after {\n  opacity: 1;\n}\n\n[dir=rtl] .sales_by_locations li .count {\n  right: auto;\n  left: 0;\n}\n\n[dir=rtl] .apexcharts-canvas {\n  direction: ltr;\n}\n\n[dir=rtl] .minus-l-20 {\n  margin-left: 0;\n  margin-right: -20px;\n}\n\n[dir=rtl] .minus-l-20:first-child {\n  margin-right: 0;\n}\n\n[dir=rtl] .ot-course-card ul {\n  justify-content: end;\n}\n\n[dir=rtl] .courses-slide .swiper-pagination {\n  bottom: 15px;\n  left: auto;\n  right: 10px;\n  text-align: right;\n}\n\n[dir=rtl] .upcoming-events-slide .d-flex {\n  justify-content: end;\n}\n\n[dir=rtl] .default-src-form .form-control {\n  padding-left: 0;\n  padding-right: 35px;\n}\n\n[dir=rtl] .default-src-form .start-0 {\n  right: 10px;\n}\n\n[dir=rtl] .default-table-area .table-responsive .table tbody tr td:first-child {\n  border-left: none;\n}\n\n[dir=rtl] .default-table-area .table-responsive .table tbody tr td:last-child {\n  border-right: none;\n}\n\n[dir=rtl] .toast-header .btn-close {\n  margin-right: 10px;\n  margin-left: 0;\n}\n\n[dir=rtl] .custom-modal.right {\n  right: auto;\n  left: -100%;\n}\n\n[dir=rtl] .custom-modal.right.show {\n  left: 0;\n  right: 0;\n}\n\n[dir=rtl] .custom-modal.right .custom-modal-content {\n  margin-left: 0;\n  margin-right: auto;\n}\n\n[dir=rtl] .custom-modal.left {\n  left: auto;\n  right: -100%;\n}\n\n[dir=rtl] .custom-modal.left.show {\n  left: 0;\n  right: 0;\n}\n\n[dir=rtl] .nft-slide .swiper-button-next,\n[dir=rtl] .nft-slide-two .swiper-button-next {\n  right: auto;\n  left: 0;\n}\n\n[dir=rtl] .for-rtl-chat .ms-auto {\n  margin-left: 0 !important;\n  margin-right: auto !important;\n  text-align: right;\n}\n\n[dir=rtl] .for-rtl-form .start-0 {\n  left: auto !important;\n  right: 0;\n}\n\n[dir=rtl] .for-rtl-form .form-control {\n  padding-right: 40px;\n}\n\n[dir=rtl] .date-time-picker-demo .react-datetime-picker__wrapper .react-datetime-picker__button {\n  margin-left: 0;\n  margin-right: 5px;\n}\n\n[dir=rtl] .ms-e-10 {\n  margin-right: 0;\n  margin-left: -10px;\n}\n\n[dir=rtl] .action-opt .dropdown-menu .dropdown-item i,\n[dir=rtl] .action-opt .dropdown-menu .dropdown-item span {\n  margin-right: 0;\n  margin-left: 5px;\n}\n\n[dir=rtl] .shape.shape-8 {\n  right: auto;\n  left: 200px;\n}\n\n[dir=rtl] .breadcrumb-page-list .breadcrumb .breadcrumb-item::before {\n  float: right;\n  padding-right: 0;\n  padding-left: 0.5rem;\n}\n\n[dir=rtl] .select-dropdown {\n  right: 0 !important;\n  left: -10px;\n}\n\n[dir=rtl] .select-dropdown .dropdown-item {\n  text-align: right;\n}\n\n[dir=rtl] .right-for-rtl {\n  right: auto !important;\n  left: -10px;\n}\n\n[dir=rtl] .position-for-mobile {\n  left: auto !important;\n  right: 0 !important;\n}\n\n[dir=rtl] .position-for-mobile ul.ps-0.mb-0.list-unstyled.last-child-none {\n  margin-left: 0 !important;\n  margin-right: -110px !important;\n}\n\n@media only screen and (max-width: 767px) {\n  [dir=rtl] .position-for-mobile {\n    position: initial !important;\n  }\n\n  [dir=rtl] .position-for-mobile ul.ps-0.mb-0.list-unstyled.last-child-none {\n    margin-right: -120px !important;\n  }\n}\n\n/* Dark Mode Area Style\n============================================*/\n.dark {\n  background-color: #000000 !important;\n}\n\n.dark body {\n  background-color: #000000 !important;\n  color: #fff !important;\n}\n\n.dark p,\n.dark span,\n.dark i,\n.dark .apexcharts-text,\n.dark td,\n.dark th,\n.dark a,\n.dark label {\n  color: #fff;\n}\n\n.dark .apexcharts-text {\n  fill: #fff;\n}\n\n.dark .apexcharts-legend-text {\n  color: #fff !important;\n}\n\n.dark .text-body {\n  color: #fff !important;\n}\n\n.dark ul li {\n  color: #fff !important;\n}\n\n.dark ol li {\n  color: #fff !important;\n}\n\n.dark .h1,\n.dark .h2,\n.dark .h3,\n.dark .h4,\n.dark .h5,\n.dark .h6,\n.dark h1,\n.dark h2,\n.dark h3,\n.dark h4,\n.dark h5,\n.dark h6 {\n  color: #fff;\n}\n\n.dark .text-secondary {\n  color: #fff !important;\n}\n\n.dark .text-dark {\n  color: #fff !important;\n}\n\n.dark .bg-white {\n  background-color: #101010 !important;\n}\n\n.dark .card {\n  background-color: #101010 !important;\n}\n\n.dark .card.bg-primary {\n  background-color: #d08f2c !important;\n}\n\n.dark .card.bg-card-bg-c .list-dot li {\n  color: #fff !important;\n}\n\n.dark .card .bg-body-bg {\n  background-color: #000000 !important;\n}\n\n.dark .bg-primary p {\n  color: #fff !important;\n}\n\n.dark .form-control {\n  background-color: #212121 !important;\n  border-color: #212121 !important;\n  color: #fff !important;\n}\n\n.dark .form-control:focus {\n  border-color: #d08f2c !important;\n}\n\n.dark .border {\n  border-color: #262626 !important;\n}\n\n.dark .border-top {\n  border-color: #262626 !important;\n}\n\n.dark .border-bottom {\n  border-color: #262626 !important;\n}\n\n.dark .border-start {\n  border-color: #262626 !important;\n}\n\n.dark .border-border-color {\n  border-color: #262626 !important;\n}\n\n.dark .settings-btn {\n  color: #fff;\n}\n\n.dark .settings-btn span {\n  color: #fff;\n}\n\n.dark .header-area {\n  background-color: #101010 !important;\n}\n\n.dark .left-header-content ul li .notifications.dropdown .btn-secondary i,\n.dark .left-header-content ul li .notifications.dropdown .btn-secondary span {\n  color: #fff;\n}\n\n.dark .left-header-content ul li .notifications.dropdown .dropdown-menu {\n  background-color: #101010;\n}\n\n.dark .left-header-content ul li .notifications.dropdown .dropdown-menu .dropdown-item span {\n  color: #fff;\n}\n\n.dark .left-header-content ul li .notifications.apps .dropdown-toggle::after {\n  display: none;\n}\n\n.dark .left-header-content ul li .header-burger-menu i,\n.dark .left-header-content ul li .header-burger-menu span {\n  color: #fff;\n}\n\n.dark .right-header-content .header-right-item .notifications.dropdown .btn-secondary i,\n.dark .right-header-content .header-right-item .notifications.dropdown .btn-secondary span {\n  color: #fff;\n}\n\n.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu {\n  background-color: #000000 !important;\n  border: 1px solid #333 !important;\n}\n\n.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .notification-menu {\n  border-color: #1b212a !important;\n}\n\n.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .title {\n  color: #fff !important;\n}\n\n.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .title span {\n  color: #fff !important;\n}\n\n.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .title button {\n  color: #fff !important;\n}\n\n.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item i {\n  background-color: #373a40;\n}\n\n.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item span {\n  transition: all ease 0.5s;\n  color: #fff !important;\n}\n\n.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item p span {\n  color: #fff !important;\n}\n\n.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:hover,\n.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:focus,\n.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item.active,\n.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:focus-visible {\n  background-color: #101010 !important;\n}\n\n.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .view-all {\n  border-color: #262626;\n}\n\n.dark .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .view-all span {\n  color: #fff !important;\n}\n\n.dark .right-header-content .header-right-item .admin-profile .dropdown-menu {\n  background-color: #000000 !important;\n  border: 1px solid #333 !important;\n}\n\n.dark .right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link {\n  border-color: #262626;\n}\n\n.dark .right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item i,\n.dark .right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item span {\n  color: #fff;\n}\n\n.dark .right-header-content .header-right-item .theme-settings-btn i,\n.dark .right-header-content .header-right-item .theme-settings-btn span {\n  color: #fff;\n}\n\n.dark .sidebar-burger-menu svg {\n  stroke: #fff;\n}\n\n.dark .sidebar-area {\n  background-color: #101010;\n}\n\n.dark .sidebar-area .logo {\n  border-color: #262626 !important;\n}\n\n.dark .sidebar-area .logo .logo-text {\n  color: #fff !important;\n}\n\n.dark .sidebar-area .admin .admin-info .name {\n  color: #fff;\n}\n\n.dark .sidebar-menu {\n  /* Track */\n  /* Handle */\n  /* Handle on hover */\n}\n\n.dark .sidebar-menu::-webkit-scrollbar-track {\n  background: #333;\n}\n\n.dark .sidebar-menu::-webkit-scrollbar-thumb {\n  background: #444;\n}\n\n.dark .sidebar-menu::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.dark .sidebar-menu .menu-title .menu-title-text {\n  color: #fff;\n}\n\n.dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button:hover {\n  background-color: #222222;\n}\n\n.dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button:hover i,\n.dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button:hover span {\n  color: #fff;\n}\n\n.dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .count {\n  background-color: rgba(255, 255, 255, 0.0784313725) !important;\n  color: #FD5812;\n}\n\n.dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button i,\n.dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button span {\n  color: #fff;\n}\n\n.dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .title {\n  color: #fff;\n}\n\n.dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button[aria-expanded=true] {\n  background-color: #222222;\n}\n\n.dark .sidebar-menu .menu-item .menu-link {\n  color: #3A4252;\n}\n\n.dark .sidebar-menu .menu-item .menu-link i,\n.dark .sidebar-menu .menu-item .menu-link span {\n  color: #fff;\n}\n\n.dark .sidebar-menu .menu-item .menu-link .title {\n  color: #fff;\n}\n\n.dark .sidebar-menu .menu-item .menu-link.logout {\n  background-color: #222222;\n}\n\n.dark .sidebar-menu .menu-item .menu-link.active,\n.dark .sidebar-menu .menu-item .menu-link:hover {\n  background-color: #222222;\n}\n\n.dark .sidebar-menu .sub-menu .menu-item .menu-link {\n  color: #fff;\n}\n\n.dark .sidebar-menu .sub-menu .menu-item .menu-link::before {\n  border: 1px solid #fff;\n}\n\n.dark .sidebar-menu .sub-menu .menu-item .menu-link.active,\n.dark .sidebar-menu .sub-menu .menu-item .menu-link:hover {\n  background-color: #222222;\n  color: #d08f2c;\n}\n\n.dark .sidebar-menu .sub-menu .menu-item .menu-link.active::before,\n.dark .sidebar-menu .sub-menu .menu-item .menu-link:hover::before {\n  opacity: 1;\n  border-color: #d08f2c;\n}\n\n.dark .sidebar-menu .sub-menu .menu-item .menu-link.active::after,\n.dark .sidebar-menu .sub-menu .menu-item .menu-link:hover::after {\n  border-color: #fff;\n}\n\n.dark .menu-vertical .menu-item .menu-link .title {\n  color: #fff;\n}\n\n.dark .menu-vertical .menu-item .menu-link i,\n.dark .menu-vertical .menu-item .menu-link span {\n  color: #fff;\n}\n\n.dark .menu-vertical .menu-item .menu-link:hover {\n  background-color: #212121;\n}\n\n.dark .menu-vertical .menu-item .menu-link.logout {\n  background-color: #212121 !important;\n}\n\n.dark .menu-vertical .menu-item.open .menu-link.active {\n  background-color: #212121;\n  color: #d08f2c;\n}\n\n.dark .menu-vertical .menu-item.open .menu-link.active .title {\n  color: #fff;\n}\n\n.dark .menu-vertical .menu-item.open .menu-link.active::before {\n  border-color: #d08f2c;\n}\n\n.dark .menu-vertical .menu-title .menu-title-text {\n  color: #fff;\n}\n\n.dark .menu-vertical .menu-sub .menu-item .menu-link {\n  color: #c5c5c5;\n}\n\n.dark .menu-vertical .menu-sub .menu-item .menu-link::before {\n  border-color: #fff;\n}\n\n.dark .menu-vertical .menu-sub .menu-item .menu-link.active {\n  color: #fff;\n}\n\n.dark .menu-vertical .menu-sub .menu-item .menu-link:hover::before {\n  border-color: #d08f2c;\n  background-color: transparent;\n}\n\n.dark .action-opt .dropdown-menu {\n  background-color: #000000 !important;\n}\n\n.dark .action-opt .dropdown-menu li .dropdown-item {\n  color: #fff;\n}\n\n.dark .default-table-area .table-responsive .table {\n  border-color: #262626;\n}\n\n.dark .default-table-area .table-responsive .table thead tr th {\n  background-color: #212121;\n  color: #fff;\n  border-color: #262626;\n}\n\n.dark .default-table-area .table-responsive .table tbody tr td {\n  color: #fff;\n  border-color: #262626;\n}\n\n.dark .default-table-area .table-responsive .table tbody tr td a h6,\n.dark .default-table-area .table-responsive .table tbody tr td a .h6 {\n  color: #fff;\n}\n\n.dark .default-table-area .showing-wrap {\n  border-color: #262626;\n}\n\n.dark .default-table-area.agents-performance-overview.style-three .table-responsive .table tbody tr td {\n  border-top: 10px solid #101010;\n  background-color: #212121;\n}\n\n.dark .pagination .page-item .page-link {\n  background: #212121;\n  border-color: #212121;\n  color: #fff;\n}\n\n.dark .pagination .page-item .page-link.active {\n  background-color: #d08f2c;\n}\n\n.dark .pagination .page-item .page-link:hover {\n  background-color: #d08f2c;\n}\n\n.dark .footer-area {\n  background-color: #101010 !important;\n}\n\n.dark .apexcharts-text.apexcharts-datalabel-value {\n  fill: #fff !important;\n}\n\n.dark .apexcharts-radialbar-hollow {\n  fill: #14171c !important;\n}\n\n.dark .apexcharts-gridline {\n  stroke: #262626;\n}\n\n.dark #top_sales .apexcharts-gridline {\n  stroke: #101010;\n}\n\n.dark #total_orders1 .apexcharts-gridline {\n  stroke: #101010;\n}\n\n.dark #total_evenue .apexcharts-gridline {\n  stroke: #101010;\n}\n\n.dark #total_customers .apexcharts-gridline {\n  stroke: #101010;\n}\n\n.dark .offcanvas {\n  background-color: #000000 !important;\n}\n\n.dark .offcanvas-header .btn-close {\n  opacity: 1;\n  filter: invert(1);\n}\n\n.dark .offcanvas-header.bg-body-bg {\n  background-color: #212121 !important;\n}\n\n.dark .form-check-input {\n  background-color: transparent;\n}\n\n.dark .stats-box.style-three {\n  background-color: #212121 !important;\n}\n\n.dark .stats-box.style-three span {\n  color: #fff;\n}\n\n.dark .priceing-border::before {\n  border-color: #262626;\n}\n\n.dark .faq-wrapper.accordion .accordion-item {\n  background-color: transparent;\n}\n\n.dark .faq-wrapper.accordion .accordion-item .accordion-body {\n  background-color: #212121;\n  color: #828690;\n}\n\n.dark .faq-wrapper.accordion .accordion-item .accordion-header .accordion-button {\n  background-color: #212121 !important;\n}\n\n.dark .faq-wrapper.accordion .accordion-item .accordion-header .accordion-button:not(.collapsed) {\n  background-color: #212121;\n}\n\n.dark .timeline-wrap .timeline-item-2 .text {\n  background-color: #212121;\n}\n\n.dark .calendar-wrap {\n  background-color: transparent;\n}\n\n.dark .calendar-wrap .fc tbody tr th {\n  border-color: #262626;\n  background-color: #212121;\n}\n\n.dark .calendar-wrap .fc .fc-col-header-cell-cushion {\n  color: #fff;\n}\n\n.dark .calendar-wrap .fc .fc-today-button {\n  color: #fff;\n}\n\n.dark .calendar-wrap .fc-icon-chevron-left:before {\n  color: #fff;\n}\n\n.dark .calendar-wrap .fc-icon-chevron-right:before {\n  color: #fff;\n}\n\n.dark .calendar-wrap .fc-theme-standard td,\n.dark .calendar-wrap .fc-theme-standard .calendar-wrap .fc-theme-standard th {\n  border-color: #262626;\n}\n\n.dark .calendar-wrap .fc-theme-standard .fc-scrollgrid {\n  border-color: #262626;\n}\n\n.dark .calendar-wrap .fc-daygrid-day-number {\n  color: #fff;\n}\n\n.dark .chat-details li p {\n  background-color: #000000;\n}\n\n.dark .chat-details li.own-chat p {\n  background-color: #d08f2c;\n  color: #fff !important;\n}\n\n.dark .chat-call-option li button {\n  background-color: #212121;\n}\n\n.dark .chat-call-option li button:hover {\n  background-color: #d08f2c;\n}\n\n.dark .bg-gary-light.for-dark {\n  background-color: #000000 !important;\n}\n\n.dark #editor-container {\n  border-color: #262626 !important;\n}\n\n.dark .ql-toolbar.ql-snow {\n  background-color: #212121;\n  border-color: #262626;\n}\n\n.dark .ql-snow .ql-picker.ql-expanded .ql-picker-label {\n  color: #fff !important;\n}\n\n.dark .ql-snow .ql-picker.ql-expanded .ql-picker-label::before {\n  color: #fff !important;\n}\n\n.dark .ql-snow .ql-stroke {\n  stroke: #fff;\n}\n\n.dark .kanban-for-dark .rounded-3 {\n  background-color: #212121 !important;\n}\n\n.dark .file-for-dark.card {\n  background-color: #212121 !important;\n}\n\n.dark ::-webkit-calendar-picker-indicator {\n  filter: invert(1);\n}\n\n.dark .seller-tabs .nav-item .nav-link {\n  background-color: #212121 !important;\n}\n\n.dark .seller-tabs .nav-item .nav-link.active {\n  background-color: #d08f2c !important;\n}\n\n.dark .bg-body-bg.product-for-dark {\n  background-color: #212121 !important;\n}\n\n.dark .product-quantity {\n  border-color: #1d2127;\n}\n\n.dark .product-quantity .add-to-cart-counter .minusBtn,\n.dark .product-quantity .product-quantity .add-to-cart-counter .plusBtn {\n  background-color: #212121 !important;\n}\n\n.dark .product-quantity .add-to-cart-counter .minusBtn:hover,\n.dark .product-quantity .product-quantity .add-to-cart-counter .plusBtn:hover {\n  background-color: #d08f2c !important;\n}\n\n.dark .product-quantity .add-to-cart-counter input {\n  background-color: #212121;\n  border-color: #212121;\n  color: #fff;\n}\n\n.dark .product-quantity.bg-e2e8f0 {\n  background-color: transparent;\n}\n\n.dark .product-quantity.bg-e2e8f0 .add-to-cart-counter .minusBtn,\n.dark .product-quantity.bg-e2e8f0 .add-to-cart-counter .plusBtn {\n  background-color: #212121;\n}\n\n.dark .product-quantity.bg-e2e8f0 .add-to-cart-counter .minusBtn:hover,\n.dark .product-quantity.bg-e2e8f0 .add-to-cart-counter .plusBtn:hover {\n  background-color: #d08f2c;\n}\n\n.dark .product-quantity .add-to-cart-counter .minusBtn,\n.dark .product-quantity .add-to-cart-counter .plusBtn {\n  background-color: #212121;\n}\n\n.dark .product-quantity .add-to-cart-counter .minusBtn:hover,\n.dark .product-quantity .add-to-cart-counter .plusBtn:hover {\n  background-color: #d08f2c;\n}\n\n.dark .product-details-content .border-0.bg-transparent span {\n  color: #fff !important;\n}\n\n.dark .product-details-content .border-0.bg-transparent .bg-border-color {\n  background-color: #212121 !important;\n}\n\n.dark .product-details-content .ps-0.mb-0.list-unstyled.d-flex.gap-2.flex-wrap .hover-bg {\n  background-color: #212121 !important;\n}\n\n.dark .product-details-content .ps-0.mb-0.list-unstyled.d-flex.gap-2.flex-wrap .hover-bg:hover {\n  background-color: #d08f2c !important;\n}\n\n.dark .review-tabs .nav-item .nav-link {\n  border-color: #212121 !important;\n}\n\n.dark .review-tabs .nav-item .nav-link.active {\n  border-color: #d08f2c !important;\n}\n\n.dark .tracking-step.style-two .count {\n  background-color: #212121 !important;\n}\n\n.dark .bg-for-dark-mode {\n  background-color: #000000 !important;\n}\n\n.dark .course-accordion.accordion .accordion-item {\n  background-color: transparent;\n}\n\n.dark .course-accordion.accordion .accordion-item .accordion-body {\n  color: #828690;\n}\n\n.dark .course-accordion.accordion .accordion-item .accordion-header .accordion-button {\n  background-color: #212121 !important;\n}\n\n.dark .course-accordion.accordion .accordion-item .accordion-header .accordion-button:not(.collapsed)::after {\n  background-color: #b3b3b3;\n  border-radius: 100%;\n}\n\n.dark .course-accordion.accordion .accordion-item .accordion-header .accordion-button:not(.collapsed) {\n  background-color: #212121;\n}\n\n.dark .nav-tabs {\n  border-color: #262626;\n  background-color: transparent !important;\n}\n\n.dark .nav-tabs .nav-link {\n  border: none;\n}\n\n.dark .nav-tabs .nav-link:hover {\n  border: none;\n}\n\n.dark .nav-tabs .nav-link.active,\n.dark .nav-tabs .nav-tabs .nav-item.show .nav-link {\n  background-color: #212121;\n  border-color: #262626;\n  color: #fff;\n}\n\n.dark :not(pre)>code[class*=language-],\n.dark pre[class*=language-] {\n  background: #212121;\n}\n\n.dark code[class*=language-],\n.dark pre[class*=language-] {\n  text-shadow: none;\n  color: #fff;\n}\n\n.dark .list-group-item {\n  border-color: #262626;\n  background-color: #000000 !important;\n}\n\n.dark .modal-content {\n  background-color: #212121;\n}\n\n.dark .modal-header {\n  border-color: #262626;\n  background-color: #101010;\n}\n\n.dark .modal-footer {\n  border-color: #262626;\n  background-color: #101010;\n}\n\n.dark #x__PREV__X {\n  background-color: #212121;\n}\n\n.dark #x__NEXT__X {\n  background-color: #212121;\n}\n\n.dark .input-group-text {\n  background-color: #000000;\n  border-color: #000000;\n}\n\n.dark .input-group-text img {\n  border-radius: 50px;\n}\n\n.dark .calendar-content th,\n.dark .calendar-content td {\n  background-color: #212121;\n  color: #fff;\n}\n\n.dark .calendar-content .active-date {\n  background-color: #d08f2c;\n  color: #fff;\n}\n\n.dark .calendar-content table {\n  background-color: #212121;\n}\n\n.dark .form-check .form-check-label {\n  color: #fff;\n}\n\n.dark .wizard-tabs .nav-item .nav-link {\n  background-color: #000000 !important;\n}\n\n.dark .wizard-tabs .nav-item .nav-link.active {\n  background-color: #d08f2c !important;\n}\n\n.dark .wizard-tabs2 .nav-item .nav-link {\n  background-color: #101010;\n}\n\n.dark .wizard-tabs2 .nav-item .nav-link span {\n  background-color: #212121 !important;\n}\n\n.dark .wizard-tabs2 .nav-item .nav-link.active span {\n  background-color: #d08f2c !important;\n}\n\n.dark .for-light-logo {\n  display: none;\n}\n\n.dark .for-dark-logo {\n  display: block;\n}\n\n.dark .toast-header {\n  background-color: #212121 !important;\n  border-color: #262626;\n}\n\n.dark .toast-body {\n  background-color: #000000 !important;\n}\n\n.dark #preloader {\n  background-color: #14171c;\n}\n\n.dark #preloader .preloader .waviy span {\n  color: #fff;\n}\n\n.dark div:where(.swal2-container) div:where(.swal2-popup) {\n  background-color: #212121;\n}\n\n.dark div#swal2-html-container {\n  color: #fff;\n}\n\n.dark .form-select {\n  background-color: #212121;\n  border-color: #212121;\n}\n\n.dark .welcome-box .border-bottom {\n  border-color: #262626 !important;\n}\n\n.dark .control-panel-modal .modal-header.bg-body-bg {\n  background-color: #000000 !important;\n  border-left: 1px solid #333;\n  border-bottom: 1px solid #333;\n}\n\n.dark .control-panel-modal .modal-header .btn-close {\n  background-color: #fff;\n  opacity: 1;\n  width: 30px;\n  height: 30px;\n  border-radius: 100px;\n}\n\n.dark .control-panel-modal .cpm-content {\n  background-color: #000;\n  border-left: 1px solid #333;\n}\n\n.dark .react-calendar {\n  background-color: #101010;\n}\n\n.dark .react-calendar .react-calendar__month-view__weekdays .react-calendar__month-view__weekdays__weekday {\n  color: #fff;\n}\n\n.dark .react-calendar .react-calendar__month-view__days .react-calendar__tile {\n  color: #fff;\n}\n\n.dark .btn {\n  color: #fff;\n}\n\n.dark .btn span,\n.dark .btn i {\n  color: #fff;\n}\n\n.dark .kb-card {\n  background-color: #212121 !important;\n}\n\n.dark code,\n.dark pre {\n  background-color: #212121 !important;\n  color: #fff !important;\n}\n\n.dark .navbar.bg-body-tertiary {\n  background-color: #000 !important;\n}\n\n.dark .trezo-accordion {\n  background-color: #212121;\n  border: 1px solid #212121;\n}\n\n.dark .trezo-accordion .accordion-item {\n  background-color: #212121;\n  border-color: #444;\n}\n\n.dark .trezo-accordion .accordion-item .accordion-button {\n  background-color: #212121;\n  color: #fff;\n}\n\n.dark .react-select__control {\n  background-color: #212121;\n  border-color: #212121;\n}\n\n.dark .react-select__control .react-select__indicator-separator {\n  background-color: #474747;\n}\n\n.dark .testimonials-card {\n  background-color: #212121 !important;\n}\n\n.dark .bg-body {\n  background-color: #212121 !important;\n}\n\n.dark .date-time-picker-demo .react-datetime-picker__wrapper {\n  border: 1px solid #000000;\n  background: #000000;\n}\n\n.dark .date-time-picker-demo .react-datetime-picker__wrapper .react-datetime-picker__button svg {\n  stroke: #fff;\n}\n\n.dark .date-time-picker-demo .react-calendar {\n  border: 1px solid #333;\n}\n\n.dark .custom-modal {\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.dark .custom-modal .close-link {\n  color: #fff;\n}\n\n.dark .custom-modal .custom-modal-header {\n  background-color: #000000;\n}\n\n.dark .custom-modal .custom-modal-content {\n  background-color: #000000;\n}\n\n.dark .custom-radio input[type=radio]:checked+.radio-content {\n  background: #000000;\n}\n\n.dark .bg-border-color {\n  background-color: #000 !important;\n}\n\n.dark .for-dark-card {\n  background-color: #0C1427 !important;\n}\n\n.dark .recent-property-slide .bg-white {\n  background-color: #000000 !important;\n}\n\n.dark .bg-ecf0ff,\n.dark .bg-faf5ff,\n.dark .bg-fff5ed {\n  background-color: #000000;\n}\n\n.dark .t-chart .apexcharts-text {\n  fill: #fff !important;\n}\n\n.dark .t-chart .apexcharts-tooltip-y-group span {\n  color: #fff !important;\n}\n\n.dark .products-list-tabs li .nav-link {\n  background-color: #1c1b1b;\n  color: #fff;\n}\n\n.dark .badge.completed,\n.dark .badge.confirmed,\n.dark .badge.active,\n.dark .badge.published,\n.dark .badge.successful,\n.dark .badge.available,\n.dark .badge.happening,\n.dark .badge.upcoming,\n.dark .badge.read {\n  color: #d08f2c !important;\n}\n\n.dark .accordion-button:not(.collapsed)::after {\n  filter: contrast(0.4);\n}\n\n.dark .payment-method .text-black {\n  color: #717171 !important;\n}\n\n.dark .border-gray-100 {\n  border-color: #212121 !important;\n}\n\n.dark .welcome-for-hotel {\n  background-color: #000000 !important;\n}\n\n.dark .popular-rooms-slide .swiper-pagination .swiper-pagination-bullet {\n  background-color: #555;\n  opacity: 1;\n}\n\n.dark .popular-rooms-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  background-color: #d08f2c;\n}\n\n.dark .bg-gray-100 {\n  background-color: #212121 !important;\n}\n\n.dark .bg-gray-100.border {\n  border-color: #212121 !important;\n}\n\n.dark .my-featured-listings-bg {\n  background-color: #222222 !important;\n}\n\n.dark .rea-manage-app {\n  background-color: #222222 !important;\n}\n\n.dark .rea-client-ratings-card .bg-border-color-50,\n.dark .rea-client-ratings-card .bg-danger-100,\n.dark .rea-client-ratings-card .bg-success-90 {\n  background-color: #222222 !important;\n}\n\n.dark .rea-client-ratings-slide .swiper-pagination .swiper-pagination-bullet,\n.dark .my-featured-listings-slide .swiper-pagination .swiper-pagination-bullet {\n  background-color: #555;\n  opacity: 1;\n}\n\n.dark .rea-client-ratings-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active,\n.dark .my-featured-listings-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  background-color: #d08f2c;\n}\n\n.dark .cc-card {\n  background-image: inherit !important;\n}\n\n.dark .gradient-card-dark {\n  background: #222222 !important;\n}\n\n.dark .bg-black-for-dark {\n  background-color: #000 !important;\n}\n\n.dark-top-navbar .header-area {\n  background-color: #101010 !important;\n}\n\n.dark-top-navbar .left-header-content p,\n.dark-top-navbar .left-header-content span {\n  color: #fff;\n}\n\n.dark-top-navbar .left-header-content ul li .src-form .form-control {\n  background-color: #212121;\n  border-color: #212121;\n  color: #fff !important;\n}\n\n.dark-top-navbar .left-header-content ul li .notifications.dropdown .btn-secondary i,\n.dark-top-navbar .left-header-content ul li .notifications.dropdown .btn-secondary span {\n  color: #fff;\n}\n\n.dark-top-navbar .left-header-content ul li .notifications.dropdown .dropdown-menu {\n  background-color: #101010;\n}\n\n.dark-top-navbar .left-header-content ul li .notifications.dropdown .dropdown-menu .dropdown-item span {\n  color: #fff;\n}\n\n.dark-top-navbar .left-header-content ul li .notifications.apps .dropdown-toggle::after {\n  display: none;\n}\n\n.dark-top-navbar .left-header-content ul li .header-burger-menu i,\n.dark-top-navbar .left-header-content ul li .header-burger-menu span {\n  color: #fff;\n}\n\n.dark-top-navbar .right-header-content p,\n.dark-top-navbar .right-header-content span {\n  color: #fff;\n}\n\n.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .btn-secondary i,\n.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .btn-secondary span {\n  color: #fff;\n}\n\n.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu {\n  background-color: #000000 !important;\n  border: 1px solid #333 !important;\n}\n\n.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .notification-menu {\n  border-color: #1b212a !important;\n}\n\n.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .title {\n  color: #fff !important;\n}\n\n.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .title span {\n  color: #fff !important;\n}\n\n.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .title button {\n  color: #fff !important;\n}\n\n.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item i,\n.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item span {\n  background-color: #373a40;\n}\n\n.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item span {\n  transition: all ease 0.5s;\n  color: #fff !important;\n}\n\n.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item p {\n  color: #fff;\n}\n\n.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item p span {\n  color: #fff !important;\n}\n\n.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .dropdown-item:hover {\n  background-color: #101010 !important;\n}\n\n.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .view-all {\n  border-color: #262626;\n}\n\n.dark-top-navbar .right-header-content .header-right-item .notifications.dropdown .dropdown-menu .view-all span {\n  color: #fff !important;\n}\n\n.dark-top-navbar .right-header-content .header-right-item .admin-profile h3,\n.dark-top-navbar .right-header-content .header-right-item .admin-profile .h3 {\n  color: #fff;\n}\n\n.dark-top-navbar .right-header-content .header-right-item .admin-profile .dropdown-menu {\n  background-color: #000000 !important;\n  border: 1px solid #333 !important;\n}\n\n.dark-top-navbar .right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link {\n  border-color: #262626;\n}\n\n.dark-top-navbar .right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item i,\n.dark-top-navbar .right-header-content .header-right-item .admin-profile .dropdown-menu .admin-link li .dropdown-item span {\n  color: #fff;\n}\n\n.dark-top-navbar .right-header-content .header-right-item .theme-settings-btn i,\n.dark-top-navbar .right-header-content .header-right-item .theme-settings-btn span {\n  color: #fff;\n}\n\n.left-sidebar-dark .sidebar-area {\n  background-color: #101010;\n}\n\n.left-sidebar-dark .sidebar-area .logo {\n  border-color: #262626 !important;\n}\n\n.left-sidebar-dark .sidebar-area .logo .logo-text {\n  color: #fff !important;\n}\n\n.left-sidebar-dark .sidebar-area .sidebar-burger-menu {\n  color: #fff;\n}\n\n.left-sidebar-dark .sidebar-area .admin .admin-info .name {\n  color: #fff;\n}\n\n.left-sidebar-dark .sidebar-menu {\n  /* Track */\n  /* Handle */\n  /* Handle on hover */\n}\n\n.left-sidebar-dark .sidebar-menu::-webkit-scrollbar-track {\n  background: #333;\n}\n\n.left-sidebar-dark .sidebar-menu::-webkit-scrollbar-thumb {\n  background: #444;\n}\n\n.left-sidebar-dark .sidebar-menu::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.left-sidebar-dark .sidebar-menu .menu-title .menu-title-text {\n  color: #fff;\n}\n\n.left-sidebar-dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button:hover {\n  background-color: #222222;\n}\n\n.left-sidebar-dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button:hover i,\n.left-sidebar-dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button:hover span {\n  color: #fff;\n}\n\n.left-sidebar-dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button i,\n.left-sidebar-dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button span {\n  color: #fff;\n}\n\n.left-sidebar-dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button .title {\n  color: #fff;\n}\n\n.left-sidebar-dark .sidebar-menu .accordion .accordion-item .accordion-header .accordion-button[aria-expanded=true] {\n  background-color: #222222;\n}\n\n.left-sidebar-dark .sidebar-menu .menu-item .menu-link {\n  color: #3A4252;\n}\n\n.left-sidebar-dark .sidebar-menu .menu-item .menu-link i,\n.left-sidebar-dark .sidebar-menu .menu-item .menu-link span {\n  color: #fff;\n}\n\n.left-sidebar-dark .sidebar-menu .menu-item .menu-link .title {\n  color: #fff;\n}\n\n.left-sidebar-dark .sidebar-menu .menu-item .menu-link.logout {\n  background-color: #222222;\n}\n\n.left-sidebar-dark .sidebar-menu .menu-item .menu-link.active,\n.left-sidebar-dark .sidebar-menu .menu-item .menu-link:hover {\n  background-color: #222222;\n}\n\n.left-sidebar-dark .sidebar-menu .sub-menu .menu-item .menu-link {\n  color: #fff;\n}\n\n.left-sidebar-dark .sidebar-menu .sub-menu .menu-item .menu-link::before {\n  border: 1px solid #fff;\n}\n\n.left-sidebar-dark .sidebar-menu .sub-menu .menu-item .menu-link.active,\n.left-sidebar-dark .sidebar-menu .sub-menu .menu-item .menu-link:hover {\n  background-color: #222222;\n  color: #d08f2c;\n}\n\n.left-sidebar-dark .sidebar-menu .sub-menu .menu-item .menu-link.active::before,\n.left-sidebar-dark .sidebar-menu .sub-menu .menu-item .menu-link:hover::before {\n  opacity: 1;\n  border-color: #d08f2c;\n}\n\n.left-sidebar-dark .sidebar-menu .sub-menu .menu-item .menu-link.active::after,\n.left-sidebar-dark .sidebar-menu .sub-menu .menu-item .menu-link:hover::after {\n  border-color: #fff;\n}\n\n/* Only Radius Square Area Style\n============================================*/\n[card-radius-square-data-theme=card-radius] .card-style-btn {\n  background-color: #d08f2c;\n}\n\n[card-radius-square-data-theme=card-radius] .card {\n  border-radius: 0 !important;\n}\n\n[card-radius-square-data-theme=card-radius] .btn {\n  border-radius: 0;\n}\n\n[card-radius-square-data-theme=card-radius] .rounded {\n  border-radius: 0 !important;\n}\n\n[card-radius-square-data-theme=card-radius] .header-area {\n  border-radius: 0 !important;\n}\n\n[card-radius-square-data-theme=card-radius] .rounded-top-7 {\n  border-radius: 0 !important;\n}\n\n[card-radius-square-data-theme=card-radius] .pagination .page-item .page-link {\n  border-radius: 0;\n}\n\n[card-radius-square-data-theme=card-radius] .form-control {\n  border-radius: 0 !important;\n}\n\n[card-radius-square-data-theme=card-radius] .right-header-content .header-right-item .notifications.dropdown .btn-secondary {\n  border-radius: 0;\n}\n\n[card-radius-square-data-theme=card-radius] .menu-vertical .menu-item .menu-link {\n  border-radius: 0;\n}\n\n[card-radius-square-data-theme=card-radius] .settings-btn {\n  border-radius: 0;\n}\n\n[card-radius-square-data-theme=card-radius] .radius {\n  display: inline-block;\n}\n\n[card-radius-square-data-theme=card-radius] .square {\n  display: none;\n}\n\n/* Only Card Background Area Style\n============================================*/\n[card-bg-data-theme=card-bg-gray] {\n  background-color: #fff !important;\n}\n\n[card-bg-data-theme=card-bg-gray] .card-bg-style-btn {\n  background-color: #d08f2c;\n}\n\n[card-bg-data-theme=card-bg-gray] .card {\n  background-color: #F6F7F9 !important;\n}\n\n[card-bg-data-theme=card-bg-gray] .card.bg-primary-div {\n  background-color: #d08f2c !important;\n}\n\n[card-bg-data-theme=card-bg-gray] .card.bg-primary {\n  background-color: #d08f2c !important;\n}\n\n[card-bg-data-theme=card-bg-gray] .header-area {\n  background-color: #F6F7F9 !important;\n}\n\n[card-bg-data-theme=card-bg-gray] .sidebar-area {\n  background-color: #F6F7F9 !important;\n}\n\n[card-bg-data-theme=card-bg-gray] .footer-area {\n  background-color: #F6F7F9 !important;\n}\n\n[card-bg-data-theme=card-bg-gray] .sidebar-area .admin .admin-info {\n  background-color: #F6F7F9 !important;\n}\n\n[card-bg-data-theme=card-bg-gray] .offcanvas {\n  background-color: #F6F7F9 !important;\n}\n\n[card-bg-data-theme=card-bg-gray] .white {\n  display: inline-block;\n}\n\n[card-bg-data-theme=card-bg-gray] .gray {\n  display: none;\n}\n\n/* Fluid & Boxed Area Style\n============================================*/\n[boxed-style-data-theme=boxed-style-boxed].boxed-size {\n  width: 1440px;\n  margin: auto;\n}\n\n[boxed-style-data-theme=boxed-style-boxed] .fluid-boxed-btn {\n  background-color: #d08f2c;\n}\n\n[boxed-style-data-theme=boxed-style-boxed] .fluid {\n  display: inline-block;\n}\n\n[boxed-style-data-theme=boxed-style-boxed] .boxed {\n  display: none;\n}\n\n[boxed-style-data-theme=boxed-style-boxed] .sidebar-area {\n  inset-inline-start: auto !important;\n}\n\n[boxed-style-data-theme=boxed-style-boxed] .priceing-border::before {\n  left: -67px;\n}\n\n[boxed-style-data-theme=boxed-style-boxed] .popular-tag {\n  left: 160px;\n}\n\n@media only screen and (min-width: 1920px) {\n  [boxed-style-data-theme=boxed-style-boxed] .custom-xxxl-10 {\n    flex: 0 0 auto;\n    width: 66.6666666667%;\n  }\n\n  [boxed-style-data-theme=boxed-style-boxed] .custom-xxxl-2 {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n}\n\n/* Landing Page Area Style\n============================================*/\n.ptb-150 {\n  padding-top: 150px;\n  padding-bottom: 150px;\n}\n\n.pt-150 {\n  padding-top: 150px;\n}\n\n.pb-150 {\n  padding-bottom: 150px;\n}\n\n.pb-125 {\n  padding-bottom: 125px;\n}\n\n.pt-125 {\n  padding-top: 125px;\n}\n\n.fs-60 {\n  font-size: 60px;\n}\n\n.shape {\n  position: absolute;\n  z-index: -1;\n}\n\n.shape.shape-1 {\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n}\n\n.shape.shape-2 {\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n}\n\n.shape.shape-3 {\n  top: 0;\n  left: 0;\n}\n\n.shape.shape-4 {\n  top: 200px;\n  right: 0;\n}\n\n.shape.shape-5 {\n  bottom: -100px;\n  left: 0;\n}\n\n.shape.shape-6 {\n  bottom: -250px;\n  right: 0;\n}\n\n.shape.shape-7 {\n  top: -180px;\n  left: 0;\n  filter: blur(125px);\n}\n\n.shape.shape-8 {\n  top: -160px;\n  right: 200px;\n  filter: blur(75px);\n}\n\n.shape.shape-9 {\n  bottom: 0;\n  left: 0;\n  filter: blur(75px);\n}\n\n.shape.shape-10 {\n  bottom: 0;\n  right: 0;\n  filter: blur(75px);\n}\n\n.navbar {\n  padding: 20px 0;\n}\n\n.navbar.sticky {\n  position: sticky;\n  top: 0;\n  width: 100%;\n  z-index: 10;\n  animation: 500ms ease-in-out 0s normal none 1 running fadeInDown;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  background-color: #fff !important;\n}\n\n.navbar .white-logo {\n  display: none;\n}\n\n.navbar .btn:hover {\n  color: #fff !important;\n}\n\n.navbar-nav .nav-link.active {\n  color: #d08f2c !important;\n}\n\n.page-banner-area {\n  padding-top: 195px;\n}\n\n.page-banner-area .shape-5 {\n  top: -220px;\n  left: -50px;\n  z-index: -1;\n  position: absolute;\n  filter: blur(150px);\n}\n\n.page-banner-area .shape-6 {\n  bottom: 0;\n  z-index: -1;\n  right: -30px;\n  position: absolute;\n  filter: blur(250px);\n}\n\n.banner-content {\n  margin-bottom: 75px;\n}\n\n.banner-area {\n  padding-top: 185px;\n  padding-bottom: 150px;\n  background-position: center -350px !important;\n}\n\n.banner-content {\n  margin-bottom: 75px;\n}\n\n.top-title {\n  color: #d08f2c;\n  border: 1px solid #d08f2c;\n  padding: 5.5px 17px;\n  display: inline-block;\n  position: relative;\n  transform: rotate(-6.536deg);\n  margin-bottom: 10px;\n}\n\n.top-title::before,\n.top-title::after {\n  content: \"\";\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  width: 7px;\n  height: 7px;\n  background-color: #d08f2c;\n}\n\n.top-title::after {\n  right: auto;\n  left: -4px;\n}\n\n.top-title span::before,\n.top-title span::after {\n  content: \"\";\n  position: absolute;\n  bottom: -4px;\n  right: -4px;\n  width: 7px;\n  height: 7px;\n  background-color: #d08f2c;\n}\n\n.top-title span::after {\n  right: auto;\n  left: -4px;\n}\n\n.section-title {\n  max-width: 848px;\n  margin: auto;\n  margin-bottom: 60px;\n  text-align: center;\n}\n\n.section-title.mw-630 {\n  max-width: 630px;\n}\n\n.section-title h2,\n.section-title .h2 {\n  font-size: 36px;\n  line-height: 1.4;\n  letter-spacing: -1px;\n}\n\n.section-title h2:last-child,\n.section-title .h2:last-child {\n  margin-bottom: 0;\n}\n\n.key-features-single-item {\n  margin-bottom: 25px;\n}\n\n.key-features-single-item i,\n.key-features-single-item span {\n  width: 85px;\n  height: 85px;\n  line-height: 85px;\n  font-size: 55px;\n  text-align: center;\n  border-radius: 17px;\n  margin-bottom: 20px;\n}\n\n.key-features-single-item h3,\n.key-features-single-item .h3 {\n  font-size: 24px;\n  margin-bottom: 15px;\n  font-weight: 600;\n}\n\n.tailor-content h2,\n.tailor-content .h2 {\n  font-size: 36px;\n  line-height: 1.4;\n  letter-spacing: -1px;\n  margin-bottom: 60px;\n}\n\n.tailor-content ul li {\n  margin-bottom: 30px;\n}\n\n.tailor-content ul li:last-child {\n  margin-bottom: 0;\n}\n\n.masonrow {\n  -moz-column-width: 25em;\n  -webkit-column-width: 25em;\n  -moz-column-gap: 1.6em;\n  -webkit-column-gap: 1.6em;\n}\n\n.masonrow .item {\n  width: 100%;\n  margin-bottom: 25px;\n  display: inline-block;\n}\n\n.masonrow.style-two {\n  -moz-column-width: 22em;\n  -webkit-column-width: 22em;\n  -moz-column-gap: 1.6em;\n  -webkit-column-gap: 1.6em;\n}\n\n.masonrow.style-two .item {\n  width: 100%;\n  margin-bottom: 30px;\n  display: inline-block;\n}\n\n.single-testimonials {\n  background-color: #fff;\n  border-radius: 10px;\n  padding: 40px;\n  position: relative;\n  display: block;\n}\n\n.single-testimonials .reating {\n  margin-bottom: 22px;\n}\n\n.single-testimonials .reating li {\n  display: inline-block;\n}\n\n.single-testimonials .reating li i,\n.single-testimonials .reating li span {\n  color: #FFBC2B;\n  font-size: 20px;\n}\n\n.single-testimonials p {\n  margin-bottom: 22px;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.9;\n}\n\n.single-testimonials .review-info h4,\n.single-testimonials .review-info .h4 {\n  font-size: 16px;\n  margin-bottom: 5px;\n}\n\n.single-testimonials .review-info span {\n  font-size: 14px;\n}\n\n.team-slide .swiper-pagination {\n  position: initial;\n  margin-top: 30px;\n}\n\n.team-slide .swiper-pagination .swiper-pagination-bullet {\n  width: 10px;\n  height: 10px;\n}\n\n.team-slide .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  background-color: #d08f2c;\n}\n\n.our-team-single-item .team-img {\n  border-radius: 7px;\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  background: rgba(255, 255, 255, 0.26);\n  backdrop-filter: blur(3.5999999046px);\n  padding: 16px;\n}\n\n.our-team-single-item .team-img img {\n  border-radius: 7px;\n}\n\n.our-team-single-item .team-content {\n  border-radius: 7px;\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  background: rgba(255, 255, 255, 0.26);\n  backdrop-filter: blur(3.5999999046px);\n  padding: 30px;\n  margin-top: -1px;\n}\n\n.team-controller .controller-icon {\n  width: 64px;\n  height: 64px;\n  line-height: 64px;\n  text-align: center;\n  background-color: #ECF0FF;\n  display: inline-block;\n  font-size: 20px;\n  border-radius: 100px;\n  transition: all ease 0.5s;\n}\n\n.team-controller .controller-icon:hover {\n  background-color: #d08f2c;\n  color: #fff;\n}\n\n.contact-us-img {\n  border-radius: 7px;\n  border: 1px solid rgba(255, 255, 255, 0.13);\n  background: rgba(255, 255, 255, 0.31);\n  backdrop-filter: blur(5.0999999046px);\n  padding: 16px;\n}\n\n.contact-us-img img {\n  border-radius: 7px;\n}\n\n.contact-us-form h2,\n.contact-us-form .h2 {\n  font-size: 36px;\n  line-height: 1.4;\n  letter-spacing: -1px;\n  margin-bottom: 60px;\n}\n\n.unlock-content {\n  max-width: 825px;\n  margin: auto;\n  text-align: center;\n}\n\n.unlock-content h2,\n.unlock-content .h2 {\n  font-size: 48px;\n  letter-spacing: -1.5px;\n  line-height: 1.4;\n  margin-bottom: 20px;\n}\n\n.unlock-content p {\n  margin-bottom: 45px;\n}\n\n#backtotop {\n  position: fixed;\n  top: 100%;\n  right: 30px;\n  bottom: 30px;\n  margin: auto;\n  width: 40px;\n  height: 40px;\n  border: none;\n  background-color: #d08f2c;\n  transform: translateY(-100%);\n  z-index: 2;\n  transition: all ease 0.5s;\n  font-size: 20px;\n  border-radius: 4px;\n}\n\n#backtotop i,\n#backtotop span {\n  color: #fff;\n}\n\n#backtotop:hover {\n  background-color: #d08f2c;\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n  .ptb-150 {\n    padding-top: 60px;\n    padding-bottom: 60px;\n  }\n\n  .pt-150 {\n    padding-top: 60px;\n  }\n\n  .pb-150 {\n    padding-bottom: 60px;\n  }\n\n  .pb-125 {\n    padding-bottom: 35px;\n  }\n\n  .pt-125 {\n    padding-top: 35px;\n  }\n\n  .fs-60 {\n    font-size: 30px;\n  }\n\n  .banner-area {\n    padding-top: 145px;\n    padding-bottom: 60px;\n  }\n\n  .banner-content {\n    margin-bottom: 30px;\n  }\n\n  .banner-content p {\n    font-size: 16px !important;\n  }\n\n  .section-title {\n    margin-bottom: 35px;\n  }\n\n  .section-title h2,\n  .section-title .h2 {\n    font-size: 25px;\n  }\n\n  .key-features-single-item i,\n  .key-features-single-item span {\n    width: 70px;\n    height: 70px;\n    line-height: 70px;\n    font-size: 40px;\n  }\n\n  .key-features-single-item h3,\n  .key-features-single-item .h3 {\n    font-size: 20px;\n  }\n\n  .tailor-content {\n    margin-top: 30px;\n  }\n\n  .tailor-content h2,\n  .tailor-content .h2 {\n    font-size: 25px;\n    margin-bottom: 35px;\n  }\n\n  .single-testimonials {\n    padding: 25px;\n  }\n\n  .single-testimonials .reating {\n    margin-bottom: 15px;\n  }\n\n  .single-testimonials p {\n    margin-bottom: 15px;\n    font-size: 15px;\n  }\n\n  .team-controller .controller-icon {\n    width: 45px;\n    height: 45px;\n    line-height: 45px;\n  }\n\n  .our-team-single-item .team-content {\n    padding: 20px;\n  }\n\n  .shape.shape-3 {\n    top: auto;\n    bottom: 0;\n  }\n\n  .contact-us-form h2,\n  .contact-us-form .h2 {\n    font-size: 25px;\n    margin-bottom: 30px;\n  }\n\n  .unlock-content h2,\n  .unlock-content .h2 {\n    font-size: 25px;\n    margin-bottom: 15px;\n  }\n\n  .unlock-content p {\n    margin-bottom: 20px;\n  }\n}\n\n/* Min width 768px to Max width 992px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .ptb-150 {\n    padding-top: 60px;\n    padding-bottom: 60px;\n  }\n\n  .pt-150 {\n    padding-top: 60px;\n  }\n\n  .pb-150 {\n    padding-bottom: 60px;\n  }\n\n  .pb-125 {\n    padding-bottom: 35px;\n  }\n\n  .pt-125 {\n    padding-top: 35px;\n  }\n\n  .fs-60 {\n    font-size: 50px;\n  }\n\n  .banner-area {\n    padding-top: 145px;\n    padding-bottom: 60px;\n  }\n\n  .banner-content {\n    margin-bottom: 30px;\n  }\n\n  .banner-content p {\n    font-size: 16px !important;\n  }\n\n  .section-title {\n    margin-bottom: 35px;\n  }\n\n  .section-title h2,\n  .section-title .h2 {\n    font-size: 30px;\n  }\n\n  .key-features-single-item i,\n  .key-features-single-item span {\n    width: 70px;\n    height: 70px;\n    line-height: 70px;\n    font-size: 40px;\n  }\n\n  .key-features-single-item h3,\n  .key-features-single-item .h3 {\n    font-size: 20px;\n  }\n\n  .tailor-content {\n    margin-top: 30px;\n  }\n\n  .tailor-content h2,\n  .tailor-content .h2 {\n    font-size: 30px;\n    margin-bottom: 35px;\n  }\n\n  .single-testimonials {\n    padding: 25px;\n  }\n\n  .single-testimonials .reating {\n    margin-bottom: 15px;\n  }\n\n  .single-testimonials p {\n    margin-bottom: 15px;\n    font-size: 15px;\n  }\n\n  .team-controller .controller-icon {\n    width: 45px;\n    height: 45px;\n    line-height: 45px;\n  }\n\n  .our-team-single-item .team-content {\n    padding: 20px;\n  }\n\n  .contact-us-form h2,\n  .contact-us-form .h2 {\n    font-size: 30px;\n    margin-bottom: 30px;\n  }\n\n  .unlock-content h2,\n  .unlock-content .h2 {\n    font-size: 35px;\n    margin-bottom: 15px;\n  }\n\n  .unlock-content p {\n    margin-bottom: 20px;\n  }\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n\n  .contact-us-form h2,\n  .contact-us-form .h2 {\n    font-size: 35px;\n  }\n}\n\n@media only screen and (max-width: 991px) {\n  .navbar {\n    background-color: #fff;\n  }\n\n  .navbar.bg-opacity-25 {\n    --bs-bg-opacity: 1 !important;\n  }\n\n  .navbar-toggler:focus {\n    box-shadow: none;\n  }\n}\n\n.footer-logo .white-logo {\n  display: none;\n}\n\n[dir=rtl] .our-team-area .section-title.mw-630 {\n  margin-left: auto !important;\n  margin-right: 0 !important;\n}\n\n.dark .navbar.sticky {\n  background-color: #000 !important;\n}\n\n.dark .navbar .black-logo {\n  display: none;\n}\n\n.dark .navbar .white-logo {\n  display: block !important;\n}\n\n.dark .single-testimonials {\n  background-color: #101010;\n}\n\n.dark .our-team-single-item .team-img {\n  border: 1px solid #101010;\n  background: #101010;\n}\n\n.dark .our-team-single-item .team-content {\n  border: 1px solid #101010;\n  background: #101010;\n}\n\n.dark .faq-wrapper.accordion .accordion-item .accordion-header .accordion-button {\n  color: #fff;\n}\n\n.dark .footer-logo .white-logo {\n  display: block;\n}\n\n.dark .footer-logo .black-logo {\n  display: none;\n}\n\n.dark .copyright-area.bg-white {\n  background-color: #101010 !important;\n}\n\n@media only screen and (max-width: 991px) {\n  .dark .navbar {\n    background-color: #000;\n  }\n}\n\n/* Analytics Dashboard Area Style\n============================================*/\n.analytics-tabs {\n  border: 1px solid #ECEEF2;\n  border-radius: 7px;\n}\n\n.analytics-tabs li button {\n  padding: 3px 15px;\n  border: 0;\n  background-color: transparent;\n  color: #fff;\n}\n\n.analytics-tabs li button.active {\n  background-color: #ECF0FF;\n}\n\n.analytics-tabs li button:hover {\n  background-color: #ECF0FF;\n}\n\n.analytics-tabs li:nth-child(2) button {\n  border-left: 1px solid #ECEEF2;\n  border-right: 1px solid #ECEEF2;\n}\n\n.cryptocurrency-controller .controller-icon {\n  width: 30px;\n  height: 30px;\n  line-height: 29px;\n  text-align: center;\n  border: 1px solid #ECEEF2;\n  display: inline-block;\n  font-size: 17px;\n  border-radius: 4px;\n  transition: all ease 0.5s;\n}\n\n.cryptocurrency-controller .controller-icon:hover {\n  background-color: #d08f2c;\n  color: #fff;\n}\n\n@media only screen and (max-width: 575px) {\n  .analytics-tabs {\n    margin-bottom: 10px !important;\n  }\n\n  .analytics-tabs li button {\n    padding: 3px 12px;\n  }\n}\n\n/* Min width 1400px to Max width 1799px */\n@media only screen and (min-width: 1400px) and (max-width: 1799px) {\n  .ms-minus-27 {\n    margin-left: -27px;\n  }\n\n  .me-plus-27 {\n    margin-right: 27px;\n  }\n\n  .ms-plus-21 {\n    margin-left: 21px;\n  }\n}\n\n/* Marketing Area Style\n============================================*/\n/* Marketing Dashboard CSS */\n.create-campaigns-tabs {\n  max-width: 960px;\n  margin: auto;\n  margin-bottom: 60px;\n}\n\n.create-campaigns-tabs .tab button {\n  position: relative;\n  padding: 0;\n  padding-bottom: 5px;\n  letter-spacing: 2px;\n}\n\n.create-campaigns-tabs .tab button::before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 0;\n  height: 2px;\n  background-color: #d08f2c;\n  transition: all ease 0.5s;\n}\n\n.create-campaigns-tabs .tab.active button {\n  color: #d08f2c !important;\n}\n\n.create-campaigns-tabs .tab.active button::before {\n  width: 100%;\n  right: auto;\n  left: 0;\n}\n\n.custom-radio {\n  width: 100%;\n  position: relative;\n  cursor: pointer;\n}\n\n.custom-radio input[type=radio] {\n  position: absolute;\n  left: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: #e2e4e7;\n  width: 20px;\n  height: 20px;\n  margin-top: 2px;\n}\n\n.custom-radio input[type=radio]:checked+.radio-content:after {\n  content: \"\";\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  background: #d08f2c;\n  left: 20px;\n  top: 50%;\n  transform: translateY(-50%);\n  border-radius: 100%;\n  border: 3px solid #fff;\n  box-shadow: 0px 0px 0px 2px #d08f2c;\n}\n\n.custom-radio input[type=radio]:checked+.radio-content {\n  border: 2px dashed #d08f2c;\n  background: #ECEEF2;\n  transition: ease-in 0.3s;\n}\n\n.custom-radio input[type=radio]:focus {\n  box-shadow: none;\n}\n\n.custom-radio .radio-content {\n  border: 2px dashed #e2e4e7;\n  border-radius: 10px;\n  position: relative;\n  padding: 18px;\n  padding-left: 55px;\n}\n\n.custom-radio.style-two input[type=radio] {\n  left: 0;\n  width: 30px;\n  height: 30px;\n  margin-top: -9px;\n}\n\n.custom-radio.style-two input[type=radio]:checked+.radio-content:after {\n  left: 0;\n  width: 30px;\n  height: 30px;\n}\n\n.custom-radio.style-two input[type=radio]:checked+.radio-content {\n  border: none;\n  background-color: transparent;\n}\n\n.custom-radio.style-two .radio-content {\n  padding: 0;\n  border: none;\n  padding-left: 45px;\n}\n\n.form-check {\n  position: relative;\n}\n\n.form-check.style .form-check-label {\n  padding: 0 0 0 40px;\n  color: #000;\n}\n\n.form-check.style .form-check-input {\n  width: 30px;\n  height: 30px;\n  border: 0;\n  background-color: #ECEEF2;\n  margin: 0;\n  position: absolute;\n  left: 0;\n  top: 5px;\n}\n\n.form-check.style .label-description {\n  padding-left: 40px;\n}\n\n.form-check.style .form-check-input:checked {\n  background-color: #d08f2c;\n}\n\n.form-check.style.after-check .form-check-input {\n  width: 20px;\n  height: 20px;\n  border: 0;\n}\n\n.form-check.style.after-check .form-check-input::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 2px dashed #ECEEF2;\n  z-index: 1;\n  border-radius: 6px;\n}\n\n.form-check.style.after-check .form-check-input::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #fff;\n  z-index: -1;\n  border-radius: 6px;\n}\n\n.form-check.style.after-check .form-check-input:checked {\n  background-color: #d08f2c;\n}\n\n.form-check.style.after-check .form-check-input:checked::before {\n  border-color: #5DA8FF;\n}\n\n.form-check.style.after-check .form-check-input:checked::after {\n  background-color: #ECEEF2;\n}\n\n.tab-content-wrap .tab-contents {\n  display: none;\n}\n\n.tab-content-wrap .tab-contents.active {\n  display: block;\n}\n\n.tab-content-wrap .tab-contents.back-none {\n  position: relative;\n}\n\n.tab-content-wrap .tab-contents.back-none::before {\n  content: \"\";\n  position: absolute;\n  bottom: -88px;\n  left: -560px;\n  right: 0;\n  margin: auto;\n  width: 625px;\n  height: 50px;\n  background-color: #f6f7f9;\n}\n\n@media only screen and (max-width: 767px) {\n  .create-campaigns-tabs {\n    margin-bottom: 30px;\n  }\n}\n\n[dir=rtl] .form-check {\n  position: relative;\n}\n\n[dir=rtl] .form-check.style .form-check-label {\n  padding: 0 40px 0 0;\n}\n\n[dir=rtl] .form-check.style .form-check-input {\n  left: auto;\n  right: 0;\n}\n\n[dir=rtl] .form-check.style .label-description {\n  padding-left: 0;\n  padding-right: 40px;\n}\n\n.dark .form-check.style .form-check-label {\n  color: #fff;\n}\n\n.dark .form-check.style .form-check-input {\n  background-color: #2f2f2f;\n}\n\n/* FNT Area Style\n============================================*/\n/* NFT Dashboard CSS */\n.place-bid .opacity-0 {\n  transition: all ease 0.5s;\n}\n\n.place-bid:hover .opacity-0 {\n  opacity: 1 !important;\n}\n\n.nft-slide {\n  margin-top: -95px;\n}\n\n.nft-slide .swiper-button-prev,\n.nft-slide .swiper-button-next {\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  text-align: center;\n  background-color: #3A4252;\n  color: #C2CDFF;\n  border-radius: 100px;\n  transition: all ease 0.5s;\n}\n\n.nft-slide .swiper-button-prev::after,\n.nft-slide .swiper-button-next::after {\n  font-size: 18px;\n}\n\n.nft-slide .swiper-button-prev:hover,\n.nft-slide .swiper-button-next:hover {\n  background-color: #d08f2c;\n}\n\n.nft-slide .swiper-button-prev.swiper-button-disabled,\n.nft-slide .swiper-button-prev.swiper-button-disabled,\n.nft-slide .swiper-button-next.swiper-button-disabled,\n.nft-slide .swiper-button-next.swiper-button-disabled {\n  pointer-events: auto;\n}\n\n.nft-slide .swiper-button-prev {\n  left: 0;\n}\n\n.nft-slide .swiper-button-next {\n  right: 0;\n}\n\n.nft-slide-two .swiper-button-prev,\n.nft-slide-two .swiper-button-next {\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  text-align: center;\n  background-color: #3A4252;\n  color: #C2CDFF;\n  border-radius: 100px;\n  transition: all ease 0.5s;\n}\n\n.nft-slide-two .swiper-button-prev::after,\n.nft-slide-two .swiper-button-next::after {\n  font-size: 18px;\n}\n\n.nft-slide-two .swiper-button-prev:hover,\n.nft-slide-two .swiper-button-next:hover {\n  background-color: #d08f2c;\n}\n\n.nft-slide-two .swiper-button-prev.swiper-button-disabled,\n.nft-slide-two .swiper-button-prev.swiper-button-disabled,\n.nft-slide-two .swiper-button-next.swiper-button-disabled,\n.nft-slide-two .swiper-button-next.swiper-button-disabled {\n  pointer-events: auto;\n}\n\n.nft-slide-two .swiper-button-prev {\n  left: 0;\n}\n\n.nft-slide-two .swiper-button-next {\n  right: 0;\n}\n\n.top-collections-slide .swiper-pagination {\n  position: initial;\n  margin-top: 15px;\n  line-height: 1;\n}\n\n.ethereum-rate-tabs {\n  margin-bottom: 30px;\n  border: 0;\n}\n\n.ethereum-rate-tabs .nav-item .nav-link {\n  width: 47px;\n  height: 32px;\n  padding: 0;\n  border: 0;\n  font-weight: 600;\n  font-size: 12px;\n  border-radius: 4px;\n  color: #64748B;\n}\n\n.ethereum-rate-tabs .nav-item .nav-link.active {\n  background-color: #d08f2c !important;\n  color: #fff !important;\n}\n\n.swiper-pagination-top-collections.swiper-pagination-clickable .swiper-pagination-bullet {\n  background-color: #526077;\n}\n\n.live-auction .nav-item .nav-link {\n  padding: 0;\n}\n\n.live-auction .nav-item .nav-link.active {\n  color: #d08f2c !important;\n}\n\n.clockdiv {\n  background: rgba(255, 255, 255, 0.6);\n  backdrop-filter: blur(12px);\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 10px;\n  margin: 6px;\n}\n\n.clockdiv .time {\n  color: #3A4252;\n  font-size: 14px;\n  font-weight: 700;\n  position: relative;\n}\n\n.clockdiv .time::before {\n  content: \":\";\n  position: absolute;\n  right: -10px;\n}\n\n.clockdiv .time:last-child::before {\n  display: none;\n}\n\n.clockdiv .days {\n  position: relative;\n  padding-right: 10px;\n}\n\n.clockdiv .days::before {\n  content: \"d\";\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n}\n\n.clockdiv .hours {\n  position: relative;\n  padding-right: 10px;\n}\n\n.clockdiv .hours::before {\n  content: \"h\";\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n}\n\n.clockdiv .minutes {\n  position: relative;\n  padding-right: 15px;\n}\n\n.clockdiv .minutes::before {\n  content: \"m\";\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n}\n\n.clockdiv .seconds {\n  position: relative;\n  padding-right: 10px;\n}\n\n.clockdiv .seconds::before {\n  content: \"s\";\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n  .manage-nft {\n    padding: 20px !important;\n    padding-bottom: 120px !important;\n  }\n\n  .nft-detail-tabs .nav-item .nav-link {\n    width: 50px !important;\n  }\n}\n\n/* Min width 768px to Max width 992px */\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .nft-detail-tabs .nav-item .nav-link {\n    width: 50px !important;\n  }\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .nft-detail-tabs .nav-item .nav-link {\n    width: 60px !important;\n  }\n}\n\n/* Min width 1400px to Max width 1799px */\n/* Restaurant Area Style\n============================================*/\n.welcome-restaurant {\n  padding: 60px 30px;\n  padding-bottom: 57px;\n}\n\n.welcome-restaurant h2,\n.welcome-restaurant .h2 {\n  color: #fff;\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 125%;\n  letter-spacing: -0.5px;\n  max-width: 326px;\n  margin-bottom: 30px;\n}\n\n.welcome-restaurant .dish-wrap {\n  position: absolute;\n  top: 50%;\n  right: 38px;\n  transform: translateY(-50%);\n}\n\n.welcome-restaurant .dish-wrap .dish-img {\n  animation: rotateAndReverse 4s linear infinite;\n}\n\n.welcome-restaurant .dish-wrap .dish-shape {\n  position: absolute;\n  top: 0;\n  right: 30px;\n}\n\n.welcome-restaurant .dish-wrap .dish-shape1 {\n  position: absolute;\n  top: -10px;\n  left: -15px;\n}\n\n.welcome-restaurant .dish-wrap .dish-shape2 {\n  position: absolute;\n  bottom: -10px;\n  right: -15px;\n}\n\n@keyframes rotateAndReverse {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  50% {\n    transform: rotate(180deg);\n  }\n\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n.revenue-card {\n  padding: 22px 24px;\n}\n\n.revenue-card h2,\n.revenue-card .h2 {\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 125%;\n  letter-spacing: -0.5px;\n  margin-bottom: 0;\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n  .welcome-restaurant {\n    padding: 20px;\n  }\n\n  .welcome-restaurant h2,\n  .welcome-restaurant .h2 {\n    font-size: 20px;\n    max-width: 200px;\n    margin-bottom: 15px;\n  }\n}\n\n@media only screen and (max-width: 520px) {\n  .dish-wrap {\n    display: none;\n  }\n}\n\n/* Min width 768px to Max width 992px */\n/* Min width 992px to Max width 1199px */\n/* Min width 1200px to Max width 1399px */\n/* Min width 1400px to Max width 1799px */\n.dark .welcome-restaurant {\n  background-color: #FE7A36 !important;\n}\n\n[dir=rtl] .welcome-restaurant .dish-wrap {\n  right: auto;\n  left: 38px;\n}\n\n.dish-details-images-card {\n  padding: 13px;\n  margin-bottom: 15px;\n  border-radius: 7px;\n}\n\n.dish-details-card {\n  padding: 25px;\n  border-radius: 7px;\n}\n\n.dish-details-card .trezo-card-content .text-xs {\n  font-size: 12px;\n}\n\n.dish-details-card .trezo-card-content h3,\n.dish-details-card .trezo-card-content .h3 {\n  font-size: 24px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.dish-details-card .trezo-card-content .price {\n  font-size: 16px;\n  color: #EC1F00;\n}\n\n.dish-details-card .trezo-card-content .ratings {\n  font-size: 15px;\n  color: #FE7A36;\n}\n\n.dish-details-card .trezo-card-content .ratings i {\n  margin-right: 2px;\n}\n\n.dish-details-card .trezo-card-content .ratings i:last-child {\n  margin-right: 0;\n}\n\n.dish-details-card .trezo-card-content .ratings span.text-xs {\n  font-size: 12px;\n  margin-left: 2px;\n}\n\n.dish-details-card .trezo-card-content .border-top {\n  border-color: #ECEEF2 !important;\n  margin-top: 25px;\n  margin-bottom: 25px;\n}\n\n.dish-details-card .trezo-card-content h4,\n.dish-details-card .trezo-card-content .h4 {\n  font-size: 18px;\n  margin-bottom: 12px;\n}\n\n.dish-details-card .trezo-card-content .nutrition-values {\n  margin-bottom: 25px;\n  margin-top: 15px;\n}\n\n.dish-details-card .trezo-card-content .nutrition-values .item {\n  padding: 10px 20px;\n  border: 1px solid #ECEEF2;\n}\n\n.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(1) .item,\n.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(2) .item,\n.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(3) .item,\n.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(4) .item,\n.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(5) .item,\n.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(6) .item {\n  border-bottom-width: 0;\n}\n\n.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(1) .item,\n.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(3) .item,\n.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(5) .item,\n.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(7) .item,\n.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(9) .item,\n.dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(11) .item {\n  border-right-width: 0;\n}\n\n.dark .dish-details-card .trezo-card-content .ratings i {\n  color: #FE7A36;\n}\n\n.dark .dish-details-card .trezo-card-content .border-top {\n  border-color: #333 !important;\n}\n\n.dark .dish-details-card .trezo-card-content .nutrition-values .item {\n  border: 1px solid #333;\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n  .dish-details-card {\n    height: auto;\n  }\n\n  .dish-details-card .trezo-card-content h3,\n  .dish-details-card .trezo-card-content .h3 {\n    font-size: 20px;\n    margin-top: 8px;\n    margin-bottom: 8px;\n  }\n\n  .dish-details-card .trezo-card-content .price {\n    font-size: 14px;\n  }\n\n  .dish-details-card .trezo-card-content .ratings {\n    margin-top: 12px;\n  }\n\n  .dish-details-card .trezo-card-content .border-top {\n    margin-top: 17px;\n    margin-bottom: 17px;\n  }\n\n  .dish-details-card .trezo-card-content h4,\n  .dish-details-card .trezo-card-content .h4 {\n    font-size: 16px;\n  }\n\n  .dish-details-card .trezo-card-content .mb-25 {\n    margin-bottom: 17px !important;\n  }\n\n  .dish-details-card .trezo-card-content .nutrition-values {\n    margin-bottom: 17px;\n    margin-top: 15px;\n  }\n\n  .dish-details-card .trezo-card-content .nutrition-values .item {\n    padding: 10px 15px;\n  }\n\n  .dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(7) .item {\n    border-bottom-width: 0;\n  }\n\n  .dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(1) .item,\n  .dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(3) .item,\n  .dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(5) .item,\n  .dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(7) .item,\n  .dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(9) .item,\n  .dish-details-card .trezo-card-content .nutrition-values .col-md-6:nth-child(11) .item {\n    border-right-width: 1px;\n  }\n}\n\n/* Min width 576px to Max width 767px */\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .dish-details-card .trezo-card-content .border-top {\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n\n  .dish-details-card .trezo-card-content .mb-25 {\n    margin-bottom: 20px !important;\n  }\n\n  .dish-details-card .trezo-card-content .nutrition-values {\n    margin-bottom: 20px;\n  }\n}\n\n/* Min width 768px to Max width 991px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .dish-details-card {\n    height: auto;\n  }\n\n  .dish-details-card .trezo-card-content h3,\n  .dish-details-card .trezo-card-content .h3 {\n    font-size: 22px;\n  }\n\n  .dish-details-card .trezo-card-content .price {\n    font-size: 15px;\n  }\n\n  .dish-details-card .trezo-card-content h4,\n  .dish-details-card .trezo-card-content .h4 {\n    font-size: 17px;\n  }\n}\n\n/* Min width 992px to Max width 1199px */\n/* Min width 1200px to Max width 1399px */\n/* Min width 1600px */\n.with-horizontal-navbar .header-area {\n  position: fixed;\n  left: 0;\n  right: 0;\n  border-radius: 0 0 7px 7px !important;\n}\n\n.with-horizontal-navbar .header-area::before {\n  left: 0;\n  right: 0;\n  top: 75px;\n  content: \"\";\n  height: 1px;\n  position: absolute;\n  background: #ECEEF2;\n}\n\n.with-horizontal-navbar .header-area .container-fluid,\n.with-horizontal-navbar .header-area .container-sm,\n.with-horizontal-navbar .header-area .container-md,\n.with-horizontal-navbar .header-area .container-lg,\n.with-horizontal-navbar .header-area .container-xl,\n.with-horizontal-navbar .header-area .container-xxl {\n  max-width: 1295px;\n}\n\n.with-horizontal-navbar .header-area .logo-box {\n  display: block !important;\n}\n\n.horizontal-navbar-area {\n  max-width: 1295px;\n  margin-top: 13px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-bottom: 0;\n  padding-top: 13px;\n  display: none;\n}\n\n.horizontal-navbar-area .accordion {\n  gap: 6px;\n}\n\n.horizontal-navbar-area .accordion .accordion-item {\n  background-color: transparent;\n  color: #3A4252;\n  white-space: nowrap;\n  position: relative;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-button {\n  display: flex;\n  align-items: center;\n  color: #3A4252;\n  font-size: 14px;\n  background-color: transparent;\n  padding-bottom: 9px;\n  padding-right: 33px;\n  padding-left: 14px;\n  padding-top: 9px;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-button i {\n  transition: all ease 0.5s;\n  color: #fff;\n  margin-right: 7px;\n  font-size: 22px;\n  line-height: 1;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-button .trezo-badge {\n  padding: 0;\n  width: 20px;\n  height: 20px;\n  font-size: 11px;\n  line-height: 20px;\n  color: #FD5812;\n  background-color: #fff5ed;\n  margin-left: 11px;\n  margin-right: 0;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-button .trezo-badge.style-two {\n  color: #00b69b;\n  background: rgba(0, 182, 155, 0.07);\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-button .trezo-badge.style-three {\n  color: #ee368c;\n  background: rgba(238, 54, 140, 0.1);\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-button::after {\n  display: none;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-button::before {\n  top: 50%;\n  right: 8px;\n  margin-top: 1px;\n  content: \"\\ea4e\";\n  position: absolute;\n  color: #fff;\n  transform: translateY(-50%);\n  transition: all ease 0.5s;\n  font-size: 19px;\n  font-family: remixicon;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-button:hover {\n  color: #3A4252;\n  background-color: #f6f7f9;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-button:hover i {\n  color: #3A4252;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-button:hover::before {\n  color: #3A4252;\n}\n\n.horizontal-navbar-area .accordion .accordion-item:has(.active) .accordion-button {\n  color: #3A4252;\n  background-color: #f6f7f9;\n}\n\n.horizontal-navbar-area .accordion .accordion-item:has(.active) .accordion-button i {\n  color: #3A4252;\n}\n\n.horizontal-navbar-area .accordion .accordion-item:has(.active) .accordion-button::before {\n  color: #3A4252;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body {\n  left: 0;\n  top: 100%;\n  opacity: 0;\n  z-index: 1;\n  width: 270px;\n  padding: 12px 0;\n  margin-top: 13px;\n  position: absolute;\n  visibility: hidden;\n  transition: all ease 0.5s;\n  background-color: #fff;\n  box-shadow: 0 0.25rem 1.125rem 0 rgba(47, 43, 61, 0.1);\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button {\n  color: #fff;\n  font-size: 14px;\n  background-color: transparent;\n  padding-bottom: 10px;\n  padding-right: 10px;\n  padding-left: 31px;\n  padding-top: 10px;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button::after {\n  top: 50%;\n  left: 13px;\n  width: 10px;\n  content: \"\";\n  height: 10px;\n  transition: 0.3s;\n  border-radius: 50%;\n  position: absolute;\n  display: inline-block;\n  transform: translateY(-50%);\n  background: unset !important;\n  border: 1px solid #fff;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button i {\n  margin-right: 0;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button:hover,\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button.active {\n  background-color: #ecf0ff;\n  color: #d08f2c;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button:hover i,\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button.active i {\n  color: #d08f2c;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button:hover::after,\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button.active::after {\n  border-color: #d08f2c;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button:hover::before,\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button.active::before {\n  color: #d08f2c;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button .trezo-badge {\n  top: 50%;\n  padding: 0;\n  right: 34px;\n  width: 20px;\n  height: 20px;\n  font-size: 11px;\n  line-height: 20px;\n  position: absolute;\n  color: #FD5812;\n  transform: translateY(-50%);\n  background-color: #fff5ed;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button .trezo-badge.style-two {\n  color: #00b69b;\n  background: rgba(0, 182, 155, 0.07);\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button .trezo-badge.style-three {\n  color: #ee368c;\n  background: rgba(238, 54, 140, 0.1);\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button.with-icon {\n  display: flex !important;\n  align-items: center;\n  padding-left: 12px;\n  gap: 7px;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button.with-icon i {\n  font-size: 21px;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button.with-icon::after {\n  display: none;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item {\n  position: relative;\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link {\n  color: #fff;\n  font-size: 14px;\n  text-decoration: none;\n  border-radius: 5px;\n  padding-bottom: 10px;\n  padding-right: 12px;\n  padding-left: 31px;\n  padding-top: 10px;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link::after {\n  top: 50%;\n  left: 13px;\n  width: 10px;\n  content: \"\";\n  height: 10px;\n  transition: 0.3s;\n  border-radius: 50%;\n  position: absolute;\n  transform: translateY(-50%);\n  border: 1px solid #fff;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link:hover,\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link.active {\n  background-color: #ecf0ff;\n  color: #d08f2c;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link:hover::after,\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link.active::after {\n  border-color: #d08f2c;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge {\n  top: -1px;\n  padding: 2px 6px;\n  margin-left: 10px;\n  border-radius: 3px;\n  line-height: initial;\n  color: #FD5812;\n  background-color: #ffe8d4;\n  font-size: 10px;\n  font-weight: normal;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge::before {\n  top: 50%;\n  left: -3px;\n  width: 6px;\n  height: 6px;\n  content: \"\";\n  position: absolute;\n  background: #ffe8d4;\n  transform: translateY(-50%) rotate(45deg);\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge.style-two {\n  color: #37D80A;\n  background-color: #d8ffc8;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge.style-two::before {\n  background: #d8ffc8;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge.style-three {\n  color: #d08f2c;\n  background-color: #eae0f3;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge.style-three::before {\n  background: #eae0f3;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link.with-icon {\n  display: flex !important;\n  align-items: center;\n  padding-left: 12px;\n  gap: 7px;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link.with-icon i {\n  font-size: 21px;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link.with-icon::after {\n  display: none;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n  top: 0;\n  left: 100%;\n  opacity: 0;\n  margin-top: 0;\n  visibility: hidden;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item:hover .accordion-body {\n  opacity: 1;\n  visibility: visible;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item:hover .accordion-body {\n  opacity: 1;\n  visibility: visible;\n}\n\n.horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item:hover .accordion-body {\n  opacity: 1;\n  visibility: visible;\n}\n\n.horizontal-navbar-area .accordion .accordion-item.megamenu {\n  position: inherit;\n}\n\n.horizontal-navbar-area .accordion .accordion-item.megamenu .accordion-body {\n  width: auto;\n  right: 0;\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n.horizontal-navbar-area .accordion .accordion-item.megamenu .accordion-body .sidebar-sub-menu {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-left: -5px;\n  margin-right: -5px;\n}\n\n.horizontal-navbar-area .accordion .accordion-item.megamenu .accordion-body .sidebar-sub-menu .sidemenu-item {\n  flex: 0 0 auto;\n  width: 25%;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.horizontal-navbar-area .accordion .accordion-item:hover .accordion-body {\n  opacity: 1;\n  visibility: visible;\n}\n\n.horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body {\n  left: auto;\n  right: 0;\n}\n\n.horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n  left: -100%;\n}\n\n.horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n  left: 100%;\n}\n\n.horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n  left: 100%;\n}\n\n.dark .with-horizontal-navbar .header-area::before {\n  background: #172036;\n}\n\n.dark .with-horizontal-navbar .header-area .logo {\n  display: none;\n}\n\n.dark .with-horizontal-navbar .header-area .logo.white-logo {\n  display: block;\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item {\n  color: #fff;\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item>.accordion-button {\n  color: #fff;\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item>.accordion-button .title {\n  color: #fff;\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item>.accordion-button .trezo-badge {\n  background-color: rgba(255, 255, 255, 0.08);\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item>.accordion-button .trezo-badge.style-two {\n  background-color: rgba(255, 255, 255, 0.08);\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item>.accordion-button .trezo-badge.style-three {\n  background-color: rgba(255, 255, 255, 0.08);\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item>.accordion-button:hover {\n  color: #fff;\n  background-color: #212121;\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item>.accordion-button:hover i {\n  color: #fff;\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item>.accordion-button:hover::before {\n  color: #fff;\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item:has(.active) .accordion-button {\n  color: #fff;\n  background-color: #212121;\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item:has(.active) .accordion-button i {\n  color: #fff;\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item:has(.active) .accordion-button::before {\n  color: #fff;\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body {\n  background-color: #0c1427;\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button:hover,\n.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button.active {\n  background-color: #212121;\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button .trezo-badge {\n  background-color: rgba(255, 255, 255, 0.08);\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button .trezo-badge.style-two {\n  background-color: rgba(255, 255, 255, 0.08);\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button .trezo-badge.style-three {\n  background-color: rgba(255, 255, 255, 0.08);\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link {\n  color: #8695aa;\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link::after {\n  border-color: #8695aa;\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link:hover,\n.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link.active {\n  background-color: #212121;\n  color: #d08f2c;\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link:hover::after,\n.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link.active::after {\n  border-color: #d08f2c;\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge::before {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge.style-two {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge.style-two::before {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge.style-three {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.dark .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge.style-three::before {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.with-horizontal-navbar .dark.header-area::before {\n  background: #172036;\n}\n\n.with-horizontal-navbar .dark.header-area .logo {\n  display: none;\n}\n\n.with-horizontal-navbar .dark.header-area .logo.white-logo {\n  display: block;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-button {\n  padding-right: 14px;\n  padding-left: 33px;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-button i {\n  margin-right: 0;\n  margin-left: 7px;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-button .trezo-badge {\n  margin-left: 0;\n  margin-right: 11px;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-button::before {\n  right: auto;\n  left: 8px;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body {\n  left: auto;\n  right: 0;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button {\n  padding-right: 31px;\n  padding-left: 10px;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button::after {\n  left: auto;\n  right: 13px;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button i {\n  margin-left: 0;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button .trezo-badge {\n  right: auto;\n  left: 34px;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .accordion-button.with-icon {\n  padding-left: 0;\n  padding-right: 12px;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link {\n  padding-right: 31px;\n  padding-left: 12px;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link::after {\n  left: auto;\n  right: 13px;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge {\n  margin-left: 0;\n  margin-right: 5px;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link .trezo-badge::before {\n  left: auto;\n  right: -3px;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .sidemenu-link.with-icon {\n  padding-left: 0;\n  padding-right: 12px;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n  left: auto;\n  right: 100%;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item.megamenu .accordion-body {\n  left: 0;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body {\n  left: 0;\n  right: auto;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n  left: auto;\n  right: -100%;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n  left: auto;\n  right: 100%;\n}\n\n[dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n  left: auto;\n  right: 100%;\n}\n\n.main-wrapper-content.with-horizontal-navbar .horizontal-navbar-area {\n  display: block;\n}\n\n.main-wrapper-content.with-horizontal-navbar .main-content {\n  padding-left: 25px;\n  padding-right: 25px;\n  padding-top: 162px;\n  max-width: 1340px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n/* Max width 575px */\n@media only screen and (max-width: 575px) {\n  .main-wrapper-content.with-horizontal-navbar .main-content {\n    padding-top: 140px;\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n  .horizontal-navbar-area {\n    display: none;\n  }\n\n  .main-wrapper-content.with-horizontal-navbar .horizontal-navbar-area {\n    display: none;\n  }\n\n  .main-wrapper-content.with-horizontal-navbar .header-area::before {\n    display: none;\n  }\n\n  .main-wrapper-content.with-horizontal-navbar .header-area .logo-box {\n    display: none !important;\n  }\n}\n\n/* Min width 576px to Max width 767px */\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .main-wrapper-content.with-horizontal-navbar .main-content {\n    padding-top: 95px;\n  }\n}\n\n/* Min width 768px to Max width 991px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .horizontal-navbar-area {\n    display: none;\n  }\n\n  .main-wrapper-content.with-horizontal-navbar .horizontal-navbar-area {\n    display: none;\n  }\n\n  .main-wrapper-content.with-horizontal-navbar .header-area::before {\n    display: none;\n  }\n\n  .main-wrapper-content.with-horizontal-navbar .header-area .logo-box {\n    display: none !important;\n  }\n\n  .main-wrapper-content.with-horizontal-navbar.with-horizontal-navbar .main-content {\n    padding-top: 95px;\n  }\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .main-wrapper-content.with-horizontal-navbar .left-header-content ul li .src-form .form-control {\n    width: 215px;\n  }\n\n  .horizontal-navbar-area {\n    max-width: 100%;\n  }\n\n  .horizontal-navbar-area .accordion .accordion-item .accordion-body {\n    width: 250px;\n  }\n\n  .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body,\n  .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body {\n    left: auto;\n    right: 0;\n  }\n\n  .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,\n  .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n    left: -100%;\n  }\n\n  .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,\n  .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n    left: -100%;\n  }\n\n  .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,\n  .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n    left: 100%;\n  }\n\n  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body,\n  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body {\n    left: 0;\n    right: auto;\n  }\n\n  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,\n  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n    left: auto;\n    right: -100%;\n  }\n\n  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,\n  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n    left: auto;\n    right: -100%;\n  }\n\n  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,\n  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n    left: auto;\n    right: 100%;\n  }\n}\n\n/* Min width 992px */\n@media only screen and (min-width: 992px) {\n  .with-horizontal-navbar .header-area .hbm {\n    display: none;\n  }\n\n  .with-horizontal-navbar .header-area .logo.white-logo {\n    display: none;\n  }\n\n  .main-wrapper-content.with-horizontal-navbar .sidebar-area {\n    display: none;\n  }\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .horizontal-navbar-area {\n    max-width: 100%;\n  }\n\n  .horizontal-navbar-area .accordion .accordion-item .accordion-body {\n    width: 250px;\n  }\n\n  .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body,\n  .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body {\n    left: auto;\n    right: 0;\n  }\n\n  .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,\n  .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n    left: -100%;\n  }\n\n  .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,\n  .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n    left: -100%;\n  }\n\n  .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,\n  .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n    left: 100%;\n  }\n\n  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body,\n  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body {\n    left: 0;\n    right: auto;\n  }\n\n  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,\n  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n    left: auto;\n    right: -100%;\n  }\n\n  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,\n  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n    left: auto;\n    right: -100%;\n  }\n\n  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:last-child .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body,\n  [dir=rtl] .horizontal-navbar-area .accordion .accordion-item:nth-last-child(2) .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body .sidebar-sub-menu .sidemenu-item .accordion-body {\n    left: auto;\n    right: 100%;\n  }\n}\n\n/* Min width 1600px */\n@media only screen and (min-width: 1600px) {\n\n  .with-horizontal-navbar .header-area .container-fluid,\n  .with-horizontal-navbar .header-area .container-sm,\n  .with-horizontal-navbar .header-area .container-md,\n  .with-horizontal-navbar .header-area .container-lg,\n  .with-horizontal-navbar .header-area .container-xl,\n  .with-horizontal-navbar .header-area .container-xxl {\n    max-width: 1545px;\n  }\n\n  .horizontal-navbar-area {\n    max-width: 1545px;\n  }\n\n  .main-wrapper-content.with-horizontal-navbar .main-content {\n    max-width: 1596px;\n  }\n}\n\n.theme-settings-btn {\n  background-color: transparent;\n}\n\n.theme-settings-btn i {\n  animation: roundedAnimation 2s infinite linear;\n  transition: transform 0.3s ease;\n}\n\n@keyframes roundedAnimation {\n  0% {\n    transform: rotate(0deg);\n    border-radius: 0%;\n  }\n\n  50% {\n    transform: rotate(180deg);\n    border-radius: 50%;\n  }\n\n  100% {\n    transform: rotate(360deg);\n    border-radius: 0%;\n  }\n}\n\n[dir=rtl] .theme-settings-btn {\n  right: auto;\n  left: 20px;\n}\n\n.settings-sidebar {\n  bottom: 0;\n  opacity: 0;\n  z-index: 100;\n  right: -100%;\n  width: 380px;\n  height: 100%;\n  position: fixed;\n  visibility: hidden;\n  box-shadow: 0 4px 20px rgba(47, 143, 232, 0.0705882353) !important;\n  overflow-y: auto;\n}\n\n.settings-sidebar .settings-header {\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 2;\n  position: sticky;\n  padding: 16.5px 25px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.settings-sidebar .settings-header h4,\n.settings-sidebar .settings-header .h4 {\n  font-size: 16px;\n  margin: 0;\n  line-height: 1;\n  font-weight: 500;\n}\n\n.settings-sidebar .settings-header .close-btn {\n  padding: 0;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  display: block !important;\n  line-height: 1;\n}\n\n.settings-sidebar .settings-header .close-btn i {\n  font-size: 20px;\n  color: #fff !important;\n}\n\n.settings-sidebar .settings-body {\n  padding-top: 25px;\n  padding-left: 25px;\n  padding-right: 25px;\n  padding-bottom: 25px;\n}\n\n.settings-sidebar .settings-body .title {\n  margin-bottom: 15px;\n  display: block;\n  color: #3A4252;\n  font-weight: 600;\n}\n\n.settings-sidebar .settings-body .switch-btn {\n  gap: 25px;\n  display: grid;\n  color: #3A4252;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  padding: 0;\n  cursor: pointer;\n  border: none;\n}\n\n.settings-sidebar .settings-body .switch-btn .box {\n  width: 140px;\n  height: 100px;\n  border-radius: 5px;\n  border: 1px solid #f1f0f3;\n  transition: all ease 0.5s;\n  position: relative;\n}\n\n.settings-sidebar .settings-body .switch-btn .box span:nth-child(1) {\n  top: 0;\n  right: 0;\n  width: 96px;\n  height: 11px;\n  position: absolute;\n  background: #f1f0f3;\n  border-radius: 0 5px 0 5px;\n}\n\n.settings-sidebar .settings-body .switch-btn .box span:nth-child(2) {\n  right: 0;\n  bottom: 0;\n  width: 96px;\n  height: 11px;\n  position: absolute;\n  background: #f1f0f3;\n  border-radius: 5px 0 5px 0;\n}\n\n.settings-sidebar .settings-body .switch-btn .box span:nth-child(3) {\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 36px;\n  position: absolute;\n  background: #f1f0f3;\n  border-radius: 5px 0 0 5px;\n}\n\n.settings-sidebar .settings-body .switch-btn .box span:nth-child(4) {\n  top: 14px;\n  left: 7px;\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  border-radius: 50%;\n  background: #d6d2df;\n}\n\n.settings-sidebar .settings-body .switch-btn .box span:nth-child(5) {\n  left: 7px;\n  top: 45px;\n  width: 20px;\n  height: 5px;\n  position: absolute;\n  border-radius: 30px;\n  background: #d6d2df;\n}\n\n.settings-sidebar .settings-body .switch-btn .box span:nth-child(6) {\n  left: 7px;\n  top: 55px;\n  width: 20px;\n  height: 5px;\n  position: absolute;\n  border-radius: 30px;\n  background: #d6d2df;\n}\n\n.settings-sidebar .settings-body .switch-btn .box span:nth-child(7) {\n  left: 7px;\n  top: 65px;\n  width: 20px;\n  height: 5px;\n  position: absolute;\n  border-radius: 30px;\n  background: #d6d2df;\n}\n\n.settings-sidebar .settings-body .switch-btn .box span:nth-child(8) {\n  top: 35px;\n  left: 46px;\n  width: 20px;\n  height: 11px;\n  position: absolute;\n  background: #f1f0f3;\n  border: 1px solid #f1f0f3;\n}\n\n.settings-sidebar .settings-body .switch-btn .box span:nth-child(9) {\n  top: 35px;\n  left: 78px;\n  width: 20px;\n  height: 11px;\n  position: absolute;\n  background: #f1f0f3;\n  border: 1px solid #f1f0f3;\n}\n\n.settings-sidebar .settings-body .switch-btn .box span:nth-child(10) {\n  top: 35px;\n  left: 110px;\n  width: 20px;\n  height: 11px;\n  position: absolute;\n  background: #f1f0f3;\n  border: 1px solid #f1f0f3;\n}\n\n.settings-sidebar .settings-body .switch-btn .box span:nth-child(11) {\n  top: 55px;\n  left: 46px;\n  width: 20px;\n  height: 11px;\n  position: absolute;\n  background: #f1f0f3;\n  border: 1px solid #f1f0f3;\n}\n\n.settings-sidebar .settings-body .switch-btn .box span:nth-child(12) {\n  top: 55px;\n  left: 78px;\n  width: 20px;\n  height: 11px;\n  position: absolute;\n  background: #f1f0f3;\n  border: 1px solid #f1f0f3;\n}\n\n.settings-sidebar .settings-body .switch-btn .box span:nth-child(13) {\n  top: 55px;\n  left: 110px;\n  width: 20px;\n  height: 11px;\n  position: absolute;\n  background: #f1f0f3;\n  border: 1px solid #f1f0f3;\n}\n\n.settings-sidebar .settings-body .switch-btn .box:hover {\n  border-color: #d08f2c;\n}\n\n.settings-sidebar .settings-body .switch-btn .first .box {\n  border-color: #d08f2c;\n}\n\n.settings-sidebar .settings-body .switch-btn .first .sub-title {\n  display: flex;\n  align-items: center;\n}\n\n.settings-sidebar .settings-body .switch-btn .first .sub-title .dot-checkbox {\n  border-color: #d08f2c;\n  background-color: #d08f2c;\n  position: relative;\n}\n\n.settings-sidebar .settings-body .switch-btn .first .sub-title .dot-checkbox::before {\n  opacity: 1;\n  visibility: visible;\n}\n\n.settings-sidebar .settings-body .switch-btn .sub-title {\n  gap: 8px;\n  margin-top: 10px;\n  display: flex;\n  align-items: center;\n}\n\n.settings-sidebar .settings-body .switch-btn .sub-title .dot-checkbox {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2px solid #f1f0f3;\n  transition: all ease 0.5s;\n  position: relative;\n}\n\n.settings-sidebar .settings-body .switch-btn .sub-title .dot-checkbox::before {\n  left: 0;\n  right: 0;\n  top: 50%;\n  opacity: 0;\n  content: \"\\eb7b\";\n  visibility: hidden;\n  position: absolute;\n  font-family: remixicon;\n  color: #fff;\n  transform: translateY(-48%);\n  transition: all ease 0.5s;\n}\n\n.settings-sidebar .settings-body .switch-btn .sub-title .dot-checkbox.active {\n  border-color: #d08f2c;\n  background-color: #d08f2c;\n}\n\n.settings-sidebar .settings-body .switch-btn .sub-title .dot-checkbox.active::before {\n  opacity: 1;\n  visibility: visible;\n}\n\n.settings-sidebar .settings-body .switch-btn.ltr-rtl-btn .second span:nth-child(1),\n.settings-sidebar .settings-body .switch-btn.left-right-sidebar-btn .second span:nth-child(1) {\n  left: 0;\n  right: auto;\n  border-radius: 5px 0 5px 0;\n}\n\n.settings-sidebar .settings-body .switch-btn.ltr-rtl-btn .second span:nth-child(2),\n.settings-sidebar .settings-body .switch-btn.left-right-sidebar-btn .second span:nth-child(2) {\n  border-radius: 0 5px 0 5px;\n  right: auto;\n  left: 0;\n}\n\n.settings-sidebar .settings-body .switch-btn.ltr-rtl-btn .second span:nth-child(3),\n.settings-sidebar .settings-body .switch-btn.left-right-sidebar-btn .second span:nth-child(3) {\n  right: 0;\n  left: auto;\n  border-radius: 0 5px 5px 0;\n}\n\n.settings-sidebar .settings-body .switch-btn.ltr-rtl-btn .second span:nth-child(4),\n.settings-sidebar .settings-body .switch-btn.left-right-sidebar-btn .second span:nth-child(4) {\n  left: auto;\n  right: 7px;\n}\n\n.settings-sidebar .settings-body .switch-btn.ltr-rtl-btn .second span:nth-child(5),\n.settings-sidebar .settings-body .switch-btn.left-right-sidebar-btn .second span:nth-child(5) {\n  left: auto;\n  right: 7px;\n}\n\n.settings-sidebar .settings-body .switch-btn.ltr-rtl-btn .second span:nth-child(6),\n.settings-sidebar .settings-body .switch-btn.left-right-sidebar-btn .second span:nth-child(6) {\n  left: auto;\n  right: 7px;\n}\n\n.settings-sidebar .settings-body .switch-btn.ltr-rtl-btn .second span:nth-child(7),\n.settings-sidebar .settings-body .switch-btn.left-right-sidebar-btn .second span:nth-child(7) {\n  left: auto;\n  right: 7px;\n}\n\n.settings-sidebar .settings-body .switch-btn.light-dark-btn .second .box {\n  background-color: #000000;\n}\n\n.settings-sidebar .settings-body .switch-btn.light-dark-btn .second .box span:nth-child(1) {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.settings-sidebar .settings-body .switch-btn.light-dark-btn .second .box span:nth-child(2) {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.settings-sidebar .settings-body .switch-btn.light-dark-btn .second .box span:nth-child(3) {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.settings-sidebar .settings-body .switch-btn.light-dark-btn .second .box span:nth-child(4) {\n  background: rgba(214, 210, 223, 0.5);\n}\n\n.settings-sidebar .settings-body .switch-btn.light-dark-btn .second .box span:nth-child(5) {\n  background: rgba(214, 210, 223, 0.5);\n}\n\n.settings-sidebar .settings-body .switch-btn.light-dark-btn .second .box span:nth-child(6) {\n  background: rgba(214, 210, 223, 0.5);\n}\n\n.settings-sidebar .settings-body .switch-btn.light-dark-btn .second .box span:nth-child(7) {\n  background: rgba(214, 210, 223, 0.5);\n}\n\n.settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(8),\n.settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(9),\n.settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(10),\n.settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(11),\n.settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(12),\n.settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(13) {\n  border-color: #d6d2df;\n}\n\n.settings-sidebar .settings-body .switch-btn.card-shape-btn .first .box span:nth-child(8),\n.settings-sidebar .settings-body .switch-btn.card-shape-btn .first .box span:nth-child(9),\n.settings-sidebar .settings-body .switch-btn.card-shape-btn .first .box span:nth-child(10),\n.settings-sidebar .settings-body .switch-btn.card-shape-btn .first .box span:nth-child(11),\n.settings-sidebar .settings-body .switch-btn.card-shape-btn .first .box span:nth-child(12),\n.settings-sidebar .settings-body .switch-btn.card-shape-btn .first .box span:nth-child(13) {\n  border-radius: 10px;\n}\n\n.settings-sidebar .settings-body .switch-btn.compact-sidebar-btn .second .box span:nth-child(1) {\n  width: 108px;\n}\n\n.settings-sidebar .settings-body .switch-btn.compact-sidebar-btn .second .box span:nth-child(2) {\n  width: 108px;\n}\n\n.settings-sidebar .settings-body .switch-btn.compact-sidebar-btn .second .box span:nth-child(3) {\n  width: 24px;\n}\n\n.settings-sidebar .settings-body .switch-btn.compact-sidebar-btn .second .box span:nth-child(4) {\n  left: 4px;\n  width: 15px;\n  height: 15px;\n}\n\n.settings-sidebar .settings-body .switch-btn.compact-sidebar-btn .second .box span:nth-child(5) {\n  left: 4px;\n  width: 15px;\n}\n\n.settings-sidebar .settings-body .switch-btn.compact-sidebar-btn .second .box span:nth-child(6) {\n  left: 4px;\n  width: 15px;\n}\n\n.settings-sidebar .settings-body .switch-btn.compact-sidebar-btn .second .box span:nth-child(7) {\n  left: 4px;\n  width: 15px;\n}\n\n.settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(8),\n.settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(9),\n.settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(10),\n.settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(11),\n.settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(12),\n.settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(13) {\n  background: #fff;\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n}\n\n.settings-sidebar .settings-body .switch-btn.sidebar-btn .second span:nth-child(3) {\n  background: #000000;\n}\n\n.settings-sidebar .settings-body .switch-btn.sidebar-btn .second span:nth-child(4) {\n  background: rgba(214, 210, 223, 0.5);\n}\n\n.settings-sidebar .settings-body .switch-btn.sidebar-btn .second span:nth-child(5) {\n  background: rgba(214, 210, 223, 0.5);\n}\n\n.settings-sidebar .settings-body .switch-btn.sidebar-btn .second span:nth-child(6) {\n  background: rgba(214, 210, 223, 0.5);\n}\n\n.settings-sidebar .settings-body .switch-btn.sidebar-btn .second span:nth-child(7) {\n  background: rgba(214, 210, 223, 0.5);\n}\n\n.settings-sidebar .settings-body .switch-btn.header-btn .second span:nth-child(1) {\n  background: #000000;\n}\n\n.settings-sidebar .settings-body .switch-btn.active .first .box {\n  border-color: #f1f0f3;\n}\n\n.settings-sidebar .settings-body .switch-btn.active .first .box:hover {\n  border-color: #d08f2c;\n}\n\n.settings-sidebar .settings-body .switch-btn.active .first .sub-title .dot-checkbox {\n  border-color: #f1f0f3;\n  background-color: transparent;\n}\n\n.settings-sidebar .settings-body .switch-btn.active .first .sub-title .dot-checkbox::before {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.settings-sidebar .settings-body .switch-btn.active .second .box {\n  border-color: #d08f2c;\n}\n\n.settings-sidebar .settings-body .switch-btn.active .second .dot-checkbox {\n  border-color: #d08f2c;\n  background-color: #d08f2c;\n}\n\n.settings-sidebar .settings-body .switch-btn.active .second .dot-checkbox::before {\n  opacity: 1;\n  visibility: visible;\n}\n\n.settings-sidebar .settings-body .mat-divider {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.settings-sidebar .ng-scroll-content {\n  padding-right: 0 !important;\n}\n\n.settings-sidebar.active {\n  right: 0;\n  opacity: 1;\n  visibility: visible;\n}\n\n.dark .settings-sidebar .settings-body .title {\n  color: #fff;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn .box {\n  border-color: #172036;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(1),\n.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(2),\n.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(3),\n.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(8),\n.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(9),\n.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(10),\n.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(11),\n.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(12),\n.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(13) {\n  background: #172036;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(8),\n.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(9),\n.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(10),\n.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(11),\n.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(12),\n.dark .settings-sidebar .settings-body .switch-btn .box span:nth-child(13) {\n  border-color: #ECEEF2;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn .box:hover {\n  border-color: #d08f2c;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn .first .box {\n  border-color: #d08f2c;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn .first .sub-title .dot-checkbox {\n  border-color: #d08f2c;\n  background-color: #d08f2c;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn .sub-title .dot-checkbox {\n  border-color: #ECEEF2;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn .sub-title span {\n  color: #fff !important;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(8),\n.dark .settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(9),\n.dark .settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(10),\n.dark .settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(11),\n.dark .settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(12),\n.dark .settings-sidebar .settings-body .switch-btn.card-border-btn .second .box span:nth-child(13) {\n  border-color: #2a395d;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(8),\n.dark .settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(9),\n.dark .settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(10),\n.dark .settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(11),\n.dark .settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(12),\n.dark .settings-sidebar .settings-body .switch-btn.card-shadow-btn .second .box span:nth-child(13) {\n  background: #3A4252;\n  box-shadow: rgba(255, 255, 255, 0.24) 0px 3px 8px;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn.sidebar-btn .second span:nth-child(3) {\n  background: #000000;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn.header-btn .second span:nth-child(1) {\n  background: #000000;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn.active .first .box {\n  border-color: #172036;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn.active .first .box:hover {\n  border-color: #d08f2c;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn.active .first .sub-title .dot-checkbox {\n  border-color: #ECEEF2;\n  background-color: transparent;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn.active .second .box {\n  border-color: #d08f2c;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn.active .second .dot-checkbox {\n  border-color: #d08f2c;\n  background-color: #d08f2c;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn.light-dark-btn .first .box {\n  border-color: #0C1427;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn.light-dark-btn .first .sub-title .dot-checkbox {\n  border-color: #ECEEF2;\n  background-color: transparent;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn.light-dark-btn .first .sub-title .dot-checkbox::before {\n  display: none;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn.light-dark-btn .second .box {\n  border-color: #d08f2c;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn.light-dark-btn .second .dot-checkbox {\n  border-color: #d08f2c;\n  background-color: #d08f2c;\n}\n\n.dark .settings-sidebar .settings-body .switch-btn.light-dark-btn .second .dot-checkbox::before {\n  opacity: 1;\n  visibility: visible;\n}\n\n[dir=rtl] .settings-sidebar {\n  text-align: end;\n  right: auto;\n  left: -100%;\n}\n\n[dir=rtl] .settings-sidebar .settings-body .title {\n  text-align: right;\n}\n\n[dir=rtl] .settings-sidebar .settings-body .switch-btn {\n  margin-left: auto;\n}\n\n[dir=rtl] .settings-sidebar.active {\n  right: auto;\n  left: 0;\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n  .settings-sidebar {\n    width: 320px;\n  }\n\n  .settings-sidebar .settings-header {\n    padding: 14.5px 20px;\n  }\n\n  .settings-sidebar .settings-header h4,\n  .settings-sidebar .settings-header .h4 {\n    font-size: 15px;\n  }\n\n  .settings-sidebar .settings-header .close-btn i {\n    font-size: 18px;\n  }\n\n  .settings-sidebar .settings-body {\n    padding-left: 20px;\n    padding-right: 20px;\n    padding-bottom: 20px;\n  }\n\n  .settings-sidebar .settings-body .title {\n    margin-bottom: 13px;\n  }\n\n  .settings-sidebar .settings-body .switch-btn {\n    gap: 20px;\n  }\n\n  .settings-sidebar .settings-body .mat-divider {\n    margin-top: 17px;\n    margin-bottom: 17px;\n  }\n}\n\n/* Min width 576px to Max width 767px */\n/* Min width 768px to Max width 991px */\n/* Min width 992px to Max width 1199px */\n/* Min width 1200px to Max width 1399px */\n/* Min width 1600px */\n\n\n.phone-input-dark .PhoneInputInput {\n  background-color: #212121;\n  /* fondo negro */\n  color: #fff;\n  /* texto blanco */\n  border: 1px solid #212121;\n  /* borde gris oscuro */\n  padding: 0.5rem;\n  border-radius: 5px;\n}\n\n.phone-input-dark .PhoneInputInput::placeholder {\n  color: #aaa;\n}\n\n.phone-input-dark .PhoneInputCountry {\n  background-color: #111;\n  border: 1px solid #444;\n  border-radius: 5px 0 0 5px;\n}\n\n.phone-input-dark .PhoneInputCountrySelect {\n  background-color: #111;\n  color: #fff;\n}\n\nhtml,\nbody,\n#root,\n.main-wrapper-content {\n  height: 100%;\n}\n\n.react-flow__controls-button {\n  color: #000 !important;\n}\ninput::placeholder,\ntextarea::placeholder,\n.form-control::placeholder {\n  opacity: 0.4;\n}\n\n.google-signin-btn span {\n  color: inherit !important;\n}\n\n.login-options {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  max-width: 400px;\n}\n.login-option-btn {\n  position: relative;\n  width: 100%;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  border: 1px solid #dadce0;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n.login-option-btn:hover {\n  background: #f8faff;\n}\n.login-option-btn, .login-option-btn span, .login-option-btn i {\n  color: #3c4043 !important;\n}\n.login-option-btn i {\n  position: absolute;\n  left: 12px;\n  font-size: 20px;\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n  @include font-size($legend-font-size);\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.2 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG/#contrast-minimum\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(-1 * #{$pagination-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               var(--#{$prefix}body-color) !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n$carousel-control-icon-filter:       null !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default; // Deprecated in v5.3.4\n$carousel-dark-caption-color:        $black !default; // Deprecated in v5.3.4\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default; // Deprecated in v5.3.4\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-filter:           null !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default; // Deprecated in v5.3.4\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n    @include font-size($font-size);\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.7 (https://getbootstrap.com/)\n   * Copyright 2011-2025 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Color\n$body-color: #fff; \n$body-color-50: #526077;\n$body-color-60: #8695AA;\n$primary: #d08f2c; \n$primary-50: #b27c26; \n$primary-60: #946920; \n$primary-70: #76561a; \n$secondary: #3A4252;\n$info: #2980B9; \n$success: #27AE60;\n$success-50: #1E8308;\n$success-60: #25B003;\n$success-70: #82FC5A;\n$success-80: #D8FFC8;\n$success-90: #eeffe5; \n$success-100: #d8ffc8;\n$warning: #D4AC0D;\n$danger: #C0392B; \n$danger-40: #D71C00; \n$danger-50: #EE3E08; \n$danger-60: #EC1F00; \n$danger-70: #FFE1DD; \n$danger-80: #ff4023; \n$danger-90: #C52B09; \n$danger-100: #ffe1dd; \n$light: #D5D9E2;\n$dark: #000000;\n$border-color: #ECEEF2;\n$border-color-50: #ECF0FF;\n$body-bg: #F6F7F9;\n$primary-div: #d08f2c; \n$primary-div-50: #b27c26; \n$primary-div-60: #946920; \n$danger-div: #ffed9d;\n$gray-light: #445164;\n$rating-color: #FE7A36;\n$card-bg-c: #3584FC;\n$card-text-c: #FFE8D4;\n$purple-100: #f3e8ff;\n$info-100: #daebff;\n$gary-light: #F4F6FC;\n$gray-div: #f7f8f7;\n$gray-100: #f5f7f8;\n$transition: all ease .5s;\n$box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n$body-font-family: \"Inter\", sans-serif;\n\n// For Dark Mode Color\n$dark-body-bg: #000000;\n$dark-body-color: #fff;\n$dark-card-bg: #101010;\n$dark-input-bg: #212121;\n$dark-border: #262626;\n\n// Font Size\n$font-size-root: null;\n$font-size-base: .88rem; // Assumes the browser default, typically `16px`\n$font-size-sm: $font-size-base * .875;\n$font-size-lg: $font-size-base * 1.25;\n\n$h1-font-size: $font-size-base * 2.5; // Updated 43.2px\n$h2-font-size: $font-size-base * 2.3; // Updated 36.8px\n$h3-font-size: $font-size-base * 1.8; // Updated 28.8px\n$h4-font-size: $font-size-base * 1.4; // Updated 22.4px\n$h5-font-size: $font-size-base * 1; // Updated 17.6px\n$h6-font-size: $font-size-base; // Updated 16px","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    max-width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n    padding-left: $form-floating-padding-x;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  > textarea:focus,\n  > textarea:not(:placeholder-shown) {\n    ~ label::after {\n      position: absolute;\n      inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n      z-index: -1;\n      height: $form-floating-label-height;\n      content: \"\";\n      background-color: $input-bg;\n      @include border-radius($input-border-radius);\n    }\n  }\n  > textarea:disabled ~ label::after {\n    background-color: $input-disabled-bg;\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(-1 * #{$input-border-width}); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  // The top radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      flex: 1 0 0;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-collapse,\n    > .accordion-header .accordion-button,\n    > .accordion-header .accordion-button.collapsed {\n      @include border-radius(0);\n    }\n    // stylelint-enable selector-max-class\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(-1 * #{$pagination-border-width}) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: var(--#{$prefix}progress-height); }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  &:not(.active) {\n    // Hover state\n    &:hover,\n    &:focus {\n      z-index: 1; // Place hover/focus items above their siblings for proper border styling\n      color: var(--#{$prefix}list-group-action-hover-color);\n      text-decoration: none;\n      background-color: var(--#{$prefix}list-group-action-hover-bg);\n    }\n\n    &:active {\n      color: var(--#{$prefix}list-group-action-active-color);\n      background-color: var(--#{$prefix}list-group-action-active-bg);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  filter: var(--#{$prefix}btn-close-filter);\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter-dark};\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include btn-close-white();\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    transform: $modal-fade-transform;\n    @include transition($modal-transition);\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}modal-header-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-left: auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  filter: var(--#{$prefix}carousel-control-icon-filter);\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg-dark};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color-dark};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter-dark};\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include carousel-dark();\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-left: auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n\n  // Fix to prevent overflowing children to become focusable\n  * {\n    overflow: hidden !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/WAI/WCAG22/Techniques/general/G1.html\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/* Global Area Style\n============================================*/\nbody {\n    font-family: $body-font-family;\n}\na {\n    transition: $transition;\n    color: $body-color;\n\t&:hover {\n       color: $primary;\n\t}\n    &:focus-visible { \n        outline: 0;\n    }\n}\n.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {\n    color: $secondary;\n\tfont: {\n\t\tweight: 700;\n\t}\n}\nh3 {\n    font-size: 18px;\n}\np {\n\tmargin-bottom: 15px;\n    line-height: 26px;\n\n\t&:last-child {\n        margin-bottom: 0;\n    }\n} \nimg {\n    max-width: 100%;\n    height: auto;\n}\n.label, .form-label {\n    font-size: 14px;\n    font-weight: 500;\n    margin-bottom: 10px;\n}\n.card {\n    transition: $transition;\n}\n.btn-primary {\n    &:hover {\n        span {\n            color:  #fff !important;\n        }\n    }\n}\n.form-control {\n\tbackground-color: $white; \n\tborder: 1px solid $light; \n    height: 50px;\n    color: $secondary !important;\n\tfont-size: 15px;\n\tpadding: 14px 16px;\n\twidth: 100%;\n\ttransition: $transition;\n    border-radius: 7px;\n\t&::placeholder {\n\t\tcolor: $body-color;\n\t\tfont-size: 14px;\n\t}\n\t&:focus {\n\t\tbackground-color: $white;\n\t\tbox-shadow: unset;\n\t\toutline: 0;\n\t\tborder: 1px solid $primary;\n        color: #8695AA;\n\t}\n\t&.form-select  {\n\t\tcursor: pointer;\n        color: #8695AA;\n\t}\n    &.file {\n        padding-top: 12px;\n    }\n    &.h-55 {\n        height: 55px;\n    }\n    &.h-60 {\n        height: 60px;\n    }\n}\ntextarea {   \n    &.form-control {\n        height: auto;\n    }\n}\n.form-check {\n    margin-bottom: 0;\n    .form-check-input {\n        border: 2px solid $body-color;\n        width: 16px;\n        height: 16px;\n        cursor: pointer;\n        &:focus {\n            box-shadow: none;\n            border-color: $primary;\n        }\n    }\n    .form-check-input:checked[type=checkbox] {\n        border-color: $primary;\n    }\n    .form-check-label {\n        padding-left: 5px;\n    }\n}\n.month-select {\n    width: 114px;\n    height: 36px;\n    padding-top: 6px;\n    padding-bottom: 10px; \n    background-size: 10px 10px;\n    background-position: right 8px center;\n    font-size: 14px;\n\n    &.w-145 {\n        width: 145px;\n    }\n    &.w-135 {\n        width: 135px;\n    }\n    &.w-90 {\n        width: 90px;\n    }\n    &.w-99 {\n        width: 105px;\n    }\n}\n.lcbmp-none {\n    &:last-child {\n        padding-bottom: 0 !important;\n        margin-bottom: 0 !important;\n        border-bottom: none !important;\n    }\n}\n.lcmb-none {\n    &:last-child {\n        border-bottom: 0 !important;\n        margin-bottom: 0 !important;\n    }\n}\n.tr-lcbp-none {\n    &:last-child {\n        td {\n            border-bottom: none;\n            padding-bottom: 0 !important;\n        }\n    }\n}\n.list-last-child {\n    li {\n        &:last-child {\n            padding-bottom: 0 !important;\n            margin-bottom: 0 !important;\n            border-bottom: none !important;\n        }\n    }\n}\n.l-lcbm {\n    li {\n        &:last-child {\n            margin-bottom: 0 !important;\n            border-bottom: none !important;\n        }\n    }\n}\n.hover-text-white {\n    &:hover {\n        color: #fff !important;\n    }\n}\n.cursor-pointer {\n    cursor: pointer;\n}\n\n.py-38 {\n    padding-top: 38px !important;\n    padding-bottom: 38px !important;\n}\n.default-src-form {\n    .form-control {\n        height: 40px;\n        background-color: $body-bg;\n        border-color: $body-bg;\n        padding-left: 35px;\n    }\n    .start-0 {\n        left: 15px !important;\n    }\n}\n.breadcrumb-page-list {\n    .breadcrumb {\n        margin: 0;\n        li {\n            a {\n                text-decoration: none;\n            }\n        }\n    }\n}\n\n.bg-4936F5 {\n    background-color: #4936F5;\n}\n\n/* BG Image Area Style\n============================================*/\n.bg-img {\n    background-position: center center;\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n\n/* Preloader Area Style\n============================================*/\n#preloader {\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 9999;\n    position: fixed;\n    background-color: $white;\n\n    .preloader {\n        transform: translate(-50%, -50%);\n        position: absolute;\n        left: 50%;\n        top: 50%;\n\n        .loader {\n            position: relative;\n            overflow: hidden;\n            display: block;\n            height: 150px;\n            width: 150px;\n            margin: {\n                left: auto;\n                right: auto;\n            };\n            div {\n                height: 100%;\n            }\n        }\n        .loader, .loader div {\n            padding: 8px;\n            border-radius: 50%;\n            border: 2px solid transparent;\n            animation: rotate linear 3.5s infinite;\n            border: {\n                top-color: $primary;\n                border-bottom: $primary;\n            };\n        }\n        .waviy {\n            position: relative;\n            text-align: center;\n            -webkit-box-reflect: below -47px linear-gradient(transparent, rgba(0, 0, 0, .2));\n            font: {\n                size: 50px;\n                weight: 700;\n            };\n            span {\n                position: relative;\n                color: $dark;\n                animation-delay: .1s;\n                display: inline-block;\n                animation: waviy 1s infinite;\n\n                &:nth-child(2) {\n                    animation-delay: .2s;\n                }\n                &:nth-child(3) {\n                    animation-delay: .3s;\n                }\n                &:nth-child(4) {\n                    animation-delay: .4s;\n                }\n                &:nth-child(5) {\n                    animation-delay: .5s;\n                }\n            }\n        }\n    }\n}\n@keyframes rotate {\n    0% {\n        transform: rotate(0deg);\n    }\n    50% {\n        transform: rotate(180deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n@keyframes waviy {\n    0%, 40%, 100% {\n        transform: translateY(0)\n    }\n    20% {\n        transform: translateY(-20px)\n    }\n}\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n\n    #preloader {\n        .preloader {\n            .waviy {\n                font: {\n                    size: 30px;\n                };\n            }\n        }\n    }\n\n}\n\n// Badge\n.badge {\n\tbackground-color: #ECF0FF;\n\tcolor: $primary;\n \n\t&.pending, &.Pending {\n\t\tbackground-color: rgba(255, 193, 7, .15);\n\t\tcolor: $warning;\n\t}\n\t&.rejected, &.Rejected, &.NotAvailable, &.notAvailable, &.Not.Available, &.not.available, &.Not, &.not, &.past, &.Past\t{\n\t\tbackground-color: #FFE1DD;\n\t\tcolor: $danger;\n\t}\n\t&.pInProgress, &.cancelled, &.Cancelled, &.draft, &.Draft, &.deactive, &.Deactive, &.Deactivate, &.deactivate, &.Unread, &.unread, &.inProgress, &.in.Progress, &.In.Progress {\n\t\tbackground-color: #FFE1DD;\n\t\tcolor: $danger;\n\t}\n\t&.finished, .Finished, &.shipped, &.Shipped, &.pFinished {\n\t\tbackground-color: #D8FFC8;\n\t\tcolor: $success;\n\t}\n\t&.pPending {\n\t\tbackground-color: #F3E8FF;\n\t\tcolor: $primary-div;\n\t}\n}\n\n/*\nAction Opt Style\n======================================================*/\n.action-opt {\n\t.btn {\n\t\tborder: none;\n        color: #8F9DBD;\n        font-size: 22px;\n\n\t\t&:after {\n            display: none;\n        }\n\t\t&:focus {\n\t\t\tborder: none;\n\t\t\tbox-shadow: none;\n\t\t}\n        &.bg {\n            width: 30px;\n            height: 30px;\n            line-height: 30px;\n            text-align: center;\n            background-color: #F3F6F9;\n            border-radius: 4px;\n\n            svg {\n                margin-right: 0 !important;\n                stroke: $body-color !important;\n            }\n        }\n\t}\n\t.dropdown-menu {\n        .dropdown-item {\n            font-size: 14px;\n            padding: 8px 12px;\n            display: flex;\n            align-items: center;\n\n            i, span {\n                font-size: 16px;\n                margin-right: 5px;\n                position: relative;\n                top: 0;\n            }\n            &:hover {\n                background: rgba(92, 97, 242, 0.05);\n                color: $primary;\n            }\n        }\n\t}\n\t&.hover {\n\t\t.dropdown-menu {\n\t\t\tdisplay: block !important;\n\t\t\topacity: 0;\n\t\t\ttransition: $transition;\n\t\t}\n\t\t&:hover {\n\t\t\t.dropdown-menu {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*\nCustom Width Area Style\n======================================================*/\n.w-330 {\n    width: 330px;\n}\n.wh-11 {\n    width: 11px;\n    height: 11px;\n}\n.wh-16 {\n    width: 16px;\n    height: 16px;\n}\n.wh-25 {\n    width: 25px;\n    height: 25px;\n}\n.wh-30 {\n    width: 30px;\n    height: 30px;\n}\n.wh-34 {\n    width: 34px;\n    height: 34px;\n}\n.wh-35 {\n    width: 35px;\n    height: 35px;\n}\n.wh-40 {\n    width: 40px;\n    height: 40px;\n}\n.wh-44 {\n    width: 44px;\n    height: 44px;\n}\n.wh-45 {\n    width: 45px;\n    height: 45px;\n}\n.wh-47 {\n    width: 47px;\n    height: 47px;\n}\n.wh-48 {\n    width: 48px;\n    height: 48px;\n}\n.wh-52 {\n    width: 52px;\n    height: 52px;\n}\n.wh-55 {\n    width: 55px;\n    height: 55px;\n}\n.wh-57 {\n    width: 57px;\n    height: 57px;\n}\n.wh-60 {\n    width: 60px;\n    height: 60px;\n}\n.wh-65 {\n    width: 65px;\n    height: 65px;\n}\n.wh-67 {\n    width: 67px;\n    height: 67px;\n}\n.wh-70 {\n    width: 70px;\n    height: 70px;\n}\n.wh-75 {\n    width: 75px;\n    height: 75px;\n}\n.wh-77 {\n    width: 77px;\n    height: 77px;\n}\n.wh-80 {\n    width: 80px;\n    height: 60px;\n}\n.wh-87 {\n    width: 87px;\n    height: 87px;\n}\n.wh-100 {\n    width: 100px;\n    height: 100px;\n}\n.wh-130 {\n    width: 130px;\n    height: 130px;\n}\n.wh-130-113 {\n    width: 130px;\n    height: 113px;\n}\n.wh-150 {\n    width: 150px;\n    height: 150px;\n}\n.wh-160 {\n    width: 160px;\n    height: 160px;\n}\n.mw-80 {\n    max-width: 80px;\n}\n.mw-123 {\n    max-width: 123px;\n}\n.mw-380 {\n    max-width: 380px;\n}\n.mw-430 {\n    max-width: 430px;\n}\n.mw-480 {\n    max-width: 480px;\n}\n.mw-548 {\n    max-width: 548px;\n}\n.mw-740 {\n    max-width: 740px;\n}\n\n/** New **/\n.max-h-198 {\n    max-height: 198px;\n    overflow-y: auto;\n}\n.max-h-217 {\n    max-height: 217.5px;\n    overflow-y: auto;\n}\n.max-h-275 {\n    max-height: 275px;\n    overflow-y: auto;\n}\n.max-h-312 {\n    max-height: 312px;\n    overflow-y: auto;\n}\n.max-h-497 {\n    max-height: 497px;\n    overflow-y: auto;\n}\n.max-h-419 {\n    max-height: 419px;\n    overflow-y: auto;\n}\n\n.scrollbar {\n    /* width */\n    &::-webkit-scrollbar {\n        width: 5px;\n    }\n    /* Track */\n    &::-webkit-scrollbar-track {\n        background: #fff; \n    }\n    /* Handle */\n    &::-webkit-scrollbar-thumb {\n        background: #c5c5c5; \n    }\n    /* Handle on hover */\n    &::-webkit-scrollbar-thumb:hover {\n        background: #888; \n    }\n}\n\n/*\nCustom Rounded Area Style\n======================================================*/\n.rounded-bottom-15 {\n    border-radius: 0 0 15px 15px;\n}\n.rounded-top-7 {\n    border-radius: 7px 7px 0 0;\n}\n\n/*\nCustom Transition Area Style\n======================================================*/\n.transition {\n    transition: $transition;\n}\n.transition-x {\n    transition: $transition;\n    &:hover {\n        transform: translateX(-5px);\n    }\n}\n.transition-x-right {\n    transition: $transition;\n    &:hover {\n        transform: translateX(5px);\n    }\n}\n.transition-y {\n    transition: $transition;\n    &:hover {\n        transform: translateY(-5px);\n    }\n}\n.transition-y-bottom {\n    transition: $transition;\n    &:hover {\n        transform: translateY(5px);\n    }\n}\n.transition-zoom-in {\n    transition: $transition;\n    &:hover {\n        transform: scale(1.3);\n    }\n}\n\n/*\nCustom Font Size Area Style\n======================================================*/\n.fs-10 {\n    font-size: 10px;\n}\n.fs-11 {\n    font-size: 11px;\n}\n.fs-12 {\n    font-size: 12px !important;\n}\n.fs-13 {\n    font-size: 13px;\n}\n.fs-14 {\n    font-size: 14px;\n}\n.fs-15 {\n    font-size: 15px;\n}\n.fs-16 {\n    font-size: 16px;\n}\n.fs-17 {\n    font-size: 17px;\n}\n.fs-18 {\n    font-size: 18px;\n}\n.fs-19 {\n    font-size: 19px;\n}\n.fs-20 {\n    font-size: 20px;\n}\n.fs-21 {\n    font-size: 21px;\n}\n.fs-22 {\n    font-size: 22px;\n}\n.fs-23 {\n    font-size: 23px;\n}\n.fs-24 {\n    font-size: 24px;\n}\n.fs-25 {\n    font-size: 25px;\n}\n.fs-26 {\n    font-size: 26px;\n}\n.fs-27 {\n    font-size: 27px;\n}\n.fs-28 {\n    font-size: 28px;\n}\n.fs-29 {\n    font-size: 29px;\n}\n.fs-30 {\n    font-size: 30px;\n}\n.fs-32 {\n    font-size: 32px;\n}\n.fs-35 {\n    font-size: 35px;\n}\n.fs-40 {\n    font-size: 40px;\n}\n.fs-45 {\n    font-size: 45px;\n}\n\n/*\nCustom Padding & Margin Area Style\n======================================================*/\n.mb-20 {\n    margin-bottom: 20px;\n}\n.mb-29 {\n    margin-bottom: 29px;\n}\n.mb-30 {\n    margin-bottom: 30px;\n}\n.mb-35 {\n    margin-bottom: 35px;\n}\n.mb-19 {\n    margin-bottom: 19px;\n}\n.ms-m-15 {\n    margin-left: -15px;\n\n    &:first-child {\n        margin-left: 0;\n    }\n}\n.ms-m-20 {\n    margin-left: -20px;\n\n    &:first-child {\n        margin-left: 0;\n    }\n}\n.ms-m-10 {\n    margin-left: -10px;\n}\n.ms-e-10 {\n    margin-right: -10px;\n}\n.p-20 {\n    padding: 20px;\n}\n.ps-20 {\n    padding-left: 20px;\n}\n.mt-minus-110 {\n    margin-top: -100px;\n}\n.minus-l-20 {\n    margin-left: -20px;\n\n    &:first-child {\n        margin-left: 0;\n    }\n}\n.box-shadow {\n    box-shadow: $box-shadow;\n}\n\n/*\nLine Height Area Style\n======================================================*/\n.lh-16 {\n    line-height: 16.5px !important;\n}\n.lh-25 {\n    line-height: 25px !important;\n}\n.lh-30 {\n    line-height: 30px !important;\n}\n.lh-34 {\n    line-height: 34px !important;\n}\n.lh-35 {\n    line-height: 35px !important;\n}\n.lh-40 {\n    line-height: 40px !important;\n}\n.lh-44 {\n    line-height: 44px !important;\n}\n.lh-45 {\n    line-height: 45px !important;\n}\n.lh-48 {\n    line-height: 48px !important;\n}\n.lh-56 {\n    line-height: 56px !important;\n}\n.lh-55 {\n    line-height: 59px !important;\n}\n.lh-60 {\n    line-height: 60px !important;\n}\n.lh-70 {\n    line-height: 70px !important;\n}\n.lh-97 {\n    line-height: 97px !important;\n}\n\n/*\nCustom Border Color Area Style\n======================================================*/\n.border-color-white {\n    border-color: $white !important;\n}\n.list-dot {\n    li {\n        position: relative;\n        padding-right: 14px;\n        margin-right: 10px;\n        &::before {\n            content: \"\";\n            position: absolute;\n            top: 50%;\n            right: 0;\n            width: 5px;\n            height: 5px;\n            background-color: $white;\n            border-radius: 50px;\n            transform: translateY(-50%);\n        }\n        &:last-child {\n            padding-right: 0;\n            margin-right: 0;\n            &::before {\n                display: none;\n            }\n        }\n    }\n}\n\n/*\nCustom Hover Area Style\n======================================================*/\n.hover {\n    transition: $transition;\n    &:hover {\n        color: $primary !important;\n        i, span {\n            color: $primary !important; \n        }\n    }\n}\n.hover-white {\n    transition: $transition;\n    &:hover {\n        color: $white !important;\n        i, span {\n            color: $white !important; \n        }\n    }\n}\n.hover-bg {\n    transition: $transition;\n    &:hover {\n        background-color: $primary !important;\n        color: $white !important;\n        i, span {\n            color: $white !important; \n        }\n    }\n}\n.cursor {\n    cursor: pointer;\n}\n.cursor-move {\n    cursor: move;\n}\n.product-upload {\n\tinput[type=file] {\n\t\tdisplay: none;\n\t}\n\t.file-upload {\n\t\tdisplay: inline-block;\n\t\tcursor: pointer;\n\t\tline-height: 40px;\n\t\ttext-align: center;\n\t\tfont-size: 16px;\n\t\twidth: 100%;\n\t}\n}\n.inbox-tabs {\n    flex-wrap: wrap !important;\n    padding-bottom: 15px !important;\n    gap: 3rem !important;\n\n    .nav-item {\n        .nav-link {\n            position: relative;\n            padding: 0;\n            font-weight: 500;\n            color: $body-color;\n            border: none;\n            background-color: transparent;\n\n            &::before {\n                content: \"\";\n                position: absolute;\n                bottom: -15px;\n                left: 0;\n                width: 100%;\n                height: 2px;\n                background-color: $primary;\n                opacity: 0;\n                transition: $transition;\n            }\n            &.active {\n                color: $primary !important;\n\n                &::before {\n                    opacity: 1;\n                }\n                i, span {\n                    color: $primary !important;\n                }\n            }\n        }\n    }\n}\n.seller-tabs {\n    .nav-item {\n        .nav-link {\n            &.active {\n                background-color: $primary !important;\n                color: $white !important;\n            }\n        }\n    }\n}\n.profile-tabs {\n    .nav-item {\n        .nav-link {\n            &.active {\n                background-color: $primary !important;\n                color: $white !important;\n            }\n            &:hover {\n                background-color: $primary !important;\n                color: $white !important;\n            }\n        }\n    } \n}\n.tracking-step {\n    position: relative;\n    z-index: 1;\n    &::before {\n        content: \"\";\n        position: absolute;\n        top: 25px;\n        left: 0;\n        right: 0;\n        border-top: 1px dashed $white;\n        z-index: -1;\n        border-spacing: 20px;\n    }\n    .count {\n        width: 50px;\n        height: 50px;\n        line-height: 48px;\n        border: 1px dashed $white;\n        display: inline-block;\n        border-radius: 50px;\n        background-color: $primary;\n        &.active {\n            background-color: #0dcaf0;\n        }\n    }\n    &.style-two {\n        &::before {\n            border-color: $primary;\n        }\n        .count {\n            border-color: $primary;\n            &.active {\n                background-color: $primary;\n            }\n        }\n    }\n}\n.top-1 {\n    top: 1px;\n}\n.top-2 {\n    top: 2px;\n}\n.top-3 {\n    top: 3px;\n}\n.top-4 {\n    top: 4px;\n}\n.top-5 {\n    top: 5px;\n}\nbutton {\n    i, span {\n        transition: $transition;\n    }\n    &:hover {\n        i, span {\n            color: $primary;\n        }\n    }\n}\n.btn-close {\n    &:focus {\n        box-shadow: none;\n    }\n}\n.copy-btn {\n    margin-top: 144px;\n    margin-right: 35px;\n    &:hover {\n        background-color: $primary !important;\n        color: $white;\n    }\n}\n.carousel-control-prev {\n    width: 38px;\n    height: 38px;\n    background-color: $primary;\n    padding: 10px;\n    position: absolute;\n    top: 50%;\n    left: 10px;\n    transform: translateY(-50%);\n    border-radius: 5px;\n    opacity: 1;\n}\n.carousel-control-next {\n    width: 38px;\n    height: 38px;\n    background-color: $primary;\n    padding: 10px;\n    position: absolute;\n    top: 50%;\n    right: 10px;\n    transform: translateY(-50%);\n    border-radius: 5px;\n    opacity: 1;\n}\n.rating {\n    i, span {\n        transition: $transition;\n        font-size: 20px;\n        cursor: pointer;\n    }\n    &.active {\n        i, span {\n            color: #f7d700;\n        }\n    }\n}\n\n/*\nScroll Bar Style\n======================================================*/\n.scroll-bar {\n    margin-top: 0 !important;\n    overflow: auto;\n\tpadding-right: 5px;\n    /* width */\n    &::-webkit-scrollbar {\n        width: 6px;\n\t\theight: 6px;\n        transition: $transition;\n\t\tborder-radius: 50px;\n    }\n    /* Track */\n    &::-webkit-scrollbar-track {\n        background: #F0F0F4;\n\t\ttransition: $transition;\n\t\tborder-radius: 50px;\n    }\n    /* Handle */\n    &::-webkit-scrollbar-thumb {\n        background: #e0e0e2;\n\t\ttransition: $transition;\n\t\tborder-radius: 50px;\n    }\n    /* Handle on hover */\n    &::-webkit-scrollbar-thumb:hover {  \n        background: $primary;\n\t\tborder-radius: 50px;\n    }\n\t&.active {\n\t\t&::-webkit-scrollbar-track {\n\t\t\tbackground: #F0F0F4;\n\t\t\ttransition: $transition;\n\t\t\tborder-radius: 0;\n\t\t}\n\t\t/* Handle */\n\t\t&::-webkit-scrollbar-thumb {\n\t\t\tbackground: $primary;\n\t\t\ttransition: $transition;\n\t\t\tborder-radius: 0;\n\t\t}\n\t\t/* Handle on hover */\n\t\t&::-webkit-scrollbar-thumb:hover {  \n\t\t\tbackground: $primary;\n\t\t\tborder-radius: 0;\n\t\t}\n\t}\n}\n.btn-primary {\n    &.bg-opacity-10 {\n        &:hover {\n            background-color: $primary !important;\n            color: $white !important;\n        }\n    }\n}\n.btn-danger {\n    &.bg-opacity-10 {\n        &:hover {\n            background-color: $danger !important;\n            color: $white !important;\n        }\n    }\n}\n.tag-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    padding: 8px;\n    .tag {\n        background-color: $primary;\n        color: $white;\n        padding: 4px 8px;\n        border-radius: 4px;\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n    }\n    .tag-close {\n        margin-left: 4px;\n        cursor: pointer;\n    }\n}\n#x__PREV__X {\n    background: #EBEAF7;\n\tfont-size: 30px;\n    height: 34px;\n    line-height: 13px;\n}\na#x__NEXT__X {\n\tbackground: #EBEAF7;\n\tfont-size: 30px;\n    height: 34px;\n    line-height: 13px;\n}\n.faq-wrapper {\n    &.accordion {\n        .accordion-item {\n            border-radius: 7px;\n            \n            .accordion-header {\n                .accordion-button {\n                    border-radius: 7px;\n                    font-size: 16px;\n                    font-weight: 500;\n                    background-color: #fff;\n                    box-shadow: none;\n                    color: #000;\n\n                    &:focus {\n                        box-shadow: none;\n                    }\n                    &:not(.collapsed) {\n                        box-shadow: none;\n                    }\n                }\n            }\n            .accordion-body {\n                padding-top: 1px;\n            }\n        }\n    }\n}\n.wizard-tabs {\n    position: relative;\n    z-index: 1;\n    &::before {\n        content: \"\";\n        position: absolute;\n        top: 25px;\n        left: 0;\n        right: 0;\n        width: 100%;\n        height: 1px;\n        background-color: #A9A9C8;\n        opacity: 0.1;\n        z-index: -1;\n    }\n    .nav-item {\n        .nav-link {\n            background-color: #f1f2fd !important;\n            &.active {\n                background-color: $primary !important;\n                span {\n                    color: $white !important;\n                }\n            }\n        }\n    }\n}\n.wizard-tabs2 {\n    position: relative;\n    z-index: 1;\n    &::before {\n        content: \"\";\n        position: absolute;\n        top: 25px;\n        left: 0;\n        right: 0;\n        width: 100%;\n        height: 2px;\n        background-color: #A9A9C8;\n        opacity: 0.1;\n        z-index: -1;\n    }\n    .nav-item {\n        .nav-link {\n            background-color: $white;\n            padding: 0 30px !important;\n            border: none;\n            span {\n                background-color: #f1f2fd !important;\n                line-height: 48px;\n            }\n            &.active {\n                span {\n                    color: $white !important;\n                    background-color: $primary !important;\n                }\n            }\n        }\n        &:first-child {\n            .nav-link {\n                padding-left: 0 !important;\n            }\n        }\n        &:last-child {\n            .nav-link {\n                padding-right: 0 !important;\n            }\n        }\n    }\n}\n\n/*\nTheme Settings Style\n======================================================*/\n.settings-btn {\n    background-color: $secondary;\n    padding: 8px 20px;\n    display: inline-block;\n    color: $white;\n    font-size: 14px;\n    border-radius: 5px;\n    cursor: pointer;\n    border: none;\n    transition: $transition;\n    input {\n        width: 0;\n        height: 0;\n        opacity: 0;\n        cursor: pointer;\n    }\n    .slider {\n        position: relative;\n        &:before {\n            content: \"Click To RTL\";\n            cursor: pointer;\n        }\n        &:after {\n            content: \"Click To LTR\";\n            cursor: pointer;\n            position: absolute;\n            top: 0;\n            left: 0;\n            opacity: 0;\n        }\n    }\n}\n.offcanvas-backdrop {\n    background-color: transparent;\n}\n.light {\n    display: none;\n}\n.light1 {\n    display: none;\n}\n.light2 {\n    display: none;\n}\n.light3 {\n    display: none;\n}\n.radius {\n    display: none;\n}\n.white {\n    display: none;\n}\n.fluid {\n    display: none;\n}\n\n/*\nSwiper Slider Style\n======================================================*/\n.swiper-pagination2 {\n    position: absolute;\n    bottom: 57px !important;\n    left: 25px !important;\n    z-index: 1;\n    text-align: left !important;\n    width: 100px !important;\n    &.swiper-pagination-clickable .swiper-pagination-bullet {\n        background-color: $white;\n        opacity: 1;\n        &.swiper-pagination-bullet-active {\n            background-color: $danger;\n        }\n    }\n}\n\n/* Courses Area Style\n============================================*/\n.course-accordion {\n    .accordion-button {\n        &:focus {\n            box-shadow: none;\n        }\n        &:not(.collapsed) {\n            box-shadow: none;\n        }\n    }\n}\n\n.courses-slide {\n    .swiper-pagination {\n        bottom: 10px;\n        left: 10px;\n        text-align: left;\n\n        .swiper-pagination-bullet {\n\n            &.swiper-pagination-bullet-active {\n                background-color: #fff;\n            }\n        }\n    }\n}\n\n/* File Manager Area Style\n============================================*/\n.file-subdown {\n    padding-left: 28px;\n    margin-top: 21px;\n    margin-bottom: 25px;\n    li {\n        position: relative;\n        padding-left: 15px;\n        margin-bottom: 18px;\n        &:last-child {\n            margin-bottom: 0;\n        }\n        &::before {\n            left: 0;\n            top: 50%;\n            width: 6px;\n            content: \"\";\n            height: 6px;\n            border-radius: 50%;\n            position: absolute;\n            transform: translateY(-50%);\n            transition: $transition;\n            border: 1px solid $primary;\n        }\n    }\n}\n\n/* Quantity Area Style\n============================================*/\n.product-quantity {\n    border: 1px solid #E2E8F0;\n    border-radius: 4px;\n    display: inline-block;\n\n    &.bg-e2e8f0 {\n        background-color: #e2e8f0;\n\n        .add-to-cart-counter {\n            input {\n                background-color: #e2e8f0;\n            }\n            .minusBtn, .plusBtn {\n                background-color: $white;\n            }\n        }\n    }\n    .add-to-cart-counter {\n        display: flex;\n        padding: 5px;\n\n        input {\n            background-color: $white;\n            border: 1px solid #E2E8F0;\n            text-align: center;\n            font-size: 16px;\n            font-weight: 500;\n            color: #5B5B98;\n            border-radius: 4px;\n            height: 36px;\n            padding: 0;\n            border-radius: 0;\n\n            &:focus {\n                border-color: $primary;\n                outline: none;\n            }\n        }\n        .minusBtn, .plusBtn {\n            background-color: #E2E8F0;\n            width: 36px;\n            height: 36px;\n            line-height: 30px;\n            border-radius: 4px;\n            transition: $transition;\n            font-family: 'remixicon' !important;\n            padding: 0;\n            border: 0;\n            color: #5B5B98;\n\n            &:hover {\n                background-color: $primary;\n                color: $white;\n                border-color: $primary;\n            }\n        }\n    }\n}\n.for-light-logo {\n    display: block;\n}\n.for-dark-logo {\n    display: none;\n}\n.upcoming-events-slide {\n    direction: ltr;\n\n    .swiper-pagination {\n        position: initial;\n        text-align: left;\n\n        .swiper-pagination-bullet {\n            width: 8px;\n            height: 8px;\n\n            &.swiper-pagination-bullet-active {\n                background-color: $primary;\n            }\n        }\n    }\n}\n.card.bg-primary.border-0.rounded-3.position-relative.mb-4 {\n    .form-select {\n        color: $white !important;\n    }\n}\n\n// email-sidebar-nav\n.email-sidebar-nav {\n    li {\n        a {\n            &:hover, &.active{\n                color: $primary; \n            }\n        }\n    }\n}\n\n// fm-sidebar-nav\n.fm-sidebar-nav {\n    li {\n        a {\n            &:hover, &.active{\n                color: $primary; \n            }\n        }\n    }\n}\n\n// products-list-tabs\n.products-list-tabs {\n    li {\n        .nav-link {\n            font-size: 16px;\n            font-weight: 500;\n            border: none !important;\n            border-radius: 7px;\n            background-color: #f6f7f9;\n            padding: 10px 30px; \n            color: $secondary; \n            text-transform: capitalize;\n\n            &.active {\n                background-color: $primary; \n                color: $white; \n            }\n        }\n    }\n}\n\n.react-select__control {\n    min-height: 60px !important;  \n}\n\n.main-content:has(div.auth-main-content) { \n    padding: 0;\n}\n.main-content:has(div.fp-wrapper) { \n    padding: 0;\n}\n.main-content:has(div.not-found-content) { \n    padding: 0;\n}\n.cryptocurrency-slider {\n    .swiper-pagination {\n        bottom: 0;\n\n        .swiper-pagination-bullet {\n\n            &.swiper-pagination-bullet-active {\n                background-color: $primary;\n            }\n        }\n    }\n}\n\n.recent-property-slide {\n    .swiper-pagination {\n        position: initial;\n        line-height: 1;\n        margin-top: 10px;\n\n        .swiper-pagination-bullet {\n            &.swiper-pagination-bullet-active {\n                background-color: $primary;\n            }\n        }\n    }\n}\n\n.date-time-picker-demo {\n    .react-datetime-picker__wrapper {\n        border: 1px solid #eee;\n        border-radius: 10px;\n        padding: 4px 10px;\n        background: #f5f5f5; \n\n        .react-datetime-picker__inputGroup {\n            font-size: 13px;\n        }\n        .react-datetime-picker__button {\n            padding: 0;\n            margin-left: 5px;\n\n            svg {\n                display: inherit;\n                width: 15px;\n            }\n        }\n    }\n    .react-calendar {\n        border: 1px solid $border-color;\n        padding: 10px;\n    }\n}\n\n// custom-modal\n.custom-modal {\n    background-color: rgba(0, 0, 0, .2);\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 99999; \n    transition: $transition;\n\n    .close-link {\n        cursor: pointer;\n        line-height: 1;\n    }\n    .custom-modal-content  {\n        width: 400px;\n        height: 100%;\n        background-color: $body-bg;\n        overflow-y: auto;\n    }\n    .custom-modal-header {\n        background-color: $body-bg;\n    }\n\n    &.right {\n        right: -100%;\n        left: auto;\n\n        &.show {\n            right: 0;\n            left: 0;\n        }\n        .custom-modal-content  {\n            margin-left: auto;\n        }\n    }\n    &.left {\n        left: -100%;\n        right: auto;\n\n        &.show {\n            right: 0;\n            left: 0;\n        } \n    }\n    &.center {\n        transform: scale(0);\n        padding: 20px;\n        \n        &.show {\n            transform: scale(1);\n        }\n        .custom-modal-content  {\n            width: 600px;\n            margin-left: auto;\n            margin-right: auto;\n        }\n    }\n    .close-outside {\n        position: absolute;\n        left: 0;\n        top: 0;\n        cursor: ne-resize;\n        width: 100%;\n        height: 100%;\n    }\n}\n\n/* Marketing Dashboard CSS */\n.avatar-upload {\n    position: relative;\n    max-width: 135px;\n    .avatar-edit {\n        position: absolute;\n        right: -17px;\n        bottom: -17px;\n        z-index: 1;\n        input {\n            display: none;\n            + label {\n                display: inline-block;\n                width: 30px;\n                height: 30px;\n                line-height: 30px;\n                margin-bottom: 0;\n                border-radius: 100%;\n                background: #FFFFFF;\n                border: 1px solid transparent;\n                box-shadow: 0px 4px 34px 0px rgba(0, 0, 0, 0.15);\n                cursor: pointer;\n                font-weight: normal;\n                transition: $transition;\n                font-size: 20px;\n                &:after {\n                    content: \"\\ea13\";\n                    font-family: remixicon !important;\n                    color: #757575;\n                    position: absolute;\n                    top: 0;\n                    left: 1px;\n                    right: 0;\n                    text-align: center;\n                    margin: auto;\n                }\n            }\n        }\n    }\n    .avatar-preview {\n        width: 135px;\n        height: 135px;\n        position: relative;\n        border-radius: 4px;\n        border: 6px solid #F8F8F8;\n        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n        > div {\n            width: 100%;\n            height: 100%;\n            border-radius: 4px;\n            background-size: cover;\n            background-repeat: no-repeat;\n            background-position: center;\n        }\n    }\n}\n\n// dark\n.dark {\n    .avatar-upload {\n        .avatar-preview {\n            border: 6px solid #2f2f2f;\n        }\n    }\n}\n\n/* File Upload Area Style\n============================================*/\n.only-file-upload {\n    .form__file {\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        cursor: pointer;\n        opacity: 0;\n    }\n    .form__files-container {\n        display: flex;\n        width: 100%;\n        padding: 5px 0;\n        justify-content: space-between;\n        align-items: center;\n        background-color: $border-color;\n        padding: 10px;\n        margin-top: 10px;\n        border-radius: 6px;\n    }\n    .form__text {\n        font-size: 14px;\n        color: $secondary;\n        max-width: 450px;\n        whitespace: no-wrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n    .form__icon {\n        font-size: 22px;\n        color: $primary;\n        text-decoration: none;\n        background-color: rgba(31, 100, 241, 0.1);\n        width: 35px;\n        height: 35px;\n        line-height: 35px;\n        text-align: center;\n        border-radius: 4px;\n        display: inline-block;\n        &:hover {\n            background-color: $primary;\n            color: $white;\n        }\n    }\n}\n\n/* Card Body Custom Padding Area Style\n============================================*/\n.custom-padding-30 {\n    padding: 30px;\n}\n.custom-shadow {\n    box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.05);\n}\n.upcoming-events-slide-two {\n    .swiper-pagination {\n        position: initial;\n        line-height: 1;\n        bottom: 0;\n\n        .swiper-pagination-bullet {\n            background-color: $primary;\n            border-radius: 50px;\n            transition: $transition;\n            height: 4px;\n            \n            &.swiper-pagination-bullet-active {\n                width: 24px;\n            }\n        }\n    }\n}\n.fw-800 {\n    font-weight: 800;\n}\n.fw-900 {\n    font-weight: 900;\n}\n.last-child-none {\n    .child {\n        &:last-child {\n            border-bottom: 0 !important;\n            padding-bottom: 0 !important;\n            margin-bottom: 0 !important;\n        }\n    }\n}\n.school-nb {\n    padding-left: 30px;\n    padding-right: 30px;\n    margin-bottom: 17.5px;\n    padding-bottom: 17.5px;\n\n    &:last-child { \n        padding-bottom: 0;\n        border-bottom: none !important;\n    }\n}\n\n// call-center\n.bg-ecf0ff {\n    background-color: #ecf0ff;\n}\n.bg-faf5ff {\n    background-color: #faf5ff;\n}\n.bg-fff5ed {\n    background-color: #fff5ed;\n}\n.cco-tab-btn {\n    cursor: pointer;\n\n    img {\n        &.hidden {\n            display: none;\n        }\n    }\n \n    &.active {\n        img {\n            display: none;\n          \n            &.hidden {\n                display: block;\n            }\n        }\n        .text-body, .text-secondary, .text-black, .text-success, .text-danger-50 {\n            color: $white !important;\n        }\n    }\n}\n\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n\n    .p-4 {\n        padding: 15px !important;\n    }\n    .fs-16 {\n        font-size: 15px;\n    }\n    .fs-20 {\n        font-size: 18px;\n    }\n    .fs-24 {\n        font-size: 20px;\n    }\n    .fs-28 {\n        font-size: 21px;\n    }\n    .file-upload {\n        font-size: 13px !important;\n    }\n    .wh-160 {\n        width: 110px;\n        height: 110px;\n    }\n    .mw-123 {\n        max-width: 43px;\n    }\n    .custom-padding-30 {\n        padding: 20px;\n    }\n    .custom-modal {\n        .custom-modal-content  {\n            width: 320px;\n        }\n        &.center {\n            .custom-modal-content  {\n                width: 320px; \n            }\n        }\n    }\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n\n    .mw-123 {\n        max-width: 120px;\n    }\n\n}\n\n/* Min width 768px to Max width 992px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n\n    .p-4 {\n        padding: 20px !important;\n    }\n    .fs-28 {\n        font-size: 24px;\n    }\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n\n    .mw-123 {\n        max-width: 98px;\n    }\n    .custom-p1 {\n        padding-right: 12px !important;\n    }\n    .custom-p2 {\n        padding-left: 12px !important;\n        .card {\n            border-radius: 0 0 8px 8px !important;\n        }\n        .rounded-start-0 {\n            border: none !important;\n            border-top: 1px solid $border-color !important;\n        }\n    }\n\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n    \n    .p-4 {\n        padding: 20px !important;\n    }\n    .pb-y-0 {\n        padding-bottom: 0 !important;\n    }\n    .py-38 {\n        padding-top: 34px !important;\n        padding-bottom: 34px !important;\n    }\n    .mw-123 {\n        max-width: 90px;\n    }\n    .custom-p1 {\n        padding-right: 12px !important;\n    }\n    .custom-p2 {\n        padding-left: 12px !important;\n        .card {\n            border-radius: 0 0 8px 8px !important;\n        }\n        .rounded-start-0 {\n            border: none !important;\n            border-top: 1px solid $border-color !important;\n        }\n    }\n\n}\n\n/* Min width 1400px to Max width 1799px */\n@media only screen and (min-width: 1400px) and (max-width: 1799px) {\n    .py-38 {\n        padding-top: 30px !important;\n        padding-bottom: 30px !important;\n    }\n\n}\n\n@media only screen and (min-width: 992px) {\n\n    .mb-lg-30 {\n        margin-bottom: 30px !important;\n    }\n    .h-md-100 {\n        height: 100%;\n    }\n\n}\n\n@media only screen and (min-width: 768px) {\n    \n    .h-md-100 {\n        height: 100%;\n    }\n\n}\n\n@media only screen and (min-width: 1600px) {\n    .employee-attendance-list {\n        li {\n            position: relative;\n\n            &::before {\n                content: \"\";\n                position: absolute;\n                top: 0;\n                left: -50%;\n                transform: translateX(-50%);\n                width: 0.5px;\n                height: 100%;\n                background-color: $border-color;\n            }\n\n            &:first-child {\n                &::before {\n                    display: none;\n                }\n            }\n        }\n    }\n}\n\n@media only screen and (min-width: 1920px) {\n    .custom-xxxl-10 {\n        flex: 0 0 auto;\n        width: 77%;\n    }\n    .custom-xxxl-2 {\n        flex: 0 0 auto;\n        width: 23%;\n    }\n}\n.c-dropdown {\n    &::after {\n        display: none;\n    }\n}\n\n// pos system & podcast dashboard\n.select-dropdown {\n    .dropdown-toggle {\n        padding: 6.5px 14px; \n        position: relative;\n\n        i {\n            font-size: 18px;\n            line-height: 1;\n            position: relative;\n            top: 2px;\n        }\n        &::after {\n            display: none;\n        }\n    }\n    .dropdown-item {\n        &:active {\n            color: $white !important;\n        }\n    }\n    &.without-border {\n        .dropdown-toggle {\n            padding: 0;\n            border: 0 !important;\n\n            &::after {\n                right: 0;\n            }\n        }\n    }\n}\n\n.categories-tabs {\n    .nav-item {\n        .nav-link {\n            border-color: #ECEEF2;\n\n            &.active {\n                border-color: $primary;\n\n                span {\n                    .d-none {\n                        display: inline-block !important;\n                    }\n                }\n            }\n        }\n    }\n}\n.payment-method {\n    .btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {\n        border-color:  $primary !important;\n        background-color: #ECF0FF !important;\n    }\n}\n\n/* Follow Button Style\n============================================*/\n.follow-button {\n    .followed {\n        transition: $transition;\n    }\n    &.followed {\n        background-color: $primary !important;\n        color: $white !important;\n    }\n}\n\n/* Audio player Style\n============================================*/\n.most-popular-tabs {\n    margin-bottom: 20px;\n\n    .nav-item {\n        .nav-link {\n            padding: 3.5px 12px;\n\n            &.active {\n                background-color: $primary !important;\n                color: $white !important;\n            }\n        }\n    }\n}\n.single-play {\n    .audio-play-btn {\n        opacity: 0;\n        transition: $transition;\n    }\n    &:hover {\n        .audio-play-btn {\n            opacity: 1;\n        }\n    }\n    &.active {\n        .audio-play-btn {\n            opacity: 1;\n        }\n    }\n}\n.doctor-cover-bg {\n    position: relative;\n    z-index: 0;\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 90px;\n        background-color: $white;\n        z-index: -1;\n    }\n    .avatar-upload .avatar-edit input + label:after {\n        display: none;\n    }\n}\n.wave-container {\n    .wave-bar {\n        width: 2px;\n        height: 25px;\n        background-color: #C2CDFF;\n        margin-left: 2px;\n        animation: wave-animation 1s infinite ease-in-out;\n        animation-play-state: paused;\n    }\n    \n    .wave-bar:nth-child(odd) {\n        animation-delay: 0.2s;\n    }\n    .wave-bar:nth-child(even) {\n        animation-delay: 0.4s;\n    }\n    \n    @keyframes wave-animation {\n        0%, 100% {\n            transform: scaleY(1);\n        }\n        50% {\n            transform: scaleY(2);\n        }\n    }\n}\n.audio-player-for-wave {\n    .ri-pause-fill {\n        left: 0 !important;\n    }\n}\n.mastering-digital-marketing-slide {\n    .swiper-pagination {\n        text-align: right;\n        position: absolute;\n        top: 0 !important; \n        right: 0 !important;\n        display: block;\n        padding: 20px 30px;\n        z-index: 0;\n        height: 30px;\n        z-index: 9;\n    \n        .swiper-pagination-bullet {\n            background-color: #8695AA;\n            width: 10px;\n            height: 3px;\n            border-radius: 4px;\n            transition: $transition;\n            opacity: 1;\n    \n            &.swiper-pagination-bullet-active {\n                background-color: $border-color;\n                width: 30px;\n            }\n        }\n    }\n}\n.call-overview-tabs {\n    .calls-card {\n        &.bg-primary {\n            &.active {\n                background-color: $primary !important; \n\n                .text-body.d-block {\n                    color: $border-color !important;\n                }\n                h3.text-secondary {\n                    color: $white !important;\n                }\n                span.d-flex.align-items-center.align-items-center.text-body {\n                    color: $white !important;\n\n                    span {\n                        color: $white !important;\n                    }\n                    .material-symbols-outlined {\n                        color: $white !important;\n                    }\n                }\n                img {\n                    filter: brightness(100);\n                }\n            }\n        }\n        &.bg-primary-divs {\n            &.active {\n                background-color: $primary-div-50 !important;\n\n                .text-body.d-block {\n                    color: $border-color !important;\n                }\n                h3.text-secondary {\n                    color: $white !important;\n                }\n                span.d-flex.align-items-center.align-items-center.text-body {\n                    color: $white !important;\n\n                    span {\n                        color: $white !important;\n                    }\n                    .material-symbols-outlined {\n                        color: $white !important;\n                    }\n                }\n                img {\n                    filter: brightness(100);\n                }\n            }\n        }\n        &.bg-dangers {\n            &.active {\n                background-color: $danger-50 !important;\n\n                .text-body.d-block {\n                    color: $border-color !important;\n                }\n                h3.text-secondary {\n                    color: $white !important;\n                }\n                span.d-flex.align-items-center.align-items-center.text-body {\n                    color: $white !important;\n\n                    span {\n                        color: $white !important;\n                    }\n                    .material-symbols-outlined {\n                        color: $white !important;\n                    }\n                }\n                img {\n                    filter: brightness(100);\n                }\n            }\n        }\n    }\n}\n.search-overlay {\n    display: none;\n    .form-control {\n        font-size: 12px;\n        height: 40px;\n        &::placeholder {\n            font-size: 12px;\n        }\n    }\n}\n.close-btn {\n    display: none !important;\n    &.active {\n        display: block !important;\n        background-color: $danger !important;\n        color: $white !important;\n    }\n}\n.recently-played {\n    .table-responsive {\n        .table {\n            tbody {\n                tr {\n                    td {\n                        border-color: #F6F7F9;\n                        padding: 12px 12px !important;\n                    }\n                    &:last-child {\n                        td {\n                            border: none;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n.popular-hosts {\n    .table-responsive {\n        .table {\n            tbody {\n                tr {\n                    td {\n                        border-color: #F6F7F9;\n                        padding-left: 12px !important;\n                        padding-right: 12px !important;\n                    }\n                    &:last-child {\n                        td {\n                            border: none;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n.top-podcasts {\n    .table-responsive {\n        .table {\n            thead {\n                tr {\n                    th {\n                        padding-left: 18px;\n                        padding-right: 18px;\n                    }\n                }\n            }\n            tbody {\n                tr {\n                    td {\n                        border-color: #F6F7F9;\n                        padding-left: 18px;\n                        padding-right: 18px;\n                    }\n                    &:last-child {\n                        td {\n                            border: none;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.light-mode-btn {\n    i {\n        color: #FE7A36 !important;\n    }\n    .dark_mode {\n        display: none;\n    }\n}\n.dark {\n    .light_mode {\n        display: none;\n    }\n    .dark_mode {\n        display: block;\n    }\n}\n.apexcharts-tooltip-marker {\n    line-height: 13px !important;\n\n    &::before {\n        font-size: 12px !important;\n    }\n}\n\n\n@media only screen and (max-width: 767px) {\n    .recently-played {\n        .table-responsive {\n            .table {\n                width: 770px;\n            }\n        }\n    }\n\n    .top-podcasts {\n        .table-responsive {\n            .table {\n                width: 745px;\n            }\n        }\n    }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n    .recently-played {\n        .table-responsive {\n            .table {\n                width: 860px;\n            }\n        }\n    }\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n    .recently-played {\n        .table-responsive {\n            .table {\n                width: 860px;\n            }\n        }\n    }\n}\n// End pos system & podcast dashboard\n\n// Social media dashboard\n.-right-10 {\n    right: -10px;\n}\n\n[dir=\"rtl\"] {\n    .-right-10 {\n        right: auto;\n        left: -10px;\n    }\n}\n// End Social media dashboard\n\n// Beauty salon dashboard\n.text-000 {\n    color: #000 !important;\n}\n.-mr-10 {\n    margin-right: -10px;\n}\n.bsts-products-slide {\n    .swiper-button-prev, .swiper-button-next {\n        background-color: $primary;\n        color: #fff;\n        width: 30px;\n        height: 30px;\n        border-radius: 100%;\n\n        &::after {\n            font-size: 18px;\n        }\n        &.swiper-button-disabled {\n            cursor: auto;\n            pointer-events: auto;\n        }\n    }\n}\n.ra-calendar {\n    .react-calendar__month-view__days {\n        .react-calendar__tile {\n            background-color: #E6EFF2;\n            border-radius: 10px;\n            border: 2px solid #fff;\n            height: 50px;\n        }\n    }\n}\n\n.dark { \n    .ra-calendar {\n        .react-calendar__month-view__days {\n            .react-calendar__tile {\n                background-color: #000; \n                border: 2px solid #333; \n            }\n        }\n    }\n}\n\n.bs-rs-appointments {\n    padding-left: 11px;\n    padding-right: 5px;\n\n    .bs-rs-appointments-list {\n        border-left: 1px dashed #D5D9E2;\n        padding-left: 37px;\n\n        .verifyIcon {\n            left: -37px !important;\n        }\n    }\n}\n\n[dir=\"rtl\"] {\n    .bs-rs-appointments {\n        padding-left: 5px;\n        padding-right: 11px;\n    \n        .bs-rs-appointments-list { \n            padding-left: 0;\n            padding-right: 37px;\n            border-left: none;\n            border-right: 1px dashed #D5D9E2; \n    \n            .verifyIcon {\n                left: auto !important;\n                right: -60px !important;\n            }\n        }\n    }\n}\n\n// Resoinsive\n@media only screen and (max-width: 767px) {\n    .default-table-area {\n        &.campaigns-table {\n            &.style-two {\n                &.bs-top-customers {\n                    .table-responsive {\n                        .table {\n                            width: 940px !important;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px)  {\n    .default-table-area {\n        &.campaigns-table {\n            &.style-two {\n                &.bs-top-customers {\n                    .table-responsive {\n                        .table {\n                            width: 940px !important;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n// End Beauty salon dashboard\n\n// Dctor dashboard\n.pr-5 {\n    padding-right: 5px;\n}\n.doctor-welcome-card {\n    padding-left: 105px;\n    padding-right: 80px;\n}\n.doctor-main-wrapper {\n    padding-left: 80px;\n    padding-right: 80px;\n}\n\n.pd-text-content {\n    h1 {\n        font-size: 20px;\n    }\n    h2 {\n        font-size: 19px;\n    }\n    h3 {\n        font-size: 18px;\n    }\n    h4 {\n        font-size: 17px;\n    }\n    h5 {\n        font-size: 16px;\n    }\n    h6 {\n        font-size: 15px;\n    }\n    ul, ol {\n        margin-bottom: 0;\n        margin-top: 15px;\n        padding-left: 17px;\n\n        li {\n            line-height: 1.8;\n            margin-bottom: 5px;\n\n            &::marker {\n                color: $primary;\n                font-size: 18px;\n            }\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n    }\n}\n.-po-left-26 {\n    left: -26px !important;\n}\n.recent-appointment-notify {\n    border-left: 1px dashed #D5D9E2;\n    padding-left: 26px,\n}\n\n.dark {\n    .doctor-cover-bg {\n        &::before {\n            background-color: #000;\n        }\n    }\n}\n \n[dir=\"rtl\"] {\n    .pr-5 {\n        padding-right: 0;\n        padding-left: 5px;\n    }\n    .pd-text-content {\n        ul, ol {\n            padding-left: 0;\n            padding-right: 17px;\n        }\n    }\n    .-po-left-26 {\n        left: 0 !important;\n        right: -50px !important;\n    }\n    .recent-appointment-notify {\n        border-left: none;\n        border-right: 1px dashed #D5D9E2;\n        padding-left: 0;\n        padding-right: 26px;\n    }\n}\n\n// Resoinsive\n@media only screen and (min-width: 992px) { \n    .default-table-area {\n        &.campaigns-table {\n            &.latest-transaction-table {\n                &.doctor-patients-table {\n                    .table-responsive {\n                        .table {\n                            width: 100% !important;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}   \n\n@media only screen and (max-width: 1199px) {\n    .doctor-welcome-card {\n        padding-top: 20px;\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n    .doctor-main-wrapper {\n        padding-left: 0;\n        padding-right: 0;\n        margin-top: 25px !important;\n    }\n}\n\n \n@media only screen and (min-width: 1200px) and (max-width: 1399px)  {\n    .doctor-welcome-card { \n        padding-left: 50px;\n        padding-right: 50px;\n    }\n    .doctor-main-wrapper {\n        padding-left: 0;\n        padding-right: 0;\n        margin-top: 25px !important;\n    }\n}\n\n@media only screen and (min-width: 1400px) and (max-width: 1599px)  {\n    .doctor-welcome-card { \n        padding-left: 50px;\n        padding-right: 50px;\n    }\n    .doctor-main-wrapper {\n        padding-left: 30px;\n        padding-right: 30px;  \n    }\n}\n// End Dctor dashboard \n\n// Hotel dashboard\n.p-25 {\n    padding: 25px;\n}\n.mt-10 {\n    margin-top: 10px;\n}\n.gad-bg {\n    background-color: rgb(255 255 255 / 10%) !important;\n    border-color: rgb(255 255 255 / 10%) !important;\n}\n.default-table-area {\n    &.upcoming-vip-reservations-table {\n        &.style-two {\n            .table-responsive {\n                .table {\n                    thead {\n                        tr {\n                            th {\n                                padding-bottom: 9px;\n                                padding-left: 21px;\n                                padding-right: 21px;\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                    tbody {\n                        tr {\n                            td {\n                                padding-top: 10px;\n                                padding-bottom: 10px;\n                                padding-left: 21px;\n                                padding-right: 21px;\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n.popular-rooms-slide {\n    .swiper-pagination {\n        position: initial;\n        margin-top: 10px;\n\n        .swiper-pagination-bullet {\n            border-radius: 30px;\n            height: 5px;\n\n            &.swiper-pagination-bullet-active {\n                width: 20px;\n                background-color: $primary;\n            }\n        }\n    }\n}\n\n// Resoinsive\n@media only screen and (max-width: 767px) { \n    .default-table-area {\n        &.upcoming-vip-reservations-table {\n            &.style-two {\n                .table-responsive {\n                    .table {\n                        width: 693px !important;\n                    }\n                }\n            }\n        }\n    }\n}\n\n@media only screen and (min-width: 992px) and (max-width: 1199px)  {\n    .default-table-area {\n        &.upcoming-vip-reservations-table {\n            &.style-two {\n                .table-responsive {\n                    .table {\n                        tbody {\n                            tr {\n                                td {\n                                    padding-left: 13px;\n                                    padding-right: 13px;\n\n                                    .fs-14 {\n                                        font-size: 12px !important;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n// End hotel dashboard\n\n// Real Estate Agent dashboard\n.welcome-real-estate-agent {\n    padding: 10px 25px 70px;\n    padding-left: 75px;\n    padding-right: 75px;\n}\n.welcome-card-wrap {\n    margin-top: -90px;\n}\n.my-featured-listings-slide {\n    .swiper-pagination {\n        position: initial;\n        margin-top: 10px;\n\n        .swiper-pagination-bullet {\n            border-radius: 30px;\n            height: 5px;\n\n            &.swiper-pagination-bullet-active {\n                width: 20px;\n                background-color: $primary;\n            }\n        }\n    }\n}\n.rea-app-btn {\n    padding: 7px 17.5px;\n    margin-bottom: 31px;\n    display: inline-block;\n    border-radius: .375rem;\n    color: $white !important;\n    background-color: #1a5710;\n    font-size: 16px;\n    text-decoration: none;\n\n    &:hover {\n        background-color: #25b003;\n        color: $white;\n    }\n}\n.rea-client-ratings-slide {\n    .swiper-pagination {\n        position: initial;\n        margin-top: 10px;\n\n        .swiper-pagination-bullet {\n            border-radius: 30px;\n            height: 5px;\n\n            &.swiper-pagination-bullet-active {\n                width: 20px;\n                background-color: $primary;\n            }\n        }\n    }\n}\n\n// Resoinsive\n@media only screen and (max-width: 767px) { \n    .welcome-real-estate-agent {\n        padding: 0 0 70px;\n        text-align: center;\n\n        .fs-32 {\n            font-size: 25px;\n        }\n    }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px)  {\n    .welcome-real-estate-agent {\n        text-align: center;\n    }\n}\n// End Estate Agent dashboard\n\n// Credit card dashboard\n\n// Resoinsive\n@media only screen and (max-width: 767px) { \n    .cc-recent-transactions {\n        .table {\n            width: 767px;\n        }\n    }\n} \n\n// End Credit card dashboard\n\n// Crypto Trader dashboard\n.default-table-area {\n    &.ct-gainers-losers {\n        &.style-two {\n            .table-responsive {\n                .table {\n                    tbody {\n                        tr {\n                            td {\n                                padding-top: 11px;\n                                padding-bottom: 11px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n// Resoinsive\n@media only screen and (max-width: 767px) { \n    .default-table-area {\n        &.ct-recent-transactions2 {\n            &.style-two {\n                .table-responsive {\n                    .table {\n                        width: 767px;\n                    }\n                }\n            }\n        }\n    }\n}\n// End Crypto Trader dashboard\n\n// Crypto Trader dashboard\n.default-table-area {\n    &.cp-transactions-history {\n        &.style-two {\n            .table-responsive {\n                .table {\n                    tbody {\n                        tr {\n                            td {\n                                padding-top: 12.5px;\n                                padding-bottom: 12.5px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n// Resoinsive\n@media only screen and (max-width: 767px) { \n    .default-table-area {\n        &.cp-individual-asset-performance {\n            &.style-two {\n                .table-responsive {\n                    .table {\n                        width: 800px;\n\n                        thead {\n                            tr {\n                                th {\n                                    font-size: 13px;\n                                }\n                            }\n                        }\n                        tbody {\n                            tr {\n                                td {\n                                    font-size: 13px;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n@media only screen and (min-width: 768px) and (max-width: 991px)  {\n    .default-table-area {\n        &.cp-individual-asset-performance {\n            &.style-two {\n                .table-responsive {\n                    .table {\n                        // width: 800px;\n\n                        thead {\n                            tr {\n                                th {\n                                    font-size: 13px;\n                                }\n                            }\n                        }\n                        tbody {\n                            tr {\n                                td {\n                                    font-size: 13px;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n// End Crypto Trader dashboard","/** Sidebar Menu Area\n===================================**/\n.sidebar-area {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 270px;\n\theight: 100%;\n\ttransition: $transition;\n\tpadding-bottom: 30px;\n\tbackground-color: $white;\n\n    .logo {\n        padding: 21.5px 25px;\n        border-bottom: 1px solid #ECF0FF;\n        \n        .logo-text {\n            font-size: 24px;\n            position: absolute;\n            top: -4px;\n            left: 33px;\n            transition: $transition;\n            font-weight: 700;\n        }\n    }\n    &.dark {\n        .logo {\n            border-color: $dark-border !important;\n        }\n    }\n    .sidebar-burger-menu {\n        transition: $transition;\n        right: 21px !important;\n    }\n}\n.sidebar-menu {\n    padding: {\n        top: 20px;\n        left: 25px;\n        right: 25px;\n        bottom: 60px;\n    };\n\twidth: 100%;\n    height: 100%;\n    overflow-y: auto;\n\n    /* width */\n    &::-webkit-scrollbar {\n        width: 5px;\n    }\n    /* Track */\n    &::-webkit-scrollbar-track {\n        background: #fff; \n    }\n    /* Handle */\n    &::-webkit-scrollbar-thumb {\n        background: #c5c5c5; \n    }\n    /* Handle on hover */\n    &::-webkit-scrollbar-thumb:hover {\n        background: #888; \n    }\n\n    .accordion {\n        border: none;\n        background-color: transparent;\n\n        .accordion-item {\n            border: none;\n            background-color: transparent;\n            margin-bottom: 3px;\n\n            .accordion-header {\n                .accordion-button {\n                    background-color: transparent;\n                    border-radius: 5px;\n                    border: none;\n                    box-shadow: none;\n                    font-weight: 500;\n                    padding: 9.5px 13px;\n                    display: flex;\n                    white-space: nowrap;\n                    transition: $transition;\n\n                    &::after {\n                        width: 15px;\n                        height: 15px;\n                        background-size: contain;\n                    }\n                    .material-symbols-outlined {\n                        margin-right: 8px;\n                        font-size: 21px;\n                        color: $body-color;\n                    }\n\n                    &:hover {\n                        background-color: #F6F7F9;\n\n                        .material-symbols-outlined {\n                            color: $secondary;\n                        }\n                    }\n                    \n                    .title {\n                        color: $secondary;\n                    }\n                    .count {\n                        background-color: #FFF5ED;\n                        color: #FD5812;\n                        border-radius: 50px;\n                        color: $danger;\n                        font-size: 11px;\n                        font-weight: 600;\n                        width: 20px;\n                        height: 20px;\n                        line-height: 20px;\n                        text-align: center;\n                        position: absolute;\n                        top: 50%;\n                        right: 42px;\n                        transform: translateY(-50%);\n                    }\n                }\n                .accordion-button[aria-expanded=\"true\"] {\n                    background-color: #F6F7F9;\n                }\n            }\n\n            .accordion-collapse {\n                .accordion-body {\n                    padding: 0;\n                }\n            }\n        }\n    }\n    .menu-item {\n        list-style-type: none;\n\t\tmargin-bottom: 5px;\n\n\t\t.menu-link {\n\t\t\ttext-decoration: none;\n\t\t\tfont-size: 14px;\n\t\t\tfont-weight: 500;\n\t\t\tcolor: $secondary;\n            padding: 9.5px 12px;\n            border-radius: 5px;\n            display: flex;\n            align-items: center;\n\n            .title {\n                transition: $transition;\n            }\n            .tag {\n                background-color: #FFE8D4;\n                width: 28px;\n                height: 16px;\n                font-size: 10px;\n                color: $danger;\n                display: inline-block;\n                text-align: center;\n                border-radius: 2px;\n                position: relative;\n                margin-left: 8px;\n\n                &::before {\n                    content: \"\";\n                    position: absolute;\n                    top: 4px;\n                    left: -3px;\n                    width: 8px;\n                    height: 8px;\n                    background-color: #FFE8D4;\n                    border-radius: 1px;\n                    transform: rotate(45deg);\n                    z-index: -1;\n                }\n                &.new {\n                    background-color: #D8FFC8;\n                    color: $success;\n\n                    &::before {\n                        background-color: #D8FFC8;\n                    }\n                }\n            } \n\t\t\t.material-symbols-outlined {\n\t\t\t\tmargin-right: 8px;\n                font-size: 21px;\n                color: $body-color;\n\t\t\t}\n            &.logout {\n                background-color: #f5f5f9;\n            }\n   \n            &.active, &:hover {\n                background-color: #f5f5f9;\n                color: $primary;\n\n                .material-symbols-outlined {\n                    color: $primary;\n                }\n\n                &::before {\n                    opacity: 1;\n                    border-color: $primary;\n                }\n                &::after {\n                    border-color: $white;\n                }\n            }\n\t\t}\n\t}\n\t.sub-menu {\n\t\tpadding: 0;\n        margin-top: 4px;\n        margin-bottom: 0;\n\n\t\t.menu-item {\n\t\t\tmargin-bottom: 4px;\n\n\t\t\t.menu-link {\n\t\t\t\tpadding: 9.5px 18px;\n                padding-left: 38px;\n\t\t\t\ttransition: $transition;\n\t\t\t\tposition: relative;\n\t\t\t\tfont-size: 14px;\n                color: $body-color;\n                display: flex;\n                white-space: nowrap;\n\n\t\t\t\t&::before {\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\twidth: 10px;\n\t\t\t\t\theight: 10px;\n\t\t\t\t\tborder: 1px solid $body-color;\n\t\t\t\t\tleft: 18px;\n\t\t\t\t\tborder-radius: 50px;\n\t\t\t\t\ttransition: $transition;\n\t\t\t\t}\n                &.active, &:hover {\n                    background-color: #ECF0FF;\n                    color: $primary;\n\n                    &::before {\n                        opacity: 1;\n                        border-color: $primary;\n                    }\n                    &::after {\n                        border-color: $white;\n                    }\n                }\n\t\t\t}\n\t\t}\n\t}\n    .menu-title {\n\t\tposition: relative;\n\t\tdisplay: block;\n\t\tz-index: 1;\n\t\tmargin-top: 12px;\n\n\t\t.menu-title-text {\n            font-size: 12px;\n            font-weight: 500;\n            color: $dark-body-color;\n            display: block;\n            margin-bottom: 7px;\n\t\t}\n        &:first-child {\n            margin-top: 0;\n        }\n\t}\n}\n\n@media only screen and (min-width: 1200px) {\n    .main-wrapper-content {\n        &.active {\n            .sidebar-area {\n                width: 80px;\n                z-index: 2;\n                transition: $transition;\n            \n                .logo {\n                    padding-left: 25px;\n                    padding-right: 25px;\n\n                    .logo-text {\n                        left: 0;\n                        opacity: 0;\n                        visibility: hidden;\n                    }\n                }\n                \n                .sidebar-menu {\n                    padding: 17px;\n                    padding-bottom: 60px;\n\n                    .accordion {\n                        .accordion-item {\n                            .accordion-header {\n                                .accordion-button {\n                                    padding: 10px;\n\n                                    &::after {\n                                        display: none;\n                                    }\n                                    .material-symbols-outlined {\n                                        margin-right: 0;\n                                    }\n                                    .title {\n                                        display: none;\n                                    }\n                                    .count {\n                                        display: none;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    .menu-item {\n                        .menu-link {\n                            .title {\n                                display: none;\n                            }\n                        }\n                    }\n                    .menu-header {\n                        display: none;\n                    }\n                    .sub-menu {\n                        display: none;\n                    }\n                    .menu-title {\n                        margin-top: 15px;\n                        margin-bottom: 15px;\n\n                        .menu-title-text {\n                            margin-bottom: 0;\n                            font-size: 0;\n                            position: relative;\n                            transition: $transition;\n                    \n                            &::before {\n                                top: 50%;\n                                width: 50px;\n                                content: \"\";\n                                height: 1px;\n                                position: absolute;\n                                transform: translateY(-50%);\n                                background: $border-color;\n                            }\n                        }\n                    }\n                }\n\n                &:hover {\n                    width: 270px;\n                    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n            \n                    .sidebar-menu {\n                        padding: {\n                            // top: 20px;\n                            // left: 20px;\n                            // right: 20px;\n                            // bottom: 60px;\n                        };\n                        .menu-header {\n                            display: block;\n                        }\n                        .accordion {\n                            .accordion-item {\n                                .accordion-header {\n                                    .accordion-button {\n                                        padding: 10px;\n        \n                                        &::after {\n                                            display: block;\n                                        }\n                                        .material-symbols-outlined {\n                                            margin-right: 8px;\n                                        }\n                                        .title {\n                                            display: block;\n                                        }\n                                        .count {\n                                            display: block;\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                        .sub-menu {\n                            display: block;\n                            \n                            .menu-item {\n                                .menu-link {\n                                    padding-left: 35px;\n                                }\n                            }\n                        }\n                        .menu-item {\n                            .menu-link {\n                                .title {\n                                    display: block;\n                                }\n                            }\n                        }\n                        .menu-title {\n                            margin-top: 12px;\n                            margin-bottom: 0;\n    \n                            .menu-title-text {\n                                margin-bottom: 7px;\n                                font-size: 12px; \n                        \n                                &::before {\n                                    display: none;\n                                }\n                            }\n                        }\n                    }\n                    .logo {\n                        .logo-text {\n                            left: 33px;\n                            opacity: 1;\n                            visibility: visible;\n                        }\n                    }\n                    .sidebar-burger-menu {\n                        opacity: 1 !important;\n                        z-index: 1 !important;\n                        right: 21px !important;\n                    }\n                }\n            }\n        }\n        &.compact-sidebar {\n            .main-content {\n                padding-left: 92px;\n\n                .header-area {\n                    .left-header-content {\n                        ul {\n                            li.hbm {\n                                display: none !important;\n                            }\n                        }\n                    }\n                }\n            }\n            .sidebar-area {\n                width: 80px;\n                z-index: 2;\n                transition: $transition;\n\n                .sidebar-burger-menu {\n                    display: none !important;\n                }\n            \n                .logo {\n                    padding-left: 25px;\n                    padding-right: 25px;\n\n                    .logo-text {\n                        left: 0;\n                        opacity: 0;\n                        visibility: hidden;\n                    }\n                }\n                \n                .sidebar-menu {\n                    padding: 17px;\n                    padding-bottom: 60px;\n\n                    .accordion {\n                        .accordion-item {\n                            .accordion-header {\n                                .accordion-button {\n                                    padding: 10px;\n\n                                    &::after {\n                                        display: none;\n                                    }\n                                    .material-symbols-outlined {\n                                        margin-right: 0;\n                                    }\n                                    .title {\n                                        display: none;\n                                    }\n                                    .count {\n                                        display: none;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    .menu-item {\n                        .menu-link {\n                            .title {\n                                display: none;\n                            }\n                        }\n                    }\n                    .menu-header {\n                        display: none;\n                    }\n                    .sub-menu {\n                        display: none;\n                    }\n                    .menu-title {\n                        margin-top: 15px;\n                        margin-bottom: 15px;\n\n                        .menu-title-text {\n                            margin-bottom: 0;\n                            font-size: 0;\n                            position: relative;\n                            transition: $transition;\n                    \n                            &::before {\n                                top: 50%;\n                                width: 50px;\n                                content: \"\";\n                                height: 1px;\n                                position: absolute;\n                                transform: translateY(-50%);\n                                background: $border-color;\n                            }\n                        }\n                    }\n                }\n\n                &:hover {\n                    width: 270px;\n                    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n            \n                    .sidebar-menu {\n                        .menu-header {\n                            display: block;\n                        }\n                        .accordion {\n                            .accordion-item {\n                                .accordion-header {\n                                    .accordion-button {\n                                        padding: 10px;\n        \n                                        &::after {\n                                            display: block;\n                                        }\n                                        .material-symbols-outlined {\n                                            margin-right: 8px;\n                                        }\n                                        .title {\n                                            display: block;\n                                        }\n                                        .count {\n                                            display: block;\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                        .sub-menu {\n                            display: block;\n                            \n                            .menu-item {\n                                .menu-link {\n                                    padding-left: 35px;\n                                }\n                            }\n                        }\n                        .menu-item {\n                            .menu-link {\n                                .title {\n                                    display: block;\n                                }\n                            }\n                        }\n                        .menu-title {\n                            margin-top: 12px;\n                            margin-bottom: 0;\n    \n                            .menu-title-text {\n                                margin-bottom: 7px;\n                                font-size: 12px; \n                        \n                                &::before {\n                                    display: none;\n                                }\n                            }\n                        }\n                    }\n                    .logo {\n                        .logo-text {\n                            left: 33px;\n                            opacity: 1;\n                            visibility: visible;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .dark {\n        .main-wrapper-content {\n            &.active {\n                .sidebar-area {\n                    .sidebar-menu {\n                        .menu-title {\n                            .menu-title-text {\n                                &::before {\n                                    background: #555;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n// RTL\n[dir=\"rtl\"] {\n    /* Min width 1200px */\n    @media only screen and (min-width: 1200px) {\n        .main-wrapper-content {\n            &.compact-sidebar {\n                .main-content {\n                    padding-left: 25px;\n                    padding-right: 106px;\n                }\n            }\n        }\n    }\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n\n\t.sidebar-area {\n\t\ttop: 0;\n\t\tz-index: 2;\n        width: 300px !important;\n\t}\n\t.main-content {\n\t\tpadding-left: 0;\n\t\tpadding-top: 0;\n\n\t\t.inner-main-content {\n\t\t\tpadding-right: 0;\n\t\t}\n\t}\n}\n\n/* Min width 768px to Max width 991px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n\n\t.main-content {\n\t\tpadding-left: 0;\n\n\t\t.inner-main-content {\n\t\t\tpadding-right: 0;\n\t\t}\n\t}\n\n}\n\n/* Max width 1199px */\n@media only screen and (max-width: 1199px) {\n\n\t.sidebar-area {\n\t\tz-index: 2;\n\t\tleft: -350px;\n        \n        .logo {\n            border-bottom: 1px solid #ededed;\n            .logo-text {\n                left: 33px;\n            }\n        }\n        .sidebar-burger-menu {\n            right: 20px !important;\n        }\n\t}\n\n    .main-wrapper-content {\n        &.active {\n            .sidebar-area {\n                width: 270px;\n                left: 0;\n                box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;\n        \n                .logo {\n                    .logo-text {\n                        left: 33px;\n                        opacity: 1;\n                        visibility: visible;\n                    }\n                }\n                .sidebar-burger-menu {\n                    opacity: 1 !important;\n                    z-index: 1 !important;\n                    right: 20px !important;\n                }\n             \n                .sidebar-menu {\n                    padding-bottom: 150px;\n                    padding: 25px;\n                    padding-top: 20px;\n                    padding-bottom: 60px;\n        \n                    .menu-header {\n                        display: block;\n                    }\n                }\n            }\n        }\n    }\n     \n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n\n\t.main-content {\n\t\tpadding-left: 0;\n\n\t\t.inner-main-content {\n\t\t\tpadding-right: 0;\n\t\t}\n\t}\n\t\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n\n\t.sidebar-area {\n\t\twidth: 250px;\n        z-index: 2;\n\t}\n\t.sidebar-menu {\n\t\tpadding-left: 15px;\n\t\tpadding-right: 15px;\n        padding-top: 15px;\n\n        .menu-title {\n            .menu-title-text {\n                font-size: 12px;\n            }\n        }\n\t\t.menu-item {\n\t\t\t.menu-link {\n                &.menu-toggle {\n                    &::after {\n                        top: 22px;\n                    }\n                }\n\t\t\t}\n\t\t}\n\t\t.sub-menu {\n\t\t\t.menu-item {\n\t\t\t\t.menu-link {\n\t\t\t\t\tpadding-left: 35px;\n                    &::before {\n                        left: 18px;\n                    }\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Min width 1400px to Max width 1799px */\n@media only screen and (min-width: 1400px) and (max-width: 1799px) {\n\n    .sidebar-area {\n\t\twidth: 250px;\n\t}\n\t.sidebar-menu {\n\t\tpadding-left: 25px;\n\t\tpadding-right: 25px;\n        padding-top: 15px;\n\n        .menu-title {\n            .menu-title-text {\n                font-size: 12px;\n            }\n        }\n\t\t.menu-item {\n\t\t\t.menu-link {\n                &.menu-toggle {\n                    &::after {\n                        top: 22px;\n                    }\n                }\n\t\t\t}\n\t\t}\n\t\t.sub-menu {\n\t\t\t.menu-item {\n\t\t\t\t.menu-link {\n\t\t\t\t\tpadding-left: 35px;\n                    \n                    &::before {\n                        left: 18px;\n                    }\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}","/* Main Content Area Style\n============================================*/\n.main-content {\n\tpadding-left: 300px;\n\ttransition: $transition;\n\tpadding-right: 25px;\n\tmin-height: 100vh;\n\t\n\t.inner-main-content {\n\t\tpadding-right: 18px;\n\t\ttransition: all ease 0.5s;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\tmin-height: 89.5vh;\n\t}\n}\n\n@media only screen and (min-width: 1200px) {\n\t.main-wrapper-content {\n\t\t&.active {\n\t\t\t.main-content {\n\t\t\t\tpadding-left: 92px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n\n\t.main-content {\n\t\tpadding-left: 262px;\n\t\ttransition: $transition;\n\t\tpadding-right: 12px;\n\t}\n\n}\n\n/* Min width 1400px to Max width 1799px */\n@media only screen and (min-width: 1400px) and (max-width: 1799px) {\n\n\t.main-content {\n\t\tpadding-left: 275px;\n\t\ttransition: $transition;\n\t\tpadding-right: 15px;\n\t}\n\n}\n\n/* Max width 1199px */\n@media only screen and (max-width: 1199px) {\n\n\t.main-content {\n\t\tpadding-left: 12px;\n\t\tpadding-right: 12px;\n\t}\n\n}","/* Header Area Style\n============================================*/\n.header-area {\n    padding: 12px 25px;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n\n    &.sticky {\n        box-shadow: $box-shadow;\n    }\n}\n@keyframes fadeInDown {\n\t0% {\n\t  opacity: 0;\n\t  transform: translate3d(0, -100%, 0);\n\t}\n\tto {\n\t  opacity: 1;\n\t  transform: translateZ(0);\n\t}\n}\n.left-header-content {\n    ul {\n        li {\n            margin-right: 25px;\n            \n            .header-burger-menu {\n\n                .material-symbols-outlined {\n                    transition: $transition;\n                    font-size: 24px;\n                    position: relative;\n                    top: 3.5px;\n                    color: $body-color;\n\n                    &:hover {\n                        color: $primary;\n                    }\n                }\n            }\n            .src-form {\n                .form-control {\n                    height: 44px;\n                    background-color: #F6F7F9;\n                    border-color: #F6F7F9;\n                    padding: 10px 16px;\n                    border-radius: 7px;\n                    width: 260px;\n\n                    &:focus {\n                        border-color: $primary;\n                    }\n                }\n                .src-btn {\n                    right: 16px !important;\n\n                    .material-symbols-outlined {\n                        color: $primary;\n                        font-size: 20px;\n                        position: relative;\n                        top: 3px;\n                    }\n                }\n            }\n            .notifications {\n                &.dropdown {\n                    .btn-secondary {\n                        background-color: transparent;\n                        line-height: 1;\n\n                        .material-symbols-outlined {\n                            font-size: 24px;\n                            color: #fff;\n                            position: relative;\n                            top: 2px;\n                            transition: $transition;\n                        }\n \n                        &:hover {\n                            .material-symbols-outlined {\n                                color: $primary;\n                            }\n                        }\n                    }\n                    .dropdown-menu {\n                        width: 240px;\n                        border-radius: 7px;\n                        background: $white;\n                        box-shadow: 0px 4px 45px 0px rgba(0, 0, 0, 0.10);\n                        transform: translate(0px, 30px) !important;\n                        left: auto !important;\n                        right: 0 !important;\n\n                        .dropdown-item {\n                            white-space: inherit;\n                            width: 53px;\n\n                            span {\n                                font-size: 12px;\n                                margin-top: 5px;\n                                display: block;\n                                color: $dark;\n                            }\n                            &:hover {\n                                background-color: transparent;\n                            }\n                        }\n                    }\n                }\n            }\n            &:last-child {\n                margin-right: 0;\n            }\n            &.logo-box {\n                display: none;\n            }\n        }\n    }\n}\n.right-header-content {\n    .header-right-item {\n        margin-right: 25px;\n        position: relative;\n        top: 3.5px;\n\n        .light-dark {\n            .material-symbols-outlined {\n                font-size: 24px;\n                color: #FE7A36;\n                cursor: pointer;\n            }\n        }\n        .notifications {\n            &.dropdown {\n                .btn-secondary {\n                    background: transparent;\n\n                    .material-symbols-outlined {\n                        font-size: 24px;\n                        color: $body-color;\n                    }\n                    &.badge {\n                        position: relative;\n\n                        &::before {\n                            content: \"\";\n                            position: absolute;\n                            top: 3px;\n                            right: 3px;\n                            width: 7px;\n                            height: 7px;\n                            background-color: #FD5812;\n                            border-radius: 50px;\n                        }\n                    }\n                    &.dropdown-toggle {\n                        padding-right: 16px !important;\n\n                        &::after {\n                            font-family: \"remixicon\";\n                            content: \"\\ea4e\";\n                            position: absolute; \n                            top: 3px;\n                            right: -2px;\n                            margin: 0;\n                            border: 0;\n                            color: $body-color;\n                        }\n                    }\n                }\n                .dropdown-menu {\n                    width: 240px;\n                    border-radius: 7px;\n                    background: $white;\n                    box-shadow: 0px 4px 45px 0px rgba(0, 0, 0, 0.10);\n                    transform: translate(0px, 30px) !important;\n                    left: auto !important;\n                    right: 0 !important;\n\n                    .title {\n                        padding: 12px 20px;\n                        display: inline-block;\n                    }\n                    .notification-menu {\n                        padding: 0;\n                        border-top: 1px dashed #eeeeee;\n\n                        &:last-child {\n                            .dropdown-item {\n                                border-radius: 0 0 6px 6px;\n                            }\n                        }\n                        &.unseen {\n                            position: relative;\n\n                            &::before {\n                                content: \"\";\n                                position: absolute;\n                                top: 50%;\n                                transform: translateY(-50%);\n                                width: 5px;\n                                height: 5px;\n                                background-color: $primary;\n                                border-radius: 50px;\n                                right: 20px;\n                            }\n                        }\n                    }\n                    .dropdown-item {\n                        white-space: inherit;\n                        padding: 12px 20px;\n\n                        .material-symbols-outlined {\n                            width: 44px;\n                            height: 44px;\n                            line-height: 44px;\n                            background-color: #f6f5fe;\n                            text-align: center;\n                            border-radius: 50px;\n                            font-size: 22px;\n                            transition: $transition;\n                        }\n                        p {\n                            margin-bottom: 0;\n                        }\n                        &:hover, &:focus, &.active, &:focus-visible {\n                            background-color: #ebf2fa;\n                            color: $body-color;\n\n                            i, .material-symbols-outlined {\n                                background-color: $primary;\n                                color: $white !important;\n                            }\n                        }\n                        &:focus {\n                            background-color: #ebf2fa;\n                        }\n                    }\n                    .view-all {\n                        padding: 12px 20px;\n                        border-top: 1px dashed #eeeeee;\n\n                        span {\n                            position: relative;\n                            display: inline-block;\n                            padding-bottom: 1px;\n\n                            &::before {\n                                content: \"\";\n                                position: absolute;\n                                bottom: 0;\n                                left: 0;\n                                width: 100%;\n                                height: 1px;\n                                background-color: $primary;\n                                transform: scale(0);\n                                transition: $transition;\n                            }\n                        }\n                        &:hover {\n                            span {\n                                &::before {\n                                    transform: scale(1);\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n            &.noti {\n                &.dropdown {\n                    .dropdown-menu {\n                        width: 350px;\n                    }\n                    .btn-secondary {\n                        &.dropdown-toggle {\n                            padding: 0 !important;\n\n                            &::after {\n                                display: none;\n                            }\n                        }\n                    }\n                } \n            }\n        }\n        .fullscreen-btn {\n            position: relative;\n            &.active {\n                i, .material-symbols-outlined {\n                    opacity: 0;\n                }\n                &::before {\n                    content: \"\";\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    width: 24px;\n                    height: 24px;\n                    // background-image: url(/images/full-screen.png);\n                    background-position: center center;\n                    background-repeat: no-repeat;\n                    background-size: contain;\n                }\n            }\n        }\n        .admin-profile {\n            top: -3px;\n\n            h3 {\n                font-size: 14px;\n                font-weight: 600;\n                margin-bottom: 0;\n            }\n            .administrator {\n                border: 2px solid #C2CDFF;\n                display: block;\n            }\n            .dropdown-toggle {\n                padding-right: 16px !important;\n\n                &::after {\n                    font-family: \"remixicon\";\n                    content: \"\\ea4e\";\n                    position: absolute;    \n                    top: 50%;\n                    right: -2px;\n                    margin: 0;\n                    border: 0;\n                    transform: translateY(-50%);\n                    color: $body-color;\n                }\n            }\n            .dropdown-menu {\n                width: 195px;\n                border-radius: 7px;\n                background: $white;\n                box-shadow: 0px 4px 45px 0px rgba(0, 0, 0, 0.10);\n                transform: translate(0px, 55px) !important;\n                padding: 20px;\n                left: auto !important;\n                right: 0 !important;\n\n                .admin-link {\n                    border-top: 1px solid #F6F7F9;\n                    margin-top: 10px;\n                    padding-top: 10px;\n\n                    li {\n                        .dropdown-item {\n                            padding: 0;\n                            padding: 7.5px 0;\n                            position: relative;\n                            \n                            &::before {\n                                content: \"\";\n                                position: absolute;\n                                top: 0;\n                                left: -20px;\n                                width: 2px;\n                                height: 100%;\n                                background-color: $primary;\n                                transform: scaleY(0);\n                                transition: $transition;\n                            }\n                            .material-symbols-outlined {\n                                font-size: 22px;\n                                color: $secondary;\n                                transition: $transition;\n                            }\n                            span {\n                                transition: $transition;\n                            }\n                            &:hover {\n                                background-color: transparent;\n\n                                &::before {\n                                    transform: scaleY(1);\n                                }\n                                span {\n                                    color: $primary;\n                                }\n                                i, .material-symbols-outlined {\n                                    color: $primary;\n                                }\n                            }\n                            &.activeLink {\n                                color: $primary !important;\n                                background-color: transparent !important;\n\n                                span, i {\n                                    color: $primary !important;\n                                }\n                            }\n                        }\n                        &:last-child {\n                            margin-bottom: 0;\n                        }\n                    }\n                }\n            }\n        }\n        .theme-settings-btn {\n            .material-symbols-outlined {\n                animation: rotation 2s infinite linear;\n                color: $secondary;\n            }\n        }\n        @keyframes rotation {\n            from {\n              transform: rotate(0deg);\n            }\n            to {\n              transform: rotate(359deg);\n            }\n        }\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n    \n    .left-header-content {\n        ul {\n            li {\n                .src-form {\n                    .form-control {\n                        width: 100%;\n                    }\n                }\n            }\n        }\n    }\n    .right-header-content {\n        .header-right-item {\n            margin-right: 16px;\n        }\n    }\n\n}\n\n@media only screen and (max-width: 575px) {\n\n    .right-header-content {\n        .header-right-item {\n            .notifications {\n                &.noti {\n                    &.dropdown {\n                        .dropdown-menu { \n                            width: 290px;\n                            transform: translate(150px, 30px) !important;\n                        }\n                    }\n                }\n                &.language.dropdown .dropdown-menu {\n                    left: 0 !important;\n                    right: auto !important;\n                }\n            }\n        }\n    }\n\n}\n\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n\n    .right-header-content {\n        .header-right-item {\n            margin-right: 10px;\n        }\n    }\n\n}\n\n@media only screen and (min-width: 479px) and (max-width: 575px) {\n\n    .right-header-content {\n        .header-right-item {\n            .dropdown {\n                &.noti {\n                    .dropdown-menu {\n                        width: 293px;\n                        transform: translate(95px, 60px) !important;\n                    }\n                }\n            }\n        }\n    }\n    \n\n}\n\n/* Min width 768px to Max width 992px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n\n    .left-header-content {\n        ul {\n            li {\n                .src-form {\n                    .form-control {\n                        width: 100%;\n                    }\n                }\n            }\n        }\n    }\n\n}\n\n/* Max width 1199px */\n@media only screen and (max-width: 1199px) {\n\n    .header-area {\n        padding: 12px;\n    }\n    .left-header-content {\n        ul {\n            li {\n                margin-right: 15px;\n            }\n        }\n    }\n\n}","/* Footer Area Style\n============================================*/\n.footer-area {\n    padding: 25px 30px;\n}\n\n/* Max width 991px */\n@media only screen and (max-width: 991px) {\n\n    .footer-area {\n        padding: 10px 10px;\n    }\n\n}","/* Stats Box Area Style\n============================================*/\n.welcome-box {\n    .border-bottom {\n        border-color:#262626 !important;\n        padding-bottom: 40px;\n        margin-bottom: 40px;\n    }\n    &.style-two {\n        background: linear-gradient(81deg, #605DFF 3.39%, #9747FF 93.3%);\n\n        .welcome-2 {\n            position: absolute;\n            top: 0;\n            right: 0; \n        }\n        p {\n            color: #F6F7F9 !important;\n        }\n    }\n}\n.welcome-status-item {\n    i, span {\n        width: 42px;\n        height: 42px;\n        line-height: 42px;\n        text-align: center;\n        border-radius: 7px;\n        background-color: #ECF0FF;\n        color: $primary;\n        position: relative;\n        top: -3px;\n        font-size: 24px;\n\n        &.icon-bg {\n            background-color: #FFE8D4;\n            color: $danger;\n        }\n    }\n    &.style-two {\n        i, span {\n            background-color: #FFC8C0;\n            color: #EE3E08;\n\n            &.icon-bg {\n                &.two {\n                    background-color: #D8FFC8;\n                    color: #25B003;\n                }\n            }\n            \n        }\n        \n    }\n}\n.stats-box {\n    .count {\n        background-color: #FFE1DD;\n        color: $danger;\n        border: 1px solid #FFCEA9;\n        display: inline-block;\n        border-radius: 50px;\n        font-size: 12px;\n        font-weight: 500;\n        width: 52px;\n        height: 24px;\n        line-height: 24px;\n        text-align: center;\n        margin-left: 7px;\n\n        &.up {\n            background-color: #D8FFC8;\n            border-color: #82FC5A;\n            color: #1E8308;\n        }\n    }\n    .stats-list {\n        li {\n            margin-bottom: 6px;\n\n            .title {\n                position: relative;\n                padding-left: 30px;\n\n                &::before {\n                    content: \"\";\n                    position: absolute;\n                    top: 50%;\n                    transform: translateY(-50%);\n                    left: 0;\n                    width: 20px;\n                    height: 5px;\n                    background-color: $primary;\n                    border-radius: 50px;\n                }\n            }\n            &:last-child {\n                margin-bottom: 0;\n\n                .title {\n                    &::before {\n                        background-color: #C2CDFF;\n                    }\n                }\n            }\n        }\n    }\n}\n.chart-position {\n    top: -5px;\n    right: 15px;\n    max-width: 120px;\n    position: absolute;\n}\n.congratulations {\n    bottom: 12px;\n    right: 7px;\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n\n    .welcome-box {\n        .border-bottom {\n            padding-bottom: 25px;\n            margin-bottom: 25px;\n        }\n    }\n\n}\n\n/* Min width 768px to Max width 992px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n\n    .stats-box {\n        &.style-three {\n            .p-4 {\n                padding: 10px !important;\n            }\n        }\n    }\n\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px)  {\n\n    .stats-box {\n        &.style-three {\n            .p-4 {\n                padding: 10px !important;\n            }\n        }\n    }\n\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n    \n    .stats-box {\n        &.style-three {\n            .p-4 {\n                padding: 10px !important;\n            }\n        }\n    }\n    .welcome-box {\n        &.style-two {\n            .welcome-2 {\n                width: 185px;\n            }\n        }\n    }\n    \n}\n\n\n\n/* Min width 1400px to Max width 1600px */\n@media only screen and (min-width: 1400px) and (max-width: 1600px) {\n    .welcome-box {\n        &.style-two {\n            .welcome-2 {\n                width: 230px;\n            }\n        }\n    }\n}\n\n@media only screen and (max-width: 1199px) {\n    \n}","/* Sales By Locations Area Style\n============================================*/\n.sales_by_locations {\n    li {\n        margin-bottom: 21.5px;\n        position: relative;\n        padding-right: 48px;\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n        .progress {\n            overflow: unset;\n            border-radius: 50px;\n            height: 5px;\n            background-color: #ECF0FF;\n        }\n        .progress-bar {\n            border-radius: 50px;\n        }\n        .count {\n            position: absolute;\n            top: 20px;\n            right: 0;\n            font-size: 15px;\n        }\n    }\n    &.style-two {\n        li {\n            margin-bottom: 22px;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n    }\n}",".gl-tr {\n    &:first-child {\n        td {\n            padding-top: 0 !important;\n        }\n    }\n}\n\n/* Default Table Area Style\n============================================*/\n.default-table-area {\n    .table-responsive {\n        border-radius: 8px 8px 0 0 !important;\n\n        .table {\n            margin-bottom: 0;\n            border: 1px solid $body-bg;\n\n            thead {\n                tr {\n                    th {\n                        background-color: $body-bg;\n                        color: $gray-light;\n                        font-weight: 500;\n                        padding: 15px 15px;\n                        border: none;\n                        border-bottom: 1px solid $border-color;\n\n                        &:first-child {\n                            border-radius: 8px 0 0 0;\n                            padding-left: 25px !important;\n                        }\n                        &:last-child {\n                            border-radius: 0 8px 0 0;\n                            padding-right: 25px !important;\n                        }\n                    }\n                }\n            }\n            tbody {\n                tr {\n                    td {\n                        background-color: transparent;\n                        color: $secondary;\n                        border-color: $border-color;\n                        padding: 15px 15px;\n\n                        &:first-child {\n                            border-left: 1px solid $border-color;\n                            padding-left: 25px !important;\n                        }\n                        &:last-child {\n                            border-right: 1px solid $border-color;\n                            padding-right: 25px !important;\n                        }\n                        a {\n                            text-decoration: none;\n\n                            h6 {\n                                margin-bottom: 0;\n                                transition: $transition;\n                            }\n                            &:hover {\n                                h6 {\n                                    color: $primary;\n                                }\n                            }\n                        }\n                        .badge {\n                            font-size: 13px;\n                        }\n                    }\n                }\n            }\n        } \n    }\n    &.top-selling-products {\n        .table-responsive {\n            .table {\n                tbody {\n                    tr {\n                        td {\n                            padding: 18.5px 15px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.recent-orders {\n        .table-responsive {\n            .table {\n                tbody {\n                    tr {\n                        td {\n                            padding: 18.5px 15px;\n                        }\n                    }\n                }\n            }\n        }\n        &.recent-style-two {\n            .table-responsive {\n                .table {\n                    tbody {\n                        tr {\n                            td {\n                                padding: 15px 15px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.recent-leads {\n        &.style-two {\n            .table-responsive {\n                .table {\n                    tbody {\n                        tr {\n                            td {\n                                padding: 10.8px 8px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .showing-wrap {\n        border: 1px solid $border-color;\n        border-top: none;\n        padding: 13px 25px;\n        border-radius: 0 0 8px 8px;\n    }\n    &.style-two {\n        .table-responsive {\n            border-radius: 0 !important;\n            .table {\n                thead {\n                    tr {\n                        th {\n                            background-color: #ECF0FF;\n                            font-size: 14px;\n                            padding: 15px 8px;\n                            border: none !important;\n\n                            &:first-child {\n                                border-radius: 0;\n                            }\n                            &:last-child {\n                                border-radius: 0;\n                            }\n                        }\n                    }\n                }\n                tbody {\n                    tr {\n                        td {\n                            padding: 15px 8px;\n                            border-left: none;\n                            border-right: none;\n                        }\n                    }\n                }\n            }\n        }\n        .showing-wrap {\n            border: 0;\n            padding: 0;\n        }\n    }\n    &.to-do-list {\n        .table-responsive {\n            .table {\n                thead {\n                    tr {\n                        th {\n                            padding: 15px 7px;\n                        }\n                    }\n                }\n                tbody {\n                    tr {\n                        td {\n                            padding: 15px 7px;\n                        }\n                    }\n                }\n            }\n        }\n        &.padding-style {\n            .table-responsive {\n                .table {\n                    thead {\n                        tr {\n                            th {\n                                padding: 9.5px 7px;\n                            }\n                        }\n                    }\n                    tbody {\n                        tr {\n                            td {\n                                padding: 11.5px 7px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.email-list {\n        .table-responsive {\n            border: none;\n\n            .table {\n                border: none;\n\n                tbody {\n                    tr {\n                        td {\n                            border: none;\n                            border-bottom: 1px solid $border-color;\n                            &:first-child {\n                                padding-left: 0 !important;\n                            }\n                            &:last-child {\n                                padding-right: 0 !important;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        .pagination-area {\n            position: absolute;\n            top: 20px;\n            right: 20px;\n        }\n    }\n    &.recent-files {\n        .table-responsive {\n            .table {\n                tbody {\n                    tr {\n                        td {\n                            padding: 15px 5px;\n                        }\n                    }\n                }\n                thead {\n                    tr {\n                        th {\n                            padding: 15px 5px;\n                        }\n                    }\n                }\n            }\n        }\n        \n    }\n    &.deals-table {\n        .table-responsive {\n            .table {\n                tbody {\n                    tr {\n                        td {\n                            padding-top: 20px;\n                            padding-bottom: 20px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.connected-table {\n        .table-responsive {\n            .table {\n                tbody {\n                    tr {\n                        td {\n                            &.ps-0 {\n                                padding-left: 0 !important;\n                            }\n                            &.pe-0 {\n                                padding-right: 0 !important;\n                            }\n                            border: 0 !important; \n                        }\n                    }\n                }\n            }\n        }\n    }\n    /* Analytics Dashboard CSS */\n    &.browser-leads {\n        &.style-two {\n            .table-responsive {\n                .table {\n                    thead {\n                        tr {\n                            th {\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                    tbody {\n                        tr {\n                            td {\n                                padding-top: 8px;\n                                padding-bottom: 8px;\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    /* Crypto Dashboard CSS */\n    &.transaction-table {\n        &.style-two {\n            .table-responsive { \n                .table {\n                    thead {\n                        tr {\n                            th {\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                    tbody {\n                        tr {\n                            td {\n                                padding-top: 8px;\n                                padding-bottom: 8px;\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.portfolio-table {\n        &.style-two {\n            .table-responsive {\n                .table {\n                    thead {\n                        tr {\n                            border-color: #262626 !important;\n                            th {\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                    tbody {\n                        tr {\n                            td {\n                                border-color: #262626;\n                                padding-top: 11px;\n                                padding-bottom: 11px;\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.rankings-table {\n        &.style-two {\n            .table-responsive {\n                .table {\n                    thead {\n                        tr {\n                            th {\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {   \n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                    tbody {\n                        tr {\n                            td {\n                                padding-top: 11px;\n                                padding-bottom: 11px;\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    /* Sales Dashboard CSS */\n    &.sales-locations-table {\n        &.style-two {\n            .table-responsive {\n                .table {\n                    thead {\n                        tr {\n                            th {\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                    tbody {\n                        tr {\n                            td {\n                                padding-top: 11px;\n                                padding-bottom: 11px;\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    /* Hospital Dashboard CSS */\n    &.patient-table {\n        &.style-two {\n            .table-responsive {\n                .table {\n                    thead {\n                        tr {\n                            th {\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                    tbody {\n                        tr {\n                            td {\n                                padding-top: 8px;\n                                padding-bottom: 8px;\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    /* Marketing Dashboard CSS */\n    &.campaigns-table {\n        &.style-two {\n            .table-responsive {\n                .table {\n                    thead {\n                        tr {\n                            th {\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                    tbody {\n                        tr {\n                            td {\n                                padding-top: 10px;\n                                padding-bottom: 10px;\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    /* NFT Dashboard CSS */\n    &.top-nfts-table {\n        &.style-two {\n            .table-responsive {\n                .table {\n                    thead {\n                        tr {\n                            th {\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                    tbody {\n                        tr {\n                            td {\n                                padding-top: 10px;\n                                padding-bottom: 10px;\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    /* NFT Dashboard CSS */\n    &.history-of-bids {\n        &.style-two {\n            .table-responsive {\n                height: 438px;\n                .table {\n                    tbody {\n                        tr {\n                            td {\n                                padding-top: 10px;\n                                padding-bottom: 10px;\n                                &:first-child {\n                                    padding-left: 0 !important;\n                                }\n                                &:last-child {\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    /* Finance Dashboard CSS */\n    &.transaction-history {\n        &.style-two {\n            .table-responsive {\n                .table {\n                    tbody {\n                        tr {\n                            td {\n                                padding-top: 23.5px;\n                                padding-bottom: 23.5px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.transaction-history-large {\n        &.style-two {\n            .table-responsive {\n                .table {\n                    tbody {\n                        tr {\n                            td {\n                                padding-top: 23.5px;\n                                padding-bottom: 23.5px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.shipment-list {\n        &.style-two {\n            .table-responsive {\n                .table {\n                    tbody {\n                        tr {\n                            td {\n                                padding-top: 19px;\n                                padding-bottom: 19px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.style-three {\n        .table-responsive {\n            .table {\n                thead {\n                    tr {\n                        th {\n                            font-size: 14px;\n                            color: $body-color;\n                            &:first-child {\n                                padding-left: 30px !important;\n                            }\n                            &:last-child {\n                                padding-right: 30px;\n                            }\n                        }\n                    }\n                }\n                tbody {\n                    tr {\n                        td {\n                            padding-top: 10px;\n                            padding-bottom: 10px;\n                            border-left: none;\n                            border-right: none;\n                            &:first-child {\n                                padding-left: 30px !important;\n                            }\n                            &:last-child {\n                                padding-right: 30px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.agents-performance-overview {\n        &.style-three {\n            .table-responsive {\n                border-radius: 0 !important;\n                .table {\n                    border-spacing: 10px;\n                    tbody {\n                        tr {\n                            td {\n                                padding: 10px !important;\n                                border-left: none;\n                                border-right: none;\n                                border-bottom: none;\n                                border-top: 10px solid #fff;\n                                background-color: #F6F7F9;\n                                border-radius: 0 !important;  \n\n                                &:first-child {\n                                    border-radius: 10px 0 0 10px !important;\n                                }\n                                &:last-child {\n                                    border-radius: 0 10px 10px 0 !important;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.for-data-table {\n        .tablesorter-header {\n            background-color: transparent !important;\n            position: relative;\n            &::after {\n                content: \"\\f326\";\n                font-family: remixicon!important;\n                margin-left: 4px;\n            }\n        }\n        .Selc {\n            display: none;\n        }\n    }\n}\n\n.table-src-form {\n    margin-right: 20px;\n\n    i, .material-symbols-outlined {\n        left: 15px !important;\n        font-size: 20px;\n    }\n    .form-control {\n        padding-left: 40px;\n        background-color: #F6F7F9;\n        height: 36px;\n        width: 240px;\n        padding-top: 5px;\n        padding-bottom: 5px;\n    }\n}\n \n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n\n    .default-table-area {\n        &.to-do-list {\n            .table {\n                width: 738.66px;\n            }\n        }\n        &.recent-files {\n            .table {\n                width: 819px;\n            }\n        }\n        &.manage-reviews-table {\n            .table {\n                width: 1100px;\n            }\n        }\n        &.latest-transaction {\n            .table {\n                width: 967px;\n            }\n        }\n        &.transaction-history {\n            &.tracking-order {\n                &.style-two {\n                    .table-responsive {\n                        .table {\n                            width: 742px;\n                        } \n                    }\n                } \n            }\n        }\n        &.style-three {\n            .table-responsive {\n                .table {\n                    thead {\n                        tr {\n                            th {\n                                &:first-child {\n                                    padding-left: 15px !important;\n                                }\n                                &:last-child {\n                                    padding-right: 15px !important;\n                                }\n                            }\n                        }\n                    }\n                    tbody {\n                        tr {\n                            td {\n                                &:first-child {\n                                    padding-left: 15px !important;\n                                }\n                                &:last-child {\n                                    padding-right: 15px !important;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        /* Analytics Dashboard CSS */\n        &.browser-leads {\n            &.style-two {\n                .table-responsive {\n                    .table {\n                        &.for-mobile-width {\n                            width: 715px !important;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .ec-recent-orders {\n        .table {\n            width: 960px;\n        }\n    }\n    \n    // analytics-bu-by-users \n    .analytics-bu-by-users {\n        width: 715px;\n    }\n    .analytics-tbpt-table {\n        width: 715px;\n    }\n    .crypto-th-table {\n        width: 715px;\n    }\n    .crypto-cr-table {\n        width: 900px;\n    }\n    .patient-table {\n        .table {\n            width: 730px;\n        }\n    }\n    .default-table-area {\n        &.email-list {\n            .pagination-area {\n                position: initial;\n                margin-top: 15px;\n            }\n        }\n    }\n}\n\n/* Max width 490px */\n@media only screen and (max-width: 490px) {\n\n    /* Analytics Dashboard CSS */\n    .default-table-area {\n        &.top-nfts-table {\n            &.style-two {\n                .table-responsive {\n                    .table {\n                        width: 436px !important;\n                    }\n                }\n            }\n        }\n        &.agents-performance-overview {\n            &.style-three {\n                .table-responsive {\n                    .table {\n                        width: 480px;\n                    }\n                }\n            }\n        }\n    }\n\n}\n\n@media only screen and (max-width: 380px) {\n\n    .default-table-area {\n        &.team-members {\n            .table {\n                width: 357.33px;\n            }\n        }\n\n        /* Crypto Dashboard CSS */\n        &.portfolio-table {\n            &.style-two {\n                .table-responsive {\n                    .table {\n                        width: 357.33px;\n                    }\n                }\n            }\n        }\n    }\n \n}\n\n@media only screen and (max-width: 576px) {\n\n    .default-table-area {\n        &.top-selling-products {\n            .table {\n                width: 595.33px;\n            }\n        }\n        &.recent-orders {\n            .table {\n                width: 690px;\n            }\n        }\n        &.my-tasks {\n            .table {\n                width: 547px;\n            }\n        }\n        &.to-do-list {\n            .table {\n                width: 738.66px;\n            }\n        }\n        &.top-instructors {\n            .table {\n                width: 551.5px;\n            }\n        }\n        &.recent-customer-ratings {\n            .table {\n                width: 551.5px;\n            }\n        }\n        &.speaker-table {\n            .table {\n                width: 525px;\n            }\n        }\n        &.connected-table  {\n            .table {\n                width: 522px;\n            }\n        }\n    }\n    .table-src-form {\n        margin-right: 10px;\n        .form-control {\n            width: 140px;\n        }\n    }\n    \n}\n\n/* Max width 650px */\n@media only screen and (max-width: 650px) {\n\n    /* Analytics Dashboard CSS */\n    .default-table-area {\n        /* Marketing Dashboard CSS */\n        &.campaigns-table {\n            &.style-two {\n                .table-responsive {\n                    .table {\n                        width: 670px !important;\n                    }\n                }\n            }\n        }\n        &.employee-leave-request {\n            &.style-three {\n                .table-responsive {\n                    .table {\n                        width: 626px !important;\n                    }\n                }\n            }\n        }\n    }\n    \n}\n\n@media only screen and (max-width: 685px) {\n\n    .default-table-area {\n        &.recent-orders {\n            .table {\n                width: 690px;\n            }\n        }\n        &.recent-leads {\n            .table {\n                width: 690px;\n            }\n        }\n        &.email-list {\n            .table {\n                width: 680px;\n            }\n        }\n    }\n\n}\n\n/* Max width 1340px */\n@media only screen and (max-width: 1340px) {\n\n    /* Crypto Dashboard CSS */\n    .default-table-area {\n        &.patient-table {\n            &.style-two {\n                .table-responsive {\n                    .table {\n                        width: 927px !important;\n                    }\n                }\n            }\n        }\n        &.shipment-list {\n            &.style-two {\n                .table-responsive {\n                    .table {\n                       width: 1003px;\n                    }\n                }\n            }\n        }\n        &.employee-list {\n            &.style-three {\n                .table-responsive {\n                    .table {\n                       width: 1042px;\n                    }\n                }\n            }\n        }\n    }\n    \n}\n\n/* Min width 768px to Max width 992px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n\n    .default-table-area {\n        &.email-list {\n            .table {\n                width: 680px;\n            }\n        }\n        &.recent-files {\n            .table {\n                width: 819px;\n            }\n        }\n        &.manage-reviews-table {\n            .table {\n                width: 1100px;\n            }\n        }\n        &.latest-transaction {\n            .table {\n                width: 967px;\n            }\n        }\n        &.style-three {\n            .table-responsive {\n                .table {\n                    thead {\n                        tr {\n                            th {\n                                &:first-child {\n                                    padding-left: 15px !important;\n                                }\n                                &:last-child {\n                                    padding-right: 15px !important;\n                                }\n                            }\n                        }\n                    }\n                    tbody {\n                        tr {\n                            td {\n                                &:first-child {\n                                    padding-left: 15px !important;\n                                }\n                                &:last-child {\n                                    padding-right: 15px !important;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .ec-recent-orders {\n        .table {\n            width: 1050px;\n        }\n    }\n\n    .crypto-cr-table {\n        width: 930px;\n    }\n}\n\n@media only screen and (max-width: 685px) {\n\n    .default-table-area {\n        &.recent-orders {\n            .table {\n                width: 690px;\n            }\n        }\n        &.recent-leads {\n            .table {\n                width: 690px;\n            }\n        }\n        &.email-list {\n            .table {\n                width: 680px;\n            }\n        }\n        /* Finance Dashboard CSS */\n        &.transaction-history {\n            &.style-two {\n                .table-responsive {\n                    .table {\n                        width: 685px;\n                    } \n                }\n            }\n        }\n        &.recent-calls {\n            &.style-three {\n                .table-responsive {\n                    .table {\n                        width: 710px;\n                    } \n                }\n            }\n        }\n    }\n\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px)  {\n\n    .default-table-area {\n        &.recent-leads {\n            .table {\n                width: 690px;\n            }\n        }\n        &.recent-customer-ratings {\n            .table {\n                width: 551.5px;\n            }\n        }\n        &.recent-files {\n            .table {\n                width: 819px;\n            }\n        }\n        &.manage-reviews-table {\n            .table {\n                width: 1100px;\n            }\n        }\n        &.speaker-table {\n            .table {\n                width: 525px;\n            }\n        }\n    }\n\n    .patient-table {\n        .table {\n            width: 730px;\n        }\n    }\n\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n\n    .default-table-area {\n        &.top-selling-products {\n            .table {\n                width: 620px;\n            }\n        }\n        &.recent-orders {\n            .table {\n                width: 719px;\n            }\n        }\n        &.recent-leads {\n            .table {\n                width: 690px;\n            }\n        }\n        // &.to-do-list {\n        //     .table {\n        //         width: 738.66px;\n        //     }\n        // }\n        &.recent-customer-ratings {\n            .table {\n                width: 551.5px;\n            }\n        }\n        &.email-list {\n            .table {\n                width: 680px;\n            }\n        }\n        &.recent-files {\n            .table {\n                width: 819px;\n            }\n        }\n        &.manage-reviews-table {\n            .table {\n                width: 1100px;\n            }\n        }\n        &.speaker-table {\n            .table {\n                width: 525px;\n            }\n        }\n    }\n\n    .patient-table {\n        .table {\n            width: 730px;\n        }\n    }\n}\n\n/* Min width 1400px to Max width 1500px */\n@media only screen and (min-width: 1400px) and (max-width: 1550px) {\n\n    .crypto-th-table {\n        width: 715px;\n    }\n    \n    \n}\n\n@media only screen and (max-width: 1399px) {\n\n    .default-table-area {\n        &.all-projects {\n            .table {\n                width: 1120px;\n            }\n        }\n        &.default-table-width {\n            .table {\n                width: 1120px;\n            }\n        }\n        &.all-products {\n            .table {\n                width: 1300px;\n            }\n            #myTable {\n                width: 1300px !important;\n            }\n        }\n    }\n    \n\n}\n\n@media only screen and (max-width: 1550px) {\n\n    .default-table-area {\n        &.campaigns-table {\n            &.latest-transaction-table {\n                .table-responsive {\n                    .table {\n                        width: 927px !important;\n                    }\n                }\n            }\n        }\n        &.real-estate-customers {\n            &.style-two {\n                .table-responsive {\n                    .table  {\n                        width: 1252px;\n                    }\n                }\n            }\n        }\n\n        &.all-products {\n            .table {\n                width: 1300px;\n            }\n            #myTable {\n                width: 1300px !important;\n            }\n        }\n        &.all-carts {\n            .table {\n                width: 926px;\n            }\n        }\n    }\n\n}\n\n","/* Pagination Area Style\n============================================*/\n.pagination {\n    .page-item {\n        margin-right: 7px;\n\n        .page-link {\n            padding: 6px 12px;\n            border-radius: 4px;\n            border: 1px solid $border-color;\n            background: $white;\n            transition: $transition;\n            font-weight: 500;\n            color: $body-color;\n\n            &:focus {\n                box-shadow: none;\n            }\n            &.icon {\n                padding: 0;\n\n                i, span {\n                    width: 31px;\n                    height: 31px;\n                    line-height: 33px;\n                    text-align: center;\n                    font-size: 22px;\n                }\n            }\n            &.active {\n                background-color: $primary;\n                color: $white;\n                z-index: 0 !important;\n            }\n            &:hover {\n                background-color: $primary;\n                color: $white;\n\n                i, span {\n                    color: $white;  \n                }\n            }\n   \n            // &:disabled,\n            // &[disabled]{ \n            //     background-color: #cccccc; \n            // }\n        }\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n}","/* Calendar Style\n============================================*/\n.fc-theme-standard  {\n    .fc-scrollgrid {\n        border: 1px solid #ECF0FF;\n    }\n    th {\n        background-color: #ECF0FF;\n        font-size: 14px;\n        font-weight: 500; \n    }\n    tr {\n        th, td {\n            border: 1px solid #ECF0FF;\n        }\n    }\n    a {\n        text-decoration: none;\n    }\n}\n.fc {\n    .fc-toolbar-title {\n        font-size: 18px;\n        font-weight: 700;\n    }\n    .fc-button-primary {\n        text-transform: capitalize;\n    }\n    .fc-col-header-cell-cushion { \n        padding: 8px 4px;\n        color: black;\n    }\n    .fc-daygrid-day-number {\n        padding: 20px;  \n    }\n}\n\n\n/* Calendar Area Style\n============================================*/\n.react-calendar {\n    width: 100%;\n    border: none;\n    font-family: $body-font-family;\n\n    .react-calendar__navigation {\n        align-items: center;\n        height: auto;\n\n        button {\n            .react-calendar__navigation__label__labelText {\n                font-weight: 600;\n                font-size: 13px;\n            }\n        }\n        .react-calendar__navigation__prev2-button, .react-calendar__navigation__next2-button {\n            display: none;\n        }\n        .react-calendar__navigation__prev-button, .react-calendar__navigation__next-button {\n            background-color: #f5f5f5;\n            width: 20px;\n            height: 20px;\n            min-width: auto;\n            border-radius: 100%;\n        } \n    }\n    .react-calendar__month-view__weekdays {\n        .react-calendar__month-view__weekdays__weekday {\n            text-transform: capitalize;\n            color: #3A4252;\n            font-size: 12px;\n        }\n    } \n    .react-calendar__month-view__days__day--weekend {\n        color: #FD5812 !important;\n    }\n    .react-calendar__month-view__days {\n        .react-calendar__month-view__days__day--neighboringMonth {\n            opacity: .5;\n        }\n        .react-calendar__tile {\n            color: #3A4252;\n            font-size: 14px;\n      \n            &.react-calendar__tile--active {\n                background-color: transparent;\n           \n                abbr {\n                    background-color: $primary;\n                    color: #fff !important;\n                    border-radius: 100%;\n                    padding: 0;\n                    width: 30px;\n                    height: 30px;\n                    display: inline-block;\n                    line-height: 30px;\n                }\n            }\n        }\n    }\n}\n \n\n.dark {\n    .react-calendar {\n        .react-calendar__navigation {\n            .react-calendar__navigation__prev-button, .react-calendar__navigation__next-button {\n                background-color: $dark-body-bg;\n            } \n        }\n        .react-calendar__month-view__weekdays {\n            .react-calendar__month-view__weekdays__weekday {\n                color: #fff;\n            }\n        } \n        .react-calendar__month-view__days {\n            .react-calendar__tile {\n                color: #3A4252;\n            }\n        }\n    }\n    .fc-theme-standard {\n        th {\n            background-color: #212121;\n            color: #fff;\n        }\n        .fc-scrollgrid {\n            border: 1px solid #172036;\n        }\n        tr {\n            th, td {\n                border: 1px solid #172036;\n            }\n        }\n    }\n    .fc {\n        .fc-col-header-cell-cushion { \n            color: #fff;\n        }\n        .fc-daygrid-day-number {\n            color: #fff;\n        }\n    }\n    .mantine-1qycoz3 {\n        border: 1px solid $dark-input-bg;\n        background-color: $dark-input-bg;\n        color: #fff;\n    }\n}","/* Chat Area Style\n============================================*/\n.status-position {\n    top: 2px;\n    right: -5px;\n}\n.status-position2 {\n    bottom: 4px;\n    right: -2px;\n}\n.chat-tabs {\n    justify-content: space-between;\n    margin-bottom: 1.5rem !important;\n\n    .nav-item {\n        .nav-link {\n            position: relative;\n            border: none;\n            padding: 0 0 10px;\n            font-weight: 500;\n            color: $body-color;\n\n            &::before {\n                content: '';\n                position: absolute;\n                bottom: 0;\n                right: 0;\n                width: 0;\n                height: 2px;\n                background-color: $primary;\n                transition: $transition;\n            }\n            &.active, &:hover {\n                color: $primary !important;\n                background-color: transparent;\n                \n                &::before {\n                    width: 100%;\n                    right: auto;\n                    left: 0;\n                }\n            }\n        }\n    }\n}\n.chat-details {\n    li {\n        max-width: 800px;\n        p {\n            border-radius: 0px 15px 15px 15px;\n            background-color: #F5F6FA;\n            margin-bottom: 0;\n            padding: 15px 20px;\n            margin-bottom: 5px;\n            display: inline-block;\n        }\n        .dropdown {\n            &.action-opt {\n                opacity: 0;\n                transition: $transition;\n            }\n        }\n        &.own-chat {\n            p {\n                border-radius: 15px 0 15px 15px;\n                background-color: $primary;\n                color: $white;\n            }\n        }\n        &:hover {\n            .dropdown {\n                &.action-opt {\n                    opacity: 1;\n                }\n            }\n        }\n    }\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n    \n    .chat-details {\n        li {\n            p {\n                padding: 10px;\n            }\n        }\n    }\n\n}\n\n/* Min width 768px to Max width 992px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n\n    \n    .chat-details {\n        li {\n            p {\n                padding: 10px;\n            }\n        }\n    }\n\n}\n\n/* Min width 1400px to Max width 1799px */\n@media only screen and (min-width: 1400px) and (max-width: 1799px) {\n\n    \n\n}","/* Terminals Area Style\n============================================*/\n.timeline-wrap {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    margin: 15px;\n    &::before {\n        content: \"\";\n        display: block;\n        position: absolute;\n        left: 50%;\n        transform: translatex(-50%);\n        border: 1px dashed $primary;\n        height: calc(100% / 5 * 4);\n    }\n    .timeline-item-2 {\n        display: flex;\n        .text {\n            flex: 1 1 calc(50% - 50px);\n            position: relative;\n            background-color: #ECF0FF;\n        }\n        .icon {\n            flex: 1 1 100px;\n            div {\n                width: 25px;\n                height: 25px;\n                border-radius: 50%;\n                margin: auto;\n                background: $primary;\n                box-shadow: $box-shadow;\n                position: relative;\n                z-index: 1;\n            }\n            &.two {\n                div {\n                    background: $success;\n                }\n            }\n            &.three {\n                div {\n                    background: $primary-div;\n                }\n            }\n            &.four {\n                div {\n                    background: $danger;\n                }\n            }\n        }\n        .time {\n            flex: 1 1 calc(50% - 50px);\n            time {\n                font-size: 12px; \n                background-color: $primary;\n                color: $white;\n                display: inline-block;\n                padding: 9px 15px;\n                border-radius: 7px;\n                position: relative;\n                &::before {\n                    content: \"\";\n                    position: absolute;\n                    top: 10px;\n                    left: -6px;\n                    width: 15px;\n                    height: 15px;\n                    background-color: $primary;\n                    transform: rotate(45deg);\n                    border-radius: 2px;\n                }\n            }\n        }\n        &:nth-child(even) {\n            flex-direction: row-reverse;\n            .time {\n                time {\n                    &::before {\n                        left: auto;\n                        right: -6px;\n                    }\n                }\n            }\n        }\n        &:nth-child(even) > div:last-child {\n            text-align: end;\n        }\n    }\n}\n.timeline-item {\n    position: relative;\n    padding-left: 90px;\n    .time-line-date {\n        position: absolute;\n        top: -5px;\n        left: 0;\n    }\n    .border-style-for-timeline {\n        border-left: 1px dashed #D5D9E2;\n        padding-left: 30px;\n        position: relative;\n        padding-bottom: 30px;\n        &::before {\n            content: \"\";\n            position: absolute;\n            top: 0;\n            left: -6px;\n            width: 12px;\n            height: 12px;\n            background-color: #37D80A;\n            border-radius: 50px;\n        }\n        &.dot-2 {\n            &::before {\n                background-color: #FD5812;\n            }\n        }\n        &.dot-3 {\n            &::before {\n                background-color: #AD63F6;\n            }\n        }\n        &.dot-4 {\n            &::before {\n                background-color: #3584FC;\n            }\n        }\n    }\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n\n    .timeline-wrap {\n        margin: 0;\n        &::before {\n            display: none;\n        }\n        .timeline-item-2 {\n            flex-flow: column wrap;\n            height: auto;\n            &:nth-child(even) {\n                flex-direction: column;\n            }\n            &:nth-child(even) > .time:last-child {\n                text-align: start;\n            }\n            &:nth-child(odd) {\n                h3 {\n                    &::after {\n                        border: none;\n                    }\n                }\n            }\n            .icon {\n                order: 1;\n                flex: 1 1 100%;\n                width: 100px;\n                div {\n                    display: none !important;\n                }\n            }\n            .time {\n                order: 2;\n                flex: 1 1 50px;\n                width: calc(100% - 90px);\n            }\n            .text {\n                order: 3;\n                flex: 1 1 calc(100% - 50px);\n                width: calc(100% - -1px);\n            }\n        }\n    }\n\n}","/* Priceing Area Style\n============================================*/\n.priceing-border {\n    position: relative;\n    &::before {\n        content: \"\";\n        position: absolute;\n        bottom: 0;\n        left: -130px;\n        width: 1px;\n        height: 100%;\n        border-left: 1px dashed $border-color;\n    }\n    &.style-two {\n        &::before {\n            left: 0 !important;\n        }\n    }\n}\n.popular-tag {\n    top: 25px;\n    left: 227px;\n    transform: rotate(-15deg);\n}\n.populartsgs {\n    top: 20px;\n    right: 20px;\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px)  {\n\n    .priceing-border {\n        &::before {\n            left: -51px;\n        }\n    }\n    .popular-tag {\n        left: 144px;\n    }\n\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n\n    .priceing-border {\n        &::before {\n            left: -51px;\n        }\n    }\n    .popular-tag {\n        left: 130px;\n    }\n\n}\n\n/* Min width 1400px to Max width 1799px */\n@media only screen and (min-width: 1400px) and (max-width: 1799px) {\n\n    .priceing-border {\n        &::before {\n            left: -68px;\n        }\n    }\n    .popular-tag {\n        left: 160px;\n    }\n\n}\n\n@media only screen and (max-width: 991px) {\n\n    .priceing-border {\n        &::before {\n            display: none;\n        }\n    }\n    .popular-tag {\n        left: auto;\n        right: 25px;\n        top: 25px;\n    }\n\n}","/* Products Area Style\n============================================*/\n.product-image {\n\n    .react-tabs__tab-panel {\n        background-color: #f6f7f9;\n        padding: 3rem !important;\n        border-radius: 7px;\n        text-align: center;\n    }\n    .react-tabs__tab-list {\n        margin: 0;\n        padding: 0;\n        display: flex;\n        justify-content: center;\n        border: none;\n        gap: 15px;\n\n        .react-tabs__tab {\n            margin: 10px 0 0;\n            background-color: #f6f7f9;\n            border-radius: 7px;\n            text-align: center;\n            padding: 15px;\n            border: 1px solid #f6f7f9 !important;\n\n            &.react-tabs__tab--selected {\n                border: 1px solid $warning !important;\n            }\n        }\n    }\n}\n.select-style {\n    .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active {\n        border-color: $warning !important;\n    }\n}\n.select-color {\n    li {\n        width: 30px;\n        height: 30px;\n        border: 1px solid $white;\n        cursor: pointer;\n        &.color1 {\n            background-color: #ECEEF2;\n            border-radius: 50px;\n            &.active {\n                border-color: $warning;\n            }\n        }\n        &.color2 {\n            background-color: #D5D9E2;\n            border-radius: 50px;\n        }\n        &:hover {\n            border-color: $warning;\n        }\n    }\n}\n.add-to-cart-counter {\n\tdisplay: flex;\n\tinput {\n\t\tbackground-color: #ECF0FF;\n\t\tcolor: $body-color;\n\t\tborder: 1px solid #ECF0FF;\n\t\tmax-width: 50px;\n\t\ttext-align: center;\n\t\tfont-size: 16px;\n        border: 0;\n        &:focus {\n            box-shadow: none;\n            border: none;\n            outline: none;\n        }\n\t}\n\t.minusBtn, .plusBtn {\n\t\tborder-right: 1px solid #ECF0FF;\n\t\twidth: 35px;\n\t\theight: 42px;\n\t\tline-height: 31.9px;\n\t\tbackground-color: #ECF0FF;\n\t\tborder-radius: 0 7px 7px 0 !important;\n\t}\n    .minusBtn {\n        border-radius: 7px 0 0 7px !important;\n    }\n}\n.review-tabs {\n    margin-bottom: 1px;\n\n    .nav-item {\n        .nav-link {\n\n            color: $body-color;\n            border-top: none;\n            border-left: none;\n            border-right: none;\n            border-bottom: 2px solid $body-bg !important;\n            padding: 11px 30px;\n\n            &.active {\n               background-color: $white;\n               border-color: $primary !important;\n            }\n        }\n    }\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n\n}\n\n/* Min width 768px to Max width 992px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px)  {\n\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n\n}\n\n/* Min width 1400px to Max width 1799px */\n@media only screen and (min-width: 1400px) and (max-width: 1799px) {\n\n}\n\n@media only screen and (max-width: 1199px) {\n\n}","/* RTL Area Style\n============================================*/\n[dir=\"rtl\"] {\n    text-align: right;\n\n    .ms-1 {\n        margin-left: 0 !important;\n        margin-right: 0.25rem !important;\n    }\n    .ms-2 {\n        margin-left: 0 !important;\n        margin-right: 0.5rem !important;\n    }\n    .ms-3 {\n        margin-left: 0 !important;\n        margin-right: 1rem !important;\n    }\n    .ms-4 {\n        margin-left: 0 !important;\n        margin-right: 1.5rem !important;\n    }\n    .ms-5 {\n        margin-left: 0 !important;\n        margin-right: 3rem !important;\n    }\n    .me-1 {\n        margin-right: 0 !important;\n        margin-left: 0.25rem !important;\n    }\n    .me-2 {\n        margin-right: 0 !important;\n        margin-left: 0.5rem !important;\n    }\n    .me-3 {\n        margin-right: 0 !important;\n        margin-left: 1rem !important;\n    }\n    .me-4 {\n        margin-right: 0 !important;\n        margin-left: 1.5rem !important;\n    }\n    .me-5 {\n        margin-right: 0 !important;\n        margin-left: 3rem !important;\n    }\n    .ms-m-20 {\n        margin-left: 0;\n        margin-right: -20px;\n    }\n    .ms-m-15 {\n        margin-left: 0;\n        margin-right: -15px;\n    }\n    .ms-xxl-3 {\n        margin-left: 0 !important;\n        margin-right: 1rem !important;\n    }\n    .ps-1 {\n        padding-left: 0 !important;\n        padding-right: 0.25rem !important;\n    }\n    .ps-2 {\n        padding-left: 0 !important;\n        padding-right: 0.5rem !important;\n    }\n    .ps-3 {\n        padding-left: 0 !important;\n        padding-right: 1rem !important;\n    }\n    .ps-4 {\n        padding-left: 0 !important;\n        padding-right: 1.5rem !important;\n    }\n    .ps-5 {\n        padding-left: 0 !important;\n        padding-right: 3rem !important;\n    }\n    .pe-1 {\n        padding-right: 0 !important;\n        padding-left: 0.25rem !important;\n    }\n    .pe-2 {\n        padding-right: 0 !important;\n        padding-left: 0.5rem !important;\n    }\n    .pe-3 {\n        padding-right: 0 !important;\n        padding-left: 1rem !important;\n    }\n    .pe-4 {\n        padding-right: 0 !important;\n        padding-left: 1.5rem !important;\n    }\n    .pe-5 {\n        padding-right: 0 !important;\n        padding-left: 3rem !important;\n    }\n    .ps-0 {\n        padding-left: 0 !important;\n        padding-right: 0 !important;\n    }\n    .ps-xxl-4 {\n        padding-left: 0 !important;\n        padding-right: 1.5rem !important;\n    }\n    .text-start {\n        text-align: right !important;\n    }\n    .text-end {\n        text-align: left !important;\n    }\n    .text-sm-end {\n        text-align: left !important;\n    }\n    .main-content {\n        padding-left: 25px;\n        padding-right: 295px;\n    }\n\n    @media only screen and (min-width: 1200px) {\n        .main-wrapper-content.active {\n            .main-content {\n                padding-left: 25px;\n                padding-right: 105px;\n            }\n        }\n    }\n \n    .sidebar-area {\n        left: auto;\n        right: 0;\n\n        .logo {\n            .logo-text {\n                left: auto;\n                right: 33px;\n            }\n        }\n    }\n    .sidebar-menu {\n        .accordion {\n            .accordion-item {\n                .accordion-header {\n                    .accordion-button {\n                        i, span {\n                            margin-right: 0;\n                            margin-left: 7px;\n                        }\n                        .count {\n                            right: auto;\n                            left: 42px;\n                        }\n                    }\n                }\n            }\n        }\n        .menu-item {\n            .menu-link {\n                i, span {\n                    margin-right: 0;\n                    margin-left: 8px;\n                }\n                .tag {\n                    margin-left: 0;\n                    margin-right: 12px;\n                }\n            }\n        }\n        .sub-menu {\n            .menu-item {\n                .menu-link {\n                    padding-left: 0;\n                    padding-right: 35px;\n\n                    &:before {\n                        left: auto;\n                        right: 18px;\n                    }\n                }\n            }\n        }\n    }\n \n    .menu-vertical {\n        .menu-item {\n            .menu-link {\n                .count {\n                    right: auto;\n                    left: 42px;\n                }\n                .menu-icon {\n                    margin-right: 0;\n                    margin-left: 4px;\n                }\n                &.menu-toggle {\n                    &::after {\n                        right: auto;\n                        left: 25px;\n                        transform: translateY(-50%) rotate(225deg);\n                    }\n                }\n            }\n            &.open:not(.menu-item-closing)>.menu-toggle::after {\n                transform: translateY(-50%) rotate(135deg);\n            }\n        }\n        .menu-sub {\n            .menu-item {\n                .menu-link {\n                    padding-left: 0;\n                    padding-right: 35px;\n                    &::before {\n                        left: auto;\n                        right: 18px;\n                    }\n                    .tag {\n                        margin-left: 0;\n                        margin-right: 12px;\n                        &::before {\n                            left: auto;\n                            right: -3px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .right-header-content {\n        .header-right-item {\n            margin-right: 0;\n            margin-left: 25px;\n\n            .notifications {\n                &.dropdown {\n                    .dropdown-menu {\n                        left: 0 !important;\n                        right: auto !important;\n                    \n                        .notification-menu {\n                            text-align: right;\n\n                            &.unseen::before {\n                                right: auto;\n                                left: 20px;\n                            }\n                        }\n                        .title {\n                            display: block;\n                            text-align: right;\n                        }\n                    }\n                }\n               \n            }\n            &:last-child {\n                margin-left: 0;\n            }\n            .admin-profile {\n                .dropdown-menu {\n                    left: 0 !important;\n                    right: auto !important;\n                }\n                .dropdown-toggle {\n                    padding-right: 0 !important;\n                    padding-left: 16px !important;\n\n                    &::after {\n                        right: auto;\n                        left: -4px !important;\n                    }\n                }\n                .info {\n                    text-align: right;\n                }\n            }\n        }\n        \n    }\n    .offcanvas-header {\n        .btn-close {\n            margin-right: auto;\n            margin-left: 0;\n        }\n    }\n    .left-header-content {\n        ul {\n            li {\n                margin-right: 0;\n                margin-left: 25px;\n                &:last-child {\n                    margin-left: 0;\n                }\n                .src-form {\n                    .src-btn {\n                        right: auto !important;\n                        left: 20px !important;\n                    }\n                }\n            }\n        }\n    }\n\n    @media only screen and (min-width: 1200px) {\n        .main-wrapper-content.active .sidebar-area:hover .sidebar-burger-menu {\n            right: auto !important;\n            left: 21px !important;\n        }\n    }\n\n    .stats-box {\n        .count {\n            margin-left: 0;\n            margin-right: 7px;\n        }\n    }\n    .apexcharts-legend.apexcharts-align-left.apx-legend-position-top {\n        right: auto !important;\n        left: 0 !important;\n    }\n    .sales_by_locations {\n        li {\n            padding-right: 0;\n            padding-left: 48px;\n        }\n    }\n    .table-src-form {\n        margin-right: 0;\n        margin-left: 20px;\n\n        i, span {\n            left: auto !important;\n            right: 15px !important;\n        }\n        .form-control {\n            padding-left: 0;\n            padding-right: 40px;\n        }\n    }\n    .chart-position {\n        right: auto;\n        left: 15px;\n    }\n    .default-table-area {\n        .table-responsive {\n            .table {\n                thead {\n                    tr {\n                        th {\n                            &:last-child {\n                                padding-right: 8px !important;\n                                padding-left: 25px !important;\n                            }\n                            &:first-child {\n                                padding-left: 8px !important;\n                                padding-right: 25px !important;\n                            }\n                        }\n                    }\n                }\n                tbody {\n                    tr {\n                        td {\n                            &:last-child {\n                                padding-right: 8px !important;\n                                padding-left: 25px !important;\n                            }\n                            &:first-child {\n                                padding-left: 8px !important;\n                                padding-right: 25px !important;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        &.email-list {\n            .table-responsive {\n                .table {\n                    tbody {\n                        tr {\n                            td {\n                                &:last-child {\n                                    padding-right: 8px !important;\n                                    padding-left: 0 !important;\n                                }\n                                &:first-child {\n                                    padding-left: 8px !important;\n                                    padding-right: 0 !important;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n            .pagination-area { \n                right: auto;\n                left: 20px;\n            }\n        }\n    }\n    .welcome-box {\n        &.style-two {\n            .welcome-2 {\n                right: auto;\n                left: 0;\n            }\n        }\n    }\n    #projects_roadmap {\n        direction: ltr;\n    }\n    #student_interested_topics {\n        direction: ltr;\n    }\n    .courses-slide {\n        direction: ltr;\n        .flex-grow-1.ms-3 {\n            margin-right: 0;\n            margin-left: 15px !important;\n        }\n        .swiper-pagination2 {\n            left: auto !important;\n            right: 25px !important;\n            text-align: right;\n        }\n    }\n    .row.mb-4 {\n        .col-lg-8.col-sm-8.pe-sm-0 {\n            padding-right: 12px !important;\n        }\n        .col-lg-4.col-sm-4.ps-sm-0 {\n            padding-left: 12px !important;\n        }\n        .rounded-3 {\n            border-radius: 8px !important;\n        }\n    }\n    .month-select {\n        background-position: left 16px center !important;\n        &.p-0 {\n            background-position: left 0 center !important;\n        }\n    }\n    .congratulations {\n        right: auto;\n        left: 0;\n    }\n    .upcoming-events-slide {\n        .ms-1 {\n            margin-right: 0 !important;\n            margin-left: 0.25rem !important;\n        }\n    }\n    .popular-tag {\n        left: auto;\n        right: 227px;\n    }\n    .populartsgs {\n        right: auto;\n        left: 20px;\n    }\n    .priceing-border {\n        &::before {\n            left: auto;\n            right: -130px;\n        }\n        &.style-two {\n            &::before {\n                right: auto;\n                left: -130px;\n            }\n        }\n    }\n    .timeline-item {\n        padding-left: 0;\n        padding-right: 90px;\n    }\n    .timeline-item {\n        .border-style-for-timeline {\n            padding-left: 0;\n            padding-right: 30px;\n            border-left: none;\n            border-right: 1px dashed #D5D9E2;\n            &::before {\n                left: auto;\n                right: -6px;\n            }\n        }\n        .time-line-date {\n            left: auto;\n            right: 0;\n        }\n    }\n    .breadcrumb-item + .breadcrumb-item {\n        padding-left: 0;\n        padding-right: 12px !important;\n    }\n    .file-subdown {\n        padding-left: 0;\n        padding-right: 28px;\n        li {\n            padding-left: 0;\n            padding-right: 15px;\n            &::before {\n                left: auto;\n                right: 0;\n            }\n        }\n    }\n    .mb-4.transition-y {\n        .ps-2 {\n            padding-right: 0 !important;\n            padding-left: 0.5rem !important;\n        }\n    }\n    .product-quantity .add-to-cart-counter .minusBtn {\n        border-radius: 0 4px 4px 0 !important;\n    }\n    .product-quantity .add-to-cart-counter .plusBtn {\n        border-radius: 4px 0 0 4px !important;\n    }\n    .form-control.form-select {\n        background-position: left 0.75rem center;\n    }\n    #projects_roadmap2 {\n        direction: ltr;\n    }\n    button.btn.border-primary.text-primary.position-absolute.hover-bg {\n        right: auto !important;\n        left: 24px !important;\n    }\n    .for-rtl-position {\n        right: auto !important;\n        left: 25px !important;\n    }\n    .start-0 {\n        left: auto;\n        right: 0;\n    }\n    .ps-20 {\n        padding-left: 0;\n        padding-right: 20px;\n    }\n    .end-0 {\n        right: auto !important;\n        left: 0 !important;\n    }\n    .ms-lg-auto {\n        margin-left: 0 !important;\n        margin-right: auto !important;\n    }\n    i.ri-eye-off-line.password-toggle-icon.translate-middle-y.top-50.end-0.position-absolute {\n        right: auto !important;\n        left: 15px !important;\n    }\n    #sales_report {\n        direction: ltr;\n    }\n    #balance_overview {\n        direction: ltr;\n    }\n    #top_sales {\n        direction: ltr;\n    }\n    #returning_customer_rate {\n        direction: ltr;\n    }\n    #projects_progress {\n        direction: ltr;\n    }\n    #project_analysis {\n        direction: ltr;\n    }\n    #time_spent {\n        direction: ltr;\n    }\n    #tickets_status {\n        direction: ltr;\n    }\n    #new_tickets_vs_solved_sickets {\n        direction: ltr;\n    }\n    .apexcharts-legend-text {\n        padding-left: 0;\n        padding-right: 5px;\n        margin-left: 0;\n        margin-right: 0;\n    }\n    .sales_by_locations {\n        li {\n            .progress-bar {\n                .count {\n                    right: auto;\n                    left: 0;\n                }\n            }\n        }\n    }\n    .pagination {\n        padding-right: 0;\n        .page-item {\n            margin-right: 0;\n            margin-left: 7px;\n            &:last-child {\n                margin-left: 0;\n            }\n        }\n    }\n    .offcanvas {\n        right: auto;\n        left: 0;\n        transform: translateX(-150%);\n        &.show {\n            transform: translateX(0);\n        }\n    }\n    @media (min-width: 768px) {\n        .ms-md-3 {\n            margin-left: 0 !important;\n            margin-right: 1rem !important;\n        }\n    }\n    \n    @media (min-width: 576px) {\n        .ms-sm-3 {\n            margin-left: 0 !important;\n            margin-right: 1rem !important;\n        }\n        .ms-sm-4 {\n            margin-left: 0 !important;\n            margin-right: 1.5rem !important;\n        }\n    }\n    .action-opt {\n        .dropdown-menu {\n            li {\n                .dropdown-item {\n                    svg {\n                        margin-right: 0;\n                        margin-left: 2px;\n                    }\n                }\n            }\n        }\n    }\n    .form-check {\n        padding-left: 0;\n        padding-right: 1.5em;\n        .form-check-input {\n            float: right;\n            margin-left: 0;\n            margin-right: -1.5em\n        }\n        .form-check-label {\n            padding-left: 0;\n            padding-right: 5px;\n        }\n    }\n    .dot {\n        padding-left: 0;\n        padding-right: 15px;\n        &::before {\n            left: auto;\n            right: 0;\n        }\n    }\n    .chat-details .own-chat {\n        margin-left: 0 !important;\n        margin-right: auto;\n    }\n    .nav-tabs {\n        padding-right: 0;\n    }\n    .accordion-button {\n        &::after {\n            margin-left: 0;\n            margin-right: auto;\n        }\n    }\n    @media (min-width: 992px) {\n        .ms-lg-5 {\n            margin-left: 0 !important;\n            margin-right: 3rem !important;\n        }\n    }\n    @media (min-width: 576px) {\n        .ps-sm-5 {\n            padding-left: 0 !important;\n            padding-right: 3rem !important;\n        }\n    }\n    @media (min-width: 576px) {\n        .ms-sm-5 {\n            margin-left: 0 !important;\n            margin-right: 3rem !important;\n        }\n    }\n    .ms-4 {\n        margin-left: 0 !important;\n        margin-right: 1.5rem !important;\n    }\n    .faq-wrapper {\n        &.accordion {\n            .accordion-item {\n                .accordion-header {\n                    .accordion-button {\n                        &.control {\n                            padding-left: 0;\n                            padding-right: 50px !important;\n                            &::after {\n                                left: auto;\n                                right: 0;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .copy-btn {\n        left: 40px !important;\n    }\n    @media (min-width: 1400px) {\n        .pe-xxl-5 {\n            padding-right: 0 !important;\n            padding-left: 3rem !important;\n        }\n    }\n    @media (min-width: 768px) {\n        .me-md-5 {\n            margin-right: 0 !important;\n            margin-left: 3rem !important;\n        } \n    }\n    .password-wrapper {\n        .password-toggle-icon {\n            right: auto !important;\n            left: 15px !important;\n        }\n    }\n    @media only screen and (max-width: 1199px) {\n        .sidebar-area {\n            left: auto;\n            right: -100%;\n            z-index: 2;\n            \n            .sidebar-burger-menu {\n                right: auto !important;\n                left: 17px !important;\n                z-index: 1 !important;\n                opacity: 1 !important;\n            }\n        }\n        .main-wrapper-content.active {\n            .sidebar-area { \n                right: 0; \n \n                .sidebar-burger-menu {\n                    right: auto !important;\n                    left: 20px !important;\n                }\n            }\n        }\n        .main-content {\n            padding-right: 12px;\n            padding-left: 12px;\n        }\n  \n        .right-header-content {\n            .header-right-item {\n                margin-left: 13px;\n            }\n        }\n        \n    }\n    @media only screen and (max-width: 575px) {\n\n        .right-header-content {\n            .header-right-item {\n                .dropdown {\n                    &.noti {\n                        .dropdown-menu {\n                            width: 275px;\n                            transform: translate(-135px, 41px) !important;\n                        }\n                    }\n                }\n                .notifications.language .dropdown-menu {\n                    left: auto !important;\n                    right: 0 !important;\n                }\n            }\n        }\n        .left-header-content {\n            ul {\n                li {\n                    .notifications {\n                        &.dropdown {\n                            .dropdown-menu {\n                                transform: translate(204px, 30px) !important;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    @media only screen and (min-width: 1200px) and (max-width: 1399px) {\n        .main-content {\n            padding-left: 12px;\n            padding-right: 262px;\n        }\n        \n    }\n    @media only screen and (min-width: 1400px) and (max-width: 1799px) {\n        .main-content {\n            padding-left: 12px;\n            padding-right: 262px;\n        }\n        \n    }\n    .rtl-btn {\n        background-color: $primary;\n    }\n    .settings-btn {\n        .slider {\n            position: relative;\n            &:before {\n                opacity: 0;\n            }\n            &:after {\n                opacity: 1;\n            }\n        }\n    }\n\n    .sales_by_locations {\n        li {\n            .count {\n                right: auto; \n                left: 0; \n            }\n        }\n    }\n    .apexcharts-canvas { \n        direction: ltr;\n    }\n    .minus-l-20 {\n        margin-left: 0;\n        margin-right: -20px;\n\n        &:first-child {\n            margin-right: 0;\n        }\n    }\n\n    .ot-course-card {\n        ul {\n            justify-content: end;\n        }\n    }\n    .courses-slide .swiper-pagination {\n        bottom: 15px;\n        left: auto;\n        right: 10px;\n        text-align: right;\n    }\n\n    .upcoming-events-slide {\n        .d-flex {\n            justify-content: end;\n        }\n    }\n    .default-src-form {\n        .form-control {\n            padding-left: 0;\n            padding-right: 35px;\n        }\n        .start-0 {\n            right: 10px;\n        }\n    }\n    .default-table-area {\n        .table-responsive {\n            .table {\n                tbody {\n                    tr {\n                        td {\n                            &:first-child {\n                                border-left: none;\n                            }\n                            &:last-child {\n                                border-right: none;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .toast-header {\n        .btn-close {\n            margin-right: 10px;\n            margin-left: 0;    \n        }\n    }\n\n    // custom-modal\n    .custom-modal {\n        &.right {\n            right: auto;\n            left: -100%;\n\n            &.show {\n                left: 0;\n                right: 0;\n            }\n \n            .custom-modal-content  {\n                margin-left: 0;\n                margin-right: auto;\n            }\n        }\n        &.left {\n            left: auto;\n            right: -100%;\n\n            &.show {\n                left: 0;\n                right: 0;\n            }\n        }\n    }\n\n    .nft-slide, .nft-slide-two {\n        .swiper-button-next {\n            right: auto;\n            left: 0;\n        }\n    }\n\n    .for-rtl-chat {\n        .ms-auto {\n            margin-left: 0 !important;\n            margin-right: auto !important;\n            text-align: right;\n        }\n    }\n    .for-rtl-form {\n        .start-0 {\n            left: auto !important;\n            right: 0;\n        }\n        .form-control {\n            padding-right: 40px;\n        }\n    }\n\n    .date-time-picker-demo {\n        .react-datetime-picker__wrapper {\n            .react-datetime-picker__button {\n                margin-left: 0;\n                margin-right: 5px;\n            }\n        }\n    }\n    .ms-e-10 {\n        margin-right: 0;\n        margin-left: -10px;\n    }\n\n    .action-opt {\n        .dropdown-menu {\n            .dropdown-item {\n                i, span {\n                    margin-right: 0;\n                    margin-left: 5px;\n                }\n            }\n        }\n    }\n    .shape.shape-8 { \n        right: auto; \n        left: 200px; \n    }\n\n    .breadcrumb-page-list {\n        .breadcrumb {\n            .breadcrumb-item {\n                &::before {\n                    float: right;\n                    padding-right: 0;\n                    padding-left: .5rem;\n                }\n            }\n        }\n    }\n\n    // pos system & podcast dashboard\n    .select-dropdown {\n        right: 0 !important;\n        left: -10px;\n\n        .dropdown-item {\n            text-align: right;\n        }\n    }\n    .right-for-rtl {\n        right: auto !important;\n        left: -10px;\n    }\n    .position-for-mobile {\n        left: auto !important;\n        right: 0 !important;\n\n        ul.ps-0.mb-0.list-unstyled.last-child-none {\n            margin-left: 0 !important;\n            margin-right: -110px !important;\n        }\n    }\n\n    @media only screen and (max-width: 767px) {\n        .position-for-mobile {\n            position: initial !important; \n\n            ul.ps-0.mb-0.list-unstyled.last-child-none {\n                margin-right: -120px !important;\n            }\n        }\n    }\n    // End pos system & podcast dashboard\n\n}","/* Dark Mode Area Style\n============================================*/ \n.dark {\n    background-color: $dark-body-bg !important;\n\n    body {\n        background-color: $dark-body-bg !important;\n        color: $dark-body-color !important; \n    }\n    p, span, i, .apexcharts-text, td, th, a, label  {\n        color: $dark-body-color;\n    }\n    .apexcharts-text {\n        fill: $dark-body-color;\n    }\n    .apexcharts-legend-text  {\n        color: $dark-body-color !important;\n    }\n    .text-body {\n        color: $dark-body-color !important;\n    }\n    ul {\n        li {\n            color: $dark-body-color !important;\n        }\n    }\n    ol {\n        li {\n            color: $dark-body-color !important;\n        }\n    }\n    .h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {\n        color: $white;\n    }\n    .text-secondary {\n        color: $white !important;\n    }\n    .text-dark {\n        color: $white !important;\n    }\n    .bg-white {\n        background-color: $dark-card-bg !important;\n    }\n    .card {\n        background-color: $dark-card-bg !important;\n        &.bg-primary {\n            background-color: $primary !important;\n        }\n        &.bg-card-bg-c {\n            .list-dot {\n                li {\n                    color: $white !important;\n                }\n            }\n        }\n        .bg-body-bg {\n            background-color: $dark-body-bg !important;\n        }\n    }\n    .bg-primary {\n        p {\n            color: $white !important;\n        }\n    }\n    .form-control {\n        background-color: $dark-input-bg !important;\n        border-color: $dark-input-bg !important;\n        color: $white !important;\n        &:focus {\n            border-color: $primary !important;\n        }\n    }\n    .border {\n        border-color: $dark-border !important;\n    }\n    .border-top {\n        border-color: $dark-border !important;\n    }\n    .border-bottom {\n        border-color: $dark-border !important;\n    }\n    .border-start {\n        border-color: $dark-border !important;\n    }\n    .border-border-color {\n        border-color: $dark-border !important;\n    }\n \n    .settings-btn {\n        color: $white;\n        span {\n            color: $white;\n        }\n    }\n    .header-area {\n        background-color: $dark-card-bg !important;\n    }\n    .left-header-content {\n        ul {\n            li {\n                .notifications {\n                    &.dropdown {\n                        .btn-secondary {\n                            i, span {\n                                color: $dark-body-color;\n                            }\n                        }\n                        .dropdown-menu {\n                            background-color: $dark-card-bg;\n                            .dropdown-item {\n                                span {\n                                    color: $dark-body-color;\n                                }\n                            }\n                        }\n                    }\n                    &.apps {\n                        .dropdown-toggle {\n                            &::after {\n                                display: none;\n                            }\n                        }\n                    }\n                }\n                .header-burger-menu {\n                    i, span {\n                        color: $dark-body-color;\n                    }\n                }\n            }\n        }\n    }\n    .right-header-content {\n        .header-right-item {\n            .notifications {\n                &.dropdown {\n                    .btn-secondary {\n                        i, span {\n                            color: $dark-body-color;\n                        }\n                    }\n                    .dropdown-menu {\n                        background-color: $dark-body-bg !important;\n                        border: 1px solid #333 !important;\n\n                        .notification-menu {\n                            border-color: #1b212a !important;\n                        }\n                        .title {\n                            color: $white !important; \n                            span {\n                                color: $white !important; \n                            }\n                            button {\n                                color: $white !important; \n                            }\n                        }\n                        .dropdown-item {\n                            i {\n                                background-color: #373a40;\n                            }\n                            span {\n                                transition: $transition;\n                                color: $white !important;\n                            }\n                            p {\n                                span {\n                                    color: $white !important;\n                                }\n                            }\n                            &:hover, &:focus, &.active, &:focus-visible {\n                                background-color: $dark-card-bg !important;\n                            }\n                        }\n                        .view-all {\n                            border-color: $dark-border;\n                            span {\n                                color: $white !important;\n                            }\n                        }\n                    }\n                }\n            }\n            .admin-profile {\n                .dropdown-menu {\n                    background-color: $dark-body-bg !important;\n                    border: 1px solid #333 !important;\n\n                    .admin-link {\n                        border-color: $dark-border;\n\n                        li {\n                            .dropdown-item {\n                                i, span {\n                                    color: $dark-body-color;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n            .theme-settings-btn {\n                i, span {\n                    color: $dark-body-color;\n                }\n            }\n        }\n    }\n    .sidebar-burger-menu  {\n        svg {\n            stroke: $white;\n        }\n    }\n    .sidebar-area {\n        background-color: $dark-card-bg;\n\n        .logo {\n            border-color: $dark-border !important;\n\n            .logo-text {\n                color: $white !important;\n            }\n        }\n        .admin {\n            .admin-info {\n                .name {\n                    color: $white;\n                }\n            }\n        }\n    }\n    .sidebar-menu {\n        /* Track */\n        &::-webkit-scrollbar-track {\n            background: #333; \n        }\n        /* Handle */\n        &::-webkit-scrollbar-thumb {\n            background: #444; \n        }\n        /* Handle on hover */\n        &::-webkit-scrollbar-thumb:hover {\n            background: #555; \n        }\n        .menu-title {\n            .menu-title-text {\n                color: $dark-body-color; \n            }\n        }\n        .accordion {\n            .accordion-item {\n                .accordion-header {\n                    .accordion-button {\n                        &:hover {\n                            background-color: #222222;\n\n                            i, span {\n                                color: #fff;\n                            }\n                        }\n                        .count {\n                            background-color: #ffffff14 !important;\n                            color: $danger; \n                        }\n                        i, span {\n                            color: $dark-body-color; \n                        }\n                        .title {\n                            color: #fff;\n                        }\n                    }\n                    .accordion-button[aria-expanded=\"true\"] {\n                        background-color: #222222;\n                    }\n                }\n            }\n        }\n\n        .menu-item {\n            .menu-link {\n                color: $secondary;\n\n                i, span {\n                    color: $dark-body-color; \n                }\n                .title {\n                    color: #fff;\n                }\n                &.logout {\n                    background-color: #222222;\n                }\n                &.active, &:hover {\n                    background-color: #222222;\n                }\n            }\n        }\n\n        .sub-menu {\n            .menu-item {\n                .menu-link {\n                    color: $dark-body-color; \n    \n                    &::before {\n                        border: 1px solid $dark-body-color; \n                    }\n                    &.active, &:hover {\n                        background-color: #222222;\n                        color: $primary;\n    \n                        &::before {\n                            opacity: 1;\n                            border-color: $primary;\n                        }\n                        &::after {\n                            border-color: $white;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .menu-vertical {\n        .menu-item {\n            .menu-link {\n                .title {\n                    color: $white;\n                }\n                i, span {\n                    color: $white;\n                }\n                &:hover {\n                    background-color: $dark-input-bg;\n                }\n                &.logout {\n                    background-color: $dark-input-bg !important;\n                }\n            }\n            &.open {\n                .menu-link {\n                    &.active {\n                        background-color: $dark-input-bg;\n                        color: $primary;\n                        .title {\n                            color: $white;\n                        }\n                        &::before {\n                            border-color: $primary;\n                        }\n                    }\n                }\n            }\n        }\n        .menu-title {\n            .menu-title-text {\n                color: $dark-body-color;\n            }\n        }\n        .menu-sub {\n            .menu-item {\n                .menu-link {\n                    color: #c5c5c5;\n                    &::before {\n                        border-color: $dark-body-color;\n                    }\n                    &.active {\n                        color: $white;\n                    }\n                    &:hover {\n                        &::before {\n                            border-color: $primary;\n                            background-color: transparent;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .action-opt {\n        .dropdown-menu {\n            background-color: $dark-body-bg !important;\n            li {\n                .dropdown-item {\n                    color: $white;\n                }\n            }\n        }\n    }\n    .default-table-area {\n        .table-responsive {\n            .table {\n                border-color: $dark-border;\n                thead {\n                    tr {\n                        th {\n                            background-color: $dark-input-bg;\n                            color: $white;\n                            border-color: $dark-border;\n                        }\n                    }\n                }\n                tbody {\n                    tr {\n                        td {\n                            color: $dark-body-color;\n                            border-color: $dark-border;\n                            a {\n                                h6 {\n                                    color: $white;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        .showing-wrap {\n            border-color: $dark-border;\n        }\n\n        &.agents-performance-overview {\n            &.style-three {\n                .table-responsive {\n                    .table {\n                        tbody {\n                            tr {\n                                td {\n                                    border-top: 10px solid $dark-card-bg;\n                                    background-color: $dark-input-bg;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .pagination {\n        .page-item {\n            .page-link {\n                background: $dark-input-bg;\n                border-color: $dark-input-bg;\n                color: $white;\n                &.active {\n                    background-color: $primary;\n                }\n                &:hover {\n                    background-color: $primary;\n                }\n            }\n        }\n    }\n    .footer-area {\n        background-color: $dark-card-bg !important;\n    }\n    .apexcharts-text.apexcharts-datalabel-value {\n        fill: #fff !important;\n    }\n    .apexcharts-radialbar-hollow {\n        fill: #14171c !important;\n    }\n    .apexcharts-gridline {\n        stroke: $dark-border;\n    }\n    #top_sales {\n        .apexcharts-gridline {\n            stroke: $dark-card-bg;\n        }\n    }\n    #total_orders1 {\n        .apexcharts-gridline {\n            stroke: $dark-card-bg;\n        }\n    }\n    #total_evenue {\n        .apexcharts-gridline {\n            stroke: $dark-card-bg;\n        }\n    }\n    #total_customers {\n        .apexcharts-gridline {\n            stroke: $dark-card-bg;\n        }\n    }\n    .offcanvas {\n        background-color: $dark-body-bg !important;\n    }\n    .offcanvas-header {\n        .btn-close {\n            opacity: 1;\n            filter: invert(1);\n        }\n        &.bg-body-bg {\n            background-color: $dark-input-bg !important;\n        }\n    }\n    .form-check-input {\n        background-color: transparent;\n    }\n    .stats-box {\n        &.style-three {\n            background-color: $dark-input-bg !important;\n            span {\n                color: $dark-body-color;\n            }\n        }\n    }\n    .priceing-border {\n        &::before {\n            border-color: $dark-border;\n        }\n    }\n    .faq-wrapper {\n        &.accordion {\n            .accordion-item {\n                background-color: transparent;\n                .accordion-body {\n                    background-color: $dark-input-bg;\n                    color: #828690;\n                }\n                .accordion-header {\n                    .accordion-button {\n                        background-color: $dark-input-bg !important;\n                    }\n                    .accordion-button {\n                        &:not(.collapsed) {\n                            background-color: $dark-input-bg;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .timeline-wrap {\n        .timeline-item-2 {\n            .text {\n                background-color: $dark-input-bg;\n            }\n        }\n    }\n\n    .calendar-wrap {\n        background-color: transparent;\n        \n        .fc {\n            tbody {\n                tr {\n                    th {\n                        border-color: $dark-border;\n                        background-color: $dark-input-bg;\n                    }\n                }\n            }\n            .fc-col-header-cell-cushion {\n                color: $white;\n            }\n            .fc-today-button {\n                color: $white;\n            }\n        }\n        .fc-icon-chevron-left {\n            &:before {\n                color: $white;\n            }\n        }\n        .fc-icon-chevron-right {\n            &:before {\n                color: $white;\n            }\n        }\n        .fc-theme-standard {\n            td, .calendar-wrap .fc-theme-standard th {\n                border-color: $dark-border;\n            }\n            .fc-scrollgrid {\n                border-color: $dark-border;\n            }\n        }\n        .fc-daygrid-day-number {\n            color: $dark-body-color;\n        }\n        \n    }\n    .chat-details {\n        li {\n            p {\n                background-color: $dark-body-bg;\n            }\n            &.own-chat {\n                p {\n                    background-color: $primary;\n                    color: $white !important;\n                } \n            }\n        }\n    }\n    .chat-call-option {\n        li {\n            button {\n                background-color: $dark-input-bg;\n                &:hover {\n                    background-color: $primary;\n                }\n            }\n        }\n    }\n    .bg-gary-light {\n        &.for-dark {\n            background-color: $dark-body-bg !important;\n        }\n    }\n    #editor-container {\n        border-color: $dark-border !important;\n    }\n    .ql-toolbar.ql-snow {\n        background-color: $dark-input-bg;\n        border-color: $dark-border;\n    }\n    .ql-snow .ql-picker.ql-expanded .ql-picker-label {\n        color: $white !important;\n        &::before {\n            color: $white !important; \n        }\n    }\n    .ql-snow .ql-stroke {\n        stroke: $white;\n    }\n    .kanban-for-dark {\n        .rounded-3 {\n            background-color: $dark-input-bg !important;\n        }\n    }\n    .file-for-dark {\n        &.card {\n            background-color: $dark-input-bg !important;\n        }\n    }\n    ::-webkit-calendar-picker-indicator {\n        filter: invert(1);\n    }\n    .seller-tabs {\n        .nav-item {\n            .nav-link {\n                background-color: $dark-input-bg !important;\n                &.active {\n                    background-color: $primary !important;\n                }\n            }\n        }\n    }\n    .bg-body-bg {\n        &.product-for-dark {\n            background-color: $dark-input-bg !important;\n        }\n    }\n    .product-quantity {\n        border-color: #1d2127;\n        .add-to-cart-counter .minusBtn, .product-quantity .add-to-cart-counter .plusBtn {\n            background-color: $dark-input-bg !important;\n            &:hover {\n                background-color: $primary !important;\n            }\n        }\n        .add-to-cart-counter {\n            input {\n                background-color: $dark-input-bg;\n                border-color: $dark-input-bg;\n                color: $white;\n            }\n        }\n        &.bg-e2e8f0 {\n            background-color: transparent;\n        }\n    }\n    .product-quantity.bg-e2e8f0 .add-to-cart-counter .minusBtn, .product-quantity.bg-e2e8f0 .add-to-cart-counter .plusBtn {\n        background-color: $dark-input-bg;\n        &:hover {\n            background-color: $primary;\n        }\n    }\n    .product-quantity .add-to-cart-counter .minusBtn, .product-quantity .add-to-cart-counter .plusBtn {\n        background-color: $dark-input-bg;\n        &:hover {\n            background-color: $primary;\n        }\n    }\n    .product-details-content {\n        .border-0.bg-transparent {\n            span {\n                color: $white !important;\n            }\n            .bg-border-color {\n                background-color: $dark-input-bg !important;\n            }\n        }\n        .ps-0.mb-0.list-unstyled.d-flex.gap-2.flex-wrap {\n            .hover-bg {\n                background-color: $dark-input-bg !important;\n                &:hover {\n                    background-color: $primary !important;\n                }\n            }\n        }\n    }\n    .review-tabs {\n        .nav-item {\n            .nav-link {\n                border-color: $dark-input-bg !important;\n                &.active {\n                    border-color: $primary !important;\n                }\n            }\n        }\n    }\n    .tracking-step {\n        &.style-two {\n            .count {\n                background-color: $dark-input-bg !important;\n            }\n        }\n    }\n    .bg-for-dark-mode {\n        background-color: $dark-body-bg !important;\n    }\n    .course-accordion {\n        &.accordion {\n            .accordion-item {\n                background-color: transparent;\n\n                .accordion-body { \n                    color: #828690;\n                }\n                .accordion-header {\n                    .accordion-button {\n                        background-color: $dark-input-bg !important;\n\n                        &:not(.collapsed)::after {\n                            background-color: #b3b3b3;\n                            border-radius: 100%;\n                        }\n                    }\n                    .accordion-button {\n                        &:not(.collapsed) {\n                            background-color: $dark-input-bg;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .nav-tabs {\n        border-color: $dark-border;\n        background-color: transparent !important;\n        .nav-link {\n            border: none;\n            &:hover {\n                border: none;\n            }\n        }\n        .nav-link.active, .nav-tabs .nav-item.show .nav-link {\n            background-color: $dark-input-bg;\n            border-color: $dark-border;\n            color: $white;\n        }\n    }\n    :not(pre)>code[class*=language-], pre[class*=language-] {\n        background: $dark-input-bg;\n    }\n    code[class*=language-], pre[class*=language-] {\n        text-shadow: none;\n        color: $white;\n    }\n    .list-group-item {\n        border-color: $dark-border;\n        background-color: $dark !important;\n    }\n    .modal-content {\n        background-color: $dark-input-bg;\n    }\n    .modal-header {\n        border-color: $dark-border;\n        background-color: $dark-card-bg;\n    }\n    .modal-footer {\n        border-color: $dark-border;\n        background-color: $dark-card-bg;\n    }\n    #x__PREV__X {\n        background-color: $dark-input-bg;\n    }\n    #x__NEXT__X {\n        background-color: $dark-input-bg;\n    }\n    .input-group-text {\n        background-color: $dark-body-bg;\n        border-color: $dark-body-bg;\n        img {\n            border-radius: 50px;\n        }\n    }\n    .calendar-content th, .calendar-content td {\n        background-color: $dark-input-bg;\n        color: $dark-body-color;\n    }\n    .calendar-content {\n        .active-date {\n            background-color: $primary;\n            color: $white;\n        }\n        table {\n            background-color: $dark-input-bg;\n        }\n    }\n    .form-check {\n        .form-check-label {\n            color: $white;\n        }\n    }\n    .wizard-tabs {\n        .nav-item {\n            .nav-link {\n                background-color: $dark-body-bg !important;\n                &.active {\n                    background-color: $primary !important;\n                }\n            }\n        }\n    }\n    .wizard-tabs2 {\n        .nav-item {\n            .nav-link {\n                background-color: $dark-card-bg;\n                span {\n                    background-color: $dark-input-bg !important;\n                }\n                &.active {\n                    span {\n                        background-color: $primary !important;\n                    }\n                }\n            }\n           \n        }\n        \n    }\n    .for-light-logo {\n        display: none;\n    }\n    .for-dark-logo {\n        display: block;\n    }\n    .toast-header {\n        background-color: $dark-input-bg !important;\n        border-color: $dark-border;\n    }\n    .toast-body {\n        background-color: $dark-body-bg !important;\n    }\n    #preloader {\n        background-color: #14171c;\n    }\n    #preloader .preloader .waviy span {\n        color: $white;\n    }\n    div:where(.swal2-container) div:where(.swal2-popup) {\n        background-color: $dark-input-bg;\n    }\n    div#swal2-html-container {\n        color: $dark-body-color;\n    }\n    .form-select {\n        background-color: $dark-input-bg;\n        border-color: $dark-input-bg;\n    }\n    .welcome-box {\n        .border-bottom {\n            border-color: #262626 !important;\n        }\n    }\n \n    .control-panel-modal {\n        .modal-header {\n            &.bg-body-bg {\n                background-color: #000000 !important;\n                border-left: 1px solid #333;\n                border-bottom: 1px solid #333;\n            }\n            .btn-close {\n                background-color: #fff;\n                opacity: 1;\n                width: 30px;\n                height: 30px;\n                border-radius: 100px;\n            }\n        }\n        .cpm-content {\n            background-color: #000;\n            border-left: 1px solid #333;\n        }\n    }\n    .react-calendar {\n        background-color: $dark-card-bg;\n\n        .react-calendar__month-view__weekdays {\n            .react-calendar__month-view__weekdays__weekday {\n                color: $dark-body-color;\n            }\n        }\n        .react-calendar__month-view__days {\n            .react-calendar__tile {\n                color: $dark-body-color;\n            }\n        }\n    }\n    .btn {\n        color: #fff;\n        \n        span, i {\n            color: #fff;\n        }\n    }\n    .kb-card {\n        background-color: $dark-input-bg !important;\n    }\n    code, pre {\n        background-color: $dark-input-bg !important; \n        color: #fff !important;\n    }\n\n    .navbar {\n        &.bg-body-tertiary {\n            background-color: #000 !important;\n        }\n    }\n\n    .trezo-accordion {\n        background-color: $dark-input-bg;\n        border: 1px solid $dark-input-bg;\n\n        .accordion-item {\n            background-color: $dark-input-bg;\n            border-color: #444;\n\n            .accordion-button {\n                background-color: $dark-input-bg;\n                color: #fff;\n            }\n        }\n    }\n\n    .react-select__control {\n        background-color: $dark-input-bg;\n        border-color: $dark-input-bg;\n\n        .react-select__indicator-separator {\n            background-color: #474747;\n        }\n    }\n    .testimonials-card {\n        background-color: $dark-input-bg !important;\n    }\n    .bg-body {\n        background-color: $dark-input-bg !important; \n    }\n\n    .date-time-picker-demo {\n        .react-datetime-picker__wrapper {\n            border: 1px solid $dark-body-bg; \n            background: $dark-body-bg; \n    \n            .react-datetime-picker__button {\n                svg {\n                    stroke: $dark-body-color; \n                }\n            }\n        }\n        .react-calendar {\n            border: 1px solid #333; \n        }\n    }\n\n    .custom-modal {\n        background-color: rgba(0, 0, 0, .2);\n\n        .close-link {\n            color: #fff;\n        }\n        .custom-modal-header  {\n            background-color: $dark-body-bg; \n        }\n        .custom-modal-content  {\n            background-color: $dark-body-bg;\n        }\n    }\n    .custom-radio {\n        input[type=radio]:checked + .radio-content {\n            background: #000000;\n        }\n    }\n    .bg-border-color {\n        background-color: #000 !important;\n    }\n    .for-dark-card {\n        background-color: #0C1427 !important;\n    }\n    .recent-property-slide {\n        .bg-white {\n            background-color: $dark-body-bg !important;\n        }\n    }\n\n    // call-center\n    .bg-ecf0ff, .bg-faf5ff, .bg-fff5ed {\n        background-color: $dark-body-bg;\n    }\n\n    .t-chart {\n        .apexcharts-text {\n            fill: #fff !important;\n        }\n        .apexcharts-tooltip-y-group {\n            span {\n                color: #fff !important;\n            }\n        }\n    }\n\n    .products-list-tabs {\n        li {\n            .nav-link { \n                background-color: #1c1b1b; \n                color: #fff;\n            }\n        }\n    }\n    .badge {\n        &.completed, &.confirmed, &.active, &.published, &.successful, &.available, &.happening, &.upcoming, &.read {\n            color: $primary !important;\n        }\n    }\n    .accordion-button:not(.collapsed)::after {\n        filter: contrast(0.4);\n    }\n\n    // pos system & podcast dashboard\n    .payment-method {\n        .text-black {\n            color: #717171 !important;\n        }\n    }\n    // End pos system & podcast dashboard\n\n    // Hotel dashboard\n    .border-gray-100 {\n        border-color: $dark-input-bg !important;\n    }\n    .welcome-for-hotel {\n        background-color: $dark-body-bg !important;\n    }\n    .popular-rooms-slide {\n        .swiper-pagination {\n            .swiper-pagination-bullet {\n                background-color: #555;\n                opacity: 1;\n    \n                &.swiper-pagination-bullet-active {\n                    background-color: $primary;\n                }\n            }\n        }\n    }\n    // End Hotel dashboard\n\n    // Real Estate Agent dashboard\n    .bg-gray-100 {\n        background-color: $dark-input-bg !important; \n        \n        &.border {\n            border-color: $dark-input-bg !important;\n        }\n    }\n    .my-featured-listings-bg {\n        background-color: #222222 !important;\n    }\n    .rea-manage-app {\n        background-color: #222222 !important;\n    }\n    .rea-client-ratings-card {\n        .bg-border-color-50, .bg-danger-100, .bg-success-90 {\n            background-color: #222222 !important;\n        }\n    }\n    .rea-client-ratings-slide, .my-featured-listings-slide {\n        .swiper-pagination {\n            .swiper-pagination-bullet {\n                background-color: #555; \n                opacity: 1;\n    \n                &.swiper-pagination-bullet-active {\n                    background-color: $primary;\n                }\n            }\n        }\n    }\n    .cc-card {\n        background-image: inherit !important;\n    }\n    .gradient-card-dark {\n        background: #222222 !important;\n    }\n    .bg-black-for-dark {\n        background-color: #000 !important;\n    }\n    // End Real Estate Agent dashboard\n}\n\n// dark-top-navbar\n.dark-top-navbar {\n    .header-area {\n        background-color: $dark-card-bg !important;\n    }\n    .left-header-content {\n        p, span {\n            color: $dark-body-color;\n        }\n        ul {\n            li {\n                .src-form {\n                    .form-control {\n                        background-color: $dark-input-bg;\n                        border-color: $dark-input-bg;\n                        color: #fff !important;\n                    }\n                }\n                .notifications {\n                    &.dropdown {\n                        .btn-secondary {\n                            i, span {\n                                color: $dark-body-color;\n                            }\n                        }\n                        .dropdown-menu {\n                            background-color: $dark-card-bg;\n                            .dropdown-item {\n                                span {\n                                    color: $dark-body-color;\n                                }\n                            }\n                        }\n                    }\n                    &.apps {\n                        .dropdown-toggle {\n                            &::after {\n                                display: none;\n                            }\n                        }\n                    }\n                }\n                .header-burger-menu {\n                    i, span {\n                        color: $dark-body-color;\n                    }\n                }\n            }\n        }\n    }\n    .right-header-content {\n        p, span {\n            color: $dark-body-color;\n        }\n        .header-right-item {\n            .notifications {\n                &.dropdown {\n                    .btn-secondary {\n                        i, span {\n                            color: $dark-body-color;\n                        }\n                    }\n                    .dropdown-menu {\n                        background-color: $dark-body-bg !important;\n                        border: 1px solid #333 !important;\n\n                        .notification-menu {\n                            border-color: #1b212a !important;\n                        }\n                        .title {\n                            color: $white !important; \n                            span {\n                                color: $white !important; \n                            }\n                            button {\n                                color: $white !important; \n                            }\n                        }\n                        .dropdown-item {\n                            i, span {\n                                background-color: #373a40;\n                            }\n                            span {\n                                transition: $transition;\n                                color: $white !important;\n                            }\n                            p {\n                                color: $dark-body-color;\n                                span {\n                                    color: $white !important;\n                                }\n                            }\n                            &:hover {\n                                background-color: $dark-card-bg !important;\n                            }\n                        }\n                        .view-all {\n                            border-color: $dark-border;\n                            span {\n                                color: $white !important;\n                            }\n                        }\n                    }\n                }\n            }\n            .admin-profile {\n                h3 {\n                    color: #fff;\n                }\n                .dropdown-menu {\n                    background-color: $dark-body-bg !important;\n                    border: 1px solid #333 !important;\n\n                    .admin-link {\n                        border-color: $dark-border;\n\n                        li {\n                            .dropdown-item {\n                                i, span {\n                                    color: $dark-body-color;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n            .theme-settings-btn {\n                i, span {\n                    color: $dark-body-color;\n                }\n            }\n        }\n    }\n}\n\n// left-sidebar-dark\n.left-sidebar-dark {\n    .sidebar-area {\n        background-color: $dark-card-bg;\n\n        .logo {\n            border-color: $dark-border !important;\n\n            .logo-text {\n                color: $white !important;\n            }\n        }\n        .sidebar-burger-menu {\n            color: $white;\n        }\n        .admin {\n            .admin-info {\n                .name {\n                    color: $white;\n                }\n            }\n        }\n    }\n    .sidebar-menu {\n        /* Track */\n        &::-webkit-scrollbar-track {\n            background: #333; \n        }\n        /* Handle */\n        &::-webkit-scrollbar-thumb {\n            background: #444; \n        }\n        /* Handle on hover */\n        &::-webkit-scrollbar-thumb:hover {\n            background: #555;  \n        }\n \n        .menu-title {\n            .menu-title-text {\n                color: $dark-body-color; \n            }\n        }\n        .accordion {\n            .accordion-item {\n                .accordion-header {\n                    .accordion-button {\n                        &:hover {\n                            background-color: #222222;\n\n                            i, span {\n                                color: #fff;\n                            }\n                        }\n                        i, span {\n                            color: $dark-body-color; \n                        }\n                        .title {\n                            color: #fff;\n                        }\n                    }\n                    .accordion-button[aria-expanded=\"true\"] {\n                        background-color: #222222;\n                    }\n                }\n            }\n        }\n\n        .menu-item {\n            .menu-link {\n                color: $secondary;\n\n                i, span {\n                    color: $dark-body-color; \n                }\n                .title {\n                    color: #fff;\n                }\n                &.logout {\n                    background-color: #222222;\n                }\n                &.active, &:hover {\n                    background-color: #222222;\n                }\n            }\n        }\n\n        .sub-menu {\n            .menu-item {\n                .menu-link {\n                    color: $dark-body-color; \n    \n                    &::before {\n                        border: 1px solid $dark-body-color; \n                    }\n                    &.active, &:hover {\n                        background-color: #222222;\n                        color: $primary;\n    \n                        &::before {\n                            opacity: 1;\n                            border-color: $primary;\n                        }\n                        &::after {\n                            border-color: $white;\n                        }\n                    }\n                }\n            }\n        }\n    } \n}","/* Only Radius Square Area Style\n============================================*/\n[card-radius-square-data-theme=card-radius] {\n    .card-style-btn {\n        background-color: $primary;\n    }\n    .card {\n        border-radius: 0 !important;\n    }\n    .btn {\n        border-radius: 0;\n    }\n    .rounded {\n        border-radius: 0 !important;\n    }\n    .header-area {\n        border-radius: 0 !important;\n    }\n    .rounded-top-7 {\n        border-radius: 0 !important;\n    }\n    .pagination {\n        .page-item {\n            .page-link {\n                border-radius: 0;\n            }\n        }\n    }\n    .form-control {\n        border-radius: 0 !important;\n    }\n    .right-header-content .header-right-item .notifications.dropdown .btn-secondary {\n        border-radius: 0;\n    }\n    .menu-vertical .menu-item .menu-link {\n        border-radius: 0;\n    }\n    .settings-btn  {\n        border-radius: 0;\n    }\n    .radius {\n        display: inline-block;\n    }\n    .square {\n        display: none;\n    }\n}","/* Only Card Background Area Style\n============================================*/\n[card-bg-data-theme=card-bg-gray] {\n    background-color: $white !important;\n    .card-bg-style-btn {\n        background-color: $primary;\n    }\n    .card {\n        background-color: $body-bg !important;\n        \n        &.bg-primary-div {\n            background-color: $primary !important;\n        }\n        &.bg-primary {\n            background-color: $primary !important;\n        }\n    }\n    .header-area {\n        background-color: $body-bg !important;\n    }\n    .sidebar-area {\n        background-color: $body-bg !important;\n    }\n    .footer-area {\n        background-color: $body-bg !important;\n    }\n    .sidebar-area .admin .admin-info {\n        background-color: $body-bg !important;\n    }\n    .offcanvas {\n        background-color: $body-bg !important;\n    }\n    .white {\n        display: inline-block;\n    }\n    .gray {\n        display: none;\n    }\n}","/* Fluid & Boxed Area Style\n============================================*/\n[boxed-style-data-theme=boxed-style-boxed] {\n    &.boxed-size {\n        width: 1440px;\n        margin: auto;\n    }\n    .fluid-boxed-btn {\n        background-color: $primary;\n    }\n    .fluid {\n        display: inline-block;\n    }\n    .boxed {\n        display: none;\n    }\n    .sidebar-area {\n        inset-inline-start: auto !important;\n    }\n    .priceing-border {\n        &::before {\n            left: -67px;\n        }\n    }\n    .popular-tag {\n        left: 160px;\n    }\n    @media only screen and (min-width: 1920px) {\n        .custom-xxxl-10 {\n            flex: 0 0 auto;\n            width: 66.6666666667%;\n        }\n        .custom-xxxl-2 {\n            flex: 0 0 auto;\n            width: 33.3333333333%;\n        }\n    }\n}\n","/* Landing Page Area Style\n============================================*/\n.ptb-150 {\n    padding-top: 150px;\n    padding-bottom: 150px;\n}\n.pt-150 {\n    padding-top: 150px;\n}\n.pb-150 {\n    padding-bottom: 150px;\n}\n.pb-125 {\n    padding-bottom: 125px;\n}\n.pt-125 {\n    padding-top: 125px;\n}\n.fs-60 {\n    font-size: 60px;\n}\n.shape {\n    position: absolute;\n    z-index: -1;\n    &.shape-1 {\n        top: 50%;\n        left: 0;\n        transform: translateY(-50%);\n    }\n    &.shape-2 {\n        top: 50%;\n        right: 0;\n        transform: translateY(-50%);\n    }\n    &.shape-3 {\n        top: 0;\n        left: 0;\n    }\n    &.shape-4 {\n        top: 200px;\n        right: 0;\n    }\n    &.shape-5 {\n        bottom: -100px;\n        left: 0;\n    }\n    &.shape-6 {\n        bottom: -250px;\n        right: 0;\n    }\n    &.shape-7 {\n        top: -180px;\n        left: 0;\n        filter: blur(125px);\n    }\n    &.shape-8 {\n        top: -160px;\n        right: 200px;\n        filter: blur(75px);\n    }\n    &.shape-9 {\n        bottom: 0;\n        left: 0;\n        filter: blur(75px);\n    }\n    &.shape-10 {\n        bottom: 0;\n        right: 0;\n        filter: blur(75px);\n    }\n}\n\n.navbar {\n    padding: 20px 0;\n    &.sticky {\n        position: sticky;\n        top: 0;\n        width: 100%;\n        z-index: 10;\n        animation: 500ms ease-in-out 0s normal none 1 running fadeInDown;\n        box-shadow: $box-shadow;\n        background-color: $white !important;\n    }\n    .white-logo {\n        display: none;\n    }\n    .btn {\n        &:hover {\n            color:  $white !important;\n        }\n    }\n}\n.navbar-nav {\n    .nav-link {\n        &.active {\n            color: $primary !important;\n        }\n    }\n}\n.page-banner-area {\n    padding-top: 195px;\n}\n.page-banner-area .shape-5 {\n    top: -220px;\n    left: -50px;\n    z-index: -1;\n    position: absolute;\n    filter: blur(150px);\n}\n.page-banner-area .shape-6 {\n    bottom: 0;\n    z-index: -1;\n    right: -30px;\n    position: absolute;\n    filter: blur(250px);\n}\n\n.banner-content {\n    margin-bottom: 75px;\n}\n\n.banner-area {\n    padding-top: 185px;\n    padding-bottom: 150px;\n    background-position: center -350px !important;\n}\n.banner-content {\n    margin-bottom: 75px;\n}\n.top-title {\n    color: $primary-div;\n    border: 1px solid $primary-div;\n    padding: 5.5px 17px;\n    display: inline-block;\n    position: relative;\n    transform: rotate(-6.536deg);\n    margin-bottom: 10px;\n    &::before, &::after {\n        content: \"\";\n        position: absolute;\n        top: -4px;\n        right: -4px;\n        width: 7px;\n        height: 7px;\n        background-color: $primary-div;\n    }\n    &::after {\n        right: auto;\n        left: -4px;\n    }\n    span {\n        &::before, &::after {\n            content: \"\";\n            position: absolute;\n            bottom: -4px;\n            right: -4px;\n            width: 7px;\n            height: 7px;\n            background-color: $primary-div;\n        }\n        &::after {\n            right: auto;\n            left: -4px;\n        }\n    }\n}\n.section-title {\n    max-width: 848px;\n    margin: auto;\n    margin-bottom: 60px;\n    text-align: center;\n    &.mw-630 {\n        max-width: 630px;\n    }\n    h2 {\n        font-size: 36px;\n        line-height: 1.4;\n        letter-spacing: -1px;\n        &:last-child {\n            margin-bottom: 0;\n        }\n    }\n}\n.key-features-single-item {\n    margin-bottom: 25px;\n    i, span {\n        width: 85px;\n        height: 85px;\n        line-height: 85px;\n        font-size: 55px;\n        text-align: center;\n        border-radius: 17px;\n        margin-bottom: 20px;\n    }\n    h3 {\n        font-size: 24px;\n        margin-bottom: 15px;\n        font-weight: 600;\n    }\n}\n.tailor-content {\n    h2 {\n        font-size: 36px;\n        line-height: 1.4;\n        letter-spacing: -1px;\n        margin-bottom: 60px;\n    }\n    ul {\n        li {\n            margin-bottom: 30px;\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n    }\n}\n.masonrow {\n\t-moz-column-width: 25em;\n\t-webkit-column-width: 25em;\n\t-moz-column-gap: 1.6em;\n\t-webkit-column-gap: 1.6em; \n\t.item {\n\t\twidth:  100%; \n\t\tmargin-bottom: 25px;\n\t\tdisplay: inline-block;\n\t}\n\t&.style-two {\n\t\t-moz-column-width: 22em;\n\t\t-webkit-column-width: 22em;\n\t\t-moz-column-gap: 1.6em;\n\t\t-webkit-column-gap: 1.6em; \n\t\t.item {\n\t\t\twidth:  100%; \n\t\t\tmargin-bottom: 30px;\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n}\n.single-testimonials { \n\tbackground-color: $white;\n\tborder-radius: 10px;\n\tpadding: 40px;\n\tposition:relative;\n\tdisplay: block;\n\t.reating {\n\t\tmargin-bottom: 22px;\n\t\tli {\n\t\t\tdisplay: inline-block;\n\t\t\ti, span {\n\t\t\t\tcolor: $warning;\n                font-size: 20px;\n\t\t\t}\n\t\t}\n\t}\n\tp {\n\t\tmargin-bottom: 22px;\n\t\tfont-weight: 500;\n\t\tfont-size: 16px;\n        line-height: 1.9;\n\t}\n\t.review-info {\n\t\th4 {\n\t\t\tfont-size: 16px;\n\t\t\tmargin-bottom: 5px;\n\t\t}\n\t\tspan {\n\t\t\tfont-size: 14px;\n\t\t}\n\t}\n}\n.team-slide {\n    .swiper-pagination {\n        position: initial;\n        margin-top: 30px;\n\n        .swiper-pagination-bullet {\n            width: 10px;\n            height: 10px;\n\n            &.swiper-pagination-bullet-active {\n                background-color: $primary;\n            }\n        }\n    }\n}\n.our-team-single-item {\n    .team-img {\n        border-radius: 7px;\n        border: 1px solid rgba(255, 255, 255, 0.24);\n        background: rgba(255, 255, 255, 0.26);\n        backdrop-filter: blur(3.5999999046325684px);\n        padding: 16px;\n        img {\n            border-radius: 7px;\n        }\n    }\n    .team-content {\n        border-radius: 7px;\n        border: 1px solid rgba(255, 255, 255, 0.24);\n        background: rgba(255, 255, 255, 0.26);\n        backdrop-filter: blur(3.5999999046325684px);\n        padding: 30px;\n        margin-top: -1px;\n    }\n}\n.team-controller {\n    .controller-icon {\n        width: 64px;\n        height: 64px;\n        line-height: 64px;\n        text-align: center;\n        background-color: #ECF0FF;\n        display: inline-block;\n        font-size: 20px;\n        border-radius: 100px;\n        transition: $transition;\n        &:hover {\n            background-color: $primary-div;\n            color: $white;\n        }\n    }\n}\n.contact-us-img {\n    border-radius: 7px;\n    border: 1px solid rgba(255, 255, 255, 0.13);\n    background: rgba(255, 255, 255, 0.31);\n    backdrop-filter: blur(5.099999904632568px);\n    padding: 16px;\n    img {\n        border-radius: 7px;\n    }\n}\n.contact-us-form {\n    h2 {\n        font-size: 36px;\n        line-height: 1.4;\n        letter-spacing: -1px;\n        margin-bottom: 60px;\n    }\n}\n.unlock-content {\n    max-width: 825px;\n    margin: auto;\n    text-align: center;\n    h2 {\n        font-size: 48px;\n        letter-spacing: -1.5px;\n        line-height: 1.4;\n        margin-bottom: 20px;\n    }\n    p {\n        margin-bottom: 45px;\n    }\n}\n#backtotop {\n\tposition: fixed;\n\ttop: 100%;\n\tright: 30px;\n    bottom: 30px;\n\tmargin: auto;\n\twidth: 40px;\n\theight: 40px;\n\tborder: none;\n\tbackground-color: $primary;\n\ttransform: translateY(-100%);\n\tz-index: 2;\n\ttransition: $transition;\n    font-size: 20px;\n    border-radius: 4px;\n\n    i, span {\n        color: $white;\n    }\n    &:hover {\n        background-color: $primary-div;\n    }\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n\n    .ptb-150 {\n        padding-top: 60px;\n        padding-bottom: 60px;\n    }\n    .pt-150 {\n        padding-top: 60px;\n    }\n    .pb-150 {\n        padding-bottom: 60px;\n    }\n    .pb-125 {\n        padding-bottom: 35px;\n    }\n    .pt-125 {\n        padding-top: 35px;\n    }\n    .fs-60 {\n        font-size: 30px;\n    }\n    .banner-area {\n        padding-top: 145px;\n        padding-bottom: 60px;\n    }\n    .banner-content {\n        margin-bottom: 30px;\n        p {\n            font-size: 16px !important;\n        }\n    }\n    .section-title {\n        margin-bottom: 35px;\n        h2 {\n            font-size: 25px;\n        }\n    }\n    .key-features-single-item {\n        i, span {\n            width: 70px;\n            height: 70px;\n            line-height: 70px;\n            font-size: 40px;\n        }\n        h3 {\n            font-size: 20px;\n        }\n    }\n    .tailor-content {\n        margin-top: 30px;\n        h2 {\n            font-size: 25px;\n            margin-bottom: 35px;\n        }\n    }\n    .single-testimonials {\n        padding: 25px;\n        .reating {\n            margin-bottom: 15px;\n        }\n        p {\n            margin-bottom: 15px;\n            font-size: 15px;\n        }\n    }\n    .team-controller {\n        .controller-icon {\n            width: 45px;\n            height: 45px;\n            line-height: 45px;\n        }\n    }\n    .our-team-single-item {\n        .team-content {\n            padding: 20px;\n        }\n    }\n    .shape {\n        &.shape-3 {\n            top: auto;\n            bottom: 0;\n        }\n    }\n    .contact-us-form {\n        h2 {\n            font-size: 25px;\n            margin-bottom: 30px;\n        }\n    }\n    .unlock-content {\n        h2 {\n            font-size: 25px;\n            margin-bottom: 15px;\n        }\n        p {\n            margin-bottom: 20px;\n        }\n    }\n}\n\n/* Min width 768px to Max width 992px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n\n    .ptb-150 {\n        padding-top: 60px;\n        padding-bottom: 60px;\n    }\n    .pt-150 {\n        padding-top: 60px;\n    }\n    .pb-150 {\n        padding-bottom: 60px;\n    }\n    .pb-125 {\n        padding-bottom: 35px;\n    }\n    .pt-125 {\n        padding-top: 35px;\n    }\n    .fs-60 {\n        font-size: 50px;\n    }\n    .banner-area {\n        padding-top: 145px;\n        padding-bottom: 60px;\n    }\n    .banner-content {\n        margin-bottom: 30px;\n        p {\n            font-size: 16px !important;\n        }\n    }\n    .section-title {\n        margin-bottom: 35px;\n        h2 {\n            font-size: 30px;\n        }\n    }\n    .key-features-single-item {\n        i, span {\n            width: 70px;\n            height: 70px;\n            line-height: 70px;\n            font-size: 40px;\n        }\n        h3 {\n            font-size: 20px;\n        }\n    }\n    .tailor-content {\n        margin-top: 30px;\n        h2 {\n            font-size: 30px;\n            margin-bottom: 35px;\n        }\n    }\n    .single-testimonials {\n        padding: 25px;\n        .reating {\n            margin-bottom: 15px;\n        }\n        p {\n            margin-bottom: 15px;\n            font-size: 15px;\n        }\n    }\n    .team-controller {\n        .controller-icon {\n            width: 45px;\n            height: 45px;\n            line-height: 45px;\n        }\n    }\n    .our-team-single-item {\n        .team-content {\n            padding: 20px;\n        }\n    }\n    .contact-us-form {\n        h2 {\n            font-size: 30px;\n            margin-bottom: 30px;\n        }\n    }\n    .unlock-content {\n        h2 {\n            font-size: 35px;\n            margin-bottom: 15px;\n        }\n        p {\n            margin-bottom: 20px;\n        }\n    }\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px)  {\n\n    .contact-us-form {\n        h2 {\n            font-size: 35px;\n        }\n    }\n\n}\n\n@media only screen and (max-width: 991px) {\n\n    .navbar {\n        background-color: #fff;\n        &.bg-opacity-25 {\n            --bs-bg-opacity: 1 !important;\n        }\n        \n    }\n    .navbar-toggler {\n        &:focus {\n            box-shadow: none;\n        }\n    }\n\n}\n\n.footer-logo {\n    .white-logo {\n        display: none;\n    }\n}\n\n[dir=\"rtl\"] {\n    \n    .our-team-area {\n        .section-title {\n            &.mw-630 {\n                margin-left: auto !important;\n                margin-right: 0 !important;\n            }\n        }\n    }\n    \n}\n\n// Dark Mode\n.dark {\n    .navbar {\n        &.sticky { \n            background-color: #000 !important;\n        }\n        .black-logo {\n            display: none;\n        }\n        .white-logo {\n            display: block !important;\n        }\n    }\n\n    .single-testimonials {\n        background-color: $dark-card-bg;\n    }\n    .our-team-single-item {\n        .team-img {\n            border: 1px solid $dark-card-bg;\n            background: $dark-card-bg;\n        }\n        .team-content {\n            border: 1px solid $dark-card-bg;\n            background: $dark-card-bg;\n        }\n    }\n\n    .faq-wrapper {\n        &.accordion {\n            .accordion-item {\n                .accordion-header {\n                    .accordion-button {\n                        color: #fff;\n                    }\n                }\n            }\n        }\n    }\n\n    .footer-logo {\n        .white-logo {\n            display: block;\n        }\n        .black-logo {\n            display: none;\n        }\n    }\n    .copyright-area {\n        &.bg-white {\n            background-color: $dark-card-bg !important;\n        }\n    }\n\n    @media only screen and (max-width: 991px) {\n        .navbar {\n            background-color: #000;\n        }\n    }\n}","/* Analytics Dashboard Area Style\n============================================*/\n.analytics-tabs {\n  border: 1px solid $border-color;\n  border-radius: 7px;\n  li {\n      button {\n          padding: 3px 15px;\n          border: 0;\n          background-color: transparent;\n          color: $body-color;\n          &.active {\n              background-color: #ECF0FF;\n          }\n          &:hover {\n              background-color: #ECF0FF;\n          }\n      }\n      &:nth-child(2) {\n          button {\n              border-left: 1px solid $border-color;\n              border-right: 1px solid $border-color;\n          }\n      }\n  }\n}\n.cryptocurrency-controller {\n  .controller-icon {\n      width: 30px;\n      height: 30px;\n      line-height: 29px;\n      text-align: center;\n      border: 1px solid #ECEEF2;\n      display: inline-block;\n      font-size: 17px;\n      border-radius: 4px;\n      transition: $transition;\n      &:hover {\n          background-color: $primary-div;\n          color: $white;\n      }\n  }\n}\n\n\n@media only screen and (max-width: 575px) {\n    .analytics-tabs {\n        margin-bottom: 10px !important;\n        li {\n            button {\n                padding: 3px 12px;\n            }\n        }\n    }\n}\n\n/* Min width 1400px to Max width 1799px */\n@media only screen and (min-width: 1400px) and (max-width: 1799px) {\n\n  .ms-minus-27 {\n      margin-left: -27px;\n  }\n  .me-plus-27 {\n      margin-right: 27px;\n  }\n  .ms-plus-21 {\n      margin-left: 21px;\n  }\n\n}","/* Marketing Area Style\n============================================*/\n/* Marketing Dashboard CSS */\n.create-campaigns-tabs {\n    max-width: 960px;\n    margin: auto;\n    margin-bottom: 60px;\n    \n    .tab {\n        button {\n            position: relative;\n            padding: 0;\n            padding-bottom: 5px;\n            letter-spacing: 2px;\n\n            &::before {\n                content: \"\";\n                position: absolute;\n                bottom: 0;\n                right: 0;\n                width: 0;\n                height: 2px;\n                background-color: $primary;\n                transition: $transition;\n            }\n        }\n        &.active {\n            button {\n                color: $primary !important;\n\n                &::before {\n                    width: 100%;\n                    right: auto;\n                    left: 0;\n                }\n            }\n        }\n    }\n}\n.custom-radio {\n    width: 100%;\n    position: relative;\n    cursor: pointer;\n    input[type=\"radio\"] {\n        position: absolute;\n        left: 20px;\n        top: 50%;\n        transform: translateY(-50%);\n        background: #e2e4e7;\n        width: 20px;\n        height: 20px;\n        margin-top: 2px;\n        &:checked + .radio-content:after {\n            content: \"\";\n            position: absolute;\n            height: 20px;\n            width: 20px;\n            background: $primary;\n            left: 20px;\n            top: 50%;\n            transform: translateY(-50%);\n            border-radius: 100%;\n            border: 3px solid $white;\n            box-shadow: 0px 0px 0px 2px $primary;\n          }\n          &:checked + .radio-content {\n            border: 2px dashed $primary;\n            background: #ECEEF2;\n            transition: ease-in 0.3s;\n        }\n        &:focus {\n            box-shadow: none;\n        }\n    }\n    .radio-content {\n        border: 2px dashed #e2e4e7;\n        border-radius: 10px;\n        position: relative;\n        padding: 18px;\n        padding-left: 55px;\n    }\n    &.style-two {\n        input[type=\"radio\"] {\n            left: 0;\n            width: 30px;\n            height: 30px;\n            margin-top: -9px;\n            &:checked + .radio-content:after {\n                left: 0;\n                width: 30px;\n                height: 30px;\n            }\n            &:checked + .radio-content {\n                border: none;\n                background-color: transparent;\n            }\n        }\n        .radio-content {\n            padding: 0;\n            border: none;\n            padding-left: 45px;\n        }\n    }\n}\n\n.form-check {\n    position: relative;\n\n    &.style {\n        .form-check-label {\n            padding: 0 0 0 40px;\n            color: #000;\n        }\n        .form-check-input {\n            width: 30px;\n            height: 30px;\n            border: 0;\n            background-color: #ECEEF2;\n            margin: 0;\n            position: absolute;\n            left: 0;\n            top: 5px;\n        }\n        .label-description {\n            padding-left: 40px;\n        }\n        .form-check-input:checked {\n            background-color: $primary;\n        }\n        &.after-check {\n            .form-check-input {\n                width: 20px;\n                height: 20px;\n                border: 0;\n\n                &::before {\n                    content: \"\";\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    right: 0;\n                    bottom: 0;\n                    border: 2px dashed #ECEEF2;\n                    z-index: 1;\n                    border-radius: 6px;\n                }\n                &::after {\n                    content: \"\";\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    right: 0;\n                    bottom: 0;\n                    background-color: $white;\n                    z-index: -1;\n                    border-radius: 6px;\n                }\n            }\n            .form-check-input:checked {\n                background-color: $primary;\n\n                &::before {\n                    border-color: #5DA8FF;\n                }\n                &::after {\n                    background-color: #ECEEF2;\n                }\n            }\n        }\n    }\n}\n\n.tab-content-wrap {\n    .tab-contents {\n        display: none;\n        &.active {\n            display: block;\n        }\n        &.back-none {\n            position: relative;\n\n            &::before {\n                content: \"\";\n                position: absolute;\n                bottom: -88px;\n                left: -560px;\n                right: 0;\n                margin: auto;\n                width: 625px;\n                height: 50px;\n                background-color: #f6f7f9;\n            }\n        }\n    }\n}\n\n\n@media only screen and (max-width: 767px) {\n    .create-campaigns-tabs {\n        margin-bottom: 30px;\n    }\n}\n \n\n// RTL\n[dir=\"rtl\"] {\n    .form-check {\n        position: relative;\n    \n        &.style {\n            .form-check-label {\n                padding: 0 40px 0 0;\n            }\n            .form-check-input {\n                left: auto;\n                right: 0; \n            }\n            .label-description {\n                padding-left: 0;\n                padding-right: 40px;\n            }\n        }\n    }\n}\n\n// dark\n.dark {\n    .form-check {\n        &.style {\n            .form-check-label {\n                color: #fff;\n            }\n            .form-check-input {\n                background-color: #2f2f2f;\n            }\n        }\n    }\n}","/* FNT Area Style\n============================================*/\n/* NFT Dashboard CSS */\n.place-bid {\n    .opacity-0 {\n        transition: $transition;\n    }\n    &:hover {\n        .opacity-0 {\n            opacity: 1 !important;\n        }\n    }\n}\n\n.nft-slide {\n    margin-top: -95px;\n\n    .swiper-button-prev, .swiper-button-next {\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        text-align: center;\n        background-color: $secondary;\n        color: #C2CDFF;\n        border-radius: 100px;\n        transition: $transition;\n\n        &::after {\n            font-size: 18px;\n        }\n        &:hover {\n            background-color: $primary;\n        }\n        &.swiper-button-disabled, &.swiper-button-disabled {\n            pointer-events: auto;\n        }\n    }\n    .swiper-button-prev {\n        left: 0;\n    }\n    .swiper-button-next {\n        right: 0;\n    }\n}\n\n.nft-slide-two {\n    .swiper-button-prev, .swiper-button-next {\n        width: 30px;\n        height: 30px;\n        line-height: 30px;\n        text-align: center;\n        background-color: $secondary;\n        color: #C2CDFF;\n        border-radius: 100px;\n        transition: $transition;\n\n        &::after {\n            font-size: 18px;\n        }\n        &:hover {\n            background-color: $primary;\n        }\n        &.swiper-button-disabled, &.swiper-button-disabled {\n            pointer-events: auto;\n        }\n    }\n    .swiper-button-prev {\n        left: 0;\n    }\n    .swiper-button-next {\n        right: 0;\n    }\n}\n\n.top-collections-slide {\n    .swiper-pagination {\n        position: initial;\n        margin-top: 15px;\n        line-height: 1;\n    }\n}\n\n.ethereum-rate-tabs {\n  margin-bottom: 30px;\n  border: 0;\n\n  .nav-item {\n      .nav-link {\n          width: 47px;\n          height: 32px;\n          padding: 0;\n          border: 0;\n          font-weight: 600;\n          font-size: 12px;\n          border-radius: 4px;\n          color: #64748B;\n          &.active {\n              background-color: $primary !important;\n              color: $white !important;\n          }\n      }\n  }\n}\n.swiper-pagination-top-collections {\n  &.swiper-pagination-clickable .swiper-pagination-bullet {\n      background-color: #526077;\n  }\n}\n.live-auction {\n  .nav-item {\n      .nav-link {\n          padding: 0;\n          &.active {\n              color: $primary !important;\n          }\n      }\n  }\n}\n.clockdiv {\n  background: rgba(255, 255, 255, 0.60);\n  backdrop-filter: blur(12px);\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 10px;\n  margin: 6px;\n  .time {\n      color: $secondary;\n      font-size: 14px;\n      font-weight: 700;\n      position: relative;\n      &::before {\n          content: \":\";\n          position: absolute;\n          right: -10px;\n\n      }\n      &:last-child {\n          &::before {\n              display: none;\n          }\n      }\n  }\n  .days {\n      position: relative;\n      padding-right: 10px;\n      &::before {\n          content: \"d\";\n          position: absolute;\n          top: 50%;\n          right: 0;\n          transform: translateY(-50%);\n      }\n  }\n  .hours {\n      position: relative;\n      padding-right: 10px;\n      &::before {\n          content: \"h\";\n          position: absolute;\n          top: 50%;\n          right: 0;\n          transform: translateY(-50%);\n      }\n  }\n  .minutes {\n      position: relative;\n      padding-right: 15px;\n      &::before {\n          content: \"m\";\n          position: absolute;\n          top: 50%;\n          right: 0;\n          transform: translateY(-50%);\n      }\n  }\n  .seconds {\n      position: relative;\n      padding-right: 10px;\n      &::before {\n          content: \"s\";\n          position: absolute;\n          top: 50%;\n          right: 0;\n          transform: translateY(-50%);\n      }\n  }\n}\n\n \n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n  .manage-nft {\n      padding: 20px !important;\n      padding-bottom: 120px !important;\n  }\n  .nft-detail-tabs {\n      .nav-item {\n          .nav-link {\n              width: 50px !important;\n          }\n      }\n  }\n}\n\n/* Min width 768px to Max width 992px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px)  {\n\n  .nft-detail-tabs {\n      .nav-item {\n          .nav-link {\n              width: 50px !important;\n          }\n      }\n  }\n\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n\n  .nft-detail-tabs {\n      .nav-item {\n          .nav-link {\n              width: 60px !important;\n          }\n      }\n  }\n\n}\n\n/* Min width 1400px to Max width 1799px */\n@media only screen and (min-width: 1400px) and (max-width: 1799px) {\n\n}\n\n@media only screen and (max-width: 1199px) {\n\n}","/* Restaurant Area Style\n============================================*/\n.welcome-restaurant {\n  padding: 60px 30px;\n  padding-bottom: 57px;\n  \n    h2 {\n        color: $white;\n        font-size: 32px;\n        font-weight: 700;\n        line-height: 125%;\n        letter-spacing: -0.5px;\n        max-width: 326px;\n        margin-bottom: 30px;\n    }\n    .dish-wrap {\n        position: absolute;\n        top: 50%;\n        right: 38px;\n        transform: translateY(-50%);\n\n        .dish-img {\n            animation: rotateAndReverse 4s linear infinite;\n        }\n        .dish-shape {\n            position: absolute;\n            top: 0;\n            right: 30px;\n        }\n        .dish-shape1 {\n            position: absolute;\n            top: -10px;\n            left: -15px;\n        }\n        .dish-shape2 {\n            position: absolute;\n            bottom: -10px;\n            right: -15px;\n        }\n    }\n}\n@keyframes rotateAndReverse {\n    0% { transform: rotate(0deg); }\n    50% { transform: rotate(180deg); }\n    100% { transform: rotate(0deg); }\n}\n.revenue-card {\n    padding: 22px 24px;\n    h2 {\n        font-size: 32px;\n        font-weight: 700;\n        line-height: 125%;\n        letter-spacing: -0.5px;\n        margin-bottom: 0;\n    }\n}\n\n\n/* Max width 767px */\n@media only screen and (max-width : 767px) {\n\n    .welcome-restaurant {\n        padding: 20px;\n        h2 {\n            font-size: 20px;\n            max-width: 200px;\n            margin-bottom: 15px;\n        }\n    }\n\n}\n\n@media only screen and (max-width : 520px) {\n    .dish-wrap {\n        display: none;\n    }\n}\n\n/* Min width 768px to Max width 992px */\n@media only screen and (min-width : 768px) and (max-width : 991px) {\n\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width : 992px) and (max-width : 1199px)  {\n\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width : 1200px) and (max-width : 1399px) {\n\n}\n\n/* Min width 1400px to Max width 1799px */\n@media only screen and (min-width : 1400px) and (max-width : 1799px) {\n\n}\n\n@media only screen and (max-width : 1199px) {\n\n}\n\n// dark\n.dark {\n    .welcome-restaurant {\n        background-color: $rating-color !important;\n    }\n}\n\n[dir=\"rtl\"] {\n    .welcome-restaurant {\n        .dish-wrap {\n            right: auto;\n            left: 38px;\n        }\n    }\n}\n\n\n// Dish Details\n.dish-details-images-card {\n    padding: 13px;\n    margin-bottom: 15px;\n    border-radius: 7px;\n}\n.dish-details-card {\n    padding: 25px;\n    border-radius: 7px;\n\n    .trezo-card-content {\n        .text-xs {\n            font-size: 12px;\n        }\n        h3 {\n            font-size: 24px;\n            margin: {\n                top: 10px;\n                bottom: 10px;\n            };\n        }\n        .price {\n            font-size: 16px;\n            color: #EC1F00;\n        }\n        .ratings {\n            font-size: 15px;\n            color: #FE7A36;\n\n            i {\n                margin-right: 2px;\n\n                &:last-child {\n                    margin-right: 0;\n                }\n            }\n            span {\n                &.text-xs {\n                    font-size: 12px;\n                    margin-left: 2px;\n                }\n            }\n        }\n        .border-top {\n            border-color: $border-color !important;\n            margin: {\n                top: 25px;\n                bottom: 25px;\n            };\n        }\n        h4 {\n            font-size: 18px;\n            margin-bottom: 12px;\n        }\n        .nutrition-values {\n            margin: {\n                bottom: 25px;\n                top: 15px;\n            };\n            .item {\n                padding: 10px 20px;\n                border: 1px solid $border-color;\n            }\n            .col-md-6 {\n                &:nth-child(1), &:nth-child(2), &:nth-child(3), &:nth-child(4), &:nth-child(5), &:nth-child(6) {\n                    .item {\n                        border-bottom-width: 0;\n                    }\n                }\n                &:nth-child(1), &:nth-child(3), &:nth-child(5), &:nth-child(7), &:nth-child(9), &:nth-child(11) {\n                    .item {\n                        border-right-width: 0;\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n// dark\n.dark {\n    .dish-details-card {\n        .trezo-card-content {\n            .ratings {\n                i {\n                    color: #FE7A36;\n                }\n            }\n            .border-top {\n                border-color: #333 !important;\n            }\n            .nutrition-values {\n                .item { \n                    border: 1px solid #333;\n                }\n            }\n        }\n    }\n}\n\n\n/* Max width 767px */\n@media only screen and (max-width : 767px) {\n\n    .dish-details-card {\n        height: auto;\n\n        .trezo-card-content {\n            h3 {\n                font-size: 20px;\n                margin: {\n                    top: 8px;\n                    bottom: 8px;\n                };\n            }\n            .price {\n                font-size: 14px;\n            }\n            .ratings {\n                margin-top: 12px;\n            }\n            .border-top {\n                margin: {\n                    top: 17px;\n                    bottom: 17px;\n                };\n            }\n            h4 {\n                font-size: 16px;\n            }\n            .mb-25 {\n                margin-bottom: 17px !important;\n            }\n            .nutrition-values {\n                margin: {\n                    bottom: 17px;\n                    top: 15px;\n                };\n                .item {\n                    padding: 10px 15px;\n                }\n                .col-md-6 {\n                    &:nth-child(7) {\n                        .item {\n                            border-bottom-width: 0;\n                        }\n                    }\n                    &:nth-child(1), &:nth-child(3), &:nth-child(5), &:nth-child(7), &:nth-child(9), &:nth-child(11) {\n                        .item {\n                            border-right-width: 1px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n}\n\n/* Min width 576px to Max width 767px */\n@media only screen and (min-width : 576px) and (max-width : 767px) {\n\n    .dish-details-card {\n        .trezo-card-content {\n            .border-top {\n                margin: {\n                    top: 20px;\n                    bottom: 20px;\n                };\n            }\n            .mb-25 {\n                margin-bottom: 20px !important;\n            }\n            .nutrition-values {\n                margin-bottom: 20px;\n            }\n        }\n    }\n\n}\n\n/* Min width 768px to Max width 991px */\n@media only screen and (min-width : 768px) and (max-width : 991px) {\n\n    .dish-details-card {\n        height: auto; \n    \n        .trezo-card-content {\n            h3 {\n                font-size: 22px;\n            }\n            .price {\n                font-size: 15px;\n            }\n            h4 {\n                font-size: 17px;\n            }\n        }\n    }\n\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width : 992px) and (max-width : 1199px) {}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {}\n\n/* Min width 1600px */\n@media only screen and (min-width: 1600px) {}",".with-horizontal-navbar {\n  .header-area {\n    position: fixed;\n    left: 0;\n    right: 0;\n    border-radius: 0 0 7px 7px !important;\n\n    &::before {\n      left: 0;\n      right: 0;\n      top: 75px;\n      content: \"\";\n      height: 1px;\n      position: absolute;\n      background: $border-color;\n    }\n    .container-fluid {\n      max-width: 1295px;\n    }\n\n    .logo-box {\n      display: block !important;\n    }\n  }\n}\n\n.horizontal-navbar-area {\n  max-width: 1295px;\n  margin: {\n    top: 13px;\n    left: auto;\n    right: auto;\n  }\n  padding: {\n    bottom: 0;\n    top: 13px;\n  }\n  display: none;\n\n  .accordion {\n    gap: 6px;\n\n    .accordion-item {\n      background-color: transparent;\n      color: $secondary;\n      white-space: nowrap;\n      position: relative;\n\n      .accordion-button {\n        display: flex;\n        align-items: center;\n        color: $secondary;\n        font-size: 14px;\n        background-color: transparent;\n        padding: {\n          bottom: 9px;\n          right: 33px;\n          left: 14px;\n          top: 9px;\n        }\n        i {\n          transition: $transition;\n          color: $body-color;\n          margin-right: 7px;\n          font-size: 22px;\n          line-height: 1;\n        }\n        .trezo-badge {\n          padding: 0;\n          width: 20px;\n          height: 20px;\n          font-size: 11px;\n          line-height: 20px;\n          color: $danger;\n          background-color: #fff5ed;\n          margin: {\n            left: 11px;\n            right: 0;\n          }\n          &.style-two {\n            color: #00b69b;\n            background: rgba(0, 182, 155, 0.07);\n          }\n          &.style-three {\n            color: #ee368c;\n            background: rgba(238, 54, 140, 0.1);\n          }\n        }\n        &::after {\n          display: none;\n        }\n        &::before {\n          top: 50%;\n          right: 8px;\n          margin-top: 1px;\n          content: \"\\ea4e\";\n          position: absolute;\n          color: $body-color;\n          transform: translateY(-50%);\n          transition: $transition;\n          font: {\n            size: 19px;\n            family: remixicon;\n          }\n        }\n        &:hover {\n          color: $secondary;\n          background-color: #f6f7f9;\n\n          i {\n            color: $secondary;\n          }\n          &::before {\n            color: $secondary;\n          }\n        }\n      }\n      &:has(.active) .accordion-button {\n        color: $secondary;\n        background-color: #f6f7f9;\n\n        i {\n          color: $secondary;\n        }\n        &::before {\n          color: $secondary;\n        }\n      }\n      .accordion-body {\n        left: 0;\n        top: 100%;\n        opacity: 0;\n        z-index: 1;\n        width: 270px;\n        padding: 12px 0;\n        margin-top: 13px;\n        position: absolute;\n        visibility: hidden;\n        transition: $transition;\n        background-color: $white;\n        box-shadow: 0 0.25rem 1.125rem 0 rgba(47, 43, 61, 0.1);\n\n        .accordion-button {\n          color: $body-color;\n          font-size: 14px;\n          background-color: transparent;\n          padding: {\n            bottom: 10px;\n            right: 10px;\n            left: 31px;\n            top: 10px;\n          }\n          &::after {\n            top: 50%;\n            left: 13px;\n            width: 10px;\n            content: \"\";\n            height: 10px;\n            transition: 0.3s;\n            border-radius: 50%;\n            position: absolute;\n            display: inline-block;\n            transform: translateY(-50%);\n            background: unset !important;\n            border: 1px solid $body-color;\n          }\n          i {\n            margin-right: 0;\n          }\n          &:hover,\n          &.active {\n            background-color: #ecf0ff;\n            color: $primary;\n\n            i {\n              color: $primary;\n            }\n            &::after {\n              border-color: $primary;\n            }\n            &::before {\n              color: $primary;\n            }\n          }\n          .trezo-badge {\n            top: 50%;\n            padding: 0;\n            right: 34px;\n            width: 20px;\n            height: 20px;\n            font-size: 11px;\n            line-height: 20px;\n            position: absolute;\n            color: $danger;\n            transform: translateY(-50%);\n            background-color: #fff5ed;\n\n            &.style-two {\n              color: #00b69b;\n              background: rgba(0, 182, 155, 0.07);\n            }\n            &.style-three {\n              color: #ee368c;\n              background: rgba(238, 54, 140, 0.1);\n            }\n          }\n          &.with-icon {\n            display: flex !important;\n            align-items: center;\n            padding-left: 12px;\n            gap: 7px;\n\n            i {\n              font-size: 21px;\n            }\n            &::after {\n              display: none;\n            }\n          }\n        }\n        .sidebar-sub-menu {\n          .sidemenu-item {\n            position: relative;\n            padding: {\n              left: 12px;\n              right: 12px;\n            }\n            .sidemenu-link {\n              color: $body-color;\n              font-size: 14px;\n              text-decoration: none;\n              border-radius: 5px;\n              padding: {\n                bottom: 10px;\n                right: 12px;\n                left: 31px;\n                top: 10px;\n              }\n              &::after {\n                top: 50%;\n                left: 13px;\n                width: 10px;\n                content: \"\";\n                height: 10px;\n                transition: 0.3s;\n                border-radius: 50%;\n                position: absolute;\n                transform: translateY(-50%);\n                border: 1px solid $body-color;\n              }\n              &:hover,\n              &.active {\n                background-color: #ecf0ff;\n                color: $primary;\n\n                &::after {\n                  border-color: $primary;\n                }\n              }\n              .trezo-badge {\n                top: -1px;\n                padding: 2px 6px;\n                margin-left: 10px;\n                border-radius: 3px;\n                line-height: initial;\n                color: $danger;\n                background-color: #ffe8d4;\n                font: {\n                  size: 10px;\n                  weight: normal;\n                }\n                &::before {\n                  top: 50%;\n                  left: -3px;\n                  width: 6px;\n                  height: 6px;\n                  content: \"\";\n                  position: absolute;\n                  background: #ffe8d4;\n                  transform: translateY(-50%) rotate(45deg);\n                }\n                &.style-two {\n                  color: $success;\n                  background-color: #d8ffc8;\n\n                  &::before {\n                    background: #d8ffc8;\n                  }\n                }\n                &.style-three {\n                  color: $primary-div;\n                  background-color: #eae0f3;\n\n                  &::before {\n                    background: #eae0f3;\n                  }\n                }\n              }\n              &.with-icon {\n                display: flex !important;\n                align-items: center;\n                padding-left: 12px;\n                gap: 7px;\n\n                i {\n                  font-size: 21px;\n                }\n                &::after {\n                  display: none;\n                }\n              }\n            }\n            .accordion-body {\n              top: 0;\n              left: 100%;\n              opacity: 0;\n              margin-top: 0;\n              visibility: hidden;\n\n              .sidebar-sub-menu {\n                .sidemenu-item {\n                  .accordion-body {\n                    opacity: 0;\n                    // left: -100%;\n                    visibility: hidden;\n\n                    .sidebar-sub-menu {\n                      .sidemenu-item {\n                        .accordion-body {\n                          opacity: 0;\n                          // left: 100%;\n                          visibility: hidden;\n                        }\n                        &:hover {\n                          .accordion-body {\n                            opacity: 1;\n                            visibility: visible;\n                          }\n                        }\n                      }\n                    }\n                  }\n                  &:hover {\n                    .accordion-body {\n                      opacity: 1;\n                      visibility: visible;\n                    }\n                  }\n                }\n              }\n            }\n            &:hover {\n              .accordion-body {\n                opacity: 1;\n                visibility: visible;\n              }\n            }\n          }\n        }\n      }\n      &.megamenu {\n        position: inherit;\n\n        .accordion-body {\n          width: auto;\n          right: 0;\n          padding: {\n            left: 12px;\n            right: 12px;\n          }\n          .sidebar-sub-menu {\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n            margin: {\n              left: -5px;\n              right: -5px;\n            }\n            .sidemenu-item {\n              flex: 0 0 auto;\n              width: 25%;\n              padding: {\n                left: 5px;\n                right: 5px;\n              }\n            }\n          }\n        }\n      }\n      &:hover {\n        .accordion-body {\n          opacity: 1;\n          visibility: visible;\n        }\n      }\n      &:last-child {\n        .accordion-body {\n          left: auto;\n          right: 0;\n\n          .sidebar-sub-menu {\n            .sidemenu-item {\n              .accordion-body {\n                left: -100%;\n\n                .sidebar-sub-menu {\n                  .sidemenu-item {\n                    .accordion-body {\n                      left: 100%;\n\n                      .sidebar-sub-menu {\n                        .sidemenu-item {\n                          .accordion-body {\n                            left: 100%;\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n// dark\n.dark {\n  .with-horizontal-navbar {\n    .header-area {\n      &::before {\n        background: #172036;\n      }\n      .logo {\n        display: none;\n\n        &.white-logo {\n          display: block;\n        }\n      }\n    }\n  }\n  .horizontal-navbar-area {\n    .accordion {\n      .accordion-item {\n        color: $white;\n\n        > .accordion-button {\n          color: $white;\n\n          .title {\n            color: $white;\n          }\n          .trezo-badge {\n            background-color: rgba(255, 255, 255, 0.08);\n\n            &.style-two {\n              background-color: rgba(255, 255, 255, 0.08);\n            }\n            &.style-three {\n              background-color: rgba(255, 255, 255, 0.08);\n            }\n          }\n          &:hover {\n            color: $white;\n            background-color: #212121;\n\n            i {\n              color: $white;\n            }\n            &::before {\n              color: $white;\n            }\n          }\n        }\n        &:has(.active) .accordion-button {\n          color: $white;\n          background-color: #212121;\n\n          i {\n            color: $white;\n          }\n          &::before {\n            color: $white;\n          }\n        }\n        .accordion-body {\n          background-color: #0c1427;\n\n          .accordion-button {\n            &:hover,\n            &.active {\n              background-color: #212121;\n            }\n            .trezo-badge {\n              background-color: rgba(255, 255, 255, 0.08);\n\n              &.style-two {\n                background-color: rgba(255, 255, 255, 0.08);\n              }\n              &.style-three {\n                background-color: rgba(255, 255, 255, 0.08);\n              }\n            }\n          }\n          .sidebar-sub-menu {\n            .sidemenu-item {\n              .sidemenu-link {\n                color: #8695aa;\n\n                &::after {\n                  border-color: #8695aa;\n                }\n\n                &:hover,\n                &.active {\n                  background-color: #212121;\n                  color: $primary;\n\n                  &::after {\n                    border-color: $primary;\n                  }\n                }\n                .trezo-badge {\n                  background: rgba(255, 255, 255, 0.08);\n\n                  &::before {\n                    background: rgba(255, 255, 255, 0.08);\n                  }\n                  &.style-two {\n                    background: rgba(255, 255, 255, 0.08);\n\n                    &::before {\n                      background: rgba(255, 255, 255, 0.08);\n                    }\n                  }\n                  &.style-three {\n                    background: rgba(255, 255, 255, 0.08);\n\n                    &::before {\n                      background: rgba(255, 255, 255, 0.08);\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n.with-horizontal-navbar {\n  .dark {\n    &.header-area {\n      &::before {\n        background: #172036;\n      }\n      .logo {\n        display: none;\n\n        &.white-logo {\n          display: block;\n        }\n      }\n    }\n  }\n}\n// End dark\n\n// RTL\n[dir=\"rtl\"] {\n  .horizontal-navbar-area {\n    .accordion {\n      .accordion-item {\n        .accordion-button {\n          padding: {\n            right: 14px;\n            left: 33px;\n          }\n          i {\n            margin: {\n              right: 0;\n              left: 7px;\n            }\n          }\n          .trezo-badge {\n            margin: {\n              left: 0;\n              right: 11px;\n            }\n          }\n          &::before {\n            right: auto;\n            left: 8px;\n          }\n        }\n        .accordion-body {\n          left: auto;\n          right: 0;\n\n          .accordion-button {\n            padding: {\n              right: 31px;\n              left: 10px;\n            }\n            &::after {\n              left: auto;\n              right: 13px;\n            }\n            i {\n              margin-left: 0;\n            }\n            .trezo-badge {\n              right: auto;\n              left: 34px;\n            }\n            &.with-icon {\n              padding: {\n                left: 0;\n                right: 12px;\n              }\n            }\n          }\n          .sidebar-sub-menu {\n            .sidemenu-item {\n              .sidemenu-link {\n                padding: {\n                  right: 31px;\n                  left: 12px;\n                }\n                &::after {\n                  left: auto;\n                  right: 13px;\n                }\n                .trezo-badge {\n                  margin: {\n                    left: 0;\n                    right: 5px;\n                  }\n                  &::before {\n                    left: auto;\n                    right: -3px;\n                  }\n                }\n                &.with-icon {\n                  padding: {\n                    left: 0;\n                    right: 12px;\n                  }\n                }\n              }\n              .accordion-body {\n                left: auto;\n                right: 100%;\n\n                // .sidebar-sub-menu {\n                //     .sidemenu-item {\n                //         .accordion-body {\n                //             left: auto;\n                //             right: -100%;\n\n                //             .sidebar-sub-menu {\n                //                 .sidemenu-item {\n                //                     .accordion-body {\n                //                         left: auto;\n                //                         right: 100%;\n                //                     }\n                //                 }\n                //             }\n                //         }\n                //     }\n                // }\n              }\n            }\n          }\n        }\n        &.megamenu {\n          .accordion-body {\n            left: 0;\n          }\n        }\n        &:last-child {\n          .accordion-body {\n            left: 0;\n            right: auto;\n\n            .sidebar-sub-menu {\n              .sidemenu-item {\n                .accordion-body {\n                  left: auto;\n                  right: -100%;\n\n                  .sidebar-sub-menu {\n                    .sidemenu-item {\n                      .accordion-body {\n                        left: auto;\n                        right: 100%;\n\n                        .sidebar-sub-menu {\n                          .sidemenu-item {\n                            .accordion-body {\n                              left: auto;\n                              right: 100%;\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n// End RTL\n\n.main-wrapper-content {\n  &.with-horizontal-navbar {\n    .horizontal-navbar-area {\n      display: block;\n    }\n    .main-content {\n      padding-left: 25px;\n      padding-right: 25px;\n      padding-top: 162px;\n      max-width: 1340px;\n      margin-right: auto;\n      margin-left: auto;\n    }\n  }\n}\n\n/* Max width 575px */\n@media only screen and (max-width: 575px) {\n  .main-wrapper-content {\n    &.with-horizontal-navbar {\n      .main-content {\n        padding-top: 140px;\n        padding-left: 15px;\n        padding-right: 15px;\n      }\n    }\n  }\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n  .horizontal-navbar-area {\n    display: none;\n  }\n  .main-wrapper-content {\n    &.with-horizontal-navbar {\n      .horizontal-navbar-area {\n        display: none;\n      }\n      .header-area {\n        &::before {\n          display: none;\n        }\n        .logo-box {\n          display: none !important;\n        }\n      }\n    }\n  }\n}\n\n/* Min width 576px to Max width 767px */\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .main-wrapper-content {\n    &.with-horizontal-navbar {\n      .main-content {\n        padding-top: 95px;\n      }\n    }\n  }\n}\n\n/* Min width 768px to Max width 991px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .horizontal-navbar-area {\n    display: none;\n  }\n\n  .main-wrapper-content {\n    &.with-horizontal-navbar {\n      .horizontal-navbar-area {\n        display: none;\n      }\n      .header-area {\n        &::before {\n          display: none;\n        }\n        .logo-box {\n          display: none !important;\n        }\n      }\n      &.with-horizontal-navbar {\n        .main-content {\n          padding-top: 95px;\n        }\n      }\n    }\n  }\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .main-wrapper-content {\n    &.with-horizontal-navbar {\n      .left-header-content {\n        ul {\n          li {\n            .src-form {\n              .form-control {\n                width: 215px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .horizontal-navbar-area {\n    max-width: 100%;\n\n    .accordion {\n      .accordion-item {\n        .accordion-body {\n          width: 250px;\n        }\n        &:last-child,\n        &:nth-last-child(2) {\n          .accordion-body {\n            left: auto;\n            right: 0;\n\n            .sidebar-sub-menu {\n              .sidemenu-item {\n                .accordion-body {\n                  left: -100%;\n\n                  .sidebar-sub-menu {\n                    .sidemenu-item {\n                      .accordion-body {\n                        left: -100%;\n\n                        .sidebar-sub-menu {\n                          .sidemenu-item {\n                            .accordion-body {\n                              left: 100%;\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // RTL\n  [dir=\"rtl\"] {\n    .horizontal-navbar-area {\n      .accordion {\n        .accordion-item {\n          &:last-child,\n          &:nth-last-child(2) {\n            .accordion-body {\n              left: 0;\n              right: auto;\n\n              .sidebar-sub-menu {\n                .sidemenu-item {\n                  .accordion-body {\n                    left: auto;\n                    right: -100%;\n\n                    .sidebar-sub-menu {\n                      .sidemenu-item {\n                        .accordion-body {\n                          left: auto;\n                          right: -100%;\n\n                          .sidebar-sub-menu {\n                            .sidemenu-item {\n                              .accordion-body {\n                                left: auto;\n                                right: 100%;\n                              }\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n/* Min width 992px */\n@media only screen and (min-width: 992px) {\n  .with-horizontal-navbar {\n    .header-area {\n      .hbm {\n        display: none;\n      }\n      .logo {\n        &.white-logo {\n          display: none;\n        }\n      }\n    }\n  }\n\n  .main-wrapper-content {\n    &.with-horizontal-navbar {\n      .sidebar-area {\n        display: none;\n      }\n    }\n  }\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n  .horizontal-navbar-area {\n    max-width: 100%;\n\n    .accordion {\n      .accordion-item {\n        .accordion-body {\n          width: 250px;\n        }\n        &:last-child,\n        &:nth-last-child(2) {\n          .accordion-body {\n            left: auto;\n            right: 0;\n\n            .sidebar-sub-menu {\n              .sidemenu-item {\n                .accordion-body {\n                  left: -100%;\n\n                  .sidebar-sub-menu {\n                    .sidemenu-item {\n                      .accordion-body {\n                        left: -100%;\n\n                        .sidebar-sub-menu {\n                          .sidemenu-item {\n                            .accordion-body {\n                              left: 100%;\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // RTL\n  [dir=\"rtl\"] {\n    .horizontal-navbar-area {\n      .accordion {\n        .accordion-item {\n          &:last-child,\n          &:nth-last-child(2) {\n            .accordion-body {\n              left: 0;\n              right: auto;\n\n              .sidebar-sub-menu {\n                .sidemenu-item {\n                  .accordion-body {\n                    left: auto;\n                    right: -100%;\n\n                    .sidebar-sub-menu {\n                      .sidemenu-item {\n                        .accordion-body {\n                          left: auto;\n                          right: -100%;\n\n                          .sidebar-sub-menu {\n                            .sidemenu-item {\n                              .accordion-body {\n                                left: auto;\n                                right: 100%;\n                              }\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n/* Min width 1600px */\n@media only screen and (min-width: 1600px) {\n  .with-horizontal-navbar {\n    .header-area {\n      .container-fluid {\n        max-width: 1545px;\n      }\n    }\n  }\n\n  .horizontal-navbar-area {\n    max-width: 1545px;\n  }\n\n  .main-wrapper-content {\n    &.with-horizontal-navbar {\n      .main-content {\n        max-width: 1596px;\n      }\n    }\n  }\n}\n",".theme-settings-btn {\n  background-color: transparent;\n  // color: #3A4252;\n\n  i { \n    animation: roundedAnimation 2s infinite linear;\n    transition: transform 0.3s ease;\n  }\n}\n@keyframes roundedAnimation {\n  0% {\n    transform: rotate(0deg);\n    border-radius: 0%;\n  }\n  50% {\n    transform: rotate(180deg);\n    border-radius: 50%;\n  }\n  100% {\n    transform: rotate(360deg);\n    border-radius: 0%;\n  }\n}\n\n[dir=\"rtl\"] {\n  .theme-settings-btn {\n    right: auto;\n    left: 20px;\n  }\n}\n\n.settings-sidebar {\n  bottom: 0;\n  opacity: 0;\n  z-index: 100;\n  right: -100%;\n  width: 380px;\n  height: 100%;\n  position: fixed;\n  visibility: hidden;\n\tbox-shadow: 0 4px 20px #2f8fe812 !important;\n  overflow-y: auto;\n\n  .settings-header {\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 2;\n    position: sticky;\n    padding: 16.5px 25px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between; \n\n    h4 {\n      font-size: 16px;\n\t\t\tmargin: 0;\n\t\t\tline-height: 1;\n\t\t\tfont-weight: 500; \n    }\n    .close-btn { \n\t\t\tpadding: 0;\n\t\t\tbackground-color: transparent;\n\t\t\tborder: none;\n\t\t\tcursor: pointer;\n      display: block !important;\n      line-height: 1;\n\t\t\t  \n      i {\n        font-size: 20px;\n        color: #fff !important;\n      }\n    }\n  }\n  .settings-body {\n    padding: {\n      top: 25px;\n      left: 25px;\n      right: 25px; \n      bottom: 25px;\n    }\n    .title {\n      margin-bottom: 15px;\n\t\t\tdisplay: block;\n\t\t\tcolor: $secondary;\n\t\t\tfont-weight: 600; \n    }\n    .switch-btn {\n      gap: 25px;\n      display: grid;\n      color: $secondary; \n      grid-template-columns: repeat(2, minmax(0, 1fr));\n\t\t\tpadding: 0;\n\t\t\tcursor: pointer;\n      border: none;\n\n      .box {\n        width: 140px;\n        height: 100px;\n        border-radius: 5px;\n        border: 1px solid #f1f0f3;\n        transition: $transition;\n\t\t\t\tposition: relative;\n\n        span {\n          &:nth-child(1) {\n            top: 0;\n            right: 0;\n            width: 96px;\n            height: 11px;\n            position: absolute;\n            background: #f1f0f3;\n            border-radius: 0 5px 0 5px;\n          }\n          &:nth-child(2) {\n            right: 0;\n            bottom: 0;\n            width: 96px;\n            height: 11px;\n            position: absolute;\n            background: #f1f0f3;\n            border-radius: 5px 0 5px 0;    \n          }\n          &:nth-child(3) {\n            top: 0;\n            left: 0;\n            bottom: 0;\n            width: 36px;\n            position: absolute;\n            background: #f1f0f3;\n            border-radius: 5px 0 0 5px;\n          }\n          &:nth-child(4) {\n            top: 14px;\n            left: 7px;\n            width: 20px;\n            height: 20px;\n            position: absolute;\n            border-radius: 50%;\n            background: #d6d2df;\n          }\n          &:nth-child(5) {\n            left: 7px;\n            top: 45px;\n            width: 20px;\n            height: 5px;\n            position: absolute;\n            border-radius: 30px;\n            background: #d6d2df;\n          }\n          &:nth-child(6) {\n            left: 7px;\n            top: 55px;\n            width: 20px;\n            height: 5px;\n            position: absolute;\n            border-radius: 30px;\n            background: #d6d2df;\n          }\n          &:nth-child(7) {\n            left: 7px;\n            top: 65px;\n            width: 20px;\n            height: 5px;\n            position: absolute;\n            border-radius: 30px;\n            background: #d6d2df;\n          }\n          &:nth-child(8) {\n            top: 35px;\n            left: 46px;\n            width: 20px;\n            height: 11px;\n            position: absolute;\n            background: #f1f0f3;\n            border: 1px solid #f1f0f3;\n          }\n          &:nth-child(9) {\n            top: 35px;\n            left: 78px;\n            width: 20px;\n            height: 11px;\n            position: absolute;\n            background: #f1f0f3;\n            border: 1px solid #f1f0f3;\n          }\n          &:nth-child(10) {\n            top: 35px;\n            left: 110px;\n            width: 20px;\n            height: 11px;\n            position: absolute;\n            background: #f1f0f3;\n            border: 1px solid #f1f0f3;\n          }\n          &:nth-child(11) {\n            top: 55px;\n            left: 46px;\n            width: 20px;\n            height: 11px;\n            position: absolute;\n            background: #f1f0f3;\n            border: 1px solid #f1f0f3;\n          }\n          &:nth-child(12) {\n            top: 55px;\n            left: 78px;\n            width: 20px;\n            height: 11px;\n            position: absolute;\n            background: #f1f0f3;\n            border: 1px solid #f1f0f3;\n          }\n          &:nth-child(13) {\n            top: 55px;\n            left: 110px;\n            width: 20px;\n            height: 11px;\n            position: absolute;\n            background: #f1f0f3;\n            border: 1px solid #f1f0f3;\n          }\n        }\n        &:hover {\n          border-color: $primary;\n        }\n      }\n      .first {\n        .box {\n          border-color: $primary;\n        }\n        .sub-title {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n \n          .dot-checkbox {\n            border-color: $primary;\n            background-color: $primary;\n\t\t\t\t\t\tposition: relative;\n\n            &::before {\n              opacity: 1;\n              visibility: visible;\n            }\n          }\n        }\n      }\n      .sub-title {\n        gap: 8px;\n        margin-top: 10px;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\n        .dot-checkbox {\n          width: 18px;\n          height: 18px;\n          border-radius: 50%;\n          border: 2px solid #f1f0f3;\n          transition: $transition;\n\t\t\t\t\tposition: relative;\n\n          &::before {\n            left: 0;\n            right: 0;\n            top: 50%;\n            opacity: 0;\n            content: \"\\eb7b\";\n            visibility: hidden;\n            position: absolute;\n            font-family: remixicon;\n            color: #fff;\n            transform: translateY(-48%);\n            transition: $transition;\n          }\n          &.active {\n            border-color: $primary;\n            background-color: $primary;\n\n            &::before {\n              opacity: 1;\n              visibility: visible;\n            }\n          }\n        }\n      }\n      &.ltr-rtl-btn,\n      &.left-right-sidebar-btn {\n        .second {\n          span {\n            &:nth-child(1) {\n              left: 0;\n              right: auto;\n              border-radius: 5px 0 5px 0;\n            }\n            &:nth-child(2) {\n              border-radius: 0 5px 0 5px;\n              right: auto;\n              left: 0;\n            }\n            &:nth-child(3) {\n              right: 0;\n              left: auto;\n              border-radius: 0 5px 5px 0;\n            }\n            &:nth-child(4) {\n              left: auto;\n              right: 7px;\n            }\n            &:nth-child(5) {\n              left: auto;\n              right: 7px;\n            }\n            &:nth-child(6) {\n              left: auto;\n              right: 7px;\n            }\n            &:nth-child(7) {\n              left: auto;\n              right: 7px;\n            }\n          }\n        }\n      }\n      &.light-dark-btn {\n        .second {\n          .box {\n            background-color: #000000;\n\n            span {\n              &:nth-child(1) {\n                background: rgba(255, 255, 255, 0.2);\n              }\n              &:nth-child(2) {\n                background: rgba(255, 255, 255, 0.2);\n              }\n              &:nth-child(3) {\n                background: rgba(255, 255, 255, 0.2);\n              }\n              &:nth-child(4) {\n                background: rgba(214, 210, 223, 0.5);\n              }\n              &:nth-child(5) {\n                background: rgba(214, 210, 223, 0.5);\n              }\n              &:nth-child(6) {\n                background: rgba(214, 210, 223, 0.5);\n              }\n              &:nth-child(7) {\n                background: rgba(214, 210, 223, 0.5);\n              }\n            }\n          }\n        }\n      }\n      &.card-border-btn {\n        .second {\n          .box {\n            span {\n              &:nth-child(8),\n              &:nth-child(9),\n              &:nth-child(10),\n              &:nth-child(11),\n              &:nth-child(12),\n              &:nth-child(13) {\n                border-color: #d6d2df;   \n              }\n            }\n          }\n        }\n      }\n      &.card-shape-btn {\n        .first {\n          .box {\n            span {\n              &:nth-child(8),\n              &:nth-child(9),\n              &:nth-child(10),\n              &:nth-child(11),\n              &:nth-child(12),\n              &:nth-child(13) {\n                border-radius: 10px;\n              }\n            }\n          }\n        }\n      }\n      &.compact-sidebar-btn {\n        .second {\n          .box {\n            span {\n              &:nth-child(1) {\n                width: 108px;\n              }\n              &:nth-child(2) {\n                width: 108px;\n              }\n              &:nth-child(3) {\n                width: 24px;\n              }\n              &:nth-child(4) {\n                left: 4px;\n                width: 15px;\n                height: 15px;\n              }\n              &:nth-child(5) {\n                left: 4px;\n                width: 15px;\n              }\n              &:nth-child(6) {\n                left: 4px;\n                width: 15px;\n              }\n              &:nth-child(7) {\n                left: 4px;\n                width: 15px;\n              }\n            }\n          }\n        }\n      }\n      &.card-shadow-btn {\n        .second {\n          .box {\n            span {\n              &:nth-child(8),\n              &:nth-child(9),\n              &:nth-child(10),\n              &:nth-child(11),\n              &:nth-child(12),\n              &:nth-child(13) {\n                background: #fff;\n                box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n              }\n            }\n          }\n        }\n      }\n      &.sidebar-btn {\n        .second {\n          span {\n            &:nth-child(3) {\n              background: #000000;\n            }\n            &:nth-child(4) {\n              background: rgba(214, 210, 223, 0.5);\n            }\n            &:nth-child(5) {\n              background: rgba(214, 210, 223, 0.5);\n            }\n            &:nth-child(6) {\n              background: rgba(214, 210, 223, 0.5);\n            }\n            &:nth-child(7) {\n              background: rgba(214, 210, 223, 0.5);\n            }\n          }\n        }\n      }\n      &.header-btn {\n        .second {\n          span {\n            &:nth-child(1) {\n              background: #000000;\n            }\n          }\n        }\n      }\n      &.active {\n        .first {\n          .box {\n            border-color: #f1f0f3;\n\n            &:hover {\n              border-color: $primary;\n            }\n          }\n          .sub-title {\n            .dot-checkbox {\n              border-color: #f1f0f3;\n              background-color: transparent;\n\n              &::before {\n                opacity: 0;\n                visibility: hidden;\n              }\n            }\n          }\n        }\n        .second {\n          .box {\n            border-color: $primary;\n          }\n          .dot-checkbox {\n            border-color: $primary;\n            background-color: $primary;\n\n            &::before {\n              opacity: 1;\n              visibility: visible;\n            }\n          }\n        }\n      }\n    }\n    .mat-divider {\n      margin: {\n        top: 20px;\n        bottom: 20px;\n      }\n    }\n  }\n  .ng-scroll-content {\n    padding-right: 0 !important;\n  }\n  &.active {\n    right: 0;\n    opacity: 1;\n    visibility: visible;\n  }\n}\n\n// dark\n.dark { \n  .settings-sidebar {\n    .settings-body {\n      .title {\n        color: #fff; \n      }\n      .switch-btn {\n        .box {\n          border-color: #172036;\n\n          span {\n            &:nth-child(1),\n            &:nth-child(2),\n            &:nth-child(3),\n            &:nth-child(8),\n            &:nth-child(9),\n            &:nth-child(10),\n            &:nth-child(11),\n            &:nth-child(12),\n            &:nth-child(13) {\n              background: #172036;\n            }\n            &:nth-child(8),\n            &:nth-child(9),\n            &:nth-child(10),\n            &:nth-child(11),\n            &:nth-child(12),\n            &:nth-child(13) {\n              border-color: $border-color;\n            }\n          }\n          &:hover {\n            border-color: $primary;\n          }\n        }\n        .first {\n          .box {\n            border-color: $primary;\n          }\n          .sub-title {\n            .dot-checkbox {\n              border-color: $primary;\n              background-color: $primary;\n            }\n          }\n        }\n        .sub-title {\n          .dot-checkbox {\n            border-color: $border-color;\n          }\n          span {\n            color: #fff !important;\n          }\n        }\n        &.card-border-btn {\n          .second {\n            .box {\n              span {\n                &:nth-child(8),\n                &:nth-child(9),\n                &:nth-child(10),\n                &:nth-child(11),\n                &:nth-child(12),\n                &:nth-child(13) {\n                  border-color: #2a395d;\n                }\n              }\n            }\n          }\n        }\n        &.card-shadow-btn {\n          .second {\n            .box {\n              span {\n                &:nth-child(8),\n                &:nth-child(9),\n                &:nth-child(10),\n                &:nth-child(11),\n                &:nth-child(12),\n                &:nth-child(13) {\n                  background: $secondary;\n                  box-shadow: rgba(255, 255, 255, 0.24) 0px 3px 8px;\n                }\n              }\n            }\n          }\n        }\n        &.sidebar-btn {\n          .second {\n            span {\n              &:nth-child(3) {\n                background: #000000;\n              }\n            }\n          }\n        }\n        &.header-btn {\n          .second {\n            span {\n              &:nth-child(1) {\n                background: #000000;\n              }\n            }\n          }\n        }\n        &.active {\n          .first {\n            .box {\n              border-color: #172036;\n\n              &:hover {\n                border-color: $primary;\n              }\n            }\n            .sub-title {\n              .dot-checkbox {\n                border-color: $border-color;\n                background-color: transparent; \n              }\n            }\n          }\n          .second {\n            .box {\n              border-color: $primary;\n            }\n            .dot-checkbox {\n              border-color: $primary;\n              background-color: $primary;\n            }\n          }\n        }\n\n        &.light-dark-btn {\n          .first {\n            .box {\n              border-color: #0C1427;\n            }\n            .sub-title {\n              .dot-checkbox {\n                border-color: $border-color;\n                background-color: transparent;\n\n                &::before {\n                  display: none;\n                }\n              }\n            }\n          }\n          .second {\n            .box {\n              border-color: $primary;\n            }\n            .dot-checkbox {\n              border-color: $primary;\n              background-color: $primary;\n\n              &::before {\n                opacity: 1;\n                visibility: visible;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n// RTL\n[dir=\"rtl\"] {\n\t.settings-sidebar {\n\t\ttext-align: end;\n\t\tright: auto;\n\t\tleft: -100%;\n\n\t\t.settings-body {\n      .title {\n        text-align: right;\n      }\n\t\t\t.switch-btn {\n\t\t\t\tmargin-left: auto;\n\t\t\t}\n\t\t}\n\t\t&.active {\n\t\t\tright: auto;\n\t\t\tleft: 0;\n\t\t}\n\t}\n}\n\n/* Max width 767px */\n@media only screen and (max-width: 767px) {\n  .settings-sidebar {\n    width: 320px;\n\n    .settings-header {\n      padding: 14.5px 20px;\n\n      h4 {\n        font-size: 15px;\n      }\n      .close-btn {\n        i {\n          font-size: 18px; \n        }\n      }\n    }\n    .settings-body {\n      padding: { \n        left: 20px;\n        right: 20px;\n        bottom: 20px;\n      }\n      .title {\n        margin-bottom: 13px;\n      }\n      .switch-btn {\n        gap: 20px;\n      }\n      .mat-divider {\n        margin: {\n          top: 17px;\n          bottom: 17px;\n        }\n      }\n    }\n  }\n}\n\n/* Min width 576px to Max width 767px */\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n}\n\n/* Min width 768px to Max width 991px */\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n}\n\n/* Min width 992px to Max width 1199px */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n}\n\n/* Min width 1200px to Max width 1399px */\n@media only screen and (min-width: 1200px) and (max-width: 1399px) {\n}\n\n/* Min width 1600px */\n@media only screen and (min-width: 1600px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
